// Auto-generated from frontend/public/locales/*/translation.json. Do not edit manually.
const resources = {
  "cs": {
    "translation": {
      "popup2.trialPaywallTitle": "Využili jste svých 10 bezplatných zkušebních projevů zájmu",
      "popup2.trialPaywallDescription": "Chcete-li projevit zájem také o tuto nemovitost, potřebujete předplatné. Vašich současných 10 zkušebních projevů zájmu bude převedeno na placené.",
      "popup2.trialPaywallManage": "Tyto projevy zájmu můžete později spravovat na svém řídicím panelu (upravit nebo odstranit).",
      "popup2.trialPaywallActivate": "Aktivovat předplatné",
      "popup2.privateData": "Soukromé údaje",
      "popup2.privateDataHint": "Interní informace zůstávají v zabezpečeném pracovním prostoru a jsou viditelné pouze oprávněným uživatelům.",
      "popup2.privateWorkspace": "Soukromý pracovní prostor",
      "popup2.privateWorkspaceHint": "Pomocí těchto záložek můžete přehledně a bezpečně spravovat citlivé poznámky vlastníka, finance, kontakty, fotografie a dokumenty.",
      "propertyDetails.privateDataDivider": "Soukromé údaje",
      "help": {
        "title": "How it works",
        "subtitle": "Short explanations for common actions in Retailmaps.",
        "howItWorks": "How it works",
        "goodToKnow": "Good to know",
        "empty": "There are no topics for this role yet.",
        "actions": {
          "openListings": "Open listings",
          "openInterests": "Open interests",
          "openProperties": "Open properties",
          "openAlerts": "Open Alerts",
          "openRequests": "Open requests",
          "openAnalysis": "Open analysis"
        },
        "topics": {
          "ownerForRent": {
            "title": "List a property for rent",
            "summary": "Publish a property as a rental offer and add the right information.",
            "step1": "Open the Properties tab.",
            "step2": "Find the property you want to offer.",
            "step3": "Click List for rent.",
            "step4": "Open For rent and complete the asking price, key money and available-from date.",
            "step5": "Check details that were already copied, such as current rent and expiry date.",
            "step6": "Add project information. You can upload a brochure or generate project information automatically.",
            "note1": "As an owner, you do not need to choose visibility. The property is automatically shown as a rental offer.",
            "note2": "Automatic project information uses the entered data, photos, floor plans and a map image."
          },
          "retailerStore": {
            "title": "Link a store to my stores",
            "summary": "Add an existing location to your store overview.",
            "step1": "Open the Stores tab.",
            "step2": "Find the store by country, city or address.",
            "step3": "Assign yourself or a colleague as retail manager.",
            "step4": "The store then appears in My stores.",
            "note1": "A store can only be listed for rent after it is linked to My stores.",
            "note2": "If the location is not on the map yet, add a new marker first."
          },
          "newMarker": {
            "title": "Add a new marker",
            "summary": "Add a new location to the map.",
            "step1": "Open the map.",
            "step2": "Desktop: double-click an empty place on the map.",
            "step3": "Mobile: double-tap an empty place on the map.",
            "step4": "Fill in the location details.",
            "note1": "First check whether the location is already on the map. If so, use the existing marker.",
            "note2": "If you place a new marker incorrectly, you can delete it yourself as long as you added it."
          },
          "moveDeleteMarker": {
            "title": "Move or delete a marker",
            "summary": "Correct a marker position or remove a marker you added yourself.",
            "step1": "Desktop: right-click the marker.",
            "step2": "Mobile: press and hold the marker.",
            "step3": "Choose Move marker and click or tap the new location.",
            "step4": "Choose Delete marker to remove a marker you added yourself.",
            "note1": "Existing markers and markers added by someone else can only be deleted by an admin.",
            "note2": "After moving a marker, open it again if you want to check or edit the data."
          },
          "mobile": {
            "title": "Use Retailmaps on mobile",
            "summary": "Add Retailmaps to your home screen for quick access.",
            "step1": "Open www.retailmaps.com on your phone.",
            "step2": "iPhone or iPad: use Safari, tap Share and choose Add to Home Screen.",
            "step3": "Android Chrome: tap the three dots and choose Install app or Add to Home screen.",
            "step4": "Samsung Internet: open the menu and choose Add page to or Add to Home screen.",
            "step5": "Name the shortcut Retailmaps and tap Add.",
            "step6": "Open Retailmaps from the icon on your home screen.",
            "note1": "On iPhone this normally works through Safari. Chrome on iPhone usually cannot do this directly.",
            "note2": "You sign in with the same account as on desktop."
          },
          "security": {
            "title": "Turn two-factor authentication on or off",
            "summary": "Protect your account with an extra code from an authenticator app.",
            "step1": "Open Settings.",
            "step2": "Go to Security or Two-factor authentication.",
            "step3": "Click Enable 2FA.",
            "step4": "Open an authenticator app, such as Google Authenticator, Microsoft Authenticator or 1Password.",
            "step5": "Scan the QR code with the authenticator app.",
            "step6": "Enter the 6-digit code from the app and confirm.",
            "step7": "From now on you sign in with your password plus the 6-digit code.",
            "step8": "To turn 2FA off, go back to Settings and click Disable 2FA.",
            "note1": "Keep access to your authenticator app. Without it, signing in can become difficult.",
            "note2": "The code changes about every 30 seconds. Always use the newest code."
          },
          "popupMedia": {
            "title": "Photos, documents and floor plans",
            "summary": "Add files to a location.",
            "step1": "Open the location popup.",
            "step2": "Přejděte do sekce Soukromé údaje.",
            "step3": "Choose Photos, Documents or Floor plans.",
            "step4": "Add a file or take a photo directly on mobile.",
            "note1": "Photos are shown as thumbnails.",
            "note2": "Floor plans work best as images, for example jpg or png."
          },
          "alerts": {
            "title": "Set alerts",
            "summary": "Set a reminder for important dates.",
            "step1": "Open Property Details or the popup.",
            "step2": "Enter a date, such as expiry date, indexation date or termination date.",
            "step3": "Tick Alert.",
            "step4": "Enter how many days in advance you want to receive the alert.",
            "step5": "View active alerts in the Alerts tab.",
            "note1": "Active alerts are visible in the Alerts tab.",
            "note2": "On the reminder date you automatically receive an email."
          },
          "ownerRequests": {
            "title": "View requests",
            "summary": "See who is interested in your rental offer or property.",
            "step1": "Open the Requests tab.",
            "step2": "Check which property the request belongs to.",
            "step3": "Review which applicant details are available.",
            "step4": "Open the request for more details.",
            "note1": "Requests are created when retailers show interest in a retail location, even if it is not actively listed for rent."
          },
          "retailerRequests": {
            "title": "View requests",
            "summary": "See which retailers are interested in your locations.",
            "step1": "Open the Requests tab.",
            "step2": "See which retailer showed interest.",
            "step3": "Check which location the request belongs to.",
            "step4": "Click the address to open the location on the map.",
            "note1": "Requests are incoming interests in locations linked to your organisation."
          },
          "interest": {
            "title": "Show interest",
            "summary": "Make clear that you are interested in a specific location.",
            "step1": "Open the location on the map.",
            "step2": "Click Show interest in the popup.",
            "step3": "Confirm the action and complete any required access step.",
            "step4": "The location then appears in the Interests tab.",
            "step5": "The interest remains active until you withdraw it.",
            "note1": "Your interest is saved on the specific property, not only in your own overview.",
            "note2": "The current tenant, owner and relevant brokers can see the interest where they have access."
          },
          "analysis": {
            "title": "Use analysis",
            "summary": "Compare locations and view important calculations.",
            "step1": "Select a property or store in your overview.",
            "step2": "Choose the Analysis action.",
            "step3": "Add multiple locations if needed.",
            "step4": "Open Analysis to view rent per m2, WALT, remaining lease term and ratios."
          }
        }
      },
      "dashboardOverlay": {
        "shared": {
          "assistant": "How it works"
        }
      },
      "dashboardOverlay.shared.assistant": "How it works",
      "settingsPanel": {
        "dashboardOverlay": {
          "shared": {
            "assistant": "How it works"
          }
        }
      },
      "settingsPanel.dashboardOverlay.shared.assistant": "How it works"
    }
  },
  "de": {
    "translation": {
      "popup2.trialPaywallTitle": "Sie haben Ihre 10 kostenlosen Probe-Interessen genutzt",
      "popup2.trialPaywallDescription": "Um auch für dieses Objekt Interesse zu zeigen, benötigen Sie ein Abonnement. Ihre bisherigen 10 Probe-Interessen werden in kostenpflichtige Interessen umgewandelt.",
      "popup2.trialPaywallManage": "Sie können diese Interessen später in Ihrem Dashboard verwalten (ändern oder entfernen).",
      "popup2.trialPaywallActivate": "Abonnement aktivieren",
      "popup2.address": "Adresse",
      "popup2.city": "Stadt",
      "popup2.website": "Website",
      "popup2.groundFloor": "Erdgeschoss",
      "popup2.loginRequired": "Du bist nicht angemeldet. Bitte melde dich erneut an, um Objekte hinzuzufügen.",
      "popup2.basement": "Untergeschoss",
      "popup2.firstFloor": "1. Obergeschoss",
      "popup2.secondFloor": "2. Obergeschoss",
      "popup2.thirdFloor": "3. Obergeschoss",
      "popup2.entresol": "Zwischengeschoss",
      "popup2.soussol": "Souterrain",
      "popup2.unit": "Einheit",
      "popup2.m2": "m²",
      "popup2.ft2": "ft²",
      "popup2.inList": "Diese Immobilie ist in deiner Liste",
      "popup2.confirmRemove": "Möchtest du dieses Objekt wirklich aus deiner Liste entfernen?",
      "popup2.pandVerwijderd": "Objekt wurde aus deiner Liste entfernt.",
      "popup2.verwijderenMislukt": "Entfernen fehlgeschlagen.",
      "popup2.removeFailed": "Entfernen fehlgeschlagen.",
      "popup2.saveFailed": "Speichern fehlgeschlagen.",
      "popup2.removeFromList": "Aus meinen Immobilien entfernen",
      "popup2.pandToegevoegd": "Objekt wurde deiner Liste hinzugefügt.",
      "popup2.toevoegenMislukt": "Hinzufügen fehlgeschlagen.",
      "popup2.addToList": "Zu meinen Objekten hinzufügen",
      "popup2.interestedRetailers": "Interessierte Händler",
      "popup2.retailersHaveInterest": "Händler haben Interesse gezeigt",
      "popup2.stripeStartFout": "Beim Starten von Stripe ist ein Fehler aufgetreten.",
      "popup2.viewRequests": "Anfragen im Dashboard ansehen →",
      "popup2.publicData": "Öffentliche Daten",
      "popup2.privateData": "Private Daten",
      "popup2.publicDataHint": "Sichtbare Objektdaten für Listen, Exposés und Kartenansichten.",
      "popup2.privateDataHint": "Interne Informationen bleiben in deinem geschützten Arbeitsbereich und sind nur für berechtigte Nutzer sichtbar.",
      "popup2.privateWorkspace": "Privater Arbeitsbereich",
      "popup2.privateWorkspaceHint": "Verwalte hier sensible Eigentümernotizen, Finanzdaten, Kontakte, Fotos und Dokumente übersichtlich und sicher.",
      "popup2.manageRentalStatus": "Mietstatus verwalten",
      "popup2.forRent": "Zu vermieten",
      "popup2.confirmTeHuurZetten": "Du bist dabei, dieses Objekt zur Vermietung anzubieten.\n• Normalerweise {{prijs}} pro Monat, derzeit vorübergehend kostenlos\n• Der Status wird für andere Parteien sichtbar\n\nKlicke auf OK, um fortzufahren.",
      "popup2.confirmStopTeHuurStatus": "Du bist dabei, den Vermietungsstatus zu beenden.\n• Dadurch wird auch dein Stripe-Abonnement für dieses Objekt beendet.\n\nMöchtest du wirklich fortfahren?",
      "popup2.teHuurGestopt": "Der Vermietungsstatus und das Abonnement wurden beendet.",
      "popup2.openbaarZichtbaarMaken": "Öffentlich sichtbar machen",
      "popup2.stripeAnnuleringMislukt": "Stripe-Kündigung fehlgeschlagen",
      "popup2.zetEerstTeHuur": "Setze das Objekt zuerst auf „zu vermieten“, bevor du es öffentlich sichtbar machst.",
      "popup2.opslaanWijzigingen": "Änderungen speichern",
      "popup2.front": "Front",
      "popup2.inPortfolio": "Im Portfolio",
      "popup2.addToMyProperties": "Zu meinen Objekten hinzufügen",
      "popup2.alreadyInOrgPortfolio": "Objekt ist bereits im Organisationsportfolio",
      "popup2.alreadyInOwnPortfolio": "Objekt ist bereits in deinem Portfolio",
      "popup2.addPropertyError": "Fehler beim Hinzufügen des Objekts",
      "popup2.invalidSession": "Keine gültige Sitzung. Bitte erneut anmelden.",
      "popup2.trialLimitReachedTitle": "Testlimit erreicht",
      "popup2.trialLimitReachedDesc1": "Während der Testphase sind maximal 3 Objekte erlaubt.",
      "popup2.trialLimitReachedDesc2": "Aktiviere ein Abonnement, um fortzufahren:",
      "popup2.subscriptionPrice": "19 € pro Monat",
      "popup2.extraPropertyPrice": "5 € pro zusätzlichem Objekt",
      "popup2.listingPrice": "Normalerweise 15 € pro Monat für ein Mietangebot, derzeit vorübergehend kostenlos",
      "popup2.stripeSessionFailed": "Die Stripe-Sitzung konnte nicht gestartet werden.",
      "popup2.stripeError": "Stripe-Fehler: ",
      "popup2.noUserEmail": "Keine E-Mail-Adresse gefunden. Bitte prüfe, ob du angemeldet bist.",
      "popup2.stripeNotLoaded": "Stripe.js wurde nicht geladen.",
      "popup2.extraPandFailed": "Der Checkout für das zusätzliche Objekt konnte nicht gestartet werden.",
      "popup2.onlyMineHeader": "Status kann nicht verwaltet werden",
      "popup2.onlyMineMessage": "Du kannst den Status erst ändern, nachdem du das Objekt zu „Meine Objekte“ hinzugefügt hast.",
      "popup2.cancel": "Abbrechen",
      "popup2.busy": "Wird verarbeitet...",
      "popup2.confirm": "Bestätigen",
      "popup2.saveError": "Fehler beim Speichern der Änderungen.",
      "popup2.surface": "Fläche",
      "popup2.retailSpace": "Verkaufsfläche",
      "popup2.secondarySpace": "Nebenfläche",
      "popup2.visibilityUpdateFailed": "Die Sichtbarkeit konnte nicht geändert werden.",
      "popup2.extraPropertyFailed": "Das zusätzliche Objekt konnte nicht hinzugefügt werden.",
      "popup2.stripeStartFailed": "Stripe konnte nicht gestartet werden.",
      "popup2.stripeErrorPrefix": "Stripe-Fehler: ",
      "popup2.interestAddFailed": "Das Interesse konnte nicht hinzugefügt werden.",
      "popup2.ownerMustAddFirst": "Füge dieses Objekt zuerst deinem Portfolio hinzu.",
      "popup2.retailerBrandClaimRequired": "Zum Verwalten der Mietanzeige ist eine bestätigte Markenzuordnung erforderlich.",
      "popup2.roleNotSupported": "Deine aktuelle Rolle unterstützt diese Aktion nicht.",
      "photos.title": "Fotos",
      "photos.add": "Foto hinzufügen",
      "photos.remove": "Foto entfernen",
      "photos.error.tooLarge": "ist groesser als 10 MB und wurde uebersprungen.",
      "documents.title": "Dokumente",
      "documents.add": "Dokument hinzufügen",
      "documents.remove": "Dokument entfernen",
      "documents.error.tooLarge": "is larger than 10 MB and was skipped.",
      "retailer.contactgegevensBlock.title": "Kontaktdaten",
      "retailer.contactgegevensBlock.company": "Unternehmen",
      "retailer.contactgegevensBlock.name": "Name",
      "retailer.contactgegevensBlock.phone": "Telefon",
      "retailer.contactgegevensBlock.email": "E-Mail",
      "retailer.contactgegevensBlock.function": "Rolle",
      "retailer.contactgegevensBlock.add": "Kontakt hinzufügen",
      "retailer.contactgegevensBlock.remove": "Kontakt entfernen",
      "brokerContact.retailerContacts": "Retailer-Kontakte",
      "brokerContact.ownerContacts": "Eigentümerkontakte",
      "brokerContact.company": "Unternehmen",
      "brokerContact.name": "Name",
      "brokerContact.phone": "Telefonnummer",
      "brokerContact.email": "E-Mail-Adresse",
      "brokerContact.position": "Rolle",
      "brokerContact.add": "Kontakt hinzufügen",
      "brokerContact.remove": "Kontakt entfernen",
      "dashboard.title": "Dashboard",
      "dashboard.logout": "Abmelden",
      "dashboard.backToMap": "← Terug naar kaart",
      "dashboard.trialExpiredTitle": "Je proefperiode is verlopen.",
      "dashboard.trialExpiredText": "Activeer je abonnement om door te gaan.",
      "dashboard.activateSubscription": "Abonnement activeren",
      "dashboard.daysLeft": "dagen resterend in gratis proefperiode",
      "dashboard.profile": "Profil",
      "dashboard.brokerInterests": "Interessierte Händler",
      "dashboard.myInterests": "Mijn interesses",
      "dashboard.myProperties": "Mein Portfolio",
      "dashboard.requests": "Anfragen",
      "dashboard.subscription": "Abonnement",
      "dashboard.subscriptionComingSoon": "Abonnement (binnenkort beschikbaar)",
      "dashboard.bundles": "Bundelbeheer",
      "dashboard.settings": "Einstellungen",
      "dashboard.brokerAccount": "Mijn account",
      "dashboard.backToDashboard": "Terug naar dashboard",
      "dashboard.brokerListings": "Meine Mietangebote",
      "authLanding.tabs.login": "Login",
      "authLanding.tabs.register": "Register",
      "authLanding.roles.retailer": "Retailer",
      "authLanding.roles.owner": "Owner",
      "authLanding.roles.broker": "Broker",
      "authLanding.headlines.login.eyebrow": "Retail real estate intelligence",
      "authLanding.headlines.login.subtitle": "Log in and work from a live map layer on portfolio, leasing and interest.",
      "authLanding.headlines.register.eyebrow": "One platform for brokers, owners and retailers",
      "authLanding.headlines.register.subtitle": "Start with an account and build your portfolio, listings and market intelligence from the map.",
      "authLanding.headlines.forgot.eyebrow": "Restore access",
      "authLanding.headlines.forgot.subtitle": "Request a reset link and quickly set a new password for your account.",
      "authLanding.forgot.helper": "Enter your email address below. If the account exists, we will send a reset link right away.",
      "authLanding.roleSlides.broker.label": "Broker",
      "authLanding.roleSlides.broker.eyebrow": "For brokers",
      "authLanding.roleSlides.broker.subtitle": "Bring listings to market, track interest and unlock contact details directly from the same map workspace.",
      "authLanding.roleSlides.broker.featureCards.0": "Publish available locations faster.",
      "authLanding.roleSlides.broker.featureCards.1": "Work with live interest, documents and project information.",
      "authLanding.roleSlides.broker.featureCards.2": "Keep listings, leads and analysis in one place.",
      "authLanding.roleSlides.broker.workflowSteps.0": "From property to listing",
      "authLanding.roleSlides.broker.workflowSteps.1": "Interest and contact details",
      "authLanding.roleSlides.broker.workflowSteps.2": "Analysis per location",
      "authLanding.roleSlides.broker.footer.0": "Listings",
      "authLanding.roleSlides.broker.footer.1": "Lead intelligence",
      "authLanding.roleSlides.broker.footer.2": "Broker intelligence",
      "authLanding.roleSlides.owner.label": "Owner",
      "authLanding.roleSlides.owner.eyebrow": "For owners",
      "authLanding.roleSlides.owner.subtitle": "Manage portfolio, lease data, documents and alerts from a map that fits real estate workflows.",
      "authLanding.roleSlides.owner.featureCards.0": "Store lease, ownership and financial data centrally.",
      "authLanding.roleSlides.owner.featureCards.1": "List properties for rent and follow status on the map.",
      "authLanding.roleSlides.owner.featureCards.2": "Use alerts and analysis without separate spreadsheets.",
      "authLanding.roleSlides.owner.workflowSteps.0": "Portfolio control",
      "authLanding.roleSlides.owner.workflowSteps.1": "Lease data and alerts",
      "authLanding.roleSlides.owner.workflowSteps.2": "Asset analysis",
      "authLanding.roleSlides.owner.footer.0": "Portfolio management",
      "authLanding.roleSlides.owner.footer.1": "Lease information",
      "authLanding.roleSlides.owner.footer.2": "Owner analytics",
      "authLanding.roleSlides.retailer.label": "Retailer",
      "authLanding.roleSlides.retailer.eyebrow": "For retailers",
      "authLanding.roleSlides.retailer.subtitle": "Discover streets, manage stores, show interest and analyse locations before taking the next step.",
      "authLanding.roleSlides.retailer.featureCards.0": "See relevant retail streets and available properties.",
      "authLanding.roleSlides.retailer.featureCards.1": "Add stores to your own portfolio.",
      "authLanding.roleSlides.retailer.featureCards.2": "Show interest and compare locations in analysis.",
      "authLanding.roleSlides.retailer.workflowSteps.0": "Manage stores",
      "authLanding.roleSlides.retailer.workflowSteps.1": "Show interest",
      "authLanding.roleSlides.retailer.workflowSteps.2": "Compare locations",
      "authLanding.roleSlides.retailer.footer.0": "My stores",
      "authLanding.roleSlides.retailer.footer.1": "Interest",
      "authLanding.roleSlides.retailer.footer.2": "Retail analysis",
      "authLanding.platformSubtitle": "For and by retail professionals",
      "authLanding.heroSubtitle": "The live retail map for retail areas worldwide, leasing, showing interest, leads and location analysis. Everything in one platform for EUR 19 per month.",
      "authLanding.trialIntro": "Start your free 60 day trial here",
      "authLanding.trialCta": "Register free",
      "authLanding.marketTagline": "Prime retail streets · live market context",
      "authLanding.featureCards.0": "Work from a live map layer with retail context.",
      "authLanding.featureCards.1": "Manage portfolio, leasing and interest in one place.",
      "authLanding.featureCards.2": "Connect broker, owner and retailer in one workflow.",
      "authLanding.workflowSteps.0": "Portfolio and listing control",
      "authLanding.workflowSteps.1": "Live market signals on the map",
      "authLanding.workflowSteps.2": "One workflow for every role",
      "authLanding.footer.0": "Portfolio management",
      "authLanding.footer.1": "For-rent listings",
      "authLanding.footer.2": "Retail intelligence",
      "authLanding.modeLabel.login": "Welcome back",
      "authLanding.modeLabel.register": "New account",
      "authLanding.modeLabel.forgot": "Forgot password",
      "authLanding.panelTitle.login": "Log in to Retailmaps",
      "authLanding.panelTitle.register": "Start with Retailmaps",
      "authLanding.panelTitle.forgot": "Reset your password",
      "authLanding.fields.email": "E-Mail-Adresse",
      "authLanding.fields.password": "Passwort",
      "authLanding.fields.firstName": "Vorname",
      "authLanding.fields.lastName": "Nachname",
      "authLanding.fields.role": "Rolle",
      "authLanding.fields.phone": "Phone",
      "authLanding.fields.companyName": "Unternehmensname",
      "authLanding.fields.website": "Website",
      "authLanding.actions.forgotPassword": "Forgot password?",
      "authLanding.actions.login": "Login",
      "authLanding.actions.register": "Register",
      "authLanding.actions.startTrial": "Start free trial",
      "authLanding.actions.sendReset": "Send reset link",
      "authLanding.actions.backToLogin": "Back to login",
      "authLanding.actions.openLocalReset": "Open local reset link",
      "authLanding.legal.acceptPrefix": "I agree to the",
      "authLanding.legal.privacy": "privacy statement",
      "authLanding.legal.and": "and the",
      "authLanding.legal.terms": "terms and conditions",
      "authLanding.errors.loginFailed": "Login failed. Please check your details.",
      "authLanding.errors.registerFailed": "Registration failed. Please try again.",
      "authLanding.errors.companyRequired": "Company name is required.",
      "authLanding.errors.forgotNotice": "If this email address is known, we have sent a reset link.",
      "authLanding.errors.forgotFailed": "We could not send the reset link right now.",
      "successStripe.title": "Stripe success",
      "successStripe.waitTitle": "Payment received",
      "successStripe.waitDescription": "We are finishing the activation now. This can take a few seconds. Keep this screen open; you will be redirected automatically when everything is ready.",
      "successStripe.stepPayment": "Payment confirmed",
      "successStripe.stepActivation": "Account or listing is being activated",
      "successStripe.stepRedirect": "You will return to Retailmaps automatically",
      "successStripe.back": "Back",
      "successStripe.processing": "Processing...",
      "successStripe.missingToken": "No valid token found. Please log in again.",
      "successStripe.missingParams": "Missing parameters in the URL.",
      "successStripe.unknownError": "Unknown error",
      "successStripe.missingSessionId": "session_id is missing.",
      "successStripe.missingRetailerId": "retailerId is missing.",
      "successStripe.paymentReceivedActivating": "Payment received! The subscription is being activated...",
      "successStripe.retailerListingActive": "The store is now for rent and publicly visible.",
      "successStripe.ownerListingActive": "The property is now for rent.",
      "successStripe.subscriptionActivating": "Subscription is being activated...",
      "successStripe.subscriptionNotConfirmed": "The subscription could not be confirmed.",
      "successStripe.subscriptionActive": "Subscription active.",
      "successStripe.extraPropertyAdded": "Extra property added successfully.",
      "successStripe.contactAccessUnlocked": "Payment received. We are preparing the contact details and returning you to the right property.",
      "successStripe.interestProcessed": "Interest processed successfully.",
      "successStripe.retailerSubscriptionActivating": "Retailer subscription is being activated...",
      "successStripe.retailerSubscriptionActive": "Retailer subscription active.",
      "successStripe.brokerSubscriptionActivating": "Payment received! The broker subscription is being activated...",
      "successStripe.invalidType": "Unknown or invalid type.",
      "successStripe.genericFailure": "Something went wrong: {{message}}",
      "common.loading": "Laden...",
      "common.save": "Speichern",
      "common.cancel": "Abbrechen",
      "common.edit": "Bearbeiten",
      "common.delete": "L?schen",
      "common.close": "Schlie?en",
      "common.yes": "Ja",
      "common.no": "Nein",
      "common.localeCode": "de-DE",
      "roles.owner": "Eigentümer",
      "roles.retailer": "Retailer",
      "roles.broker": "Makler",
      "listings.common.country": "Land",
      "listings.common.city": "Stadt",
      "listings.common.address": "Adresse",
      "listings.common.askingPrice": "Angebotspreis",
      "listings.common.currentRent": "Aktuelle Miete",
      "listings.common.keyMoney": "Ablösesumme",
      "listings.common.expiryDate": "Ablaufdatum",
      "listings.common.availableFrom": "Verfügbar ab",
      "listings.common.projectInformation": "Projektinformationen",
      "listings.common.onBehalfOf": "Im Namen von",
      "listings.common.visibility": "Sichtbarkeit",
      "listings.common.actions": "Aktionen",
      "listings.common.upload": "Hochladen",
      "listings.common.uploadDocument": "Dokument hochladen",
      "listings.common.chooseFile": "Datei auswählen",
      "listings.common.noFileChosen": "Keine Datei ausgewählt",
      "listings.common.projectDocuments": "Projektdokumente",
      "listings.common.empty": "Derzeit sind keine Standorte zur Miete verf?gbar.",
      "listings.common.selectFileFirst": "Wählen Sie zuerst eine Datei aus.",
      "listings.common.uploadFailed": "Hochladen fehlgeschlagen.",
      "listings.common.confirmDeleteDocument": "Möchten Sie \"{{name}}\" wirklich löschen?",
      "listings.common.documentDeleteFailed": "Dokument konnte nicht gelöscht werden.",
      "listings.common.brochureFailed": "Broschüre konnte nicht erstellt oder hochgeladen werden.",
      "listings.common.stopForRent": "Stoppen",
      "listings.common.forRent": "Zu vermieten",
      "listings.common.documentTypes.document": "Dokument",
      "listings.common.documentTypes.floorplan": "Grundriss",
      "listings.common.documentTypes.brochure": "Broschüre",
      "listings.common.documentTypes.photo": "Foto",
      "listings.common.visibilityOptions.public": "Alle",
      "listings.common.visibilityOptions.retailers": "Alle Retailer",
      "listings.common.visibilityOptions.interested": "Nur Interessenten",
      "ownerListings.currentOffer": "Meine Mietangebote",
      "accountSettings.title": "Einstellungen",
      "accountSettings.tabs.profile": "Profil",
      "accountSettings.tabs.company": "Unternehmen",
      "accountSettings.tabs.preferences": "Einstellungen",
      "accountSettings.tabs.billing": "Abrechnung",
      "accountSettings.descriptions.profile": "Kontaktdaten und Rolleninformationen fuer dein Konto.",
      "accountSettings.descriptions.company": "Unternehmensdaten, Marke und Abrechnung.",
      "accountSettings.descriptions.preferences": "Sprache, Waehrung, Einheiten und Kartenanzeige.",
      "accountSettings.descriptions.billing": "Abonnement, Nutzung und einmalige Kaeufe.",
      "accountSettings.personal.title": "Persoenliches Profil",
      "accountSettings.personal.description": "Kontaktdaten und Rolleninformationen fuer dein Konto. Aenderungen werden automatisch gespeichert.",
      "accountSettings.personal.firstName": "Vorname",
      "accountSettings.personal.lastName": "Nachname",
      "accountSettings.personal.role": "Position",
      "accountSettings.personal.phone": "Telefonnummer",
      "accountSettings.personal.email": "E-Mail-Adresse",
      "accountSettings.personal.linkedin": "LinkedIn",
      "accountSettings.personal.address": "Adresse",
      "accountSettings.company.brandLogoTitle": "Marke und Logo",
      "accountSettings.company.brandLogoDescription": "Wir verwenden dieses Logo auf Objektkarten und anderen sichtbaren Markenflaechen.",
      "accountSettings.company.title": "Unternehmensprofil",
      "accountSettings.company.description": "Unternehmensdaten, Markeninformationen und Abrechnung fuer Makler- und Eigentuemerkonten. Aenderungen werden automatisch gespeichert.",
      "accountSettings.company.readOnlyNotice": "Unternehmensgruppe und Domain steuern Verknuepfungen, Sichtbarkeit und KI-Profile und bleiben daher schreibgeschuetzt.",
      "accountSettings.company.companyName": "Unternehmensname",
      "accountSettings.company.companyGroup": "Unternehmensgruppe",
      "accountSettings.company.domain": "Domain",
      "accountSettings.company.legalName": "Rechtlicher Name",
      "accountSettings.company.website": "Website",
      "accountSettings.company.roleType": "Rollentyp",
      "accountSettings.company.headquartersTitle": "Hauptsitz",
      "accountSettings.company.headquartersAddress": "Adresse Hauptsitz",
      "accountSettings.company.postalCode": "Postleitzahl",
      "accountSettings.company.city": "Stadt",
      "accountSettings.company.country": "Land",
      "accountSettings.company.billingTitle": "Abrechnung",
      "accountSettings.company.billingDescription": "Diese Angaben verwenden wir fuer Abonnements, Rechnungen und Finanzadministration.",
      "accountSettings.company.billingEmail": "E-Mail fuer Abrechnung",
      "accountSettings.company.invoiceReference": "Rechnungsreferenz / PO",
      "accountSettings.company.chamberOfCommerce": "Handelsregisternummer",
      "accountSettings.company.vatNumber": "USt-IdNr.",
      "accountSettings.company.billingAddress": "Rechnungsadresse",
      "billing.title": "Abrechnung",
      "billing.description": "Alles fuer {{account}} in einer Uebersicht: Abonnements, einmalige Kaeufe und offene Kosten fuer {{period}}.",
      "billing.yourAccount": "dein Konto",
      "billing.currentMonth": "dieser Monat",
      "billing.currentPeriod": "Aktueller Zeitraum",
      "billing.preparingPdf": "PDF wird vorbereitet...",
      "billing.downloadPdf": "Rechnung herunterladen (PDF)",
      "billing.downloadError": "Downloading the invoice failed.",
      "billing.loadError": "Billing data could not be loaded.",
      "billing.amountDueThisMonth": "Faellig diesen Monat",
      "billing.subscriptionStatus": "Abonnementstatus",
      "billing.subscriptionActive": "Aktiv",
      "billing.subscriptionInactive": "Nicht aktiv",
      "billing.nextRenewal": "Naechste Verlaengerung",
      "billing.stripeCustomer": "Stripe-Kunde",
      "billing.paidSince": "Bezahlt seit",
      "billing.infoNotice": "User details now live in Profile and Company. We only show what is financially relevant here: recurring subscription costs, one-off purchases and the total for this month.",
      "billing.summary.title": "Zusammenfassung",
      "billing.recurring.title": "Abonnements und Nutzung",
      "billing.recurring.description": "Wiederkehrende Kosten fuer dein Abonnement, aktive Mietobjekte und andere monatliche Bestandteile.",
      "billing.oneOff.title": "Einmalige Kaeufe",
      "billing.oneOff.description": "Einmalige Kosten, zum Beispiel Dokumentfreischaltungen oder andere einzelne Abrechnungsereignisse.",
      "billing.oneOff.none": "Keine einmaligen Kaeufe in diesem Zeitraum.",
      "billing.oneOff.noneTitle": "Keine einmaligen Kaeufe in diesem Zeitraum",
      "billing.oneOff.noneDescription": "Sobald ein einmaliger Kauf abgeschlossen ist, erscheint er hier automatisch.",
      "billing.totals.subscriptions": "Abonnements",
      "billing.totals.oneOff": "Einmalige Kaeufe",
      "billing.totals.totalDue": "Gesamt fällig",
      "billing.history.title": "Abrechnungshistorie",
      "billing.history.description": "Aktuelle Abrechnungsereignisse und einmalige Transaktionen fuer dieses Konto.",
      "billing.history.none": "Fuer dieses Konto wurden noch keine Abrechnungsereignisse gefunden.",
      "billing.history.documentUnlock": "Dokumentfreischaltung",
      "billing.columns.description": "Beschreibung",
      "billing.columns.quantity": "Anzahl",
      "billing.columns.unitPrice": "Einheit",
      "billing.columns.total": "Gesamt",
      "billing.columns.date": "Datum",
      "billing.columns.amount": "Betrag",
      "billing.columns.status": "Status",
      "billing.invoice.overview": "Invoice overview {{period}}",
      "billing.invoice.invoiceDate": "Invoice date",
      "billing.invoice.period": "Period",
      "billing.invoice.statusOpen": "Status: open",
      "billing.invoice.billTo": "Bill to",
      "billing.invoice.footer": "This overview was generated from the current Retailmaps billing data for this period.",
      "stores.common.number": "No.",
      "stores.common.storeName": "Store name",
      "stores.common.status": "Status",
      "stores.common.byWho": "By whom",
      "stores.common.details": "Details",
      "stores.common.retailManager": "Retail manager",
      "stores.common.brokerOnBehalfOfOwner": "Broker (on behalf of owner)",
      "stores.status.forRent": "Zu vermieten",
      "stores.status.rented": "Rented",
      "stores.actions.stopRent": "Stop rental",
      "stores.actions.setForRent": "Set for rent",
      "stores.sections.mine": "Meine Geschäfte",
      "stores.sections.organization": "Stores from my organisation",
      "stores.filters.allCountries": "All countries",
      "stores.filters.allCities": "All cities",
      "stores.messages.addedToPortfolio": "Store added to your portfolio.",
      "stores.messages.addFailed": "The store could not be added.",
      "stores.messages.removeFailed": "The store could not be removed.",
      "stores.messages.toggleRentFailed": "Changing rental status failed.",
      "stores.messages.subscriptionRequired": "An active subscription is required for this action.",
      "stores.messages.assignFailed": "Assigning failed.",
      "dashboard.verhuurAanbod": "Meine Mietangebote",
      "successPage.processing": "Even geduld... we verwerken je gegevens...",
      "successPage.notLoggedIn": "❌ Niet ingelogd. Probeer opnieuw.",
      "successPage.subscriptionActivated": "✅ Je abonnement is succesvol geactiveerd!",
      "successPage.subscriptionFailed": "❌ Activatie mislukt: ",
      "successPage.subscriptionError": "❌ Serverfout bij activeren abonnement.",
      "successPage.propertyForRent": "✅ Pand staat nu als 'te huur'.",
      "successPage.propertyUpdateError": "❌ Fout bij updaten pandstatus: ",
      "successPage.serverError": "❌ Serverfout.",
      "successPage.bundleActivated": "✅ Bundel succesvol geactiveerd.",
      "successPage.bundleFailed": "❌ Bundelactivatie mislukt.",
      "successPage.bundleError": "❌ Fout bij bundelactivatie.",
      "successPage.interestRegistered": "✅ Interesse is succesvol geregistreerd.",
      "successPage.interestStoredFailed": "❌ Opslaan interesse mislukt.",
      "successPage.interestStoreError": "❌ Fout bij opslaan interesse.",
      "successPage.missingContactData": "❌ Onvoldoende gegevens om toegang te verlenen.",
      "successPage.contactConfirmed": "✅ Contactgegevens zijn nu beschikbaar. Je wordt doorgestuurd...",
      "successPage.contactConfirmFailed": "⚠️ Betaling gelukt, maar toegang nog niet verleend.",
      "successPage.contactError": "❌ Serverfout bij bevestigen contacttoegang.",
      "successPage.incompleteOrUnknown": "❌ Onvolledige of onbekende sessiegegevens.",
      "successPage.propertyAddFailed": "❌ Pand toevoegen mislukt: ",
      "successPage.propertyAddError": "❌ Fout bij toevoegen pand.",
      "successPage.success": "Gelukt!",
      "successPage.loading": "Wird verarbeitet...",
      "successPage.comboSuccess": "✅ Combo: pand toegevoegd én abonnement actief.",
      "successPage.comboFailed": "❌ Toevoegen mislukt na combo-betaling: ",
      "successPage.extraPropertyAdded": "✅ Extra pand succesvol toegevoegd.",
      "successPage.extraPropertyFailed": "❌ Toevoegen mislukt na betaling: ",
      "successPage.missingRetailerId": "❌ Geen retailerId opgegeven.",
      "myProperties.title": "Mijn Portefeuille",
      "myProperties.back": "Terug naar Dashboard",
      "myProperties.empty": "Je hebt nog geen panden toegevoegd.",
      "myProperties.name": "Naam",
      "myProperties.address": "Adresse",
      "myProperties.city": "Stadt",
      "myProperties.country": "Land",
      "myProperties.link": "Details",
      "myProperties.action": "Actie",
      "myProperties.remove": "Entfernen",
      "myProperties.confirmRemove": "Moechtest du dieses Objekt wirklich aus dem Organisationsportfolio entfernen? Wenn kein Kollege dieses Objekt ebenfalls hat, verschwindet es vollstaendig aus der Organisation.",
      "myProperties.removeFailed": "Entfernen fehlgeschlagen.",
      "propertyDetails.back": "Zurueck zur Uebersicht",
      "propertyDetails.address": "Adresse",
      "propertyDetails.publicData": "Publieke gegevens",
      "propertyDetails.privateData": "Private Daten",
      "propertyDetails.groundFloor": "Erdgeschoss",
      "propertyDetails.firstFloor": "1. Etage",
      "propertyDetails.secondFloor": "2. Etage",
      "propertyDetails.thirdFloor": "3. Etage",
      "propertyDetails.basement": "Keller",
      "propertyDetails.entresol": "Zwischengeschoss",
      "propertyDetails.soussol": "Souterrain",
      "propertyDetails.rentalData": "Mietdaten",
      "propertyDetails.formalTenant": "Formal tenant",
      "propertyDetails.huurprijs": "Rent",
      "propertyDetails.startDate": "Start date",
      "propertyDetails.endDate": "Expiry date",
      "propertyDetails.remainingLeaseTermMonths": "Remaining lease term (months)",
      "propertyDetails.indexDate": "Indexation date",
      "propertyDetails.cancelDate": "Notice date",
      "propertyDetails.cancelNotice": "Notice period",
      "propertyDetails.guaranteeType": "$t(owner.huurgegevensBlock.garantiesoort)",
      "propertyDetails.guaranteeAmount": "Guarantee amount",
      "propertyDetails.financialData": "Finanzdaten",
      "propertyDetails.purchasePrice": "Koopsom",
      "propertyDetails.purchaseDate": "Aankoopdatum",
      "propertyDetails.mortgage": "Hypotheekbedrag",
      "propertyDetails.interestRate": "Rentepercentage",
      "propertyDetails.bank": "Bank",
      "propertyDetails.loanDuration": "Looptijd (jaren)",
      "propertyDetails.comments": "Opmerkingen",
      "propertyDetails.addComment": "Voeg opmerking toe",
      "propertyDetails.addCommentPrompt": "Voeg een opmerking toe:",
      "propertyDetails.contacts": "Huurderscontacten",
      "propertyDetails.documents": "Documenten",
      "propertyDetails.photos": "Foto's",
      "propertyDetails.save": "Änderungen speichern",
      "propertyDetails.saveSuccess": "✅ Gegevens opgeslagen",
      "propertyDetails.saveError": "❌ Opslaan mislukt",
      "propertyDetails.loading": "📦 Laden...",
      "propertyDetails.notFound": "❌ Deze locatie bestaat niet (meer).",
      "registerPage.title": "📝 Registreren",
      "registerPage.email": "E-Mail-Adresse",
      "registerPage.password": "Passwort",
      "registerPage.role": "Rolle",
      "registerPage.retailer": "Retailer",
      "registerPage.owner": "Eigentümer",
      "registerPage.broker": "Makler",
      "registerPage.brand": "Markenname",
      "registerPage.website": "Website",
      "registerPage.firstName": "Vorname",
      "registerPage.lastName": "Nachname",
      "registerPage.phone": "Telefonnummer",
      "registerPage.register": "Registrieren",
      "registerPage.registrationSuccess": "Registratie succesvol! Je proefperiode is gestart.",
      "login.title": "🔐 Login",
      "login.email": "E-Mail-Adresse",
      "login.password": "Passwort",
      "login.loginButton": "Einloggen",
      "login.noAccount": "Noch kein Konto?",
      "login.registerLink": "Registrieren",
      "retailerMap.unnamed": "Naamloos",
      "retailerMap.dashboard": "Dashboard",
      "retailerMap.addressPlaceholder": "Adresse eingeben...",
      "retailerMap.flyButton": "Los",
      "bundelSelector.title": "📦 Bundelbeheer",
      "bundelSelector.usage": "Je gebruikt momenteel {{active}} van {{max}} beschikbare interesses.",
      "bundelSelector.selectLabel": "Kies een nieuwe bundel:",
      "bundelSelector.option5": "5 panden (€22,50 / maand)",
      "bundelSelector.option15": "15 panden (€60 / maand)",
      "bundelSelector.option30": "30 panden (€100 / maand)",
      "bundelSelector.option100": "100 panden (€300 / maand)",
      "bundelSelector.upgradeButton": "Bundel upgraden via Stripe",
      "retailerProfile.title": "Retailer Profiel",
      "retailerProfile.backToDashboard": "Terug naar dashboard",
      "retailerProfile.aantalWinkels": "Aantal winkels",
      "retailerProfile.actiefInLanden": "Actief in landen",
      "retailerProfile.oprichtingsjaar": "Oprichtingsjaar",
      "retailerProfile.aantalMedewerkers": "Aantal medewerkers",
      "retailerProfile.omzetIndicatie": "Omzetindicatie",
      "retailerProfile.branche": "Branche",
      "retailerProfile.saveButton": "Opslaan",
      "interest.completeProfileFirst": "⚠️ Vul eerst je profiel in (minimaal 3 van de 6 velden).",
      "interest.confirmWithdraw": "❌ Interesse intrekken?",
      "interest.withdrawnSuccess": "✅ Interesse ingetrokken.",
      "interest.bundleFull": "❌ Je bundel is vol. Trek een interesse in of upgrade.",
      "interest.saved": "✅ Interesse opgeslagen.",
      "interest.noBundlePrompt": "ℹ️ Je hebt geen actieve interessebundel.\n\nTyp:\n  'bundle' om bundels te bekijken,\n  'pay' om €5 ex. btw te betalen voor deze locatie,\nof iets anders om te annuleren.",
      "interest.processing": "Wird verarbeitet...",
      "interest.withdraw": "Trek interesse in",
      "interest.show": "Toon interesse",
      "documents.photoUpload.title": "Foto's",
      "documents.photoUpload.add": "Voeg foto's toe",
      "documents.photoUpload.remove": "Verwijder",
      "documents.rentDetails.title": "Huurgegevens",
      "documents.rentDetails.rent": "Huurprijs",
      "documents.rentDetails.startDate": "Ingangsdatum",
      "documents.rentDetails.expiryDate": "Expiratiedatum",
      "documents.rentDetails.indexationDate": "Indexatiedatum",
      "documents.rentDetails.terminationDate": "Opzegdatum",
      "documents.rentDetails.noticePeriod": "Opzegtermijn (maanden)",
      "documents.rentDetails.guaranteeType": "Garantie",
      "documents.rentDetails.guaranteeAmount": "Garantiebedrag",
      "documents.rentDetails.selectOption": "-- Selecteer --",
      "documents.rentDetails.securityDeposit": "Waarborgsom",
      "documents.rentDetails.bankGuarantee": "Bankgarantie",
      "brokerProperty.title": "Pandgegevens",
      "brokerProperty.commencementRent": "Aanvangshuurprijs",
      "brokerProperty.currentRent": "Huidige huurprijs",
      "brokerProperty.askingPrice": "Angebotspreis",
      "brokerProperty.keyMoney": "Overnamesom",
      "brokerProperty.commencementDate": "Ingangsdatum",
      "brokerProperty.expirationDate": "Expiratiedatum",
      "brokerProperty.indexationDate": "Indexatiedatum",
      "brokerProperty.terminationDate": "Opzegdatum",
      "brokerProperty.noticePeriod": "Opzegtermijn (maanden)",
      "brokerProperty.guarantee": "Garantie",
      "brokerProperty.select": "-- Selecteer --",
      "brokerProperty.securityDeposit": "Waarborgsom",
      "brokerProperty.bankGuarantee": "Bankgarantie",
      "brokerProperty.guaranteeAmount": "Garantiebedrag",
      "brokerProperty.purchasePrice": "Koopsom",
      "brokerProperty.landlord": "Eigentümer",
      "brokerProperty.purchaseYear": "Koopjaar",
      "brokerProperty.cadastralMunicipality": "Kadastrale gemeente",
      "brokerProperty.section": "Sectie",
      "brokerProperty.number": "Nummer",
      "brokerProperty.cadastralSize": "Kadastrale grootte",
      "comments.title": "Opmerkingen",
      "comments.none": "Geen opmerkingen toegevoegd.",
      "comments.placeholder": "Typ hier een nieuwe opmerking...",
      "comments.add": "Voeg opmerking toe",
      "huur.title": "Huurgegevens",
      "huur.rent": "Huurprijs",
      "huur.commencementDate": "Ingangsdatum",
      "huur.expirationDate": "Expiratiedatum",
      "huur.indexationDate": "Indexatiedatum",
      "huur.terminationDate": "Opzegdatum",
      "huur.noticePeriod": "Opzegtermijn (maanden)",
      "huur.guaranteeType": "Garantievorm",
      "huur.selecteer": "-- Selecteer --",
      "huur.securityDeposit": "Waarborgsom",
      "huur.bankGuarantee": "Bankgarantie",
      "huur.guaranteeAmount": "Garantiebedrag",
      "contact.title": "Contactpersonen",
      "contact.landlord": "Eigentümer",
      "contact.staff": "Personeel",
      "contact.broker": "Makler",
      "contact.name": "Naam",
      "contact.phone": "Telefoon",
      "contact.email": "E-Mail-Adresse",
      "contact.position": "Functie",
      "contact.remove": "Verwijderen",
      "contact.add": "Contactpersoon toevoegen",
      "brokerContact.title": "Contactgegevens (Broker)",
      "brokerComments.title": "Opmerkingen (Broker)",
      "brokerComments.noComments": "Nog geen opmerkingen toegevoegd.",
      "brokerComments.placeholder": "Typ hier je opmerking...",
      "brokerComments.add": "Opmerking toevoegen",
      "brokerPhotos.title": "Foto's (Broker)",
      "brokerPhotos.add": "Foto toevoegen",
      "brokerPhotos.remove": "Verwijder foto",
      "brokerPhotos.photo": "Foto",
      "brokerPhotos.tooLarge": "is te groot (max 10MB)",
      "brokerDocs.title": "Documenten (Broker)",
      "brokerDocs.add": "Document toevoegen",
      "brokerDocs.delete": "Verwijder document",
      "brokerDocs.tooLarge2": "is te groot (max 10MB)",
      "account.title": "Accountgegevens",
      "account.name": "Naam",
      "account.email": "E-Mail-Adresse",
      "account.phone": "Telefonnummer",
      "account.address": "Adresse",
      "account.website": "Website",
      "account.linkedin": "LinkedIn-profiel",
      "account.logo": "Logo",
      "account.chooseFile": "Kies een bestand",
      "account.selectedFile": "Gekozen bestand",
      "account.uploadLogo": "Upload logo",
      "account.save": "Opslaan",
      "account.saved": "✅ Accountgegevens opgeslagen",
      "account.saveSuccess": "✅ Accountgegevens succesvol opgeslagen",
      "account.saveFailed": "❌ Opslaan mislukt",
      "account.logoUploaded": "✅ Logo geüpload",
      "account.logoTooLarge": "Logo is te groot (max 2MB)",
      "account.noFileChosen": "Geen bestand gekozen",
      "account.loading": "Bezig met laden...",
      "account.invalidEmail": "Ongeldig e-mailadres",
      "account.invalidPhone": "Ongeldig telefoonnummer",
      "account.fetchError": "Fout bij ophalen profiel",
      "account.saveError": "Fout bij opslaan profiel",
      "account.logoUploadError": "Fout bij uploaden logo",
      "myInterests.title": "⭐ Mijn interesses",
      "myInterests.backToDashboard": "Terug naar dashboard",
      "myInterests.loading": "Interesses laden...",
      "myInterests.noResults": "Geen resultaten",
      "myInterests.ownInterests": "👤 Je eigen interesses",
      "myInterests.groupInterests": "👥 Interesses van je organisatie",
      "myInterests.country": "Land",
      "myInterests.city": "Stadt",
      "myInterests.address": "Adresse",
      "myInterests.currentRetailer": "Huidige retailer",
      "myInterests.date": "Datum",
      "myInterests.shownBy": "Getoond door",
      "myInterests.link": "Link",
      "myInterests.action": "Actie",
      "myInterests.remove": "Verwijder",
      "myInterests.removeSuccess": "✅ Interesse verwijderd",
      "myInterests.removeError": "❌ Fout bij verwijderen interesse",
      "broker.listingsTitle": "Meine Mietangebote",
      "subscriptionPage.loading": "Laden...",
      "subscriptionPage.backToDashboard": "Terug naar dashboard",
      "subscriptionPage.title": "📦 Abonnement",
      "subscriptionPage.userSection.title": "👤 Gebruiker",
      "subscriptionPage.userSection.name": "Naam",
      "subscriptionPage.userSection.email": "Emailadres",
      "subscriptionPage.userSection.company": "Bedrijfsnaam",
      "subscriptionPage.userSection.kvk": "KVK nummer",
      "subscriptionPage.subscription.trialUntil": "📅 Proefperiode tot",
      "subscriptionPage.subscription.unknown": "Onbekend",
      "subscriptionPage.subscription.base": "📦 Basisabonnement",
      "subscriptionPage.subscription.perMonth": "per maand",
      "subscriptionPage.subscription.includes3": "inclusief 3 panden",
      "subscriptionPage.subscription.extra": "➕ Extra panden",
      "subscriptionPage.subscription.paidStart": "📆 Start betaald abonnement",
      "subscriptionPage.subscription.notStarted": "Nog niet gestart",
      "subscriptionPage.subscription.totalProperties": "🧾 Totaal aantal panden",
      "subscriptionPage.subscription.forRent": "🏷️ Te huur",
      "subscriptionPage.subscription.totalMonthly": "💰 Totale maandkosten",
      "subscriptionPage.subscription.renewsOn": "Abonnement wordt verlengd op",
      "subscriptionPage.subscription.note": "Opzegtermijn: 1 maand â€¢ Abonnement blijft actief tenzij je het hebt opgezegd.",
      "subscriptionPage.subscription.trialEnded": "Proefperiode beëindigd op",
      "owner.listingsPage.title": "Meine Mietangebote",
      "owner.listingsPage.column.country": "Land",
      "owner.listingsPage.column.city": "Stadt",
      "owner.listingsPage.column.address": "Adresse",
      "owner.listingsPage.column.name": "Huidige huurder",
      "owner.listingsPage.column.website": "Website",
      "owner.listingsPage.column.owner": "Eigentümer",
      "owner.listingsPage.column.currentRetailer": "Huidige huurder",
      "owner.listingsPage.column.opdrachtgever": "Asset Manager",
      "owner.listingsPage.column.broker": "Makler",
      "owner.financieringBlock.title": "Finanzdaten",
      "owner.financieringBlock.koopsom": "Kaufpreis",
      "owner.financieringBlock.aankoopdatum": "Kaufdatum",
      "owner.financieringBlock.hypotheek": "Hypothekenbetrag",
      "owner.financieringBlock.rentepercentage": "Zinssatz",
      "owner.financieringBlock.bank": "Bank",
      "owner.financieringBlock.looptijd": "Laufzeit (Jahre)",
      "owner.financieringBlock.jaar": "Jahr",
      "owner.ownerFields.title": "Eigentümerdaten",
      "owner.ownerFields.parentCompany": "Muttergesellschaft des Eigentümers",
      "owner.ownerFields.owner": "Eigentümer",
      "owner.ownerFields.contactPerson": "Kontaktperson",
      "owner.ownerFields.email": "E-Mail-Adresse",
      "owner.ownerFields.phone": "Telefonnummer",
      "owner.huurgegevensBlock.title": "Mietdaten",
      "owner.huurgegevensBlock.formeleHuurder": "Formeller Mieter",
      "owner.huurgegevensBlock.huurprijs": "Miete",
      "owner.huurgegevensBlock.ingangsdatum": "Mietbeginn",
      "owner.huurgegevensBlock.expiratiedatum": "Ablaufdatum",
      "owner.huurgegevensBlock.resterendeLooptijdMaanden": "Restlaufzeit (Monate)",
      "owner.huurgegevensBlock.huurtermijn": "Mietlaufzeit (Jahre)",
      "owner.huurgegevensBlock.verlengingsjaren": "Verlängerungsjahre",
      "owner.huurgegevensBlock.huurvrijePeriodeMaanden": "Mietfreie Zeit (Monate)",
      "owner.huurgegevensBlock.indexatiedatum": "Indexierungsdatum",
      "owner.huurgegevensBlock.opzegdatum": "Kündigungsdatum",
      "owner.huurgegevensBlock.opzegtermijn": "Kündigungsfrist (Monate)",
      "owner.huurgegevensBlock.garantiesoort": "Garantieart",
      "owner.huurgegevensBlock.kiesOptie": "Option wählen",
      "owner.huurgegevensBlock.waarborgsom": "Kaution",
      "owner.huurgegevensBlock.bankgarantie": "Bankgarantie",
      "owner.huurgegevensBlock.concerngarantie": "Konzerngarantie",
      "owner.huurgegevensBlock.garantiebedrag": "Garantiebetrag",
      "owner.huurgegevensBlock.noGuarantee": "Keine Garantie",
      "owner.contactgegevensBlock.title": "Kontaktdaten",
      "owner.contactgegevensBlock.company": "Unternehmen",
      "owner.contactgegevensBlock.name": "Name",
      "owner.contactgegevensBlock.phone": "Telefon",
      "owner.contactgegevensBlock.email": "E-Mail",
      "owner.contactgegevensBlock.function": "Funktion",
      "owner.contactgegevensBlock.remove": "Kontakt entfernen",
      "owner.contactgegevensBlock.add": "Kontakt hinzufügen",
      "owner.photoUpload.title": "Foto's uploaden",
      "owner.photoUpload.add": "Foto toevoegen",
      "owner.photoUpload.remove": "Verwijderen",
      "owner.photoUpload.tooLarge": "is te groot (max 10MB)",
      "owner.opmerkingen.title": "Notizen",
      "owner.opmerkingen.none": "Noch keine Notizen hinzugefügt.",
      "owner.opmerkingen.unknownAuthor": "Unbekannter Autor",
      "owner.opmerkingen.add": "Notiz hinzufügen",
      "owner.opmerkingen.placeholder": "Notiz hier eingeben?",
      "popup2.addedState": "Hinzugefügt",
      "popup2.adding": "Wird hinzugefügt...",
      "popup2.extraPropertyTitle": "Zusätzliches Objekt hinzufügen",
      "popup2.setForRent": "Zur Vermietung anbieten",
      "popup2.rentStatusActive": "Zu vermieten (aktiv)",
      "popup2.rentActionErrorPrefix": "Fehler beim Ändern des Vermietungsstatus: ",
      "popup2.rentConfirmTitle": "Objekt zur Vermietung anbieten",
      "popup2.rentConfirmDescription": "Das Anbieten dieses Objekts zur Vermietung kostet normalerweise 15 € pro Monat, ist während der Einführungsphase jedoch vorübergehend kostenlos.",
      "popup2.rentLaunchFree": "Jetzt kostenlos",
      "popup2.dontShowAgain": "Nicht mehr anzeigen",
      "propertyDetails.addCommentPlaceholder": "Voeg opmerking toe",
      "propertyDetails.contactName": "Naam",
      "propertyDetails.role": "Functie",
      "propertyDetails.phone": "Telefoon",
      "propertyDetails.email": "E-Mail-Adresse",
      "propertyDetails.addContact": "Kontakt hinzufuegen",
      "propertyDetails.contactpersonen": "Contactpersonen",
      "propertyDetails.delete": "Verwijderen",
      "propertyDetails.addDocument": "Document toevoegen",
      "propertyDetails.documentLabel": "Document",
      "propertyDetails.addPhoto": "Foto toevoegen",
      "propertyDetails.publicDataDivider": "Public data",
      "propertyDetails.privateDataDivider": "Private Daten",
      "propertyDetails.commentsDivider": "Notizen",
      "propertyDetails.contactsDivider": "Kontakte",
      "propertyDetails.documentsDivider": "Dokumente",
      "propertyDetails.photosDivider": "Fotos",
      "propertyDetails.floorplansDivider": "Pläne",
      "propertyDetails.addFloorplan": "Grundriss hinzufügen",
      "propertyDetails.removeFloorplan": "Grundriss entfernen",
      "propertyDetails.floorplansInfo": "Laden Sie Grundrisse als JPG oder PNG hoch. Diese Zeichnungen werden in Broschüren verwendet. PDF-Dateien können unter Dokumente gespeichert werden.",
      "propertyDetails.ownerData": "Eigentümerdaten",
      "propertyDetails.floorAreaTitle": "Flaeche pro Etage (BGF)",
      "propertyDetails.retailSurface": "Mietfläche",
      "propertyDetails.secondarySurface": "Secondary surface",
      "propertyDetails.retailSpace": "Verkaufsfläche",
      "propertyDetails.secondarySpace": "Nebenfläche",
      "propertyDetails.sessionExpired": "Session expired, please log in again.",
      "propertyDetails.removeField": "Feld entfernen",
      "propertyDetails.removeFieldHint": "Eigene Zusatzfelder entfernst du, indem du auf das Feld doppelklickst und dann Feld entfernen waehlst.",
      "propertyDetails.autosave.saving": "Speichern...",
      "propertyDetails.autosave.saved": "Gespeichert",
      "propertyDetails.autosave.error": "Speichern fehlgeschlagen",
      "propertyDetails.autosave.active": "Autosave aktiv",
      "propertyDetails.popupSettings.open": "Einstellungen oeffnen",
      "propertyDetails.popupSettings.hide": "Einstellungen ausblenden",
      "propertyDetails.popupSettings.title": "Popup-Einstellungen",
      "propertyDetails.popupSettings.description": "Waehle, welche Felder im Kartenpopup sichtbar sind. Das gilt fuer Standardfelder und eigene Zusatzfelder.",
      "propertyDetails.popupSettings.extraFields": "Zusatzfelder",
      "propertyDetails.popupSettings.noExtraFields": "Noch keine Zusatzfelder in diesem Abschnitt.",
      "propertyDetails.popupSettings.showInPopup": "Im Popup anzeigen",
      "propertyDetails.popupSettings.hideInPopup": "Im Popup ausblenden",
      "propertyDetails.leaseTerm": "Lease term (years)",
      "propertyDetails.extensionYears": "Extension years",
      "propertyDetails.rentFreePeriodMonths": "Rent-free period (months)",
      "propertyDetails.front": "Front",
      "mapSettings.backToDashboard": "Zurueck zum Dashboard",
      "mapSettings.title": "Kaartinstellingen",
      "mapSettings.subtitle": "Passe Gebaeude- und Markerfarben an",
      "mapSettings.fetchWarn": "Kon instellingen niet ophalen",
      "mapSettings.noUser": "Geen gebruiker gevonden.",
      "mapSettings.invalidHex": "Ungueltige Hexfarbe. Verwende z. B. #0077cc.",
      "mapSettings.saved": "Instellingen opgeslagen.",
      "mapSettings.saveFailed": "Opslaan mislukt.",
      "mapSettings.retailColorLabel": "Farbe fuer Retail-Gebaeude",
      "mapSettings.retailColorPicker": "Farbe fuer Retail-Gebaeude waehlen",
      "mapSettings.otherColorLabel": "Farbe anderer Gebaeude",
      "mapSettings.otherColorPicker": "Farbe anderer Gebaeude waehlen",
      "mapSettings.opacityLabel": "Deckkraft anderer Gebaeude: {{value}}",
      "mapSettings.opacityAria": "Opacity schuifregelaar",
      "mapSettings.markerNameColorLabel": "Marker naamkleur (normaal)",
      "mapSettings.markerNameColorPicker": "Marker-Namensfarbe waehlen",
      "mapSettings.markerNameHoverColorLabel": "Marker naamkleur (hover)",
      "mapSettings.markerNameHoverColorPicker": "Marker-Hoverfarbe waehlen",
      "mapSettings.previewRetail": "Retail highlight",
      "mapSettings.previewOther": "Andere Gebaeude",
      "mapSettings.previewMarkerNormal": "Marker (normaal)",
      "mapSettings.previewMarkerHover": "Marker (hover)",
      "mapSettings.saving": "Opslaanâ€¦",
      "mapSettings.save": "Instellingen opslaan",
      "mapSettings.reset": "Auf Standard zuruecksetzen",
      "mapSettings.cancel": "Abbrechen",
      "mapSettings.hexHelp": "Gebruik hex, bijv. #0077cc",
      "common.backToDashboard": "Terug naar dashboard",
      "requests.title": "Anfragen",
      "requests.overview": "Overview",
      "requests.loading": "Loading...",
      "requests.none": "No requests received for your properties.",
      "requests.columns.location": "Locatie",
      "requests.columns.number": "No.",
      "requests.columns.city": "Stadt",
      "requests.columns.address": "Adresse",
      "requests.columns.tenant": "Tenant",
      "requests.columns.forRent": "Zu vermieten",
      "requests.columns.total": "Gesamt",
      "requests.columns.purchased": "Purchased",
      "requests.columns.date": "Datum",
      "requests.columns.interestedParty": "Interested party",
      "requests.columns.profile": "Profil",
      "requests.columns.type": "Type",
      "requests.columns.actions": "Actions",
      "requests.interestTypes.forRent": "For-rent interest",
      "requests.interestTypes.general": "General interest",
      "requests.profile.branch": "Branch",
      "requests.profile.shops": "Stores",
      "requests.profile.countries": "Countries",
      "requests.profile.revenue": "Revenue",
      "requests.download": "📥 Download contact details",
      "requests.downloadLabel": "Download contact details",
      "requests.payToView": "💳 Buy contact details (€49)",
      "requests.payToViewLabel": "Buy contact details (€49)",
      "requests.shielded": "Hidden",
      "requests.removeError": "Removing the request failed.",
      "requests.paymentError": "Er is iets misgegaan bij het starten van de betaling.",
      "retailerProfile.back": "Terug",
      "retailerProfile.personalTab": "Persoonlijk profiel",
      "retailerProfile.companyTab": "Bedrijfsprofiel",
      "retailerProfile.firstName": "Vorname",
      "retailerProfile.lastName": "Nachname",
      "retailerProfile.function": "Functie",
      "retailerProfile.phone": "Telefonnummer",
      "retailerProfile.email": "E-Mail-Adresse",
      "retailerProfile.linkedin": "LinkedIn-profiel",
      "retailerProfile.loading": "Laden...",
      "retailerProfile.loadingText": "Even geduld a.u.b...",
      "retailerProfile.success": "Profiel succesvol opgeslagen",
      "retailerProfile.error": "Speichern fehlgeschlagen",
      "retailerProfile.bedrijfsnaam": "Bedrijfsnaam",
      "retailerProfile.website": "Website",
      "retailerProfile.hoofdkantoor": "Hoofdkantoor",
      "retailerProfile.logo": "Logo",
      "retailerProfile.kvkNummer": "KvK-nummer",
      "retailerProfile.btwNummer": "BTW-nummer",
      "dashboard.myStores": "Meine Geschäfte",
      "myStores.title": "Meine Geschäfte",
      "myStores.ownStores": "Meine Geschäfte",
      "myStores.groupStores": "Winkels van mijn organisatie",
      "myStores.noResults": "Geen resultaten",
      "myStores.loading": "Laden...",
      "myStores.backToDashboard": "Terug naar dashboard",
      "myStores.nr": "Nr.",
      "myStores.city": "Stadt",
      "myStores.address": "Adresse",
      "myStores.name": "Naam winkel",
      "myStores.source": "Bron",
      "myStores.link": "Details",
      "myStores.country": "Land",
      "myStores.allCountries": "Alle landen",
      "myStores.allCities": "Alle steden",
      "retailerProperty.loading": "Winkel laden...",
      "retailerProperty.notFound": "Winkel niet gevonden",
      "retailerProperty.back": "Terug",
      "retailerProperty.address": "Adresse",
      "retailerProperty.country": "Land",
      "retailerProperty.source": "Bron",
      "retailerProperty.publicDataDivider": "Publieke data",
      "retailerProperty.privateDataDivider": "Private Daten",
      "retailerProperty.commentsDivider": "Opmerkingen",
      "retailerProperty.contactsDivider": "Kontakte",
      "retailerProperty.documentsDivider": "Documenten",
      "retailerProperty.photosDivider": "Fotos",
      "retailer.huurgegevensBlock.title": "Huurgegevens",
      "retailer.huurgegevensBlock.huurprijs": "Huurprijs",
      "retailer.huurgegevensBlock.ingangsdatum": "Ingangsdatum",
      "retailer.huurgegevensBlock.expiratiedatum": "Expiratiedatum",
      "retailer.huurgegevensBlock.indexatiedatum": "Indexatiedatum",
      "retailer.huurgegevensBlock.opzegdatum": "Opzegdatum",
      "retailer.huurgegevensBlock.opzegtermijn": "Opzegtermijn (maanden)",
      "retailer.huurgegevensBlock.garantiesoort": "Garantiesoort",
      "retailer.huurgegevensBlock.garantiebedrag": "Garantiebedrag",
      "retailer.huurgegevensBlock.kiesOptie": "Kies een optie",
      "retailer.huurgegevensBlock.waarborgsom": "Waarborgsom",
      "retailer.huurgegevensBlock.bankgarantie": "Bankgarantie",
      "retailer.huurgegevensBlock.concerngarantie": "Concerngarantie",
      "propertyDetails.extraFieldsDivider": "Extra velden",
      "propertyDetails.noComments": "Geen opmerkingen",
      "extraFieldsBlock.title": "Zusatzfelder",
      "extraFieldsBlock.showInPopup": "Zichtbaar in popup",
      "extraFieldsBlock.addField": "Feld hinzufuegen",
      "extraFieldsBlock.addHeader": "Abschnitt hinzufuegen",
      "extraSections.titleLabel": "Titel",
      "extraSections.fieldLabel": "Feldname",
      "extraSections.fieldType": "Typ",
      "extraSections.value": "Wert",
      "extraSections.addField": "Feld hinzufügen",
      "extraSections.addSection": "Abschnitt hinzufügen",
      "extraSections.newTab": "Neuer Tab",
      "extraSections.tabName": "Tabname",
      "extraSections.renameTab": "Tab umbenennen",
      "extraSections.untitledTab": "Tabname",
      "extraSections.sectionName": "Abschnittsname",
      "rentalData.addField": "Feld hinzufuegen",
      "financialData.addField": "Feld hinzufuegen",
      "addMarker.retailerName": "Naam winkel",
      "addMarker.unknownAddress": "Onbekend adres",
      "addMarker.unknownCity": "Onbekende stad",
      "owners.add.success": "Pand succesvol toegevoegd aan je portefeuille.",
      "owners.add.missingParameters": "Ontbrekende gegevens: e-mailadres of pand-ID.",
      "owners.add.invalidId": "Ongeldig pand-ID.",
      "owners.add.noAccess": "Alleen eigenaren kunnen panden toevoegen.",
      "owners.add.alreadyInMine": "Dit pand staat al in je eigen portefeuille.",
      "owners.add.alreadyInOrgPortfolio": "Dit pand staat al in de organisatieportefeuille.",
      "owners.add.extraRequiresPayment": "Voor dit extra pand is een aanvullende betaling vereist.",
      "owners.add.trialLimitReached": "Je proefperiode staat maximaal 3 panden toe. Activeer een abonnement om meer panden toe te voegen.",
      "owners.add.trialExpired": "Je proefperiode is verlopen. Activeer een abonnement om panden toe te voegen.",
      "owners.add.error": "Er is een fout opgetreden bij het toevoegen van het pand.",
      "retailerMap.paywall.title": "Je abonnement is verlopen",
      "retailerMap.paywall.body": "Activeer je abonnement om de kaart, panddetails en bewerkingen te gebruiken.",
      "retailerMap.paywall.activate": "Activeer abonnement",
      "retailerMap.paywall.openDashboard": "Open dashboard",
      "retailerMap.paywall.error.noJwt": "Je bent niet ingelogd. Log in om de kaart te gebruiken.",
      "retailerMap.paywall.error.sessionExpired": "Je sessie is verlopen. Log opnieuw in om verder te gaan.",
      "retailerMap.paywall.error.noSubscription": "Je hebt nog geen actief abonnement.",
      "retailerMap.paywall.error.accessDenied": "Je hebt geen toegang tot deze kaart.",
      "retailerMap.paywall.error.serverError": "Er is een interne fout opgetreden. Probeer het later opnieuw.",
      "retailerMap.paywall.error.network": "We konden je abonnement niet controleren. Controleer je internetverbinding of probeer het later opnieuw.",
      "retailerMap.paywall.error.trialExpired": "Je proefperiode is verlopen en er is geen actief abonnement. Activeer je abonnement om verder te gaan.",
      "subscriptionPage.subscription.forRentBackend": "🏷️ Te huur",
      "admin.common.openModule": "Open module",
      "admin.common.refreshing": "Refreshing...",
      "admin.common.today": "Today",
      "admin.common.week": "Week",
      "admin.common.month": "Month",
      "admin.common.year": "Year",
      "admin.common.noData": "No data available yet.",
      "admin.common.unknown": "unknown",
      "admin.common.loading": "Loading...",
      "admin.common.userLoadFailed": "User could not be loaded.",
      "admin.dashboard.aiReview": "AI review",
      "admin.home.title": "Retailmaps Admin Ops",
      "admin.home.subtitle": "Central control layer for mail, AI review, analytics and administration. This is where agents, teams and operational processes come together.",
      "admin.home.heroStats.openReview": "Open review",
      "admin.home.heroStats.inbox7d": "Inbox 7d",
      "admin.home.heroStats.activeLanguages": "Active languages",
      "admin.home.heroStats.agentLanes": "Agent lanes",
      "admin.home.sections.alerts": "Operational alerts",
      "admin.home.sections.snapshot": "Operational snapshot",
      "admin.home.alerts.reviewBacklog.label": "Review backlog",
      "admin.home.alerts.reviewBacklog.text": "{{count}} threads are waiting for review.",
      "admin.home.alerts.draftsReady.label": "Drafts ready",
      "admin.home.alerts.draftsReady.text": "{{count}} drafts are ready to review.",
      "admin.home.alerts.escalations.label": "Escalations",
      "admin.home.alerts.escalations.text": "{{count}} threads need manual follow-up.",
      "admin.home.alerts.stable.label": "Stable",
      "admin.home.alerts.stable.text": "No urgent operational alerts right now.",
      "admin.home.snapshot.draftsReady": "{{count}} drafts ready",
      "admin.home.snapshot.laneDistribution": "Lane distribution",
      "admin.home.snapshot.languages": "Languages",
      "admin.home.snapshot.reviewActions": "Review actions",
      "admin.home.snapshot.approved": "Approved",
      "admin.home.snapshot.edited": "Edited",
      "admin.home.snapshot.escalated": "Escalated",
      "admin.home.snapshot.rejected": "Rejected",
      "admin.home.modules.emailOps.title": "Email Agent Ops",
      "admin.home.modules.emailOps.description": "Triage, review, drafts, knowledge base and escalations for all incoming Retailmaps emails.",
      "admin.home.modules.aiQueue.title": "AI Queue",
      "admin.home.modules.aiQueue.description": "Brand validation and other AI-driven review flows that still need human control.",
      "admin.home.modules.statistics.title": "Statistics",
      "admin.home.modules.statistics.description": "Central overview of volumes, languages, response times, conversions and agent performance.",
      "admin.home.modules.administration.title": "Administration",
      "admin.home.modules.administration.description": "Operational backoffice for billing, subscriptions, mailbox management and internal processes.",
      "admin.emailDashboard.title": "Email Agent Ops",
      "admin.emailDashboard.subtitle": "Review incoming email, improve drafts and grow the knowledge base for the role agents.",
      "admin.emailDashboard.refreshMetrics": "Refresh metrics",
      "admin.emailDashboard.badges.aiActive": "AI active",
      "admin.emailDashboard.badges.aiFallback": "AI fallback",
      "admin.emailDashboard.badges.inboundActive": "Inbound active",
      "admin.emailDashboard.badges.inboundMissing": "Inbound missing",
      "admin.emailDashboard.metrics.openReview": "Open review",
      "admin.emailDashboard.metrics.draftsReady": "Drafts ready",
      "admin.emailDashboard.metrics.activeLanguages": "Active languages",
      "admin.emailDashboard.metrics.brokerLane": "Broker lane",
      "admin.emailDashboard.helpers.openReview": "Threads waiting for review or approval.",
      "admin.emailDashboard.helpers.draftsReady": "Drafts currently ready to send.",
      "admin.emailDashboard.helpers.activeLanguages": "Languages currently seen in the inbox.",
      "admin.emailDashboard.helpers.brokerLane": "Threads currently routed to the broker agent.",
      "admin.brandQueue.title": "AI Queue",
      "admin.brandQueue.pendingTitle": "Brands awaiting review",
      "admin.brandQueue.verifiedTitle": "Verified brands",
      "admin.brandQueue.reject": "Reject",
      "admin.brandQueue.columns.name": "Name",
      "admin.brandQueue.columns.status": "Status",
      "admin.brandQueue.columns.createdAt": "Created",
      "admin.brandQueue.columns.actions": "Actions",
      "admin.brandQueue.columns.group": "Group",
      "admin.brandQueue.columns.domain": "Domain",
      "admin.brandQueue.columns.brands": "Brands",
      "admin.brandQueue.prompts.domain": "Domain for {{name}}? (e.g. levi.com)",
      "admin.brandQueue.prompts.group": "Group / parent company for {{name}}? (e.g. Levi Strauss & Co.)",
      "admin.brandQueue.prompts.reject": "Are you sure you want to reject '{{name}}'?",
      "admin.mailPanel.title": "Agent review inbox",
      "admin.mailPanel.subtitle": "Review, edit and respond to incoming email conversations from one central ops inbox.",
      "admin.mailPanel.refreshInbox": "Refresh inbox",
      "admin.mailPanel.mode": "Mode",
      "admin.mailPanel.threads": "threads",
      "admin.mailPanel.messages": "messages",
      "admin.mailPanel.inbound": "inbound",
      "admin.mailPanel.aiInactive": "AI is inactive, fallback drafts are being used.",
      "admin.mailPanel.quickFilters.all": "All",
      "admin.mailPanel.quickFilters.broker": "Broker inbox",
      "admin.mailPanel.quickFilters.retailer": "Retailer inbox",
      "admin.mailPanel.quickFilters.owner": "Owner inbox",
      "admin.mailPanel.quickFilters.support": "Support inbox",
      "admin.mailPanel.quickFilters.router": "Router inbox",
      "admin.mailPanel.filters.search": "Search",
      "admin.mailPanel.filters.lane": "Lane",
      "admin.mailPanel.filters.status": "Status",
      "admin.mailPanel.filters.agent": "Agent",
      "admin.mailPanel.filters.language": "Sprache",
      "admin.mailPanel.filters.review": "Review",
      "admin.mailPanel.filters.all": "All",
      "admin.mailPanel.filters.allLanes": "All lanes",
      "admin.mailPanel.filters.allStatuses": "All statuses",
      "admin.mailPanel.filters.allAgents": "All agents",
      "admin.mailPanel.filters.allLanguages": "All languages",
      "admin.mailPanel.filters.onlyNeedsReview": "Only needs review",
      "admin.mailPanel.filters.noReview": "No review filter",
      "admin.mailPanel.filters.clear": "Clear filters",
      "admin.mailPanel.inbox": "Inbox",
      "admin.mailPanel.noSubject": "No subject",
      "admin.mailPanel.unknownSender": "Unknown sender",
      "admin.mailPanel.noThreads": "No threads match the current filters.",
      "admin.mailPanel.threadDetail": "Thread detail",
      "admin.mailPanel.loadingThread": "Loading thread...",
      "admin.mailPanel.agentLabel": "Agent",
      "admin.mailPanel.languageLabel": "Sprache",
      "admin.mailPanel.statusLabel": "Status",
      "admin.mailPanel.autoReplyEligible": "Auto-reply eligible",
      "admin.mailPanel.reviewRequired": "Review required",
      "admin.mailPanel.lastActivity": "Last activity",
      "admin.mailPanel.escalation": "Escalation",
      "admin.mailPanel.incomingMail": "Incoming mail",
      "admin.mailPanel.incomingFrom": "Incoming from",
      "admin.mailPanel.noPlainText": "No plain text body available.",
      "admin.mailPanel.agentDraft": "Agent draft",
      "admin.mailPanel.subject": "Subject",
      "admin.mailPanel.reply": "Reply",
      "admin.mailPanel.saveEditedAsKnowledge": "Save edited version as knowledge article",
      "admin.mailPanel.sending": "Wird gesendet...",
      "admin.mailPanel.sendReply": "Send reply",
      "admin.mailPanel.approve": "Approve",
      "admin.mailPanel.saveEdited": "Save edited",
      "admin.mailPanel.escalate": "Escalate",
      "admin.mailPanel.reject": "Reject",
      "admin.mailPanel.feedbackProcessed": "Feedback processed successfully.",
      "admin.mailPanel.feedbackFailed": "Processing feedback failed.",
      "admin.mailPanel.replySentVia": "Reply sent to {{recipient}} via {{provider}}.",
      "admin.mailPanel.replySendFailed": "Sending reply failed.",
      "admin.mailPanel.manualEscalationNote": "Manual escalation requested by admin review.",
      "admin.mailPanel.noDraft": "No draft is available yet for this thread.",
      "admin.mailPanel.selectThread": "Select a thread to review its details and draft.",
      "admin.mailPanel.knowledgeBase": "Knowledge base",
      "admin.mailPanel.knowledgeTitle": "Title",
      "admin.mailPanel.knowledgeContent": "Content",
      "admin.mailPanel.knowledgeKeywords": "Keywords (comma separated)",
      "admin.mailPanel.addKnowledgeArticle": "Add knowledge article",
      "admin.mailPanel.knowledgeSaved": "Knowledge article saved.",
      "admin.mailPanel.knowledgeSaveFailed": "Saving knowledge article failed.",
      "admin.mailPanel.noKnowledgeArticles": "No knowledge articles available yet.",
      "admin.statistics.title": "Statistics",
      "admin.statistics.subtitle": "Live operations overview of volumes, review load, languages and feedback on agent answers.",
      "admin.statistics.meta.generatedAt": "Generated at",
      "admin.statistics.meta.mailThreads": "Mail threads",
      "admin.statistics.meta.activeInboxCountries": "Active inbox countries",
      "admin.statistics.overview.users": "Users",
      "admin.statistics.overview.totalInterests": "Total interests",
      "admin.statistics.overview.totalProperties": "Total properties",
      "admin.statistics.overview.activeForRent": "Active for-rent stock",
      "admin.statistics.overview.activeListings": "Active listings",
      "admin.statistics.overview.activeSubscriptions": "Active subscriptions",
      "admin.statistics.roles.admins": "Admins",
      "admin.statistics.roles.brokers": "Brokers",
      "admin.statistics.roles.retailers": "Retailers",
      "admin.statistics.roles.owners": "Owners",
      "admin.statistics.conversion.interestsPerActiveProperty": "Interests per active property",
      "admin.statistics.conversion.propertiesWithInterest": "Properties with interest",
      "admin.statistics.conversion.propertiesWithInterestShare": "Share of properties with interest",
      "admin.statistics.conversion.listingUnlockRate": "Listing unlock rate",
      "admin.statistics.conversion.contactUnlocks": "Contact unlocks",
      "admin.statistics.conversion.unlockRevenue": "Unlock revenue",
      "admin.statistics.manual.manualAddedToday": "Manually added today",
      "admin.statistics.manual.manualAddedMonth": "Manually added this month",
      "admin.statistics.manual.manualEditedToday": "Manually edited today",
      "admin.statistics.manual.manualEditedMonth": "Manually edited this month",
      "admin.statistics.manual.topCreators": "Top manual creators",
      "admin.statistics.manual.topEditors": "Top manual editors",
      "admin.statistics.sections.rolesAndGrowth": "Roles and growth",
      "admin.statistics.sections.accountsPerRole": "Accounts per role",
      "admin.statistics.sections.newUsers": "New users",
      "admin.statistics.sections.userCountries": "User countries",
      "admin.statistics.sections.userCountriesHelp": "Top countries based on user/company profile data.",
      "admin.statistics.sections.interestsByPeriod": "Interests by period",
      "admin.statistics.sections.manualInteraction": "Manual system interaction",
      "admin.statistics.sections.manualInteractionHelp": "User actions in which properties were manually added or edited.",
      "admin.statistics.sections.heatmapHotspots": "Interest hotspots",
      "admin.statistics.sections.heatmapHotspotsHelp": "Top city-country combinations based on recorded interests.",
      "admin.statistics.sections.interestsByCity": "Interests by city",
      "admin.statistics.sections.propertiesAdded": "Properties added",
      "admin.statistics.sections.topPropertyCountries": "Top countries in the property database",
      "admin.statistics.sections.activeForRentStock": "Active for-rent stock",
      "admin.statistics.sections.conversionSignals": "Conversion & commercial signals",
      "admin.statistics.sections.agentMailContext": "Agent mail context",
      "admin.administration.title": "Administration",
      "admin.administration.subtitle": "Operational backoffice for mail health, environment status and internal ops readiness.",
      "admin.administration.sections.mailInfrastructure": "Mail infrastructure",
      "admin.administration.sections.healthCheck": "Health check",
      "admin.administration.sections.operationalStatus": "Operational status",
      "admin.administration.sections.roadmap": "Next backoffice steps",
      "admin.administration.fields.provider": "Provider",
      "admin.administration.fields.from": "From",
      "admin.administration.fields.frontendUrl": "Frontend URL",
      "admin.administration.fields.internalInboxes": "Internal inboxes",
      "admin.administration.fields.testRecipient": "Test recipient",
      "admin.administration.health.mailProvider": "Mail provider",
      "admin.administration.health.mailProviderActive": "{{provider}} aktiv",
      "admin.administration.health.notConfigured": "Not configured",
      "admin.administration.health.inboundAgent": "Inbound agent",
      "admin.administration.health.inboundActive": "Inbound receiving active",
      "admin.administration.health.inboundMissing": "Inbound receiving not configured",
      "admin.administration.health.aiClassification": "AI classification",
      "admin.administration.health.aiActive": "OpenAI active",
      "admin.administration.health.fallbackOnly": "Fallback only",
      "admin.administration.health.internalInboxes": "Internal inboxes",
      "admin.administration.health.internalRecipientsConfigured": "{{count}} internal recipients configured",
      "admin.administration.health.noInternalRecipients": "No internal recipients configured",
      "admin.administration.health.actionNeeded": "Action needed",
      "admin.administration.status.threads": "Threads",
      "admin.administration.status.openReview": "Open review",
      "admin.administration.status.draftsReady": "Drafts ready",
      "admin.administration.status.escalations": "Escalations",
      "admin.administration.roadmap.subscriptions": "Subscription and billing controls per role",
      "admin.administration.roadmap.mailboxes": "Mailbox routing and alias management",
      "admin.administration.roadmap.internalNotifications": "Internal notification preferences",
      "admin.administration.roadmap.billing": "Billing exports and invoice overviews",
      "admin.administration.roadmap.escalations": "Escalation rules and SLA monitoring",
      "admin.administration.roadmap.agentPolicies": "Agent policies and role-specific automations",
      "admin.administration.roadmap.footer": "This page is intentionally operational and will expand into the central Retailmaps backoffice.",
      "dashboardOverlay.shared.forRent": "Zu vermieten",
      "dashboardOverlay.shared.requests": "Anfragen",
      "dashboardOverlay.shared.alerts": "Alerts",
      "dashboardOverlay.shared.analysis": "Analyse",
      "dashboardOverlay.shared.assistant": "So funktioniert es",
      "dashboardOverlay.shared.settings": "Einstellungen",
      "dashboardOverlay.owner.properties": "Objekte",
      "dashboardOverlay.owner.forRent": "Zu vermieten",
      "dashboardOverlay.retailer.stores": "Filialen",
      "dashboardOverlay.retailer.interests": "Interessen",
      "dashboardOverlay.broker.properties": "Objekte",
      "dashboardOverlay.admin.ops": "Ops",
      "dashboardOverlay.admin.mail": "Mail",
      "dashboardOverlay.admin.aiQueue": "AI Queue",
      "dashboardOverlay.admin.statistics": "Statistics",
      "dashboardOverlay.admin.administration": "Administration",
      "retailerMap.loading.zoomInToLoad": "Bis {{zoom}} heranzoomen, um Retailer zu laden",
      "retailerMap.loading.fillingStreet": "Neue Objekte werden geladen. Das kann bis zu 2 Minuten dauern...",
      "retailerMap.loading.paintingFromCenter": "Objekte werden von der Mitte aus geladen...",
      "retailerMap.errors.invalidSession": "No valid session found. Please log in again.",
      "retailerMap.errors.noUserInfo": "No user information available.",
      "retailerMap.errors.unknownRoleSubscription": "Unknown user role. Subscription could not be started.",
      "settingsPanel.common.saving": "Speichern...",
      "settingsPanel.common.saved": "Gespeichert",
      "settingsPanel.common.saveFailed": "Speichern fehlgeschlagen",
      "settingsPanel.common.ready": "Bereit",
      "settingsPanel.regional.title": "Regionale Einstellungen",
      "settingsPanel.regional.subtitle": "Lege fest, wie Sprache, Waehrung und Einheiten verwendet werden. Browser- und Regionsdaten werden automatisch genutzt.",
      "settingsPanel.regional.language": "Sprache",
      "settingsPanel.regional.currency": "Waehrung",
      "settingsPanel.regional.units": "Einheiten",
      "settingsPanel.regional.autoLanguage": "Automatisch ({{language}})",
      "settingsPanel.regional.autoCurrency": "Automatisch ({{currency}})",
      "settingsPanel.regional.autoUnits": "Automatisch ({{units}})",
      "settingsPanel.regional.metric": "Metrisch",
      "settingsPanel.regional.imperial": "Imperial",
      "settingsPanel.regional.detectedRegion": "Erkannte Region: {{region}}",
      "settingsPanel.mailTest.title": "E-Mail testen",
      "settingsPanel.mailTest.subtitle": "Pruefe, ob die E-Mail-Einstellungen korrekt funktionieren.",
      "settingsPanel.mailTest.send": "Testmail senden",
      "settingsPanel.mailTest.sending": "Wird gesendet...",
      "settingsPanel.mailTest.status": "Status: {{status}}",
      "settingsPanel.mailTest.providerActive": "{{provider}} aktiv",
      "settingsPanel.mailTest.devPreviewOnly": "nur Mail-Vorschau",
      "settingsPanel.mailTest.from": "Von: {{value}}",
      "settingsPanel.mailTest.testRecipient": "Testempfaenger: {{value}}",
      "settingsPanel.mailTest.internalInboxes": "Interne Postfaecher: {{value}}",
      "settingsPanel.mailTest.noneConfigured": "keine konfiguriert",
      "settingsPanel.mailTest.notConfigured": "nicht konfiguriert",
      "settingsPanel.map.title": "Karteneinstellungen",
      "settingsPanel.map.subtitle": "Passe Farben, Umrandungen, Labels und Sichtbarkeit der Karte an.",
      "settingsPanel.map.invalidOrSaveFailed": "Ungueltige Farbe oder Speichern fehlgeschlagen.",
      "settingsPanel.map.highlight.title": "Highlight-Intensität",
      "settingsPanel.map.highlight.description": "Bestimmt, wie stark aktive Polygone und Auswahlen hervorgehoben werden.",
      "settingsPanel.map.highlight.retailTitle": "Highlight-Intensitaet fuer Einzelhandelsobjekte",
      "settingsPanel.map.highlight.retailDescription": "Legt fest, wie stark Einzelhandelsobjekte auf der Karte hervorgehoben werden.",
      "settingsPanel.map.highlight.otherTitle": "Intensitaet anderer Objekte",
      "settingsPanel.map.highlight.otherDescription": "Legt fest, wie sichtbar andere Objekte als Hintergrundebene sind.",
      "settingsPanel.map.highlight.opacity": "Intensitaet: {{value}}",
      "settingsPanel.map.markerFont.title": "Schriftgroesse der Marker",
      "settingsPanel.map.markerFont.description": "Legt fest, wie gross Namen und Labels auf der Karte erscheinen.",
      "settingsPanel.map.markerFont.size": "Skalierung: {{value}}",
      "settingsPanel.map.preview.title": "Vorschau",
      "settingsPanel.map.preview.description": "Eine schnelle Vorschau deiner Karteneinstellungen.",
      "settingsPanel.map.colors.retail.label": "Farbe fuer Retail-Gebaeude",
      "settingsPanel.map.colors.retail.description": "Grundfarbe fuer Einzelhandelsobjekte auf der Karte.",
      "settingsPanel.map.colors.other.label": "Farbe anderer Gebaeude",
      "settingsPanel.map.colors.other.description": "Grundfarbe fuer andere Objekte auf der Karte.",
      "settingsPanel.map.colors.retailOutline.label": "Umrandung aktiver Immobilien",
      "settingsPanel.map.colors.retailOutline.description": "Randfarbe fuer aktive Objekte und Highlights.",
      "settingsPanel.map.colors.otherOutline.label": "Umrandung weiterer Immobilien",
      "settingsPanel.map.colors.otherOutline.description": "Randfarbe fuer nicht aktive Objekte.",
      "settingsPanel.map.colors.markerName.label": "Marker-Textfarbe",
      "settingsPanel.map.colors.markerName.description": "Textfarbe fuer Labels auf der Karte.",
      "settingsPanel.map.colors.markerHover.label": "Hover-Farbe",
      "settingsPanel.map.colors.markerHover.description": "Hintergrundfarbe beim Ueberfahren von Labels.",
      "settingsPanel.map.colors.forRentMarker.label": "Mietmarker",
      "settingsPanel.map.colors.forRentMarker.description": "Textfarbe fuer Marker von Objekten, die zur Vermietung stehen.",
      "settingsPanel.retailerMap.loading.zoomInToLoad": "Bis {{zoom}} heranzoomen, um Retailer zu laden",
      "settingsPanel.retailerMap.loading.fillingStreet": "Neue Objekte werden geladen. Das kann bis zu 2 Minuten dauern...",
      "settingsPanel.retailerMap.loading.paintingFromCenter": "Objekte werden von der Mitte aus geladen...",
      "settingsPanel.retailerMap.errors.invalidSession": "Geen geldige sessie gevonden. Log opnieuw in.",
      "settingsPanel.retailerMap.errors.noUserInfo": "Geen gebruikersinformatie beschikbaar.",
      "settingsPanel.retailerMap.errors.unknownRoleSubscription": "Onbekende gebruikersrol. Abonnement kan niet worden gestart.",
      "settingsPanel.dashboardOverlay.owner.properties": "Panden",
      "settingsPanel.dashboardOverlay.owner.forRent": "Zu vermieten",
      "settingsPanel.dashboardOverlay.shared.requests": "Anfragen",
      "settingsPanel.dashboardOverlay.shared.alerts": "Alerts",
      "settingsPanel.dashboardOverlay.shared.analysis": "Analyse",
      "settingsPanel.dashboardOverlay.shared.assistant": "So funktioniert es",
      "settingsPanel.dashboardOverlay.shared.settings": "Einstellungen",
      "settingsPanel.myProperties.nr": "Nr.",
      "settingsPanel.myProperties.city": "Stadt",
      "settingsPanel.myProperties.address": "Adresse",
      "settingsPanel.myProperties.tenant": "Huurder",
      "settingsPanel.myProperties.link": "Details",
      "settingsPanel.myProperties.status": "Status",
      "settingsPanel.myProperties.actions": "Acties",
      "settingsPanel.myProperties.assetManager": "Assetmanager",
      "settingsPanel.myProperties.noAssetManager": "â€” geen â€”",
      "settingsPanel.myProperties.noResults": "Geen resultaten",
      "settingsPanel.myProperties.ownProperties": "Mijn panden",
      "settingsPanel.myProperties.groupProperties": "Organisatieportefeuille",
      "settingsPanel.myProperties.stopRent": "Stop verhuur",
      "settingsPanel.myProperties.setForRent": "Zet te huur",
      "settingsPanel.myProperties.street": "Straat",
      "settingsPanel.myProperties.allCities": "Alle steden",
      "settingsPanel.myProperties.allStreets": "Alle straten",
      "settingsPanel.myProperties.status.forRent": "Zu vermieten",
      "settingsPanel.myProperties.status.rented": "Verhuurd",
      "settingsPanel.myProperties.bulk.assignToSelection": "Toewijzen aan selectie",
      "settingsPanel.myProperties.bulk.onlyUnassigned": "Alleen zonder assetmanager",
      "settingsPanel.myProperties.bulk.selectAllVisible": "Alles selecteren",
      "settingsPanel.myProperties.bulk.noManagerSelected": "Kies een assetmanager.",
      "settingsPanel.myProperties.bulk.noSelection": "Geen panden geselecteerd.",
      "settingsPanel.myProperties.loading": "Laden...",
      "settingsPanel.myProperties.assignToMe": "Naar mij",
      "settingsPanel.myProperties.view": "Bekijken",
      "settingsPanel.myProperties.assignError": "Toewijzen mislukt.",
      "settingsPanel.myProperties.claimSuccess": "Pand toegevoegd aan je portefeuille.",
      "settingsPanel.myProperties.claimError": "Toevoegen mislukt.",
      "settingsPanel.myProperties.rentToggleError": "Wijzigen van verhuurstatus mislukt.",
      "settingsPanel.myProperties.subscription.required": "Voor deze actie is een actief abonnement nodig.",
      "settingsPanel.myProperties.subscription.badge": "Owner-abonnement",
      "settingsPanel.myProperties.subscription.title": "Klaar voor je volgende pand",
      "settingsPanel.myProperties.subscription.description": "Je trial bevat 3 panden. Voor het volgende pand via de organisatie activeer je het owner-abonnement, waarna je direct verder kunt.",
      "settingsPanel.myProperties.subscription.activate": "Activeer owner-abonnement",
      "settingsPanel.myProperties.subscription.sessionError": "Kan Stripe sessie niet starten.",
      "settingsPanel.myProperties.subscription.stripeMissing": "Stripe.js niet geladen.",
      "settingsPanel.myProperties.subscription.startError": "Kon abonnement niet starten.",
      "settingsPanel.requests.branches.fashionAndApparel": "Kleding en mode",
      "settingsPanel.requests.branches.footwear": "Schoenen",
      "settingsPanel.requests.branches.foodAndBeverage": "Food en beverage",
      "settingsPanel.requests.branches.beautyAndPersonalCare": "Beauty en persoonlijke verzorging",
      "settingsPanel.requests.branches.jewelleryAndWatches": "Juwelen en horloges",
      "settingsPanel.requests.branches.supermarketAndGrocery": "Supermarkt en boodschappen",
      "settingsPanel.requests.branches.electronics": "Elektronica",
      "settingsPanel.requests.branches.homeAndLiving": "Wonen en interieur",
      "settingsPanel.requests.branches.sportsAndOutdoor": "Sport en outdoor",
      "settingsPanel.requests.branches.booksAndMedia": "Boeken en media",
      "settingsPanel.common.cancel": "Abbrechen",
      "settingsPanel.countries.nl": "Nederland",
      "settingsPanel.countries.be": "België",
      "settingsPanel.countries.de": "Duitsland",
      "settingsPanel.countries.fr": "Frankrijk",
      "settingsPanel.countries.gb": "Verenigd Koninkrijk",
      "settingsPanel.countries.es": "Spanje",
      "settingsPanel.countries.it": "Italië",
      "common.back": "Zurück",
      "common.busy": "Besch?ftigt...",
      "propertyDrawer.title": "Immobiliendetails",
      "propertyDrawer.loadFailed": "Immobiliendetails konnten nicht geladen werden.",
      "propertyDrawer.openInNewTab": "In neuem Tab öffnen",
      "propertyDrawer.address": "Adresse",
      "propertyDrawer.status": "Status",
      "propertyDrawer.forRent": "Zu vermieten",
      "propertyDrawer.rented": "Vermietet",
      "propertyDrawer.assetManager": "Asset Manager",
      "propertyDrawer.openInMaps": "In Maps öffnen",
      "interestButton.invalidSession": "Keine gültige Sitzung.",
      "interestButton.withdraw": "Zurückziehen",
      "interestButton.showInterest": "Interesse zeigen",
      "retailerMap.printTooltip": "Wahlen Sie, wie Sie die Karte exportieren mochten",
      "retailerMap.print": "Drucken",
      "retailerMap.openStreetView": "Street View öffnen",
      "retailerMap.closeStreetView": "Street View schließen",
      "retailerMap.streetView": "Street View",
      "retailerMap.zoomIn": "Vergrößern",
      "retailerMap.zoomOut": "Verkleinern",
      "retailerMap.highlightEdit.dragHint": "Punkte ziehen, Punkte entfernen oder einen Punkt hinzufügen.",
      "retailerMap.highlightEdit.selectHint": "Klicke auf ein blaues Highlight, um es zu bearbeiten.",
      "retailerMap.highlightEdit.adminHint": "Admin-Tool für fehlerhafte Gebäudeformen.",
      "retailerMap.highlightEdit.disable": "Bearbeitungsmodus aus",
      "retailerMap.highlightEdit.edit": "Highlight bearbeiten",
      "retailerMap.highlightEdit.merge": "Zusammenführen",
      "retailerMap.highlightEdit.reset": "Zurücksetzen",
      "retailerMap.highlightEdit.mergeHint": "Wähle mindestens zwei blaue Highlights. Ausgewählt: {{count}}",
      "retailerMap.highlightEdit.mergeNow": "Zusammenführen",
      "retailerMap.highlightEdit.buildingId": "Building ID",
      "retailerMap.highlightEdit.addPoint": "Punkt hinzufügen",
      "retailerMap.highlightEdit.removePoint": "Punkt entfernen",
      "retailerMap.highlightEdit.makeOneShape": "Eine Fläche erstellen",
      "retailerMap.highlightEdit.removeCorrection": "Korrektur entfernen",
      "retailerMap.highlightEdit.restore": "Highlight wiederherstellen",
      "propertyList.filters.city": "Stadt",
      "propertyList.filters.street": "Strasse",
      "propertyList.filters.retailer": "Retailer",
      "propertyList.filters.select": "Auswaehlen...",
      "propertyList.filters.typeStreet": "Strasse eingeben...",
      "propertyList.filters.chooseCityFirst": "Zuerst eine Stadt waehlen",
      "propertyList.filters.noStreets": "Keine Strassen gefunden",
      "propertyList.filters.cityRequiredForStreet": "Waehle zuerst eine Stadt, um Strassen auszuwaehlen.",
      "propertyList.filters.retailerExample": "Z. B. Suit Supply",
      "propertyList.filters.retailerExampleShort": "Retailer",
      "propertyList.filters.searchAddress": "Adresse suchen",
      "propertyList.filters.scopeHint": "Waehle eine Strasse oder suche nach einem Retailer, um die Objektliste zu laden.",
      "propertyList.loading": "Objekte werden geladen...",
      "propertyList.noPropertiesFound": "Keine Objekte gefunden",
      "propertyList.openDetails": "Details oeffnen",
      "propertyList.pagination.rowsPerPage": "Zeilen pro Seite",
      "propertyList.columns.number": "Nr.",
      "propertyList.columns.country": "Land",
      "propertyList.columns.city": "Stadt",
      "propertyList.columns.address": "Adresse",
      "propertyList.columns.retailer": "Retailer",
      "propertyList.columns.status": "Status",
      "propertyList.columns.showInterest": "Interesse zeigen",
      "propertyList.columns.details": "Details",
      "propertyList.columns.analysis": "Analyse",
      "propertyList.columns.interests": "Interessen",
      "propertyList.columns.purchased": "Gekauft",
      "propertyList.columns.rental": "Vermietung",
      "propertyList.status.forRent": "Zu vermieten",
      "propertyList.status.notForRent": "Nicht zu vermieten",
      "propertyList.interests.none": "Keine Interessen",
      "propertyList.interests.date": "Datum",
      "propertyList.interests.interestedParty": "Interessent",
      "propertyList.interests.type": "Typ",
      "propertyList.interests.branch": "Branche",
      "propertyList.interests.stores": "Standorte",
      "propertyList.interests.contactDetails": "Kontaktdaten",
      "propertyList.interests.protected": "Geschuetzt",
      "propertyList.interests.forRentInterest": "Mietinteresse",
      "propertyList.interests.generalInterest": "Allgemeines Interesse",
      "propertyList.interests.downloadContact": "Kontaktdaten herunterladen",
      "propertyList.interests.buyContact": "Kontaktdaten kaufen (EUR 9)",
      "propertyList.interests.interest": "Interesse",
      "propertyList.contactPurchase.title": "Kontaktdaten kaufen",
      "propertyList.contactPurchase.description": "Du kaufst die Kontaktdaten zu diesem Interesse.",
      "propertyList.contactPurchase.invoiceNotice": "Die Kosten werden separat berechnet.",
      "propertyList.contactPurchase.buy": "Kontaktdaten kaufen",
      "common": {
        "loading": "Laden...",
        "save": "Speichern",
        "cancel": "Abbrechen",
        "edit": "Bearbeiten",
        "delete": "L?schen",
        "open": "Öffnen",
        "close": "Schlie?en",
        "yes": "Ja",
        "no": "Nein",
        "busy": "Besch?ftigt...",
        "active": "Aktiv",
        "inactive": "Nicht aktiv",
        "backToDashboard": "Zur?ck zum Dashboard",
        "download": "Herunterladen",
        "saved": "Gespeichert",
        "saving": "Speichern...",
        "saveFailed": "Speichern fehlgeschlagen",
        "ready": "Bereit",
        "canceled": "Gekuendigt",
        "confirm": "Bestätigen",
        "localeCode": "de-DE"
      },
      "settingsPanel": {
        "branding": {
          "title": "Makler-Branding",
          "subtitle": "Laden Sie Ihr Logo hoch. Es wird bei Ihren Angeboten angezeigt."
        },
        "common": {
          "saving": "Speichern...",
          "saved": "Gespeichert",
          "saveFailed": "Speichern fehlgeschlagen",
          "ready": "Bereit"
        },
        "regional": {
          "title": "Regionale Einstellungen",
          "subtitle": "Lege fest, wie Sprache, Waehrung und Einheiten verwendet werden. Browser- und Regionsdaten werden automatisch genutzt.",
          "language": "Sprache",
          "currency": "Waehrung",
          "units": "Einheiten",
          "autoLanguage": "Automatisch ({{language}})",
          "autoCurrency": "Automatisch ({{currency}})",
          "autoUnits": "Automatisch ({{units}})",
          "metric": "Metrisch",
          "imperial": "Imperial",
          "detectedRegion": "Erkannte Region: {{region}}"
        },
        "map": {
          "title": "Karteneinstellungen",
          "subtitle": "Passe Farben, Umrandungen, Labels und Sichtbarkeit der Karte an.",
          "invalidOrSaveFailed": "Ungueltige Farbe oder Speichern fehlgeschlagen.",
          "highlight": {
            "retailTitle": "Highlight-Intensitaet fuer Einzelhandelsobjekte",
            "retailDescription": "Legt fest, wie stark Einzelhandelsobjekte auf der Karte hervorgehoben werden.",
            "otherTitle": "Intensitaet anderer Objekte",
            "otherDescription": "Legt fest, wie sichtbar andere Objekte als Hintergrundebene sind.",
            "opacity": "Intensitaet: {{value}}"
          },
          "markerFont": {
            "title": "Schriftgroesse der Marker",
            "description": "Legt fest, wie gross Namen und Labels auf der Karte erscheinen.",
            "size": "Skalierung: {{value}}"
          },
          "preview": {
            "title": "Vorschau",
            "description": "Eine schnelle Vorschau deiner Karteneinstellungen."
          },
          "colors": {
            "retail": {
              "label": "Farbe fuer Retail-Gebaeude",
              "description": "Grundfarbe fuer Einzelhandelsobjekte auf der Karte.",
              "picker": "Farbe fuer Retail-Gebaeude waehlen"
            },
            "other": {
              "label": "Farbe anderer Gebaeude",
              "description": "Grundfarbe fuer andere Objekte auf der Karte.",
              "picker": "Farbe anderer Gebaeude waehlen"
            },
            "retailOutline": {
              "label": "Rahmen aktiver Objekte",
              "description": "Randfarbe fuer aktive Objekte und Highlights."
            },
            "otherOutline": {
              "label": "Rahmen anderer Objekte",
              "description": "Randfarbe fuer nicht aktive Objekte."
            },
            "markerName": {
              "label": "Marker-Namensfarbe",
              "description": "Textfarbe fuer Labels auf der Karte."
            },
            "markerHover": {
              "label": "Hover-Farbe",
              "description": "Hintergrundfarbe beim Ueberfahren von Labels."
            },
            "forRentMarker": {
              "label": "Zu-vermieten-Marker",
              "description": "Textfarbe fuer Marker von Objekten, die zur Vermietung stehen."
            }
          }
        },
        "mailTest": {
          "title": "Test-E-Mail",
          "subtitle": "Pruefe, ob die E-Mail-Einstellungen korrekt funktionieren.",
          "send": "Test-E-Mail senden",
          "sending": "Senden...",
          "status": "Status: {{status}}",
          "providerActive": "{{provider}} aktiv",
          "devPreviewOnly": "Nur Dev-Vorschau",
          "from": "Von: {{value}}",
          "testRecipient": "Testempfaenger: {{value}}",
          "internalInboxes": "Interne Postfaecher: {{value}}",
          "notConfigured": "Nicht eingerichtet",
          "noneConfigured": "Keine eingerichtet",
          "previewLogged": "{{provider}} ist noch nicht vollstaendig eingerichtet. Die Test-E-Mail wurde als Vorschau fuer {{recipient}} protokolliert.",
          "sentMessage": "Test-E-Mail an {{recipient}} ueber {{provider}} gesendet.",
          "failed": "Senden der Test-E-Mail fehlgeschlagen.",
          "yourInbox": "dein Postfach"
        },
        "dashboardOverlay": {
          "shared": {
            "assistant": "So funktioniert es"
          }
        },
        "retailerMap": {
          "loading": {
            "zoomInToLoad": "Bis {{zoom}} heranzoomen, um Retailer zu laden",
            "fillingStreet": "Neue Objekte werden geladen. Das kann bis zu 2 Minuten dauern...",
            "paintingFromCenter": "Objekte werden von der Mitte aus geladen..."
          }
        }
      },
      "mapSettings": {
        "activeOutlineLabel": "Rahmen aktiver Objekte",
        "otherOutlineLabel": "Rahmen anderer Objekte",
        "markerNameColorLabel": "Marker-Namensfarbe",
        "hoverColorLabel": "Hover-Farbe",
        "backToDashboard": "Zurueck zum Dashboard",
        "title": "Karteneinstellungen",
        "subtitle": "Passe Gebaeude- und Markerfarben an",
        "fetchWarn": "Einstellungen konnten nicht geladen werden",
        "noUser": "Kein Benutzer gefunden.",
        "invalidHex": "Ungueltige Hexfarbe. Verwende z. B. #0077cc.",
        "saved": "Einstellungen gespeichert.",
        "saveFailed": "Speichern fehlgeschlagen.",
        "retailColorLabel": "Farbe fuer Retail-Gebaeude",
        "retailColorPicker": "Farbe fuer Retail-Gebaeude waehlen",
        "otherColorLabel": "Farbe anderer Gebaeude",
        "otherColorPicker": "Farbe anderer Gebaeude waehlen",
        "opacityLabel": "Deckkraft anderer Gebaeude: {{value}}",
        "opacityAria": "Deckkraft-Schieberegler",
        "markerNameColorPicker": "Marker-Namensfarbe waehlen",
        "markerNameHoverColorLabel": "Marker-Hoverfarbe",
        "markerNameHoverColorPicker": "Marker-Hoverfarbe waehlen",
        "previewRetail": "Retail-Highlight",
        "previewOther": "Andere Gebaeude",
        "previewMarkerNormal": "Marker normal",
        "previewMarkerHover": "Marker Hover",
        "saving": "Speichern...",
        "save": "Einstellungen speichern",
        "reset": "Auf Standard zuruecksetzen",
        "cancel": "Abbrechen",
        "hexHelp": "Hex verwenden, z. B. #0077cc"
      },
      "retailerProfile": {
        "personalTitle": "Persoenliches Profil",
        "companyTitle": "Unternehmensprofil",
        "autosaveHint": "Aenderungen werden automatisch gespeichert.",
        "companyProtectedHint": "Unternehmensgruppe und Firmenname sind fuehrend fuer KI-Profile und interne Verknuepfungen und bleiben daher geschuetzt.",
        "parentCompany": "Muttergesellschaft",
        "company": "Unternehmen",
        "companyName": "Unternehmensname",
        "name": "Name",
        "legalName": "Juristischer Name",
        "headquartersAddress": "Adresse der Zentrale",
        "headquartersPostalCode": "Postleitzahl der Zentrale",
        "headquartersCity": "Ort der Zentrale",
        "headquartersCountry": "Land der Zentrale",
        "industry": "Branche",
        "organization": "Organisation",
        "foundingYear": "Gruendungsjahr",
        "storeCount": "Anzahl Filialen",
        "activeCountries": "Aktiv in Laendern",
        "employeeCount": "Anzahl Mitarbeitende",
        "revenueIndication": "Umsatzindikation",
        "billingHint": "Nuetzlich fuer Abonnements, Rechnungen und interne Verwaltung.",
        "billingEmail": "Rechnungs-E-Mail",
        "invoiceReference": "Rechnungsreferenz / PO",
        "billingAddress": "Rechnungsadresse",
        "chamberOfCommerceNumber": "Handelsregisternummer",
        "vatNumber": "USt-IdNr.",
        "postalCode": "Postleitzahl",
        "city": "Stadt",
        "country": "Land"
      },
      "paidInterest": {
        "title": "Zusaetzliches Interesse",
        "bodyPrefix": "Dieses Interesse kostet",
        "price": "€5 zzgl. MwSt. pro Monat",
        "bodySuffix": "und wird Ihrem Abonnement hinzugefuegt. Sie koennen dieses Interesse spaeter jederzeit zurueckziehen.",
        "confirm": "Zustimmen und fortfahren",
        "paymentStartFailed": "Zahlung konnte nicht gestartet werden."
      },
      "forRentTab": {
        "selectActingRole": "Waehlen Sie aus, in wessen Namen Sie vermieten.",
        "created": "Das Objekt ist jetzt zur Miete gelistet.",
        "updated": "Listing aktualisiert.",
        "updateFailed": "Aktualisierung fehlgeschlagen.",
        "confirmDelete": "Moechten Sie dieses Mietangebot wirklich entfernen?",
        "deleteFailed": "Loeschen fehlgeschlagen.",
        "listProperty": "Objekt zur Miete anbieten",
        "missingData": "Fehlende Daten zum Aktivieren des Mietangebots.",
        "activateFailed": "Mietangebot konnte nicht aktiviert werden.",
        "activating": "Mietangebot wird aktiviert..."
      },
      "requests": {
        "empty": "Keine Anfragen",
        "removeFailed": "Die Anfrage konnte nicht entfernt werden.",
        "total": "Gesamt",
        "purchased": "Gekauft",
        "date": "Datum",
        "interestedParty": "Interessent",
        "hidden": "Ausgeblendet",
        "downloadContact": "Kontaktdaten herunterladen",
        "buyContact": "Kontaktdaten kaufen (€49)",
        "interests": "Interessen",
        "interestTypes": {
          "forRent": "Mietinteresse",
          "general": "Allgemeines Interesse"
        }
      },
      "billing": {
        "user": "Benutzer",
        "title": "Abrechnung",
        "subscription": "Abonnement",
        "paidSince": "Bezahlt seit",
        "trialUntil": "Testzeitraum bis",
        "trialEndedOn": "Testzeitraum beendet am",
        "baseSubscription": "Basisabonnement",
        "perMonth": "pro Monat",
        "totalMonthlyCosts": "Gesamte monatliche Kosten",
        "renewsOn": "Verlaengert am {{date}}",
        "noticePeriod": "Kuendigungsfrist: 1 Monat. Das Abonnement bleibt aktiv, bis Sie es kuendigen.",
        "includesProperties": "inkl. {{count}} Objekte",
        "extraProperties": "Zusaetzliche Objekte",
        "totalProperties": "Objekte gesamt",
        "monthlyCosts": "Monatliche Kosten",
        "cancelSubscription": "Abonnement kündigen",
        "cancellationScheduled": "Dein Abonnement endet planmäßig am {{date}}. Deine Daten bleiben sicher archiviert und können bei einer Reaktivierung wiederhergestellt werden.",
        "cancelDialog": {
          "title": "Abonnement kündigen",
          "retention": "Dein Abonnement endet nach der aktuellen Zahlungsperiode. Es wird nichts gelöscht: Portfolio, Dokumente, Historie und Rechnungen bleiben für eine Reaktivierung archiviert.",
          "endsOn": "Der Zugang bleibt bis {{date}} aktiv.",
          "ownerProperties": "Meine Objekte",
          "retailerStores": "Meine Geschäfte",
          "returnPortfolio": "In das Organisationsportfolio zurückgeben (nicht zugewiesen)",
          "transferColleague": "An einen Kollegen übertragen",
          "listings": "Aktive Mietangebote",
          "archiveListings": "Zum Enddatum stoppen und archivieren",
          "transferListings": "An einen Kollegen übertragen",
          "interests": "Aktive Interessen werden zum Enddatum zurückgezogen. Die geschützte Historie bleibt archiviert.",
          "contacts": "Gekaufte Kontaktdaten und Rechnungen bleiben als Kaufhistorie erhalten und werden bei Reaktivierung wiederhergestellt.",
          "recipient": "Empfangender Kollege",
          "confirm": "Kündigung einplanen"
        },
        "recurring": {
          "title": "Abonnements und Nutzung",
          "description": "Wiederkehrende Kosten fuer dein Abonnement, aktive Mietobjekte und andere monatliche Bestandteile."
        },
        "baseSubscriptionDescription": "Zugang zu Retailmaps und Basisfunktionen.",
        "forRent": "Zu vermieten",
        "forRentDescription": "Aktive Mietobjekte, die ueber dieses Benutzerkonto aktiviert wurden.",
        "oneOff": {
          "title": "Einmalige Kaeufe",
          "description": "Einmalige Kosten, zum Beispiel Dokumentfreischaltungen oder andere einzelne Abrechnungsereignisse.",
          "noneTitle": "Keine einmaligen Kaeufe in diesem Zeitraum",
          "noneDescription": "Sobald ein einmaliger Kauf abgeschlossen ist, erscheint er hier automatisch.",
          "none": "Keine einmaligen Kaeufe in diesem Zeitraum."
        },
        "totals": {
          "subscriptions": "Abonnements",
          "trialDiscount": "Testrabatt",
          "oneOff": "Einmalige Kaeufe",
          "vat": "MwSt.",
          "totalInclVat": "Gesamt inkl. MwSt."
        },
        "history": {
          "title": "Abrechnungshistorie",
          "description": "Aktuelle Abrechnungsereignisse und einmalige Transaktionen fuer dieses Konto.",
          "none": "Fuer dieses Konto wurden noch keine Abrechnungsereignisse gefunden.",
          "documentUnlock": "Dokumentfreischaltung"
        },
        "columns": {
          "date": "Datum",
          "description": "Beschreibung",
          "status": "Status",
          "amount": "Betrag",
          "quantity": "Anzahl",
          "unitPrice": "Einheit",
          "total": "Gesamt"
        },
        "description": "Alles fuer {{account}} in einer Uebersicht: Abonnements, einmalige Kaeufe und offene Kosten fuer {{period}}.",
        "yourAccount": "dein Konto",
        "currentMonth": "dieser Monat",
        "currentPeriod": "Aktueller Zeitraum",
        "downloadPdf": "Rechnung herunterladen (PDF)",
        "preparingPdf": "PDF wird vorbereitet...",
        "amountDueThisMonth": "Faellig diesen Monat",
        "subscriptionStatus": "Abonnementstatus",
        "subscriptionActive": "Aktiv",
        "subscriptionInactive": "Nicht aktiv",
        "nextRenewal": "Naechste Verlaengerung",
        "stripeCustomer": "Stripe-Kunde"
      },
      "verifyEmail": {
        "loadingMessage": "Wir bestaetigen Ihre E-Mail-Adresse...",
        "invalidLink": "Dieser Verifizierungslink ist ungueltig.",
        "successMessage": "Ihre E-Mail-Adresse wurde bestaetigt. Melden Sie sich an, um Retailmaps zu oeffnen.",
        "failedMessage": "Verifizierung fehlgeschlagen.",
        "expiredOrInvalid": "Dieser Verifizierungslink ist abgelaufen oder ungueltig.",
        "successTitle": "E-Mail-Adresse bestaetigt",
        "failedTitle": "Verifizierung fehlgeschlagen",
        "checkingTitle": "Wird geprueft",
        "backToLogin": "Zurueck zum Login",
        "openLogin": "Einloggen und Retailmaps oeffnen"
      },
      "listings": {
        "common": {
          "forRentSince": "Zur Miete seit",
          "onRequest": "Auf Anfrage",
          "empty": "Derzeit sind keine Standorte zur Miete verf?gbar.",
          "country": "Land",
          "city": "Stadt",
          "address": "Adresse",
          "askingPrice": "Mietpreis",
          "currentRent": "Aktuelle Miete",
          "keyMoney": "Ablösesumme",
          "expiryDate": "Ablaufdatum",
          "availableFrom": "Verfügbar ab",
          "projectInformation": "Projektinformationen",
          "onBehalfOf": "Im Auftrag von",
          "visibility": "Sichtbarkeit",
          "broker": "Makler",
          "actions": "Aktionen",
          "upload": "Hochladen",
          "uploadDocument": "Dokument hochladen",
          "stopForRent": "Stoppen",
          "brochureFailed": "Broschüre konnte nicht erstellt oder hochgeladen werden.",
          "projectDocuments": "Projektdokumente",
          "chooseFile": "Datei auswählen",
          "noFileChosen": "Keine Datei ausgewählt",
          "selectFileFirst": "Wählen Sie zuerst eine Datei aus.",
          "uploadFailed": "Hochladen fehlgeschlagen.",
          "documentDeleteFailed": "Dokument konnte nicht gelöscht werden.",
          "confirmDeleteDocument": "Möchten Sie \"{{name}}\" wirklich löschen?",
          "forRent": "Zu vermieten",
          "edit": "Bearbeiten",
          "save": "Speichern",
          "cancel": "Abbrechen",
          "documentTypes": {
            "document": "Dokument",
            "floorplan": "Grundriss",
            "brochure": "Broschüre",
            "photo": "Foto"
          },
          "visibilityOptions": {
            "public": "Alle",
            "retailers": "Alle Retailer",
            "interested": "Nur Interessenten"
          },
          "noDocuments": "Keine Dokumente",
          "fileCountOne": "{{count}} Datei",
          "fileCountOther": "{{count}} Dateien",
          "addedOn": "Hinzugefügt {{date}}",
          "deleteDocumentAria": "{{name}} löschen",
          "available": "Verfügbar",
          "surface": "Fläche",
          "total": "Gesamt",
          "contactBroker": "Vermietungsmakler kontaktieren",
          "thirdPartyNotice": "Informationen von Dritten. Prüfen Sie Details beim Anbieter.",
          "interestAndDocuments": "Interesse zeigen und Dokumente erhalten",
          "goToInformation": "Zur Information",
          "viewDocuments": "Dokumente ansehen",
          "unlockForPrice": "Kostenlos freischalten",
          "unlockDocuments": "Dokumente freischalten",
          "oneTimeAccessPrice": "Der Dokumentzugriff ist derzeit kostenlos."
        },
        "roles": {
          "external": "Externes Angebot",
          "owner": "Eigentümer",
          "tenant": "Retailer",
          "brokerOnBehalfOwner": "Makler (im Namen des Eigentümers)",
          "provider": "Anbieter"
        }
      },
      "propertyDetails": {
        "floors": {
          "ground": "Erdgeschoss",
          "basement": "Keller",
          "first": "1. Obergeschoss",
          "second": "2. Obergeschoss",
          "third": "3. Obergeschoss",
          "entresol": "Zwischengeschoss",
          "soussol": "Souterrain"
        },
        "frontWidth": "Frontbreite",
        "rentalData": "Mietdaten",
        "financialData": "Finanzdaten",
        "ownerData": "Eigentümerdaten",
        "commentsDivider": "Notizen",
        "contactsDivider": "Kontakte",
        "photosDivider": "Fotos",
        "floorplansDivider": "Pläne",
        "documentsDivider": "Dokumente",
        "objectInfoDivider": "Objektinformationen",
        "floorplansInfo": "Laden Sie Grundrisse als JPG oder PNG hoch. Diese Zeichnungen werden in Broschüren verwendet. PDF-Dateien können unter Dokumente gespeichert werden.",
        "addFloorplan": "Grundriss hinzufügen",
        "removeFloorplan": "Grundriss entfernen",
        "addObjectInfo": "Objektinformationen hinzufügen",
        "notesDivider": "Notizen",
        "datePlaceholder": "tt-mm-jjjj",
        "addContact": "Kontakt hinzufuegen",
        "removeField": "Feld entfernen",
        "removeFieldHint": "Eigene Zusatzfelder entfernst du, indem du auf das Feld doppelklickst und dann Feld entfernen waehlst.",
        "popupSettings": {
          "open": "Einstellungen oeffnen",
          "hide": "Einstellungen ausblenden",
          "title": "Popup-Einstellungen",
          "description": "Waehle, welche Felder im Kartenpopup sichtbar sind. Das gilt fuer Standardfelder und eigene Zusatzfelder.",
          "extraFields": "Zusatzfelder",
          "noExtraFields": "Noch keine Zusatzfelder in diesem Abschnitt.",
          "showInPopup": "Im Popup anzeigen",
          "hideInPopup": "Im Popup ausblenden"
        },
        "askingRentPrice": "Angebotsmiete",
        "serviceCosts": "Nebenkosten",
        "takeoverPrice": "Abl?sesumme",
        "availableFrom": "Verf?gbar ab",
        "back": "Zurueck zur Uebersicht",
        "projectInfoDivider": "Projektinformationen",
        "addProjectInfo": "Projektinformationen hinzufuegen",
        "privateData": "Private Daten",
        "privateDataDivider": "Private Daten"
      },
      "help": {
        "tab": "So funktioniert es",
        "title": "So funktioniert es",
        "subtitle": "Kurze Erklaerungen zu haeufigen Aktionen in Retailmaps.",
        "howItWorks": "So funktioniert es",
        "goodToKnow": "Gut zu wissen",
        "empty": "Fuer diese Rolle gibt es noch keine Themen.",
        "actions": {
          "openListings": "Angebote oeffnen",
          "openInterests": "Interessen oeffnen",
          "openProperties": "Objekte oeffnen",
          "openAlerts": "Alerts oeffnen",
          "openRequests": "Anfragen oeffnen",
          "openAnalysis": "Analyse oeffnen"
        },
        "topics": {
          "ownerForRent": {
            "title": "Objekt zur Vermietung anbieten",
            "summary": "Veroeffentliche ein Objekt als Mietangebot und ergaenze die richtigen Informationen.",
            "step1": "Oeffne den Tab Objekte.",
            "step2": "Suche das Objekt, das du anbieten moechtest.",
            "step3": "Klicke auf Zu vermieten.",
            "step4": "Oeffne Zu vermieten und ergaenze Mietpreis, Abstandszahlung und Verfuegbarkeitsdatum.",
            "step5": "Pruefe die bereits uebernommenen Angaben, zum Beispiel aktuelle Miete und Ablaufdatum.",
            "step6": "Fuege Projektinformationen hinzu. Du kannst eine Broschuere hochladen oder Projektinformationen automatisch erstellen lassen.",
            "note1": "Als Eigentuemer musst du keine Sichtbarkeit auswaehlen. Das Objekt wird automatisch als Mietangebot angezeigt.",
            "note2": "Automatische Projektinformationen verwenden die eingegebenen Daten, Fotos, Grundrisse und ein Kartenbild."
          },
          "retailerStore": {
            "title": "Geschaeft mit meinen Geschaeften verknuepfen",
            "summary": "Fuege einen bestehenden Standort zu deiner Geschaeftsuebersicht hinzu.",
            "step1": "Oeffne den Tab Geschaefte.",
            "step2": "Suche das Geschaeft nach Land, Stadt oder Adresse.",
            "step3": "Waehle dich selbst oder einen Kollegen als Retailmanager aus.",
            "step4": "Das Geschaeft erscheint danach unter Meine Geschaefte.",
            "note1": "Ein Geschaeft kann erst zur Vermietung angeboten werden, nachdem es mit Meine Geschaefte verknuepft ist.",
            "note2": "Ist der Standort noch nicht auf der Karte? Fuege zuerst einen neuen Marker hinzu."
          },
          "newMarker": {
            "title": "Neuen Marker hinzufuegen",
            "summary": "Fuege der Karte einen neuen Standort hinzu.",
            "step1": "Oeffne die Karte.",
            "step2": "Desktop: doppelklicke auf eine freie Stelle auf der Karte.",
            "step3": "Mobil: tippe doppelt auf eine freie Stelle auf der Karte.",
            "step4": "Fuege danach die Standortdaten ein.",
            "note1": "Pruefe zuerst, ob der Standort bereits auf der Karte steht. Nutze in diesem Fall den bestehenden Marker.",
            "note2": "Wenn du einen neuen Marker falsch platzierst, kannst du ihn selbst wieder loeschen, solange du ihn hinzugefuegt hast."
          },
          "moveDeleteMarker": {
            "title": "Marker verschieben oder loeschen",
            "summary": "Korrigiere die Position eines Markers oder entferne einen Marker, den du selbst hinzugefuegt hast.",
            "step1": "Desktop: klicke mit der rechten Maustaste auf den Marker.",
            "step2": "Mobil: halte den Marker laenger gedrueckt.",
            "step3": "Waehle Marker verschieben und klicke oder tippe auf die neue Position.",
            "step4": "Waehle Marker loeschen, um einen Marker zu entfernen, den du selbst hinzugefuegt hast.",
            "note1": "Bestehende Marker und Marker anderer Nutzer koennen nur von einem Admin geloescht werden.",
            "note2": "Nach dem Verschieben oeffnest du den Marker erneut, wenn du die Daten pruefen oder bearbeiten moechtest."
          },
          "mobile": {
            "title": "Retailmaps mobil verwenden",
            "summary": "Fuege Retailmaps deinem Startbildschirm hinzu, um schneller darauf zuzugreifen.",
            "step1": "Oeffne www.retailmaps.com auf deinem Telefon.",
            "step2": "iPhone oder iPad: verwende Safari, tippe auf Teilen und waehle Zum Home-Bildschirm.",
            "step3": "Chrome auf Android: tippe auf die drei Punkte und waehle App installieren oder Zum Startbildschirm hinzufuegen.",
            "step4": "Samsung Internet: oeffne das Menue und waehle Seite hinzufuegen oder Zum Startbildschirm hinzufuegen.",
            "step5": "Gib der Verknuepfung den Namen Retailmaps und tippe auf Hinzufuegen.",
            "step6": "Oeffne Retailmaps danach ueber das Symbol auf deinem Startbildschirm.",
            "note1": "Auf dem iPhone funktioniert dies normalerweise ueber Safari. Chrome auf dem iPhone kann das meist nicht direkt.",
            "note2": "Du meldest dich mit demselben Konto wie auf dem Desktop an."
          },
          "security": {
            "title": "Zwei-Faktor-Authentifizierung ein- oder ausschalten",
            "summary": "Schuetze dein Konto zusaetzlich mit einem Code aus einer Authenticator-App.",
            "step1": "Oeffne Einstellungen.",
            "step2": "Gehe zu Security oder Zwei-Faktor-Authentifizierung.",
            "step3": "Klicke auf 2FA aktivieren.",
            "step4": "Oeffne eine Authenticator-App, zum Beispiel Google Authenticator, Microsoft Authenticator oder 1Password.",
            "step5": "Scanne den QR-Code mit der Authenticator-App.",
            "step6": "Gib den 6-stelligen Code aus der App ein und bestaetige.",
            "step7": "Ab jetzt meldest du dich mit Passwort plus 6-stelligem Code an.",
            "step8": "Wenn du 2FA ausschalten moechtest, gehe erneut zu Einstellungen und klicke auf 2FA deaktivieren.",
            "note1": "Bewahre den Zugriff auf deine Authenticator-App gut auf. Ohne diese App kann die Anmeldung schwierig werden.",
            "note2": "Der Code aendert sich etwa alle 30 Sekunden. Verwende immer den neuesten Code."
          },
          "popupMedia": {
            "title": "Fotos, Dokumente und Grundrisse",
            "summary": "Fuege Dateien zu einem Standort hinzu.",
            "step1": "Oeffne das Popup des Standorts.",
            "step2": "Gehe zu Private Daten.",
            "step3": "Waehle Fotos, Dokumente oder Grundrisse.",
            "step4": "Fuege eine Datei hinzu oder mache mobil direkt ein Foto.",
            "note1": "Fotos werden als Vorschaubilder angezeigt.",
            "note2": "Grundrisse funktionieren am besten als Bild, zum Beispiel jpg oder png."
          },
          "alerts": {
            "title": "Alerts einstellen",
            "summary": "Stelle eine Erinnerung fuer wichtige Termine ein.",
            "step1": "Oeffne Property Details oder das Popup.",
            "step2": "Trage ein Datum ein, zum Beispiel Ablaufdatum, Indexierungsdatum oder Kuendigungsdatum.",
            "step3": "Aktiviere Alert.",
            "step4": "Gib ein, wie viele Tage vorher du die Erinnerung erhalten moechtest.",
            "step5": "Aktive Alerts findest du im Tab Alerts.",
            "note1": "Aktive Alerts werden im Tab Alerts angezeigt.",
            "note2": "Am Erinnerungsdatum erhaeltst du automatisch eine E-Mail."
          },
          "ownerRequests": {
            "title": "Anfragen ansehen",
            "summary": "Sieh, wer Interesse an deinem Mietangebot oder Objekt hat.",
            "step1": "Oeffne den Tab Anfragen.",
            "step2": "Pruefe, zu welchem Objekt die Anfrage gehoert.",
            "step3": "Pruefe, welche Angaben des Interessenten verfuegbar sind.",
            "step4": "Oeffne die Anfrage fuer weitere Details.",
            "note1": "Anfragen entstehen, wenn Retailer Interesse an einem Ladenstandort zeigen, auch wenn dieser nicht aktiv zur Vermietung steht."
          },
          "retailerRequests": {
            "title": "Anfragen ansehen",
            "summary": "Sieh, welche Retailer Interesse an deinen Standorten haben.",
            "step1": "Oeffne den Tab Anfragen.",
            "step2": "Sieh, welcher Retailer Interesse gezeigt hat.",
            "step3": "Pruefe, zu welchem Standort die Anfrage gehoert.",
            "step4": "Klicke auf die Adresse, um den Standort auf der Karte zu oeffnen.",
            "note1": "Anfragen sind eingehende Interessen fuer Standorte, die mit deiner Organisation verknuepft sind."
          },
          "interest": {
            "title": "Interesse zeigen",
            "summary": "Mache sichtbar, dass du Interesse an einem bestimmten Standort hast.",
            "step1": "Oeffne auf der Karte den Standort, an dem du Interesse hast.",
            "step2": "Klicke im Popup auf Interesse zeigen.",
            "step3": "Pruefe die Bestaetigung und schliesse eventuell erforderliche Zugriffsschritte ab.",
            "step4": "Der Standort erscheint danach im Tab Interessen.",
            "step5": "Das Interesse bleibt aktiv, bis du es selbst wieder zurueckziehst.",
            "note1": "Dein Interesse wird am konkreten Objekt gespeichert, nicht nur in deiner eigenen Uebersicht.",
            "note2": "Der aktuelle Mieter, Eigentuemer und relevante Makler koennen das Interesse sehen, sofern sie Zugriff haben."
          },
          "analysis": {
            "title": "Analyse verwenden",
            "summary": "Vergleiche Standorte und sieh wichtige Berechnungen.",
            "step1": "Waehle ein Objekt oder Geschaeft in deiner Uebersicht aus.",
            "step2": "Waehle die Aktion Analyse.",
            "step3": "Fuege bei Bedarf mehrere Standorte hinzu.",
            "step4": "Oeffne Analyse, um unter anderem Miete pro m2, WALT, Restlaufzeit und Kennzahlen zu sehen."
          }
        }
      },
      "legal": {
        "disclaimer": "Konzeptdokument fuer Retailmaps. Ergaenzen Sie die Unternehmensdaten vor der endgueltigen Veroeffentlichung.",
        "lastUpdated": "Zuletzt aktualisiert: 28. Mai 2026",
        "privacy": {
          "title": "Datenschutzerklaerung",
          "intro": "Retailmaps processes business account, company, property, listing, interest and usage data to provide the platform.",
          "roles": "Data can be visible to relevant users depending on their role, access rights, subscriptions and actions within the platform.",
          "providers": "Retailmaps may use external providers for hosting, maps, payments, email, analytics and AI functionality.",
          "rights": "Users can request access, correction or deletion of personal data where applicable.",
          "contact": "For privacy questions, contact Retailmaps through the published contact details."
        },
        "terms": {
          "title": "Allgemeine Geschaeftsbedingungen",
          "intro": "Retailmaps is a professional platform for retail real estate information, listings, interests, requests and related collaboration.",
          "account": "Users are responsible for correct account details, secure login credentials and lawful use of the platform.",
          "data": "Users remain responsible for the accuracy and rights to information, photos, documents and contact details they upload or publish.",
          "uploadLicense": "Mit der Bereitstellung von Grundrissen, IMDF-, GeoJSON-, CAD-, SVG- oder anderen Standortdateien bestätigt der Nutzer, hierzu berechtigt zu sein, und erteilt Retailmaps ein nicht ausschließliches, lizenzgebührenfreies Recht, diese Dateien zu speichern, zu hosten, zu kopieren, zu analysieren, zu konvertieren, zu georeferenzieren, anzupassen und zu kombinieren, daraus abgeleitete Grundrisse und Kartenebenen zu erstellen und diese innerhalb des Retailmaps-Dienstes anzuzeigen. Retailmaps darf seinen technischen Dienstleistern die hierfür zwingend erforderlichen Rechte einräumen. Erforderliche Quellenangaben, Lizenzen Dritter oder sonstige Beschränkungen muss der Nutzer bei der Bereitstellung mitteilen.",
          "payments": "Paid features, subscriptions, bundles and transaction fees can apply where clearly shown in the dashboard or order flow.",
          "liability": "Retailmaps is an information and networking platform and does not guarantee that a property is available or that a transaction will be completed."
        }
      },
      "popup": {
        "autosaveActive": "Automatisch gespeichert"
      },
      "alerts": {
        "daysBefore": "Tage vorher",
        "enterDaysBefore": "Tage vorher eingeben",
        "title": "Alerts",
        "loading": "Alerts werden geladen...",
        "empty": "Derzeit gibt es keine Alerts, die Aufmerksamkeit erfordern.",
        "toggleLabel": "Alert",
        "dismiss": "Erledigen",
        "columns": {
          "property": "Objekt",
          "field": "Feld",
          "date": "Datum",
          "alertDate": "Alert-Datum",
          "daysBefore": "Tage vorher",
          "status": "Status",
          "actions": "Aktionen"
        },
        "status": {
          "expired": "Abgelaufen",
          "actionNeeded": "Aktion erforderlich",
          "upcoming": "Bevorstehend"
        },
        "fields": {
          "expiryDate": "Ablaufdatum",
          "indexationDate": "Indexierungsdatum",
          "terminationDate": "Kündigungsdatum",
          "availableFrom": "Verfügbar ab",
          "startDate": "Startdatum"
        }
      },
      "analysis": {
        "title": "Analyse",
        "empty": "Fuege Objekte zur Analyse hinzu, um die Kennzahlen zu sehen.",
        "summary": {
          "totalRent": "Jahresmiete gesamt",
          "totalAskingRent": "Gesamte Angebotsmiete",
          "weightedArea": "Gewichtete m2",
          "avgAskingRentPerM2": "Durchschn. Angebotsmiete/m2/Jahr",
          "avgRentPerM2": "Durchschn. Miete/m2/Jahr",
          "wault": "WAULT"
        },
        "values": {
          "years": "{{value}} Jahre"
        },
        "metrics": {
          "waltYears": "WALT: {{value}} Jahre",
          "expiry12": "Ablauf 12M: {{value}}",
          "expiry24": "Ablauf 24M: {{value}}",
          "expiry36": "Ablauf 36M: {{value}}"
        },
        "actions": {
          "clear": "Analyse leeren",
          "collapseSurfaces": "Flaechen einklappen",
          "expandSurfaces": "Flaechen ausklappen",
          "remove": "Entfernen"
        },
        "table": {
          "property": "Objekt",
          "tenant": "Mieter",
          "annualRent": "Jahresmiete",
          "askingRent": "Angebotsmiete",
          "weightedM2": "Gewichtete m2",
          "rentPerM2": "Miete/m2",
          "askingRentPerM2": "Angebotsmiete/m2",
          "expiry": "Ablauf",
          "remainingTerm": "Restlaufzeit",
          "remainingMonths": "Restmonate",
          "guaranteeMonths": "Garantiemonate",
          "surfaces": "Flaechen",
          "front": "Front",
          "rentCoverage": "Mietdeckung",
          "interestCoverage": "Zinsdeckung",
          "weightedArea": "Gewichtete m2",
          "ltv": "LTV"
        },
        "surfaces": {
          "title": "Flaechen",
          "helper": "Standard: Retail 100%, Nebenflaeche 50%. Passe dies hier je Etage an.",
          "weightedTotal": "Gewichtete Summe",
          "grossM2": "{{value}} m2 brutto",
          "weightedM2Value": "= {{value}} m2",
          "empty": "Keine Flaechen gefunden. Fuelle Retail- und Nebenflaechen unter oeffentlichen Daten aus.",
          "button": "Flaechen"
        },
        "surfaceFields": {
          "beganeGrondWinkel": "EG Verkauf",
          "beganeGrondSecundair": "EG Nebenflaeche",
          "kelderWinkel": "Keller Verkauf",
          "kelderSecundair": "Keller Nebenflaeche",
          "eersteVerdiepingWinkel": "1. OG Verkauf",
          "eersteVerdiepingSecundair": "1. OG Nebenflaeche",
          "tweedeVerdiepingWinkel": "2. OG Verkauf",
          "tweedeVerdiepingSecundair": "2. OG Nebenflaeche",
          "derdeVerdiepingWinkel": "3. OG Verkauf",
          "derdeVerdiepingSecundair": "3. OG Nebenflaeche",
          "entresolWinkel": "Zwischengeschoss Verkauf",
          "entresolSecundair": "Zwischengeschoss Nebenflaeche",
          "soussolWinkel": "Souterrain Verkauf",
          "soussolSecundair": "Souterrain Nebenflaeche",
          "front": "Front",
          "winkel": "Laden",
          "secundair": "Nebenflaeche",
          "begane_grond_winkel": "Erdgeschoss Laden",
          "begane_grond_secundair": "Erdgeschoss Nebenflaeche",
          "kelder_winkel": "Keller Laden",
          "kelder_secundair": "Keller Nebenflaeche",
          "shop": "Laden",
          "secondary": "Nebenflaeche"
        },
        "chips": {
          "wault": "WAULT: {{value}} Jahre",
          "expiry12": "Ablauf 12M: {{value}}",
          "expiry24": "Ablauf 24M: {{value}}",
          "expiry36": "Ablauf 36M: {{value}}"
        }
      },
      "brokerRequests": {
        "title": "Makleranfragen",
        "overview": "?bersicht",
        "empty": "Keine Anfragen",
        "interestCount": "{{count}} Interesse(n)",
        "buyContact": "Kaufen (€9)",
        "profile": {
          "industry": "Branche",
          "stores": "Filialen",
          "activeIn": "Aktiv in",
          "founded": "Gr?ndungsjahr",
          "revenue": "Umsatz"
        }
      },
      "retailerProperties": {
        "sameBrandInterestBlocked": "Interesse an einem Objekt der eigenen Marke oder Gruppe ist nicht erlaubt."
      },
      "landing": {
        "language": {
          "select": "Sprache wählen"
        },
        "nav": {
          "aria": "Hauptnavigation",
          "forWho": "Für wen",
          "howItWorks": "So funktioniert es",
          "product": "Produkt",
          "price": "Preis"
        },
        "actions": {
          "login": "Login",
          "register": "Registrieren",
          "startFree": "Kostenlos registrieren",
          "start60": "60 Tage kostenlos starten",
          "startTrial": "Kostenlose Testphase starten",
          "viewProduct": "Produkt ansehen"
        },
        "auth": {
          "tag": "Account",
          "close": "Formular schließen",
          "copy": {
            "loginTitle": "Willkommen zurück.",
            "loginText": "Melden Sie sich mit Ihrer geschäftlichen E-Mail-Adresse an und öffnen Sie Ihre Karte, Objekte und Daten.",
            "registerTitle": "Starten Sie Ihre kostenlose Testphase.",
            "registerText": "Erstellen Sie ein Geschäftskonto und testen Sie die Karte 60 Tage kostenlos. Nach der Registrierung senden wir Ihnen eine E-Mail zur Verifizierung Ihres Kontos.",
            "forgotTitle": "Zugang wiederherstellen.",
            "forgotText": "Geben Sie Ihre E-Mail-Adresse ein. Falls ein Konto besteht, senden wir Ihnen eine Wiederherstellungs-E-Mail."
          },
          "twoFactor": {
            "help": "Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein.",
            "label": "2FA-Code",
            "back": "Zurück zum Passwort"
          },
          "forgot": {
            "link": "Passwort vergessen?",
            "help": "Geben Sie Ihre E-Mail-Adresse ein. Falls das Konto existiert, senden wir einen Link zum Zurücksetzen des Passworts.",
            "submit": "Wiederherstellungs-E-Mail senden",
            "back": "Zurück zum Login",
            "openLocal": "Lokalen Reset-Link öffnen"
          },
          "fields": {
            "email": "E-Mail-Adresse",
            "businessEmail": "Geschäftliche E-Mail-Adresse",
            "password": "Passwort",
            "role": "Rolle",
            "chooseRole": "Rolle wählen",
            "firstName": "Vorname",
            "lastName": "Nachname",
            "companyName": "Firmenname"
          },
          "registerNote": "60 Tage kostenlos. Keine Kreditkarte erforderlich. Sie erhalten zuerst eine Verifizierungs-E-Mail zur Aktivierung Ihres Kontos.",
          "legalAccept": "Ich akzeptiere die <privacy>Datenschutzerklärung</privacy> und die <terms>Allgemeinen Geschäftsbedingungen</terms>.",
          "notices": {
            "emailVerified": "Ihre E-Mail-Adresse wurde bestätigt. Melden Sie sich an, um Retailmaps zu öffnen.",
            "twoFactorRequired": "Geben Sie Ihren 2FA-Code ein, um fortzufahren.",
            "registerSuccess": "Registrierung erfolgreich. Wir haben eine Bestätigungs-E-Mail an Ihre Adresse gesendet.",
            "forgotSent": "Wenn diese E-Mail-Adresse bekannt ist, senden wir eine Wiederherstellungs-E-Mail."
          },
          "errors": {
            "loginFailed": "Login fehlgeschlagen. Bitte prüfen Sie Ihre Angaben.",
            "twoFactorFailed": "Login fehlgeschlagen. Bitte prüfen Sie Ihren 2FA-Code.",
            "businessEmail": "Verwenden Sie eine geschäftliche E-Mail-Adresse. Kostenlose E-Mail-Adressen wie Gmail, Hotmail, Outlook oder iCloud sind nicht erlaubt.",
            "roleRequired": "Wählen Sie zuerst Ihre Rolle: Retailer, Eigentümer oder Makler.",
            "companyRequired": "Geben Sie Ihren Firmennamen ein.",
            "legalRequired": "Akzeptieren Sie die Datenschutzerklärung und Bedingungen, um Ihr Konto zu erstellen.",
            "registerFailed": "Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
            "forgotFailed": "Passwort-Wiederherstellung fehlgeschlagen."
          }
        },
        "roles": {
          "options": {
            "retailer": "Retailer",
            "owner": "Eigentümer",
            "broker": "Makler"
          },
          "tag": "Für wen",
          "title": "Drei Rollen, drei Wege, schneller zu handeln.",
          "intro": "Expansion, Portfoliomanagement und Beratung — alles in einer Kartenumgebung.",
          "retailer": {
            "kicker": "Für Retailer",
            "title": "Finden Sie den richtigen Standort, bevor er am Markt ist.",
            "text": "Folgen Sie Objekten, zeigen Sie diskret Interesse und verpassen Sie keine Chancen mehr.",
            "points": {
              "1": {
                "title": "Proaktiv Interesse zeigen",
                "text": "Halten Sie Interesse an einem bestimmten Objekt fest, auch wenn es noch nicht offiziell verfügbar ist."
              },
              "2": {
                "title": "Bis zum richtigen Moment anonym bleiben",
                "text": "Eigentümer, Makler und aktuelle Retailer sehen Ihr anonymes Interesse und können Kontakt aufnehmen, sobald der Zeitpunkt passt."
              },
              "3": {
                "title": "Standorte verfolgen und nachfassen",
                "text": "Speichern Sie Projektinformationen, Fotos und Notizen <underline>pro Objekt</underline> und teilen Sie sie mit Ihrem Team. Folgen Sie Objekten und erhalten Sie Benachrichtigungen, wenn Bewegung entsteht. So gehen wertvolle Daten nicht mehr verloren."
              }
            }
          },
          "owner": {
            "kicker": "Für Eigentümer",
            "title": "Mehr Kontrolle über Portfolio, Marktnachfrage und Vermietungsstrategie.",
            "text": "Eigentümer verwalten Einzelhandelsimmobilien aus einer zentralen Umgebung. Stellen Sie ein Objekt mit einem Klick zur Vermietung, erstellen Sie bei Bedarf automatisch Projektinformationen, analysieren Sie Ihr Portfolio und verteilen Sie Standorte auf Teammitglieder.",
            "points": {
              "1": {
                "title": "Portfolio verwalten",
                "text": "Halten Sie Objekt-, Miet- und Kontaktdaten, Dokumente und Notizen übersichtlich <underline>pro Objekt</underline> fest, sichtbar für Ihr gesamtes Team. Fügen Sie Felder und Abschnitte hinzu und bauen Sie eine vollständig anpassbare Immobiliendatenbank, die zu Ihrer Arbeitsweise passt."
              },
              "2": {
                "title": "Interessen von Retailern erhalten",
                "text": "Sehen Sie, welche interessierten Retailer sich melden, inklusive Branche und Art des Interesses. Auch wenn das Objekt noch regulär vermietet ist."
              },
              "3": {
                "title": "Alerts einstellen",
                "text": "Vergessen Sie nie wieder eine Indexierung, Kündigungsfrist oder einen anderen wichtigen Termin."
              }
            }
          },
          "broker": {
            "kicker": "Für Makler",
            "title": "Besser beraten mit sichtbarer Marktnachfrage.",
            "text": "Kombinieren Sie Standortdaten, Mietstatus, Retailer-Labels und Interesse in einem Arbeitsplatz. Beratung hängt weniger von losen Listen ab und basiert stärker auf aktuellen Daten.",
            "points": {
              "1": {
                "title": "Interaktive Karte",
                "text": "Suchen Sie Retailer, passen Sie Labels an die aktuelle Situation an und tragen Sie zur vollständigsten Open-Source-Retailmap der Welt bei."
              },
              "2": {
                "title": "Leads finden und besser beraten",
                "text": "Nutzen Sie Leads, um gezielter zu arbeiten und Eigentümer mit besseren Marktinformationen zu beraten."
              },
              "3": {
                "title": "Alle Immobiliendaten an einem Ort",
                "text": "Rufen Sie Immobiliendaten ab, analysieren und teilen Sie sie mit Teammitgliedern, mobil und am Desktop."
              },
              "4": {
                "title": "Objekte einfach anbieten",
                "text": "Stellen Sie Objekte schnell zur Vermietung und passen Sie die Sichtbarkeit an, wenn die Situation es erfordert."
              }
            }
          }
        },
        "hero": {
          "eyebrow": "Retail Real Estate Intelligence",
          "title": "Retailmaps ist DIE interaktive Karte für Handelsimmobilien.",
          "line1": "Für und von Retail-Profis.",
          "line2": "Finden Sie interessante Standorte, zeigen Sie anonym Interesse, verfolgen Sie Entwicklungen und verwalten Sie Objektinformationen in einer zentralen Umgebung — auf Laptop und Mobilgerät.",
          "line3": "Für Retailer, Eigentümer und Makler, die schneller sehen wollen, wo Nachfrage, Angebot und Lage zusammenkommen.",
          "proofs": {
            "trial": "60 Tage kostenlos. Ohne Verpflichtungen.",
            "price": "Danach 19 € pro Monat",
            "cancel": "Keine Kündigung nötig",
            "noCard": "Keine Kreditkarte erforderlich",
            "noCharges": "Keine automatische Zahlung",
            "afterTrial": "Nach 60 Tagen entscheidest du selbst, ob du kostenpflichtig weitermachen möchtest. Tust du nichts, zahlst du nichts.",
            "cta": "Kostenlose Testphase starten"
          }
        },
        "how": {
          "tag": "So funktioniert es",
          "title": "Arbeiten Sie aus der Karte, nicht aus losen Listen.",
          "steps": {
            "1": {
              "title": "In das Einkaufsgebiet hineinzoomen",
              "text": "Sehen Sie Objekte, Retailer und Verfügbarkeit direkt auf Straßenebene."
            },
            "2": {
              "title": "Ein Objekt öffnen",
              "text": "Sehen Sie alle relevanten Informationen an einem Ort: private Daten, Flächen, Miet-, Objekt- und Finanzdaten, Kontakte, Fotos, Notizen und Dokumente."
            },
            "3": {
              "title": "Interesse oder Verfügbarkeit festhalten",
              "text": "Retailer zeigen diskret Interesse. Makler stellen Objekte zur Vermietung und bestimmen selbst, für wen die Informationen sichtbar sind."
            }
          }
        },
        "product": {
          "tag": "Produkt",
          "title": "Nicht nur Daten. Ein täglicher Arbeitsplatz.",
          "features": {
            "1": {
              "title": "Interaktive Karte",
              "text": "Arbeiten Sie visuell von Einkaufsstraßen, Objekten und Gebieten aus, statt nur mit Tabellen."
            },
            "2": {
              "title": "Interesse zeigen",
              "text": "Marktnachfrage sichtbar machen, ohne sensible Strategien offenzulegen."
            },
            "3": {
              "title": "Private Daten",
              "text": "Mietdaten, Dokumente, Fotos und Notizen an einem Ort, geschützt innerhalb der Organisation. Keine Exporte und Zwei-Faktor-Login für optimalen Schutz."
            },
            "4": {
              "title": "Street-View-Kontext",
              "text": "Betrachten und prüfen Sie Standorte direkt von der Straße aus, neben der Karte, für ein besseres Verständnis der Lage."
            }
          }
        },
        "visual": {
          "tag": "Im Bild",
          "title": "Standortkontext ohne Wechseln",
          "text": "Street View hilft bei der schnellen Beurteilung von Fassade, Lage und Umgebung."
        },
        "price": {
          "tag": "Preis",
          "title": "Einfach starten, ohne langen Prozess.",
          "text": "Testen Sie die Karte 60 Tage kostenlos. Nach der Testphase entscheiden Sie selbst, ob Sie weitermachen. Der Preis bleibt einfach, damit die Plattform auch für kleine Teams sinnvoll ist.",
          "cardTitle": "Retailmaps Professional",
          "amount": "19 €",
          "period": "/ Monat",
          "cardText": "Retailmaps 60 Tage kostenlos testen. Keine Kreditkarte erforderlich.",
          "items": {
            "1": "Interaktive Karte und Objektliste",
            "2": "Interesse zeigen und Alerts",
            "3": "Objektdaten, Dokumente und Notizen",
            "4": "Funktioniert auf Laptop und Mobilgerät"
          }
        },
        "final": {
          "title": "Sehen Sie, wo Bewegung im Einzelhandelsimmobilienmarkt entsteht.",
          "text": "Starten Sie mit der Karte, folgen Sie relevanten Objekten und sehen Sie schneller, wo Nachfrage, Angebot und Lage zusammenkommen."
        },
        "images": {
          "interestStackAria": "Mobile Interessenfunktion",
          "interestSavedAlt": "Interesse mobil zurückziehen",
          "interestAlt": "Interesse an einem Objekt mobil zeigen",
          "interestCaption": "Zeigen Sie Interesse an Ihrem bevorzugten Objekt.",
          "ownerAlt": "Eigentümerübersicht mit eingegangenen Interessen",
          "ownerCaption": "Sehen Sie pro Objekt, welches Interesse eingeht, und entscheiden Sie selbst, wann Sie Kontaktdaten anfordern.",
          "brokerAlt": "Makler-Dashboard mit Objekten, Retailern und Leads",
          "brokerCaption": "Sehen Sie Objekte, Retailer und Leads einfach in einer Übersicht.",
          "rentalAlt": "Mobile Objektinformationen mit Mietangebot",
          "streetViewAlt": "Karte und Street View nebeneinander"
        },
        "footer": {
          "copyright": "© 2026 Retailmaps.com",
          "security": "Daten & Sicherheit",
          "privacy": "Datenschutzerklärung",
          "terms": "Bedingungen",
          "contact": "Kontakt"
        }
      },
      "popup.autosaveActive": "Autosave aktiv",
      "retailerMap.mobileZoomFeedback": "Zoom {{zoom}} – ab 19 doppeltippen, um hinzuzufügen",
      "retailerMap.installPrompt.title": "Retailmaps schneller öffnen",
      "retailerMap.installPrompt.subtitle": "Fügen Sie Retailmaps zum Startbildschirm hinzu.",
      "retailerMap.installPrompt.install": "Zum Handy hinzufügen",
      "retailerMap.installPrompt.later": "Später",
      "retailerMap.iosInstall.title": "Retailmaps zum Startbildschirm hinzufügen",
      "retailerMap.iosInstall.intro": "Auf dem iPhone kann Safari dies nicht automatisch tun. Folgen Sie diesen Schritten:",
      "retailerMap.iosInstall.step1": "1. Tippen Sie unten auf die Teilen-Schaltfläche",
      "retailerMap.iosInstall.step2": "2. Wählen Sie Zum Home-Bildschirm.",
      "retailerMap.iosInstall.step3": "3. Tippen Sie auf Hinzufügen.",
      "common.understood": "Verstanden",
      "propertyList.filters.country": "Land",
      "propertyList.filters.allCountries": "Alle Laender",
      "propertyList.interest.changeFailed": "Interesse konnte nicht geaendert werden.",
      "propertyList.interest.ownGroup": "Eigene Gruppe",
      "propertyList.interest.viaColleague": "Ueber Kollegin/Kollegen",
      "propertyList.interest.withdraw": "Zurueckziehen",
      "propertyList.interest.show": "Interesse zeigen",
      "propertyList.rental.stop": "Vermietung stoppen",
      "propertyList.rental.setForRent": "Zur Vermietung setzen",
      "ownerListings": {
        "currentOffer": "Meine Mietangebote"
      },
      "broker": {
        "listingsTitle": "Meine Mietangebote"
      },
      "retailer": {
        "listingsTitle": "Meine Mietangebote",
        "contactgegevensBlock": {
          "title": "Kontaktdaten",
          "phone": "Telefon",
          "add": "Kontakt hinzufügen",
          "remove": "Kontakt entfernen"
        }
      },
      "retailer.listingsTitle": "Meine Mietangebote",
      "owner": {
        "ownerFields": {
          "title": "Eigentümerdaten",
          "parentCompany": "Muttergesellschaft des Eigentümers",
          "owner": "Eigentümer",
          "contactPerson": "Kontaktperson",
          "email": "E-Mail-Adresse",
          "phone": "Telefonnummer"
        },
        "huurgegevensBlock": {
          "title": "Mietdaten",
          "formeleHuurder": "Formeller Mieter",
          "huurprijs": "Miete",
          "ingangsdatum": "Mietbeginn",
          "expiratiedatum": "Ablaufdatum",
          "resterendeLooptijdMaanden": "Restlaufzeit (Monate)",
          "huurtermijn": "Mietlaufzeit (Jahre)",
          "verlengingsjaren": "Verlängerungsjahre",
          "huurvrijePeriodeMaanden": "Mietfreie Zeit (Monate)",
          "indexatiedatum": "Indexierungsdatum",
          "opzegdatum": "Kündigungsdatum",
          "opzegtermijn": "Kündigungsfrist (Monate)",
          "garantiesoort": "Garantieart",
          "kiesOptie": "Option wählen",
          "waarborgsom": "Kaution",
          "bankgarantie": "Bankgarantie",
          "concerngarantie": "Konzerngarantie",
          "garantiebedrag": "Garantiebetrag",
          "noGuarantee": "Keine Garantie"
        },
        "financieringBlock": {
          "title": "Finanzdaten",
          "koopsom": "Kaufpreis",
          "aankoopdatum": "Kaufdatum",
          "actueleMarktwaarde": "Aktueller Marktwert",
          "taxatiedatum": "Bewertungsdatum",
          "hypotheek": "Hypothekenbetrag",
          "actueleHypotheekschuld": "Aktuelle Hypothekenschuld",
          "actueleHypotheekrente": "Aktueller Hypothekenzins (%)",
          "rentevastTot": "Zinsbindung bis",
          "aflossingspercentage": "Tilgungsprozentsatz (%)",
          "looptijd": "Laufzeit (Jahre)",
          "jaarlijkseRentelasten": "Jährliche Zinskosten",
          "jaarlijkseAflossing": "Jährliche Tilgung",
          "bank": "Bank",
          "jaarlijkseOverigeLasten": "Jährliche sonstige Kosten",
          "netOperatingIncome": "Net Operating Income",
          "markthuurPerM2": "Marktmiete pro m²",
          "servicekostenPerJaar": "Nebenkosten pro Jahr",
          "rentepercentage": "Zinssatz",
          "jaar": "Jahr",
          "vraagprijs": "Angebotspreis"
        },
        "opmerkingen": {
          "title": "Notizen",
          "none": "Noch keine Notizen hinzugefügt.",
          "unknownAuthor": "Unbekannter Autor",
          "add": "Notiz hinzufügen",
          "placeholder": "Notiz hier eingeben?"
        },
        "contactgegevensBlock": {
          "title": "Kontaktdaten",
          "add": "Kontakt hinzufügen",
          "remove": "Kontakt entfernen",
          "company": "Unternehmen",
          "name": "Name",
          "phone": "Telefon",
          "email": "E-Mail",
          "function": "Funktion"
        }
      },
      "owner.financieringBlock.actueleMarktwaarde": "Aktueller Marktwert",
      "owner.financieringBlock.taxatiedatum": "Bewertungsdatum",
      "owner.financieringBlock.actueleHypotheekschuld": "Aktuelle Hypothekenschuld",
      "owner.financieringBlock.actueleHypotheekrente": "Aktueller Hypothekenzins (%)",
      "owner.financieringBlock.rentevastTot": "Zinsbindung bis",
      "owner.financieringBlock.aflossingspercentage": "Tilgungsprozentsatz (%)",
      "owner.financieringBlock.jaarlijkseRentelasten": "Jährliche Zinskosten",
      "owner.financieringBlock.jaarlijkseAflossing": "Jährliche Tilgung",
      "owner.financieringBlock.jaarlijkseOverigeLasten": "Jährliche sonstige Kosten",
      "owner.financieringBlock.netOperatingIncome": "Net Operating Income",
      "owner.financieringBlock.markthuurPerM2": "Marktmiete pro m²",
      "owner.financieringBlock.servicekostenPerJaar": "Nebenkosten pro Jahr",
      "propertyDetails.objectInfoDivider": "Objektinformationen",
      "propertyDetails.addObjectInfo": "Objektinformationen hinzufügen",
      "listings.common.forRentSince": "Zur Miete seit",
      "listings.common.broker": "Makler",
      "listings.common.edit": "Bearbeiten",
      "listings.common.save": "Speichern",
      "listings.common.cancel": "Abbrechen",
      "roles": {
        "owner": "Eigentümer",
        "retailer": "Retailer",
        "broker": "Makler"
      },
      "listings.common.noDocuments": "Keine Dokumente verfügbar.",
      "listings.common.fileCountOne": "{{count}} Datei",
      "listings.common.fileCountOther": "{{count}} Dateien",
      "listings.common.addedOn": "Hinzugefügt {{date}}",
      "listings.common.deleteDocumentAria": "{{name}} löschen",
      "common.open": "Öffnen",
      "photos": {
        "title": "Fotos",
        "add": "Foto hinzufügen",
        "remove": "Foto entfernen",
        "useAsCover": "Als Titelbild verwenden",
        "cover": "Titelbild",
        "chooseCover": "Auswählen",
        "openPreview": "Vorschau öffnen",
        "error": {
          "tooLarge": "ist groesser als 10 MB und wurde uebersprungen."
        }
      },
      "photos.useAsCover": "Als Titelbild verwenden",
      "photos.cover": "Titelbild",
      "photos.chooseCover": "Auswählen",
      "photos.openPreview": "Vorschau öffnen",
      "propertyDetails.notesDivider": "Notizen",
      "retailerProperty": {
        "contactsDivider": "Kontakte",
        "notesDivider": "Notizen",
        "photosDivider": "Fotos"
      },
      "retailerProperty.notesDivider": "Notizen",
      "accountSettings": {
        "company": {
          "brandLogoTitle": "Marke und Logo",
          "brandLogoDescription": "Wir verwenden dieses Logo auf Objektkarten und anderen sichtbaren Markenflaechen.",
          "title": "Unternehmensprofil",
          "description": "Unternehmensdaten, Markeninformationen und Abrechnung fuer Makler- und Eigentuemerkonten. Aenderungen werden automatisch gespeichert.",
          "readOnlyNotice": "Unternehmensgruppe und Domain steuern Verknuepfungen, Sichtbarkeit und KI-Profile und bleiben daher schreibgeschuetzt.",
          "companyName": "Unternehmensname",
          "companyGroup": "Unternehmensgruppe",
          "domain": "Domain",
          "legalName": "Rechtlicher Name",
          "website": "Website",
          "roleType": "Rollentyp",
          "headquartersTitle": "Hauptsitz",
          "headquartersAddress": "Adresse Hauptsitz",
          "postalCode": "Postleitzahl",
          "city": "Stadt",
          "country": "Land",
          "billingTitle": "Abrechnung",
          "billingDescription": "Diese Angaben verwenden wir fuer Abonnements, Rechnungen und Finanzadministration.",
          "billingEmail": "E-Mail fuer Abrechnung",
          "invoiceReference": "Rechnungsreferenz / PO",
          "chamberOfCommerce": "Handelsregisternummer",
          "vatNumber": "USt-IdNr.",
          "billingAddress": "Rechnungsadresse",
          "taxIdType": "Steuernummer-Typ",
          "taxIdValue": "USt- / Steuernummer",
          "taxIdPlaceholder": "DE123456789",
          "peopleTitle": "Personen",
          "peopleDescription": "Konten, die mit derselben Organisation verknuepft sind. Status basiert auf Abonnement und Testzeitraum.",
          "peopleName": "Name",
          "peopleEmail": "E-Mail",
          "peopleRole": "Rolle",
          "peopleStatus": "Status",
          "peopleTrialUntil": "Test bis",
          "peopleYou": "Du",
          "peopleEmpty": "Es wurden noch keine anderen Konten in dieser Organisation gefunden.",
          "statusActive": "Aktiv",
          "statusTrial": "Testphase",
          "statusInactive": "Nicht aktiv",
          "taxTypes": {
            "euVat": "Europaeische USt-IdNr.",
            "gbVat": "Britische USt-IdNr.",
            "auAbn": "Australische Unternehmensnummer (AU ABN)",
            "auArn": "Australische Steuerreferenznummer",
            "brCnpj": "Brasilianische CNPJ-Nummer",
            "brCpf": "Brasilianische CPF-Nummer",
            "caBn": "Kanadische BN",
            "caGstHst": "Kanadische GST/HST-Nummer",
            "chVat": "Schweizer USt-IdNr.",
            "clTin": "Chilenische TIN",
            "egTin": "Aegyptische Steueridentifikationsnummer",
            "inGst": "Indische GST-Nummer",
            "jpCn": "Japanische Unternehmensnummer",
            "jpRn": "Japanische Registrierungsnummer fuer auslaendische Unternehmen",
            "mxRfc": "Mexikanische RFC-Nummer",
            "noVat": "Norwegische USt-IdNr.",
            "nzGst": "Neuseelaendische GST-Nummer",
            "sgGst": "Singapurische GST-Nummer",
            "usEin": "US EIN",
            "zaVat": "Suedafrikanische USt-IdNr."
          }
        },
        "title": "Einstellungen",
        "tabs": {
          "profile": "Profil",
          "company": "Unternehmen",
          "preferences": "Einstellungen",
          "security": "Sicherheit",
          "billing": "Abrechnung"
        },
        "descriptions": {
          "profile": "Kontaktdaten und Rolleninformationen fuer dein Konto.",
          "company": "Unternehmensdaten, Marke und Abrechnung.",
          "preferences": "Sprache, Waehrung, Einheiten und Kartenanzeige.",
          "security": "Login und Kontosicherheit.",
          "billing": "Abonnement, Nutzung und einmalige Kaeufe."
        },
        "personal": {
          "title": "Persoenliches Profil",
          "description": "Kontaktdaten und Rolleninformationen fuer dein Konto. Aenderungen werden automatisch gespeichert.",
          "firstName": "Vorname",
          "lastName": "Nachname",
          "role": "Position",
          "phone": "Telefonnummer",
          "email": "E-Mail-Adresse",
          "linkedin": "LinkedIn",
          "address": "Adresse"
        }
      },
      "account.noLogo": "Noch kein Logo",
      "listings.common.uploading": "Wird hochgeladen...",
      "propertyDetails.detailsDivider": "Details",
      "common.saved": "Gespeichert",
      "common.saving": "Speichern...",
      "common.saveFailed": "Speichern fehlgeschlagen",
      "common.ready": "Bereit",
      "common.active": "Aktiv",
      "common.inactive": "Nicht aktiv",
      "common.canceled": "Gekuendigt",
      "accountSettings.tabs.security": "Sicherheit",
      "accountSettings.descriptions.security": "Login und Kontosicherheit.",
      "accountSettings.company.taxIdType": "Steuernummer-Typ",
      "accountSettings.company.taxIdValue": "USt- / Steuernummer",
      "accountSettings.company.taxIdPlaceholder": "DE123456789",
      "accountSettings.company.peopleTitle": "Personen",
      "accountSettings.company.peopleDescription": "Konten, die mit derselben Organisation verknuepft sind. Status basiert auf Abonnement und Testzeitraum.",
      "accountSettings.company.peopleName": "Name",
      "accountSettings.company.peopleEmail": "E-Mail",
      "accountSettings.company.peopleRole": "Rolle",
      "accountSettings.company.peopleStatus": "Status",
      "accountSettings.company.peopleTrialUntil": "Test bis",
      "accountSettings.company.peopleYou": "Du",
      "accountSettings.company.peopleEmpty": "Es wurden noch keine anderen Konten in dieser Organisation gefunden.",
      "accountSettings.company.statusTrial": "Testphase",
      "accountSettings.company.statusActive": "Aktiv",
      "accountSettings.company.statusInactive": "Nicht aktiv",
      "accountSettings.company.taxTypes.euVat": "Europaeische USt-IdNr.",
      "accountSettings.company.taxTypes.gbVat": "Britische USt-IdNr.",
      "accountSettings.company.taxTypes.auAbn": "Australische Unternehmensnummer (AU ABN)",
      "accountSettings.company.taxTypes.auArn": "Australische Steuerreferenznummer",
      "accountSettings.company.taxTypes.brCnpj": "Brasilianische CNPJ-Nummer",
      "accountSettings.company.taxTypes.brCpf": "Brasilianische CPF-Nummer",
      "accountSettings.company.taxTypes.caBn": "Kanadische BN",
      "accountSettings.company.taxTypes.caGstHst": "Kanadische GST/HST-Nummer",
      "accountSettings.company.taxTypes.chVat": "Schweizer USt-IdNr.",
      "accountSettings.company.taxTypes.clTin": "Chilenische TIN",
      "accountSettings.company.taxTypes.egTin": "Aegyptische Steueridentifikationsnummer",
      "accountSettings.company.taxTypes.inGst": "Indische GST-Nummer",
      "accountSettings.company.taxTypes.jpCn": "Japanische Unternehmensnummer",
      "accountSettings.company.taxTypes.jpRn": "Japanische Registrierungsnummer fuer auslaendische Unternehmen",
      "accountSettings.company.taxTypes.mxRfc": "Mexikanische RFC-Nummer",
      "accountSettings.company.taxTypes.noVat": "Norwegische USt-IdNr.",
      "accountSettings.company.taxTypes.nzGst": "Neuseelaendische GST-Nummer",
      "accountSettings.company.taxTypes.sgGst": "Singapurische GST-Nummer",
      "accountSettings.company.taxTypes.usEin": "US EIN",
      "accountSettings.company.taxTypes.zaVat": "Suedafrikanische USt-IdNr.",
      "security.twoFactor.title": "Zwei-Faktor-Authentifizierung",
      "security": {
        "twoFactor": {
          "title": "Zwei-Faktor-Authentifizierung",
          "subtitle": "Schuetze dein Konto mit einem 6-stelligen Code aus einer Authenticator-App.",
          "setup": "2FA einrichten",
          "scanQr": "Scanne den QR-Code mit deiner Authenticator-App. Falls das nicht funktioniert, nutze den Einrichtungscode manuell.",
          "openAuthenticator": "In Authenticator-App oeffnen",
          "sixDigitCode": "6-stelliger Code",
          "enable": "2FA aktivieren",
          "disableWarning": "Deaktiviere 2FA nur, wenn du sicher bist, dass dieses Konto anders geschuetzt ist.",
          "code": "2FA-Code",
          "disable": "2FA deaktivieren"
        },
        "password": "Passwort"
      },
      "security.twoFactor.subtitle": "Schuetze dein Konto mit einem 6-stelligen Code aus einer Authenticator-App.",
      "security.twoFactor.setup": "2FA einrichten",
      "security.twoFactor.scanQr": "Scanne den QR-Code mit deiner Authenticator-App. Falls das nicht funktioniert, nutze den Einrichtungscode manuell.",
      "security.twoFactor.openAuthenticator": "In Authenticator-App oeffnen",
      "security.twoFactor.sixDigitCode": "6-stelliger Code",
      "security.twoFactor.enable": "2FA aktivieren",
      "security.twoFactor.disableWarning": "Deaktiviere 2FA nur, wenn du sicher bist, dass dieses Konto anders geschuetzt ist.",
      "security.password": "Passwort",
      "security.twoFactor.code": "2FA-Code",
      "security.twoFactor.disable": "2FA deaktivieren",
      "billing.baseSubscription": "Basisabonnement",
      "billing.baseSubscriptionDescription": "Zugang zu Retailmaps und Basisfunktionen.",
      "billing.forRent": "Zu vermieten",
      "billing.forRentDescription": "Aktive Mietobjekte, die ueber dieses Benutzerkonto aktiviert wurden.",
      "billing.totals.trialDiscount": "Testrabatt",
      "billing.totals.vat": "MwSt.",
      "billing.totals.totalInclVat": "Gesamt inkl. MwSt.",
      "settingsPanel.mailTest.previewLogged": "{{provider}} ist noch nicht vollstaendig eingerichtet. Die Test-E-Mail wurde als Vorschau fuer {{recipient}} protokolliert.",
      "settingsPanel.mailTest.sentMessage": "Test-E-Mail an {{recipient}} ueber {{provider}} gesendet.",
      "propertyDetails.datePlaceholder": "tt-mm-jjjj",
      "brokerProperty": {
        "askingPrice": "Angebotspreis"
      },
      "owner.financieringBlock.vraagprijs": "Angebotspreis",
      "propertyDetails.askingRentPrice": "Angebotsmiete",
      "propertyDetails.serviceCosts": "Nebenkosten",
      "propertyDetails.takeoverPrice": "Abl?sesumme",
      "propertyDetails.availableFrom": "Verf?gbar ab",
      "propertyDetails.projectInfoDivider": "Projektinformationen",
      "propertyDetails.addProjectInfo": "Projektinformationen hinzufuegen",
      "extraSections": {
        "addField": "Feld hinzufügen",
        "addSection": "Abschnitt hinzufügen",
        "newTab": "Neuer Tab",
        "titleLabel": "Titel",
        "fieldLabel": "Feldname",
        "fieldType": "Typ",
        "value": "Wert",
        "tabName": "Tabname",
        "renameTab": "Tab umbenennen",
        "untitledTab": "Tabname",
        "sectionName": "Abschnittsname"
      },
      "extraFields.addField": "Feld hinzufuegen",
      "extraFields": {
        "addField": "Feld hinzufuegen",
        "addSection": "Abschnitt hinzufuegen"
      },
      "extraFields.addSection": "Abschnitt hinzufuegen",
      "extraFieldsBlock": {
        "addField": "Feld hinzufuegen",
        "addHeader": "Abschnitt hinzufuegen",
        "title": "Zusatzfelder"
      },
      "settingsPanel.map.colors.retail.picker": "Farbe fuer Retail-Gebaeude waehlen",
      "settingsPanel.map.colors.other.picker": "Farbe anderer Gebaeude waehlen",
      "retailerMap.downloadSvg": "SVG herunterladen",
      "retailerMap.downloadSvgTooltip": "Karte als SVG-Datei herunterladen",
      "retailerMap.printMenu.paper": "Auf Papier drucken",
      "retailerMap.printMenu.pdf": "Als PDF speichern",
      "retailerMap.printMenu.svg": "Kartenbild als SVG herunterladen",
      "dashboardOverlay": {
        "shared": {
          "assistant": "So funktioniert es",
          "forRent": "Zu vermieten",
          "requests": "Anfragen",
          "alerts": "Alerts",
          "analysis": "Analyse",
          "settings": "Einstellungen"
        },
        "broker": {
          "properties": "Objekte"
        }
      },
      "myProperties.nr": "Nr.",
      "myProperties.tenant": "Mieter",
      "myProperties.status": "Status",
      "myProperties.actions": "Aktionen",
      "myProperties.assetManager": "Asset-Manager",
      "myProperties.noAssetManager": "- keiner -",
      "myProperties.noPaidSubscriptionSuffix": " - kein bezahltes Abo",
      "myProperties.noResults": "Keine Ergebnisse",
      "myProperties.ownProperties": "Meine Objekte",
      "myProperties.groupProperties": "Organisationsportfolio",
      "myProperties.stopRent": "Vermietung stoppen",
      "myProperties.setForRent": "Zur Vermietung setzen",
      "myProperties.street": "Strasse",
      "myProperties.allCities": "Alle Staedte",
      "myProperties.allStreets": "Alle Strassen",
      "myProperties.status.forRent": "Zu vermieten",
      "myProperties.status.rented": "Vermietet",
      "myProperties.bulk.assignToSelection": "Auswahl zuweisen",
      "myProperties.bulk.onlyUnassigned": "Nur ohne Asset-Manager",
      "myProperties.bulk.selectAllVisible": "Alle sichtbaren auswaehlen",
      "myProperties.bulk.noManagerSelected": "Waehle einen Asset-Manager.",
      "myProperties.bulk.noSelection": "Keine Objekte ausgewaehlt.",
      "myProperties.loading": "Laedt...",
      "myProperties.assignToMe": "Mir zuweisen",
      "myProperties.analysis": "Analyse",
      "myProperties.view": "Ansehen",
      "myProperties.assignError": "Zuweisung fehlgeschlagen.",
      "myProperties.assignRequiresPaidSubscription": "Dieser Benutzer braucht ein aktives Abo.",
      "myProperties.importPortfolio": "Portfolio importieren",
      "myProperties.rentToggleError": "Aenderung des Vermietungsstatus fehlgeschlagen.",
      "popup2": {
        "addedState": "Hinzugefuegt",
        "addToMyProperties": "Zu meinen Objekten hinzufuegen",
        "front": "Front",
        "groundFloor": "Erdgeschoss",
        "basement": "Untergeschoss",
        "firstFloor": "1. Obergeschoss",
        "secondFloor": "2. Obergeschoss",
        "thirdFloor": "3. Obergeschoss",
        "entresol": "Zwischengeschoss",
        "soussol": "Souterrain",
        "retailSpace": "Verkaufsfläche",
        "secondarySpace": "Nebenfläche",
        "adding": "Wird hinzugefügt...",
        "publicData": "Öffentliche Daten",
        "privateData": "Private Daten",
        "surface": "Fläche",
        "loginRequired": "Du bist nicht angemeldet. Bitte melde dich erneut an, um Objekte hinzuzufügen.",
        "confirmRemove": "Möchtest du dieses Objekt wirklich aus deiner Liste entfernen?",
        "pandVerwijderd": "Objekt wurde aus deiner Liste entfernt.",
        "verwijderenMislukt": "Entfernen fehlgeschlagen.",
        "removeFailed": "Entfernen fehlgeschlagen.",
        "saveFailed": "Speichern fehlgeschlagen.",
        "pandToegevoegd": "Objekt wurde deiner Liste hinzugefügt.",
        "toevoegenMislukt": "Hinzufügen fehlgeschlagen.",
        "addToList": "Zu meinen Objekten hinzufügen",
        "publicDataHint": "Sichtbare Objektdaten für Listen, Exposés und Kartenansichten.",
        "privateDataHint": "Interne Informationen bleiben in deinem geschützten Arbeitsbereich und sind nur für berechtigte Nutzer sichtbar.",
        "privateWorkspaceHint": "Verwalte hier sensible Eigentümernotizen, Finanzdaten, Kontakte, Fotos und Dokumente übersichtlich und sicher.",
        "viewRequests": "Anfragen im Dashboard ansehen →",
        "openbaarZichtbaarMaken": "Öffentlich sichtbar machen",
        "stripeAnnuleringMislukt": "Stripe-Kündigung fehlgeschlagen",
        "zetEerstTeHuur": "Setze das Objekt zuerst auf „zu vermieten“, bevor du es öffentlich sichtbar machst.",
        "opslaanWijzigingen": "Änderungen speichern",
        "alreadyInOrgPortfolio": "Objekt ist bereits im Organisationsportfolio",
        "alreadyInOwnPortfolio": "Objekt ist bereits in deinem Portfolio",
        "addPropertyError": "Fehler beim Hinzufügen des Objekts",
        "invalidSession": "Keine gültige Sitzung. Bitte erneut anmelden.",
        "ownerMustAddFirst": "Füge dieses Objekt zuerst deinem Portfolio hinzu.",
        "noUserEmail": "Keine E-Mail-Adresse gefunden. Bitte prüfe, ob du angemeldet bist.",
        "roleNotSupported": "Deine aktuelle Rolle unterstützt diese Aktion nicht."
      },
      "retailerMap": {
        "dashboard": "Dashboard",
        "loading": {
          "zoomInToLoad": "Bis {{zoom}} heranzoomen, um Retailer zu laden",
          "fillingStreet": "Neue Objekte werden geladen. Das kann bis zu 2 Minuten dauern...",
          "paintingFromCenter": "Objekte werden von der Mitte aus geladen..."
        }
      },
      "propertyFields": {
        "shop": "Laden",
        "storage": "Lager",
        "secondary": "Nebenfläche"
      },
      "propertyList": {
        "filters": {
          "country": "Land",
          "allCountries": "Alle Laender",
          "city": "Stadt",
          "select": "Auswaehlen...",
          "street": "Strasse",
          "typeStreet": "Strasse eingeben...",
          "retailer": "Retailer",
          "retailerExampleShort": "Retailer",
          "searchAddress": "Adresse suchen",
          "scopeHint": "Waehle eine Strasse oder suche nach einem Retailer, um die Objektliste zu laden.",
          "chooseCityFirst": "Zuerst eine Stadt waehlen",
          "noStreets": "Keine Strassen gefunden",
          "cityRequiredForStreet": "Waehle zuerst eine Stadt, um Strassen auszuwaehlen."
        },
        "columns": {
          "number": "Nr.",
          "country": "Land",
          "city": "Stadt",
          "address": "Adresse",
          "retailer": "Retailer",
          "status": "Status",
          "interests": "Interessen",
          "purchased": "Gekauft",
          "details": "Details",
          "analysis": "Analyse",
          "rental": "Vermietung"
        },
        "status": {
          "forRent": "Zu vermieten",
          "notForRent": "Nicht zu vermieten"
        },
        "rental": {
          "setForRent": "Zur Vermietung setzen",
          "stop": "Vermietung stoppen",
          "stopForRent": "Vermietung stoppen"
        },
        "pagination": {
          "rowsPerPage": "Zeilen pro Seite"
        },
        "interests": {
          "none": "Keine Interessen",
          "date": "Datum",
          "interestedParty": "Interessent",
          "type": "Typ",
          "branch": "Branche",
          "stores": "Standorte",
          "contactDetails": "Kontaktdaten",
          "protected": "Geschuetzt",
          "interest": "Interesse",
          "generalInterest": "Allgemeines Interesse",
          "forRentInterest": "Mietinteresse",
          "downloadContact": "Kontaktdaten herunterladen",
          "buyContact": "Kontaktdaten kaufen (EUR 9)"
        },
        "contactPurchase": {
          "title": "Kontaktdaten kaufen",
          "description": "Bestaetige den einmaligen Preis von EUR 9, um diese Kontaktdaten freizuschalten.",
          "invoiceNotice": "EUR 9 werden deiner naechsten monatlichen Kreditkartenrechnung hinzugefuegt.",
          "buy": "EUR 9 bestaetigen und freischalten"
        },
        "openDetails": "Details oeffnen",
        "loading": "Objekte werden geladen...",
        "noPropertiesFound": "Keine Objekte gefunden",
        "interest": {
          "changeFailed": "Interesse konnte nicht geaendert werden.",
          "viaColleague": "Ueber Kollegin/Kollegen",
          "withdraw": "Zurueckziehen"
        }
      },
      "analysis.title": "Analyse",
      "analysis.empty": "Fuege Objekte zur Analyse hinzu, um die Kennzahlen zu sehen.",
      "analysis.summary.totalRent": "Jahresmiete gesamt",
      "analysis.summary.totalAskingRent": "Gesamte Angebotsmiete",
      "analysis.summary.weightedArea": "Gewichtete m2",
      "analysis.summary.avgRentPerM2": "Durchschn. Miete/m2/Jahr",
      "analysis.summary.avgAskingRentPerM2": "Durchschn. Angebotsmiete/m2/Jahr",
      "analysis.metrics.waltYears": "WALT: {{value}} Jahre",
      "analysis.metrics.expiry12": "Ablauf 12M: {{value}}",
      "analysis.metrics.expiry24": "Ablauf 24M: {{value}}",
      "analysis.metrics.expiry36": "Ablauf 36M: {{value}}",
      "analysis.values.years": "{{value}} Jahre",
      "analysis.actions.clear": "Analyse leeren",
      "analysis.actions.collapseSurfaces": "Flaechen einklappen",
      "analysis.actions.expandSurfaces": "Flaechen ausklappen",
      "analysis.table.property": "Objekt",
      "analysis.table.tenant": "Mieter",
      "analysis.table.front": "Front",
      "analysis.table.annualRent": "Jahresmiete",
      "analysis.table.askingRent": "Angebotsmiete",
      "analysis.table.weightedM2": "Gewichtete m2",
      "analysis.table.rentPerM2": "Miete/m2",
      "analysis.table.askingRentPerM2": "Angebotsmiete/m2",
      "analysis.table.expiry": "Ablauf",
      "analysis.table.remainingTerm": "Restlaufzeit",
      "analysis.table.remainingMonths": "Restmonate",
      "analysis.table.rentCoverage": "Mietdeckung",
      "analysis.table.interestCoverage": "Zinsdeckung",
      "analysis.table.guaranteeMonths": "Garantiemonate",
      "analysis.table.surfaces": "Flaechen",
      "analysis.surfaces.title": "Flaechen",
      "analysis.surfaces.helper": "Standard: Retail 100%, Nebenflaeche 50%. Passe dies hier je Etage an.",
      "analysis.surfaces.weightedTotal": "Gewichtete Summe",
      "analysis.surfaces.grossM2": "{{value}} m2 brutto",
      "analysis.surfaces.weightedM2Value": "= {{value}} m2",
      "analysis.surfaces.empty": "Keine Flaechen gefunden. Fuelle Retail- und Nebenflaechen unter oeffentlichen Daten aus.",
      "analysis.surfaceFields.front": "Front",
      "analysis.surfaceFields.winkel": "Laden",
      "analysis.surfaceFields.secundair": "Nebenflaeche",
      "analysis.surfaceFields.begane_grond_winkel": "Erdgeschoss Laden",
      "analysis.surfaceFields.begane_grond_secundair": "Erdgeschoss Nebenflaeche",
      "analysis.surfaceFields.kelder_winkel": "Keller Laden",
      "analysis.surfaceFields.kelder_secundair": "Keller Nebenflaeche",
      "propertyList.rental.stopForRent": "Vermietung stoppen",
      "analysis.summary.wault": "WAULT",
      "analysis.actions.remove": "Entfernen",
      "analysis.chips.wault": "WAULT: {{value}} Jahre",
      "analysis.chips.expiry12": "Ablauf 12M: {{value}}",
      "analysis.chips.expiry24": "Ablauf 24M: {{value}}",
      "analysis.chips.expiry36": "Ablauf 36M: {{value}}",
      "analysis.table.weightedArea": "Gewichtete m2",
      "analysis.table.ltv": "LTV",
      "analysis.surfaces.button": "Flaechen",
      "analysis.surfaceFields.shop": "Laden",
      "analysis.surfaceFields.secondary": "Nebenflaeche",
      "analysis.surfaceFields.beganeGrondSecundair": "EG Nebenflaeche",
      "analysis.surfaceFields.kelderSecundair": "Keller Nebenflaeche",
      "analysis.surfaceFields.eersteVerdiepingSecundair": "1. OG Nebenflaeche",
      "analysis.surfaceFields.tweedeVerdiepingSecundair": "2. OG Nebenflaeche",
      "analysis.surfaceFields.derdeVerdiepingSecundair": "3. OG Nebenflaeche",
      "analysis.surfaceFields.entresolSecundair": "Zwischengeschoss Nebenflaeche",
      "analysis.surfaceFields.soussolSecundair": "Souterrain Nebenflaeche",
      "documents": {
        "title": "Dokumente",
        "add": "Dokument hinzufügen",
        "remove": "Dokument entfernen"
      },
      "brokerContact": {
        "retailerContacts": "Retailer-Kontakte",
        "ownerContacts": "Eigentümerkontakte",
        "add": "Kontakt hinzufügen",
        "remove": "Kontakt entfernen"
      },
      "dashboardOverlay.shared.support": "Support",
      "support": {
        "title": "Support",
        "intro": "Brauchen Sie Hilfe? Senden Sie Ihre Frage direkt an unser Supportteam.",
        "emailIntro": "Sie können uns auch direkt per E-Mail erreichen.",
        "category": "Thema",
        "categoryGeneral": "Allgemeine Frage",
        "categoryAccount": "Konto und Abonnement",
        "categoryBilling": "Abrechnung und Zahlungen",
        "categoryMap": "Karte und Daten",
        "categoryForRent": "Zu vermieten",
        "categoryBug": "Problem melden",
        "subject": "Betreff",
        "message": "Ihre Frage",
        "subjectPlaceholder": "Beschreiben Sie Ihre Frage kurz",
        "messagePlaceholder": "Wie können wir Ihnen helfen?",
        "send": "An Support senden",
        "sending": "Wird gesendet…",
        "successTitle": "Ihre Supportanfrage wurde gesendet",
        "success": "Wir haben Ihre Frage erhalten. Ihre Referenz ist {{ticketNumber}}. Sie erhalten auch eine Bestätigung per E-Mail.",
        "context": "Ihre Nachricht ist mit Ihrem {{role}}-Konto und der aktuell angezeigten Seite verknüpft.",
        "validation": "Bitte geben Sie sowohl einen Betreff als auch Ihre Frage ein.",
        "error": "Ihre Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut oder schreiben Sie an support@retailmaps.com."
      }
    }
  },
  "en": {
    "translation": {
      "popup2": {
        "trialPaywallTitle": "You have used your 10 free trial interests",
        "trialPaywallDescription": "To show interest in this property as well, you need a subscription. Your current 10 trial interests will be converted into paid interests.",
        "trialPaywallManage": "You can manage these interests later in your dashboard (edit or remove them).",
        "trialPaywallActivate": "Activate subscription",
        "userRoleInLog": "User role in Popup2:",
        "checkIfPropertyInList": "Check if property is in list:",
        "userHasProperties": "User has properties:",
        "errorFetchingUser": "Error fetching user:",
        "noUserEmail": "No userEmail available. Please check if you are logged in.",
        "loginRequired": "You are not logged in. Please log in again to add properties.",
        "publicStatusUpdated": "Public visibility successfully updated:",
        "publicStatusUpdateFailed": "Error saving public visibility status",
        "publicStatusUpdateError": "Error while making public:",
        "saveFailed": "Error saving changes.",
        "invalidJSON": "Invalid JSON, using fallback:",
        "saveSummary": "onSave() summary:",
        "inList": "This property is in your list",
        "confirmRemove": "Are you sure you want to remove this property from your list?",
        "removed": "Property removed from your list.",
        "removeError": "Error removing property:",
        "removeFailed": "Removal failed.",
        "removeFromList": "Remove from my properties",
        "addRequestLog": "Send request: add-property",
        "addResponseLog": "Server response:",
        "added": "Property added to your list!",
        "addFailed": "Adding failed.",
        "addError": "Error adding property:",
        "addToList": "Add to my properties",
        "addToMyProperties": "Add to my properties",
        "addedState": "Added",
        "adding": "Adding...",
        "localStorageUpdated": "localStorage user updated with property:",
        "interestedRetailers": "Interested retailers",
        "retailersHaveInterest": "retailers have shown interest",
        "viewRequests": "View requests in dashboard ->",
        "publicData": "Public data",
        "privateData": "Private data",
        "publicDataHint": "Visible property information used across listings, brochures and map views.",
        "privateDataHint": "Internal information stays within your secured workspace and is only shown to authorised users.",
        "privateWorkspace": "Private workspace",
        "privateWorkspaceHint": "Use these tabs to manage owner-sensitive notes, finance, contacts, photos and documents with more confidence and clarity.",
        "cancel": "Cancel",
        "busy": "Working...",
        "confirm": "Confirm",
        "surface": "Surface",
        "retailSpace": "Retail",
        "secondarySpace": "Secondary",
        "address": "Address",
        "city": "City",
        "website": "Website",
        "front": "Frontage",
        "groundFloor": "Ground floor",
        "basement": "Basement",
        "firstFloor": "1st floor",
        "secondFloor": "2nd floor",
        "thirdFloor": "3rd floor",
        "entresol": "Entresol",
        "soussol": "Lower ground",
        "unit": "Unit",
        "m2": "m2",
        "ft2": "ft2",
        "manageRentalStatus": "Manage rental status",
        "forRent": "For rent",
        "confirmRent": "You are about to list this property for rent.\n- The cost is EUR 19 per month\n- The status will be visible to other parties\n\nClick OK to proceed.",
        "confirmStopRent": "You are about to stop the rental status.\n- This will also cancel your Stripe subscription for this property.\n\nAre you sure you want to continue?",
        "rentCancelled": "The rental status has been cancelled and the subscription has been stopped.",
        "stripeStartError": "Something went wrong while starting Stripe.",
        "stripeError": "Stripe error: ",
        "cancelError": "Error cancelling subscription:",
        "cancelStripeError": "Stripe cancellation failed: ",
        "makePublic": "Make publicly visible",
        "mustRentFirst": "List the property for rent before making it public.",
        "saveChanges": "Save changes",
        "visibilityUpdateFailed": "Changing visibility failed.",
        "extraPropertyFailed": "Adding an extra property failed.",
        "stripeStartFailed": "Starting Stripe failed.",
        "stripeErrorPrefix": "Stripe error: ",
        "interestAddFailed": "Adding interest failed.",
        "ownerMustAddFirst": "Add this property to your portfolio first.",
        "retailerBrandClaimRequired": "A brand claim is required to manage rental visibility.",
        "roleNotSupported": "Your current role does not support this action.",
        "saveError": "Error saving changes.",
        "extraPropertyTitle": "Add extra property",
        "setForRent": "Set for rent",
        "rentStatusActive": "For rent (active)",
        "rentActionErrorPrefix": "Error changing rental status: ",
        "rentConfirmTitle": "List property for rent",
        "rentConfirmDescription": "Listing this property for rent normally costs EUR 15 per month, but is currently free during the launch period.",
        "rentLaunchFree": "Now free",
        "dontShowAgain": "Do not show again",
        "interestConfirmBody": "This interest will be saved on this property and added to your overview. As long as you are within your trial limit or active access, no extra costs will be charged. If payment is required, we will ask separately before any costs are incurred.",
        "skipConfirmation": "Skip this confirmation next time"
      },
      "authLanding": {
        "tabs": {
          "login": "Login",
          "register": "Register"
        },
        "roles": {
          "retailer": "Retailer",
          "owner": "Owner",
          "broker": "Broker"
        },
        "headlines": {
          "login": {
            "eyebrow": "Retail real estate intelligence",
            "subtitle": "Log in and work from a live map layer on portfolio, leasing and interest."
          },
          "register": {
            "eyebrow": "One platform for brokers, owners and retailers",
            "subtitle": "Start with an account and build your portfolio, listings and market intelligence from the map."
          },
          "forgot": {
            "eyebrow": "Restore access",
            "subtitle": "Request a reset link and quickly set a new password for your account."
          }
        },
        "forgot": {
          "helper": "Enter your email address below. If the account exists, we will send a reset link right away."
        },
        "roleSlides": {
          "broker": {
            "label": "Broker",
            "eyebrow": "For brokers",
            "subtitle": "Bring listings to market, track interest and unlock contact details directly from the same map workspace.",
            "featureCards": {
              "0": "Publish available locations faster.",
              "1": "Work with live interest, documents and project information.",
              "2": "Keep listings, leads and analysis in one place."
            },
            "workflowSteps": {
              "0": "From property to listing",
              "1": "Interest and contact details",
              "2": "Analysis per location"
            },
            "footer": {
              "0": "Listings",
              "1": "Lead intelligence",
              "2": "Broker intelligence"
            }
          },
          "owner": {
            "label": "Owner",
            "eyebrow": "For owners",
            "subtitle": "Manage portfolio, lease data, documents and alerts from a map that fits real estate workflows.",
            "featureCards": {
              "0": "Store lease, ownership and financial data centrally.",
              "1": "List properties for rent and follow status on the map.",
              "2": "Use alerts and analysis without separate spreadsheets."
            },
            "workflowSteps": {
              "0": "Portfolio control",
              "1": "Lease data and alerts",
              "2": "Asset analysis"
            },
            "footer": {
              "0": "Portfolio management",
              "1": "Lease information",
              "2": "Owner analytics"
            }
          },
          "retailer": {
            "label": "Retailer",
            "eyebrow": "For retailers",
            "subtitle": "Discover streets, manage stores, show interest and analyse locations before taking the next step.",
            "featureCards": {
              "0": "See relevant retail streets and available properties.",
              "1": "Add stores to your own portfolio.",
              "2": "Show interest and compare locations in analysis."
            },
            "workflowSteps": {
              "0": "Manage stores",
              "1": "Show interest",
              "2": "Compare locations"
            },
            "footer": {
              "0": "My stores",
              "1": "Interest",
              "2": "Retail analysis"
            }
          }
        },
        "platformSubtitle": "For and by retail professionals",
        "heroSubtitle": "The live retail map for retail areas worldwide, leasing, showing interest, leads and location analysis. Everything in one platform for EUR 19 per month.",
        "trialIntro": "Start your free 60 day trial here",
        "trialCta": "Register free",
        "marketTagline": "Prime retail streets · live market context",
        "featureCards": {
          "0": "Work from a live map layer with retail context.",
          "1": "Manage portfolio, leasing and interest in one place.",
          "2": "Connect broker, owner and retailer in one workflow."
        },
        "workflowSteps": {
          "0": "Portfolio and listing control",
          "1": "Live market signals on the map",
          "2": "One workflow for every role"
        },
        "footer": {
          "0": "Portfolio management",
          "1": "For-rent listings",
          "2": "Retail intelligence"
        },
        "modeLabel": {
          "login": "Welcome back",
          "register": "New account",
          "forgot": "Forgot password"
        },
        "panelTitle": {
          "login": "Log in to Retailmaps",
          "register": "Start with Retailmaps",
          "forgot": "Reset your password"
        },
        "fields": {
          "email": "Email address",
          "password": "Password",
          "firstName": "First name",
          "lastName": "Last name",
          "role": "Role",
          "phone": "Phone",
          "companyName": "Company name",
          "website": "Website"
        },
        "actions": {
          "forgotPassword": "Forgot password?",
          "login": "Login",
          "register": "Register",
          "startTrial": "Start free trial",
          "sendReset": "Send reset link",
          "backToLogin": "Back to login",
          "openLocalReset": "Open local reset link"
        },
        "legal": {
          "acceptPrefix": "I agree to the",
          "privacy": "privacy statement",
          "and": "and the",
          "terms": "terms and conditions"
        },
        "errors": {
          "loginFailed": "Login failed. Please check your details.",
          "registerFailed": "Registration failed. Please try again.",
          "companyRequired": "Company name is required.",
          "forgotNotice": "If this email address is known, we have sent a reset link.",
          "forgotFailed": "We could not send the reset link right now."
        }
      },
      "successStripe": {
        "title": "Stripe success",
        "waitTitle": "Payment received",
        "waitDescription": "We are finishing the activation now. This can take a few seconds. Keep this screen open; you will be redirected automatically when everything is ready.",
        "stepPayment": "Payment confirmed",
        "stepActivation": "Account or listing is being activated",
        "stepRedirect": "You will return to Retailmaps automatically",
        "back": "Back",
        "processing": "Processing...",
        "missingToken": "No valid token found. Please log in again.",
        "missingParams": "Missing parameters in the URL.",
        "unknownError": "Unknown error",
        "missingSessionId": "session_id is missing.",
        "missingRetailerId": "retailerId is missing.",
        "paymentReceivedActivating": "Payment received! The subscription is being activated...",
        "retailerListingActive": "The store is now for rent and publicly visible.",
        "ownerListingActive": "The property is now for rent.",
        "subscriptionActivating": "Subscription is being activated...",
        "subscriptionNotConfirmed": "The subscription could not be confirmed.",
        "subscriptionActive": "Subscription active.",
        "extraPropertyAdded": "Extra property added successfully.",
        "contactAccessUnlocked": "Payment received. We are preparing the contact details and returning you to the right property.",
        "interestProcessed": "Interest processed successfully.",
        "retailerSubscriptionActivating": "Retailer subscription is being activated...",
        "retailerSubscriptionActive": "Retailer subscription active.",
        "brokerSubscriptionActivating": "Payment received! The broker subscription is being activated...",
        "invalidType": "Unknown or invalid type.",
        "genericFailure": "Something went wrong: {{message}}"
      },
      "common": {
        "loading": "Loading...",
        "save": "Save",
        "cancel": "Cancel",
        "edit": "Edit",
        "delete": "Delete",
        "close": "Close",
        "yes": "Yes",
        "no": "No",
        "localeCode": "en-GB",
        "open": "Open",
        "active": "Active",
        "inactive": "Inactive",
        "busy": "Busy...",
        "backToDashboard": "Back to dashboard",
        "download": "Download",
        "saved": "Saved",
        "saving": "Saving...",
        "saveFailed": "Save failed",
        "ready": "Ready",
        "canceled": "Canceled",
        "confirm": "Confirm"
      },
      "roles": {
        "owner": "Owner",
        "retailer": "Retailer",
        "broker": "Broker"
      },
      "listings": {
        "common": {
          "country": "Country",
          "city": "City",
          "address": "Address",
          "askingPrice": "Asking price",
          "currentRent": "Current rent",
          "keyMoney": "Key money",
          "expiryDate": "Expiry date",
          "availableFrom": "Available from",
          "projectInformation": "Project information",
          "onBehalfOf": "On behalf of",
          "visibility": "Visibility",
          "actions": "Actions",
          "upload": "Upload",
          "uploadDocument": "Upload document",
          "chooseFile": "Choose file",
          "noFileChosen": "No file selected",
          "projectDocuments": "Project documents",
          "empty": "There are currently no locations for rent.",
          "selectFileFirst": "Select a file first.",
          "uploadFailed": "Upload failed.",
          "confirmDeleteDocument": "Are you sure you want to delete \"{{name}}\"?",
          "documentDeleteFailed": "Deleting the document failed.",
          "brochureFailed": "Generating or uploading the brochure failed.",
          "stopForRent": "Stop",
          "forRent": "For rent",
          "documentTypes": {
            "document": "Document",
            "floorplan": "Floor plan",
            "brochure": "Brochure",
            "photo": "Photo"
          },
          "visibilityOptions": {
            "public": "Everyone",
            "retailers": "All retailers",
            "interested": "Interested only"
          },
          "interestAndDocuments": "Show interest and receive documents",
          "deleteDocumentAria": "Delete {{name}}",
          "selectDocumentFirst": "Select at least one document first.",
          "documentsSavedToProject": "The selected documents have been added to my project information.",
          "documentsSaveFailed": "Saving project information failed.",
          "projectDocumentsHelp": "Open documents via the link or select them to add them to my project information.",
          "addedOn": "Added {{date}}",
          "saveToProjectInformation": "Add to my project information",
          "forRentSince": "For rent since",
          "onRequest": "On request",
          "broker": "Broker",
          "edit": "Edit",
          "save": "Save",
          "cancel": "Cancel",
          "noDocuments": "No documents",
          "fileCountOne": "{{count}} file",
          "fileCountOther": "{{count}} files",
          "available": "Available",
          "surface": "Surface",
          "total": "Total",
          "contactBroker": "Contact leasing broker",
          "thirdPartyNotice": "Information from third parties. Check details with the provider.",
          "goToInformation": "Go to information",
          "viewDocuments": "View documents",
          "unlockForPrice": "Unlock for free",
          "unlockDocuments": "Unlock documents",
          "oneTimeAccessPrice": "Document access is currently free."
        },
        "roles": {
          "external": "External offer",
          "owner": "Owner",
          "tenant": "Retailer",
          "brokerOnBehalfOwner": "Broker (on behalf of owner)",
          "provider": "Provider"
        }
      },
      "ownerListings": {
        "currentOffer": "My rental listings"
      },
      "accountSettings": {
        "title": "Settings",
        "tabs": {
          "profile": "Profile",
          "company": "Company",
          "preferences": "Preferences",
          "billing": "Billing",
          "security": "Security"
        },
        "descriptions": {
          "profile": "Contact details and role information for your account.",
          "company": "Company details, brand and billing.",
          "preferences": "Language, currency, units and map display.",
          "billing": "Subscription, usage and one-off purchases.",
          "security": "Login and account security."
        },
        "personal": {
          "title": "Personal profile",
          "description": "Contact details and role information for your account. Changes are saved automatically.",
          "firstName": "First name",
          "lastName": "Last name",
          "role": "Job title",
          "phone": "Phone number",
          "email": "Email address",
          "linkedin": "LinkedIn",
          "address": "Address"
        },
        "company": {
          "brandLogoTitle": "Brand and logo",
          "brandLogoDescription": "We use this logo on property cards and other visible brand spaces.",
          "title": "Company profile",
          "description": "Company details, brand information and billing for broker and owner accounts. Changes are saved automatically.",
          "readOnlyNotice": "Company group and domain drive connections, visibility and AI profiles, and therefore remain read-only.",
          "companyName": "Company name",
          "companyGroup": "Company group",
          "domain": "Domain",
          "legalName": "Legal name",
          "website": "Website",
          "roleType": "Role type",
          "headquartersTitle": "Headquarters",
          "headquartersAddress": "Headquarters address",
          "postalCode": "Postal code",
          "city": "City",
          "country": "Country",
          "billingTitle": "Billing",
          "billingDescription": "We use these details for subscriptions, invoices and financial administration.",
          "billingEmail": "Billing email",
          "invoiceReference": "Invoice reference / PO",
          "chamberOfCommerce": "Chamber of Commerce number",
          "vatNumber": "VAT number",
          "billingAddress": "Billing address",
          "taxIdType": "Tax ID type",
          "taxIdValue": "VAT / Tax ID number",
          "taxIdPlaceholder": "NL123456789B01",
          "peopleTitle": "People",
          "peopleDescription": "Accounts linked to the same organization. Statuses are based on subscription and trial period.",
          "peopleName": "Name",
          "peopleEmail": "Email",
          "peopleRole": "Role",
          "peopleStatus": "Status",
          "peopleTrialUntil": "Trial until",
          "peopleYou": "You",
          "peopleEmpty": "No other accounts have been found in this organization yet.",
          "statusActive": "Active",
          "statusTrial": "Trial",
          "statusInactive": "Inactive",
          "taxTypes": {
            "euVat": "European VAT number",
            "gbVat": "United Kingdom VAT number",
            "auAbn": "Australian Business Number (AU ABN)",
            "auArn": "Australian Taxation Office Reference Number",
            "brCnpj": "Brazilian CNPJ number",
            "brCpf": "Brazilian CPF number",
            "caBn": "Canadian BN",
            "caGstHst": "Canadian GST/HST number",
            "chVat": "Swiss VAT number",
            "clTin": "Chilean TIN",
            "egTin": "Egyptian Tax Identification Number",
            "inGst": "Indian GST number",
            "jpCn": "Japanese Corporate Number",
            "jpRn": "Japanese Registered Foreign Businesses number",
            "mxRfc": "Mexican RFC number",
            "noVat": "Norwegian VAT number",
            "nzGst": "New Zealand GST number",
            "sgGst": "Singaporean GST number",
            "usEin": "United States EIN",
            "zaVat": "South African VAT number"
          }
        }
      },
      "billing": {
        "title": "Billing",
        "description": "Everything for {{account}} in one overview: subscriptions, one-off purchases and the open costs of {{period}}.",
        "yourAccount": "your account",
        "currentMonth": "this month",
        "currentPeriod": "Current period",
        "preparingPdf": "Preparing PDF...",
        "downloadPdf": "Download invoice (PDF)",
        "downloadError": "Downloading the invoice failed.",
        "loadError": "Billing data could not be loaded.",
        "amountDueThisMonth": "Amount due this month",
        "subscriptionStatus": "Subscription status",
        "subscriptionActive": "Active",
        "subscriptionInactive": "Inactive",
        "nextRenewal": "Next renewal",
        "stripeCustomer": "Stripe customer",
        "paidSince": "Paid since",
        "infoNotice": "User details now live in Profile and Company. We only show what is financially relevant here: recurring subscription costs, one-off purchases and the total for this month.",
        "summary": {
          "title": "Summary"
        },
        "recurring": {
          "title": "Subscriptions and usage",
          "description": "Recurring costs for your subscription, active for-rent locations and other monthly components."
        },
        "oneOff": {
          "title": "One-off purchases",
          "description": "One-off costs, such as document unlocks or other standalone billing events.",
          "none": "No one-off purchases in this period.",
          "noneTitle": "No one-off purchases in this period",
          "noneDescription": "As soon as a one-off purchase is completed, it will appear here automatically."
        },
        "totals": {
          "subscriptions": "Subscriptions",
          "oneOff": "One-off purchases",
          "totalDue": "Total due"
        },
        "history": {
          "title": "Billing history",
          "description": "Recent billing events and one-off transactions for this account.",
          "none": "No billing events have been found for this account yet.",
          "documentUnlock": "Document unlock"
        },
        "columns": {
          "description": "Description",
          "quantity": "Qty",
          "unitPrice": "Unit",
          "total": "Total",
          "date": "Date",
          "amount": "Amount",
          "status": "Status"
        },
        "invoice": {
          "overview": "Invoice overview {{period}}",
          "invoiceDate": "Invoice date",
          "period": "Period",
          "statusOpen": "Status: open",
          "billTo": "Bill to",
          "footer": "This overview was generated from the current Retailmaps billing data for this period."
        },
        "user": "User",
        "subscription": "Subscription",
        "trialUntil": "Trial period until",
        "trialEndedOn": "Trial ended on",
        "baseSubscription": "Base subscription",
        "perMonth": "per month",
        "totalMonthlyCosts": "Total monthly costs",
        "renewsOn": "Renews on {{date}}",
        "noticePeriod": "Notice period: 1 month. The subscription remains active unless you cancel it.",
        "includesProperties": "includes {{count}} properties",
        "extraProperties": "Extra properties",
        "totalProperties": "Total properties",
        "monthlyCosts": "Monthly costs",
        "cancelSubscription": "Cancel subscription",
        "cancellationScheduled": "Your subscription is scheduled to end on {{date}}. Your data remains safely archived and can be restored when you reactivate.",
        "cancelDialog": {
          "title": "Cancel subscription",
          "retention": "Your subscription will end after the current paid period. Nothing is deleted: your portfolio, documents, history and invoices remain safely archived for reactivation.",
          "endsOn": "Access remains active until {{date}}.",
          "ownerProperties": "My properties",
          "retailerStores": "My stores",
          "returnPortfolio": "Return them to the organisation portfolio (unassigned)",
          "transferColleague": "Transfer them to a colleague",
          "listings": "Active for-rent listings",
          "archiveListings": "Stop and archive them at the end date",
          "transferListings": "Transfer them to a colleague",
          "interests": "Active interests will be withdrawn at the end date. Their protected history remains archived in your account.",
          "contacts": "Previously purchased contact details and invoices remain registered as purchase history and are restored when this account is reactivated.",
          "recipient": "Receiving colleague",
          "confirm": "Schedule cancellation"
        }
      },
      "requests": {
        "title": "Requests",
        "overview": "Overview",
        "loading": "Loading...",
        "none": "No requests received for your properties.",
        "columns": {
          "number": "No.",
          "city": "City",
          "address": "Address",
          "tenant": "Tenant",
          "forRent": "For rent",
          "total": "Total",
          "purchased": "Purchased",
          "date": "Date",
          "interestedParty": "Interested party",
          "type": "Type",
          "actions": "Actions"
        },
        "profile": {
          "branch": "Branch",
          "shops": "Stores",
          "countries": "Countries",
          "revenue": "Revenue"
        },
        "interestTypes": {
          "forRent": "For-rent interest",
          "general": "General interest"
        },
        "download": "📥 Download contact details",
        "payToView": "💳 Buy contact details (€49)",
        "downloadLabel": "Download contact details",
        "payToViewLabel": "Buy contact details (€49)",
        "shielded": "Hidden",
        "removeError": "Removing the request failed.",
        "empty": "No requests",
        "removeFailed": "Removing the request failed.",
        "total": "Total",
        "purchased": "Purchased",
        "date": "Date",
        "interestedParty": "Interested party",
        "hidden": "Hidden",
        "downloadContact": "Download contact details",
        "buyContact": "Buy contact details (€49)",
        "interests": "Interests"
      },
      "stores": {
        "common": {
          "number": "No.",
          "storeName": "Store name",
          "status": "Status",
          "byWho": "By whom",
          "details": "Details",
          "retailManager": "Retail manager",
          "brokerOnBehalfOfOwner": "Broker (on behalf of owner)"
        },
        "status": {
          "forRent": "For rent",
          "rented": "Rented"
        },
        "actions": {
          "stopRent": "Stop rental",
          "setForRent": "Set for rent"
        },
        "sections": {
          "mine": "My stores",
          "organization": "Stores from my organisation"
        },
        "filters": {
          "allCountries": "All countries",
          "allCities": "All cities"
        },
        "messages": {
          "addedToPortfolio": "Store added to your portfolio.",
          "addFailed": "The store could not be added.",
          "removeFailed": "The store could not be removed.",
          "toggleRentFailed": "Changing rental status failed.",
          "subscriptionRequired": "An active subscription is required for this action.",
          "assignFailed": "Assigning failed."
        }
      },
      "admin": {
        "common": {
          "openModule": "Open module",
          "refreshing": "Refreshing...",
          "today": "Today",
          "week": "Week",
          "month": "Month",
          "year": "Year",
          "noData": "No data available yet.",
          "unknown": "unknown",
          "loading": "Loading...",
          "userLoadFailed": "User could not be loaded."
        },
        "dashboard": {
          "aiReview": "AI review"
        },
        "home": {
          "title": "Retailmaps Admin Ops",
          "subtitle": "Central control layer for mail, AI review, analytics and administration. This is where agents, teams and operational processes come together.",
          "heroStats": {
            "openReview": "Open review",
            "inbox7d": "Inbox 7d",
            "activeLanguages": "Active languages",
            "agentLanes": "Agent lanes"
          },
          "sections": {
            "alerts": "Operational alerts",
            "snapshot": "Operational snapshot"
          },
          "alerts": {
            "reviewBacklog": {
              "label": "Review backlog",
              "text": "{{count}} threads are waiting for review."
            },
            "draftsReady": {
              "label": "Drafts ready",
              "text": "{{count}} drafts are ready to review."
            },
            "escalations": {
              "label": "Escalations",
              "text": "{{count}} threads need manual follow-up."
            },
            "stable": {
              "label": "Stable",
              "text": "No urgent operational alerts right now."
            }
          },
          "snapshot": {
            "draftsReady": "{{count}} drafts ready",
            "laneDistribution": "Lane distribution",
            "languages": "Languages",
            "reviewActions": "Review actions",
            "approved": "Approved",
            "edited": "Edited",
            "escalated": "Escalated",
            "rejected": "Rejected"
          },
          "modules": {
            "emailOps": {
              "title": "Email Agent Ops",
              "description": "Triage, review, drafts, knowledge base and escalations for all incoming Retailmaps emails."
            },
            "aiQueue": {
              "title": "AI Queue",
              "description": "Brand validation and other AI-driven review flows that still need human control."
            },
            "statistics": {
              "title": "Statistics",
              "description": "Central overview of volumes, languages, response times, conversions and agent performance."
            },
            "administration": {
              "title": "Administration",
              "description": "Operational backoffice for billing, subscriptions, mailbox management and internal processes."
            }
          }
        },
        "emailDashboard": {
          "title": "Email Agent Ops",
          "subtitle": "Review incoming email, improve drafts and grow the knowledge base for the role agents.",
          "refreshMetrics": "Refresh metrics",
          "badges": {
            "aiActive": "AI active",
            "aiFallback": "AI fallback",
            "inboundActive": "Inbound active",
            "inboundMissing": "Inbound missing"
          },
          "metrics": {
            "openReview": "Open review",
            "draftsReady": "Drafts ready",
            "activeLanguages": "Active languages",
            "brokerLane": "Broker lane"
          },
          "helpers": {
            "openReview": "Threads waiting for review or approval.",
            "draftsReady": "Drafts currently ready to send.",
            "activeLanguages": "Languages currently seen in the inbox.",
            "brokerLane": "Threads currently routed to the broker agent."
          }
        },
        "brandQueue": {
          "title": "AI Queue",
          "pendingTitle": "Brands awaiting review",
          "verifiedTitle": "Verified brands",
          "reject": "Reject",
          "columns": {
            "name": "Name",
            "status": "Status",
            "createdAt": "Created",
            "actions": "Actions",
            "group": "Group",
            "domain": "Domain",
            "brands": "Brands"
          },
          "prompts": {
            "domain": "Domain for {{name}}? (e.g. levi.com)",
            "group": "Group / parent company for {{name}}? (e.g. Levi Strauss & Co.)",
            "reject": "Are you sure you want to reject '{{name}}'?"
          }
        },
        "mailPanel": {
          "title": "Agent review inbox",
          "subtitle": "Review, edit and respond to incoming email conversations from one central ops inbox.",
          "refreshInbox": "Refresh inbox",
          "mode": "Mode",
          "threads": "threads",
          "messages": "messages",
          "inbound": "inbound",
          "aiInactive": "AI is inactive, fallback drafts are being used.",
          "quickFilters": {
            "all": "All",
            "broker": "Broker inbox",
            "retailer": "Retailer inbox",
            "owner": "Owner inbox",
            "support": "Support inbox",
            "router": "Router inbox"
          },
          "filters": {
            "search": "Search",
            "lane": "Lane",
            "status": "Status",
            "agent": "Agent",
            "language": "Language",
            "review": "Review",
            "all": "All",
            "allLanes": "All lanes",
            "allStatuses": "All statuses",
            "allAgents": "All agents",
            "allLanguages": "All languages",
            "onlyNeedsReview": "Only needs review",
            "noReview": "No review filter",
            "clear": "Clear filters"
          },
          "inbox": "Inbox",
          "noSubject": "No subject",
          "unknownSender": "Unknown sender",
          "noThreads": "No threads match the current filters.",
          "threadDetail": "Thread detail",
          "loadingThread": "Loading thread...",
          "agentLabel": "Agent",
          "languageLabel": "Language",
          "statusLabel": "Status",
          "autoReplyEligible": "Auto-reply eligible",
          "reviewRequired": "Review required",
          "lastActivity": "Last activity",
          "escalation": "Escalation",
          "incomingMail": "Incoming mail",
          "incomingFrom": "Incoming from",
          "noPlainText": "No plain text body available.",
          "agentDraft": "Agent draft",
          "subject": "Subject",
          "reply": "Reply",
          "saveEditedAsKnowledge": "Save edited version as knowledge article",
          "sending": "Sending...",
          "sendReply": "Send reply",
          "approve": "Approve",
          "saveEdited": "Save edited",
          "escalate": "Escalate",
          "reject": "Reject",
          "feedbackProcessed": "Feedback processed successfully.",
          "feedbackFailed": "Processing feedback failed.",
          "replySentVia": "Reply sent to {{recipient}} via {{provider}}.",
          "replySendFailed": "Sending reply failed.",
          "manualEscalationNote": "Manual escalation requested by admin review.",
          "noDraft": "No draft is available yet for this thread.",
          "selectThread": "Select a thread to review its details and draft.",
          "knowledgeBase": "Knowledge base",
          "knowledgeTitle": "Title",
          "knowledgeContent": "Content",
          "knowledgeKeywords": "Keywords (comma separated)",
          "addKnowledgeArticle": "Add knowledge article",
          "knowledgeSaved": "Knowledge article saved.",
          "knowledgeSaveFailed": "Saving knowledge article failed.",
          "noKnowledgeArticles": "No knowledge articles available yet."
        },
        "statistics": {
          "title": "Statistics",
          "subtitle": "Live operations overview of volumes, review load, languages and feedback on agent answers.",
          "meta": {
            "generatedAt": "Generated at",
            "mailThreads": "Mail threads",
            "activeInboxCountries": "Active inbox countries"
          },
          "overview": {
            "users": "Users",
            "totalInterests": "Total interests",
            "totalProperties": "Total properties",
            "activeForRent": "Active for-rent stock",
            "activeListings": "Active listings",
            "activeSubscriptions": "Active subscriptions"
          },
          "roles": {
            "admins": "Admins",
            "brokers": "Brokers",
            "retailers": "Retailers",
            "owners": "Owners"
          },
          "conversion": {
            "interestsPerActiveProperty": "Interests per active property",
            "propertiesWithInterest": "Properties with interest",
            "propertiesWithInterestShare": "Share of properties with interest",
            "listingUnlockRate": "Listing unlock rate",
            "contactUnlocks": "Contact unlocks",
            "unlockRevenue": "Unlock revenue"
          },
          "manual": {
            "manualAddedToday": "Manually added today",
            "manualAddedMonth": "Manually added this month",
            "manualEditedToday": "Manually edited today",
            "manualEditedMonth": "Manually edited this month",
            "topCreators": "Top manual creators",
            "topEditors": "Top manual editors"
          },
          "sections": {
            "rolesAndGrowth": "Roles and growth",
            "accountsPerRole": "Accounts per role",
            "newUsers": "New users",
            "userCountries": "User countries",
            "userCountriesHelp": "Top countries based on user/company profile data.",
            "interestsByPeriod": "Interests by period",
            "manualInteraction": "Manual system interaction",
            "manualInteractionHelp": "User actions in which properties were manually added or edited.",
            "heatmapHotspots": "Interest hotspots",
            "heatmapHotspotsHelp": "Top city-country combinations based on recorded interests.",
            "interestsByCity": "Interests by city",
            "propertiesAdded": "Properties added",
            "topPropertyCountries": "Top countries in the property database",
            "activeForRentStock": "Active for-rent stock",
            "conversionSignals": "Conversion & commercial signals",
            "agentMailContext": "Agent mail context"
          }
        },
        "administration": {
          "title": "Administration",
          "subtitle": "Operational backoffice for mail health, environment status and internal ops readiness.",
          "sections": {
            "mailInfrastructure": "Mail infrastructure",
            "healthCheck": "Health check",
            "operationalStatus": "Operational status",
            "roadmap": "Next backoffice steps"
          },
          "fields": {
            "provider": "Provider",
            "from": "From",
            "frontendUrl": "Frontend URL",
            "internalInboxes": "Internal inboxes",
            "testRecipient": "Test recipient"
          },
          "health": {
            "mailProvider": "Mail provider",
            "mailProviderActive": "{{provider}} active",
            "notConfigured": "Not configured",
            "inboundAgent": "Inbound agent",
            "inboundActive": "Inbound receiving active",
            "inboundMissing": "Inbound receiving not configured",
            "aiClassification": "AI classification",
            "aiActive": "OpenAI active",
            "fallbackOnly": "Fallback only",
            "internalInboxes": "Internal inboxes",
            "internalRecipientsConfigured": "{{count}} internal recipients configured",
            "noInternalRecipients": "No internal recipients configured",
            "actionNeeded": "Action needed"
          },
          "status": {
            "threads": "Threads",
            "openReview": "Open review",
            "draftsReady": "Drafts ready",
            "escalations": "Escalations"
          },
          "roadmap": {
            "subscriptions": "Subscription and billing controls per role",
            "mailboxes": "Mailbox routing and alias management",
            "internalNotifications": "Internal notification preferences",
            "billing": "Billing exports and invoice overviews",
            "escalations": "Escalation rules and SLA monitoring",
            "agentPolicies": "Agent policies and role-specific automations",
            "footer": "This page is intentionally operational and will expand into the central Retailmaps backoffice."
          }
        }
      },
      "dashboardOverlay": {
        "shared": {
          "forRent": "For rent",
          "requests": "Requests",
          "alerts": "Alerts",
          "analysis": "Analysis",
          "assistant": "How it works",
          "settings": "Settings"
        },
        "owner": {
          "properties": "Properties",
          "forRent": "For rent"
        },
        "retailer": {
          "stores": "Stores",
          "interests": "Interests"
        },
        "broker": {
          "properties": "Properties"
        },
        "admin": {
          "ops": "Ops",
          "mail": "Mail",
          "aiQueue": "AI Queue",
          "statistics": "Statistics",
          "administration": "Administration"
        }
      },
      "settingsPanel": {
        "common": {
          "saving": "Saving...",
          "saved": "Saved",
          "saveFailed": "Saving failed",
          "ready": "Ready"
        },
        "regional": {
          "title": "Regional preferences",
          "subtitle": "Choose how language, currency and units behave. Browser and region data are used automatically.",
          "language": "Language",
          "currency": "Currency",
          "units": "Units",
          "autoLanguage": "Automatic ({{language}})",
          "autoCurrency": "Automatic ({{currency}})",
          "autoUnits": "Automatic ({{units}})",
          "metric": "Metric",
          "imperial": "Imperial",
          "detectedRegion": "Detected region: {{region}}"
        },
        "mailTest": {
          "title": "Test email",
          "subtitle": "Check whether the mail settings work correctly.",
          "send": "Send test email",
          "sending": "Sending...",
          "status": "Status: {{status}}",
          "providerActive": "{{provider}} active",
          "devPreviewOnly": "Dev preview only",
          "from": "From: {{value}}",
          "testRecipient": "Test recipient: {{value}}",
          "internalInboxes": "Internal inboxes: {{value}}",
          "noneConfigured": "None configured",
          "notConfigured": "Not configured",
          "previewLogged": "{{provider}} is not fully configured yet. The test email was logged as a preview for {{recipient}}.",
          "sentMessage": "Test email sent to {{recipient}} via {{provider}}.",
          "failed": "Sending the test email failed.",
          "yourInbox": "your inbox"
        },
        "map": {
          "title": "Map preferences",
          "subtitle": "Adjust colours, outlines, labels and map visibility.",
          "invalidOrSaveFailed": "Invalid colour or saving failed.",
          "highlight": {
            "title": "Highlight intensity",
            "description": "Controls how strongly active polygons and selections stand out.",
            "retailTitle": "Retail property highlight intensity",
            "retailDescription": "Controls how strongly retail properties stand out on the map.",
            "otherTitle": "Other property intensity",
            "otherDescription": "Controls how visible other properties are as a background layer.",
            "opacity": "Intensity: {{value}}"
          },
          "markerFont": {
            "title": "Marker font size",
            "description": "Controls how large names and labels appear on the map.",
            "size": "Scale: {{value}}"
          },
          "preview": {
            "title": "Preview",
            "description": "A quick indication of how your map settings will look."
          },
          "colors": {
            "retail": {
              "label": "Retail colour",
              "description": "Base colour for retail properties on the map."
            },
            "other": {
              "label": "Other properties",
              "description": "Base colour for other properties on the map."
            },
            "retailOutline": {
              "label": "Active property outline",
              "description": "Border colour for active properties and highlights."
            },
            "otherOutline": {
              "label": "Other property outline",
              "description": "Border colour for inactive properties."
            },
            "markerName": {
              "label": "Marker name colour",
              "description": "Text colour for labels on the map."
            },
            "markerHover": {
              "label": "Hover colour",
              "description": "Background colour when moving over labels."
            },
            "forRentMarker": {
              "label": "For-rent marker",
              "description": "Text colour for markers on properties listed for rent."
            }
          }
        },
        "branding": {
          "title": "Broker branding",
          "subtitle": "Upload your logo. It will be shown with your listings."
        },
        "dashboardOverlay": {
          "shared": {
            "assistant": "How it works"
          }
        },
        "retailerMap": {
          "loading": {
            "zoomInToLoad": "Zoom in to {{zoom}} to load retailers",
            "fillingStreet": "Loading new properties. This can take up to 2 min...",
            "paintingFromCenter": "Loading properties from the centre..."
          }
        }
      },
      "propertyDetails.back": "Back to overview",
      "propertyDetails.address": "Address",
      "propertyDetails.publicDataDivider": "Public data",
      "propertyDetails.privateDataDivider": "Private data",
      "propertyDetails.documentsDivider": "Documents",
      "propertyDetails.photosDivider": "Photos",
      "propertyDetails.floorplansDivider": "Floor plans",
      "propertyDetails.addFloorplan": "Add floor plan",
      "propertyDetails.removeFloorplan": "Remove floor plan",
      "propertyDetails.floorplansInfo": "Upload floor plans as JPG or PNG. These drawings are used in brochure layouts. PDF files can be stored under Documents.",
      "propertyDetails.commentsDivider": "Notes",
      "propertyDetails.contactsDivider": "Contacts",
      "propertyDetails.website": "Website",
      "propertyDetails.front": "Front",
      "propertyDetails.formalTenant": "Formal tenant",
      "propertyDetails.huurprijs": "Rent",
      "propertyDetails.startDate": "Start date",
      "propertyDetails.endDate": "Expiry date",
      "propertyDetails.remainingLeaseTermMonths": "Remaining lease term (months)",
      "propertyDetails.leaseTerm": "Lease term (years)",
      "propertyDetails.extensionYears": "Extension years",
      "propertyDetails.rentFreePeriodMonths": "Rent-free period (months)",
      "propertyDetails.indexDate": "Indexation date",
      "propertyDetails.cancelDate": "Notice date",
      "propertyDetails.cancelNotice": "Notice period",
      "propertyDetails.guaranteeAmount": "Guarantee amount",
      "propertyDetails.rentalData": "Rental details",
      "propertyDetails.financialData": "Financial details",
      "propertyDetails.ownerData": "Owner details",
      "propertyDetails.groundFloor": "Ground floor",
      "propertyDetails.basement": "Basement",
      "propertyDetails.firstFloor": "1st floor",
      "propertyDetails.secondFloor": "2nd floor",
      "propertyDetails.thirdFloor": "3rd floor",
      "propertyDetails.entresol": "Entresol",
      "propertyDetails.floorAreaTitle": "Floor area by level (GFA)",
      "propertyDetails.retailSurface": "GLA",
      "propertyDetails.secondarySurface": "Secondary surface",
      "propertyDetails.retailSpace": "Retail",
      "propertyDetails.secondarySpace": "Secondary",
      "propertyDetails.sessionExpired": "Session expired, please log in again.",
      "propertyDetails.removeField": "Remove field",
      "propertyDetails.removeFieldHint": "Remove custom extra fields by double-clicking the field and then choosing Remove field.",
      "propertyDetails.autosave.saving": "Saving...",
      "propertyDetails.autosave.saved": "Saved",
      "propertyDetails.autosave.error": "Saving failed",
      "propertyDetails.autosave.active": "Autosave active",
      "propertyDetails.popupSettings.open": "Open settings",
      "propertyDetails.popupSettings.hide": "Hide settings",
      "propertyDetails.popupSettings.title": "Popup settings",
      "propertyDetails.popupSettings.description": "Choose which fields are visible in the map popup. This applies to standard fields and your own extra fields.",
      "propertyDetails.popupSettings.extraFields": "extra fields",
      "propertyDetails.popupSettings.noExtraFields": "No extra fields in this section yet.",
      "propertyDetails.popupSettings.showInPopup": "Show in popup",
      "propertyDetails.popupSettings.hideInPopup": "Hide in popup",
      "owner.ownerFields.title": "Owner details",
      "owner.ownerFields.parentCompany": "Parent owner company",
      "owner.ownerFields.owner": "Owner",
      "owner.ownerFields.contactPerson": "Contact person",
      "owner.ownerFields.email": "Email address",
      "owner.ownerFields.phone": "Phone number",
      "owner.financieringBlock.title": "Financial details",
      "owner.financieringBlock.koopsom": "Purchase price",
      "owner.financieringBlock.aankoopdatum": "Purchase date",
      "owner.financieringBlock.hypotheek": "Mortgage amount",
      "owner.financieringBlock.rentepercentage": "Interest rate",
      "owner.financieringBlock.bank": "Bank",
      "owner.financieringBlock.looptijd": "Term (years)",
      "owner.financieringBlock.jaar": "year",
      "owner.huurgegevensBlock.title": "Rental details",
      "owner.huurgegevensBlock.formeleHuurder": "Formal tenant",
      "owner.huurgegevensBlock.huurprijs": "Rent",
      "owner.huurgegevensBlock.ingangsdatum": "Start date",
      "owner.huurgegevensBlock.expiratiedatum": "Expiry date",
      "owner.huurgegevensBlock.resterendeLooptijdMaanden": "Remaining lease term",
      "owner.huurgegevensBlock.huurtermijn": "Lease term",
      "owner.huurgegevensBlock.verlengingsjaren": "Extension years",
      "owner.huurgegevensBlock.huurvrijePeriodeMaanden": "Rent-free period",
      "owner.huurgegevensBlock.indexatiedatum": "Indexation date",
      "owner.huurgegevensBlock.opzegdatum": "Notice date",
      "owner.huurgegevensBlock.opzegtermijn": "Notice period",
      "owner.huurgegevensBlock.garantiesoort": "Guarantee type",
      "owner.huurgegevensBlock.kiesOptie": "Choose an option",
      "owner.huurgegevensBlock.waarborgsom": "Security deposit",
      "owner.huurgegevensBlock.bankgarantie": "Bank guarantee",
      "owner.huurgegevensBlock.concerngarantie": "Company guarantee",
      "owner.huurgegevensBlock.garantiebedrag": "Guarantee amount",
      "owner.huurgegevensBlock.noGuarantee": "No guarantee",
      "owner.contactgegevensBlock.title": "Contact details",
      "owner.contactgegevensBlock.company": "Company",
      "owner.contactgegevensBlock.name": "Name",
      "owner.contactgegevensBlock.phone": "Phone",
      "owner.contactgegevensBlock.email": "Email",
      "owner.contactgegevensBlock.function": "Role",
      "owner.contactgegevensBlock.remove": "Remove contact",
      "owner.contactgegevensBlock.add": "Add contact",
      "owner.opmerkingen.title": "Notes",
      "owner.opmerkingen.none": "No notes added yet.",
      "owner.opmerkingen.unknownAuthor": "Unknown author",
      "owner.opmerkingen.add": "Add note",
      "owner.opmerkingen.placeholder": "Type your note here...",
      "retailer.contactgegevensBlock.title": "Contact details",
      "retailer.contactgegevensBlock.company": "Company",
      "retailer.contactgegevensBlock.name": "Name",
      "retailer.contactgegevensBlock.phone": "Phone",
      "retailer.contactgegevensBlock.email": "Email",
      "retailer.contactgegevensBlock.function": "Role",
      "retailer.contactgegevensBlock.add": "Add contact",
      "retailer.contactgegevensBlock.remove": "Remove contact",
      "brokerContact.retailerContacts": "Retailer contacts",
      "brokerContact.ownerContacts": "Owner contacts",
      "brokerContact.company": "Company",
      "brokerContact.name": "Name",
      "brokerContact.phone": "Phone",
      "brokerContact.email": "Email",
      "brokerContact.position": "Role",
      "brokerContact.add": "Add contact",
      "brokerContact.remove": "Remove contact",
      "photos.title": "Photos",
      "photos.add": "Add photo",
      "photos.remove": "Remove photo",
      "photos.error.tooLarge": "is larger than 10 MB and was skipped.",
      "documents.title": "Documents",
      "documents.add": "Add document",
      "documents.remove": "Remove document",
      "documents.error.tooLarge": "is larger than 10 MB and was skipped.",
      "retailerMap.loading.zoomInToLoad": "Zoom in to {{zoom}} to load retailers",
      "retailerMap.loading.fillingStreet": "Loading new properties. This can take up to 2 min...",
      "retailerMap.loading.paintingFromCenter": "Loading properties from the centre...",
      "retailerMap.errors.invalidSession": "No valid session found. Please log in again.",
      "retailerMap.errors.noUserInfo": "No user information available.",
      "retailerMap.errors.unknownRoleSubscription": "Unknown user role. Subscription could not be started.",
      "retailerMap.dashboard": "Dashboard",
      "retailerMap.addressPlaceholder": "Type an address...",
      "retailerMap.flyButton": "Fly",
      "dashboardOverlay.owner.properties": "Properties",
      "dashboardOverlay.owner.forRent": "For rent",
      "dashboardOverlay.shared.requests": "Requests",
      "dashboardOverlay.shared.alerts": "Alerts",
      "dashboardOverlay.shared.analysis": "Analysis",
      "dashboardOverlay.shared.assistant": "How it works",
      "dashboardOverlay.shared.settings": "Settings",
      "myProperties.nr": "No.",
      "myProperties.city": "City",
      "myProperties.address": "Address",
      "myProperties.tenant": "Tenant",
      "myProperties.link": "Details",
      "myProperties.status": "Status",
      "myProperties.actions": "Actions",
      "myProperties.assetManager": "Asset manager",
      "myProperties.noAssetManager": "- none -",
      "myProperties.noResults": "No results",
      "myProperties.ownProperties": "My properties",
      "myProperties.groupProperties": "Organisation portfolio",
      "myProperties.stopRent": "Stop rental",
      "myProperties.setForRent": "Set for rent",
      "myProperties.street": "Street",
      "myProperties.allCities": "All cities",
      "myProperties.allStreets": "All streets",
      "myProperties.status.forRent": "For rent",
      "myProperties.status.rented": "Rented",
      "myProperties.bulk.assignToSelection": "Assign to selection",
      "myProperties.bulk.onlyUnassigned": "Only without asset manager",
      "myProperties.bulk.selectAllVisible": "Select all visible",
      "myProperties.bulk.noManagerSelected": "Choose an asset manager.",
      "myProperties.bulk.noSelection": "No properties selected.",
      "myProperties.loading": "Loading...",
      "myProperties.assignToMe": "Assign to me",
      "myProperties.view": "View",
      "myProperties.assignError": "Assigning failed.",
      "myProperties.claimSuccess": "Property added to your portfolio.",
      "myProperties.claimError": "Adding the property failed.",
      "myProperties.rentToggleError": "Changing the rental status failed.",
      "myProperties.subscription.required": "An active subscription is required for this action.",
      "myProperties.subscription.badge": "Owner subscription",
      "myProperties.subscription.title": "Ready for your next property",
      "myProperties.subscription.description": "Your trial includes 3 properties. To claim the next property through the organisation, activate the owner subscription and continue right away.",
      "myProperties.subscription.activate": "Activate owner subscription",
      "myProperties.subscription.sessionError": "Could not start the Stripe session.",
      "myProperties.subscription.stripeMissing": "Stripe.js is not loaded.",
      "myProperties.subscription.startError": "Could not start the subscription.",
      "requests.branches.fashionAndApparel": "Fashion and apparel",
      "requests.branches.footwear": "Footwear",
      "requests.branches.foodAndBeverage": "Food and beverage",
      "requests.branches.beautyAndPersonalCare": "Beauty and personal care",
      "requests.branches.jewelleryAndWatches": "Jewellery and watches",
      "requests.branches.supermarketAndGrocery": "Supermarket and grocery",
      "requests.branches.electronics": "Electronics",
      "requests.branches.homeAndLiving": "Home and living",
      "requests.branches.sportsAndOutdoor": "Sports and outdoor",
      "requests.branches.booksAndMedia": "Books and media",
      "common.cancel": "Cancel",
      "countries.nl": "Netherlands",
      "countries.be": "Belgium",
      "countries.de": "Germany",
      "countries.fr": "France",
      "countries.gb": "United Kingdom",
      "countries.es": "Spain",
      "countries.it": "Italy",
      "common.back": "Back",
      "common.save": "Save",
      "common.busy": "Busy...",
      "propertyDrawer.title": "Property details",
      "propertyDrawer.loadFailed": "Could not load property details.",
      "propertyDrawer.openInNewTab": "Open in new tab",
      "propertyDrawer.address": "Address",
      "propertyDrawer.status": "Status",
      "propertyDrawer.forRent": "For rent",
      "propertyDrawer.rented": "Rented",
      "propertyDrawer.assetManager": "Asset manager",
      "propertyDrawer.openInMaps": "Open in Maps",
      "interestButton.invalidSession": "No valid session.",
      "interestButton.withdraw": "Withdraw",
      "interestButton.showInterest": "Show interest",
      "retailerMap.printTooltip": "Choose how to export the map",
      "retailerMap.print": "Print",
      "retailerMap.openStreetView": "Open Street View",
      "retailerMap.closeStreetView": "Close Street View",
      "retailerMap.streetView": "Street View",
      "retailerMap.zoomIn": "Zoom in",
      "retailerMap.zoomOut": "Zoom out",
      "retailerMap.highlightEdit.dragHint": "Drag points, remove points or add a point.",
      "retailerMap.highlightEdit.selectHint": "Click a blue highlight to edit it.",
      "retailerMap.highlightEdit.adminHint": "Admin tool for incorrect building shapes.",
      "retailerMap.highlightEdit.disable": "Turn edit mode off",
      "retailerMap.highlightEdit.edit": "Edit highlight",
      "retailerMap.highlightEdit.merge": "Merge",
      "retailerMap.highlightEdit.reset": "Reset",
      "retailerMap.highlightEdit.mergeHint": "Select at least two blue highlights. Selected: {{count}}",
      "retailerMap.highlightEdit.mergeNow": "Merge now",
      "retailerMap.highlightEdit.buildingId": "Building ID",
      "retailerMap.highlightEdit.addPoint": "Add point",
      "retailerMap.highlightEdit.removePoint": "Remove point",
      "retailerMap.highlightEdit.makeOneShape": "Make one shape",
      "retailerMap.highlightEdit.removeCorrection": "Remove correction",
      "retailerMap.highlightEdit.restore": "Restore highlight",
      "propertyList.filters.city": "City",
      "propertyList.filters.street": "Street",
      "propertyList.filters.retailer": "Retailer",
      "propertyList.filters.select": "Select...",
      "propertyList.filters.typeStreet": "Type street...",
      "propertyList.filters.chooseCityFirst": "Choose a city first",
      "propertyList.filters.noStreets": "No streets found",
      "propertyList.filters.cityRequiredForStreet": "Choose a city before selecting streets.",
      "propertyList.filters.retailerExample": "E.g. Suit Supply",
      "propertyList.filters.retailerExampleShort": "Retailer",
      "propertyList.filters.searchAddress": "Search address",
      "propertyList.filters.scopeHint": "Choose a street or search by retailer to load the property list.",
      "propertyList.loading": "Loading properties...",
      "propertyList.noPropertiesFound": "No properties found",
      "propertyList.openDetails": "Open details",
      "propertyList.pagination.rowsPerPage": "Rows per page",
      "propertyList.columns.number": "No.",
      "propertyList.columns.country": "Country",
      "propertyList.columns.city": "City",
      "propertyList.columns.address": "Address",
      "propertyList.columns.retailer": "Retailer",
      "propertyList.columns.status": "Status",
      "propertyList.columns.showInterest": "Show interest",
      "propertyList.columns.details": "Details",
      "propertyList.columns.analysis": "Analysis",
      "propertyList.columns.interests": "Interests",
      "propertyList.columns.purchased": "Purchased",
      "propertyList.columns.rental": "Rental",
      "propertyList.status.forRent": "For rent",
      "propertyList.status.notForRent": "Not for rent",
      "propertyList.interests.none": "No interests",
      "propertyList.interests.date": "Date",
      "propertyList.interests.interestedParty": "Interested party",
      "propertyList.interests.type": "Type",
      "propertyList.interests.branch": "Sector",
      "propertyList.interests.stores": "Stores",
      "propertyList.interests.contactDetails": "Contact details",
      "propertyList.interests.protected": "Protected",
      "propertyList.interests.forRentInterest": "For-rent interest",
      "propertyList.interests.generalInterest": "General interest",
      "propertyList.interests.downloadContact": "Download contact details",
      "propertyList.interests.buyContact": "Buy contact details (EUR 9)",
      "propertyList.interests.interest": "Interest",
      "propertyList.contactPurchase.title": "Buy contact details",
      "propertyList.contactPurchase.description": "You are buying the contact details for this interest.",
      "propertyList.contactPurchase.invoiceNotice": "The costs are billed separately.",
      "propertyList.contactPurchase.buy": "Buy contact details",
      "retailerMap": {
        "loading": {
          "stores": "Loading stores...",
          "zoomInToLoad": "Zoom in to {{zoom}} to load retailers",
          "fillingStreet": "Loading new properties. This can take up to 2 min...",
          "paintingFromCenter": "Loading properties from the centre..."
        },
        "dashboard": "Dashboard"
      },
      "subscriptionRequired": {
        "title": "Subscription required",
        "body": "To list a property for rent on Retailmaps, you need an active subscription.",
        "details": "With a subscription, you can list properties for rent and make them visible to all platform users or selected groups.",
        "activate": "Activate subscription"
      },
      "security": {
        "password": "Password",
        "errors": {
          "statusFailed": "Could not load the security status.",
          "setupFailed": "Could not start 2FA setup.",
          "enableFailed": "Could not enable 2FA.",
          "disableFailed": "Could not disable 2FA."
        },
        "notices": {
          "enabled": "2FA has been enabled for your account.",
          "disabled": "2FA has been disabled for your account."
        },
        "twoFactor": {
          "title": "Two-factor authentication",
          "subtitle": "Protect your account with a 6-digit code from an authenticator app.",
          "setup": "Set up 2FA",
          "scanQr": "Scan the QR code with your authenticator app. If that does not work, use the setup code manually.",
          "openAuthenticator": "Open in authenticator app",
          "sixDigitCode": "6-digit code",
          "enable": "Enable 2FA",
          "disableWarning": "Only disable 2FA if you are sure this account is protected in another way.",
          "code": "2FA code",
          "disable": "Disable 2FA"
        }
      },
      "auth": {
        "twoFactor": {
          "prompt": "Enter the 6-digit code from your authenticator app.",
          "backToPassword": "Back to password"
        }
      },
      "mapSettings": {
        "activeOutlineLabel": "Active property outline",
        "otherOutlineLabel": "Other property outline",
        "markerNameColorLabel": "Marker name colour",
        "hoverColorLabel": "Hover colour",
        "backToDashboard": "Back to dashboard",
        "title": "Map settings",
        "subtitle": "Adjust building and marker-name colours",
        "fetchWarn": "Could not load settings",
        "noUser": "No user found.",
        "invalidHex": "Invalid hex colour. Use e.g. #0077cc.",
        "saved": "Settings saved.",
        "saveFailed": "Saving failed.",
        "retailColorLabel": "Retail building colour",
        "retailColorPicker": "Choose retail building colour",
        "otherColorLabel": "Other building colour",
        "otherColorPicker": "Choose other building colour",
        "opacityLabel": "Opacity other buildings: {{value}}",
        "opacityAria": "Opacity slider",
        "markerNameColorPicker": "Choose marker name colour",
        "markerNameHoverColorLabel": "Marker hover colour",
        "markerNameHoverColorPicker": "Choose marker hover colour",
        "previewRetail": "Retail highlight",
        "previewOther": "Other buildings",
        "previewMarkerNormal": "Marker normal",
        "previewMarkerHover": "Marker hover",
        "saving": "Saving...",
        "save": "Save settings",
        "reset": "Reset to default",
        "cancel": "Cancel",
        "hexHelp": "Use hex, e.g. #0077cc"
      },
      "retailerProfile": {
        "personalTitle": "Personal profile",
        "companyTitle": "Company profile",
        "autosaveHint": "Changes are saved automatically.",
        "companyProtectedHint": "Company group and company name are leading for AI profiles and internal links, so they remain protected.",
        "parentCompany": "Parent company",
        "company": "Company",
        "companyName": "Company name",
        "name": "Name",
        "legalName": "Legal name",
        "headquartersAddress": "Head office address",
        "headquartersPostalCode": "Head office postal code",
        "headquartersCity": "Head office city",
        "headquartersCountry": "Head office country",
        "industry": "Industry",
        "organization": "Organization",
        "foundingYear": "Founding year",
        "storeCount": "Number of stores",
        "activeCountries": "Active in countries",
        "employeeCount": "Number of employees",
        "revenueIndication": "Revenue indication",
        "billingHint": "Useful for subscriptions, invoices and internal administration.",
        "billingEmail": "Billing email",
        "invoiceReference": "Invoice reference / PO",
        "billingAddress": "Billing address",
        "chamberOfCommerceNumber": "Chamber of Commerce number",
        "vatNumber": "VAT number",
        "postalCode": "Postal code",
        "city": "City",
        "country": "Country"
      },
      "paidInterest": {
        "title": "Extra interest",
        "bodyPrefix": "This interest costs",
        "price": "€5 excluding VAT per month",
        "bodySuffix": "and will be added to your subscription. You can withdraw this interest later at any time.",
        "confirm": "Agree and continue",
        "paymentStartFailed": "Could not start payment."
      },
      "forRentTab": {
        "selectActingRole": "Select who you are listing on behalf of.",
        "created": "The property is now listed for rent.",
        "updated": "Listing updated.",
        "updateFailed": "Updating failed.",
        "confirmDelete": "Are you sure you want to remove this rental listing?",
        "deleteFailed": "Deleting failed.",
        "listProperty": "List property for rent",
        "missingData": "Missing data to list this property for rent.",
        "activateFailed": "Activating the rental listing failed.",
        "activating": "Activating rental listing..."
      },
      "verifyEmail": {
        "loadingMessage": "We are confirming your email address...",
        "invalidLink": "This verification link is invalid.",
        "successMessage": "Your email address has been confirmed. Log in to open Retailmaps.",
        "failedMessage": "Verification failed.",
        "expiredOrInvalid": "This verification link has expired or is invalid.",
        "successTitle": "Email address confirmed",
        "failedTitle": "Verification failed",
        "checkingTitle": "Checking",
        "backToLogin": "Back to login",
        "openLogin": "Log in and open Retailmaps"
      },
      "propertyDetails": {
        "floors": {
          "ground": "Ground floor",
          "basement": "Basement",
          "first": "1st floor",
          "second": "2nd floor",
          "third": "3rd floor",
          "entresol": "Mezzanine",
          "soussol": "Lower ground floor"
        },
        "frontWidth": "Front width",
        "rentalData": "Rental details",
        "financialData": "Financial details",
        "ownerData": "Owner details",
        "commentsDivider": "Notes",
        "contactsDivider": "Contacts",
        "photosDivider": "Photos",
        "floorplansDivider": "Floor plans",
        "documentsDivider": "Documents",
        "objectInfoDivider": "Object information",
        "floorplansInfo": "Upload floor plans as JPG or PNG. These drawings are used in brochure layouts. PDF files can be stored under Documents.",
        "addFloorplan": "Add floor plan",
        "removeFloorplan": "Remove floor plan",
        "addObjectInfo": "Add object information",
        "notesDivider": "Notes",
        "datePlaceholder": "dd-mm-yyyy",
        "addContact": "Add contact",
        "removeField": "Remove field",
        "removeFieldHint": "Remove custom extra fields by double-clicking the field and then choosing Remove field.",
        "popupSettings": {
          "open": "Open settings",
          "hide": "Hide settings",
          "title": "Popup settings",
          "description": "Choose which fields are visible in the map popup. This applies to standard fields and your own extra fields.",
          "extraFields": "extra fields",
          "noExtraFields": "No extra fields in this section yet.",
          "showInPopup": "Show in popup",
          "hideInPopup": "Hide in popup"
        },
        "askingRentPrice": "Asking rent",
        "serviceCosts": "Service costs",
        "takeoverPrice": "Key money",
        "availableFrom": "Available from",
        "back": "Back to overview",
        "projectInfoDivider": "Project information",
        "addProjectInfo": "Add project information"
      },
      "help": {
        "subtitle": "Short explanations for common actions in Retailmaps.",
        "howItWorks": "How it works",
        "goodToKnow": "Good to know",
        "empty": "There are no topics for this role yet.",
        "actions": {
          "openListings": "Open listings",
          "openInterests": "Open interests",
          "openProperties": "Open properties",
          "openAlerts": "Open Alerts",
          "openRequests": "Open requests",
          "openAnalysis": "Open analysis"
        },
        "topics": {
          "ownerForRent": {
            "title": "List a property for rent",
            "summary": "Publish a property as a rental offer and add the right information.",
            "step1": "Open the Properties tab.",
            "step2": "Find the property you want to offer.",
            "step3": "Click List for rent.",
            "step4": "Open For rent and complete the asking price, key money and available-from date.",
            "step5": "Check details that were already copied, such as current rent and expiry date.",
            "step6": "Add project information. You can upload a brochure or generate project information automatically.",
            "note1": "As an owner, you do not need to choose visibility. The property is automatically shown as a rental offer.",
            "note2": "Automatic project information uses the entered data, photos, floor plans and a map image."
          },
          "retailerStore": {
            "title": "Link a store to my stores",
            "summary": "Add an existing location to your store overview.",
            "step1": "Open the Stores tab.",
            "step2": "Find the store by country, city or address.",
            "step3": "Assign yourself or a colleague as retail manager.",
            "step4": "The store then appears in My stores.",
            "note1": "A store can only be listed for rent after it is linked to My stores.",
            "note2": "If the location is not on the map yet, add a new marker first."
          },
          "newMarker": {
            "title": "Add a new marker",
            "summary": "Add a new location to the map.",
            "step1": "Open the map.",
            "step2": "Desktop: double-click an empty place on the map.",
            "step3": "Mobile: double-tap an empty place on the map.",
            "step4": "Fill in the location details.",
            "note1": "First check whether the location is already on the map. If so, use the existing marker.",
            "note2": "If you place a new marker incorrectly, you can delete it yourself as long as you added it."
          },
          "moveDeleteMarker": {
            "title": "Move or delete a marker",
            "summary": "Correct a marker position or remove a marker you added yourself.",
            "step1": "Desktop: right-click the marker.",
            "step2": "Mobile: press and hold the marker.",
            "step3": "Choose Move marker and click or tap the new location.",
            "step4": "Choose Delete marker to remove a marker you added yourself.",
            "note1": "Existing markers and markers added by someone else can only be deleted by an admin.",
            "note2": "After moving a marker, open it again if you want to check or edit the data."
          },
          "mobile": {
            "title": "Use Retailmaps on mobile",
            "summary": "Add Retailmaps to your home screen for quick access.",
            "step1": "Open www.retailmaps.com on your phone.",
            "step2": "iPhone or iPad: use Safari, tap Share and choose Add to Home Screen.",
            "step3": "Android Chrome: tap the three dots and choose Install app or Add to Home screen.",
            "step4": "Samsung Internet: open the menu and choose Add page to or Add to Home screen.",
            "step5": "Name the shortcut Retailmaps and tap Add.",
            "step6": "Open Retailmaps from the icon on your home screen.",
            "note1": "On iPhone this normally works through Safari. Chrome on iPhone usually cannot do this directly.",
            "note2": "You sign in with the same account as on desktop."
          },
          "security": {
            "title": "Turn two-factor authentication on or off",
            "summary": "Protect your account with an extra code from an authenticator app.",
            "step1": "Open Settings.",
            "step2": "Go to Security or Two-factor authentication.",
            "step3": "Click Enable 2FA.",
            "step4": "Open an authenticator app, such as Google Authenticator, Microsoft Authenticator or 1Password.",
            "step5": "Scan the QR code with the authenticator app.",
            "step6": "Enter the 6-digit code from the app and confirm.",
            "step7": "From now on you sign in with your password plus the 6-digit code.",
            "step8": "To turn 2FA off, go back to Settings and click Disable 2FA.",
            "note1": "Keep access to your authenticator app. Without it, signing in can become difficult.",
            "note2": "The code changes about every 30 seconds. Always use the newest code."
          },
          "popupMedia": {
            "title": "Photos, documents and floor plans",
            "summary": "Add files to a location.",
            "step1": "Open the location popup.",
            "step2": "Go to Private data.",
            "step3": "Choose Photos, Documents or Floor plans.",
            "step4": "Add a file or take a photo directly on mobile.",
            "note1": "Photos are shown as thumbnails.",
            "note2": "Floor plans work best as images, for example jpg or png."
          },
          "alerts": {
            "title": "Set alerts",
            "summary": "Set a reminder for important dates.",
            "step1": "Open Property Details or the popup.",
            "step2": "Enter a date, such as expiry date, indexation date or termination date.",
            "step3": "Tick Alert.",
            "step4": "Enter how many days in advance you want to receive the alert.",
            "step5": "View active alerts in the Alerts tab.",
            "note1": "Active alerts are visible in the Alerts tab.",
            "note2": "On the reminder date you automatically receive an email."
          },
          "ownerRequests": {
            "title": "View requests",
            "summary": "See who is interested in your rental offer or property.",
            "step1": "Open the Requests tab.",
            "step2": "Check which property the request belongs to.",
            "step3": "Review which applicant details are available.",
            "step4": "Open the request for more details.",
            "note1": "Requests are created when retailers show interest in a retail location, even if it is not actively listed for rent."
          },
          "retailerRequests": {
            "title": "View requests",
            "summary": "See which retailers are interested in your locations.",
            "step1": "Open the Requests tab.",
            "step2": "See which retailer showed interest.",
            "step3": "Check which location the request belongs to.",
            "step4": "Click the address to open the location on the map.",
            "note1": "Requests are incoming interests in locations linked to your organisation."
          },
          "interest": {
            "title": "Show interest",
            "summary": "Make clear that you are interested in a specific location.",
            "step1": "Open the location on the map.",
            "step2": "Click Show interest in the popup.",
            "step3": "Confirm the action and complete any required access step.",
            "step4": "The location then appears in the Interests tab.",
            "step5": "The interest remains active until you withdraw it.",
            "note1": "Your interest is saved on the specific property, not only in your own overview.",
            "note2": "The current tenant, owner and relevant brokers can see the interest where they have access."
          },
          "analysis": {
            "title": "Use analysis",
            "summary": "Compare locations and view important calculations.",
            "step1": "Select a property or store in your overview.",
            "step2": "Choose the Analysis action.",
            "step3": "Add multiple locations if needed.",
            "step4": "Open Analysis to view rent per m2, WALT, remaining lease term and ratios."
          }
        },
        "title": "How it works"
      },
      "legal": {
        "disclaimer": "Concept document for Retailmaps. Complete the company details before publishing this definitively.",
        "lastUpdated": "Last updated: May 28, 2026",
        "privacy": {
          "title": "Privacy statement",
          "intro": "Retailmaps processes business account, company, property, listing, interest and usage data to provide the platform.",
          "roles": "Data can be visible to relevant users depending on their role, access rights, subscriptions and actions within the platform.",
          "providers": "Retailmaps may use external providers for hosting, maps, payments, email, analytics and AI functionality.",
          "rights": "Users can request access, correction or deletion of personal data where applicable.",
          "contact": "For privacy questions, contact Retailmaps through the published contact details."
        },
        "terms": {
          "title": "Terms and conditions",
          "intro": "Retailmaps is a professional platform for retail real estate information, listings, interests, requests and related collaboration.",
          "account": "Users are responsible for correct account details, secure login credentials and lawful use of the platform.",
          "data": "Users remain responsible for the accuracy and rights to information, photos, documents and contact details they upload or publish.",
          "uploadLicense": "By supplying floor plans, IMDF, GeoJSON, CAD, SVG or other location files, the user confirms that they are authorised to do so and grants Retailmaps a non-exclusive, royalty-free licence to store, host, copy, analyse, convert, georeference, adapt and combine those files, create derived floor plans and map layers, and display them within the Retailmaps service. Retailmaps may grant the strictly necessary rights to its technical service providers. The user must disclose any required attribution, third-party licence or other restriction when supplying the file.",
          "payments": "Paid features, subscriptions, bundles and transaction fees can apply where clearly shown in the dashboard or order flow.",
          "liability": "Retailmaps is an information and networking platform and does not guarantee that a property is available or that a transaction will be completed."
        }
      },
      "popup": {
        "autosaveActive": "Autosave active"
      },
      "alerts": {
        "daysBefore": "days before",
        "enterDaysBefore": "Enter days before",
        "title": "Alerts",
        "loading": "Loading alerts...",
        "empty": "There are currently no alerts requiring attention.",
        "toggleLabel": "Alert",
        "dismiss": "Dismiss",
        "columns": {
          "property": "Property",
          "field": "Field",
          "date": "Date",
          "alertDate": "Alert date",
          "daysBefore": "Days before",
          "status": "Status",
          "actions": "Actions"
        },
        "status": {
          "expired": "Expired",
          "actionNeeded": "Action needed",
          "upcoming": "Upcoming"
        },
        "fields": {
          "expiryDate": "Expiry date",
          "indexationDate": "Indexation date",
          "terminationDate": "Termination date",
          "availableFrom": "Available from",
          "startDate": "Start date"
        }
      },
      "analysis": {
        "title": "Analysis",
        "empty": "Add properties to the analysis to view the figures.",
        "summary": {
          "totalRent": "Total annual rent",
          "totalAskingRent": "Total asking rent",
          "weightedArea": "Weighted m2",
          "avgAskingRentPerM2": "Avg. asking rent/m2/year",
          "avgRentPerM2": "Avg. rent/m2/year",
          "wault": "WAULT"
        },
        "values": {
          "years": "{{value}} years"
        },
        "metrics": {
          "waltYears": "WALT: {{value}} years",
          "expiry12": "Expiry 12m: {{value}}",
          "expiry24": "Expiry 24m: {{value}}",
          "expiry36": "Expiry 36m: {{value}}"
        },
        "actions": {
          "clear": "Clear analysis",
          "collapseSurfaces": "Collapse surfaces",
          "expandSurfaces": "Expand surfaces",
          "remove": "Remove"
        },
        "table": {
          "property": "Property",
          "tenant": "Tenant",
          "annualRent": "Annual rent",
          "askingRent": "Asking rent",
          "weightedM2": "Weighted m2",
          "rentPerM2": "Rent/m2",
          "askingRentPerM2": "Asking rent/m2",
          "expiry": "Expiry",
          "remainingTerm": "Remaining term",
          "remainingMonths": "Remaining months",
          "guaranteeMonths": "Guarantee months",
          "surfaces": "Surfaces",
          "front": "Front",
          "rentCoverage": "Rent coverage",
          "interestCoverage": "Interest coverage",
          "weightedArea": "Weighted m2",
          "ltv": "LTV"
        },
        "surfaces": {
          "title": "Surfaces",
          "helper": "Default: retail 100%, secondary 50%. Adjust this per floor here.",
          "weightedTotal": "Weighted total",
          "grossM2": "{{value}} m2 gross",
          "weightedM2Value": "= {{value}} m2",
          "empty": "No surfaces found. Fill in retail and secondary surfaces under public data.",
          "button": "Surfaces"
        },
        "surfaceFields": {
          "beganeGrondWinkel": "Ground floor retail",
          "beganeGrondSecundair": "Ground floor secondary",
          "kelderWinkel": "Basement retail",
          "kelderSecundair": "Basement secondary",
          "eersteVerdiepingWinkel": "1st floor retail",
          "eersteVerdiepingSecundair": "1st floor secondary",
          "tweedeVerdiepingWinkel": "2nd floor retail",
          "tweedeVerdiepingSecundair": "2nd floor secondary",
          "derdeVerdiepingWinkel": "3rd floor retail",
          "derdeVerdiepingSecundair": "3rd floor secondary",
          "entresolWinkel": "Mezzanine retail",
          "entresolSecundair": "Mezzanine secondary",
          "soussolWinkel": "Lower ground retail",
          "soussolSecundair": "Lower ground secondary",
          "front": "Front",
          "winkel": "Shop",
          "secundair": "Secondary",
          "begane_grond_winkel": "Ground floor shop",
          "begane_grond_secundair": "Ground floor secondary",
          "kelder_winkel": "Basement shop",
          "kelder_secundair": "Basement secondary",
          "shop": "Shop",
          "secondary": "Secondary"
        },
        "chips": {
          "wault": "WAULT: {{value}} years",
          "expiry12": "Expiry 12m: {{value}}",
          "expiry24": "Expiry 24m: {{value}}",
          "expiry36": "Expiry 36m: {{value}}"
        }
      },
      "brokerRequests": {
        "title": "Broker requests",
        "overview": "Overview",
        "empty": "No requests",
        "interestCount": "{{count}} interest(s)",
        "buyContact": "Buy (€9)",
        "profile": {
          "industry": "Industry",
          "stores": "Stores",
          "activeIn": "Active in",
          "founded": "Founded",
          "revenue": "Revenue"
        }
      },
      "retailerProperties": {
        "sameBrandInterestBlocked": "Showing interest in a property from your own brand or group is not allowed."
      },
      "landing": {
        "language": {
          "select": "Choose language"
        },
        "nav": {
          "aria": "Main navigation",
          "forWho": "Who it’s for",
          "howItWorks": "How it works",
          "product": "Product",
          "price": "Pricing"
        },
        "actions": {
          "login": "Log in",
          "register": "Register",
          "startFree": "Register for free",
          "start60": "Start 60 days free",
          "startTrial": "Start free trial",
          "viewProduct": "View product"
        },
        "auth": {
          "tag": "Account",
          "close": "Close form",
          "copy": {
            "loginTitle": "Welcome back.",
            "loginText": "Log in with your business email address to access your map, properties and data.",
            "registerTitle": "Start your free trial.",
            "registerText": "Create a business account and try Retailmaps free for 60 days. We’ll send you an email to verify your account.",
            "forgotTitle": "Recover access.",
            "forgotText": "Enter your email address. If an account exists, we will send a recovery email."
          },
          "twoFactor": {
            "help": "Enter the 6-digit code from your authenticator app.",
            "label": "2FA code",
            "back": "Back to password"
          },
          "forgot": {
            "link": "Forgot password?",
            "help": "Enter your email address. If the account exists, we will send a password reset link.",
            "submit": "Send recovery email",
            "back": "Back to login",
            "openLocal": "Open local reset link"
          },
          "fields": {
            "email": "Email address",
            "businessEmail": "Business email address",
            "password": "Password",
            "role": "Role",
            "chooseRole": "Choose your role",
            "firstName": "First name",
            "lastName": "Last name",
            "companyName": "Company name"
          },
          "registerNote": "60 days free. No credit card required. You will first receive a verification email to activate your account.",
          "legalAccept": "I accept the <privacy>privacy policy</privacy> and <terms>terms and conditions</terms>.",
          "notices": {
            "emailVerified": "Your email address has been confirmed. Log in to open Retailmaps.",
            "twoFactorRequired": "Enter your 2FA code to continue.",
            "registerSuccess": "Registration successful. We have sent a confirmation email to your address.",
            "forgotSent": "If this email address is known, we will send a recovery email."
          },
          "errors": {
            "loginFailed": "Login failed. Please check your details.",
            "twoFactorFailed": "Login failed. Please check your 2FA code.",
            "businessEmail": "Use a business email address. Free email addresses such as Gmail, Hotmail, Outlook or iCloud are not allowed.",
            "roleRequired": "First choose your role: retailer, owner or broker.",
            "companyRequired": "Enter your company name.",
            "legalRequired": "Accept the privacy policy and terms to create your account.",
            "registerFailed": "Registration failed. Please try again.",
            "forgotFailed": "Password recovery failed."
          }
        },
        "roles": {
          "options": {
            "retailer": "Retailer",
            "owner": "Owner",
            "broker": "Broker"
          },
          "tag": "Who it’s for",
          "title": "One platform, built around three roles.",
          "intro": "Expansion, portfolio management and advisory services — all in one map-based workspace.",
          "retailer": {
            "kicker": "For retailers",
            "title": "Find the right location before it comes to market.",
            "text": "Follow properties, register your interest discreetly and stay ahead of new opportunities.",
            "points": {
              "1": {
                "title": "Register interest early",
                "text": "Express interest in a specific property, even before it officially becomes available."
              },
              "2": {
                "title": "Stay anonymous until the right moment",
                "text": "Owners, brokers and current occupiers can see that there is anonymous interest and contact you when the time is right."
              },
              "3": {
                "title": "Track promising locations",
                "text": "Keep project information, photos and notes organised <underline>by property</underline> and share them with your team. Follow properties and receive notifications when something changes, so valuable information is never lost."
              }
            }
          },
          "owner": {
            "kicker": "For owners",
            "title": "More control over your portfolio, market demand and leasing strategy.",
            "text": "Manage your retail property portfolio from one central workspace. List a property in one click, generate project information when needed, analyse your portfolio and assign locations to team members.",
            "points": {
              "1": {
                "title": "Manage your portfolio",
                "text": "Keep property, lease and contact data, documents and notes organised <underline>by property</underline> and accessible to your whole team. Add fields and sections to create a flexible property database that fits your workflow."
              },
              "2": {
                "title": "Receive interest from retailers",
                "text": "See which retailers are interested, including their sector and type of interest — even while the property is still occupied."
              },
              "3": {
                "title": "Set alerts",
                "text": "Stay on top of rent reviews, break dates and other important milestones."
              }
            }
          },
          "broker": {
            "kicker": "For brokers",
            "title": "Give better advice with a clear view of demand.",
            "text": "Bring location data, lease status, retailer information and market interest together in one workspace. Base your advice on current data, not disconnected spreadsheets.",
            "points": {
              "1": {
                "title": "Interactive map",
                "text": "Find retailers, keep map labels up to date and contribute to the world’s most complete open-source retail map."
              },
              "2": {
                "title": "Find leads and advise better",
                "text": "Use live leads to target opportunities more precisely and advise owners with stronger market insight."
              },
              "3": {
                "title": "All real estate data in one place",
                "text": "View, analyse and share property data with your team on desktop and mobile."
              },
              "4": {
                "title": "List properties easily",
                "text": "Bring properties to market quickly and adjust their visibility whenever circumstances change."
              }
            }
          }
        },
        "hero": {
          "eyebrow": "Retail Real Estate Intelligence",
          "title": "The interactive map for retail real estate.",
          "line1": "For and by retail professionals.",
          "line2": "Discover promising locations, express interest anonymously, track developments and manage property information in one central workspace — on desktop and mobile.",
          "line3": "Built for retailers, owners and brokers who want a faster view of where demand, supply and location come together.",
          "proofs": {
            "trial": "60 days free. No commitment.",
            "price": "Then €19 per month",
            "cancel": "Nothing to cancel",
            "noCard": "No credit card required",
            "noCharges": "No automatic charges",
            "afterTrial": "After 60 days, you decide whether to continue with a paid plan. Do nothing, pay nothing.",
            "cta": "Start my free trial"
          }
        },
        "how": {
          "tag": "How it works",
          "title": "Work from the map, not from disconnected spreadsheets.",
          "steps": {
            "1": {
              "title": "Explore a retail area",
              "text": "View properties, retailers and availability directly at street level."
            },
            "2": {
              "title": "Open a property",
              "text": "See everything relevant in one place: private information, floor areas, lease terms, property and financial data, contacts, photos, notes and documents."
            },
            "3": {
              "title": "Record interest or availability",
              "text": "Retailers express interest discreetly. Brokers list properties and control who can view the information."
            }
          }
        },
        "product": {
          "tag": "Product",
          "title": "More than data. Your daily workspace.",
          "features": {
            "1": {
              "title": "Interactive map",
              "text": "Work visually with shopping streets, properties and retail areas — not just tables."
            },
            "2": {
              "title": "Show interest",
              "text": "Make market demand visible without exposing sensitive strategies."
            },
            "3": {
              "title": "Private data",
              "text": "Keep lease data, documents, photos and notes together and protected within your organisation. Data cannot be exported, and two-factor authentication adds an extra layer of security."
            },
            "4": {
              "title": "Street View context",
              "text": "Explore locations at street level alongside the map for a clearer understanding of each property and its surroundings."
            }
          }
        },
        "visual": {
          "tag": "Street-level context",
          "title": "Location context without switching",
          "text": "Use Street View to assess the frontage, position and surroundings at a glance."
        },
        "price": {
          "tag": "Pricing",
          "title": "Get started without a lengthy process.",
          "text": "Try Retailmaps free for 60 days, then decide whether you want to continue. Straightforward pricing keeps the platform accessible to smaller teams too.",
          "cardTitle": "Retailmaps Professional",
          "amount": "€19",
          "period": "/ month",
          "cardText": "Try Retailmaps free for 60 days. No credit card required.",
          "items": {
            "1": "Interactive map and property list",
            "2": "Show interest and alerts",
            "3": "Property data, documents and notes",
            "4": "Works on laptop and mobile"
          }
        },
        "final": {
          "title": "See where the retail property market is moving.",
          "text": "Start with the map, follow relevant properties and quickly see where demand, supply and location meet."
        },
        "images": {
          "interestStackAria": "Mobile interest feature",
          "interestSavedAlt": "Withdraw interest on mobile",
          "interestAlt": "Show interest in a property on mobile",
          "interestCaption": "Express interest in a promising property — discreetly and directly from the map.",
          "ownerAlt": "Owner overview with received interest",
          "ownerCaption": "Review interest by property and decide when to request the retailer’s contact details.",
          "brokerAlt": "Broker dashboard with properties, retailers and leads",
          "brokerCaption": "View properties, retailers and leads together in one clear overview.",
          "rentalAlt": "Mobile property information with rental offer",
          "streetViewAlt": "Map and Street View side by side"
        },
        "footer": {
          "copyright": "© 2026 Retailmaps.com",
          "security": "Data & security",
          "privacy": "Privacy policy",
          "terms": "Terms",
          "contact": "Contact"
        }
      },
      "popup.autosaveActive": "Autosave active",
      "retailerMap.mobileZoomFeedback": "Zoom {{zoom}} - double tap from 19 to add",
      "retailerMap.installPrompt.title": "Open Retailmaps faster",
      "retailerMap.installPrompt.subtitle": "Add Retailmaps to your home screen.",
      "retailerMap.installPrompt.install": "Add to mobile",
      "retailerMap.installPrompt.later": "Later",
      "retailerMap.iosInstall.title": "Add Retailmaps to home screen",
      "retailerMap.iosInstall.intro": "On iPhone, Safari cannot do this automatically. Follow these steps:",
      "retailerMap.iosInstall.step1": "1. Tap the share button at the bottom",
      "retailerMap.iosInstall.step2": "2. Choose Add to Home Screen.",
      "retailerMap.iosInstall.step3": "3. Tap Add.",
      "common.understood": "Understood",
      "propertyList.filters.country": "Country",
      "propertyList.filters.allCountries": "All countries",
      "propertyList.interest.changeFailed": "Changing interest failed.",
      "propertyList.interest.ownGroup": "Own group",
      "propertyList.interest.viaColleague": "Via colleague",
      "propertyList.interest.withdraw": "Withdraw",
      "propertyList.interest.show": "Show interest",
      "propertyList.rental.stop": "Stop rental",
      "propertyList.rental.setForRent": "Set for rent",
      "broker": {
        "listingsTitle": "My rental listings"
      },
      "retailer": {
        "listingsTitle": "My rental listings"
      },
      "ownerListings.currentOffer": "My rental listings",
      "broker.listingsTitle": "My rental listings",
      "retailer.listingsTitle": "My rental listings",
      "listings.common.empty": "There are currently no locations for rent.",
      "owner": {
        "ownerFields": {
          "title": "Owner details",
          "parentCompany": "Parent owner company",
          "owner": "Owner",
          "contactPerson": "Contact person",
          "email": "Email address",
          "phone": "Phone number"
        },
        "huurgegevensBlock": {
          "title": "Rental details",
          "formeleHuurder": "Formal tenant",
          "huurprijs": "Rent",
          "ingangsdatum": "Start date",
          "expiratiedatum": "Expiry date",
          "resterendeLooptijdMaanden": "Remaining lease term",
          "huurtermijn": "Lease term",
          "verlengingsjaren": "Extension years",
          "huurvrijePeriodeMaanden": "Rent-free period",
          "indexatiedatum": "Indexation date",
          "opzegdatum": "Notice date",
          "opzegtermijn": "Notice period",
          "garantiesoort": "Guarantee type",
          "kiesOptie": "Choose an option",
          "waarborgsom": "Security deposit",
          "bankgarantie": "Bank guarantee",
          "concerngarantie": "Company guarantee",
          "garantiebedrag": "Guarantee amount",
          "noGuarantee": "No guarantee"
        },
        "financieringBlock": {
          "title": "Financial details",
          "koopsom": "Purchase price",
          "aankoopdatum": "Purchase date",
          "actueleMarktwaarde": "Current market value",
          "taxatiedatum": "Valuation date",
          "hypotheek": "Mortgage amount",
          "actueleHypotheekschuld": "Current mortgage debt",
          "actueleHypotheekrente": "Current mortgage rate (%)",
          "rentevastTot": "Fixed interest until",
          "aflossingspercentage": "Repayment percentage (%)",
          "looptijd": "Term (years)",
          "jaarlijkseRentelasten": "Annual interest costs",
          "jaarlijkseAflossing": "Annual repayment",
          "bank": "Bank",
          "jaarlijkseOverigeLasten": "Annual other costs",
          "netOperatingIncome": "Net operating income",
          "markthuurPerM2": "Market rent per m?",
          "servicekostenPerJaar": "Service costs per year",
          "vraagprijs": "Asking price"
        },
        "opmerkingen": {
          "title": "Notes",
          "none": "No notes added yet.",
          "unknownAuthor": "Unknown author",
          "add": "Add note",
          "placeholder": "Type your note here..."
        },
        "contactgegevensBlock": {
          "title": "Contact details",
          "add": "Add contact",
          "remove": "Remove contact",
          "company": "Company",
          "name": "Name",
          "phone": "Phone",
          "email": "Email",
          "function": "Role"
        }
      },
      "owner.financieringBlock.actueleMarktwaarde": "Current market value",
      "owner.financieringBlock.taxatiedatum": "Valuation date",
      "owner.financieringBlock.actueleHypotheekschuld": "Current mortgage debt",
      "owner.financieringBlock.actueleHypotheekrente": "Current mortgage rate (%)",
      "owner.financieringBlock.rentevastTot": "Fixed interest until",
      "owner.financieringBlock.aflossingspercentage": "Repayment percentage (%)",
      "owner.financieringBlock.jaarlijkseRentelasten": "Annual interest costs",
      "owner.financieringBlock.jaarlijkseAflossing": "Annual repayment",
      "owner.financieringBlock.jaarlijkseOverigeLasten": "Annual other costs",
      "owner.financieringBlock.netOperatingIncome": "Net operating income",
      "owner.financieringBlock.markthuurPerM2": "Market rent per m?",
      "owner.financieringBlock.servicekostenPerJaar": "Service costs per year",
      "propertyDetails.objectInfoDivider": "Object information",
      "propertyDetails.addObjectInfo": "Add object information",
      "listings.common.country": "Country",
      "listings.common.city": "City",
      "listings.common.address": "Address",
      "listings.common.askingPrice": "Asking price",
      "listings.common.currentRent": "Current rent",
      "listings.common.keyMoney": "Key money",
      "listings.common.expiryDate": "Expiry date",
      "listings.common.availableFrom": "Available from",
      "listings.common.forRentSince": "For rent since",
      "listings.common.projectInformation": "Project information",
      "listings.common.onBehalfOf": "On behalf of",
      "listings.common.visibility": "Visibility",
      "listings.common.broker": "Broker",
      "listings.common.actions": "Actions",
      "listings.common.upload": "Upload",
      "listings.common.uploadDocument": "Upload document",
      "listings.common.stopForRent": "Stop",
      "listings.common.brochureFailed": "Generating or uploading the brochure failed.",
      "listings.common.projectDocuments": "Project documents",
      "listings.common.chooseFile": "Choose file",
      "listings.common.noFileChosen": "No file selected",
      "listings.common.selectFileFirst": "Select a file first.",
      "listings.common.uploadFailed": "Upload failed.",
      "listings.common.documentDeleteFailed": "Deleting the document failed.",
      "listings.common.confirmDeleteDocument": "Are you sure you want to delete \"{{name}}\"?",
      "listings.common.forRent": "For rent",
      "listings.common.edit": "Edit",
      "listings.common.save": "Save",
      "listings.common.cancel": "Cancel",
      "listings.common.documentTypes.document": "Document",
      "listings.common.documentTypes.floorplan": "Floor plan",
      "listings.common.documentTypes.brochure": "Brochure",
      "listings.common.documentTypes.photo": "Photo",
      "listings.common.visibilityOptions.public": "Everyone",
      "listings.common.visibilityOptions.retailers": "All retailers",
      "listings.common.visibilityOptions.interested": "Interested only",
      "roles.owner": "Owner",
      "roles.retailer": "Retailer",
      "roles.broker": "Broker",
      "common.edit": "Edit",
      "listings.common.noDocuments": "No documents available.",
      "listings.common.fileCountOne": "{{count}} file",
      "listings.common.fileCountOther": "{{count}} files",
      "listings.common.addedOn": "Added {{date}}",
      "listings.common.deleteDocumentAria": "Delete {{name}}",
      "common.close": "Close",
      "common.open": "Open",
      "common.delete": "Delete",
      "photos": {
        "title": "Photos",
        "add": "Add photo",
        "remove": "Remove photo",
        "useAsCover": "Use as cover photo",
        "cover": "Cover",
        "chooseCover": "Choose",
        "openPreview": "Open preview",
        "error": {
          "tooLarge": "is larger than 10 MB and was skipped."
        }
      },
      "photos.useAsCover": "Use as cover photo",
      "photos.cover": "Cover",
      "photos.chooseCover": "Choose",
      "photos.openPreview": "Open preview",
      "propertyDetails.notesDivider": "Notes",
      "retailerProperty.contactsDivider": "Contacts",
      "retailerProperty": {
        "contactsDivider": "Contacts",
        "notesDivider": "Notes",
        "photosDivider": "Photos"
      },
      "retailerProperty.notesDivider": "Notes",
      "retailerProperty.photosDivider": "Photos",
      "account.noLogo": "No logo yet",
      "listings.common.uploading": "Uploading...",
      "extraFieldsBlock.addField": "Add field",
      "extraFieldsBlock.addHeader": "Add section",
      "extraSections.fieldLabel": "Field name",
      "extraSections.fieldType": "Type",
      "extraSections.addField": "Add field",
      "extraSections.addSection": "Add section",
      "extraSections.newTab": "New tab",
      "extraSections.tabName": "Tab name",
      "extraSections.renameTab": "Rename tab",
      "extraSections.untitledTab": "Tab name",
      "extraSections.sectionName": "Section name",
      "rentalData.addField": "Add field",
      "financialData.addField": "Add field",
      "propertyDetails.detailsDivider": "Details",
      "common.saved": "Saved",
      "common.saving": "Saving...",
      "common.saveFailed": "Save failed",
      "common.ready": "Ready",
      "common.active": "Active",
      "common.inactive": "Inactive",
      "common.canceled": "Canceled",
      "common.loading": "Loading...",
      "accountSettings.title": "Settings",
      "accountSettings.tabs.profile": "Profile",
      "accountSettings.tabs.company": "Company",
      "accountSettings.tabs.preferences": "Preferences",
      "accountSettings.tabs.security": "Security",
      "accountSettings.tabs.billing": "Billing",
      "accountSettings.descriptions.profile": "Contact details and role information for your account.",
      "accountSettings.descriptions.company": "Company details, brand and billing.",
      "accountSettings.descriptions.preferences": "Language, currency, units and map display.",
      "accountSettings.descriptions.security": "Login and account security.",
      "accountSettings.descriptions.billing": "Subscription, usage and one-off purchases.",
      "accountSettings.personal.title": "Personal profile",
      "accountSettings.personal.description": "Contact details and role information for your account. Changes are saved automatically.",
      "accountSettings.personal.firstName": "First name",
      "accountSettings.personal.lastName": "Last name",
      "accountSettings.personal.role": "Job title",
      "accountSettings.personal.phone": "Phone number",
      "accountSettings.personal.email": "Email address",
      "accountSettings.personal.linkedin": "LinkedIn",
      "accountSettings.personal.address": "Address",
      "accountSettings.company.title": "Company profile",
      "accountSettings.company.description": "Company details, brand information and billing for broker and owner accounts. Changes are saved automatically.",
      "accountSettings.company.brandLogoTitle": "Brand and logo",
      "accountSettings.company.brandLogoDescription": "We use this logo on property cards and other visible brand spaces.",
      "accountSettings.company.readOnlyNotice": "Company group and domain drive connections, visibility and AI profiles, and therefore remain read-only.",
      "accountSettings.company.companyName": "Company name",
      "accountSettings.company.companyGroup": "Company group",
      "accountSettings.company.domain": "Domain",
      "accountSettings.company.legalName": "Legal name",
      "accountSettings.company.website": "Website",
      "accountSettings.company.roleType": "Role type",
      "accountSettings.company.headquartersTitle": "Headquarters",
      "accountSettings.company.headquartersAddress": "Headquarters address",
      "accountSettings.company.postalCode": "Postal code",
      "accountSettings.company.city": "City",
      "accountSettings.company.country": "Country",
      "accountSettings.company.billingTitle": "Billing",
      "accountSettings.company.billingDescription": "We use these details for subscriptions, invoices and financial administration.",
      "accountSettings.company.billingEmail": "Billing email",
      "accountSettings.company.invoiceReference": "Invoice reference / PO",
      "accountSettings.company.chamberOfCommerce": "Chamber of Commerce number",
      "accountSettings.company.vatNumber": "VAT number",
      "accountSettings.company.billingAddress": "Billing address",
      "accountSettings.company.taxIdType": "Tax ID type",
      "accountSettings.company.taxIdValue": "VAT / Tax ID number",
      "accountSettings.company.taxIdPlaceholder": "NL123456789B01",
      "accountSettings.company.peopleTitle": "People",
      "accountSettings.company.peopleDescription": "Accounts linked to the same organization. Statuses are based on subscription and trial period.",
      "accountSettings.company.peopleName": "Name",
      "accountSettings.company.peopleEmail": "Email",
      "accountSettings.company.peopleRole": "Role",
      "accountSettings.company.peopleStatus": "Status",
      "accountSettings.company.peopleTrialUntil": "Trial until",
      "accountSettings.company.peopleYou": "You",
      "accountSettings.company.peopleEmpty": "No other accounts have been found in this organization yet.",
      "accountSettings.company.statusTrial": "Trial",
      "accountSettings.company.statusActive": "Active",
      "accountSettings.company.statusInactive": "Inactive",
      "accountSettings.company.taxTypes.euVat": "European VAT number",
      "accountSettings.company.taxTypes.gbVat": "United Kingdom VAT number",
      "accountSettings.company.taxTypes.auAbn": "Australian Business Number (AU ABN)",
      "accountSettings.company.taxTypes.auArn": "Australian Taxation Office Reference Number",
      "accountSettings.company.taxTypes.brCnpj": "Brazilian CNPJ number",
      "accountSettings.company.taxTypes.brCpf": "Brazilian CPF number",
      "accountSettings.company.taxTypes.caBn": "Canadian BN",
      "accountSettings.company.taxTypes.caGstHst": "Canadian GST/HST number",
      "accountSettings.company.taxTypes.chVat": "Swiss VAT number",
      "accountSettings.company.taxTypes.clTin": "Chilean TIN",
      "accountSettings.company.taxTypes.egTin": "Egyptian Tax Identification Number",
      "accountSettings.company.taxTypes.inGst": "Indian GST number",
      "accountSettings.company.taxTypes.jpCn": "Japanese Corporate Number",
      "accountSettings.company.taxTypes.jpRn": "Japanese Registered Foreign Businesses number",
      "accountSettings.company.taxTypes.mxRfc": "Mexican RFC number",
      "accountSettings.company.taxTypes.noVat": "Norwegian VAT number",
      "accountSettings.company.taxTypes.nzGst": "New Zealand GST number",
      "accountSettings.company.taxTypes.sgGst": "Singaporean GST number",
      "accountSettings.company.taxTypes.usEin": "United States EIN",
      "accountSettings.company.taxTypes.zaVat": "South African VAT number",
      "security.twoFactor.title": "Two-factor authentication",
      "security.twoFactor.subtitle": "Protect your account with a 6-digit code from an authenticator app.",
      "security.twoFactor.setup": "Set up 2FA",
      "security.twoFactor.scanQr": "Scan the QR code with your authenticator app. If that does not work, use the setup code manually.",
      "security.twoFactor.openAuthenticator": "Open in authenticator app",
      "security.twoFactor.sixDigitCode": "6-digit code",
      "security.twoFactor.enable": "Enable 2FA",
      "security.twoFactor.disableWarning": "Only disable 2FA if you are sure this account is protected in another way.",
      "security.password": "Password",
      "security.twoFactor.code": "2FA code",
      "security.twoFactor.disable": "Disable 2FA",
      "propertyDetails.datePlaceholder": "dd-mm-yyyy",
      "propertyDetails.addContact": "Add contact",
      "brokerProperty.askingPrice": "Asking price",
      "brokerProperty": {
        "askingPrice": "Asking price"
      },
      "owner.financieringBlock.vraagprijs": "Asking price",
      "propertyDetails.askingRentPrice": "Asking rent",
      "propertyDetails.serviceCosts": "Service costs",
      "propertyDetails.takeoverPrice": "Key money",
      "propertyDetails.availableFrom": "Available from",
      "propertyDetails.projectInfoDivider": "Project information",
      "propertyDetails.addProjectInfo": "Add project information",
      "extraSections": {
        "addField": "Add field",
        "addSection": "Add section",
        "newTab": "New tab"
      },
      "extraFields.addField": "Add field",
      "extraFields": {
        "addField": "Add field",
        "addSection": "Add section"
      },
      "extraFields.addSection": "Add section",
      "extraFieldsBlock": {
        "addField": "Add field",
        "addHeader": "Add section",
        "title": "Extra fields"
      },
      "extraFieldsBlock.title": "Extra fields",
      "retailerMap.downloadSvg": "Download SVG",
      "retailerMap.downloadSvgTooltip": "Download the map as an SVG file",
      "retailerMap.printMenu.paper": "Print on paper",
      "retailerMap.printMenu.pdf": "Save as PDF",
      "retailerMap.printMenu.svg": "Download map image SVG",
      "settingsPanel.dashboardOverlay.shared.assistant": "How it works",
      "myProperties.noPaidSubscriptionSuffix": " - no paid subscription",
      "myProperties.analysis": "Analysis",
      "myProperties.assignRequiresPaidSubscription": "This user needs an active subscription.",
      "myProperties.importPortfolio": "Import portfolio",
      "myProperties.remove": "Remove",
      "myProperties.confirmRemove": "Are you sure you want to remove this property from the organisation portfolio? If no colleague also has this property, it will disappear from the organisation.",
      "myProperties.removeFailed": "Removing failed.",
      "popup2.addedState": "Added",
      "popup2.addToMyProperties": "Add to my properties",
      "popup2.front": "Frontage",
      "popup2.groundFloor": "Ground floor",
      "popup2.basement": "Basement",
      "popup2.firstFloor": "1st floor",
      "popup2.secondFloor": "2nd floor",
      "popup2.thirdFloor": "3rd floor",
      "popup2.entresol": "Entresol",
      "popup2.soussol": "Lower ground",
      "popup2.retailSpace": "Retail",
      "popup2.secondarySpace": "Secondary",
      "popup2.adding": "Adding...",
      "popup2.publicData": "Public data",
      "popup2.privateData": "Private data",
      "popup2.surface": "Surface",
      "settingsPanel.retailerMap.loading.zoomInToLoad": "Zoom in to {{zoom}} to load retailers",
      "settingsPanel.retailerMap.loading.fillingStreet": "Loading new properties. This can take up to 2 min...",
      "settingsPanel.retailerMap.loading.paintingFromCenter": "Loading properties from the centre...",
      "propertyFields": {
        "shop": "Shop",
        "storage": "Storage",
        "secondary": "Secondary"
      },
      "propertyList": {
        "filters": {
          "country": "Country",
          "allCountries": "All countries",
          "city": "City",
          "select": "Select...",
          "street": "Street",
          "typeStreet": "Type street...",
          "retailer": "Retailer",
          "retailerExampleShort": "Retailer",
          "searchAddress": "Search address",
          "scopeHint": "Choose a street or search by retailer to load the property list."
        },
        "columns": {
          "number": "No.",
          "country": "Country",
          "city": "City",
          "address": "Address",
          "retailer": "Retailer",
          "status": "Status",
          "interests": "Interests",
          "purchased": "Purchased",
          "details": "Details",
          "analysis": "Analysis",
          "rental": "Rental"
        },
        "status": {
          "forRent": "For rent",
          "notForRent": "Not for rent"
        },
        "rental": {
          "setForRent": "Set for rent",
          "stop": "Stop rental",
          "stopForRent": "Stop rental"
        },
        "pagination": {
          "rowsPerPage": "Rows per page"
        },
        "interests": {
          "none": "No interests",
          "date": "Date",
          "interestedParty": "Interested party",
          "type": "Type",
          "branch": "Sector",
          "stores": "Stores",
          "contactDetails": "Contact details",
          "protected": "Protected",
          "interest": "Interest",
          "generalInterest": "General interest",
          "forRentInterest": "For-rent interest",
          "downloadContact": "Download contact details",
          "buyContact": "Buy contact details (EUR 9)"
        },
        "contactPurchase": {
          "title": "Buy contact details",
          "description": "Approve the one-time price of EUR 9 to unlock these contact details.",
          "invoiceNotice": "EUR 9 will be added to your next monthly credit card invoice.",
          "buy": "Approve EUR 9 and unlock"
        },
        "openDetails": "Open details",
        "loading": "Loading properties...",
        "noPropertiesFound": "No properties found"
      },
      "dashboardOverlay.shared.forRent": "For rent",
      "dashboardOverlay.broker.properties": "Properties",
      "analysis.title": "Analysis",
      "analysis.empty": "Add properties to the analysis to view the figures.",
      "analysis.summary.totalRent": "Total annual rent",
      "analysis.summary.totalAskingRent": "Total asking rent",
      "analysis.summary.weightedArea": "Weighted m2",
      "analysis.summary.avgRentPerM2": "Avg. rent/m2/year",
      "analysis.summary.avgAskingRentPerM2": "Avg. asking rent/m2/year",
      "analysis.metrics.waltYears": "WALT: {{value}} years",
      "analysis.metrics.expiry12": "Expiry 12m: {{value}}",
      "analysis.metrics.expiry24": "Expiry 24m: {{value}}",
      "analysis.metrics.expiry36": "Expiry 36m: {{value}}",
      "analysis.values.years": "{{value}} years",
      "analysis.actions.clear": "Clear analysis",
      "analysis.actions.collapseSurfaces": "Collapse surfaces",
      "analysis.actions.expandSurfaces": "Expand surfaces",
      "analysis.table.property": "Property",
      "analysis.table.tenant": "Tenant",
      "analysis.table.front": "Front",
      "analysis.table.annualRent": "Annual rent",
      "analysis.table.askingRent": "Asking rent",
      "analysis.table.weightedM2": "Weighted m2",
      "analysis.table.rentPerM2": "Rent/m2",
      "analysis.table.askingRentPerM2": "Asking rent/m2",
      "analysis.table.expiry": "Expiry",
      "analysis.table.remainingTerm": "Remaining term",
      "analysis.table.remainingMonths": "Remaining months",
      "analysis.table.rentCoverage": "Rent coverage",
      "analysis.table.interestCoverage": "Interest coverage",
      "analysis.table.guaranteeMonths": "Guarantee months",
      "analysis.table.surfaces": "Surfaces",
      "analysis.surfaces.title": "Surfaces",
      "analysis.surfaces.helper": "Default: retail 100%, secondary 50%. Adjust this per floor here.",
      "analysis.surfaces.weightedTotal": "Weighted total",
      "analysis.surfaces.grossM2": "{{value}} m2 gross",
      "analysis.surfaces.weightedM2Value": "= {{value}} m2",
      "analysis.surfaces.empty": "No surfaces found. Fill in retail and secondary surfaces under public data.",
      "analysis.surfaceFields.front": "Front",
      "analysis.surfaceFields.winkel": "Shop",
      "analysis.surfaceFields.secundair": "Secondary",
      "analysis.surfaceFields.begane_grond_winkel": "Ground floor shop",
      "analysis.surfaceFields.begane_grond_secundair": "Ground floor secondary",
      "analysis.surfaceFields.kelder_winkel": "Basement shop",
      "analysis.surfaceFields.kelder_secundair": "Basement secondary",
      "propertyList.rental.stopForRent": "Stop rental",
      "analysis.summary.wault": "WAULT",
      "analysis.actions.remove": "Remove",
      "analysis.chips.wault": "WAULT: {{value}} years",
      "analysis.chips.expiry12": "Expiry 12m: {{value}}",
      "analysis.chips.expiry24": "Expiry 24m: {{value}}",
      "analysis.chips.expiry36": "Expiry 36m: {{value}}",
      "analysis.table.weightedArea": "Weighted m2",
      "analysis.table.ltv": "LTV",
      "analysis.surfaces.button": "Surfaces",
      "analysis.surfaceFields.shop": "Shop",
      "analysis.surfaceFields.secondary": "Secondary",
      "dashboardOverlay.shared.support": "Support",
      "support": {
        "title": "Support",
        "intro": "Need help? Send your question directly to our support team.",
        "emailIntro": "You can also email us directly.",
        "category": "Topic",
        "categoryGeneral": "General question",
        "categoryAccount": "Account and subscription",
        "categoryBilling": "Billing and payments",
        "categoryMap": "Map and data",
        "categoryForRent": "For rent",
        "categoryBug": "Report a problem",
        "subject": "Subject",
        "message": "Your question",
        "subjectPlaceholder": "Briefly describe your question",
        "messagePlaceholder": "Tell us how we can help you",
        "send": "Send to support",
        "sending": "Sending…",
        "successTitle": "Your support request has been sent",
        "success": "We received your question. Your reference is {{ticketNumber}}. We also sent a confirmation to your email address.",
        "context": "Your message is linked to your {{role}} account and the page you are currently viewing.",
        "validation": "Please enter both a subject and your question.",
        "error": "Your request could not be sent. Please try again or email support@retailmaps.com."
      }
    }
  },
  "es": {
    "translation": {
      "popup2.trialPaywallTitle": "Has utilizado tus 10 muestras de interés gratuitas",
      "popup2.trialPaywallDescription": "Para mostrar interés también en este inmueble, necesitas una suscripción. Tus 10 muestras de interés de prueba actuales se convertirán en muestras de interés de pago.",
      "popup2.trialPaywallManage": "Más adelante podrás gestionar estas muestras de interés en tu panel (modificarlas o eliminarlas).",
      "popup2.trialPaywallActivate": "Activar suscripción",
      "popup2": {
        "userRoleInLog": "User role in Popup2:",
        "checkIfPropertyInList": "Check if property is in list:",
        "userHasProperties": "User has properties:",
        "errorFetchingUser": "Error fetching user:",
        "noUserEmail": "No hay ninguna dirección de correo disponible. Comprueba que hayas iniciado sesión.",
        "loginRequired": "No has iniciado sesión. Vuelve a iniciar sesión para añadir inmuebles.",
        "publicStatusUpdated": "Public visibility successfully updated:",
        "publicStatusUpdateFailed": "No se pudo guardar la visibilidad pública.",
        "publicStatusUpdateError": "Error while making public:",
        "saveFailed": "No se pudieron guardar los cambios.",
        "invalidJSON": "Invalid JSON, using fallback:",
        "saveSummary": "🚀 onSave() summary:",
        "inList": "Este inmueble está en tu lista",
        "confirmRemove": "Are you sure you want to remove this property from your list",
        "removed": "El inmueble se ha eliminado de tu lista.",
        "removeError": "Error al eliminar el inmueble:",
        "removeFailed": "No se pudo eliminar.",
        "removeFromList": "Eliminar de mis inmuebles",
        "addRequestLog": "Send request: add-property",
        "addResponseLog": "Server response:",
        "added": "El inmueble se ha añadido a tu lista.",
        "addFailed": "No se pudo añadir.",
        "addError": "Error al añadir el inmueble:",
        "addToList": "Añadir a mis inmuebles",
        "localStorageUpdated": "localStorage user updated with property:",
        "interestedRetailers": "Minoristas interesados",
        "retailersHaveInterest": "minoristas han mostrado interés",
        "viewRequests": "View requests in dashboard →",
        "publicData": "Datos públicos",
        "privateData": "Datos privados",
        "privateDataHint": "La información interna permanece en tu espacio de trabajo seguro y solo es visible para los usuarios autorizados.",
        "privateWorkspace": "Espacio de trabajo privado",
        "privateWorkspaceHint": "Usa estas pestañas para gestionar de forma clara y segura notas confidenciales del propietario, finanzas, contactos, fotos y documentos.",
        "address": "Dirección",
        "city": "Ciudad",
        "website": "Sitio web",
        "groundFloor": "Planta baja",
        "basement": "Sótano",
        "firstFloor": "1.ª planta",
        "secondFloor": "2.ª planta",
        "thirdFloor": "3.ª planta",
        "entresol": "Entresuelo",
        "unit": "Unidad",
        "m2": "m",
        "ft2": "ft",
        "manageRentalStatus": "Gestionar el estado de alquiler",
        "forRent": "En alquiler",
        "confirmRent": "You are about to list this property for rent.\n• The cost is €19 per month\n• The status will be visible to other parties\n\nClick OK to proceed.",
        "confirmStopRent": "You are about to stop the rental status.\n• This will also cancel your Stripe subscription for this property.\n\nAre you sure you want to continue",
        "rentCancelled": "✅ The rental status has been cancelled and the subscription has been stopped.",
        "stripeStartError": "Se ha producido un error al iniciar Stripe.",
        "stripeError": "Error de Stripe: ",
        "cancelError": "Error al cancelar la suscripción:",
        "cancelStripeError": "No se pudo cancelar la suscripción en Stripe: ",
        "makePublic": "Hacer visible públicamente",
        "mustRentFirst": "Publica primero el inmueble en alquiler antes de hacerlo público.",
        "saveChanges": "Guardar cambios",
        "addedState": "Añadido",
        "addToMyProperties": "Añadir a mis inmuebles",
        "front": "Fachada",
        "soussol": "Sótano",
        "retailSpace": "Tienda",
        "secondarySpace": "Secundaria",
        "adding": "Añadiendo...",
        "surface": "Superficie",
        "trialPaywallTitle": "Has utilizado tus 10 muestras de interés gratuitas",
        "trialPaywallDescription": "Para mostrar interés también en este inmueble, necesitas una suscripción. Tus 10 muestras de interés de prueba actuales se convertirán en muestras de interés de pago.",
        "trialPaywallManage": "Más adelante podrás gestionar estas muestras de interés en tu panel (modificarlas o eliminarlas).",
        "trialPaywallActivate": "Activar suscripción",
        "cancel": "Cancelar",
        "confirm": "Confirmar",
        "stripeErrorPrefix": "Error de Stripe: ",
        "busy": "Laboral...",
        "interestAddFailed": "No se pudo agregar intereses.",
        "stripeStartFailed": "Error al iniciar Stripe.",
        "extraPropertyFailed": "Error al agregar una propiedad adicional.",
        "saveError": "No se pudieron guardar los cambios.",
        "visibilityUpdateFailed": "Error al cambiar la visibilidad.",
        "setForRent": "Poner en alquiler",
        "roleNotSupported": "Su función actual no admite esta acción.",
        "ownerMustAddFirst": "Primero agregue esta propiedad a su cartera.",
        "retailerBrandClaimRequired": "Se requiere un reclamo de marca para gestionar la visibilidad del alquiler.",
        "publicDataHint": "Información visible de la propiedad utilizada en listados, folletos y vistas de mapas.",
        "rentConfirmDescription": "Poner esta propiedad en alquiler normalmente cuesta 15 EUR al mes, pero actualmente es gratuito durante el período de lanzamiento.",
        "rentStatusActive": "En alquiler (activo)",
        "extraPropertyTitle": "Agregar propiedad adicional",
        "rentActionErrorPrefix": "Error al cambiar el estado del alquiler:",
        "skipConfirmation": "Omita esta confirmación la próxima vez",
        "rentConfirmTitle": "Listar propiedad en alquiler",
        "rentLaunchFree": "Ahora gratis",
        "dontShowAgain": "No volver a mostrar",
        "interestConfirmBody": "Este interés se guardará en esta propiedad y se agregará a su descripción general. Mientras esté dentro de su límite de prueba o acceso activo, no se le cobrarán costos adicionales. Si se requiere pago, lo solicitaremos por separado antes de incurrir en costos."
      },
      "authLanding": {
        "fields": {
          "firstName": "Nombre",
          "lastName": "Apellidos",
          "phone": "Teléfono",
          "email": "Dirección de correo electrónico",
          "website": "Sitio web",
          "password": "Contraseña",
          "role": "Rol",
          "companyName": "Nombre de empresa"
        },
        "tabs": {
          "login": "Acceso",
          "register": "Registrarse"
        },
        "roles": {
          "retailer": "Retailer",
          "owner": "Propietario",
          "broker": "Corredor"
        },
        "headlines": {
          "login": {
            "eyebrow": "Inteligencia inmobiliaria minorista",
            "subtitle": "Inicie sesión y trabaje desde una capa de mapa en vivo sobre cartera, arrendamiento e intereses."
          },
          "forgot": {
            "eyebrow": "Restaurar acceso",
            "subtitle": "Solicite un enlace de restablecimiento y establezca rápidamente una nueva contraseña para su cuenta."
          },
          "register": {
            "eyebrow": "Una plataforma para corredores, propietarios y minoristas",
            "subtitle": "Comience con una cuenta y cree su cartera, listados e inteligencia de mercado desde el mapa."
          }
        },
        "roleSlides": {
          "broker": {
            "eyebrow": "Para brokers",
            "label": "Corredor",
            "featureCards": {
              "0": "Publica las ubicaciones disponibles más rápido.",
              "1": "Trabaje con intereses en vivo, documentos e información del proyecto.",
              "2": "Mantenga listados, clientes potenciales y análisis en un solo lugar."
            },
            "subtitle": "Lleve listados al mercado, realice un seguimiento de los intereses y desbloquee los detalles de contacto directamente desde el mismo espacio de trabajo del mapa.",
            "footer": {
              "0": "Listados",
              "1": "Inteligencia líder",
              "2": "Inteligencia de corredores"
            },
            "workflowSteps": {
              "0": "De la propiedad al listado",
              "1": "Intereses y datos de contacto",
              "2": "Análisis por ubicación"
            }
          },
          "owner": {
            "label": "Propietario",
            "eyebrow": "Para propietarios",
            "subtitle": "Administre cartera, datos de arrendamiento, documentos y alertas desde un mapa que se adapta a los flujos de trabajo inmobiliarios.",
            "featureCards": {
              "0": "Almacene los datos financieros, de propiedad y de arrendamiento de forma centralizada.",
              "1": "Enumere propiedades en alquiler y siga el estado en el mapa.",
              "2": "Utilice alertas y análisis sin hojas de cálculo separadas."
            },
            "footer": {
              "0": "Gestión de cartera",
              "1": "Información de arrendamiento",
              "2": "Análisis del propietario"
            },
            "workflowSteps": {
              "0": "Control de cartera",
              "1": "Datos de arrendamiento y alertas",
              "2": "Análisis de activos"
            }
          },
          "retailer": {
            "label": "Retailer",
            "eyebrow": "Para retailers",
            "featureCards": {
              "0": "Vea calles comerciales relevantes y propiedades disponibles.",
              "1": "Añade tiendas a tu propio portafolio.",
              "2": "Muestre interés y compare ubicaciones en el análisis."
            },
            "subtitle": "Descubre calles, gestiona tiendas, muestra interés y analiza ubicaciones antes de dar el siguiente paso.",
            "workflowSteps": {
              "0": "Administrar tiendas",
              "1": "Mostrar interés",
              "2": "Comparar ubicaciones"
            },
            "footer": {
              "0": "Mis tiendas",
              "1": "Interes",
              "2": "Análisis minorista"
            }
          }
        },
        "forgot": {
          "helper": "Introduzca su dirección de correo electrónico a continuación. Si la cuenta existe, le enviaremos un enlace de restablecimiento de inmediato."
        },
        "platformSubtitle": "Por y para profesionales del comercio minorista",
        "heroSubtitle": "El mapa minorista en vivo para áreas minoristas en todo el mundo, arrendamiento, muestra de interés, clientes potenciales y análisis de ubicación. Todo en una sola plataforma por 19€ al mes.",
        "trialCta": "Regístrate gratis",
        "trialIntro": "Comience su prueba gratuita de 60 días aquí",
        "workflowSteps": {
          "0": "Control de cartera y cotización",
          "1": "Señales del mercado en vivo en el mapa.",
          "2": "Un flujo de trabajo para cada rol"
        },
        "marketTagline": "Calles comerciales privilegiadas · contexto de mercado en vivo",
        "featureCards": {
          "0": "Trabaje desde una capa de mapa en vivo con contexto minorista.",
          "1": "Gestione cartera, arrendamiento e intereses en un solo lugar.",
          "2": "Conecte al corredor, al propietario y al minorista en un solo flujo de trabajo."
        },
        "footer": {
          "0": "Gestión de cartera",
          "1": "Listados de alquiler",
          "2": "Inteligencia minorista"
        },
        "modeLabel": {
          "login": "Bienvenido de nuevo",
          "register": "Nueva cuenta",
          "forgot": "Has olvidado tu contraseña"
        },
        "panelTitle": {
          "forgot": "Restablece tu contraseña",
          "register": "Comience con Retailmaps",
          "login": "Iniciar sesión en Retailmaps"
        },
        "actions": {
          "forgotPassword": "¿Olvidaste tu contraseña",
          "register": "Registrarse",
          "startTrial": "Iniciar prueba gratis",
          "backToLogin": "Volver al login",
          "openLocalReset": "Abrir enlace local",
          "login": "Acceso",
          "sendReset": "Enviar enlace de reinicio"
        },
        "errors": {
          "loginFailed": "No se pudo iniciar sesión. Comprueba tus datos.",
          "registerFailed": "No se pudo completar el registro. Inténtalo de nuevo.",
          "companyRequired": "Se requiere el nombre de la empresa.",
          "forgotFailed": "No pudimos enviar el enlace de reinicio en este momento.",
          "forgotNotice": "Si se conoce esta dirección de correo electrónico, le hemos enviado un enlace de restablecimiento."
        },
        "legal": {
          "acceptPrefix": "Estoy de acuerdo con el",
          "and": "y el",
          "terms": "Términos y condiciones",
          "privacy": "declaración de privacidad"
        }
      },
      "landing": {
        "language": {
          "select": "Elegir idioma"
        },
        "nav": {
          "aria": "Navegación principal",
          "forWho": "Para quién",
          "howItWorks": "Cómo funciona",
          "product": "Producto",
          "price": "Precio"
        },
        "actions": {
          "login": "Iniciar sesión",
          "register": "Registrarse",
          "startFree": "Regístrate gratis",
          "start60": "60 días gratis",
          "startTrial": "Iniciar prueba gratis",
          "viewProduct": "Ver producto"
        },
        "auth": {
          "tag": "Cuenta",
          "close": "Cerrar formulario",
          "copy": {
            "loginTitle": "Bienvenido de nuevo.",
            "loginText": "Inicia sesión con tu e-mail profesional para acceder a tu mapa, inmuebles y datos.",
            "registerTitle": "Inicia tu prueba gratuita.",
            "registerText": "Crea una cuenta profesional y prueba el mapa gratis durante 60 días. Después del registro te enviaremos un e-mail para verificar tu cuenta.",
            "forgotTitle": "Recuperar acceso.",
            "forgotText": "Introduce tu e-mail. Si existe una cuenta, te enviaremos un e-mail de recuperación."
          },
          "twoFactor": {
            "help": "Introduce el código de 6 dígitos de tu app de autenticación.",
            "label": "Código 2FA",
            "back": "Volver a contraseña"
          },
          "forgot": {
            "link": "¿Olvidaste tu contraseña",
            "help": "Introduce tu e-mail. Si la cuenta existe, enviaremos un enlace para restablecer la contraseña.",
            "submit": "Enviar e-mail de recuperación",
            "back": "Volver al login",
            "openLocal": "Abrir enlace local"
          },
          "fields": {
            "email": "E-mail",
            "businessEmail": "E-mail profesional",
            "password": "Contraseña",
            "role": "Rol",
            "chooseRole": "Elige tu rol",
            "firstName": "Nombre",
            "lastName": "Apellido",
            "companyName": "Empresa"
          },
          "registerNote": "60 días gratis. No se requiere tarjeta de crédito. Primero recibirás un e-mail de verificación para activar tu cuenta.",
          "legalAccept": "Acepto la <privacy>política de privacidad</privacy> y los <terms>términos y condiciones</terms>.",
          "notices": {
            "emailVerified": "Tu e-mail ha sido confirmado. Inicia sesión para abrir Retailmaps.",
            "twoFactorRequired": "Introduce tu código 2FA para continuar.",
            "registerSuccess": "Registro correcto. Hemos enviado un e-mail de confirmación a tu dirección.",
            "forgotSent": "Si conocemos este e-mail, enviaremos un mensaje de recuperación."
          },
          "errors": {
            "loginFailed": "No se pudo iniciar sesión. Comprueba tus datos.",
            "twoFactorFailed": "No se pudo iniciar sesión. Comprueba tu código 2FA.",
            "businessEmail": "Usa un e-mail profesional. No se permiten direcciones gratuitas como Gmail, Hotmail, Outlook o iCloud.",
            "roleRequired": "Elige primero tu rol: retailer, propietario o broker.",
            "companyRequired": "Introduce el nombre de tu empresa.",
            "legalRequired": "Acepta la política de privacidad y los términos para crear tu cuenta.",
            "registerFailed": "No se pudo completar el registro. Inténtalo de nuevo.",
            "forgotFailed": "No se pudo recuperar la contraseña."
          }
        },
        "roles": {
          "options": {
            "retailer": "Retailer",
            "owner": "Propietario",
            "broker": "Broker"
          },
          "tag": "Para quién",
          "title": "Tres roles, tres formas de actuar más rápido.",
          "intro": "Expansión, gestión de cartera y asesoramiento — todo en un único entorno de mapa.",
          "retailer": {
            "kicker": "Para retailers",
            "title": "Encuentra la ubicación adecuada antes de que salga al mercado.",
            "text": "Sigue inmuebles, muestra interés de forma discreta y no pierdas más oportunidades.",
            "points": {
              "1": {
                "title": "Mostrar interés de forma proactiva",
                "text": "Registra interés en un inmueble concreto, incluso cuando todavía no está oficialmente disponible."
              },
              "2": {
                "title": "Mantente anónimo hasta el momento adecuado",
                "text": "Propietarios, brokers y retailers actuales ven tu interés anónimo y pueden contactarte cuando sea oportuno."
              },
              "3": {
                "title": "Seguir y gestionar ubicaciones",
                "text": "Guarda información de proyecto, fotos y notas <underline>por inmueble</underline> y compártelas con tu equipo. Sigue inmuebles y recibe avisos cuando haya movimiento. Así no perderás datos valiosos."
              }
            }
          },
          "owner": {
            "kicker": "Para propietarios",
            "title": "Más control sobre tu cartera, la demanda del mercado y la estrategia de alquiler.",
            "text": "Los propietarios gestionan inmuebles comerciales desde un entorno central. Publica un inmueble en alquiler con un clic, crea información de proyecto automáticamente cuando haga falta, analiza tu cartera y reparte ubicaciones entre miembros del equipo.",
            "points": {
              "1": {
                "title": "Gestiona tu cartera",
                "text": "Mantén datos de inmuebles, alquileres y contactos, documentos y notas organizados <underline>por inmueble</underline>, visibles para todo tu equipo. Añade campos y secciones y crea una base de datos inmobiliaria totalmente adaptable a tu forma de trabajar."
              },
              "2": {
                "title": "Recibe interés de retailers",
                "text": "Consulta qué retailers interesados se presentan, incluyendo sector y tipo de interés. Incluso cuando el inmueble sigue alquilado."
              },
              "3": {
                "title": "Configura alertas",
                "text": "No vuelvas a olvidar una indexación, fecha de rescisión u otro momento importante."
              }
            }
          },
          "broker": {
            "kicker": "Para brokers",
            "title": "Asesora mejor con demanda de mercado visible.",
            "text": "Combina datos de ubicación, estado de alquiler, etiquetas de retailers e interés desde un único espacio de trabajo. El asesoramiento depende menos de listas sueltas y más de datos actuales.",
            "points": {
              "1": {
                "title": "Mapa interactivo",
                "text": "Busca retailers, ajusta etiquetas a la situación actual y contribuye al retailmap open source más completo del mundo."
              },
              "2": {
                "title": "Encuentra leads y asesora mejor",
                "text": "Usa leads para trabajar de forma más precisa y asesorar a propietarios con mejor información de mercado."
              },
              "3": {
                "title": "Todos los datos inmobiliarios en un lugar",
                "text": "Consulta, analiza y comparte datos inmobiliarios con miembros del equipo, tanto en móvil como en desktop."
              },
              "4": {
                "title": "Publica inmuebles fácilmente",
                "text": "Publica inmuebles en alquiler rápidamente y ajusta la visibilidad cuando la situación lo requiera."
              }
            }
          }
        },
        "hero": {
          "eyebrow": "Retail Real Estate Intelligence",
          "title": "Retailmaps es EL mapa interactivo para inmuebles comerciales.",
          "line1": "Para y por profesionales del retail.",
          "line2": "Encuentra ubicaciones interesantes, muestra interés de forma anónima, sigue cambios y gestiona información de inmuebles desde un entorno central — en portátil y móvil.",
          "line3": "Para retailers, propietarios y brokers que quieren ver antes dónde se unen demanda, oferta y ubicación.",
          "proofs": {
            "trial": "60 días gratis. Sin compromiso.",
            "price": "Después 19 € al mes",
            "cancel": "No tienes que cancelar nada",
            "noCard": "No se requiere tarjeta de crédito",
            "noCharges": "Sin cobros automáticos",
            "afterTrial": "Después de 60 días, tú decides si quieres continuar con un plan de pago. Si no haces nada, no pagas nada.",
            "cta": "Empezar mi prueba gratis"
          }
        },
        "how": {
          "tag": "Cómo funciona",
          "title": "Trabaja desde el mapa, no desde listas sueltas.",
          "steps": {
            "1": {
              "title": "Acércate a la zona comercial",
              "text": "Consulta inmuebles, retailers y disponibilidad directamente a nivel de calle."
            },
            "2": {
              "title": "Abre un inmueble",
              "text": "Toda la información relevante en un solo lugar: datos privados, superficies, datos de alquiler, inmueble y finanzas, contactos, fotos, notas y documentos."
            },
            "3": {
              "title": "Registra interés o disponibilidad",
              "text": "Los retailers muestran interés discreto. Los brokers publican inmuebles y deciden para quién es visible la información."
            }
          }
        },
        "product": {
          "tag": "Producto",
          "title": "No solo datos. Un espacio de trabajo diario.",
          "features": {
            "1": {
              "title": "Mapa interactivo",
              "text": "Trabaja visualmente desde calles comerciales, inmuebles y zonas, no solo desde tablas."
            },
            "2": {
              "title": "Mostrar interés",
              "text": "Haz visible la demanda del mercado sin revelar estrategias sensibles."
            },
            "3": {
              "title": "Datos privados",
              "text": "Datos de alquiler, documentos, fotos y notas desde un único lugar, protegidos dentro de la organización. Sin exportaciones y con inicio de sesión de dos factores para máxima protección."
            },
            "4": {
              "title": "Contexto Street View",
              "text": "Consulta e investiga ubicaciones directamente desde la calle, junto al mapa, para entender mejor la localización."
            }
          }
        },
        "visual": {
          "tag": "En imagen",
          "title": "Contexto de ubicación sin cambiar de pantalla",
          "text": "Street View ayuda a evaluar rápidamente fachada, situación y entorno."
        },
        "price": {
          "tag": "Precio",
          "title": "Empieza fácilmente, sin un proceso largo.",
          "text": "Prueba Retailmaps gratis durante 60 días. Después de la prueba decides si continúas. El precio sigue siendo sencillo, también para equipos pequeños.",
          "cardTitle": "Retailmaps Professional",
          "amount": "19 €",
          "period": "/ mes",
          "cardText": "Prueba Retailmaps gratis durante 60 días. No se requiere tarjeta de crédito.",
          "items": {
            "1": "Mapa interactivo y lista de inmuebles",
            "2": "Interés y alertas",
            "3": "Datos de inmuebles, documentos y notas",
            "4": "Funciona en portátil y móvil"
          }
        },
        "final": {
          "title": "Ve dónde se mueve el mercado inmobiliario comercial.",
          "text": "Empieza con el mapa, sigue inmuebles relevantes y ve antes dónde se encuentran demanda, oferta y ubicación."
        },
        "images": {
          "interestStackAria": "Función móvil de interés",
          "interestSavedAlt": "Retirar interés en móvil",
          "interestAlt": "Mostrar interés por un inmueble en móvil",
          "interestCaption": "Muestra interés en tu inmueble favorito.",
          "ownerAlt": "Vista de propietario con intereses recibidos",
          "ownerCaption": "Consulta el interés recibido por inmueble y decide cuándo solicitar los datos de contacto.",
          "brokerAlt": "Panel de broker con inmuebles, retailers y leads",
          "brokerCaption": "Consulta inmuebles, retailers y leads fácilmente desde una sola vista.",
          "rentalAlt": "Información móvil del inmueble con oferta de alquiler",
          "streetViewAlt": "Mapa y Street View lado a lado"
        },
        "footer": {
          "copyright": "© 2026 Retailmaps.com",
          "security": "Datos y seguridad",
          "privacy": "Privacidad",
          "terms": "Condiciones",
          "contact": "Contacto"
        }
      },
      "retailerMap.loading.zoomInToLoad": "Acerca hasta {{zoom}} para cargar retailers",
      "retailerMap.loading.fillingStreet": "Cargando nuevos inmuebles. Puede tardar hasta 2 min...",
      "retailerMap.loading.paintingFromCenter": "Cargando inmuebles desde el centro...",
      "retailerMap.addressPlaceholder": "Introduce una dirección...",
      "retailerMap.flyButton": "Ir",
      "retailerMap.dashboard": "Panel",
      "retailerMap.print": "Imprimir",
      "retailerMap.printTooltip": "Elige como exportar el mapa",
      "retailerMap.streetView": "Street View",
      "retailerMap.openStreetView": "Abrir Street View",
      "retailerMap.closeStreetView": "Cerrar Street View",
      "propertyDetails.autosave.saving": "Guardando...",
      "propertyDetails.autosave.saved": "Guardado",
      "propertyDetails.autosave.error": "Error al guardar",
      "propertyDetails.autosave.active": "Autosave activo",
      "popup.autosaveActive": "Autosave activo",
      "common.save": "Guardar",
      "retailerMap.mobileZoomFeedback": "Zoom {{zoom}} - doble toque desde 19 para añadir",
      "retailerMap.installPrompt.title": "Abrir Retailmaps más rápido",
      "retailerMap.installPrompt.subtitle": "Añade Retailmaps a la pantalla de inicio.",
      "retailerMap.installPrompt.install": "Añadir al móvil",
      "retailerMap.installPrompt.later": "Más tarde",
      "retailerMap.iosInstall.title": "Añadir Retailmaps a la pantalla de inicio",
      "retailerMap.iosInstall.intro": "En iPhone, Safari no puede hacerlo automáticamente. Sigue estos pasos:",
      "retailerMap.iosInstall.step1": "1. Toca el botón de compartir en la parte inferior",
      "retailerMap.iosInstall.step2": "2. Elige Añadir a pantalla de inicio.",
      "retailerMap.iosInstall.step3": "3. Toca Añadir.",
      "common.understood": "Entendido",
      "propertyList.filters.country": "Pais",
      "propertyList.filters.allCountries": "Todos los paises",
      "propertyList.interest.changeFailed": "No se pudo cambiar el interés.",
      "propertyList.interest.ownGroup": "Grupo propio",
      "propertyList.interest.viaColleague": "Vía compañero",
      "propertyList.interest.withdraw": "Retirar",
      "propertyList.interest.show": "Mostrar interés",
      "propertyList.rental.stop": "Detener alquiler",
      "propertyList.rental.setForRent": "Poner en alquiler",
      "propertyList.openDetails": "Abrir detalles",
      "dashboardOverlay.shared.analysis": "Analisis",
      "dashboardOverlay.owner.properties": "Inmuebles",
      "dashboardOverlay.owner.forRent": "En alquiler",
      "dashboardOverlay.retailer.stores": "Tiendas",
      "dashboardOverlay.retailer.interests": "Intereses",
      "dashboardOverlay.broker.properties": "Inmuebles",
      "dashboardOverlay.shared.assistant": "Como funciona",
      "propertyList.columns.analysis": "Analisis",
      "ownerListings": {
        "currentOffer": "Mis locales en alquiler"
      },
      "broker": {
        "listingsTitle": "Mis ofertas de alquiler"
      },
      "retailer": {
        "listingsTitle": "Mis ofertas de alquiler",
        "contactgegevensBlock": {
          "add": "Añadir contacto",
          "remove": "Eliminar contacto",
          "phone": "Teléfono",
          "email": "Correo electrónico",
          "title": "Datos de contacto",
          "company": "Empresa",
          "name": "Nombre",
          "function": "Cargo"
        }
      },
      "listings": {
        "common": {
          "empty": "Actualmente no hay ubicaciones en alquiler.",
          "country": "País",
          "city": "Ciudad",
          "address": "Dirección",
          "askingPrice": "Precio solicitado",
          "currentRent": "Renta actual",
          "keyMoney": "Traspaso",
          "expiryDate": "Fecha de vencimiento",
          "availableFrom": "Disponible desde",
          "forRentSince": "En alquiler desde",
          "projectInformation": "Información del proyecto",
          "onBehalfOf": "En nombre de",
          "visibility": "Visibilidad",
          "broker": "Agente",
          "actions": "Acciones",
          "upload": "Subir",
          "uploadDocument": "Subir documento",
          "stopForRent": "Parar",
          "brochureFailed": "No se pudo generar o subir el folleto.",
          "projectDocuments": "Documentos del proyecto",
          "chooseFile": "Elegir archivo",
          "noFileChosen": "Ningún archivo seleccionado",
          "selectFileFirst": "Seleccione primero un archivo.",
          "uploadFailed": "Error al subir.",
          "documentDeleteFailed": "No se pudo eliminar el documento.",
          "confirmDeleteDocument": "¿Seguro que quieres eliminar \"{{name}}\"",
          "forRent": "En alquiler",
          "edit": "Editar",
          "save": "Guardar",
          "cancel": "Cancelar",
          "documentTypes": {
            "document": "Documento",
            "floorplan": "Plano",
            "brochure": "Folleto",
            "photo": "Foto"
          },
          "visibilityOptions": {
            "public": "Todos",
            "retailers": "Todos los retailers",
            "interested": "Solo interesados"
          },
          "noDocuments": "Sin documentos",
          "fileCountOne": "{{count}} archivo",
          "fileCountOther": "{{count}} archivos",
          "addedOn": "Añadido el {{date}}",
          "deleteDocumentAria": "Eliminar {{name}}",
          "onRequest": "A petición",
          "available": "Disponible",
          "surface": "Superficie",
          "total": "Total",
          "contactBroker": "Contactar con el agente de alquiler",
          "thirdPartyNotice": "Información procedente de terceros. Comprueba los detalles con el proveedor.",
          "interestAndDocuments": "Mostrar interés y recibir documentos",
          "goToInformation": "Ir a la información",
          "viewDocuments": "Ver documentos",
          "unlockForPrice": "Desbloquear gratis",
          "unlockDocuments": "Desbloquear documentos",
          "oneTimeAccessPrice": "El acceso a los documentos es gratuito actualmente.",
          "documentsSaveFailed": "Error al guardar la información del proyecto.",
          "selectDocumentFirst": "Seleccione al menos un documento primero.",
          "documentsSavedToProject": "Los documentos seleccionados se han agregado a la información de mi proyecto.",
          "saveToProjectInformation": "Añadir a la información de mi proyecto",
          "projectDocumentsHelp": "Abra documentos a través del enlace o selecciónelos para agregarlos a la información de mi proyecto.",
          "uploading": "Subiendo..."
        },
        "roles": {
          "external": "Oferta externa",
          "owner": "Propietario",
          "tenant": "Retailer",
          "provider": "Proveedor",
          "brokerOnBehalfOwner": "Corredor (en nombre del propietario)"
        }
      },
      "ownerListings.currentOffer": "Mis locales en alquiler",
      "broker.listingsTitle": "Mis ofertas de alquiler",
      "retailer.listingsTitle": "Mis ofertas de alquiler",
      "listings.common.empty": "Actualmente no hay ubicaciones en alquiler.",
      "alerts": {
        "title": "Alertas",
        "loading": "Cargando alertas...",
        "empty": "Actualmente no hay alertas que requieran atención.",
        "toggleLabel": "Alerta",
        "daysBefore": "días antes",
        "enterDaysBefore": "Introduce los días previos",
        "dismiss": "Resolver",
        "columns": {
          "property": "Inmueble",
          "field": "Campo",
          "date": "Fecha",
          "alertDate": "Fecha de alerta",
          "daysBefore": "Días antes",
          "status": "Estado",
          "actions": "Acciones"
        },
        "status": {
          "expired": "Vencida",
          "actionNeeded": "Acción necesaria",
          "upcoming": "Próxima"
        },
        "fields": {
          "expiryDate": "Fecha de vencimiento",
          "indexationDate": "Fecha de indexación",
          "terminationDate": "Fecha de terminación",
          "availableFrom": "Disponible desde",
          "startDate": "Fecha de inicio"
        }
      },
      "propertyDetails.rentalData": "Datos de alquiler",
      "propertyDetails": {
        "rentalData": "Datos de alquiler",
        "financialData": "Datos financieros",
        "ownerData": "Datos del propietario",
        "commentsDivider": "Notas",
        "contactsDivider": "Contactos",
        "photosDivider": "Fotos",
        "floorplansDivider": "Planos",
        "documentsDivider": "Documentos",
        "objectInfoDivider": "Información del inmueble",
        "floorplansInfo": "Sube planos en JPG o PNG. Estos planos se usan en los folletos. Los archivos PDF se pueden guardar en Documentos.",
        "addFloorplan": "Añadir plano",
        "removeFloorplan": "Eliminar plano",
        "addObjectInfo": "Añadir información del inmueble",
        "notesDivider": "Notas",
        "datePlaceholder": "dd-mm-aaaa",
        "addContact": "Añadir contacto",
        "removeField": "Eliminar campo",
        "removeFieldHint": "Elimina campos adicionales haciendo doble clic en el campo y eligiendo Eliminar campo.",
        "popupSettings": {
          "open": "Abrir configuracion",
          "hide": "Ocultar configuracion",
          "title": "Configuracion del popup",
          "description": "Elige que campos son visibles en el popup del mapa. Esto se aplica a campos estandar y campos adicionales propios.",
          "extraFields": "campos adicionales",
          "noExtraFields": "Todavia no hay campos adicionales en esta seccion.",
          "showInPopup": "Mostrar en popup",
          "hideInPopup": "Ocultar en popup"
        },
        "askingRentPrice": "Alquiler solicitado",
        "serviceCosts": "Gastos de servicio",
        "takeoverPrice": "Traspaso",
        "availableFrom": "Disponible desde",
        "back": "Volver al resumen",
        "projectInfoDivider": "Informacion del proyecto",
        "addProjectInfo": "Añadir información del proyecto",
        "publicData": "Datos públicos",
        "privateData": "Datos privados",
        "publicDataDivider": "Datos pblicos",
        "privateDataDivider": "Datos privados",
        "groundFloor": "Planta baja",
        "basement": "Sótano",
        "firstFloor": "1.ª planta",
        "secondFloor": "2.ª planta",
        "thirdFloor": "3.ª planta",
        "floorAreaTitle": "Superficie por planta (SBA)",
        "front": "Fachada",
        "address": "DIRECCIÓN",
        "website": "Sitio web",
        "startDate": "Fecha de inicio",
        "endDate": "Fecha de vencimiento",
        "remainingLeaseTermMonths": "Plazo de arrendamiento restante (meses)",
        "leaseTerm": "Duración del arrendamiento (años)",
        "extensionYears": "Años de prórroga",
        "rentFreePeriodMonths": "Periodo sin renta (meses)",
        "huurprijs": "Alquilar",
        "cancelDate": "Fecha de preaviso",
        "cancelNotice": "Plazo de preaviso",
        "guaranteeAmount": "Importe de la garantía",
        "entresol": "Entresuelo",
        "retailSurface": "SBA",
        "secondarySurface": "Superficie secundaria",
        "retailSpace": "Tienda",
        "secondarySpace": "Secundaria",
        "sessionExpired": "La sesión ha caducado. Inicia sesión de nuevo.",
        "autosave": {
          "saving": "Guardando...",
          "saved": "Guardado",
          "error": "Error al guardar",
          "active": "Autosave activo"
        },
        "formalTenant": "inquilino formal",
        "indexDate": "fecha de indexación",
        "floors": {
          "ground": "Planta baja",
          "basement": "Sótano",
          "second": "2do piso",
          "entresol": "Entreplanta",
          "soussol": "Semisótano",
          "first": "1er piso",
          "third": "3er piso"
        },
        "frontWidth": "Ancho de fachada",
        "detailsDivider": "Detalles"
      },
      "propertyDetails.financialData": "Datos financieros",
      "propertyDetails.ownerData": "Datos del propietario",
      "owner.ownerFields.title": "Datos del propietario",
      "owner": {
        "ownerFields": {
          "title": "Datos del propietario",
          "parentCompany": "Sociedad matriz propietaria",
          "owner": "Propietario",
          "contactPerson": "Persona de contacto",
          "email": "Correo electrónico",
          "phone": "Teléfono"
        },
        "huurgegevensBlock": {
          "title": "Datos de alquiler",
          "formeleHuurder": "Arrendatario formal",
          "huurprijs": "Alquiler",
          "ingangsdatum": "Fecha de inicio",
          "expiratiedatum": "Fecha de vencimiento",
          "resterendeLooptijdMaanden": "Plazo restante del contrato",
          "huurtermijn": "Duración del contrato",
          "verlengingsjaren": "Años de prórroga",
          "huurvrijePeriodeMaanden": "Periodo sin alquiler",
          "indexatiedatum": "Fecha de indexación",
          "opzegdatum": "Fecha de preaviso",
          "opzegtermijn": "Plazo de preaviso",
          "garantiesoort": "Tipo de garantía",
          "kiesOptie": "Elige una opción",
          "waarborgsom": "Depósito de garantía",
          "bankgarantie": "Garantía bancaria",
          "concerngarantie": "Garantía corporativa",
          "garantiebedrag": "Importe de la garantía",
          "noGuarantee": "Sin garantía",
          "resterendeLooptijd": "Plazo restante del contrato",
          "resterendeLooptijdMnd": "Plazo restante del contrato (meses)"
        },
        "financieringBlock": {
          "title": "Datos financieros",
          "koopsom": "Precio de compra",
          "aankoopdatum": "Fecha de compra",
          "actueleMarktwaarde": "Valor de mercado actual",
          "taxatiedatum": "Fecha de tasacin",
          "hypotheek": "Importe hipotecario",
          "actueleHypotheekschuld": "Deuda hipotecaria actual",
          "actueleHypotheekrente": "Tipo hipotecario actual (%)",
          "rentevastTot": "Tipo fijo hasta",
          "aflossingspercentage": "Porcentaje de amortizacin (%)",
          "looptijd": "Plazo (aos)",
          "jaarlijkseRentelasten": "Costes anuales de intereses",
          "jaarlijkseAflossing": "Amortizacin anual",
          "bank": "Banco",
          "jaarlijkseOverigeLasten": "Otros costes anuales",
          "netOperatingIncome": "Ingresos operativos netos",
          "markthuurPerM2": "Alquiler de mercado por m²",
          "servicekostenPerJaar": "Gastos de servicio al ao",
          "rentepercentage": "Tipo de interés",
          "jaar": "ao",
          "vraagprijs": "Precio solicitado"
        },
        "opmerkingen": {
          "title": "Notas",
          "none": "No se han añadido notas.",
          "unknownAuthor": "Autor desconocido",
          "add": "Añadir nota",
          "placeholder": "Escribe tu nota aquí..."
        },
        "contactgegevensBlock": {
          "title": "Contactos",
          "add": "Añadir contacto",
          "remove": "Eliminar contacto",
          "company": "Empresa",
          "name": "Nombre",
          "phone": "Teléfono",
          "email": "Correo electrónico",
          "function": "Cargo"
        }
      },
      "owner.ownerFields.parentCompany": "Sociedad matriz propietaria",
      "owner.ownerFields.owner": "Propietario",
      "owner.ownerFields.contactPerson": "Persona de contacto",
      "owner.ownerFields.email": "Correo electrónico",
      "owner.ownerFields.phone": "Teléfono",
      "owner.huurgegevensBlock.title": "Datos de alquiler",
      "owner.huurgegevensBlock.formeleHuurder": "Arrendatario formal",
      "owner.huurgegevensBlock.huurprijs": "Alquiler",
      "owner.huurgegevensBlock.ingangsdatum": "Fecha de inicio",
      "owner.huurgegevensBlock.expiratiedatum": "Fecha de vencimiento",
      "owner.huurgegevensBlock.resterendeLooptijdMaanden": "Plazo restante del contrato",
      "owner.huurgegevensBlock.huurtermijn": "Duración del contrato",
      "owner.huurgegevensBlock.verlengingsjaren": "Años de prórroga",
      "owner.huurgegevensBlock.huurvrijePeriodeMaanden": "Periodo sin alquiler",
      "owner.huurgegevensBlock.indexatiedatum": "Fecha de indexación",
      "owner.huurgegevensBlock.opzegdatum": "Fecha de preaviso",
      "owner.huurgegevensBlock.opzegtermijn": "Plazo de preaviso",
      "owner.huurgegevensBlock.garantiesoort": "Tipo de garantía",
      "owner.huurgegevensBlock.kiesOptie": "Elige una opción",
      "owner.huurgegevensBlock.waarborgsom": "Depósito de garantía",
      "owner.huurgegevensBlock.bankgarantie": "Garantía bancaria",
      "owner.huurgegevensBlock.concerngarantie": "Garantía corporativa",
      "owner.huurgegevensBlock.garantiebedrag": "Importe de la garantía",
      "owner.huurgegevensBlock.noGuarantee": "Sin garantía",
      "owner.financieringBlock.title": "Datos financieros",
      "owner.financieringBlock.koopsom": "Precio de compra",
      "owner.financieringBlock.aankoopdatum": "Fecha de compra",
      "owner.financieringBlock.actueleMarktwaarde": "Valor de mercado actual",
      "owner.financieringBlock.taxatiedatum": "Fecha de tasacin",
      "owner.financieringBlock.hypotheek": "Importe hipotecario",
      "owner.financieringBlock.actueleHypotheekschuld": "Deuda hipotecaria actual",
      "owner.financieringBlock.actueleHypotheekrente": "Tipo hipotecario actual (%)",
      "owner.financieringBlock.rentevastTot": "Tipo fijo hasta",
      "owner.financieringBlock.aflossingspercentage": "Porcentaje de amortizacin (%)",
      "owner.financieringBlock.looptijd": "Plazo (aos)",
      "owner.financieringBlock.jaarlijkseRentelasten": "Costes anuales de intereses",
      "owner.financieringBlock.jaarlijkseAflossing": "Amortizacin anual",
      "owner.financieringBlock.bank": "Banco",
      "owner.financieringBlock.jaarlijkseOverigeLasten": "Otros costes anuales",
      "owner.financieringBlock.netOperatingIncome": "Ingresos operativos netos",
      "owner.financieringBlock.markthuurPerM2": "Alquiler de mercado por m²",
      "owner.financieringBlock.servicekostenPerJaar": "Gastos de servicio al ao",
      "owner.financieringBlock.rentepercentage": "Tipo de interés",
      "owner.financieringBlock.jaar": "ao",
      "propertyDetails.commentsDivider": "Notas",
      "propertyDetails.contactsDivider": "Contactos",
      "propertyDetails.photosDivider": "Fotos",
      "propertyDetails.floorplansDivider": "Planos",
      "propertyDetails.documentsDivider": "Documentos",
      "propertyDetails.objectInfoDivider": "Información del inmueble",
      "propertyDetails.floorplansInfo": "Sube planos en JPG o PNG. Estos planos se usan en los folletos. Los archivos PDF se pueden guardar en Documentos.",
      "propertyDetails.addFloorplan": "Añadir plano",
      "propertyDetails.removeFloorplan": "Eliminar plano",
      "propertyDetails.addObjectInfo": "Añadir información del inmueble",
      "owner.opmerkingen.title": "Notas",
      "owner.opmerkingen.none": "No se han añadido notas.",
      "owner.opmerkingen.unknownAuthor": "Autor desconocido",
      "owner.opmerkingen.add": "Añadir nota",
      "owner.opmerkingen.placeholder": "Escribe tu nota aquí...",
      "listings.common.country": "País",
      "listings.common.city": "Ciudad",
      "listings.common.address": "Dirección",
      "listings.common.askingPrice": "Precio solicitado",
      "listings.common.currentRent": "Renta actual",
      "listings.common.keyMoney": "Traspaso",
      "listings.common.expiryDate": "Fecha de vencimiento",
      "listings.common.availableFrom": "Disponible desde",
      "listings.common.forRentSince": "En alquiler desde",
      "listings.common.projectInformation": "Información del proyecto",
      "listings.common.onBehalfOf": "En nombre de",
      "listings.common.visibility": "Visibilidad",
      "listings.common.broker": "Agente",
      "listings.common.actions": "Acciones",
      "listings.common.upload": "Subir",
      "listings.common.uploadDocument": "Subir documento",
      "listings.common.stopForRent": "Parar",
      "listings.common.brochureFailed": "No se pudo generar o subir el folleto.",
      "listings.common.projectDocuments": "Documentos del proyecto",
      "listings.common.chooseFile": "Elegir archivo",
      "listings.common.noFileChosen": "Ningún archivo seleccionado",
      "listings.common.selectFileFirst": "Seleccione primero un archivo.",
      "listings.common.uploadFailed": "Error al subir.",
      "listings.common.documentDeleteFailed": "No se pudo eliminar el documento.",
      "listings.common.confirmDeleteDocument": "¿Seguro que quieres eliminar \"{{name}}\"",
      "listings.common.forRent": "En alquiler",
      "listings.common.edit": "Editar",
      "listings.common.save": "Guardar",
      "listings.common.cancel": "Cancelar",
      "listings.common.documentTypes.document": "Documento",
      "listings.common.documentTypes.floorplan": "Plano",
      "listings.common.documentTypes.brochure": "Folleto",
      "listings.common.documentTypes.photo": "Foto",
      "listings.common.visibilityOptions.public": "Todos",
      "listings.common.visibilityOptions.retailers": "Todos los retailers",
      "listings.common.visibilityOptions.interested": "Solo interesados",
      "roles.owner": "Propietario",
      "roles": {
        "owner": "Propietario",
        "retailer": "Retailer",
        "broker": "Agente"
      },
      "roles.retailer": "Retailer",
      "roles.broker": "Agente",
      "common.edit": "Editar",
      "common": {
        "edit": "Editar",
        "save": "Guardar",
        "cancel": "Cancelar",
        "close": "Cerrar",
        "open": "Abrir",
        "delete": "Eliminar",
        "saved": "Guardado",
        "saving": "Guardando...",
        "saveFailed": "Error al guardar",
        "ready": "Listo",
        "active": "Activo",
        "inactive": "Inactivo",
        "canceled": "Cancelado",
        "loading": "Cargando...",
        "confirm": "Confirmar",
        "busy": "Procesando...",
        "yes": "Sí",
        "no": "No",
        "localeCode": "es-ES",
        "backToDashboard": "Volver al panel",
        "download": "Descargar",
        "back": "Volver",
        "understood": "Entendido"
      },
      "common.cancel": "Cancelar",
      "listings.common.noDocuments": "No hay documentos disponibles.",
      "listings.common.fileCountOne": "{{count}} archivo",
      "listings.common.fileCountOther": "{{count}} archivos",
      "listings.common.addedOn": "Añadido el {{date}}",
      "listings.common.deleteDocumentAria": "Eliminar {{name}}",
      "common.close": "Cerrar",
      "common.open": "Abrir",
      "common.delete": "Eliminar",
      "photos.title": "Fotos",
      "photos": {
        "title": "Fotos",
        "add": "Añadir foto",
        "remove": "Eliminar foto",
        "useAsCover": "Usar como foto de portada",
        "cover": "Portada",
        "chooseCover": "Elegir",
        "openPreview": "Abrir vista previa",
        "error": {
          "tooLarge": "supera los 10 MB y se ha omitido."
        }
      },
      "photos.add": "Añadir foto",
      "photos.remove": "Eliminar foto",
      "photos.useAsCover": "Usar como foto de portada",
      "photos.cover": "Portada",
      "photos.chooseCover": "Elegir",
      "photos.openPreview": "Abrir vista previa",
      "photos.error.tooLarge": "supera los 10 MB y se ha omitido.",
      "propertyDetails.notesDivider": "Notas",
      "retailerProperty.contactsDivider": "Contactos",
      "retailerProperty": {
        "contactsDivider": "Contactos",
        "notesDivider": "Notas",
        "photosDivider": "Fotos"
      },
      "retailerProperty.notesDivider": "Notas",
      "retailerProperty.photosDivider": "Fotos",
      "accountSettings": {
        "company": {
          "brandLogoTitle": "Marca y logo",
          "brandLogoDescription": "Usamos este logo en fichas de inmuebles y otros espacios visibles de marca.",
          "title": "Perfil de empresa",
          "description": "Datos de empresa, informacion de marca y facturacion para cuentas de agentes y propietarios. Los cambios se guardan automaticamente.",
          "readOnlyNotice": "El grupo empresarial y el dominio dirigen conexiones, visibilidad y perfiles IA, por eso son de solo lectura.",
          "companyName": "Nombre de empresa",
          "companyGroup": "Grupo empresarial",
          "domain": "Dominio",
          "legalName": "Razon social",
          "website": "Sitio web",
          "roleType": "Tipo de rol",
          "headquartersTitle": "Sede",
          "headquartersAddress": "Direccion de sede",
          "postalCode": "Codigo postal",
          "city": "Ciudad",
          "country": "Pais",
          "billingTitle": "Facturacion",
          "billingDescription": "Usamos estos datos para suscripciones, facturas y administracion financiera.",
          "billingEmail": "E-mail de facturacion",
          "invoiceReference": "Referencia factura / PO",
          "chamberOfCommerce": "Numero de registro mercantil",
          "vatNumber": "Numero de IVA",
          "billingAddress": "Direccion de facturacion",
          "taxIdType": "Tipo de identificacion fiscal",
          "taxIdValue": "Numero de IVA / fiscal",
          "taxIdPlaceholder": "ES123456789",
          "peopleTitle": "Personas",
          "peopleDescription": "Cuentas vinculadas a la misma organizacion. Los estados se basan en la suscripcion y el periodo de prueba.",
          "peopleName": "Nombre",
          "peopleEmail": "E-mail",
          "peopleRole": "Rol",
          "peopleStatus": "Estado",
          "peopleTrialUntil": "Prueba hasta",
          "peopleYou": "Tu",
          "peopleEmpty": "Todavia no se han encontrado otras cuentas dentro de esta organizacion.",
          "statusActive": "Activo",
          "statusTrial": "Prueba",
          "statusInactive": "Inactivo",
          "taxTypes": {
            "euVat": "Numero de IVA europeo",
            "gbVat": "Numero de IVA del Reino Unido",
            "auAbn": "Numero empresarial australiano (AU ABN)",
            "auArn": "Numero de referencia fiscal australiano",
            "brCnpj": "Numero CNPJ brasileno",
            "brCpf": "Numero CPF brasileno",
            "caBn": "BN canadiense",
            "caGstHst": "Numero GST/HST canadiense",
            "chVat": "Numero de IVA suizo",
            "clTin": "TIN chileno",
            "egTin": "Identificacion fiscal egipcia",
            "inGst": "Numero GST indio",
            "jpCn": "Numero corporativo japones",
            "jpRn": "Numero japones de empresa extranjera registrada",
            "mxRfc": "Numero RFC mexicano",
            "noVat": "Numero de IVA noruego",
            "nzGst": "Numero GST neozelandes",
            "sgGst": "Numero GST singapurense",
            "usEin": "EIN estadounidense",
            "zaVat": "Numero de IVA sudafricano"
          }
        },
        "title": "Configuracion",
        "tabs": {
          "profile": "Perfil",
          "company": "Empresa",
          "preferences": "Preferencias",
          "security": "Seguridad",
          "billing": "Facturacion"
        },
        "descriptions": {
          "profile": "Datos de contacto y rol de tu cuenta.",
          "company": "Datos de empresa, marca y facturacion.",
          "preferences": "Idioma, moneda, unidades y visualizacion del mapa.",
          "security": "Inicio de sesion y seguridad de la cuenta.",
          "billing": "Suscripcion, uso y compras puntuales."
        },
        "personal": {
          "title": "Perfil personal",
          "description": "Datos de contacto y rol de tu cuenta. Los cambios se guardan automaticamente.",
          "firstName": "Nombre",
          "lastName": "Apellidos",
          "role": "Cargo",
          "phone": "Telefono",
          "email": "Correo electronico",
          "linkedin": "LinkedIn",
          "address": "Direccion"
        }
      },
      "settingsPanel": {
        "common": {
          "saving": "Guardando...",
          "saved": "Guardado",
          "saveFailed": "Error al guardar",
          "ready": "Listo"
        },
        "regional": {
          "title": "Configuracion regional",
          "subtitle": "Elige como funcionan el idioma, la moneda y las unidades. Se usan automaticamente los datos del navegador y la region.",
          "language": "Idioma",
          "currency": "Moneda",
          "units": "Unidades",
          "autoLanguage": "Automatico ({{language}})",
          "autoCurrency": "Automatico ({{currency}})",
          "autoUnits": "Automatico ({{units}})",
          "metric": "Metrico",
          "imperial": "Imperial",
          "detectedRegion": "Region detectada: {{region}}"
        },
        "map": {
          "title": "Configuracion del mapa",
          "subtitle": "Ajusta colores, bordes, etiquetas y visibilidad del mapa.",
          "invalidOrSaveFailed": "Color no valido o error al guardar.",
          "highlight": {
            "retailTitle": "Intensidad de resaltado de locales retail",
            "retailDescription": "Determina cuanto destacan los locales retail en el mapa.",
            "otherTitle": "Intensidad de otros inmuebles",
            "otherDescription": "Determina la visibilidad de otros inmuebles como capa de fondo.",
            "opacity": "Intensidad: {{value}}",
            "title": "Intensidad de resaltado",
            "description": "Controla la fuerza con la que se destacan los polígonos y las selecciones activos."
          },
          "markerFont": {
            "title": "Tamano del texto de marcadores",
            "description": "Determina el tamano de nombres y etiquetas en el mapa.",
            "size": "Escala: {{value}}"
          },
          "preview": {
            "title": "Vista previa",
            "description": "Una vista rapida de como se veran tus ajustes del mapa."
          },
          "colors": {
            "retail": {
              "label": "Color retail",
              "description": "Color base para locales retail en el mapa."
            },
            "other": {
              "label": "Otros inmuebles",
              "description": "Color base para otros inmuebles en el mapa."
            },
            "retailOutline": {
              "label": "Contorno de inmuebles activos",
              "description": "Color del borde para inmuebles activos y resaltados."
            },
            "otherOutline": {
              "label": "Contorno de otros inmuebles",
              "description": "Color del borde para inmuebles no activos."
            },
            "markerName": {
              "label": "Color del nombre del marcador",
              "description": "Color del texto de las etiquetas en el mapa."
            },
            "markerHover": {
              "label": "Color al pasar el cursor",
              "description": "Color de fondo al pasar por encima de las etiquetas."
            },
            "forRentMarker": {
              "label": "Marcador en alquiler",
              "description": "Color del texto de marcadores de inmuebles en alquiler."
            }
          }
        },
        "mailTest": {
          "title": "Correo de prueba",
          "subtitle": "Comprueba si la configuracion de correo funciona correctamente.",
          "send": "Enviar correo de prueba",
          "sending": "Enviando...",
          "status": "Estado: {{status}}",
          "providerActive": "{{provider}} activo",
          "devPreviewOnly": "Solo vista previa dev",
          "from": "De: {{value}}",
          "testRecipient": "Destinatario de prueba: {{value}}",
          "internalInboxes": "Buzones internos: {{value}}",
          "notConfigured": "No configurado",
          "noneConfigured": "Ninguno configurado",
          "previewLogged": "{{provider}} aun no esta completamente configurado. El correo de prueba se registro como vista previa para {{recipient}}.",
          "sentMessage": "Correo de prueba enviado a {{recipient}} mediante {{provider}}.",
          "failed": "No se pudo enviar el correo de prueba.",
          "yourInbox": "tu buzon"
        },
        "dashboardOverlay": {
          "shared": {
            "assistant": "Como funciona"
          }
        },
        "retailerMap": {
          "loading": {
            "zoomInToLoad": "Acerca hasta {{zoom}} para cargar retailers",
            "fillingStreet": "Cargando nuevos inmuebles. Puede tardar hasta 2 min...",
            "paintingFromCenter": "Cargando inmuebles desde el centro..."
          }
        },
        "branding": {
          "title": "Marca del corredor",
          "subtitle": "Sube tu logotipo. Se mostrará con sus listados."
        }
      },
      "mapSettings": {
        "backToDashboard": "Volver al panel",
        "title": "Configuracin del mapa",
        "subtitle": "Ajusta los colores de edificios y nombres de marcadores",
        "fetchWarn": "No se pudieron cargar los ajustes",
        "noUser": "No se encontr ningn usuario.",
        "invalidHex": "Color hex no vlido. Usa p. ej. #0077cc.",
        "saved": "Ajustes guardados.",
        "saveFailed": "No se pudo guardar.",
        "retailColorLabel": "Color de edificios retail",
        "retailColorPicker": "Elegir color de edificios retail",
        "otherColorLabel": "Color de otros edificios",
        "otherColorPicker": "Elegir color de otros edificios",
        "opacityLabel": "Opacidad de otros edificios: {{value}}",
        "opacityAria": "Control de opacidad",
        "markerNameColorLabel": "Color del nombre del marcador",
        "markerNameColorPicker": "Elegir color del nombre del marcador",
        "markerNameHoverColorLabel": "Color hover del marcador",
        "markerNameHoverColorPicker": "Elegir color hover del marcador",
        "previewRetail": "Resaltado retail",
        "previewOther": "Otros edificios",
        "previewMarkerNormal": "Marcador normal",
        "previewMarkerHover": "Marcador hover",
        "saving": "Guardando...",
        "save": "Guardar ajustes",
        "reset": "Restablecer valores",
        "cancel": "Cancelar",
        "hexHelp": "Usa hex, p. ej. #0077cc",
        "activeOutlineLabel": "Contorno de inmuebles activos",
        "otherOutlineLabel": "Contorno de otros inmuebles",
        "hoverColorLabel": "Color al pasar el cursor"
      },
      "account.noLogo": "Aun no hay logotipo",
      "listings.common.uploading": "Subiendo...",
      "extraFieldsBlock.addField": "Agregar campo",
      "extraFieldsBlock.addHeader": "Agregar seccion",
      "extraSections.fieldLabel": "Nombre del campo",
      "extraSections.fieldType": "Tipo",
      "extraSections.addField": "Agregar campo",
      "extraSections.addSection": "Agregar seccion",
      "extraSections.newTab": "Nueva pestana",
      "extraSections.tabName": "Nombre de la pestana",
      "extraSections.renameTab": "Renombrar pestana",
      "extraSections.untitledTab": "Nombre de la pestana",
      "extraSections.sectionName": "Nombre de la seccion",
      "rentalData.addField": "Agregar campo",
      "financialData.addField": "Agregar campo",
      "propertyDetails.removeField": "Eliminar campo",
      "propertyDetails.removeFieldHint": "Elimina campos adicionales haciendo doble clic en el campo y eligiendo Eliminar campo.",
      "propertyDetails.detailsDivider": "Detalles",
      "common.saved": "Guardado",
      "common.saving": "Guardando...",
      "common.saveFailed": "Error al guardar",
      "common.ready": "Listo",
      "common.active": "Activo",
      "common.inactive": "Inactivo",
      "common.canceled": "Cancelado",
      "common.loading": "Cargando...",
      "accountSettings.title": "Configuracion",
      "accountSettings.tabs.profile": "Perfil",
      "accountSettings.tabs.company": "Empresa",
      "accountSettings.tabs.preferences": "Preferencias",
      "accountSettings.tabs.security": "Seguridad",
      "accountSettings.tabs.billing": "Facturacion",
      "accountSettings.descriptions.profile": "Datos de contacto y rol de tu cuenta.",
      "accountSettings.descriptions.company": "Datos de empresa, marca y facturacion.",
      "accountSettings.descriptions.preferences": "Idioma, moneda, unidades y visualizacion del mapa.",
      "accountSettings.descriptions.security": "Inicio de sesion y seguridad de la cuenta.",
      "accountSettings.descriptions.billing": "Suscripcion, uso y compras puntuales.",
      "accountSettings.personal.title": "Perfil personal",
      "accountSettings.personal.description": "Datos de contacto y rol de tu cuenta. Los cambios se guardan automaticamente.",
      "accountSettings.personal.firstName": "Nombre",
      "accountSettings.personal.lastName": "Apellidos",
      "accountSettings.personal.role": "Cargo",
      "accountSettings.personal.phone": "Telefono",
      "accountSettings.personal.email": "Correo electronico",
      "accountSettings.personal.linkedin": "LinkedIn",
      "accountSettings.personal.address": "Direccion",
      "accountSettings.company.title": "Perfil de empresa",
      "accountSettings.company.description": "Datos de empresa, informacion de marca y facturacion para cuentas de agentes y propietarios. Los cambios se guardan automaticamente.",
      "accountSettings.company.brandLogoTitle": "Marca y logo",
      "accountSettings.company.brandLogoDescription": "Usamos este logo en fichas de inmuebles y otros espacios visibles de marca.",
      "accountSettings.company.readOnlyNotice": "El grupo empresarial y el dominio dirigen conexiones, visibilidad y perfiles IA, por eso son de solo lectura.",
      "accountSettings.company.companyName": "Nombre de empresa",
      "accountSettings.company.companyGroup": "Grupo empresarial",
      "accountSettings.company.domain": "Dominio",
      "accountSettings.company.legalName": "Razon social",
      "accountSettings.company.website": "Sitio web",
      "accountSettings.company.roleType": "Tipo de rol",
      "accountSettings.company.headquartersTitle": "Sede",
      "accountSettings.company.headquartersAddress": "Direccion de sede",
      "accountSettings.company.postalCode": "Codigo postal",
      "accountSettings.company.city": "Ciudad",
      "accountSettings.company.country": "Pais",
      "accountSettings.company.billingTitle": "Facturacion",
      "accountSettings.company.billingDescription": "Usamos estos datos para suscripciones, facturas y administracion financiera.",
      "accountSettings.company.billingEmail": "E-mail de facturacion",
      "accountSettings.company.invoiceReference": "Referencia factura / PO",
      "accountSettings.company.chamberOfCommerce": "Numero de registro mercantil",
      "accountSettings.company.vatNumber": "Numero de IVA",
      "accountSettings.company.billingAddress": "Direccion de facturacion",
      "accountSettings.company.taxIdType": "Tipo de identificacion fiscal",
      "accountSettings.company.taxIdValue": "Numero de IVA / fiscal",
      "accountSettings.company.taxIdPlaceholder": "ES123456789",
      "accountSettings.company.peopleTitle": "Personas",
      "accountSettings.company.peopleDescription": "Cuentas vinculadas a la misma organizacion. Los estados se basan en la suscripcion y el periodo de prueba.",
      "accountSettings.company.peopleName": "Nombre",
      "accountSettings.company.peopleEmail": "E-mail",
      "accountSettings.company.peopleRole": "Rol",
      "accountSettings.company.peopleStatus": "Estado",
      "accountSettings.company.peopleTrialUntil": "Prueba hasta",
      "accountSettings.company.peopleYou": "Tu",
      "accountSettings.company.peopleEmpty": "Todavia no se han encontrado otras cuentas dentro de esta organizacion.",
      "accountSettings.company.statusTrial": "Prueba",
      "accountSettings.company.statusActive": "Activo",
      "accountSettings.company.statusInactive": "Inactivo",
      "accountSettings.company.taxTypes.euVat": "Numero de IVA europeo",
      "accountSettings.company.taxTypes.gbVat": "Numero de IVA del Reino Unido",
      "accountSettings.company.taxTypes.auAbn": "Numero empresarial australiano (AU ABN)",
      "accountSettings.company.taxTypes.auArn": "Numero de referencia fiscal australiano",
      "accountSettings.company.taxTypes.brCnpj": "Numero CNPJ brasileno",
      "accountSettings.company.taxTypes.brCpf": "Numero CPF brasileno",
      "accountSettings.company.taxTypes.caBn": "BN canadiense",
      "accountSettings.company.taxTypes.caGstHst": "Numero GST/HST canadiense",
      "accountSettings.company.taxTypes.chVat": "Numero de IVA suizo",
      "accountSettings.company.taxTypes.clTin": "TIN chileno",
      "accountSettings.company.taxTypes.egTin": "Identificacion fiscal egipcia",
      "accountSettings.company.taxTypes.inGst": "Numero GST indio",
      "accountSettings.company.taxTypes.jpCn": "Numero corporativo japones",
      "accountSettings.company.taxTypes.jpRn": "Numero japones de empresa extranjera registrada",
      "accountSettings.company.taxTypes.mxRfc": "Numero RFC mexicano",
      "accountSettings.company.taxTypes.noVat": "Numero de IVA noruego",
      "accountSettings.company.taxTypes.nzGst": "Numero GST neozelandes",
      "accountSettings.company.taxTypes.sgGst": "Numero GST singapurense",
      "accountSettings.company.taxTypes.usEin": "EIN estadounidense",
      "accountSettings.company.taxTypes.zaVat": "Numero de IVA sudafricano",
      "security.twoFactor.title": "Autenticacion de dos factores",
      "security": {
        "twoFactor": {
          "title": "Autenticacion de dos factores",
          "subtitle": "Protege tu cuenta con un codigo de 6 digitos desde una app de autenticacion.",
          "setup": "Configurar 2FA",
          "scanQr": "Escanea el codigo QR con tu app de autenticacion. Si no funciona, usa el codigo de configuracion manualmente.",
          "openAuthenticator": "Abrir en app de autenticacion",
          "sixDigitCode": "Codigo de 6 digitos",
          "enable": "Activar 2FA",
          "disableWarning": "Desactiva 2FA solo si estas seguro de que esta cuenta esta protegida de otra forma.",
          "code": "Codigo 2FA",
          "disable": "Desactivar 2FA"
        },
        "password": "Contrasena",
        "errors": {
          "enableFailed": "No se pudo habilitar 2FA.",
          "setupFailed": "No se pudo iniciar la configuración 2FA.",
          "statusFailed": "No se pudo cargar el estado de seguridad.",
          "disableFailed": "No se pudo desactivar 2FA."
        },
        "notices": {
          "enabled": "2FA se ha habilitado para su cuenta.",
          "disabled": "2FA ha sido deshabilitado para su cuenta."
        }
      },
      "security.twoFactor.subtitle": "Protege tu cuenta con un codigo de 6 digitos desde una app de autenticacion.",
      "security.twoFactor.setup": "Configurar 2FA",
      "security.twoFactor.scanQr": "Escanea el codigo QR con tu app de autenticacion. Si no funciona, usa el codigo de configuracion manualmente.",
      "security.twoFactor.openAuthenticator": "Abrir en app de autenticacion",
      "security.twoFactor.sixDigitCode": "Codigo de 6 digitos",
      "security.twoFactor.enable": "Activar 2FA",
      "security.twoFactor.disableWarning": "Desactiva 2FA solo si estas seguro de que esta cuenta esta protegida de otra forma.",
      "security.password": "Contrasena",
      "security.twoFactor.code": "Codigo 2FA",
      "security.twoFactor.disable": "Desactivar 2FA",
      "settingsPanel.regional.title": "Configuracion regional",
      "settingsPanel.regional.subtitle": "Elige como funcionan el idioma, la moneda y las unidades. Se usan automaticamente los datos del navegador y la region.",
      "settingsPanel.regional.language": "Idioma",
      "settingsPanel.regional.currency": "Moneda",
      "settingsPanel.regional.units": "Unidades",
      "settingsPanel.regional.autoLanguage": "Automatico ({{language}})",
      "settingsPanel.regional.autoCurrency": "Automatico ({{currency}})",
      "settingsPanel.regional.autoUnits": "Automatico ({{units}})",
      "settingsPanel.regional.metric": "Metrico",
      "settingsPanel.regional.imperial": "Imperial",
      "settingsPanel.regional.detectedRegion": "Region detectada: {{region}}",
      "settingsPanel.map.title": "Configuracion del mapa",
      "settingsPanel.map.subtitle": "Ajusta colores, bordes, etiquetas y visibilidad del mapa.",
      "settingsPanel.map.invalidOrSaveFailed": "Color no valido o error al guardar.",
      "settingsPanel.map.highlight.retailTitle": "Intensidad de resaltado de locales retail",
      "settingsPanel.map.highlight.retailDescription": "Determina cuanto destacan los locales retail en el mapa.",
      "settingsPanel.map.highlight.otherTitle": "Intensidad de otros inmuebles",
      "settingsPanel.map.highlight.otherDescription": "Determina la visibilidad de otros inmuebles como capa de fondo.",
      "settingsPanel.map.highlight.opacity": "Intensidad: {{value}}",
      "settingsPanel.map.markerFont.title": "Tamano del texto de marcadores",
      "settingsPanel.map.markerFont.description": "Determina el tamano de nombres y etiquetas en el mapa.",
      "settingsPanel.map.markerFont.size": "Escala: {{value}}",
      "settingsPanel.map.preview.title": "Vista previa",
      "settingsPanel.map.preview.description": "Una vista rapida de como se veran tus ajustes del mapa.",
      "settingsPanel.common.saved": "Guardado",
      "settingsPanel.common.saving": "Guardando...",
      "settingsPanel.common.saveFailed": "Error al guardar",
      "settingsPanel.common.ready": "Listo",
      "billing.title": "Facturacion",
      "billing": {
        "title": "Facturacion",
        "recurring": {
          "title": "Suscripciones y uso",
          "description": "Costes recurrentes de tu suscripcion, ubicaciones en alquiler activas y otros componentes mensuales."
        },
        "baseSubscription": "Suscripcion base",
        "baseSubscriptionDescription": "Acceso a Retailmaps y funciones basicas.",
        "forRent": "En alquiler",
        "forRentDescription": "Ubicaciones en alquiler activas habilitadas por esta cuenta de usuario.",
        "oneOff": {
          "title": "Compras puntuales",
          "description": "Costes puntuales, como desbloqueo de documentos u otros eventos de facturacion independientes.",
          "noneTitle": "No hay compras puntuales en este periodo",
          "noneDescription": "Cuando se complete una compra puntual, aparecera aqui automaticamente.",
          "none": "No hay compras puntuales en este periodo."
        },
        "totals": {
          "subscriptions": "Suscripciones",
          "trialDiscount": "Descuento prueba",
          "oneOff": "Compras puntuales",
          "vat": "IVA",
          "totalInclVat": "Total incl. IVA",
          "totalDue": "Total adeudado"
        },
        "history": {
          "title": "Historial de facturacion",
          "description": "Eventos de facturacion recientes y transacciones puntuales de esta cuenta.",
          "none": "Aun no se han encontrado eventos de facturacion para esta cuenta.",
          "documentUnlock": "Desbloqueo de documento"
        },
        "columns": {
          "date": "Fecha",
          "description": "Descripcion",
          "status": "Estado",
          "amount": "Importe",
          "quantity": "Cant.",
          "unitPrice": "Unidad",
          "total": "Total"
        },
        "description": "Todo para {{account}} en una vista: suscripciones, compras puntuales y costes abiertos de {{period}}.",
        "yourAccount": "tu cuenta",
        "currentMonth": "este mes",
        "currentPeriod": "Periodo actual",
        "downloadPdf": "Descargar factura (PDF)",
        "preparingPdf": "Preparando PDF...",
        "amountDueThisMonth": "Importe a pagar este mes",
        "subscriptionStatus": "Estado de suscripcion",
        "subscriptionActive": "Activo",
        "subscriptionInactive": "Inactivo",
        "nextRenewal": "Proxima renovacion",
        "stripeCustomer": "Cliente Stripe",
        "paidSince": "Pagado desde",
        "downloadError": "Error al descargar la factura.",
        "loadError": "No se pudieron cargar los datos de facturación.",
        "summary": {
          "title": "Resumen"
        },
        "invoice": {
          "invoiceDate": "fecha de factura",
          "overview": "Resumen de facturas {{period}}",
          "period": "Período",
          "statusOpen": "Estado: abierto",
          "billTo": "Cobrar a",
          "footer": "Esta descripción general se generó a partir de los datos de facturación actuales de Retailmaps para este período."
        },
        "infoNotice": "Los detalles del usuario ahora se encuentran en Perfil y Empresa. Aquí solo mostramos lo que es financieramente relevante: costos de suscripción recurrentes, compras únicas y el total de este mes.",
        "user": "Usuario",
        "subscription": "Suscripción",
        "perMonth": "por mes",
        "trialUntil": "Período de prueba hasta",
        "trialEndedOn": "El juicio terminó el",
        "totalMonthlyCosts": "Costos mensuales totales",
        "extraProperties": "Propiedades adicionales",
        "noticePeriod": "Plazo de notificación: 1 mes. La suscripción permanece activa a menos que la canceles.",
        "renewsOn": "Renueva en {{date}}",
        "includesProperties": "incluye propiedades {{count}}",
        "monthlyCosts": "Costos mensuales",
        "cancelSubscription": "Cancelar suscripción",
        "cancellationScheduled": "Tu suscripción finalizará el {{date}}. Tus datos permanecerán archivados y podrán restaurarse al reactivarla.",
        "cancelDialog": {
          "title": "Cancelar suscripción",
          "retention": "La suscripción finalizará al terminar el periodo pagado actual. No se elimina nada: cartera, documentos, historial y facturas quedan archivados para reactivarlos.",
          "endsOn": "El acceso permanece activo hasta {{date}}.",
          "ownerProperties": "Mis propiedades",
          "retailerStores": "Mis tiendas",
          "returnPortfolio": "Devolver a la cartera de la organización (sin asignar)",
          "transferColleague": "Transferir a un compañero",
          "listings": "Anuncios de alquiler activos",
          "archiveListings": "Detener y archivar en la fecha final",
          "transferListings": "Transferir a un compañero",
          "interests": "Los intereses activos se retirarán en la fecha final. El historial protegido permanecerá archivado.",
          "contacts": "Los datos de contacto comprados y las facturas se conservan como historial y se restauran al reactivar la cuenta.",
          "recipient": "Compañero receptor",
          "confirm": "Programar cancelación"
        },
        "totalProperties": "Propiedades totales"
      },
      "billing.recurring.title": "Suscripciones y uso",
      "billing.recurring.description": "Costes recurrentes de tu suscripcion, ubicaciones en alquiler activas y otros componentes mensuales.",
      "billing.baseSubscription": "Suscripcion base",
      "billing.baseSubscriptionDescription": "Acceso a Retailmaps y funciones basicas.",
      "billing.forRent": "En alquiler",
      "billing.forRentDescription": "Ubicaciones en alquiler activas habilitadas por esta cuenta de usuario.",
      "billing.oneOff.title": "Compras puntuales",
      "billing.oneOff.description": "Costes puntuales, como desbloqueo de documentos u otros eventos de facturacion independientes.",
      "billing.oneOff.noneTitle": "No hay compras puntuales en este periodo",
      "billing.oneOff.noneDescription": "Cuando se complete una compra puntual, aparecera aqui automaticamente.",
      "billing.oneOff.none": "No hay compras puntuales en este periodo.",
      "billing.totals.subscriptions": "Suscripciones",
      "billing.totals.trialDiscount": "Descuento prueba",
      "billing.totals.oneOff": "Compras puntuales",
      "billing.totals.vat": "IVA",
      "billing.totals.totalInclVat": "Total incl. IVA",
      "billing.history.title": "Historial de facturacion",
      "billing.history.description": "Eventos de facturacion recientes y transacciones puntuales de esta cuenta.",
      "billing.history.none": "Aun no se han encontrado eventos de facturacion para esta cuenta.",
      "billing.history.documentUnlock": "Desbloqueo de documento",
      "billing.columns.date": "Fecha",
      "billing.columns.description": "Descripcion",
      "billing.columns.status": "Estado",
      "billing.columns.amount": "Importe",
      "billing.columns.quantity": "Cant.",
      "billing.columns.unitPrice": "Unidad",
      "billing.columns.total": "Total",
      "billing.description": "Todo para {{account}} en una vista: suscripciones, compras puntuales y costes abiertos de {{period}}.",
      "billing.yourAccount": "tu cuenta",
      "billing.currentMonth": "este mes",
      "billing.currentPeriod": "Periodo actual",
      "billing.downloadPdf": "Descargar factura (PDF)",
      "billing.preparingPdf": "Preparando PDF...",
      "billing.amountDueThisMonth": "Importe a pagar este mes",
      "billing.subscriptionStatus": "Estado de suscripcion",
      "billing.subscriptionActive": "Activo",
      "billing.subscriptionInactive": "Inactivo",
      "billing.nextRenewal": "Proxima renovacion",
      "billing.stripeCustomer": "Cliente Stripe",
      "billing.paidSince": "Pagado desde",
      "settingsPanel.mailTest.subtitle": "Comprueba si la configuracion de correo funciona correctamente.",
      "settingsPanel.mailTest.previewLogged": "{{provider}} aun no esta completamente configurado. El correo de prueba se registro como vista previa para {{recipient}}.",
      "settingsPanel.mailTest.yourInbox": "tu buzon",
      "propertyDetails.datePlaceholder": "dd-mm-aaaa",
      "propertyDetails.addContact": "Añadir contacto",
      "propertyDetails.popupSettings.open": "Abrir configuracion",
      "propertyDetails.popupSettings.hide": "Ocultar configuracion",
      "propertyDetails.popupSettings.title": "Configuracion del popup",
      "propertyDetails.popupSettings.description": "Elige que campos son visibles en el popup del mapa. Esto se aplica a campos estandar y campos adicionales propios.",
      "propertyDetails.popupSettings.extraFields": "campos adicionales",
      "propertyDetails.popupSettings.noExtraFields": "Todavia no hay campos adicionales en esta seccion.",
      "propertyDetails.popupSettings.showInPopup": "Mostrar en popup",
      "propertyDetails.popupSettings.hideInPopup": "Ocultar en popup",
      "brokerProperty.askingPrice": "Precio solicitado",
      "brokerProperty": {
        "askingPrice": "Precio solicitado"
      },
      "owner.financieringBlock.vraagprijs": "Precio solicitado",
      "propertyDetails.askingRentPrice": "Alquiler solicitado",
      "propertyDetails.serviceCosts": "Gastos de servicio",
      "propertyDetails.takeoverPrice": "Traspaso",
      "propertyDetails.availableFrom": "Disponible desde",
      "propertyDetails.back": "Volver al resumen",
      "propertyDetails.projectInfoDivider": "Informacion del proyecto",
      "propertyDetails.addProjectInfo": "Añadir información del proyecto",
      "extraSections": {
        "addField": "Agregar campo",
        "addSection": "Agregar seccion",
        "newTab": "Nueva pestana",
        "fieldLabel": "Nombre del campo",
        "fieldType": "Tipo",
        "tabName": "Nombre de la pestana",
        "renameTab": "Renombrar pestana",
        "untitledTab": "Nombre de la pestana",
        "sectionName": "Nombre de la seccion"
      },
      "extraFields.addField": "Agregar campo",
      "extraFields": {
        "addField": "Agregar campo",
        "addSection": "Agregar seccion"
      },
      "extraFields.addSection": "Agregar seccion",
      "extraFieldsBlock": {
        "addField": "Agregar campo",
        "addHeader": "Agregar seccion",
        "title": "Campos adicionales"
      },
      "extraFieldsBlock.title": "Campos adicionales",
      "retailerMap.downloadSvg": "Descargar SVG",
      "retailerMap.downloadSvgTooltip": "Descargar el mapa como archivo SVG",
      "retailerMap.printMenu.paper": "Imprimir en papel",
      "retailerMap.printMenu.pdf": "Guardar como PDF",
      "retailerMap.printMenu.svg": "Descargar imagen del mapa SVG",
      "help": {
        "tab": "Como funciona",
        "title": "Como funciona",
        "subtitle": "Explicaciones breves para acciones habituales en Retailmaps.",
        "howItWorks": "Como funciona",
        "goodToKnow": "Conviene saber",
        "empty": "Aun no hay temas para este rol.",
        "actions": {
          "openListings": "Abrir alquileres",
          "openInterests": "Abrir intereses",
          "openProperties": "Abrir inmuebles",
          "openAlerts": "Abrir alertas",
          "openRequests": "Abrir solicitudes",
          "openAnalysis": "Abrir analisis"
        },
        "topics": {
          "ownerForRent": {
            "title": "Poner un inmueble en alquiler",
            "summary": "Publica un inmueble como oferta de alquiler y anade la informacion correcta.",
            "step1": "Abre la pestana Inmuebles.",
            "step2": "Busca el inmueble que quieres ofrecer.",
            "step3": "Haz clic en Poner en alquiler.",
            "step4": "Abre En alquiler y completa precio solicitado, traspaso y fecha de disponibilidad.",
            "step5": "Comprueba los datos ya copiados, como alquiler actual y fecha de vencimiento.",
            "step6": "Anade informacion del proyecto. Puedes subir una brochure o generar informacion del proyecto automaticamente.",
            "note1": "Como propietario no necesitas elegir visibilidad. El inmueble se muestra automaticamente como oferta de alquiler.",
            "note2": "La informacion automatica del proyecto usa los datos introducidos, fotos, planos y una imagen del mapa."
          },
          "retailerStore": {
            "title": "Vincular una tienda a mis tiendas",
            "summary": "Anade una ubicacion existente a tu vista de tiendas.",
            "step1": "Abre la pestana Tiendas.",
            "step2": "Busca la tienda por pais, ciudad o direccion.",
            "step3": "Seleccionate a ti mismo o a un companero como retail manager.",
            "step4": "La tienda aparecera despues en Mis tiendas.",
            "note1": "Solo puedes poner una tienda en alquiler despues de vincularla a Mis tiendas.",
            "note2": "La ubicacion aun no esta en el mapa Anade primero un nuevo marcador."
          },
          "newMarker": {
            "title": "Anadir un nuevo marcador",
            "summary": "Anade una nueva ubicacion al mapa.",
            "step1": "Abre el mapa.",
            "step2": "Escritorio: haz doble clic en un lugar vacio del mapa.",
            "step3": "Movil: toca dos veces un lugar vacio del mapa.",
            "step4": "Rellena despues los datos de la ubicacion.",
            "note1": "Comprueba primero si la ubicacion ya esta en el mapa. En ese caso, usa el marcador existente.",
            "note2": "Si colocas mal un nuevo marcador, puedes eliminarlo tu mismo si lo has anadido tu."
          },
          "moveDeleteMarker": {
            "title": "Mover o eliminar un marcador",
            "summary": "Corrige la posicion de un marcador o elimina un marcador que has anadido tu.",
            "step1": "Escritorio: haz clic derecho en el marcador.",
            "step2": "Movil: manten pulsado el marcador.",
            "step3": "Elige Mover marcador y haz clic o toca la nueva ubicacion.",
            "step4": "Elige Eliminar marcador para quitar un marcador que has anadido tu.",
            "note1": "Los marcadores existentes y los anadidos por otros usuarios solo puede eliminarlos un admin.",
            "note2": "Despues de moverlo, vuelve a abrir el marcador si quieres comprobar o editar los datos."
          },
          "mobile": {
            "title": "Usar Retailmaps en movil",
            "summary": "Anade Retailmaps a tu pantalla de inicio para acceder mas rapido.",
            "step1": "Abre www.retailmaps.com en tu telefono.",
            "step2": "iPhone o iPad: usa Safari, toca Compartir y elige Anadir a pantalla de inicio.",
            "step3": "Chrome en Android: toca los tres puntos y elige Instalar app o Anadir a pantalla de inicio.",
            "step4": "Samsung Internet: abre el menu y elige Anadir pagina a o Anadir a pantalla de inicio.",
            "step5": "Pon al acceso directo el nombre Retailmaps y toca Anadir.",
            "step6": "Abre despues Retailmaps desde el icono de la pantalla de inicio.",
            "note1": "En iPhone esto normalmente funciona con Safari. Chrome en iPhone normalmente no lo permite directamente.",
            "note2": "Inicias sesion con la misma cuenta que en escritorio."
          },
          "security": {
            "title": "Activar o desactivar autenticacion de dos factores",
            "summary": "Protege tu cuenta con un codigo extra de una app de autenticacion.",
            "step1": "Abre Configuracion.",
            "step2": "Ve a Seguridad o Autenticacion de dos factores.",
            "step3": "Haz clic en Activar 2FA.",
            "step4": "Abre una app de autenticacion, como Google Authenticator, Microsoft Authenticator o 1Password.",
            "step5": "Escanea el codigo QR con la app de autenticacion.",
            "step6": "Introduce el codigo de 6 digitos de la app y confirma.",
            "step7": "A partir de ahora inicias sesion con tu contrasena mas el codigo de 6 digitos.",
            "step8": "Quieres desactivar 2FA Vuelve a Configuracion y haz clic en Desactivar 2FA.",
            "note1": "Conserva bien el acceso a tu app de autenticacion. Sin ella puede ser dificil iniciar sesion.",
            "note2": "El codigo cambia aproximadamente cada 30 segundos. Usa siempre el codigo mas reciente."
          },
          "popupMedia": {
            "title": "Fotos, documentos y planos",
            "summary": "Anade archivos a una ubicacion.",
            "step1": "Abre la popup de la ubicacion.",
            "step2": "Ve a Datos privados.",
            "step3": "Elige Fotos, Documentos o Planos.",
            "step4": "Anade un archivo o toma una foto directamente desde movil.",
            "note1": "Las fotos se muestran como miniaturas.",
            "note2": "Los planos funcionan mejor como imagen, por ejemplo jpg o png."
          },
          "alerts": {
            "title": "Configurar alertas",
            "summary": "Configura un recordatorio para fechas importantes.",
            "step1": "Abre los detalles del inmueble o la popup.",
            "step2": "Introduce una fecha, como vencimiento, indexacion o preaviso.",
            "step3": "Marca Alert.",
            "step4": "Introduce cuantos dias antes quieres recibir la alerta.",
            "step5": "Consulta las alertas activas en la pestana Alertas.",
            "note1": "Las alertas activas se muestran en la pestana Alertas.",
            "note2": "En la fecha del recordatorio recibes automaticamente un e-mail."
          },
          "ownerRequests": {
            "title": "Ver solicitudes",
            "summary": "Ve quien esta interesado en tu oferta de alquiler o inmueble.",
            "step1": "Abre la pestana Solicitudes.",
            "step2": "Comprueba a que inmueble pertenece la solicitud.",
            "step3": "Revisa que datos del solicitante estan disponibles.",
            "step4": "Abre la solicitud para mas detalles.",
            "note1": "Las solicitudes aparecen cuando retailers muestran interes por una ubicacion retail, incluso si no esta anunciada activamente en alquiler."
          },
          "retailerRequests": {
            "title": "Ver solicitudes",
            "summary": "Ve que retailers estan interesados en tus ubicaciones.",
            "step1": "Abre la pestana Solicitudes.",
            "step2": "Ve que retailer ha mostrado interes.",
            "step3": "Comprueba a que ubicacion pertenece la solicitud.",
            "step4": "Haz clic en la direccion para abrir la ubicacion en el mapa.",
            "note1": "Las solicitudes son intereses entrantes en ubicaciones vinculadas a tu organizacion."
          },
          "interest": {
            "title": "Mostrar interes",
            "summary": "Haz visible que estas interesado en una ubicacion concreta.",
            "step1": "Abre en el mapa la ubicacion que te interesa.",
            "step2": "Haz clic en la popup en Mostrar interes.",
            "step3": "Comprueba la confirmacion y completa posibles pasos de acceso.",
            "step4": "La ubicacion aparecera despues en la pestana Intereses.",
            "step5": "El interes permanece activo hasta que lo retires tu.",
            "note1": "Tu interes se guarda en el inmueble concreto, no solo en tu propia vista.",
            "note2": "El inquilino actual, el propietario y brokers relevantes pueden ver el interes si tienen acceso."
          },
          "analysis": {
            "title": "Usar analisis",
            "summary": "Compara ubicaciones y consulta calculos importantes.",
            "step1": "Selecciona un inmueble o tienda en tu vista.",
            "step2": "Elige la accion Analisis.",
            "step3": "Anade varias ubicaciones si hace falta.",
            "step4": "Abre Analisis para ver, entre otros, alquiler por m2, WALT, plazo restante e indicadores."
          }
        }
      },
      "dashboardOverlay": {
        "shared": {
          "assistant": "Como funciona",
          "forRent": "En alquiler",
          "requests": "Solicitudes",
          "alerts": "Alertas",
          "analysis": "Analisis",
          "settings": "Configuracion"
        },
        "broker": {
          "properties": "Inmuebles"
        },
        "owner": {
          "properties": "Inmuebles",
          "forRent": "En alquiler"
        },
        "retailer": {
          "stores": "Tiendas",
          "interests": "Intereses"
        },
        "admin": {
          "aiQueue": "Cola de IA",
          "ops": "operaciones",
          "mail": "Correo",
          "administration": "Administración",
          "statistics": "Estadística"
        }
      },
      "settingsPanel.dashboardOverlay.shared.assistant": "Como funciona",
      "myProperties.nr": "Núm.",
      "myProperties.city": "Ciudad",
      "myProperties.address": "Direccion",
      "myProperties.tenant": "Inquilino",
      "myProperties.link": "Detalles",
      "myProperties.status": "Estado",
      "myProperties.actions": "Acciones",
      "myProperties.assetManager": "Gestor de activos",
      "myProperties.noAssetManager": "- ninguno -",
      "myProperties.noPaidSubscriptionSuffix": " - sin suscripcion activa",
      "myProperties.noResults": "Sin resultados",
      "myProperties.ownProperties": "Mis inmuebles",
      "myProperties.groupProperties": "Cartera de la organizacion",
      "myProperties.stopRent": "Detener alquiler",
      "myProperties.setForRent": "Poner en alquiler",
      "myProperties.street": "Calle",
      "myProperties.allCities": "Todas las ciudades",
      "myProperties.allStreets": "Todas las calles",
      "myProperties.status.forRent": "En alquiler",
      "myProperties.status.rented": "Alquilado",
      "myProperties.bulk.assignToSelection": "Asignar seleccion",
      "myProperties.bulk.onlyUnassigned": "Solo sin asset manager",
      "myProperties.bulk.selectAllVisible": "Seleccionar visibles",
      "myProperties.bulk.noManagerSelected": "Elige un asset manager.",
      "myProperties.bulk.noSelection": "No hay inmuebles seleccionados.",
      "myProperties.loading": "Cargando...",
      "myProperties.assignToMe": "Asignarme",
      "myProperties.analysis": "Analisis",
      "myProperties.view": "Ver",
      "myProperties.assignError": "No se pudo asignar.",
      "myProperties.assignRequiresPaidSubscription": "Este usuario necesita una suscripcion activa.",
      "myProperties.importPortfolio": "Importar cartera",
      "myProperties.remove": "Eliminar",
      "myProperties.confirmRemove": "Seguro que quieres eliminar este inmueble de la cartera de la organizacion Si ningun companero tambien tiene este inmueble, desaparecera por completo de la organizacion.",
      "myProperties.removeFailed": "No se pudo eliminar.",
      "myProperties.rentToggleError": "No se pudo cambiar el estado de alquiler.",
      "popup2.addedState": "Añadido",
      "popup2.addToMyProperties": "Añadir a mis inmuebles",
      "popup2.front": "Fachada",
      "popup2.groundFloor": "Planta baja",
      "popup2.basement": "Sótano",
      "popup2.firstFloor": "1.ª planta",
      "popup2.secondFloor": "2.ª planta",
      "popup2.thirdFloor": "3.ª planta",
      "popup2.entresol": "Entresuelo",
      "popup2.soussol": "Sótano",
      "popup2.retailSpace": "Tienda",
      "popup2.secondarySpace": "Secundaria",
      "popup2.adding": "Añadiendo...",
      "owner.contactgegevensBlock.title": "Contactos",
      "owner.contactgegevensBlock.add": "Añadir contacto",
      "owner.contactgegevensBlock.remove": "Eliminar contacto",
      "owner.contactgegevensBlock.company": "Empresa",
      "owner.contactgegevensBlock.name": "Nombre",
      "owner.contactgegevensBlock.phone": "Teléfono",
      "owner.contactgegevensBlock.email": "Correo electrónico",
      "owner.contactgegevensBlock.function": "Cargo",
      "retailerMap": {
        "dashboard": "Panel",
        "loading": {
          "zoomInToLoad": "Acerca hasta {{zoom}} para cargar retailers",
          "fillingStreet": "Cargando nuevos inmuebles. Puede tardar hasta 2 min...",
          "paintingFromCenter": "Cargando inmuebles desde el centro...",
          "stores": "Cargando tiendas..."
        },
        "addressPlaceholder": "Introduce una dirección...",
        "flyButton": "Ir",
        "errors": {
          "noUserInfo": "No hay información de usuario disponible.",
          "unknownRoleSubscription": "Rol de usuario desconocido. No se pudo iniciar la suscripción.",
          "invalidSession": "No se encontró ninguna sesión válida. Por favor inicia sesión nuevamente."
        },
        "printTooltip": "Elige como exportar el mapa",
        "print": "Imprimir",
        "openStreetView": "Abrir Street View",
        "closeStreetView": "Cerrar Street View",
        "streetView": "Street View",
        "zoomIn": "Dar un golpe de zoom",
        "zoomOut": "alejar",
        "highlightEdit": {
          "selectHint": "Haga clic en un resaltado azul para editarlo.",
          "dragHint": "Arrastre puntos, elimine puntos o agregue un punto.",
          "reset": "Reiniciar",
          "merge": "Unir",
          "adminHint": "Herramienta de administración para formas de construcción incorrectas.",
          "addPoint": "Agregar punto",
          "mergeNow": "Fusionarse ahora",
          "edit": "Editar resaltado",
          "buildingId": "Identificación del edificio",
          "disable": "Desactivar el modo de edición",
          "mergeHint": "Seleccione al menos dos resaltados azules. Seleccionado: {{count}}",
          "removePoint": "Quitar punto",
          "removeCorrection": "Eliminar corrección",
          "restore": "Restaurar resaltado",
          "makeOneShape": "hacer una forma"
        },
        "mobileZoomFeedback": "Zoom {{zoom}} - doble toque desde 19 para añadir",
        "installPrompt": {
          "title": "Abrir Retailmaps más rápido",
          "subtitle": "Añade Retailmaps a la pantalla de inicio.",
          "install": "Añadir al móvil",
          "later": "Más tarde"
        },
        "iosInstall": {
          "title": "Añadir Retailmaps a la pantalla de inicio",
          "intro": "En iPhone, Safari no puede hacerlo automáticamente. Sigue estos pasos:",
          "step1": "1. Toca el botón de compartir en la parte inferior",
          "step2": "2. Elige Añadir a pantalla de inicio.",
          "step3": "3. Toca Añadir."
        },
        "downloadSvg": "Descargar SVG",
        "downloadSvgTooltip": "Descargar el mapa como archivo SVG",
        "printMenu": {
          "paper": "Imprimir en papel",
          "pdf": "Guardar como PDF",
          "svg": "Descargar imagen del mapa SVG"
        }
      },
      "popup2.publicData": "Datos públicos",
      "popup2.privateData": "Datos privados",
      "popup2.surface": "Superficie",
      "settingsPanel.retailerMap.loading.zoomInToLoad": "Acerca hasta {{zoom}} para cargar retailers",
      "settingsPanel.retailerMap.loading.fillingStreet": "Cargando nuevos inmuebles. Puede tardar hasta 2 min...",
      "settingsPanel.retailerMap.loading.paintingFromCenter": "Cargando inmuebles desde el centro...",
      "interestButton.showInterest": "Mostrar interés",
      "interestButton.withdraw": "Retirar",
      "popup2.address": "Dirección",
      "popup2.city": "Ciudad",
      "popup2.website": "Sitio web",
      "popup2.unit": "Unidad",
      "popup2.m2": "m",
      "popup2.ft2": "ft",
      "popup2.forRent": "En alquiler",
      "propertyDetails.publicData": "Datos públicos",
      "propertyDetails.privateData": "Datos privados",
      "propertyDetails.publicDataDivider": "Datos pblicos",
      "propertyDetails.privateDataDivider": "Datos privados",
      "interestButton": {
        "showInterest": "Mostrar interés",
        "withdraw": "Retirar",
        "invalidSession": "No hay sesión válida."
      },
      "propertyDetails.groundFloor": "Planta baja",
      "propertyDetails.basement": "Sótano",
      "propertyDetails.firstFloor": "1.ª planta",
      "propertyDetails.secondFloor": "2.ª planta",
      "propertyDetails.thirdFloor": "3.ª planta",
      "propertyDetails.front": "Fachada",
      "retailer.contactgegevensBlock.add": "Añadir contacto",
      "retailer.contactgegevensBlock.remove": "Eliminar contacto",
      "retailer.contactgegevensBlock.phone": "Teléfono",
      "retailer.contactgegevensBlock.email": "Correo electrónico",
      "brokerContact.add": "Añadir contacto",
      "brokerContact": {
        "add": "Añadir contacto",
        "remove": "Eliminar contacto",
        "company": "Empresa",
        "name": "Nombre",
        "phone": "Teléfono",
        "email": "Correo electrónico",
        "position": "Cargo",
        "ownerContacts": "contactos del propietario",
        "retailerContacts": "Contactos minoristas"
      },
      "brokerContact.remove": "Eliminar contacto",
      "owner.huurgegevensBlock.resterendeLooptijd": "Plazo restante del contrato",
      "owner.huurgegevensBlock.resterendeLooptijdMnd": "Plazo restante del contrato (meses)",
      "propertyFields": {
        "shop": "Tienda",
        "storage": "Almacén",
        "secondary": "Secundaria"
      },
      "propertyList": {
        "filters": {
          "country": "Pais",
          "allCountries": "Todos los paises",
          "city": "Ciudad",
          "select": "Seleccionar...",
          "street": "Calle",
          "typeStreet": "Escribe una calle...",
          "retailer": "Retailer",
          "retailerExampleShort": "Retailer",
          "searchAddress": "Buscar direccion",
          "scopeHint": "Elige una calle o busca por retailer para cargar la lista de inmuebles.",
          "chooseCityFirst": "Elige una ciudad primero",
          "cityRequiredForStreet": "Elija una ciudad antes de seleccionar calles.",
          "retailerExample": "P.ej. Suministro de trajes",
          "noStreets": "No se encontraron calles"
        },
        "columns": {
          "number": "N.",
          "country": "Pais",
          "city": "Ciudad",
          "address": "Direccion",
          "retailer": "Retailer",
          "status": "Estado",
          "interests": "Intereses",
          "purchased": "Comprado",
          "details": "Detalles",
          "analysis": "Analisis",
          "rental": "Alquiler",
          "showInterest": "Mostrar interés"
        },
        "status": {
          "forRent": "En alquiler",
          "notForRent": "No en alquiler"
        },
        "rental": {
          "setForRent": "Poner en alquiler",
          "stop": "Detener alquiler",
          "stopForRent": "Detener alquiler"
        },
        "pagination": {
          "rowsPerPage": "Filas por pagina"
        },
        "interests": {
          "none": "Sin intereses",
          "date": "Fecha",
          "interestedParty": "Interesado",
          "type": "Tipo",
          "branch": "Sector",
          "stores": "Tiendas",
          "contactDetails": "Datos de contacto",
          "protected": "Oculto",
          "interest": "Interes",
          "generalInterest": "Interes general",
          "forRentInterest": "Interes en alquiler",
          "downloadContact": "Descargar datos de contacto",
          "buyContact": "Comprar datos de contacto (EUR 9)"
        },
        "contactPurchase": {
          "title": "Comprar datos de contacto",
          "description": "Aprueba el precio unico de EUR 9 para desbloquear estos datos de contacto.",
          "invoiceNotice": "EUR 9 se anadiran a tu proxima factura mensual de tarjeta de credito.",
          "buy": "Aprobar EUR 9 y desbloquear"
        },
        "openDetails": "Abrir detalles",
        "loading": "Cargando inmuebles...",
        "noPropertiesFound": "No se encontraron inmuebles",
        "interest": {
          "changeFailed": "No se pudo cambiar el interés.",
          "ownGroup": "Grupo propio",
          "viaColleague": "Vía compañero",
          "withdraw": "Retirar",
          "show": "Mostrar interés"
        }
      },
      "analysis": {
        "title": "Analisis",
        "empty": "Anade inmuebles al analisis para ver las cifras.",
        "summary": {
          "totalRent": "Renta anual total",
          "totalAskingRent": "Renta solicitada total",
          "weightedArea": "m2 ponderados",
          "avgRentPerM2": "Renta media/m2/ano",
          "avgAskingRentPerM2": "Renta solicitada media/m2/ano",
          "wault": "WAULT"
        },
        "metrics": {
          "waltYears": "WALT: {{value}} anos",
          "expiry12": "Vencimiento 12m: {{value}}",
          "expiry24": "Vencimiento 24m: {{value}}",
          "expiry36": "Vencimiento 36m: {{value}}"
        },
        "values": {
          "years": "{{value}} anos"
        },
        "actions": {
          "clear": "Limpiar analisis",
          "collapseSurfaces": "Contraer superficies",
          "expandSurfaces": "Expandir superficies",
          "remove": "Eliminar"
        },
        "table": {
          "property": "Inmueble",
          "tenant": "Inquilino",
          "front": "Frente",
          "annualRent": "Renta anual",
          "askingRent": "Renta solicitada",
          "weightedM2": "m2 ponderados",
          "rentPerM2": "Renta/m2",
          "askingRentPerM2": "Renta solicitada/m2",
          "expiry": "Vencimiento",
          "remainingTerm": "Plazo restante",
          "remainingMonths": "Meses restantes",
          "rentCoverage": "Cobertura de renta",
          "interestCoverage": "Cobertura de intereses",
          "guaranteeMonths": "Meses de garantia",
          "surfaces": "Superficies",
          "weightedArea": "m2 ponderados",
          "ltv": "LTV"
        },
        "surfaces": {
          "title": "Superficies",
          "helper": "Por defecto: retail 100 %, secundaria 50 %. Ajusta esto por planta aqui.",
          "weightedTotal": "Total ponderado",
          "grossM2": "{{value}} m2 brutos",
          "weightedM2Value": "= {{value}} m2",
          "empty": "No se encontraron superficies. Completa las superficies de tienda y secundarias en los datos publicos.",
          "button": "Superficies"
        },
        "surfaceFields": {
          "front": "Fachada",
          "winkel": "Tienda",
          "secundair": "Secundaria",
          "begane_grond_winkel": "Planta baja tienda",
          "begane_grond_secundair": "Planta baja secundaria",
          "kelder_winkel": "Sotano tienda",
          "kelder_secundair": "Sotano secundaria",
          "shop": "Tienda",
          "secondary": "Secundaria",
          "beganeGrondSecundair": "Planta baja secundaria",
          "kelderSecundair": "Sotano secundaria",
          "beganeGrondWinkel": "Comercio en planta baja",
          "eersteVerdiepingSecundair": "1er piso secundario",
          "kelderWinkel": "Venta minorista en el sótano",
          "eersteVerdiepingWinkel": "comercio 1er piso",
          "derdeVerdiepingWinkel": "comercio minorista en el tercer piso",
          "tweedeVerdiepingWinkel": "comercio 2do piso",
          "derdeVerdiepingSecundair": "3er piso secundario",
          "tweedeVerdiepingSecundair": "2do piso secundario",
          "soussolSecundair": "Secundaria en terreno inferior",
          "entresolSecundair": "Entresuelo secundario",
          "entresolWinkel": "Venta al por menor en entresuelo",
          "soussolWinkel": "Comercio minorista en planta baja"
        },
        "chips": {
          "wault": "WAULT: {{value}} anos",
          "expiry12": "Vencimiento 12m: {{value}}",
          "expiry24": "Vencimiento 24m: {{value}}",
          "expiry36": "Vencimiento 36m: {{value}}"
        }
      },
      "dashboardOverlay.shared.forRent": "En alquiler",
      "dashboardOverlay.shared.requests": "Solicitudes",
      "dashboardOverlay.shared.alerts": "Alertas",
      "dashboardOverlay.shared.settings": "Configuracion",
      "propertyList.filters.city": "Ciudad",
      "propertyList.filters.select": "Seleccionar...",
      "propertyList.filters.street": "Calle",
      "propertyList.filters.typeStreet": "Escribe una calle...",
      "propertyList.filters.retailer": "Retailer",
      "propertyList.filters.retailerExampleShort": "Retailer",
      "propertyList.filters.searchAddress": "Buscar direccion",
      "propertyList.filters.scopeHint": "Elige una calle o busca por retailer para cargar la lista de inmuebles.",
      "propertyList.columns.number": "N.",
      "propertyList.columns.country": "Pais",
      "propertyList.columns.city": "Ciudad",
      "propertyList.columns.address": "Direccion",
      "propertyList.columns.retailer": "Retailer",
      "propertyList.columns.status": "Estado",
      "propertyList.columns.interests": "Intereses",
      "propertyList.columns.purchased": "Comprado",
      "propertyList.columns.details": "Detalles",
      "propertyList.columns.rental": "Alquiler",
      "propertyList.status.forRent": "En alquiler",
      "propertyList.status.notForRent": "No en alquiler",
      "propertyList.pagination.rowsPerPage": "Filas por pagina",
      "propertyList.interests.none": "Sin intereses",
      "propertyList.interests.date": "Fecha",
      "propertyList.interests.interestedParty": "Interesado",
      "propertyList.interests.type": "Tipo",
      "propertyList.interests.branch": "Sector",
      "propertyList.interests.stores": "Tiendas",
      "propertyList.interests.contactDetails": "Datos de contacto",
      "propertyList.interests.protected": "Oculto",
      "propertyList.interests.interest": "Interes",
      "propertyList.interests.generalInterest": "Interes general",
      "propertyList.interests.forRentInterest": "Interes en alquiler",
      "propertyList.interests.downloadContact": "Descargar datos de contacto",
      "propertyList.interests.buyContact": "Comprar datos de contacto (EUR 9)",
      "propertyList.contactPurchase.title": "Comprar datos de contacto",
      "propertyList.contactPurchase.description": "Estas comprando los datos de contacto de este interes.",
      "propertyList.contactPurchase.invoiceNotice": "Los costes se facturan por separado.",
      "propertyList.contactPurchase.buy": "Comprar datos de contacto",
      "propertyList.loading": "Cargando inmuebles...",
      "propertyList.noPropertiesFound": "No se encontraron inmuebles",
      "analysis.title": "Analisis",
      "analysis.empty": "Anade inmuebles al analisis para ver las cifras.",
      "analysis.summary.totalRent": "Renta anual total",
      "analysis.summary.totalAskingRent": "Renta solicitada total",
      "analysis.summary.weightedArea": "m2 ponderados",
      "analysis.summary.avgRentPerM2": "Renta media/m2/ano",
      "analysis.summary.avgAskingRentPerM2": "Renta solicitada media/m2/ano",
      "analysis.metrics.waltYears": "WALT: {{value}} anos",
      "analysis.metrics.expiry12": "Vencimiento 12m: {{value}}",
      "analysis.metrics.expiry24": "Vencimiento 24m: {{value}}",
      "analysis.metrics.expiry36": "Vencimiento 36m: {{value}}",
      "analysis.values.years": "{{value}} anos",
      "analysis.actions.clear": "Limpiar analisis",
      "analysis.actions.collapseSurfaces": "Contraer superficies",
      "analysis.actions.expandSurfaces": "Expandir superficies",
      "analysis.table.property": "Inmueble",
      "analysis.table.tenant": "Inquilino",
      "analysis.table.front": "Frente",
      "analysis.table.annualRent": "Renta anual",
      "analysis.table.askingRent": "Renta solicitada",
      "analysis.table.weightedM2": "m2 ponderados",
      "analysis.table.rentPerM2": "Renta/m2",
      "analysis.table.askingRentPerM2": "Renta solicitada/m2",
      "analysis.table.expiry": "Vencimiento",
      "analysis.table.remainingTerm": "Plazo restante",
      "analysis.table.remainingMonths": "Meses restantes",
      "analysis.table.rentCoverage": "Cobertura de renta",
      "analysis.table.interestCoverage": "Cobertura de intereses",
      "analysis.table.guaranteeMonths": "Meses de garantia",
      "analysis.table.surfaces": "Superficies",
      "analysis.surfaces.title": "Superficies",
      "analysis.surfaces.helper": "Por defecto: retail 100 %, secundaria 50 %. Ajusta esto por planta aqui.",
      "analysis.surfaces.weightedTotal": "Total ponderado",
      "analysis.surfaces.grossM2": "{{value}} m2 brutos",
      "analysis.surfaces.weightedM2Value": "= {{value}} m2",
      "analysis.surfaces.empty": "No se encontraron superficies. Completa las superficies de tienda y secundarias en los datos publicos.",
      "analysis.surfaceFields.front": "Fachada",
      "analysis.surfaceFields.winkel": "Tienda",
      "analysis.surfaceFields.secundair": "Secundaria",
      "analysis.surfaceFields.begane_grond_winkel": "Planta baja tienda",
      "analysis.surfaceFields.begane_grond_secundair": "Planta baja secundaria",
      "analysis.surfaceFields.kelder_winkel": "Sotano tienda",
      "analysis.surfaceFields.kelder_secundair": "Sotano secundaria",
      "common.busy": "Procesando...",
      "propertyList.rental.stopForRent": "Detener alquiler",
      "analysis.summary.wault": "WAULT",
      "analysis.actions.remove": "Eliminar",
      "analysis.chips.wault": "WAULT: {{value}} anos",
      "analysis.chips.expiry12": "Vencimiento 12m: {{value}}",
      "analysis.chips.expiry24": "Vencimiento 24m: {{value}}",
      "analysis.chips.expiry36": "Vencimiento 36m: {{value}}",
      "analysis.table.weightedArea": "m2 ponderados",
      "analysis.table.ltv": "LTV",
      "analysis.surfaces.button": "Superficies",
      "analysis.surfaceFields.shop": "Tienda",
      "analysis.surfaceFields.secondary": "Secundaria",
      "successStripe.title": "Pago completado",
      "successStripe.waitTitle": "Pago recibido",
      "successStripe.waitDescription": "Estamos finalizando la activación. Puede tardar unos segundos. Mantén esta pantalla abierta; volverás automáticamente cuando todo esté listo.",
      "successStripe.stepPayment": "Pago confirmado",
      "successStripe.stepActivation": "La cuenta o el anuncio se está activando",
      "successStripe.stepRedirect": "Volverás automáticamente a Retailmaps",
      "successStripe.back": "Volver",
      "successStripe.processing": "Procesando...",
      "successStripe.missingToken": "No se ha encontrado un token válido. Inicia sesión de nuevo.",
      "successStripe.missingParams": "Faltan parámetros en la URL.",
      "successStripe.unknownError": "Error desconocido",
      "successStripe.missingSessionId": "Falta session_id.",
      "successStripe.missingRetailerId": "Falta retailerId.",
      "successStripe.paymentReceivedActivating": "¡Pago recibido! Se está activando la suscripción...",
      "successStripe.retailerListingActive": "La tienda ya está disponible para alquilar y es visible públicamente.",
      "successStripe.ownerListingActive": "El inmueble ya está disponible para alquilar.",
      "successStripe.subscriptionActivating": "Se está activando la suscripción...",
      "successStripe.subscriptionNotConfirmed": "No se ha podido confirmar la suscripción.",
      "successStripe.subscriptionActive": "Suscripción activa.",
      "successStripe.extraPropertyAdded": "El inmueble adicional se ha añadido correctamente.",
      "successStripe.contactAccessUnlocked": "Pago recibido. Estamos preparando los datos de contacto y te llevaremos al inmueble correspondiente.",
      "successStripe.interestProcessed": "El interés se ha procesado correctamente.",
      "successStripe.retailerSubscriptionActivating": "Se está activando la suscripción de retailer...",
      "successStripe.retailerSubscriptionActive": "La suscripción de retailer está activa.",
      "successStripe.brokerSubscriptionActivating": "¡Pago recibido! Se está activando la suscripción de agente inmobiliario...",
      "successStripe.invalidType": "Tipo desconocido o no válido.",
      "successStripe.genericFailure": "Se ha producido un error: {{message}}",
      "common.yes": "Sí",
      "common.no": "No",
      "common.localeCode": "es-ES",
      "common.backToDashboard": "Volver al panel",
      "common.download": "Descargar",
      "common.back": "Volver",
      "propertyDetails.address": "Dirección",
      "propertyDetails.website": "Sitio web",
      "propertyDetails.formalTenant": "Arrendatario contractual",
      "propertyDetails.huurprijs": "Renta",
      "propertyDetails.startDate": "Fecha de inicio",
      "propertyDetails.endDate": "Fecha de vencimiento",
      "propertyDetails.remainingLeaseTermMonths": "Plazo de arrendamiento restante (meses)",
      "propertyDetails.leaseTerm": "Duración del arrendamiento (años)",
      "propertyDetails.extensionYears": "Años de prórroga",
      "propertyDetails.rentFreePeriodMonths": "Periodo sin renta (meses)",
      "propertyDetails.indexDate": "Fecha de actualización",
      "propertyDetails.cancelDate": "Fecha de preaviso",
      "propertyDetails.cancelNotice": "Plazo de preaviso",
      "propertyDetails.guaranteeAmount": "Importe de la garantía",
      "propertyDetails.entresol": "Entreplanta",
      "propertyDetails.retailSurface": "SBA",
      "propertyDetails.secondarySurface": "Superficie secundaria",
      "propertyDetails.retailSpace": "Tienda",
      "propertyDetails.secondarySpace": "Secundaria",
      "propertyDetails.sessionExpired": "La sesión ha caducado. Inicia sesión de nuevo.",
      "propertyDetails.floors.ground": "Planta baja",
      "propertyDetails.floors.basement": "Sótano",
      "propertyDetails.floors.first": "Primera planta",
      "propertyDetails.floors.second": "Segunda planta",
      "propertyDetails.floors.third": "Tercera planta",
      "propertyDetails.floors.entresol": "Entreplanta",
      "propertyDetails.floors.soussol": "Semisótano",
      "propertyDetails.frontWidth": "Ancho de fachada",
      "subscriptionRequired.title": "Se requiere una suscripción",
      "subscriptionRequired.body": "Para anunciar un inmueble en alquiler en Retailmaps, necesitas una suscripción activa.",
      "subscriptionRequired.details": "Con una suscripción puedes anunciar inmuebles en alquiler y hacerlos visibles para todos los usuarios de la plataforma o para grupos seleccionados.",
      "subscriptionRequired.activate": "Activar suscripción",
      "successStripe": {
        "title": "Pago completado",
        "waitTitle": "Pago recibido",
        "waitDescription": "Estamos finalizando la activación. Puede tardar unos segundos. Mantén esta pantalla abierta; volverás automáticamente cuando todo esté listo.",
        "stepPayment": "Pago confirmado",
        "stepActivation": "La cuenta o el anuncio se está activando",
        "stepRedirect": "Volverás automáticamente a Retailmaps",
        "back": "Volver",
        "processing": "Procesando...",
        "missingToken": "No se ha encontrado un token válido. Inicia sesión de nuevo.",
        "missingParams": "Faltan parámetros en la URL.",
        "unknownError": "Error desconocido",
        "missingSessionId": "Falta session_id.",
        "missingRetailerId": "Falta retailerId.",
        "paymentReceivedActivating": "¡Pago recibido! Se está activando la suscripción...",
        "retailerListingActive": "La tienda ya está disponible para alquilar y es visible públicamente.",
        "ownerListingActive": "El inmueble ya está disponible para alquilar.",
        "subscriptionActivating": "Se está activando la suscripción...",
        "subscriptionNotConfirmed": "No se ha podido confirmar la suscripción.",
        "subscriptionActive": "Suscripción activa.",
        "extraPropertyAdded": "El inmueble adicional se ha añadido correctamente.",
        "contactAccessUnlocked": "Pago recibido. Estamos preparando los datos de contacto y te llevaremos al inmueble correspondiente.",
        "interestProcessed": "El interés se ha procesado correctamente.",
        "retailerSubscriptionActivating": "Se está activando la suscripción de retailer...",
        "retailerSubscriptionActive": "La suscripción de retailer está activa.",
        "brokerSubscriptionActivating": "¡Pago recibido! Se está activando la suscripción de agente inmobiliario...",
        "invalidType": "Tipo desconocido o no válido.",
        "genericFailure": "Se ha producido un error: {{message}}"
      },
      "requests": {
        "title": "Solicitudes",
        "loading": "Cargando...",
        "columns": {
          "city": "Ciudad",
          "tenant": "Inquilino",
          "forRent": "En alquiler",
          "total": "Total",
          "purchased": "Comprado",
          "date": "Fecha",
          "interestedParty": "Interesado",
          "type": "Tipo",
          "actions": "Acciones",
          "number": "Núm.",
          "address": "DIRECCIÓN"
        },
        "overview": "Descripción general",
        "profile": {
          "shops": "Tiendas",
          "branch": "Rama",
          "countries": "Países",
          "revenue": "Ganancia"
        },
        "none": "No se recibieron solicitudes para sus propiedades.",
        "interestTypes": {
          "forRent": "Interes en alquiler",
          "general": "Interes general"
        },
        "downloadLabel": "Descargar datos de contacto",
        "shielded": "Oculto",
        "payToViewLabel": "Comprar datos de contacto (49€)",
        "total": "Total",
        "purchased": "Comprado",
        "date": "Fecha",
        "interestedParty": "Interesado",
        "payToView": "💳 Comprar datos de contacto (49€)",
        "downloadContact": "Descargar datos de contacto",
        "download": "📥 Descargar datos de contacto",
        "interests": "Intereses",
        "removeError": "Error al eliminar la solicitud.",
        "empty": "Sin solicitudes",
        "removeFailed": "Error al eliminar la solicitud.",
        "hidden": "Oculto",
        "buyContact": "Comprar datos de contacto (49 €)",
        "branches": {
          "foodAndBeverage": "Alimentos y bebidas",
          "beautyAndPersonalCare": "Belleza y cuidado personal",
          "electronics": "Electrónica",
          "footwear": "Calzado",
          "booksAndMedia": "Libros y medios",
          "sportsAndOutdoor": "Deportes y aire libre",
          "fashionAndApparel": "Moda y confección",
          "homeAndLiving": "Hogar y vida",
          "jewelleryAndWatches": "Joyas y relojes",
          "supermarketAndGrocery": "Supermercado y tienda de comestibles"
        }
      },
      "stores": {
        "common": {
          "status": "Estado",
          "details": "Detalles",
          "number": "Núm.",
          "storeName": "Nombre de la tienda",
          "brokerOnBehalfOfOwner": "Corredor (en nombre del propietario)",
          "byWho": "por quien",
          "retailManager": "gerente minorista"
        },
        "status": {
          "forRent": "En alquiler",
          "rented": "Alquilado"
        },
        "actions": {
          "stopRent": "Detener alquiler",
          "setForRent": "Poner en alquiler"
        },
        "filters": {
          "allCountries": "Todos los paises",
          "allCities": "Todas las ciudades"
        },
        "sections": {
          "mine": "Mis tiendas",
          "organization": "Tiendas de mi organización"
        },
        "messages": {
          "assignFailed": "No se pudo asignar.",
          "addFailed": "No se pudo agregar la tienda.",
          "addedToPortfolio": "Tienda agregada a su cartera.",
          "removeFailed": "La tienda no se pudo eliminar.",
          "toggleRentFailed": "Error al cambiar el estado del alquiler.",
          "subscriptionRequired": "Se requiere una suscripción activa para esta acción."
        }
      },
      "admin": {
        "common": {
          "today": "Hoy",
          "openModule": "Abrir módulo",
          "refreshing": "Refrescante...",
          "loading": "Cargando...",
          "week": "Semana",
          "month": "Mes",
          "year": "Año",
          "unknown": "desconocido",
          "noData": "Aún no hay datos disponibles.",
          "userLoadFailed": "No se pudo cargar el usuario."
        },
        "dashboard": {
          "aiReview": "revisión de IA"
        },
        "home": {
          "subtitle": "Capa de control central para correo, revisión de IA, análisis y administración. Aquí es donde se unen agentes, equipos y procesos operativos.",
          "heroStats": {
            "openReview": "Abrir revisión",
            "activeLanguages": "Idiomas activos",
            "inbox7d": "Bandeja de entrada 7d",
            "agentLanes": "Carriles de agentes"
          },
          "title": "Operaciones administrativas de Retailmaps",
          "sections": {
            "alerts": "Alertas operativas",
            "snapshot": "Instantánea operativa"
          },
          "alerts": {
            "reviewBacklog": {
              "text": "Los hilos de {{count}} están esperando revisión.",
              "label": "Revisar el trabajo pendiente"
            },
            "draftsReady": {
              "text": "Los borradores de {{count}} están listos para revisar.",
              "label": "Borradores listos"
            },
            "escalations": {
              "label": "Escaladas",
              "text": "Los subprocesos {{count}} necesitan seguimiento manual."
            },
            "stable": {
              "label": "Estable",
              "text": "No hay alertas operativas urgentes en este momento."
            }
          },
          "snapshot": {
            "languages": "Idiomas",
            "draftsReady": "Borradores {{count}} listos",
            "reviewActions": "Revisar acciones",
            "laneDistribution": "Distribución de carriles",
            "approved": "Aprobado",
            "edited": "Editado",
            "escalated": "escalado",
            "rejected": "Rechazado"
          },
          "modules": {
            "emailOps": {
              "description": "Clasificación, revisión, borradores, base de conocimientos y escalamientos para todos los correos electrónicos entrantes de Retailmaps.",
              "title": "Operaciones del agente de correo electrónico"
            },
            "aiQueue": {
              "title": "Cola de IA",
              "description": "Validación de marca y otros flujos de revisión impulsados ​​por IA que aún necesitan control humano."
            },
            "statistics": {
              "title": "Estadística",
              "description": "Descripción general central de volúmenes, idiomas, tiempos de respuesta, conversiones y rendimiento de los agentes."
            },
            "administration": {
              "title": "Administración",
              "description": "Backoffice operativo para facturación, suscripciones, gestión de buzones y procesos internos."
            }
          }
        },
        "emailDashboard": {
          "title": "Operaciones del agente de correo electrónico",
          "refreshMetrics": "Actualizar métricas",
          "badges": {
            "aiActive": "IA activa",
            "aiFallback": "Respaldo de la IA",
            "inboundMissing": "faltante entrante",
            "inboundActive": "Entrante activo"
          },
          "subtitle": "Revise el correo electrónico entrante, mejore los borradores y aumente la base de conocimientos para los agentes.",
          "metrics": {
            "activeLanguages": "Idiomas activos",
            "openReview": "Abrir revisión",
            "draftsReady": "Borradores listos",
            "brokerLane": "carril de corredor"
          },
          "helpers": {
            "openReview": "Hilos esperando revisión o aprobación.",
            "brokerLane": "Hilos actualmente enrutados al agente corredor.",
            "draftsReady": "Borradores actualmente listos para enviar.",
            "activeLanguages": "Idiomas que se ven actualmente en la bandeja de entrada."
          }
        },
        "brandQueue": {
          "title": "Cola de IA",
          "columns": {
            "name": "Nombre",
            "status": "Estado",
            "actions": "Acciones",
            "domain": "Dominio",
            "group": "Grupo",
            "createdAt": "Creado",
            "brands": "Marcas"
          },
          "reject": "Rechazar",
          "prompts": {
            "group": "¿Grupo/empresa matriz de {{name}}? (por ejemplo, Levi Strauss & Co.)",
            "reject": "¿Está seguro de que desea rechazar '{{name}}'?",
            "domain": "¿Dominio para {{name}}? (por ejemplo, levi.com)"
          },
          "verifiedTitle": "Marcas verificadas",
          "pendingTitle": "Marcas en espera de revisión"
        },
        "mailPanel": {
          "mode": "Modo",
          "threads": "trapos",
          "inbound": "entrante",
          "quickFilters": {
            "all": "Todo",
            "retailer": "Bandeja de entrada del minorista",
            "owner": "Bandeja de entrada del propietario",
            "support": "Bandeja de entrada de soporte",
            "broker": "Bandeja de entrada del corredor",
            "router": "Bandeja de entrada del enrutador"
          },
          "title": "Bandeja de entrada de revisión del agente",
          "refreshInbox": "Actualizar bandeja de entrada",
          "subtitle": "Revise, edite y responda conversaciones de correo electrónico entrantes desde una bandeja de entrada de operaciones centrales.",
          "messages": "mensajes",
          "filters": {
            "status": "Estado",
            "language": "Idioma",
            "lane": "carril",
            "search": "Buscar",
            "agent": "Agente",
            "review": "Revisar",
            "all": "Todo",
            "allAgents": "Todos los agentes",
            "allLanes": "Todos los carriles",
            "allStatuses": "Todos los estados",
            "clear": "Limpiar filtros",
            "onlyNeedsReview": "Sólo necesita revisión",
            "noReview": "Sin filtro de reseñas",
            "allLanguages": "Todos los idiomas"
          },
          "aiInactive": "La IA está inactiva, se están utilizando borradores alternativos.",
          "inbox": "Bandeja de entrada",
          "noSubject": "Sin tema",
          "unknownSender": "Remitente desconocido",
          "noThreads": "Ningún hilo coincide con los filtros actuales.",
          "languageLabel": "Idioma",
          "statusLabel": "Estado",
          "reviewRequired": "Revisión requerida",
          "agentLabel": "Agente",
          "escalation": "Escalada",
          "lastActivity": "Última actividad",
          "incomingMail": "Correo entrante",
          "autoReplyEligible": "Respuesta automática elegible",
          "threadDetail": "Detalle del hilo",
          "loadingThread": "Cargando hilo...",
          "incomingFrom": "Entrante de",
          "sending": "Enviando...",
          "subject": "Sujeto",
          "reply": "Responder",
          "sendReply": "Enviar respuesta",
          "approve": "Aprobar",
          "escalate": "Escalar",
          "reject": "Rechazar",
          "noPlainText": "No hay cuerpo de texto plano disponible.",
          "agentDraft": "borrador del agente",
          "saveEdited": "Guardar editado",
          "replySendFailed": "Error al enviar la respuesta.",
          "replySentVia": "Respuesta enviada a {{recipient}} a través de {{provider}}.",
          "saveEditedAsKnowledge": "Guardar la versión editada como artículo de conocimiento",
          "feedbackFailed": "Error al procesar los comentarios.",
          "feedbackProcessed": "Comentarios procesados ​​exitosamente.",
          "knowledgeContent": "Contenido",
          "knowledgeBase": "base de conocimientos",
          "knowledgeTitle": "Título",
          "manualEscalationNote": "Escalamiento manual solicitado por revisión del administrador.",
          "noDraft": "Aún no hay ningún borrador disponible para este hilo.",
          "selectThread": "Seleccione un hilo para revisar sus detalles y borrador.",
          "knowledgeKeywords": "Palabras clave (separadas por comas)",
          "knowledgeSaved": "Artículo de conocimiento guardado.",
          "addKnowledgeArticle": "Agregar artículo de conocimiento",
          "knowledgeSaveFailed": "Error al guardar el artículo de conocimiento.",
          "noKnowledgeArticles": "Aún no hay artículos de conocimiento disponibles."
        },
        "statistics": {
          "title": "Estadística",
          "overview": {
            "users": "Usuarios",
            "totalProperties": "Propiedades totales",
            "activeSubscriptions": "Suscripciones activas",
            "activeListings": "Listados activos",
            "activeForRent": "Stock activo en alquiler",
            "totalInterests": "Intereses totales"
          },
          "subtitle": "Descripción general de las operaciones en vivo de volúmenes, carga de reseñas, idiomas y comentarios sobre las respuestas de los agentes.",
          "meta": {
            "generatedAt": "Generado en",
            "activeInboxCountries": "Países de bandeja de entrada activa",
            "mailThreads": "Hilos de correo"
          },
          "roles": {
            "brokers": "Corredores",
            "admins": "Administradores",
            "owners": "Propietarios",
            "retailers": "Minoristas"
          },
          "conversion": {
            "interestsPerActiveProperty": "Intereses por propiedad activa",
            "contactUnlocks": "Desbloqueos de contacto",
            "propertiesWithInterest": "Propiedades con interés",
            "unlockRevenue": "Desbloquear ingresos",
            "listingUnlockRate": "Tasa de desbloqueo de listado",
            "propertiesWithInterestShare": "Proporción de propiedades con interés"
          },
          "manual": {
            "manualAddedToday": "Agregado manualmente hoy",
            "topEditors": "Principales editores de manuales",
            "topCreators": "Principales creadores de manuales",
            "manualEditedToday": "Editado manualmente hoy",
            "manualEditedMonth": "Editado manualmente este mes",
            "manualAddedMonth": "Agregado manualmente este mes"
          },
          "sections": {
            "rolesAndGrowth": "Roles y crecimiento",
            "newUsers": "Nuevos usuarios",
            "userCountries": "Países usuarios",
            "accountsPerRole": "Cuentas por rol",
            "userCountriesHelp": "Principales países según los datos del perfil de usuario/empresa.",
            "manualInteraction": "Interacción manual del sistema",
            "manualInteractionHelp": "Acciones de usuario en las que se agregaron o editaron propiedades manualmente.",
            "heatmapHotspotsHelp": "Principales combinaciones de ciudad y país según los intereses registrados.",
            "interestsByPeriod": "Intereses por periodo",
            "interestsByCity": "Intereses por ciudad",
            "activeForRentStock": "Stock activo en alquiler",
            "heatmapHotspots": "Puntos de interés",
            "propertiesAdded": "Propiedades agregadas",
            "agentMailContext": "Contexto de correo del agente",
            "topPropertyCountries": "Países principales en la base de datos de propiedades",
            "conversionSignals": "Conversión y señales comerciales."
          }
        },
        "administration": {
          "title": "Administración",
          "sections": {
            "mailInfrastructure": "Infraestructura de correo",
            "healthCheck": "control de salud",
            "operationalStatus": "Estado operativo",
            "roadmap": "Próximos pasos del back office"
          },
          "subtitle": "Backoffice operativo para el estado del correo, el estado del entorno y la preparación de las operaciones internas.",
          "fields": {
            "from": "De",
            "provider": "Proveedor",
            "frontendUrl": "URL de interfaz",
            "testRecipient": "Destinatario de la prueba",
            "internalInboxes": "Bandejas de entrada internas"
          },
          "health": {
            "mailProviderActive": "{{provider}} activo",
            "notConfigured": "No configurado",
            "inboundMissing": "Recepción entrante no configurada",
            "aiClassification": "Clasificación de IA",
            "inboundActive": "Recepción entrante activa",
            "mailProvider": "Proveedor de correo",
            "fallbackOnly": "Solo respaldo",
            "actionNeeded": "Acción necesaria",
            "inboundAgent": "Agente entrante",
            "aiActive": "OpenAI activo",
            "internalInboxes": "Bandejas de entrada internas",
            "internalRecipientsConfigured": "Destinatarios internos {{count}} configurados",
            "noInternalRecipients": "No hay destinatarios internos configurados"
          },
          "status": {
            "openReview": "Abrir revisión",
            "threads": "Trapos",
            "draftsReady": "Borradores listos",
            "escalations": "Escaladas"
          },
          "roadmap": {
            "subscriptions": "Controles de suscripción y facturación por rol",
            "internalNotifications": "Preferencias de notificación interna",
            "billing": "Exportaciones de facturación y resúmenes de facturas",
            "mailboxes": "Enrutamiento de buzones y gestión de alias",
            "agentPolicies": "Políticas de agentes y automatizaciones específicas de roles",
            "escalations": "Reglas de escalamiento y monitoreo de SLA",
            "footer": "Esta página está operativa intencionalmente y se expandirá al backoffice central de Retailmaps."
          }
        }
      },
      "documents": {
        "title": "Documentos",
        "add": "Agregar documento",
        "error": {
          "tooLarge": "supera los 10 MB y se ha omitido."
        },
        "remove": "Quitar documento"
      },
      "myProperties": {
        "nr": "Núm.",
        "city": "Ciudad",
        "address": "DIRECCIÓN",
        "tenant": "Inquilino",
        "link": "Detalles",
        "status": {
          "forRent": "En alquiler",
          "rented": "Alquilado"
        },
        "actions": "Acciones",
        "assetManager": "Gestor de activos",
        "noAssetManager": "- ninguno -",
        "noResults": "Sin resultados",
        "ownProperties": "Mis inmuebles",
        "groupProperties": "Cartera de la organizacion",
        "stopRent": "Detener alquiler",
        "setForRent": "Poner en alquiler",
        "street": "Calle",
        "allCities": "Todas las ciudades",
        "allStreets": "Todas las calles",
        "bulk": {
          "assignToSelection": "Asignar seleccion",
          "onlyUnassigned": "Solo sin asset manager",
          "selectAllVisible": "Seleccionar visibles",
          "noManagerSelected": "Elige un asset manager.",
          "noSelection": "No hay inmuebles seleccionados."
        },
        "loading": "Cargando...",
        "assignToMe": "Asignarme",
        "view": "Ver",
        "assignError": "No se pudo asignar.",
        "rentToggleError": "No se pudo cambiar el estado de alquiler.",
        "subscription": {
          "required": "Se requiere una suscripción activa para esta acción.",
          "badge": "Suscripción de propietario",
          "stripeMissing": "Stripe.js no está cargado.",
          "startError": "No se pudo iniciar la suscripción.",
          "sessionError": "No se pudo iniciar la sesión de Stripe.",
          "activate": "Activar suscripción de propietario",
          "title": "Listo para su próxima propiedad",
          "description": "Su prueba incluye 3 propiedades. Para reclamar la siguiente propiedad a través de la organización, activa la suscripción de propietario y continúa inmediatamente."
        },
        "claimError": "Error al agregar la propiedad.",
        "claimSuccess": "Propiedad agregada a su cartera.",
        "noPaidSubscriptionSuffix": " - sin suscripcion activa",
        "analysis": "Analisis",
        "assignRequiresPaidSubscription": "Este usuario necesita una suscripcion activa.",
        "importPortfolio": "Importar cartera",
        "remove": "Eliminar",
        "confirmRemove": "Seguro que quieres eliminar este inmueble de la cartera de la organizacion Si ningun companero tambien tiene este inmueble, desaparecera por completo de la organizacion.",
        "removeFailed": "No se pudo eliminar."
      },
      "countries": {
        "nl": "Países Bajos",
        "be": "Bélgica",
        "de": "Alemania",
        "fr": "Francia",
        "gb": "Reino Unido",
        "es": "España",
        "it": "Italia"
      },
      "propertyDrawer": {
        "title": "Detalles de la propiedad",
        "openInNewTab": "Abrir en nueva pestaña",
        "address": "DIRECCIÓN",
        "status": "Estado",
        "forRent": "En alquiler",
        "rented": "Alquilado",
        "assetManager": "Gestor de activos",
        "openInMaps": "Abrir en mapas",
        "loadFailed": "No se pudieron cargar los detalles de la propiedad."
      },
      "subscriptionRequired": {
        "title": "Se requiere una suscripción",
        "body": "Para anunciar un inmueble en alquiler en Retailmaps, necesitas una suscripción activa.",
        "details": "Con una suscripción puedes anunciar inmuebles en alquiler y hacerlos visibles para todos los usuarios de la plataforma o para grupos seleccionados.",
        "activate": "Activar suscripción"
      },
      "auth": {
        "twoFactor": {
          "prompt": "Introduce el código de 6 dígitos de tu app de autenticación.",
          "backToPassword": "Volver a contraseña"
        }
      },
      "retailerProfile": {
        "personalTitle": "Perfil personal",
        "companyTitle": "Perfil de empresa",
        "autosaveHint": "Los cambios se guardan automáticamente.",
        "company": "Empresa",
        "name": "Nombre",
        "legalName": "Razon social",
        "companyName": "Nombre de empresa",
        "headquartersPostalCode": "Código postal de la sede",
        "parentCompany": "Empresa matriz",
        "headquartersAddress": "dirección de la oficina central",
        "industry": "Industria",
        "organization": "Organización",
        "companyProtectedHint": "El grupo y el nombre de la empresa son los principales perfiles de IA y enlaces internos, por lo que permanecen protegidos.",
        "headquartersCity": "ciudad sede",
        "headquartersCountry": "País de la oficina central",
        "storeCount": "Número de tiendas",
        "billingEmail": "E-mail de facturacion",
        "invoiceReference": "Referencia factura / PO",
        "billingAddress": "Direccion de facturacion",
        "chamberOfCommerceNumber": "Numero de registro mercantil",
        "vatNumber": "Numero de IVA",
        "postalCode": "Codigo postal",
        "city": "Ciudad",
        "employeeCount": "Número de empleados",
        "foundingYear": "año de fundación",
        "activeCountries": "Activo en países",
        "country": "País",
        "billingHint": "Útil para suscripciones, facturas y administración interna.",
        "revenueIndication": "Indicación de ingresos"
      },
      "paidInterest": {
        "price": "5 € sin IVA al mes",
        "title": "Interés extra",
        "bodyPrefix": "Este interés cuesta",
        "paymentStartFailed": "No se pudo iniciar el pago.",
        "confirm": "Aceptar y continuar",
        "bodySuffix": "y se agregará a su suscripción. Podrás retirar este interés más tarde en cualquier momento."
      },
      "forRentTab": {
        "created": "La propiedad ahora está listada para alquiler.",
        "listProperty": "Listar propiedad en alquiler",
        "confirmDelete": "¿Estás seguro de que deseas eliminar este anuncio de alquiler?",
        "deleteFailed": "Error al eliminar.",
        "updateFailed": "La actualización falló.",
        "updated": "Listado actualizado.",
        "missingData": "Faltan datos para listar esta propiedad en alquiler.",
        "selectActingRole": "Selecciona en nombre de quién estás listando.",
        "activateFailed": "Error al activar el anuncio de alquiler.",
        "activating": "Activando anuncio de alquiler..."
      },
      "verifyEmail": {
        "successMessage": "Tu e-mail ha sido confirmado. Inicia sesión para abrir Retailmaps.",
        "successTitle": "Dirección de correo electrónico confirmada",
        "failedTitle": "La verificación falló",
        "checkingTitle": "De cheques",
        "backToLogin": "Volver al login",
        "loadingMessage": "Estamos confirmando tu dirección de correo electrónico...",
        "invalidLink": "Este enlace de verificación no es válido.",
        "failedMessage": "La verificación falló.",
        "expiredOrInvalid": "Este enlace de verificación ha caducado o no es válido.",
        "openLogin": "Inicie sesión y abra Retailmaps"
      },
      "legal": {
        "privacy": {
          "title": "Declaración de privacidad",
          "providers": "Retailmaps puede utilizar proveedores externos para alojamiento, mapas, pagos, correo electrónico, análisis y funcionalidad de inteligencia artificial.",
          "roles": "Los datos pueden ser visibles para los usuarios relevantes según su función, derechos de acceso, suscripciones y acciones dentro de la plataforma.",
          "intro": "Retailmaps procesa datos de cuentas comerciales, empresas, propiedades, listados, intereses y uso para proporcionar la plataforma.",
          "rights": "Los usuarios pueden solicitar el acceso, rectificación o eliminación de datos personales cuando corresponda.",
          "contact": "Si tiene preguntas sobre privacidad, comuníquese con Retailmaps a través de los datos de contacto publicados."
        },
        "disclaimer": "Documento conceptual para Retailmaps. Complete los datos de la empresa antes de publicar esto definitivamente.",
        "lastUpdated": "Última actualización: 28 de mayo de 2026",
        "terms": {
          "title": "Términos y condiciones",
          "data": "Los usuarios siguen siendo responsables de la exactitud y los derechos de la información, fotografías, documentos y datos de contacto que cargan o publican.",
          "intro": "Retailmaps es una plataforma profesional para información, listados, intereses, solicitudes y colaboraciones relacionadas de bienes raíces minoristas.",
          "account": "Los usuarios son responsables de los detalles correctos de la cuenta, las credenciales de inicio de sesión seguras y el uso legal de la plataforma.",
          "uploadLicense": "Al proporcionar planos de planta, IMDF, GeoJSON, CAD, SVG u otros archivos de ubicación, el usuario confirma que está autorizado para hacerlo y otorga a Retailmaps una licencia no exclusiva y libre de regalías para almacenar, alojar, copiar, analizar, convertir, georreferenciar, adaptar y combinar esos archivos, crear planos de planta derivados y capas de mapas, y mostrarlos dentro del servicio Retailmaps. Retailmaps podrá conceder los derechos estrictamente necesarios a sus proveedores de servicios técnicos. El usuario debe revelar cualquier atribución requerida, licencia de terceros u otra restricción al proporcionar el archivo.",
          "payments": "Se pueden aplicar funciones pagas, suscripciones, paquetes y tarifas de transacción cuando se muestran claramente en el panel o en el flujo de pedidos.",
          "liability": "Retailmaps es una plataforma de información y networking y no garantiza que una propiedad esté disponible o que se complete una transacción."
        }
      },
      "popup": {
        "autosaveActive": "Autosave activo"
      },
      "brokerRequests": {
        "overview": "Descripción general",
        "title": "Solicitudes de corredor",
        "profile": {
          "stores": "Tiendas",
          "industry": "Industria",
          "founded": "Fundado",
          "revenue": "Ganancia",
          "activeIn": "Activo en"
        },
        "empty": "Sin solicitudes",
        "interestCount": "Interés(es) {{count}}",
        "buyContact": "Comprar (9 €)"
      },
      "account": {
        "noLogo": "Aun no hay logotipo"
      },
      "rentalData": {
        "addField": "Agregar campo"
      },
      "financialData": {
        "addField": "Agregar campo"
      },
      "retailerProperties": {
        "sameBrandInterestBlocked": "No se permite mostrar interés en una propiedad de su propia marca o grupo."
      },
      "dashboardOverlay.shared.support": "Soporte",
      "support": {
        "title": "Soporte",
        "intro": "¿Necesita ayuda? Envíe su pregunta directamente a nuestro equipo de soporte.",
        "emailIntro": "También puede enviarnos un correo electrónico directamente.",
        "category": "Tema",
        "categoryGeneral": "Pregunta general",
        "categoryAccount": "Cuenta y suscripción",
        "categoryBilling": "Facturación y pagos",
        "categoryMap": "Mapa y datos",
        "categoryForRent": "En alquiler",
        "categoryBug": "Informar de un problema",
        "subject": "Asunto",
        "message": "Su pregunta",
        "subjectPlaceholder": "Describa brevemente su pregunta",
        "messagePlaceholder": "Díganos cómo podemos ayudarle",
        "send": "Enviar a soporte",
        "sending": "Enviando…",
        "successTitle": "Su solicitud de soporte ha sido enviada",
        "success": "Hemos recibido su pregunta. Su referencia es {{ticketNumber}}. También recibirá una confirmación por correo electrónico.",
        "context": "Su mensaje está vinculado a su cuenta de {{role}} y a la página que está viendo.",
        "validation": "Introduzca un asunto y su pregunta.",
        "error": "No se pudo enviar su solicitud. Inténtelo de nuevo o escriba a support@retailmaps.com."
      }
    }
  },
  "fr": {
    "translation": {
      "popup2.trialPaywallTitle": "Vous avez utilisé vos 10 manifestations d’intérêt gratuites",
      "popup2.trialPaywallDescription": "Pour manifester également votre intérêt pour ce bien, vous avez besoin d’un abonnement. Vos 10 manifestations d’intérêt d’essai actuelles seront converties en manifestations d’intérêt payantes.",
      "popup2.trialPaywallManage": "Vous pourrez gérer ces manifestations d’intérêt ultérieurement dans votre tableau de bord (les modifier ou les supprimer).",
      "popup2.trialPaywallActivate": "Activer l’abonnement",
      "popup2.address": "Adresse",
      "popup2.city": "Ville",
      "popup2.website": "Site web",
      "popup2.groundFloor": "Rez-de-chaussée",
      "popup2.loginRequired": "Vous n'êtes pas connecté. Connectez-vous à nouveau pour ajouter des biens.",
      "popup2.basement": "Sous-sol",
      "popup2.firstFloor": "1er étage",
      "popup2.secondFloor": "2e étage",
      "popup2.thirdFloor": "3e étage",
      "popup2.entresol": "Entresol",
      "popup2.soussol": "Sous-sol",
      "popup2.unit": "Unité",
      "popup2.m2": "m²",
      "popup2.ft2": "ft²",
      "popup2.inList": "Ce bien est dans votre liste",
      "popup2.confirmRemove": "Êtes-vous sûr de vouloir supprimer ce bien de votre liste ?",
      "popup2.pandVerwijderd": "Bien supprimé de votre liste.",
      "popup2.verwijderenMislukt": "La suppression a échoué.",
      "popup2.removeFailed": "Échec de la suppression.",
      "popup2.saveFailed": "Erreur lors de l'enregistrement.",
      "popup2.removeFromList": "Supprimer de mes biens",
      "popup2.pandToegevoegd": "Bien ajouté à votre liste.",
      "popup2.toevoegenMislukt": "L’ajout a échoué.",
      "popup2.addToList": "Ajouter à mes biens",
      "popup2.interestedRetailers": "Enseignes intéressées",
      "popup2.retailersHaveInterest": "enseignes ont manifesté leur intérêt",
      "popup2.stripeStartFout": "Er is iets misgegaan bij het starten van Stripe.",
      "popup2.viewRequests": "Voir les demandes dans le tableau de bord",
      "popup2.publicData": "Données publiques",
      "popup2.privateData": "Données privées",
      "popup2.publicDataHint": "Visible property information used across listings, brochures and map views.",
      "popup2.privateDataHint": "Les informations internes restent dans votre espace de travail sécurisé et ne sont visibles que par les utilisateurs autorisés.",
      "popup2.privateWorkspace": "Espace privé",
      "popup2.privateWorkspaceHint": "Utilisez ces onglets pour gérer clairement et en toute sécurité les notes sensibles du propriétaire, les finances, les contacts, les photos et les documents.",
      "popup2.manageRentalStatus": "Gérer le statut de location",
      "popup2.forRent": "ì louer",
      "popup2.confirmTeHuurZetten": "Je staat op het punt om dit pand te huur te zetten.\n⬢ Normaal {{prijs}} per maand, nu tijdelijk gratis\n⬢ De status wordt zichtbaar voor andere partijen\n\nKlik op OK om akkoord te gaan.",
      "popup2.confirmStopTeHuurStatus": "Je staat op het punt om de te huur status te beëindigen.\n⬢ Hiermee wordt ook je Stripe abonnement voor dit pand gestopt.\n\nWeet je zeker dat je wilt doorgaan?",
      "popup2.teHuurGestopt": "Le statut À louer a été arrêté et l’abonnement a été stoppé.",
      "popup2.openbaarZichtbaarMaken": "Rendre public",
      "popup2.stripeAnnuleringMislukt": "Stripe annulering mislukt",
      "popup2.zetEerstTeHuur": "Zet eerst het pand te huur voordat je openbaar kunt maken.",
      "popup2.opslaanWijzigingen": "Enregistrer les modifications",
      "popup2.front": "Façade",
      "popup2.inPortfolio": "Dans le portefeuille",
      "popup2.addToMyProperties": "Ajouter à mes biens",
      "popup2.alreadyInOrgPortfolio": "Pand zit al in organisatieportefeuille",
      "popup2.alreadyInOwnPortfolio": "Pand zit al in eigen portefeuille",
      "popup2.addPropertyError": "Fout bij toevoegen van pand",
      "popup2.invalidSession": "Session invalide. Connectez-vous à nouveau.",
      "popup2.trialLimitReachedTitle": "🚧 Limiet bereikt",
      "popup2.trialLimitReachedDesc1": "Maximaal 3 panden tijdens proefperiode toegestaan",
      "popup2.trialLimitReachedDesc2": "Activeer abonnement om verder te gaan:",
      "popup2.subscriptionPrice": "19 € par mois",
      "popup2.extraPropertyPrice": "5 € par bien supplémentaire",
      "popup2.listingPrice": "Normalement 15 € par mois pour publier un bien à louer, temporairement gratuit",
      "popup2.stripeSessionFailed": "Stripe-sessie starten mislukt",
      "popup2.stripeError": "Erreur Stripe : ",
      "popup2.noUserEmail": "Aucun email utilisateur disponible. Vérifiez que vous êtes connecté.",
      "popup2.stripeNotLoaded": "Stripe.js niet geladen",
      "popup2.extraPandFailed": "Kon extra pand-checkout niet starten",
      "popup2.onlyMineHeader": "Status beheren niet mogelijk",
      "popup2.onlyMineMessage": "Je kan de status niet wijzigen. Als je de status wil aanpassen moet je het pand aan 'mijn panden' toevoegen",
      "popup2.cancel": "Annuler",
      "popup2.busy": "En cours...",
      "popup2.confirm": "Confirmer",
      "popup2.saveError": "Error saving changes.",
      "popup2.surface": "Surface",
      "popup2.retailSpace": "Commerce",
      "popup2.secondarySpace": "Secondaire",
      "popup2.visibilityUpdateFailed": "Changing visibility failed.",
      "popup2.extraPropertyFailed": "Adding an extra property failed.",
      "popup2.stripeStartFailed": "Starting Stripe failed.",
      "popup2.stripeErrorPrefix": "Stripe error: ",
      "popup2.interestAddFailed": "Adding interest failed.",
      "popup2.ownerMustAddFirst": "Add this property to your portfolio first.",
      "popup2.retailerBrandClaimRequired": "A brand claim is required to manage rental visibility.",
      "popup2.roleNotSupported": "Your current role does not support this action.",
      "photos.title": "Photos",
      "photos.add": "Ajouter une photo",
      "photos.remove": "Supprimer la photo",
      "photos.error.tooLarge": "depasse 10 Mo et a ete ignore.",
      "documents.title": "Documents",
      "documents.add": "Ajouter un document",
      "documents.remove": "Supprimer",
      "documents.error.tooLarge": "est supérieur à 10 Mo",
      "retailer.contactgegevensBlock.title": "Contacts",
      "retailer.contactgegevensBlock.company": "Entreprise",
      "retailer.contactgegevensBlock.name": "Nom",
      "retailer.contactgegevensBlock.phone": "Téléphone",
      "retailer.contactgegevensBlock.email": "E-mail",
      "retailer.contactgegevensBlock.function": "Rôle",
      "retailer.contactgegevensBlock.add": "Ajouter un contact",
      "retailer.contactgegevensBlock.remove": "Supprimer le contact",
      "brokerContact.retailerContacts": "Contacts du revendeur",
      "brokerContact.ownerContacts": "Contacts du propriétaire",
      "brokerContact.company": "Entreprise",
      "brokerContact.name": "Nom",
      "brokerContact.phone": "Numéro de téléphone",
      "brokerContact.email": "Adresse e-mail",
      "brokerContact.position": "Rôle",
      "brokerContact.add": "Ajouter un contact",
      "brokerContact.remove": "Supprimer",
      "dashboard.title": "Tableau de bord",
      "dashboard.logout": "Déconnexion",
      "dashboard.backToMap": "Retour à la carte",
      "dashboard.trialExpiredTitle": "Votre période d'essai est terminée.",
      "dashboard.trialExpiredText": "Activez votre abonnement pour continuer.",
      "dashboard.activateSubscription": "Activer l'abonnement",
      "dashboard.daysLeft": "jours restants dans la période d'essai gratuite",
      "dashboard.profile": "Profil",
      "dashboard.brokerInterests": "Enseignes intéressées",
      "dashboard.myInterests": "Mes intérêts",
      "dashboard.myProperties": "Mon portefeuille",
      "dashboard.requests": "Demandes",
      "dashboard.subscription": "Abonnement",
      "dashboard.subscriptionComingSoon": "Abonnement (bientôt disponible)",
      "dashboard.bundles": "Gestion des packs",
      "dashboard.settings": "Paramètres",
      "dashboard.brokerAccount": "Mijn account",
      "dashboard.backToDashboard": "Terug naar dashboard",
      "dashboard.brokerListings": "Mes offres de location",
      "authLanding.tabs.login": "Login",
      "authLanding.tabs.register": "Register",
      "authLanding.roles.retailer": "Retailer",
      "authLanding.roles.owner": "Owner",
      "authLanding.roles.broker": "Broker",
      "authLanding.headlines.login.eyebrow": "Retail real estate intelligence",
      "authLanding.headlines.login.subtitle": "Log in and work from a live map layer on portfolio, leasing and interest.",
      "authLanding.headlines.register.eyebrow": "One platform for brokers, owners and retailers",
      "authLanding.headlines.register.subtitle": "Start with an account and build your portfolio, listings and market intelligence from the map.",
      "authLanding.headlines.forgot.eyebrow": "Restore access",
      "authLanding.headlines.forgot.subtitle": "Request a reset link and quickly set a new password for your account.",
      "authLanding.forgot.helper": "Enter your email address below. If the account exists, we will send a reset link right away.",
      "authLanding.roleSlides.broker.label": "Broker",
      "authLanding.roleSlides.broker.eyebrow": "For brokers",
      "authLanding.roleSlides.broker.subtitle": "Bring listings to market, track interest and unlock contact details directly from the same map workspace.",
      "authLanding.roleSlides.broker.featureCards.0": "Publish available locations faster.",
      "authLanding.roleSlides.broker.featureCards.1": "Work with live interest, documents and project information.",
      "authLanding.roleSlides.broker.featureCards.2": "Keep listings, leads and analysis in one place.",
      "authLanding.roleSlides.broker.workflowSteps.0": "From property to listing",
      "authLanding.roleSlides.broker.workflowSteps.1": "Interest and contact details",
      "authLanding.roleSlides.broker.workflowSteps.2": "Analysis per location",
      "authLanding.roleSlides.broker.footer.0": "Listings",
      "authLanding.roleSlides.broker.footer.1": "Lead intelligence",
      "authLanding.roleSlides.broker.footer.2": "Broker intelligence",
      "authLanding.roleSlides.owner.label": "Owner",
      "authLanding.roleSlides.owner.eyebrow": "For owners",
      "authLanding.roleSlides.owner.subtitle": "Manage portfolio, lease data, documents and alerts from a map that fits real estate workflows.",
      "authLanding.roleSlides.owner.featureCards.0": "Store lease, ownership and financial data centrally.",
      "authLanding.roleSlides.owner.featureCards.1": "List properties for rent and follow status on the map.",
      "authLanding.roleSlides.owner.featureCards.2": "Use alerts and analysis without separate spreadsheets.",
      "authLanding.roleSlides.owner.workflowSteps.0": "Portfolio control",
      "authLanding.roleSlides.owner.workflowSteps.1": "Lease data and alerts",
      "authLanding.roleSlides.owner.workflowSteps.2": "Asset analysis",
      "authLanding.roleSlides.owner.footer.0": "Portfolio management",
      "authLanding.roleSlides.owner.footer.1": "Lease information",
      "authLanding.roleSlides.owner.footer.2": "Owner analytics",
      "authLanding.roleSlides.retailer.label": "Retailer",
      "authLanding.roleSlides.retailer.eyebrow": "For retailers",
      "authLanding.roleSlides.retailer.subtitle": "Discover streets, manage stores, show interest and analyse locations before taking the next step.",
      "authLanding.roleSlides.retailer.featureCards.0": "See relevant retail streets and available properties.",
      "authLanding.roleSlides.retailer.featureCards.1": "Add stores to your own portfolio.",
      "authLanding.roleSlides.retailer.featureCards.2": "Show interest and compare locations in analysis.",
      "authLanding.roleSlides.retailer.workflowSteps.0": "Manage stores",
      "authLanding.roleSlides.retailer.workflowSteps.1": "Show interest",
      "authLanding.roleSlides.retailer.workflowSteps.2": "Compare locations",
      "authLanding.roleSlides.retailer.footer.0": "My stores",
      "authLanding.roleSlides.retailer.footer.1": "Interest",
      "authLanding.roleSlides.retailer.footer.2": "Retail analysis",
      "authLanding.platformSubtitle": "For and by retail professionals",
      "authLanding.heroSubtitle": "The live retail map for retail areas worldwide, leasing, showing interest, leads and location analysis. Everything in one platform for EUR 19 per month.",
      "authLanding.trialIntro": "Start your free 60 day trial here",
      "authLanding.trialCta": "Register free",
      "authLanding.marketTagline": "Prime retail streets · live market context",
      "authLanding.featureCards.0": "Work from a live map layer with retail context.",
      "authLanding.featureCards.1": "Manage portfolio, leasing and interest in one place.",
      "authLanding.featureCards.2": "Connect broker, owner and retailer in one workflow.",
      "authLanding.workflowSteps.0": "Portfolio and listing control",
      "authLanding.workflowSteps.1": "Live market signals on the map",
      "authLanding.workflowSteps.2": "One workflow for every role",
      "authLanding.footer.0": "Portfolio management",
      "authLanding.footer.1": "For-rent listings",
      "authLanding.footer.2": "Retail intelligence",
      "authLanding.modeLabel.login": "Welcome back",
      "authLanding.modeLabel.register": "New account",
      "authLanding.modeLabel.forgot": "Forgot password",
      "authLanding.panelTitle.login": "Log in to Retailmaps",
      "authLanding.panelTitle.register": "Start with Retailmaps",
      "authLanding.panelTitle.forgot": "Reset your password",
      "authLanding.fields.email": "Adresse e-mail",
      "authLanding.fields.password": "Mot de passe",
      "authLanding.fields.firstName": "Prénom",
      "authLanding.fields.lastName": "Nom",
      "authLanding.fields.role": "Rôle",
      "authLanding.fields.phone": "Phone",
      "authLanding.fields.companyName": "Nom de l'entreprise",
      "authLanding.fields.website": "Site web",
      "authLanding.actions.forgotPassword": "Forgot password?",
      "authLanding.actions.login": "Login",
      "authLanding.actions.register": "Register",
      "authLanding.actions.startTrial": "Start free trial",
      "authLanding.actions.sendReset": "Send reset link",
      "authLanding.actions.backToLogin": "Back to login",
      "authLanding.actions.openLocalReset": "Open local reset link",
      "authLanding.legal.acceptPrefix": "I agree to the",
      "authLanding.legal.privacy": "privacy statement",
      "authLanding.legal.and": "and the",
      "authLanding.legal.terms": "terms and conditions",
      "authLanding.errors.loginFailed": "Login failed. Please check your details.",
      "authLanding.errors.registerFailed": "Registration failed. Please try again.",
      "authLanding.errors.companyRequired": "Company name is required.",
      "authLanding.errors.forgotNotice": "If this email address is known, we have sent a reset link.",
      "authLanding.errors.forgotFailed": "We could not send the reset link right now.",
      "successStripe.title": "Stripe success",
      "successStripe.waitTitle": "Payment received",
      "successStripe.waitDescription": "We are finishing the activation now. This can take a few seconds. Keep this screen open; you will be redirected automatically when everything is ready.",
      "successStripe.stepPayment": "Payment confirmed",
      "successStripe.stepActivation": "Account or listing is being activated",
      "successStripe.stepRedirect": "You will return to Retailmaps automatically",
      "successStripe.back": "Back",
      "successStripe.processing": "Processing...",
      "successStripe.missingToken": "No valid token found. Please log in again.",
      "successStripe.missingParams": "Missing parameters in the URL.",
      "successStripe.unknownError": "Unknown error",
      "successStripe.missingSessionId": "session_id is missing.",
      "successStripe.missingRetailerId": "retailerId is missing.",
      "successStripe.paymentReceivedActivating": "Payment received! The subscription is being activated...",
      "successStripe.retailerListingActive": "The store is now for rent and publicly visible.",
      "successStripe.ownerListingActive": "The property is now for rent.",
      "successStripe.subscriptionActivating": "Subscription is being activated...",
      "successStripe.subscriptionNotConfirmed": "The subscription could not be confirmed.",
      "successStripe.subscriptionActive": "Subscription active.",
      "successStripe.extraPropertyAdded": "Extra property added successfully.",
      "successStripe.contactAccessUnlocked": "Payment received. We are preparing the contact details and returning you to the right property.",
      "successStripe.interestProcessed": "Interest processed successfully.",
      "successStripe.retailerSubscriptionActivating": "Retailer subscription is being activated...",
      "successStripe.retailerSubscriptionActive": "Retailer subscription active.",
      "successStripe.brokerSubscriptionActivating": "Payment received! The broker subscription is being activated...",
      "successStripe.invalidType": "Unknown or invalid type.",
      "successStripe.genericFailure": "Something went wrong: {{message}}",
      "common.loading": "Chargement...",
      "common.save": "Enregistrer",
      "common.cancel": "Annuler",
      "common.edit": "Modifier",
      "common.delete": "Supprimer",
      "common.close": "Fermer",
      "common.yes": "Yes",
      "common.no": "No",
      "common.localeCode": "en-GB",
      "roles.owner": "Propriétaire",
      "roles.retailer": "Retailer",
      "roles.broker": "Courtier",
      "listings.common.country": "Pays",
      "listings.common.city": "Ville",
      "listings.common.address": "Adresse",
      "listings.common.askingPrice": "Prix demande",
      "listings.common.currentRent": "Loyer actuel",
      "listings.common.keyMoney": "Pas-de-porte",
      "listings.common.expiryDate": "Date d’expiration",
      "listings.common.availableFrom": "Disponible à partir du",
      "listings.common.projectInformation": "Informations projet",
      "listings.common.onBehalfOf": "Pour le compte de",
      "listings.common.visibility": "Visibilité",
      "listings.common.actions": "Actions",
      "listings.common.upload": "Téléverser",
      "listings.common.uploadDocument": "Téléverser un document",
      "listings.common.chooseFile": "Choisir un fichier",
      "listings.common.noFileChosen": "Aucun fichier sélectionné",
      "listings.common.projectDocuments": "Documents du projet",
      "listings.common.empty": "Aucun local n’est actuellement à louer.",
      "listings.common.selectFileFirst": "Sélectionnez d’abord un fichier.",
      "listings.common.uploadFailed": "Le téléversement a échoué.",
      "listings.common.confirmDeleteDocument": "Voulez-vous vraiment supprimer \"{{name}}\" ?",
      "listings.common.documentDeleteFailed": "La suppression du document a échoué.",
      "listings.common.brochureFailed": "La génération ou le téléversement de la brochure a échoué.",
      "listings.common.stopForRent": "Arrêter",
      "listings.common.forRent": "ì louer",
      "listings.common.documentTypes.document": "Document",
      "listings.common.documentTypes.floorplan": "Plan",
      "listings.common.documentTypes.brochure": "Brochure",
      "listings.common.documentTypes.photo": "Photo",
      "listings.common.visibilityOptions.public": "Tout le monde",
      "listings.common.visibilityOptions.retailers": "Tous les retailers",
      "listings.common.visibilityOptions.interested": "Uniquement les interesses",
      "ownerListings.currentOffer": "Mes offres de location",
      "accountSettings.title": "Parametres",
      "accountSettings.tabs.profile": "Profil",
      "accountSettings.tabs.company": "Entreprise",
      "accountSettings.tabs.preferences": "Preferences",
      "accountSettings.tabs.billing": "Facturation",
      "accountSettings.descriptions.profile": "Coordonnees et role de votre compte.",
      "accountSettings.descriptions.company": "Donnees entreprise, marque et facturation.",
      "accountSettings.descriptions.preferences": "Langue, devise, unites et affichage de la carte.",
      "accountSettings.descriptions.billing": "Abonnement, utilisation et achats ponctuels.",
      "accountSettings.personal.title": "Profil personnel",
      "accountSettings.personal.description": "Coordonnees et role de votre compte. Les modifications sont enregistrees automatiquement.",
      "accountSettings.personal.firstName": "Prenom",
      "accountSettings.personal.lastName": "Nom",
      "accountSettings.personal.role": "Fonction",
      "accountSettings.personal.phone": "Telephone",
      "accountSettings.personal.email": "Adresse e-mail",
      "accountSettings.personal.linkedin": "LinkedIn",
      "accountSettings.personal.address": "Adresse",
      "accountSettings.company.brandLogoTitle": "Marque et logo",
      "accountSettings.company.brandLogoDescription": "Nous utilisons ce logo sur les fiches de biens et autres emplacements visibles.",
      "accountSettings.company.title": "Profil entreprise",
      "accountSettings.company.description": "Donnees entreprise, informations de marque et facturation pour les comptes courtiers et proprietaires. Les modifications sont enregistrees automatiquement.",
      "accountSettings.company.readOnlyNotice": "Le groupe d entreprise et le domaine pilotent les connexions, la visibilite et les profils IA et restent donc en lecture seule.",
      "accountSettings.company.companyName": "Nom de l entreprise",
      "accountSettings.company.companyGroup": "Groupe d entreprise",
      "accountSettings.company.domain": "Domaine",
      "accountSettings.company.legalName": "Raison sociale",
      "accountSettings.company.website": "Site web",
      "accountSettings.company.roleType": "Type de role",
      "accountSettings.company.headquartersTitle": "Siege",
      "accountSettings.company.headquartersAddress": "Adresse du siege",
      "accountSettings.company.postalCode": "Code postal",
      "accountSettings.company.city": "Ville",
      "accountSettings.company.country": "Pays",
      "accountSettings.company.billingTitle": "Facturation",
      "accountSettings.company.billingDescription": "Nous utilisons ces informations pour les abonnements, factures et administration financiere.",
      "accountSettings.company.billingEmail": "E-mail de facturation",
      "accountSettings.company.invoiceReference": "Reference facture / PO",
      "accountSettings.company.chamberOfCommerce": "Numero registre du commerce",
      "accountSettings.company.vatNumber": "Numero TVA",
      "accountSettings.company.billingAddress": "Adresse de facturation",
      "billing.title": "Facturation",
      "billing.description": "Tout pour {{account}} en un apercu : abonnements, achats ponctuels et couts ouverts pour {{period}}.",
      "billing.yourAccount": "votre compte",
      "billing.currentMonth": "ce mois",
      "billing.currentPeriod": "Periode actuelle",
      "billing.preparingPdf": "Preparation du PDF...",
      "billing.downloadPdf": "Telecharger la facture (PDF)",
      "billing.downloadError": "Downloading the invoice failed.",
      "billing.loadError": "Billing data could not be loaded.",
      "billing.amountDueThisMonth": "Montant du ce mois",
      "billing.subscriptionStatus": "Statut abonnement",
      "billing.subscriptionActive": "Actif",
      "billing.subscriptionInactive": "Inactif",
      "billing.nextRenewal": "Prochain renouvellement",
      "billing.stripeCustomer": "Client Stripe",
      "billing.paidSince": "Paye depuis",
      "billing.infoNotice": "User details now live in Profile and Company. We only show what is financially relevant here: recurring subscription costs, one-off purchases and the total for this month.",
      "billing.summary.title": "Résumé",
      "billing.recurring.title": "Abonnements et utilisation",
      "billing.recurring.description": "Couts recurrents pour votre abonnement, biens a louer actifs et autres composants mensuels.",
      "billing.oneOff.title": "Achats ponctuels",
      "billing.oneOff.description": "Couts ponctuels, comme le deblocage de documents ou autres evenements de facturation separes.",
      "billing.oneOff.none": "Aucun achat ponctuel pendant cette periode.",
      "billing.oneOff.noneTitle": "Aucun achat ponctuel pendant cette periode",
      "billing.oneOff.noneDescription": "Des qu un achat ponctuel est termine, il apparait automatiquement ici.",
      "billing.totals.subscriptions": "Abonnements",
      "billing.totals.oneOff": "Achats ponctuels",
      "billing.totals.totalDue": "Total dû",
      "billing.history.title": "Historique de facturation",
      "billing.history.description": "Evenements de facturation recents et transactions ponctuelles pour ce compte.",
      "billing.history.none": "Aucun evenement de facturation n a encore ete trouve pour ce compte.",
      "billing.history.documentUnlock": "Deblocage document",
      "billing.columns.description": "Description",
      "billing.columns.quantity": "Quantite",
      "billing.columns.unitPrice": "Unite",
      "billing.columns.total": "Total",
      "billing.columns.date": "Date",
      "billing.columns.amount": "Montant",
      "billing.columns.status": "Statut",
      "billing.invoice.overview": "Invoice overview {{period}}",
      "billing.invoice.invoiceDate": "Invoice date",
      "billing.invoice.period": "Period",
      "billing.invoice.statusOpen": "Status: open",
      "billing.invoice.billTo": "Bill to",
      "billing.invoice.footer": "This overview was generated from the current Retailmaps billing data for this period.",
      "stores.common.number": "No.",
      "stores.common.storeName": "Store name",
      "stores.common.status": "Statut",
      "stores.common.byWho": "By whom",
      "stores.common.details": "Details",
      "stores.common.retailManager": "Retail manager",
      "stores.common.brokerOnBehalfOfOwner": "Broker (on behalf of owner)",
      "stores.status.forRent": "ì louer",
      "stores.status.rented": "Rented",
      "stores.actions.stopRent": "Stop rental",
      "stores.actions.setForRent": "Set for rent",
      "stores.sections.mine": "Mes magasins",
      "stores.sections.organization": "Stores from my organisation",
      "stores.filters.allCountries": "All countries",
      "stores.filters.allCities": "All cities",
      "stores.messages.addedToPortfolio": "Store added to your portfolio.",
      "stores.messages.addFailed": "The store could not be added.",
      "stores.messages.removeFailed": "The store could not be removed.",
      "stores.messages.toggleRentFailed": "Changing rental status failed.",
      "stores.messages.subscriptionRequired": "An active subscription is required for this action.",
      "stores.messages.assignFailed": "Assigning failed.",
      "dashboard.verhuurAanbod": "Mes offres de location",
      "successPage.processing": "Veuillez patienter... nous traitons vos données...",
      "successPage.notLoggedIn": "Non connecté. Réessayez.",
      "successPage.subscriptionActivated": "Votre abonnement a été activé avec succès !",
      "successPage.subscriptionFailed": "Échec de l’activation : ",
      "successPage.subscriptionError": "Une erreur est survenue.",
      "successPage.propertyForRent": "Le bien est maintenant à louer.",
      "successPage.propertyUpdateError": "Erreur lors de la mise à jour du retailer : ",
      "successPage.serverError": "Erreur serveur lors de la mise à jour du retailer.",
      "successPage.bundleActivated": "Pack activé avec succès.",
      "successPage.bundleFailed": "Échec de l’activation du pack.",
      "successPage.bundleError": "Erreur lors de l’activation du pack.",
      "successPage.interestRegistered": "Intérêt enregistré avec succès.",
      "successPage.interestStoredFailed": "Paiement effectué, mais profil non enregistré.",
      "successPage.interestStoreError": "Une erreur est survenue lors de l’enregistrement de votre intérêt.",
      "successPage.missingContactData": "Informations insuffisantes pour accorder l’accès.",
      "successPage.contactConfirmed": "Vos coordonnées sont maintenant disponibles. Redirection en cours...",
      "successPage.contactConfirmFailed": "Paiement effectué, mais l’accès n’est pas encore accordé.",
      "successPage.contactError": "Une erreur est survenue lors de l’accord de l’accès.",
      "successPage.incompleteOrUnknown": "Informations incomplètes ou inconnues.",
      "successPage.propertyAddFailed": "Échec de l’ajout du bien : ",
      "successPage.propertyAddError": "Erreur lors de l’ajout du bien.",
      "successPage.success": "Réussi !",
      "successPage.loading": "En cours...",
      "successPage.comboSuccess": "Bien ajouté et abonnement actif.",
      "successPage.comboFailed": "Échec de l’ajout après le paiement combiné : ",
      "successPage.extraPropertyAdded": "Bien supplémentaire ajouté avec succès.",
      "successPage.extraPropertyFailed": "Échec de l’ajout après paiement : ",
      "successPage.missingRetailerId": "Aucun retailerId renseigné.",
      "myProperties.title": "Mijn Portefeuille",
      "myProperties.back": "Terug naar Dashboard",
      "myProperties.empty": "Je hebt nog geen panden toegevoegd.",
      "myProperties.name": "Naam",
      "myProperties.address": "Adresse",
      "myProperties.city": "Ville",
      "myProperties.country": "Land",
      "myProperties.link": "Details",
      "myProperties.action": "Actie",
      "myProperties.remove": "Supprimer",
      "myProperties.confirmRemove": "Voulez-vous vraiment supprimer ce bien du portefeuille de l'organisation ? Si aucun collegue ne possede aussi ce bien, il disparaitra completement de l'organisation.",
      "myProperties.removeFailed": "Suppression echouee.",
      "propertyDetails.back": "Retour a l'apercu",
      "propertyDetails.address": "Adresse",
      "propertyDetails.publicData": "Données publiques",
      "propertyDetails.privateData": "Données privées",
      "propertyDetails.groundFloor": "Rez-de-chaussée",
      "propertyDetails.firstFloor": "1er étage",
      "propertyDetails.secondFloor": "2e étage",
      "propertyDetails.thirdFloor": "3e étage",
      "propertyDetails.basement": "Sous-sol",
      "propertyDetails.entresol": "Entresol",
      "propertyDetails.soussol": "Sous-sol",
      "propertyDetails.rentalData": "Donnees locatives",
      "propertyDetails.formalTenant": "Formal tenant",
      "propertyDetails.huurprijs": "Rent",
      "propertyDetails.startDate": "Start date",
      "propertyDetails.endDate": "Expiry date",
      "propertyDetails.remainingLeaseTermMonths": "Remaining lease term (months)",
      "propertyDetails.indexDate": "Indexation date",
      "propertyDetails.cancelDate": "Notice date",
      "propertyDetails.cancelNotice": "Notice period",
      "propertyDetails.guaranteeType": "$t(owner.huurgegevensBlock.garantiesoort)",
      "propertyDetails.guaranteeAmount": "Guarantee amount",
      "propertyDetails.financialData": "Donnees financieres",
      "propertyDetails.purchasePrice": "Koopsom",
      "propertyDetails.purchaseDate": "Aankoopdatum",
      "propertyDetails.mortgage": "Hypotheekbedrag",
      "propertyDetails.interestRate": "Rentepercentage",
      "propertyDetails.bank": "Bank",
      "propertyDetails.loanDuration": "Looptijd (jaren)",
      "propertyDetails.comments": "Opmerkingen",
      "propertyDetails.addComment": "Voeg opmerking toe",
      "propertyDetails.addCommentPrompt": "Voeg een opmerking toe:",
      "propertyDetails.contacts": "Huurderscontacten",
      "propertyDetails.documents": "Documenten",
      "propertyDetails.photos": "Foto's",
      "propertyDetails.save": "Enregistrer les modifications",
      "propertyDetails.saveSuccess": "Données enregistrées",
      "propertyDetails.saveError": "Échec de l’enregistrement",
      "propertyDetails.loading": "📦 Laden...",
      "propertyDetails.notFound": "Cette localisation n’existe plus.",
      "registerPage.title": "📝 Inscription",
      "registerPage.email": "Adresse e-mail",
      "registerPage.password": "Mot de passe",
      "registerPage.role": "Rôle",
      "registerPage.retailer": "Revendeur",
      "registerPage.owner": "Propriétaire",
      "registerPage.broker": "Agent immobilier",
      "registerPage.brand": "Nom de marque",
      "registerPage.website": "Site web",
      "registerPage.firstName": "Prénom",
      "registerPage.lastName": "Nom",
      "registerPage.phone": "Numéro de téléphone",
      "registerPage.register": "S'inscrire",
      "registerPage.registrationSuccess": "Inscription réussie. Votre période d’essai gratuite a commencé.",
      "login.title": "🔐 Connexion",
      "login.email": "Adresse e-mail",
      "login.password": "Mot de passe",
      "login.loginButton": "Connexion",
      "login.noAccount": "Pas encore de compte ?",
      "login.registerLink": "S'inscrire",
      "retailerMap.unnamed": "Sans nom",
      "retailerMap.dashboard": "Tableau de bord",
      "retailerMap.addressPlaceholder": "Saisissez une adresse...",
      "retailerMap.flyButton": "Aller",
      "bundelSelector.title": "📦 Gestion des packs",
      "bundelSelector.usage": "Vous utilisez actuellement {{active}} sur {{max}} intérêts disponibles.",
      "bundelSelector.selectLabel": "Choisissez un nouveau pack :",
      "bundelSelector.option5": "5 biens (22,50 € / mois)",
      "bundelSelector.option15": "15 biens (60 € / mois)",
      "bundelSelector.option30": "30 biens (100 € / mois)",
      "bundelSelector.option100": "100 biens (300 € / mois)",
      "bundelSelector.upgradeButton": "Mettre à niveau via Stripe",
      "retailerProfile.title": "Profil Revendeur",
      "retailerProfile.backToDashboard": "Retour au tableau de bord",
      "retailerProfile.aantalWinkels": "Nombre de magasins",
      "retailerProfile.actiefInLanden": "Présent dans des pays",
      "retailerProfile.oprichtingsjaar": "Année de création",
      "retailerProfile.aantalMedewerkers": "Nombre d'employés",
      "retailerProfile.omzetIndicatie": "Indication de chiffre d'affaires",
      "retailerProfile.branche": "Secteur",
      "retailerProfile.saveButton": "Enregistrer le profil",
      "interest.completeProfileFirst": "Complétez d’abord votre profil (au moins 3 champs sur 6).",
      "interest.confirmWithdraw": "Retirer l’intérêt ?",
      "interest.withdrawnSuccess": "Intérêt retiré.",
      "interest.bundleFull": "Votre pack est complet. Retirez un intérêt ou passez à une formule supérieure.",
      "interest.saved": "Intérêt enregistré.",
      "interest.noBundlePrompt": "Vous n’avez pas de pack d’intérêts actif.\n\nTapez :\n  « bundle » pour voir les packs,\n  « pay » pour payer 5 € hors TVA pour cette localisation,\nou autre chose pour annuler.",
      "interest.processing": "En cours...",
      "interest.withdraw": "Trek interesse in",
      "interest.show": "Toon interesse",
      "documents.photoUpload.title": "Photos",
      "documents.photoUpload.add": "Ajouter des photos",
      "documents.photoUpload.remove": "Supprimer",
      "documents.rentDetails.title": "Détails de location",
      "documents.rentDetails.rent": "Loyer",
      "documents.rentDetails.startDate": "Date de début",
      "documents.rentDetails.expiryDate": "Date d'expiration",
      "documents.rentDetails.indexationDate": "Date d'indexation",
      "documents.rentDetails.terminationDate": "Date de résiliation",
      "documents.rentDetails.noticePeriod": "Préavis (mois)",
      "documents.rentDetails.guaranteeType": "Type de garantie",
      "documents.rentDetails.guaranteeAmount": "Montant de la garantie",
      "documents.rentDetails.selectOption": "-- Sélectionner --",
      "documents.rentDetails.securityDeposit": "Dépôt de garantie",
      "documents.rentDetails.bankGuarantee": "Garantie bancaire",
      "brokerProperty.title": "Données du bien",
      "brokerProperty.commencementRent": "Prix de location initial",
      "brokerProperty.currentRent": "Loyer actuel",
      "brokerProperty.askingPrice": "Prix demande",
      "brokerProperty.keyMoney": "Droits d'entrée",
      "brokerProperty.commencementDate": "Date de début",
      "brokerProperty.expirationDate": "Date d'expiration",
      "brokerProperty.indexationDate": "Date d'indexation",
      "brokerProperty.terminationDate": "Date de résiliation",
      "brokerProperty.noticePeriod": "Période de préavis (mois)",
      "brokerProperty.guarantee": "Garantie",
      "brokerProperty.select": "-- Sélectionner --",
      "brokerProperty.securityDeposit": "Dépôt de garantie",
      "brokerProperty.bankGuarantee": "Garantie bancaire",
      "brokerProperty.guaranteeAmount": "Montant de la garantie",
      "brokerProperty.purchasePrice": "Prix d'achat",
      "brokerProperty.landlord": "Propriétaire",
      "brokerProperty.purchaseYear": "Année d'achat",
      "brokerProperty.cadastralMunicipality": "Commune cadastrale",
      "brokerProperty.section": "Section",
      "brokerProperty.number": "Numéro",
      "brokerProperty.cadastralSize": "Surface cadastrale",
      "comments.title": "Opmerkingen",
      "comments.none": "Geen opmerkingen toegevoegd.",
      "comments.placeholder": "Typ hier een nieuwe opmerking...",
      "comments.add": "Voeg opmerking toe",
      "huur.title": "Huurgegevens",
      "huur.rent": "Huurprijs",
      "huur.commencementDate": "Ingangsdatum",
      "huur.expirationDate": "Expiratiedatum",
      "huur.indexationDate": "Indexatiedatum",
      "huur.terminationDate": "Opzegdatum",
      "huur.noticePeriod": "Opzegtermijn (maanden)",
      "huur.guaranteeType": "Garantievorm",
      "huur.selecteer": "-- Selecteer --",
      "huur.securityDeposit": "Waarborgsom",
      "huur.bankGuarantee": "Bankgarantie",
      "huur.guaranteeAmount": "Garantiebedrag",
      "contact.title": "Contactpersonen",
      "contact.landlord": "Propriétaire",
      "contact.staff": "Personeel",
      "contact.broker": "Agent immobilier",
      "contact.name": "Naam",
      "contact.phone": "Telefoon",
      "contact.email": "Adresse e-mail",
      "contact.position": "Functie",
      "contact.remove": "Verwijderen",
      "contact.add": "Contactpersoon toevoegen",
      "brokerContact.title": "Personnes de contact",
      "brokerComments.title": "Commentaires",
      "brokerComments.noComments": "Aucun commentaire ajouté.",
      "brokerComments.placeholder": "Tapez un nouveau commentaire...",
      "brokerComments.add": "Ajouter un commentaire",
      "brokerPhotos.title": "Photos de l'agence",
      "brokerPhotos.add": "Ajouter une photo",
      "brokerPhotos.remove": "Supprimer",
      "brokerPhotos.photo": "Photo",
      "brokerPhotos.tooLarge": "est supérieur à 10 Mo",
      "brokerDocs.title": "Documents de l'agence",
      "brokerDocs.add": "Ajouter un document",
      "brokerDocs.delete": "Supprimer",
      "brokerDocs.tooLarge2": "is te groot (max 10MB)",
      "account.title": "Accountgegevens",
      "account.name": "Naam",
      "account.email": "Adresse e-mail",
      "account.phone": "Numéro de téléphone",
      "account.address": "Adresse",
      "account.website": "Site web",
      "account.linkedin": "LinkedIn-profiel",
      "account.logo": "Logo",
      "account.chooseFile": "Kies een bestand",
      "account.selectedFile": "Gekozen bestand",
      "account.uploadLogo": "Upload logo",
      "account.save": "Opslaan",
      "account.saved": "Données du compte enregistrées",
      "account.saveSuccess": "Données du compte enregistrées avec succès",
      "account.saveFailed": "Échec de l’enregistrement",
      "account.logoUploaded": "Logo téléversé",
      "account.logoTooLarge": "Logo is te groot (max 2MB)",
      "account.noFileChosen": "Geen bestand gekozen",
      "account.loading": "Bezig met laden...",
      "account.invalidEmail": "Ongeldig e-mailadres",
      "account.invalidPhone": "Ongeldig telefoonnummer",
      "account.fetchError": "Fout bij ophalen profiel",
      "account.saveError": "Fout bij opslaan profiel",
      "account.logoUploadError": "Fout bij uploaden logo",
      "myInterests.title": "⭐ Mijn interesses",
      "myInterests.backToDashboard": "Terug naar dashboard",
      "myInterests.loading": "Interesses laden...",
      "myInterests.noResults": "Geen resultaten",
      "myInterests.ownInterests": "👤 Je eigen interesses",
      "myInterests.groupInterests": "👥 Interesses van je organisatie",
      "myInterests.country": "Land",
      "myInterests.city": "Ville",
      "myInterests.address": "Adresse",
      "myInterests.currentRetailer": "Huidige retailer",
      "myInterests.date": "Date",
      "myInterests.shownBy": "Getoond door",
      "myInterests.link": "Link",
      "myInterests.action": "Actie",
      "myInterests.remove": "Verwijder",
      "myInterests.removeSuccess": "Intérêt supprimé",
      "myInterests.removeError": "Erreur lors de la suppression de l’intérêt",
      "broker.listingsTitle": "Mes offres de location",
      "subscriptionPage.loading": "Laden...",
      "subscriptionPage.backToDashboard": "Terug naar dashboard",
      "subscriptionPage.title": "📦 Abonnement",
      "subscriptionPage.userSection.title": "👤 Gebruiker",
      "subscriptionPage.userSection.name": "Naam",
      "subscriptionPage.userSection.email": "Emailadres",
      "subscriptionPage.userSection.company": "Bedrijfsnaam",
      "subscriptionPage.userSection.kvk": "KVK nummer",
      "subscriptionPage.subscription.trialUntil": "📅 Proefperiode tot",
      "subscriptionPage.subscription.unknown": "Onbekend",
      "subscriptionPage.subscription.base": "📦 Basisabonnement",
      "subscriptionPage.subscription.perMonth": "per maand",
      "subscriptionPage.subscription.includes3": "inclusief 3 panden",
      "subscriptionPage.subscription.extra": "Biens supplémentaires",
      "subscriptionPage.subscription.paidStart": "📆 Start betaald abonnement",
      "subscriptionPage.subscription.notStarted": "Nog niet gestart",
      "subscriptionPage.subscription.totalProperties": "🧾 Totaal aantal panden",
      "subscriptionPage.subscription.forRent": "🏷️ Te huur",
      "subscriptionPage.subscription.totalMonthly": "💰 Totale maandkosten",
      "subscriptionPage.subscription.renewsOn": "Abonnement wordt verlengd op",
      "subscriptionPage.subscription.note": "Opzegtermijn: 1 maand ⬢ Abonnement blijft actief tenzij je het hebt opgezegd.",
      "subscriptionPage.subscription.trialEnded": "Proefperiode beëindigd op",
      "owner.listingsPage.title": "Mes offres de location",
      "owner.listingsPage.column.country": "Land",
      "owner.listingsPage.column.city": "Ville",
      "owner.listingsPage.column.address": "Adresse",
      "owner.listingsPage.column.name": "Huidige huurder",
      "owner.listingsPage.column.website": "Site web",
      "owner.listingsPage.column.owner": "Propriétaire",
      "owner.listingsPage.column.currentRetailer": "Huidige huurder",
      "owner.listingsPage.column.opdrachtgever": "Asset Manager",
      "owner.listingsPage.column.broker": "Agent immobilier",
      "owner.financieringBlock.title": "Données financières",
      "owner.financieringBlock.koopsom": "Prix d’achat",
      "owner.financieringBlock.aankoopdatum": "Date d’achat",
      "owner.financieringBlock.hypotheek": "Montant hypothécaire",
      "owner.financieringBlock.rentepercentage": "Taux d’intérêt",
      "owner.financieringBlock.bank": "Banque",
      "owner.financieringBlock.looptijd": "Durée (années)",
      "owner.financieringBlock.jaar": "année",
      "owner.ownerFields.title": "Données propriétaire",
      "owner.ownerFields.parentCompany": "Société mère propriétaire",
      "owner.ownerFields.owner": "Propriétaire",
      "owner.ownerFields.contactPerson": "Personne de contact",
      "owner.ownerFields.email": "Adresse e-mail",
      "owner.ownerFields.phone": "Numéro de téléphone",
      "owner.huurgegevensBlock.title": "Données locatives",
      "owner.huurgegevensBlock.formeleHuurder": "Locataire officiel",
      "owner.huurgegevensBlock.huurprijs": "Loyer",
      "owner.huurgegevensBlock.ingangsdatum": "Date de début",
      "owner.huurgegevensBlock.expiratiedatum": "Date d’expiration",
      "owner.huurgegevensBlock.resterendeLooptijdMaanden": "Durée restante du bail",
      "owner.huurgegevensBlock.huurtermijn": "Durée du bail",
      "owner.huurgegevensBlock.verlengingsjaren": "Années de prolongation",
      "owner.huurgegevensBlock.huurvrijePeriodeMaanden": "Période sans loyer",
      "owner.huurgegevensBlock.indexatiedatum": "Date d’indexation",
      "owner.huurgegevensBlock.opzegdatum": "Date de préavis",
      "owner.huurgegevensBlock.opzegtermijn": "Délai de préavis",
      "owner.huurgegevensBlock.garantiesoort": "Type de garantie",
      "owner.huurgegevensBlock.kiesOptie": "Choisir une option",
      "owner.huurgegevensBlock.waarborgsom": "Dépôt de garantie",
      "owner.huurgegevensBlock.bankgarantie": "Garantie bancaire",
      "owner.huurgegevensBlock.concerngarantie": "Garantie de groupe",
      "owner.huurgegevensBlock.garantiebedrag": "Montant de la garantie",
      "owner.huurgegevensBlock.noGuarantee": "Aucune garantie",
      "owner.contactgegevensBlock.title": "Coordonnees",
      "owner.contactgegevensBlock.company": "Entreprise",
      "owner.contactgegevensBlock.name": "Nom",
      "owner.contactgegevensBlock.phone": "Telephone",
      "owner.contactgegevensBlock.email": "E-mail",
      "owner.contactgegevensBlock.function": "Fonction",
      "owner.contactgegevensBlock.remove": "Supprimer le contact",
      "owner.contactgegevensBlock.add": "Ajouter un contact",
      "owner.photoUpload.title": "Foto's uploaden",
      "owner.photoUpload.add": "Foto toevoegen",
      "owner.photoUpload.remove": "Verwijderen",
      "owner.photoUpload.tooLarge": "is te groot (max 10MB)",
      "owner.opmerkingen.title": "Notes",
      "owner.opmerkingen.none": "Aucune note ajoutée.",
      "owner.opmerkingen.unknownAuthor": "Auteur inconnu",
      "owner.opmerkingen.add": "Ajouter une note",
      "owner.opmerkingen.placeholder": "Saisissez votre note ici...",
      "popup2.addedState": "Ajouté",
      "popup2.adding": "Ajout...",
      "popup2.extraPropertyTitle": "Add extra property",
      "popup2.setForRent": "Set for rent",
      "popup2.rentStatusActive": "For rent (active)",
      "popup2.rentActionErrorPrefix": "Error changing rental status: ",
      "popup2.rentConfirmTitle": "List property for rent",
      "popup2.rentConfirmDescription": "Listing this property for rent normally costs EUR 15 per month, but is currently free during the launch period.",
      "popup2.rentLaunchFree": "Now free",
      "popup2.dontShowAgain": "Do not show again",
      "propertyDetails.addCommentPlaceholder": "Voeg opmerking toe",
      "propertyDetails.contactName": "Naam",
      "propertyDetails.role": "Functie",
      "propertyDetails.phone": "Telefoon",
      "propertyDetails.email": "Adresse e-mail",
      "propertyDetails.addContact": "Ajouter un contact",
      "propertyDetails.contactpersonen": "Contactpersonen",
      "propertyDetails.delete": "Verwijderen",
      "propertyDetails.addDocument": "Document toevoegen",
      "propertyDetails.documentLabel": "Document",
      "propertyDetails.addPhoto": "Foto toevoegen",
      "propertyDetails.publicDataDivider": "Données publiques",
      "propertyDetails.privateDataDivider": "Données privées",
      "propertyDetails.commentsDivider": "Notes",
      "propertyDetails.contactsDivider": "Contacts",
      "propertyDetails.documentsDivider": "Documents",
      "propertyDetails.photosDivider": "Photos",
      "propertyDetails.floorplansDivider": "Plans",
      "propertyDetails.addFloorplan": "Ajouter un plan",
      "propertyDetails.removeFloorplan": "Supprimer le plan",
      "propertyDetails.floorplansInfo": "Téléversez les plans au format JPG ou PNG. Ces plans sont utilisés dans les brochures. Les fichiers PDF peuvent être stockés sous Documents.",
      "propertyDetails.ownerData": "Donnees proprietaire",
      "propertyDetails.floorAreaTitle": "Surface par niveau (surface brute)",
      "propertyDetails.retailSurface": "Surface locative",
      "propertyDetails.secondarySurface": "Secondary surface",
      "propertyDetails.retailSpace": "Commerce",
      "propertyDetails.secondarySpace": "Secondaire",
      "propertyDetails.sessionExpired": "Session expired, please log in again.",
      "propertyDetails.removeField": "Supprimer le champ",
      "propertyDetails.removeFieldHint": "Supprimez les champs supplementaires en double-cliquant sur le champ puis en choisissant Supprimer le champ.",
      "propertyDetails.autosave.saving": "Enregistrement...",
      "propertyDetails.autosave.saved": "Enregistré",
      "propertyDetails.autosave.error": "Échec de l’enregistrement",
      "propertyDetails.autosave.active": "Enregistrement automatique actif",
      "propertyDetails.popupSettings.open": "Ouvrir les parametres",
      "propertyDetails.popupSettings.hide": "Masquer les parametres",
      "propertyDetails.popupSettings.title": "Parametres du popup",
      "propertyDetails.popupSettings.description": "Choisissez les champs visibles dans le popup de la carte. Cela vaut pour les champs standards et vos champs supplementaires.",
      "propertyDetails.popupSettings.extraFields": "champs supplementaires",
      "propertyDetails.popupSettings.noExtraFields": "Aucun champ supplementaire dans cette section.",
      "propertyDetails.popupSettings.showInPopup": "Afficher dans le popup",
      "propertyDetails.popupSettings.hideInPopup": "Masquer dans le popup",
      "propertyDetails.leaseTerm": "Lease term (years)",
      "propertyDetails.extensionYears": "Extension years",
      "propertyDetails.rentFreePeriodMonths": "Rent-free period (months)",
      "propertyDetails.front": "Façade",
      "mapSettings.backToDashboard": "Terug naar dashboard",
      "mapSettings.title": "Parametres de carte",
      "mapSettings.subtitle": "Ajustez les couleurs des batiments et des noms de marqueurs",
      "mapSettings.fetchWarn": "Impossible de charger les parametres",
      "mapSettings.noUser": "Aucun utilisateur trouve.",
      "mapSettings.invalidHex": "Ongeldige hexkleur. Gebruik bijv. #0077cc.",
      "mapSettings.saved": "Parametres enregistres.",
      "mapSettings.saveFailed": "Echec de l'enregistrement.",
      "mapSettings.retailColorLabel": "Couleur des batiments retail",
      "mapSettings.retailColorPicker": "Choisir la couleur des batiments retail",
      "mapSettings.otherColorLabel": "Couleur des autres batiments",
      "mapSettings.otherColorPicker": "Choisir la couleur des autres batiments",
      "mapSettings.opacityLabel": "Opacite des autres batiments : {{value}}",
      "mapSettings.opacityAria": "Curseur d'opacite",
      "mapSettings.markerNameColorLabel": "Marker naamkleur (normaal)",
      "mapSettings.markerNameColorPicker": "Kies marker naamkleur (normaal)",
      "mapSettings.markerNameHoverColorLabel": "Marker naamkleur (hover)",
      "mapSettings.markerNameHoverColorPicker": "Kies marker naamkleur (hover)",
      "mapSettings.previewRetail": "Mise en evidence retail",
      "mapSettings.previewOther": "Autres batiments",
      "mapSettings.previewMarkerNormal": "Marker (normaal)",
      "mapSettings.previewMarkerHover": "Marker (hover)",
      "mapSettings.saving": "Opslaan⬦",
      "mapSettings.save": "Enregistrer les parametres",
      "mapSettings.reset": "Reinitialiser",
      "mapSettings.cancel": "Annuler",
      "mapSettings.hexHelp": "Gebruik hex, bijv. #0077cc",
      "common.backToDashboard": "Terug naar dashboard",
      "requests.title": "Demandes",
      "requests.overview": "Overview",
      "requests.loading": "Loading...",
      "requests.none": "No requests received for your properties.",
      "requests.columns.location": "Locatie",
      "requests.columns.number": "No.",
      "requests.columns.city": "Ville",
      "requests.columns.address": "Adresse",
      "requests.columns.tenant": "Tenant",
      "requests.columns.forRent": "ì louer",
      "requests.columns.total": "Total",
      "requests.columns.purchased": "Purchased",
      "requests.columns.date": "Date",
      "requests.columns.interestedParty": "Interested party",
      "requests.columns.profile": "Profil",
      "requests.columns.type": "Type",
      "requests.columns.actions": "Actions",
      "requests.interestTypes.forRent": "For-rent interest",
      "requests.interestTypes.general": "General interest",
      "requests.profile.branch": "Branch",
      "requests.profile.shops": "Stores",
      "requests.profile.countries": "Countries",
      "requests.profile.revenue": "Revenue",
      "requests.download": "📥 Download contact details",
      "requests.downloadLabel": "Download contact details",
      "requests.payToView": "Acheter les coordonnées (49 €)",
      "requests.payToViewLabel": "Acheter les coordonnées (49 €)",
      "requests.shielded": "Hidden",
      "requests.removeError": "Removing the request failed.",
      "requests.paymentError": "Er is iets misgegaan bij het starten van de betaling.",
      "retailerProfile.back": "Terug",
      "retailerProfile.personalTab": "Persoonlijk profiel",
      "retailerProfile.companyTab": "Bedrijfsprofiel",
      "retailerProfile.firstName": "Prénom",
      "retailerProfile.lastName": "Nom",
      "retailerProfile.function": "Functie",
      "retailerProfile.phone": "Numéro de téléphone",
      "retailerProfile.email": "Adresse e-mail",
      "retailerProfile.linkedin": "LinkedIn-profiel",
      "retailerProfile.loading": "⏳ Chargement...",
      "retailerProfile.loadingText": "Even geduld a.u.b...",
      "retailerProfile.success": "Profil enregistré avec succès.",
      "retailerProfile.error": "Échec de l’enregistrement",
      "retailerProfile.bedrijfsnaam": "Bedrijfsnaam",
      "retailerProfile.website": "Site web",
      "retailerProfile.hoofdkantoor": "Hoofdkantoor",
      "retailerProfile.logo": "Logo",
      "retailerProfile.kvkNummer": "KvK-nummer",
      "retailerProfile.btwNummer": "BTW-nummer",
      "dashboard.myStores": "Mes magasins",
      "myStores.title": "Mes magasins",
      "myStores.ownStores": "Mes magasins",
      "myStores.groupStores": "Winkels van mijn organisatie",
      "myStores.noResults": "Geen resultaten",
      "myStores.loading": "Laden...",
      "myStores.backToDashboard": "Terug naar dashboard",
      "myStores.nr": "Nr.",
      "myStores.city": "Ville",
      "myStores.address": "Adresse",
      "myStores.name": "Naam winkel",
      "myStores.source": "Bron",
      "myStores.link": "Details",
      "myStores.country": "Land",
      "myStores.allCountries": "Alle landen",
      "myStores.allCities": "Alle steden",
      "retailerProperty.loading": "Winkel laden...",
      "retailerProperty.notFound": "Winkel niet gevonden",
      "retailerProperty.back": "Terug",
      "retailerProperty.address": "Adresse",
      "retailerProperty.country": "Land",
      "retailerProperty.source": "Bron",
      "retailerProperty.publicDataDivider": "Données publiques",
      "retailerProperty.privateDataDivider": "Données privées",
      "retailerProperty.commentsDivider": "Opmerkingen",
      "retailerProperty.contactsDivider": "Contacts",
      "retailerProperty.documentsDivider": "Documenten",
      "retailerProperty.photosDivider": "Photos",
      "retailer.huurgegevensBlock.title": "Huurgegevens",
      "retailer.huurgegevensBlock.huurprijs": "Huurprijs",
      "retailer.huurgegevensBlock.ingangsdatum": "Ingangsdatum",
      "retailer.huurgegevensBlock.expiratiedatum": "Expiratiedatum",
      "retailer.huurgegevensBlock.indexatiedatum": "Indexatiedatum",
      "retailer.huurgegevensBlock.opzegdatum": "Opzegdatum",
      "retailer.huurgegevensBlock.opzegtermijn": "Opzegtermijn (maanden)",
      "retailer.huurgegevensBlock.garantiesoort": "Garantiesoort",
      "retailer.huurgegevensBlock.garantiebedrag": "Garantiebedrag",
      "retailer.huurgegevensBlock.kiesOptie": "Kies een optie",
      "retailer.huurgegevensBlock.waarborgsom": "Waarborgsom",
      "retailer.huurgegevensBlock.bankgarantie": "Bankgarantie",
      "retailer.huurgegevensBlock.concerngarantie": "Concerngarantie",
      "propertyDetails.extraFieldsDivider": "Extra velden",
      "propertyDetails.noComments": "Geen opmerkingen",
      "extraFieldsBlock.title": "Champs supplementaires",
      "extraFieldsBlock.showInPopup": "Zichtbaar in popup",
      "extraFieldsBlock.addField": "Ajouter un champ",
      "extraFieldsBlock.addHeader": "Ajouter une section",
      "extraSections.titleLabel": "Titel",
      "extraSections.fieldLabel": "Nom du champ",
      "extraSections.fieldType": "Type",
      "extraSections.value": "Waarde",
      "extraSections.addField": "Ajouter un champ",
      "extraSections.addSection": "Ajouter une section",
      "extraSections.newTab": "Nouvel onglet",
      "extraSections.tabName": "Nom de l'onglet",
      "extraSections.renameTab": "Renommer l'onglet",
      "extraSections.untitledTab": "Nom de l'onglet",
      "extraSections.sectionName": "Nom de la section",
      "rentalData.addField": "Ajouter un champ",
      "financialData.addField": "Ajouter un champ",
      "addMarker.retailerName": "Revendeur",
      "addMarker.unknownAddress": "Adresse inconnue",
      "addMarker.unknownCity": "Ville inconnue",
      "owners.add.success": "Pand succesvol toegevoegd aan je portefeuille.",
      "owners.add.missingParameters": "Ontbrekende gegevens: e-mailadres of pand-ID.",
      "owners.add.invalidId": "Ongeldig pand-ID.",
      "owners.add.noAccess": "Alleen eigenaren kunnen panden toevoegen.",
      "owners.add.alreadyInMine": "Dit pand staat al in je eigen portefeuille.",
      "owners.add.alreadyInOrgPortfolio": "Dit pand staat al in de organisatieportefeuille.",
      "owners.add.extraRequiresPayment": "Voor dit extra pand is een aanvullende betaling vereist.",
      "owners.add.trialLimitReached": "Je proefperiode staat maximaal 3 panden toe. Activeer een abonnement om meer panden toe te voegen.",
      "owners.add.trialExpired": "Je proefperiode is verlopen. Activeer een abonnement om panden toe te voegen.",
      "owners.add.error": "Er is een fout opgetreden bij het toevoegen van het pand.",
      "retailerMap.paywall.title": "Je abonnement is verlopen",
      "retailerMap.paywall.body": "Activeer je abonnement om de kaart, panddetails en bewerkingen te gebruiken.",
      "retailerMap.paywall.activate": "Activeer abonnement",
      "retailerMap.paywall.openDashboard": "Open dashboard",
      "retailerMap.paywall.error.noJwt": "Je bent niet ingelogd. Log in om de kaart te gebruiken.",
      "retailerMap.paywall.error.sessionExpired": "Je sessie is verlopen. Log opnieuw in om verder te gaan.",
      "retailerMap.paywall.error.noSubscription": "Je hebt nog geen actief abonnement.",
      "retailerMap.paywall.error.accessDenied": "Je hebt geen toegang tot deze kaart.",
      "retailerMap.paywall.error.serverError": "Er is een interne fout opgetreden. Probeer het later opnieuw.",
      "retailerMap.paywall.error.network": "We konden je abonnement niet controleren. Controleer je internetverbinding of probeer het later opnieuw.",
      "retailerMap.paywall.error.trialExpired": "Je proefperiode is verlopen en er is geen actief abonnement. Activeer je abonnement om verder te gaan.",
      "subscriptionPage.subscription.forRentBackend": "🏷️ Te huur",
      "admin.common.openModule": "Open module",
      "admin.common.refreshing": "Refreshing...",
      "admin.common.today": "Today",
      "admin.common.week": "Week",
      "admin.common.month": "Month",
      "admin.common.year": "Year",
      "admin.common.noData": "No data available yet.",
      "admin.common.unknown": "unknown",
      "admin.common.loading": "Loading...",
      "admin.common.userLoadFailed": "User could not be loaded.",
      "admin.dashboard.aiReview": "AI review",
      "admin.home.title": "Retailmaps Admin Ops",
      "admin.home.subtitle": "Central control layer for mail, AI review, analytics and administration. This is where agents, teams and operational processes come together.",
      "admin.home.heroStats.openReview": "Open review",
      "admin.home.heroStats.inbox7d": "Inbox 7d",
      "admin.home.heroStats.activeLanguages": "Active languages",
      "admin.home.heroStats.agentLanes": "Agent lanes",
      "admin.home.sections.alerts": "Operational alerts",
      "admin.home.sections.snapshot": "Operational snapshot",
      "admin.home.alerts.reviewBacklog.label": "Review backlog",
      "admin.home.alerts.reviewBacklog.text": "{{count}} threads are waiting for review.",
      "admin.home.alerts.draftsReady.label": "Drafts ready",
      "admin.home.alerts.draftsReady.text": "{{count}} drafts are ready to review.",
      "admin.home.alerts.escalations.label": "Escalations",
      "admin.home.alerts.escalations.text": "{{count}} threads need manual follow-up.",
      "admin.home.alerts.stable.label": "Stable",
      "admin.home.alerts.stable.text": "No urgent operational alerts right now.",
      "admin.home.snapshot.draftsReady": "{{count}} drafts ready",
      "admin.home.snapshot.laneDistribution": "Lane distribution",
      "admin.home.snapshot.languages": "Languages",
      "admin.home.snapshot.reviewActions": "Review actions",
      "admin.home.snapshot.approved": "Approved",
      "admin.home.snapshot.edited": "Edited",
      "admin.home.snapshot.escalated": "Escalated",
      "admin.home.snapshot.rejected": "Rejected",
      "admin.home.modules.emailOps.title": "Email Agent Ops",
      "admin.home.modules.emailOps.description": "Triage, review, drafts, knowledge base and escalations for all incoming Retailmaps emails.",
      "admin.home.modules.aiQueue.title": "AI Queue",
      "admin.home.modules.aiQueue.description": "Brand validation and other AI-driven review flows that still need human control.",
      "admin.home.modules.statistics.title": "Statistics",
      "admin.home.modules.statistics.description": "Central overview of volumes, languages, response times, conversions and agent performance.",
      "admin.home.modules.administration.title": "Administration",
      "admin.home.modules.administration.description": "Operational backoffice for billing, subscriptions, mailbox management and internal processes.",
      "admin.emailDashboard.title": "Email Agent Ops",
      "admin.emailDashboard.subtitle": "Review incoming email, improve drafts and grow the knowledge base for the role agents.",
      "admin.emailDashboard.refreshMetrics": "Refresh metrics",
      "admin.emailDashboard.badges.aiActive": "AI active",
      "admin.emailDashboard.badges.aiFallback": "AI fallback",
      "admin.emailDashboard.badges.inboundActive": "Inbound active",
      "admin.emailDashboard.badges.inboundMissing": "Inbound missing",
      "admin.emailDashboard.metrics.openReview": "Open review",
      "admin.emailDashboard.metrics.draftsReady": "Drafts ready",
      "admin.emailDashboard.metrics.activeLanguages": "Active languages",
      "admin.emailDashboard.metrics.brokerLane": "Broker lane",
      "admin.emailDashboard.helpers.openReview": "Threads waiting for review or approval.",
      "admin.emailDashboard.helpers.draftsReady": "Drafts currently ready to send.",
      "admin.emailDashboard.helpers.activeLanguages": "Languages currently seen in the inbox.",
      "admin.emailDashboard.helpers.brokerLane": "Threads currently routed to the broker agent.",
      "admin.brandQueue.title": "AI Queue",
      "admin.brandQueue.pendingTitle": "Brands awaiting review",
      "admin.brandQueue.verifiedTitle": "Verified brands",
      "admin.brandQueue.reject": "Reject",
      "admin.brandQueue.columns.name": "Nom",
      "admin.brandQueue.columns.status": "Statut",
      "admin.brandQueue.columns.createdAt": "Created",
      "admin.brandQueue.columns.actions": "Actions",
      "admin.brandQueue.columns.group": "Group",
      "admin.brandQueue.columns.domain": "Domaine",
      "admin.brandQueue.columns.brands": "Brands",
      "admin.brandQueue.prompts.domain": "Domain for {{name}}? (e.g. levi.com)",
      "admin.brandQueue.prompts.group": "Group / parent company for {{name}}? (e.g. Levi Strauss & Co.)",
      "admin.brandQueue.prompts.reject": "Are you sure you want to reject '{{name}}'?",
      "admin.mailPanel.title": "Agent review inbox",
      "admin.mailPanel.subtitle": "Review, edit and respond to incoming email conversations from one central ops inbox.",
      "admin.mailPanel.refreshInbox": "Refresh inbox",
      "admin.mailPanel.mode": "Mode",
      "admin.mailPanel.threads": "threads",
      "admin.mailPanel.messages": "messages",
      "admin.mailPanel.inbound": "inbound",
      "admin.mailPanel.aiInactive": "AI is inactive, fallback drafts are being used.",
      "admin.mailPanel.quickFilters.all": "All",
      "admin.mailPanel.quickFilters.broker": "Broker inbox",
      "admin.mailPanel.quickFilters.retailer": "Retailer inbox",
      "admin.mailPanel.quickFilters.owner": "Owner inbox",
      "admin.mailPanel.quickFilters.support": "Support inbox",
      "admin.mailPanel.quickFilters.router": "Router inbox",
      "admin.mailPanel.filters.search": "Search",
      "admin.mailPanel.filters.lane": "Lane",
      "admin.mailPanel.filters.status": "Statut",
      "admin.mailPanel.filters.agent": "Agent",
      "admin.mailPanel.filters.language": "Langue",
      "admin.mailPanel.filters.review": "Review",
      "admin.mailPanel.filters.all": "All",
      "admin.mailPanel.filters.allLanes": "All lanes",
      "admin.mailPanel.filters.allStatuses": "All statuses",
      "admin.mailPanel.filters.allAgents": "All agents",
      "admin.mailPanel.filters.allLanguages": "All languages",
      "admin.mailPanel.filters.onlyNeedsReview": "Only needs review",
      "admin.mailPanel.filters.noReview": "No review filter",
      "admin.mailPanel.filters.clear": "Clear filters",
      "admin.mailPanel.inbox": "Inbox",
      "admin.mailPanel.noSubject": "No subject",
      "admin.mailPanel.unknownSender": "Unknown sender",
      "admin.mailPanel.noThreads": "No threads match the current filters.",
      "admin.mailPanel.threadDetail": "Thread detail",
      "admin.mailPanel.loadingThread": "Loading thread...",
      "admin.mailPanel.agentLabel": "Agent",
      "admin.mailPanel.languageLabel": "Langue",
      "admin.mailPanel.statusLabel": "Statut",
      "admin.mailPanel.autoReplyEligible": "Auto-reply eligible",
      "admin.mailPanel.reviewRequired": "Review required",
      "admin.mailPanel.lastActivity": "Last activity",
      "admin.mailPanel.escalation": "Escalation",
      "admin.mailPanel.incomingMail": "Incoming mail",
      "admin.mailPanel.incomingFrom": "Incoming from",
      "admin.mailPanel.noPlainText": "No plain text body available.",
      "admin.mailPanel.agentDraft": "Agent draft",
      "admin.mailPanel.subject": "Subject",
      "admin.mailPanel.reply": "Reply",
      "admin.mailPanel.saveEditedAsKnowledge": "Save edited version as knowledge article",
      "admin.mailPanel.sending": "Envoi...",
      "admin.mailPanel.sendReply": "Send reply",
      "admin.mailPanel.approve": "Approve",
      "admin.mailPanel.saveEdited": "Save edited",
      "admin.mailPanel.escalate": "Escalate",
      "admin.mailPanel.reject": "Reject",
      "admin.mailPanel.feedbackProcessed": "Feedback processed successfully.",
      "admin.mailPanel.feedbackFailed": "Processing feedback failed.",
      "admin.mailPanel.replySentVia": "Reply sent to {{recipient}} via {{provider}}.",
      "admin.mailPanel.replySendFailed": "Sending reply failed.",
      "admin.mailPanel.manualEscalationNote": "Manual escalation requested by admin review.",
      "admin.mailPanel.noDraft": "No draft is available yet for this thread.",
      "admin.mailPanel.selectThread": "Select a thread to review its details and draft.",
      "admin.mailPanel.knowledgeBase": "Knowledge base",
      "admin.mailPanel.knowledgeTitle": "Title",
      "admin.mailPanel.knowledgeContent": "Content",
      "admin.mailPanel.knowledgeKeywords": "Keywords (comma separated)",
      "admin.mailPanel.addKnowledgeArticle": "Add knowledge article",
      "admin.mailPanel.knowledgeSaved": "Knowledge article saved.",
      "admin.mailPanel.knowledgeSaveFailed": "Saving knowledge article failed.",
      "admin.mailPanel.noKnowledgeArticles": "No knowledge articles available yet.",
      "admin.statistics.title": "Statistics",
      "admin.statistics.subtitle": "Live operations overview of volumes, review load, languages and feedback on agent answers.",
      "admin.statistics.meta.generatedAt": "Generated at",
      "admin.statistics.meta.mailThreads": "Mail threads",
      "admin.statistics.meta.activeInboxCountries": "Active inbox countries",
      "admin.statistics.overview.users": "Users",
      "admin.statistics.overview.totalInterests": "Total interests",
      "admin.statistics.overview.totalProperties": "Total properties",
      "admin.statistics.overview.activeForRent": "Active for-rent stock",
      "admin.statistics.overview.activeListings": "Active listings",
      "admin.statistics.overview.activeSubscriptions": "Active subscriptions",
      "admin.statistics.roles.admins": "Admins",
      "admin.statistics.roles.brokers": "Brokers",
      "admin.statistics.roles.retailers": "Retailers",
      "admin.statistics.roles.owners": "Owners",
      "admin.statistics.conversion.interestsPerActiveProperty": "Interests per active property",
      "admin.statistics.conversion.propertiesWithInterest": "Properties with interest",
      "admin.statistics.conversion.propertiesWithInterestShare": "Share of properties with interest",
      "admin.statistics.conversion.listingUnlockRate": "Listing unlock rate",
      "admin.statistics.conversion.contactUnlocks": "Contact unlocks",
      "admin.statistics.conversion.unlockRevenue": "Unlock revenue",
      "admin.statistics.manual.manualAddedToday": "Manually added today",
      "admin.statistics.manual.manualAddedMonth": "Manually added this month",
      "admin.statistics.manual.manualEditedToday": "Manually edited today",
      "admin.statistics.manual.manualEditedMonth": "Manually edited this month",
      "admin.statistics.manual.topCreators": "Top manual creators",
      "admin.statistics.manual.topEditors": "Top manual editors",
      "admin.statistics.sections.rolesAndGrowth": "Roles and growth",
      "admin.statistics.sections.accountsPerRole": "Accounts per role",
      "admin.statistics.sections.newUsers": "New users",
      "admin.statistics.sections.userCountries": "User countries",
      "admin.statistics.sections.userCountriesHelp": "Top countries based on user/company profile data.",
      "admin.statistics.sections.interestsByPeriod": "Interests by period",
      "admin.statistics.sections.manualInteraction": "Manual system interaction",
      "admin.statistics.sections.manualInteractionHelp": "User actions in which properties were manually added or edited.",
      "admin.statistics.sections.heatmapHotspots": "Interest hotspots",
      "admin.statistics.sections.heatmapHotspotsHelp": "Top city-country combinations based on recorded interests.",
      "admin.statistics.sections.interestsByCity": "Interests by city",
      "admin.statistics.sections.propertiesAdded": "Properties added",
      "admin.statistics.sections.topPropertyCountries": "Top countries in the property database",
      "admin.statistics.sections.activeForRentStock": "Active for-rent stock",
      "admin.statistics.sections.conversionSignals": "Conversion & commercial signals",
      "admin.statistics.sections.agentMailContext": "Agent mail context",
      "admin.administration.title": "Administration",
      "admin.administration.subtitle": "Operational backoffice for mail health, environment status and internal ops readiness.",
      "admin.administration.sections.mailInfrastructure": "Mail infrastructure",
      "admin.administration.sections.healthCheck": "Health check",
      "admin.administration.sections.operationalStatus": "Operational status",
      "admin.administration.sections.roadmap": "Next backoffice steps",
      "admin.administration.fields.provider": "Provider",
      "admin.administration.fields.from": "From",
      "admin.administration.fields.frontendUrl": "Frontend URL",
      "admin.administration.fields.internalInboxes": "Internal inboxes",
      "admin.administration.fields.testRecipient": "Test recipient",
      "admin.administration.health.mailProvider": "Mail provider",
      "admin.administration.health.mailProviderActive": "{{provider}} actif",
      "admin.administration.health.notConfigured": "Not configured",
      "admin.administration.health.inboundAgent": "Inbound agent",
      "admin.administration.health.inboundActive": "Inbound receiving active",
      "admin.administration.health.inboundMissing": "Inbound receiving not configured",
      "admin.administration.health.aiClassification": "AI classification",
      "admin.administration.health.aiActive": "OpenAI active",
      "admin.administration.health.fallbackOnly": "Fallback only",
      "admin.administration.health.internalInboxes": "Internal inboxes",
      "admin.administration.health.internalRecipientsConfigured": "{{count}} internal recipients configured",
      "admin.administration.health.noInternalRecipients": "No internal recipients configured",
      "admin.administration.health.actionNeeded": "Action needed",
      "admin.administration.status.threads": "Threads",
      "admin.administration.status.openReview": "Open review",
      "admin.administration.status.draftsReady": "Drafts ready",
      "admin.administration.status.escalations": "Escalations",
      "admin.administration.roadmap.subscriptions": "Subscription and billing controls per role",
      "admin.administration.roadmap.mailboxes": "Mailbox routing and alias management",
      "admin.administration.roadmap.internalNotifications": "Internal notification preferences",
      "admin.administration.roadmap.billing": "Billing exports and invoice overviews",
      "admin.administration.roadmap.escalations": "Escalation rules and SLA monitoring",
      "admin.administration.roadmap.agentPolicies": "Agent policies and role-specific automations",
      "admin.administration.roadmap.footer": "This page is intentionally operational and will expand into the central Retailmaps backoffice.",
      "dashboardOverlay.shared.forRent": "A louer",
      "dashboardOverlay.shared.requests": "Demandes",
      "dashboardOverlay.shared.alerts": "Alertes",
      "dashboardOverlay.shared.analysis": "Analyse",
      "dashboardOverlay.shared.assistant": "Comment ca marche",
      "dashboardOverlay.shared.settings": "Parametres",
      "dashboardOverlay.owner.properties": "Biens",
      "dashboardOverlay.owner.forRent": "A louer",
      "dashboardOverlay.retailer.stores": "Magasins",
      "dashboardOverlay.retailer.interests": "Interets",
      "dashboardOverlay.broker.properties": "Biens",
      "dashboardOverlay.admin.ops": "Ops",
      "dashboardOverlay.admin.mail": "Mail",
      "dashboardOverlay.admin.aiQueue": "AI Queue",
      "dashboardOverlay.admin.statistics": "Statistiques",
      "dashboardOverlay.admin.administration": "Administration",
      "retailerMap.loading.zoomInToLoad": "Zoomez jusqu'a {{zoom}} pour charger les enseignes",
      "retailerMap.loading.fillingStreet": "Chargement des nouveaux locaux. Cela peut prendre jusqu'a 2 min...",
      "retailerMap.loading.paintingFromCenter": "Chargement des locaux depuis le centre...",
      "retailerMap.errors.invalidSession": "No valid session found. Please log in again.",
      "retailerMap.errors.noUserInfo": "No user information available.",
      "retailerMap.errors.unknownRoleSubscription": "Unknown user role. Subscription could not be started.",
      "settingsPanel.common.saving": "Enregistrement...",
      "settingsPanel.common.saved": "Enregistre",
      "settingsPanel.common.saveFailed": "Echec de l enregistrement",
      "settingsPanel.common.ready": "Pret",
      "settingsPanel.regional.title": "Parametres regionaux",
      "settingsPanel.regional.subtitle": "Choisissez le fonctionnement de la langue, de la devise et des unites. Les donnees du navigateur et de la region sont utilisees automatiquement.",
      "settingsPanel.regional.language": "Langue",
      "settingsPanel.regional.currency": "Devise",
      "settingsPanel.regional.units": "Unites",
      "settingsPanel.regional.autoLanguage": "Automatique ({{language}})",
      "settingsPanel.regional.autoCurrency": "Automatique ({{currency}})",
      "settingsPanel.regional.autoUnits": "Automatique ({{units}})",
      "settingsPanel.regional.metric": "Metrique",
      "settingsPanel.regional.imperial": "Imperial",
      "settingsPanel.regional.detectedRegion": "Region detectee : {{region}}",
      "settingsPanel.mailTest.title": "Tester l'e-mail",
      "settingsPanel.mailTest.subtitle": "Verifiez si les parametres e-mail fonctionnent correctement.",
      "settingsPanel.mailTest.send": "Envoyer un e-mail test",
      "settingsPanel.mailTest.sending": "Envoi...",
      "settingsPanel.mailTest.status": "Statut : {{status}}",
      "settingsPanel.mailTest.providerActive": "{{provider}} actif",
      "settingsPanel.mailTest.devPreviewOnly": "Apercu dev uniquement",
      "settingsPanel.mailTest.from": "De : {{value}}",
      "settingsPanel.mailTest.testRecipient": "Destinataire test : {{value}}",
      "settingsPanel.mailTest.internalInboxes": "Boites internes : {{value}}",
      "settingsPanel.mailTest.noneConfigured": "Aucune configuree",
      "settingsPanel.mailTest.notConfigured": "Non configure",
      "settingsPanel.map.title": "Parametres de carte",
      "settingsPanel.map.subtitle": "Ajustez les couleurs des batiments et des noms de marqueurs",
      "settingsPanel.map.invalidOrSaveFailed": "Couleur invalide ou echec de l enregistrement.",
      "settingsPanel.map.highlight.title": "Intensité du surlignage",
      "settingsPanel.map.highlight.description": "Détermine la visibilité des polygones actifs et des sélections.",
      "settingsPanel.map.highlight.retailTitle": "Intensite de mise en evidence des commerces",
      "settingsPanel.map.highlight.retailDescription": "Determine a quel point les commerces ressortent sur la carte.",
      "settingsPanel.map.highlight.otherTitle": "Intensite des autres biens",
      "settingsPanel.map.highlight.otherDescription": "Determine la visibilite des autres biens en couche de fond.",
      "settingsPanel.map.highlight.opacity": "Intensite : {{value}}",
      "settingsPanel.map.markerFont.title": "Taille du texte des marqueurs",
      "settingsPanel.map.markerFont.description": "Determine la taille des noms et libelles sur la carte.",
      "settingsPanel.map.markerFont.size": "Echelle : {{value}}",
      "settingsPanel.map.preview.title": "Apercu",
      "settingsPanel.map.preview.description": "Un apercu rapide du rendu de vos parametres de carte.",
      "settingsPanel.map.colors.retail.label": "Couleur des batiments retail",
      "settingsPanel.map.colors.retail.description": "Bâtiments et mises en évidence pour les objets retail.",
      "settingsPanel.map.colors.other.label": "Couleur des autres batiments",
      "settingsPanel.map.colors.other.description": "Couleur de base des autres biens sur la carte.",
      "settingsPanel.map.colors.retailOutline.label": "Contour des biens actifs",
      "settingsPanel.map.colors.retailOutline.description": "Couleur de bordure des biens actifs et des mises en evidence.",
      "settingsPanel.map.colors.otherOutline.label": "Contour des autres biens",
      "settingsPanel.map.colors.otherOutline.description": "Couleur du contour des autres biens sur la carte.",
      "settingsPanel.map.colors.markerName.label": "Couleur du nom des marqueurs",
      "settingsPanel.map.colors.markerName.description": "Couleur du texte des libelles sur la carte.",
      "settingsPanel.map.colors.markerHover.label": "Couleur au survol",
      "settingsPanel.map.colors.markerHover.description": "Couleur d arriere-plan au survol des libelles.",
      "settingsPanel.map.colors.forRentMarker.label": "Marqueur a louer",
      "settingsPanel.map.colors.forRentMarker.description": "Couleur du texte des marqueurs pour les biens a louer.",
      "settingsPanel.retailerMap.loading.zoomInToLoad": "Zoomez jusqu'a {{zoom}} pour charger les enseignes",
      "settingsPanel.retailerMap.loading.fillingStreet": "Chargement des nouveaux locaux. Cela peut prendre jusqu'a 2 min...",
      "settingsPanel.retailerMap.loading.paintingFromCenter": "Chargement des locaux depuis le centre...",
      "settingsPanel.retailerMap.errors.invalidSession": "Geen geldige sessie gevonden. Log opnieuw in.",
      "settingsPanel.retailerMap.errors.noUserInfo": "Geen gebruikersinformatie beschikbaar.",
      "settingsPanel.retailerMap.errors.unknownRoleSubscription": "Onbekende gebruikersrol. Abonnement kan niet worden gestart.",
      "settingsPanel.dashboardOverlay.owner.properties": "Panden",
      "settingsPanel.dashboardOverlay.owner.forRent": "ì louer",
      "settingsPanel.dashboardOverlay.shared.requests": "Demandes",
      "settingsPanel.dashboardOverlay.shared.alerts": "Alerts",
      "settingsPanel.dashboardOverlay.shared.analysis": "Analyse",
      "settingsPanel.dashboardOverlay.shared.assistant": "Comment ca marche ?",
      "settingsPanel.dashboardOverlay.shared.settings": "Paramètres",
      "settingsPanel.myProperties.nr": "Nr.",
      "settingsPanel.myProperties.city": "Ville",
      "settingsPanel.myProperties.address": "Adresse",
      "settingsPanel.myProperties.tenant": "Huurder",
      "settingsPanel.myProperties.link": "Details",
      "settingsPanel.myProperties.status": "Statut",
      "settingsPanel.myProperties.actions": "Acties",
      "settingsPanel.myProperties.assetManager": "Assetmanager",
      "settingsPanel.myProperties.noAssetManager": "sans asset manager",
      "settingsPanel.myProperties.noResults": "Geen resultaten",
      "settingsPanel.myProperties.ownProperties": "Mijn panden",
      "settingsPanel.myProperties.groupProperties": "Organisatieportefeuille",
      "settingsPanel.myProperties.stopRent": "Stop verhuur",
      "settingsPanel.myProperties.setForRent": "Zet te huur",
      "settingsPanel.myProperties.street": "Straat",
      "settingsPanel.myProperties.allCities": "Alle steden",
      "settingsPanel.myProperties.allStreets": "Alle straten",
      "settingsPanel.myProperties.status.forRent": "ì louer",
      "settingsPanel.myProperties.status.rented": "Verhuurd",
      "settingsPanel.myProperties.bulk.assignToSelection": "Toewijzen aan selectie",
      "settingsPanel.myProperties.bulk.onlyUnassigned": "Alleen zonder assetmanager",
      "settingsPanel.myProperties.bulk.selectAllVisible": "Alles selecteren",
      "settingsPanel.myProperties.bulk.noManagerSelected": "Kies een assetmanager.",
      "settingsPanel.myProperties.bulk.noSelection": "Geen panden geselecteerd.",
      "settingsPanel.myProperties.loading": "Laden...",
      "settingsPanel.myProperties.assignToMe": "Naar mij",
      "settingsPanel.myProperties.view": "Bekijken",
      "settingsPanel.myProperties.assignError": "Toewijzen mislukt.",
      "settingsPanel.myProperties.claimSuccess": "Pand toegevoegd aan je portefeuille.",
      "settingsPanel.myProperties.claimError": "Toevoegen mislukt.",
      "settingsPanel.myProperties.rentToggleError": "Wijzigen van verhuurstatus mislukt.",
      "settingsPanel.myProperties.subscription.required": "Voor deze actie is een actief abonnement nodig.",
      "settingsPanel.myProperties.subscription.badge": "Owner-abonnement",
      "settingsPanel.myProperties.subscription.title": "Klaar voor je volgende pand",
      "settingsPanel.myProperties.subscription.description": "Je trial bevat 3 panden. Voor het volgende pand via de organisatie activeer je het owner-abonnement, waarna je direct verder kunt.",
      "settingsPanel.myProperties.subscription.activate": "Activeer owner-abonnement",
      "settingsPanel.myProperties.subscription.sessionError": "Kan Stripe sessie niet starten.",
      "settingsPanel.myProperties.subscription.stripeMissing": "Stripe.js niet geladen.",
      "settingsPanel.myProperties.subscription.startError": "Kon abonnement niet starten.",
      "settingsPanel.requests.branches.fashionAndApparel": "Kleding en mode",
      "settingsPanel.requests.branches.footwear": "Schoenen",
      "settingsPanel.requests.branches.foodAndBeverage": "Food en beverage",
      "settingsPanel.requests.branches.beautyAndPersonalCare": "Beauty en persoonlijke verzorging",
      "settingsPanel.requests.branches.jewelleryAndWatches": "Juwelen en horloges",
      "settingsPanel.requests.branches.supermarketAndGrocery": "Supermarkt en boodschappen",
      "settingsPanel.requests.branches.electronics": "Elektronica",
      "settingsPanel.requests.branches.homeAndLiving": "Wonen en interieur",
      "settingsPanel.requests.branches.sportsAndOutdoor": "Sport en outdoor",
      "settingsPanel.requests.branches.booksAndMedia": "Boeken en media",
      "settingsPanel.common.cancel": "Annuler",
      "settingsPanel.countries.nl": "Nederland",
      "settingsPanel.countries.be": "België",
      "settingsPanel.countries.de": "Duitsland",
      "settingsPanel.countries.fr": "Frankrijk",
      "settingsPanel.countries.gb": "Verenigd Koninkrijk",
      "settingsPanel.countries.es": "Spanje",
      "settingsPanel.countries.it": "Italië",
      "common.back": "Retour",
      "common.busy": "En cours...",
      "propertyDrawer.title": "Détails du bien",
      "propertyDrawer.loadFailed": "Impossible de charger les détails du bien.",
      "propertyDrawer.openInNewTab": "Ouvrir dans un nouvel onglet",
      "propertyDrawer.address": "Adresse",
      "propertyDrawer.status": "Statut",
      "propertyDrawer.forRent": "ì louer",
      "propertyDrawer.rented": "Loué",
      "propertyDrawer.assetManager": "Asset manager",
      "propertyDrawer.openInMaps": "Ouvrir dans Maps",
      "interestButton.invalidSession": "Session invalide.",
      "interestButton.withdraw": "Retirer",
      "interestButton.showInterest": "Manifester son intérêt",
      "retailerMap.printTooltip": "Choisissez comment exporter la carte",
      "retailerMap.print": "Imprimer",
      "retailerMap.openStreetView": "Ouvrir Street View",
      "retailerMap.closeStreetView": "Fermer Street View",
      "retailerMap.streetView": "Street View",
      "retailerMap.zoomIn": "Zoom avant",
      "retailerMap.zoomOut": "Zoom arrière",
      "retailerMap.highlightEdit.dragHint": "Déplacez des points, supprimez des points ou ajoutez un point.",
      "retailerMap.highlightEdit.selectHint": "Cliquez sur un highlight bleu pour le modifier.",
      "retailerMap.highlightEdit.adminHint": "Outil admin pour les formes de bâtiments incorrectes.",
      "retailerMap.highlightEdit.disable": "Désactiver le mode édition",
      "retailerMap.highlightEdit.edit": "Modifier le highlight",
      "retailerMap.highlightEdit.merge": "Fusionner",
      "retailerMap.highlightEdit.reset": "Réinitialiser",
      "retailerMap.highlightEdit.mergeHint": "Sélectionnez au moins deux highlights bleus. Sélectionnés : {{count}}",
      "retailerMap.highlightEdit.mergeNow": "Fusionner",
      "retailerMap.highlightEdit.buildingId": "Building ID",
      "retailerMap.highlightEdit.addPoint": "Ajouter un point",
      "retailerMap.highlightEdit.removePoint": "Supprimer le point",
      "retailerMap.highlightEdit.makeOneShape": "Créer une seule forme",
      "retailerMap.highlightEdit.removeCorrection": "Supprimer la correction",
      "retailerMap.highlightEdit.restore": "Restaurer le highlight",
      "propertyList.filters.city": "Ville",
      "propertyList.filters.street": "Rue",
      "propertyList.filters.retailer": "Retailer",
      "propertyList.filters.select": "Selectionner...",
      "propertyList.filters.typeStreet": "Saisir une rue...",
      "propertyList.filters.chooseCityFirst": "Choisissez d'abord une ville",
      "propertyList.filters.noStreets": "Aucune rue trouvee",
      "propertyList.filters.cityRequiredForStreet": "Choisissez d abord une ville pour selectionner des rues.",
      "propertyList.filters.retailerExample": "Ex. Suit Supply",
      "propertyList.filters.retailerExampleShort": "Retailer",
      "propertyList.filters.searchAddress": "Rechercher une adresse",
      "propertyList.filters.scopeHint": "Choisissez une rue ou recherchez un retailer pour charger la liste des biens.",
      "propertyList.loading": "Chargement des biens...",
      "propertyList.noPropertiesFound": "Aucun bien trouve",
      "propertyList.openDetails": "Ouvrir les details",
      "propertyList.pagination.rowsPerPage": "Lignes par page",
      "propertyList.columns.number": "N.",
      "propertyList.columns.country": "Pays",
      "propertyList.columns.city": "Ville",
      "propertyList.columns.address": "Adresse",
      "propertyList.columns.retailer": "Retailer",
      "propertyList.columns.status": "Statut",
      "propertyList.columns.showInterest": "Manifester son interet",
      "propertyList.columns.details": "Details",
      "propertyList.columns.analysis": "Analyse",
      "propertyList.columns.interests": "Interets",
      "propertyList.columns.purchased": "Achete",
      "propertyList.columns.rental": "Location",
      "propertyList.status.forRent": "A louer",
      "propertyList.status.notForRent": "Non disponible a la location",
      "propertyList.interests.none": "Aucun interet",
      "propertyList.interests.date": "Date",
      "propertyList.interests.interestedParty": "Interesse",
      "propertyList.interests.type": "Type",
      "propertyList.interests.branch": "Secteur",
      "propertyList.interests.stores": "Magasins",
      "propertyList.interests.contactDetails": "Coordonnees",
      "propertyList.interests.protected": "Masque",
      "propertyList.interests.forRentInterest": "Interet pour location",
      "propertyList.interests.generalInterest": "Interet general",
      "propertyList.interests.downloadContact": "Telecharger les coordonnees",
      "propertyList.interests.buyContact": "Acheter les coordonnees (EUR 9)",
      "propertyList.interests.interest": "Interet",
      "propertyList.contactPurchase.title": "Acheter les coordonnees",
      "propertyList.contactPurchase.description": "Vous achetez les coordonnees liees a cet interet.",
      "propertyList.contactPurchase.invoiceNotice": "Les frais sont factures separement.",
      "propertyList.contactPurchase.buy": "Acheter les coordonnees",
      "common": {
        "loading": "Chargement...",
        "save": "Enregistrer",
        "cancel": "Annuler",
        "edit": "Modifier",
        "delete": "Supprimer",
        "open": "Ouvrir",
        "close": "Fermer",
        "yes": "Oui",
        "no": "Non",
        "busy": "En cours...",
        "active": "Actif",
        "inactive": "Inactif",
        "backToDashboard": "Retour au tableau de bord",
        "download": "T?l?charger",
        "saved": "Enregistre",
        "saving": "Enregistrement...",
        "saveFailed": "Echec de l enregistrement",
        "ready": "Pret",
        "canceled": "Annule",
        "confirm": "Confirmer"
      },
      "settingsPanel": {
        "branding": {
          "title": "Identite du courtier",
          "subtitle": "Telechargez votre logo. Il sera affiche avec vos annonces."
        },
        "common": {
          "saving": "Enregistrement...",
          "saved": "Enregistre",
          "saveFailed": "Echec de l enregistrement",
          "ready": "Pret"
        },
        "regional": {
          "title": "Parametres regionaux",
          "subtitle": "Choisissez le fonctionnement de la langue, de la devise et des unites. Les donnees du navigateur et de la region sont utilisees automatiquement.",
          "language": "Langue",
          "currency": "Devise",
          "units": "Unites",
          "autoLanguage": "Automatique ({{language}})",
          "autoCurrency": "Automatique ({{currency}})",
          "autoUnits": "Automatique ({{units}})",
          "metric": "Metrique",
          "imperial": "Imperial",
          "detectedRegion": "Region detectee : {{region}}"
        },
        "map": {
          "title": "Parametres de carte",
          "subtitle": "Ajustez les couleurs des batiments et des noms de marqueurs",
          "invalidOrSaveFailed": "Couleur invalide ou echec de l enregistrement.",
          "highlight": {
            "retailTitle": "Intensite de mise en evidence des commerces",
            "retailDescription": "Determine a quel point les commerces ressortent sur la carte.",
            "otherTitle": "Intensite des autres biens",
            "otherDescription": "Determine la visibilite des autres biens en couche de fond.",
            "opacity": "Intensite : {{value}}"
          },
          "markerFont": {
            "title": "Taille du texte des marqueurs",
            "description": "Determine la taille des noms et libelles sur la carte.",
            "size": "Echelle : {{value}}"
          },
          "preview": {
            "title": "Apercu",
            "description": "Un apercu rapide du rendu de vos parametres de carte."
          },
          "colors": {
            "retail": {
              "label": "Couleur des batiments retail",
              "description": "Bâtiments et mises en évidence pour les objets retail.",
              "picker": "Choisir la couleur des batiments retail"
            },
            "other": {
              "label": "Couleur des autres batiments",
              "description": "Couleur de base des autres biens sur la carte.",
              "picker": "Choisir la couleur des autres batiments"
            },
            "retailOutline": {
              "label": "Contour des biens actifs",
              "description": "Couleur de bordure des biens actifs et des mises en evidence."
            },
            "otherOutline": {
              "label": "Contour des autres biens",
              "description": "Couleur de bordure des biens non actifs."
            },
            "markerName": {
              "label": "Couleur du nom du marqueur",
              "description": "Couleur du texte des libelles sur la carte."
            },
            "markerHover": {
              "label": "Couleur au survol",
              "description": "Couleur d arriere-plan au survol des libelles."
            },
            "forRentMarker": {
              "label": "Marqueur a louer",
              "description": "Couleur du texte des marqueurs pour les biens a louer."
            }
          },
          "fetchWarn": "Impossible de charger les parametres",
          "saved": "Parametres enregistres.",
          "saveFailed": "Echec de l'enregistrement.",
          "opacityLabel": "Opacite des autres batiments : {{value}}",
          "previewOther": "Autres batiments",
          "save": "Enregistrer les parametres"
        },
        "mailTest": {
          "title": "E-mail de test",
          "subtitle": "Verifiez si les parametres e-mail fonctionnent correctement.",
          "send": "Envoyer un e-mail de test",
          "sending": "Envoi...",
          "status": "Statut : {{status}}",
          "providerActive": "{{provider}} actif",
          "devPreviewOnly": "Apercu dev uniquement",
          "from": "De : {{value}}",
          "testRecipient": "Destinataire test : {{value}}",
          "internalInboxes": "Boites internes : {{value}}",
          "notConfigured": "Non configure",
          "noneConfigured": "Aucune configuree",
          "previewLogged": "{{provider}} n est pas encore entierement configure. L e-mail de test a ete enregistre comme apercu pour {{recipient}}.",
          "sentMessage": "E-mail de test envoye a {{recipient}} via {{provider}}.",
          "failed": "L envoi de l e-mail de test a echoue.",
          "yourInbox": "votre boite de reception"
        },
        "dashboardOverlay": {
          "shared": {
            "assistant": "Comment ca marche ?"
          }
        },
        "retailerMap": {
          "loading": {
            "zoomInToLoad": "Zoomez jusqu'a {{zoom}} pour charger les enseignes",
            "fillingStreet": "Chargement des nouveaux locaux. Cela peut prendre jusqu'a 2 min...",
            "paintingFromCenter": "Chargement des locaux depuis le centre..."
          }
        },
        "myProperties": {
          "noAssetManager": "sans asset manager"
        }
      },
      "mapSettings": {
        "activeOutlineLabel": "Contour des biens actifs",
        "otherOutlineLabel": "Contour des autres biens",
        "markerNameColorLabel": "Couleur du nom du marqueur",
        "hoverColorLabel": "Couleur au survol",
        "backToDashboard": "Retour au tableau de bord",
        "title": "Parametres de carte",
        "subtitle": "Ajustez les couleurs des batiments et des noms de marqueurs",
        "fetchWarn": "Impossible de charger les parametres",
        "noUser": "Aucun utilisateur trouve.",
        "invalidHex": "Couleur hex invalide. Utilisez p. ex. #0077cc.",
        "saved": "Parametres enregistres.",
        "saveFailed": "Echec de l'enregistrement.",
        "retailColorLabel": "Couleur des batiments retail",
        "retailColorPicker": "Choisir la couleur des batiments retail",
        "otherColorLabel": "Couleur des autres batiments",
        "otherColorPicker": "Choisir la couleur des autres batiments",
        "opacityLabel": "Opacite des autres batiments : {{value}}",
        "opacityAria": "Curseur d'opacite",
        "markerNameColorPicker": "Choisir la couleur du nom du marqueur",
        "markerNameHoverColorLabel": "Couleur du marqueur au survol",
        "markerNameHoverColorPicker": "Choisir la couleur au survol",
        "previewRetail": "Mise en evidence retail",
        "previewOther": "Autres batiments",
        "previewMarkerNormal": "Marqueur normal",
        "previewMarkerHover": "Marqueur au survol",
        "saving": "Enregistrement...",
        "save": "Enregistrer les parametres",
        "reset": "Reinitialiser",
        "cancel": "Annuler",
        "hexHelp": "Utilisez hex, p. ex. #0077cc"
      },
      "retailerProfile": {
        "personalTitle": "Profil personnel",
        "companyTitle": "Profil entreprise",
        "autosaveHint": "Les modifications sont enregistrees automatiquement.",
        "companyProtectedHint": "Le groupe et le nom de l entreprise guident les profils IA et les liens internes; ils restent donc proteges.",
        "parentCompany": "Societe mere",
        "company": "Entreprise",
        "companyName": "Nom de l entreprise",
        "name": "Nom",
        "legalName": "Nom legal",
        "headquartersAddress": "Adresse du siege",
        "headquartersPostalCode": "Code postal du siege",
        "headquartersCity": "Ville du siege",
        "headquartersCountry": "Pays du siege",
        "industry": "Secteur",
        "organization": "Organisation",
        "foundingYear": "Annee de creation",
        "storeCount": "Nombre de magasins",
        "activeCountries": "Actif dans les pays",
        "employeeCount": "Nombre d employes",
        "revenueIndication": "Indication de chiffre d affaires",
        "billingHint": "Utile pour les abonnements, factures et l administration interne.",
        "billingEmail": "E-mail de facturation",
        "invoiceReference": "Reference facture / PO",
        "billingAddress": "Adresse de facturation",
        "chamberOfCommerceNumber": "Numero de registre",
        "vatNumber": "Numero TVA",
        "postalCode": "Code postal",
        "city": "Ville",
        "country": "Pays",
        "success": "Profil enregistré avec succès.",
        "error": "Échec de l’enregistrement"
      },
      "paidInterest": {
        "title": "Interet supplementaire",
        "bodyPrefix": "Cet interet coute",
        "price": "5 € hors TVA par mois",
        "bodySuffix": "et sera ajoute a votre abonnement. Vous pouvez toujours retirer cet interet plus tard.",
        "confirm": "Accepter et continuer",
        "paymentStartFailed": "Impossible de demarrer le paiement."
      },
      "forRentTab": {
        "selectActingRole": "Selectionnez pour qui vous publiez l offre.",
        "created": "Le bien est maintenant publie a la location.",
        "updated": "Annonce mise a jour.",
        "updateFailed": "Mise a jour echouee.",
        "confirmDelete": "Voulez-vous vraiment supprimer cette annonce de location ?",
        "deleteFailed": "Suppression echouee.",
        "listProperty": "Publier le bien a la location",
        "missingData": "Donnees manquantes pour publier ce bien a la location.",
        "activateFailed": "L activation de l annonce a echoue.",
        "activating": "Activation de l annonce..."
      },
      "requests": {
        "empty": "Aucune demande",
        "removeFailed": "La demande n a pas pu etre supprimee.",
        "total": "Total",
        "purchased": "Achete",
        "date": "Date",
        "interestedParty": "Partie interessee",
        "hidden": "Masque",
        "downloadContact": "Telecharger les coordonnees",
        "buyContact": "Acheter les coordonnees (49 €)",
        "interests": "Interets",
        "interestTypes": {
          "forRent": "Interet pour une location",
          "general": "Interet general"
        },
        "payToView": "Acheter les coordonnées (49 €)",
        "payToViewLabel": "Acheter les coordonnées (49 €)"
      },
      "billing": {
        "user": "Utilisateur",
        "title": "Facturation",
        "subscription": "Abonnement",
        "paidSince": "Paye depuis",
        "trialUntil": "Periode d essai jusqu au",
        "trialEndedOn": "Periode d essai terminee le",
        "baseSubscription": "Abonnement de base",
        "perMonth": "par mois",
        "totalMonthlyCosts": "Cout mensuel total",
        "renewsOn": "Renouvellement le {{date}}",
        "noticePeriod": "Preavis: 1 mois. L abonnement reste actif sauf annulation.",
        "includesProperties": "inclut {{count}} biens",
        "extraProperties": "Biens supplementaires",
        "totalProperties": "Total des biens",
        "monthlyCosts": "Couts mensuels",
        "cancelSubscription": "Annuler l’abonnement",
        "cancellationScheduled": "Votre abonnement prendra fin le {{date}}. Vos données resteront archivées et pourront être restaurées lors de la réactivation.",
        "cancelDialog": {
          "title": "Annuler l’abonnement",
          "retention": "L’abonnement prendra fin après la période payée actuelle. Rien n’est supprimé : portefeuille, documents, historique et factures restent archivés pour une réactivation.",
          "endsOn": "L’accès reste actif jusqu’au {{date}}.",
          "ownerProperties": "Mes biens",
          "retailerStores": "Mes magasins",
          "returnPortfolio": "Rendre au portefeuille de l’organisation (non attribué)",
          "transferColleague": "Transférer à un collègue",
          "listings": "Annonces de location actives",
          "archiveListings": "Arrêter et archiver à la date de fin",
          "transferListings": "Transférer à un collègue",
          "interests": "Les intérêts actifs seront retirés à la date de fin. L’historique protégé restera archivé.",
          "contacts": "Les coordonnées achetées et les factures restent dans l’historique et sont restaurées lors de la réactivation.",
          "recipient": "Collègue destinataire",
          "confirm": "Planifier l’annulation"
        },
        "recurring": {
          "title": "Abonnements et utilisation",
          "description": "Couts recurrents pour votre abonnement, biens a louer actifs et autres composants mensuels."
        },
        "baseSubscriptionDescription": "Acces a Retailmaps et aux fonctions de base.",
        "forRent": "A louer",
        "forRentDescription": "Biens a louer actifs actives par ce compte utilisateur.",
        "oneOff": {
          "title": "Achats ponctuels",
          "description": "Couts ponctuels, comme le deblocage de documents ou autres evenements de facturation separes.",
          "noneTitle": "Aucun achat ponctuel pendant cette periode",
          "noneDescription": "Des qu un achat ponctuel est termine, il apparait automatiquement ici.",
          "none": "Aucun achat ponctuel pendant cette periode."
        },
        "totals": {
          "subscriptions": "Abonnements",
          "trialDiscount": "Remise essai",
          "oneOff": "Achats ponctuels",
          "vat": "TVA",
          "totalInclVat": "Total TTC"
        },
        "history": {
          "title": "Historique de facturation",
          "description": "Evenements de facturation recents et transactions ponctuelles pour ce compte.",
          "none": "Aucun evenement de facturation n a encore ete trouve pour ce compte.",
          "documentUnlock": "Deblocage document"
        },
        "columns": {
          "date": "Date",
          "description": "Description",
          "status": "Statut",
          "amount": "Montant",
          "quantity": "Quantite",
          "unitPrice": "Unite",
          "total": "Total"
        },
        "description": "Tout pour {{account}} en un apercu : abonnements, achats ponctuels et couts ouverts pour {{period}}.",
        "yourAccount": "votre compte",
        "currentMonth": "ce mois",
        "currentPeriod": "Periode actuelle",
        "downloadPdf": "Telecharger la facture (PDF)",
        "preparingPdf": "Preparation du PDF...",
        "amountDueThisMonth": "Montant du ce mois",
        "subscriptionStatus": "Statut abonnement",
        "subscriptionActive": "Actif",
        "subscriptionInactive": "Inactif",
        "nextRenewal": "Prochain renouvellement",
        "stripeCustomer": "Client Stripe"
      },
      "verifyEmail": {
        "loadingMessage": "Nous confirmons votre adresse e-mail...",
        "invalidLink": "Ce lien de verification est invalide.",
        "successMessage": "Votre adresse e-mail est confirmee. Connectez-vous pour ouvrir Retailmaps.",
        "failedMessage": "La verification a echoue.",
        "expiredOrInvalid": "Ce lien de verification a expire ou est invalide.",
        "successTitle": "Adresse e-mail confirmee",
        "failedTitle": "Verification echouee",
        "checkingTitle": "Verification",
        "backToLogin": "Retour a la connexion",
        "openLogin": "Se connecter et ouvrir Retailmaps"
      },
      "listings": {
        "common": {
          "forRentSince": "ì louer depuis",
          "onRequest": "Sur demande",
          "empty": "Aucun local n’est actuellement à louer.",
          "country": "Pays",
          "city": "Ville",
          "address": "Adresse",
          "askingPrice": "Loyer demandé",
          "currentRent": "Loyer actuel",
          "keyMoney": "Pas-de-porte",
          "expiryDate": "Date d’expiration",
          "availableFrom": "Disponible à partir du",
          "projectInformation": "Informations projet",
          "onBehalfOf": "Pour le compte de",
          "visibility": "Visibilité",
          "broker": "Courtier",
          "actions": "Actions",
          "upload": "Téléverser",
          "uploadDocument": "Téléverser un document",
          "stopForRent": "Arrêter",
          "brochureFailed": "La génération ou le téléversement de la brochure a échoué.",
          "projectDocuments": "Documents du projet",
          "chooseFile": "Choisir un fichier",
          "noFileChosen": "Aucun fichier sélectionné",
          "selectFileFirst": "Sélectionnez d’abord un fichier.",
          "uploadFailed": "Le téléversement a échoué.",
          "documentDeleteFailed": "La suppression du document a échoué.",
          "confirmDeleteDocument": "Voulez-vous vraiment supprimer \"{{name}}\" ?",
          "forRent": "ì louer",
          "edit": "Modifier",
          "save": "Enregistrer",
          "cancel": "Annuler",
          "documentTypes": {
            "document": "Document",
            "floorplan": "Plan",
            "brochure": "Brochure",
            "photo": "Photo"
          },
          "visibilityOptions": {
            "public": "Tout le monde",
            "retailers": "Tous les retailers",
            "interested": "Uniquement les interesses"
          },
          "noDocuments": "Aucun document",
          "fileCountOne": "{{count}} fichier",
          "fileCountOther": "{{count}} fichiers",
          "addedOn": "Ajoute le {{date}}",
          "deleteDocumentAria": "Supprimer {{name}}",
          "roles": {
            "owner": "Proprietaire",
            "brokerOnBehalfOwner": "Courtier (pour le proprietaire)"
          },
          "available": "Disponible",
          "surface": "Surface",
          "total": "Total",
          "contactBroker": "Contacter le courtier en location",
          "thirdPartyNotice": "Informations fournies par des tiers. Vérifiez les détails auprès du fournisseur.",
          "interestAndDocuments": "Manifester son intérêt et recevoir les documents",
          "goToInformation": "Voir les informations",
          "viewDocuments": "Voir les documents",
          "unlockForPrice": "Débloquer gratuitement",
          "unlockDocuments": "Débloquer les documents",
          "oneTimeAccessPrice": "L’accès aux documents est actuellement gratuit."
        },
        "roles": {
          "external": "Offre externe",
          "owner": "Propriétaire",
          "tenant": "Retailer",
          "brokerOnBehalfOwner": "Courtier (pour le proprietaire)",
          "provider": "Fournisseur"
        }
      },
      "propertyDetails": {
        "floors": {
          "ground": "Rez-de-chaussee",
          "basement": "Sous-sol",
          "first": "1er etage",
          "second": "2e etage",
          "third": "3e etage",
          "entresol": "Entresol",
          "soussol": "Sous-sol"
        },
        "frontWidth": "Largeur de facade",
        "rentalData": "Donnees locatives",
        "financialData": "Donnees financieres",
        "ownerData": "Donnees proprietaire",
        "commentsDivider": "Notes",
        "contactsDivider": "Contacts",
        "photosDivider": "Photos",
        "floorplansDivider": "Plans",
        "documentsDivider": "Documents",
        "objectInfoDivider": "Informations objet",
        "floorplansInfo": "Téléversez les plans au format JPG ou PNG. Ces plans sont utilisés dans les brochures. Les fichiers PDF peuvent être stockés sous Documents.",
        "addFloorplan": "Ajouter un plan",
        "removeFloorplan": "Supprimer le plan",
        "addObjectInfo": "Ajouter des informations objet",
        "notesDivider": "Notes",
        "datePlaceholder": "jj-mm-aaaa",
        "addContact": "Ajouter un contact",
        "removeField": "Supprimer le champ",
        "removeFieldHint": "Supprimez les champs supplementaires en double-cliquant sur le champ puis en choisissant Supprimer le champ.",
        "popupSettings": {
          "open": "Ouvrir les parametres",
          "hide": "Masquer les parametres",
          "title": "Parametres du popup",
          "description": "Choisissez les champs visibles dans le popup de la carte. Cela vaut pour les champs standards et vos champs supplementaires.",
          "extraFields": "champs supplementaires",
          "noExtraFields": "Aucun champ supplementaire dans cette section.",
          "showInPopup": "Afficher dans le popup",
          "hideInPopup": "Masquer dans le popup"
        },
        "askingRentPrice": "Loyer demande",
        "serviceCosts": "Charges de service",
        "takeoverPrice": "Pas-de-porte",
        "availableFrom": "Disponible a partir de",
        "back": "Retour a l'apercu",
        "projectInfoDivider": "Informations projet",
        "addProjectInfo": "Ajouter des informations projet",
        "autosave": {
          "saved": "Enregistré",
          "active": "Enregistrement automatique actif",
          "error": "Échec de l’enregistrement"
        },
        "publicData": "Données publiques",
        "privateData": "Données privées",
        "publicDataDivider": "Données publiques",
        "privateDataDivider": "Données privées",
        "front": "Façade",
        "surface": "Surface",
        "groundFloor": "Rez-de-chaussée",
        "basement": "Sous-sol",
        "firstFloor": "1er étage",
        "secondFloor": "2e étage",
        "thirdFloor": "3e étage",
        "saveSuccess": "Données enregistrées",
        "saveError": "Échec de l’enregistrement",
        "notFound": "Cette localisation n’existe plus."
      },
      "help": {
        "subtitle": "Explications courtes pour les actions courantes dans Retailmaps.",
        "howItWorks": "Comment ca marche",
        "goodToKnow": "Bon a savoir",
        "empty": "Aucun sujet pour ce role pour le moment.",
        "actions": {
          "openListings": "Ouvrir les offres",
          "openInterests": "Ouvrir les interets",
          "openProperties": "Ouvrir les biens",
          "openAlerts": "Ouvrir les alertes",
          "openRequests": "Ouvrir les demandes",
          "openAnalysis": "Ouvrir l analyse"
        },
        "topics": {
          "ownerForRent": {
            "title": "Mettre un bien en location",
            "summary": "Publiez un bien comme offre de location et ajoutez les bonnes informations.",
            "step1": "Ouvrez l onglet Biens.",
            "step2": "Cherchez le bien que vous voulez proposer.",
            "step3": "Cliquez sur Mettre en location.",
            "step4": "Ouvrez A louer et completez le loyer demande, le pas-de-porte et la date de disponibilite.",
            "step5": "Verifiez les donnees deja reprises, comme le loyer actuel et la date d expiration.",
            "step6": "Ajoutez les informations projet. Vous pouvez televerser une brochure ou generer automatiquement les informations projet.",
            "note1": "En tant que proprietaire, vous n avez pas besoin de choisir la visibilite. Le bien est automatiquement affiche comme offre de location.",
            "note2": "Les informations projet automatiques utilisent les donnees saisies, les photos, les plans et une image de carte."
          },
          "retailerStore": {
            "title": "Lier un magasin a mes magasins",
            "summary": "Ajoutez un emplacement existant a votre vue des magasins.",
            "step1": "Ouvrez l onglet Magasins.",
            "step2": "Recherchez le magasin par pays, ville ou adresse.",
            "step3": "Choisissez vous-meme ou un collegue comme retail manager.",
            "step4": "Le magasin apparait ensuite dans Mes magasins.",
            "note1": "Vous ne pouvez mettre un magasin en location qu apres l avoir lie a Mes magasins.",
            "note2": "Si l emplacement n est pas encore sur la carte, ajoutez d abord un nouveau marqueur."
          },
          "newMarker": {
            "title": "Ajouter un nouveau marqueur",
            "summary": "Ajoutez un nouvel emplacement sur la carte.",
            "step1": "Ouvrez la carte.",
            "step2": "Desktop : double-cliquez sur un emplacement vide de la carte.",
            "step3": "Mobile : appuyez deux fois sur un emplacement vide de la carte.",
            "step4": "Remplissez ensuite les donnees de l emplacement.",
            "note1": "Verifiez d abord si l emplacement existe deja sur la carte. Dans ce cas, utilisez le marqueur existant.",
            "note2": "Si vous placez un nouveau marqueur au mauvais endroit, vous pouvez le supprimer vous-meme si vous l avez ajoute."
          },
          "moveDeleteMarker": {
            "title": "Deplacer ou supprimer un marqueur",
            "summary": "Corrigez la position d un marqueur ou supprimez un marqueur que vous avez ajoute vous-meme.",
            "step1": "Desktop : faites un clic droit sur le marqueur.",
            "step2": "Mobile : maintenez le marqueur appuye.",
            "step3": "Choisissez Deplacer le marqueur puis cliquez ou appuyez sur la nouvelle position.",
            "step4": "Choisissez Supprimer le marqueur pour retirer un marqueur que vous avez ajoute vous-meme.",
            "note1": "Les marqueurs existants et ceux ajoutes par un autre utilisateur ne peuvent etre supprimes que par un admin.",
            "note2": "Apres le deplacement, rouvrez le marqueur si vous voulez verifier ou modifier les donnees."
          },
          "mobile": {
            "title": "Utiliser Retailmaps sur mobile",
            "summary": "Ajoutez Retailmaps a votre ecran d accueil pour un acces rapide.",
            "step1": "Ouvrez www.retailmaps.com sur votre telephone.",
            "step2": "iPhone ou iPad : utilisez Safari, appuyez sur Partager et choisissez Ajouter a l ecran d accueil.",
            "step3": "Chrome sur Android : appuyez sur les trois points et choisissez Installer l application ou Ajouter a l ecran d accueil.",
            "step4": "Samsung Internet : ouvrez le menu et choisissez Ajouter la page a ou Ajouter a l ecran d accueil.",
            "step5": "Nommez le raccourci Retailmaps et appuyez sur Ajouter.",
            "step6": "Ouvrez ensuite Retailmaps avec l icone sur votre ecran d accueil.",
            "note1": "Sur iPhone, cela fonctionne normalement avec Safari. Chrome sur iPhone ne le permet generalement pas directement.",
            "note2": "Vous vous connectez avec le meme compte que sur desktop."
          },
          "security": {
            "title": "Activer ou desactiver l authentification a deux facteurs",
            "summary": "Protegez votre compte avec un code supplementaire depuis une application d authentification.",
            "step1": "Ouvrez Parametres.",
            "step2": "Allez dans Securite ou Authentification a deux facteurs.",
            "step3": "Cliquez sur Activer 2FA.",
            "step4": "Ouvrez une application d authentification, comme Google Authenticator, Microsoft Authenticator ou 1Password.",
            "step5": "Scannez le QR-code avec l application.",
            "step6": "Saisissez le code a 6 chiffres et confirmez.",
            "step7": "Vous vous connecterez ensuite avec votre mot de passe plus le code a 6 chiffres.",
            "step8": "Pour desactiver 2FA, retournez dans Parametres et cliquez sur Desactiver 2FA.",
            "note1": "Gardez l acces a votre application d authentification. Sans elle, la connexion peut devenir difficile.",
            "note2": "Le code change environ toutes les 30 secondes. Utilisez toujours le code le plus recent."
          },
          "popupMedia": {
            "title": "Photos, documents et plans",
            "summary": "Ajoutez des fichiers a un emplacement.",
            "step1": "Ouvrez la popup de l emplacement.",
            "step2": "Accédez aux Données privées.",
            "step3": "Choisissez Photos, Documents ou Plans.",
            "step4": "Ajoutez un fichier ou prenez directement une photo sur mobile.",
            "note1": "Les photos sont affichees sous forme de miniatures.",
            "note2": "Les plans fonctionnent mieux sous forme d image, par exemple jpg ou png."
          },
          "alerts": {
            "title": "Configurer des alertes",
            "summary": "Definissez un rappel pour les dates importantes.",
            "step1": "Ouvrez les details du bien ou la popup.",
            "step2": "Saisissez une date, par exemple date d expiration, date d indexation ou date de preavis.",
            "step3": "Cochez Alerte.",
            "step4": "Indiquez combien de jours a l avance vous voulez recevoir l alerte.",
            "step5": "Consultez les alertes actives dans l onglet Alertes.",
            "note1": "Les alertes actives sont visibles dans l onglet Alertes.",
            "note2": "A la date de rappel, vous recevez automatiquement un e-mail."
          },
          "ownerRequests": {
            "title": "Voir les demandes",
            "summary": "Voyez qui s interesse a votre offre de location ou a votre bien.",
            "step1": "Ouvrez l onglet Demandes.",
            "step2": "Verifiez a quel bien la demande se rapporte.",
            "step3": "Verifiez quelles donnees du demandeur sont disponibles.",
            "step4": "Ouvrez la demande pour plus de details.",
            "note1": "Les demandes apparaissent quand des retailers montrent un interet pour un emplacement, meme s il n est pas activement propose a la location."
          },
          "retailerRequests": {
            "title": "Voir les demandes",
            "summary": "Voyez quels retailers s interessent a vos emplacements.",
            "step1": "Ouvrez l onglet Demandes.",
            "step2": "Voyez quel retailer a montre son interet.",
            "step3": "Verifiez a quel emplacement la demande se rapporte.",
            "step4": "Cliquez sur l adresse pour ouvrir l emplacement sur la carte.",
            "note1": "Les demandes sont des interets entrants pour les emplacements lies a votre organisation."
          },
          "interest": {
            "title": "Montrer un interet",
            "summary": "Indiquez que vous etes interesse par un emplacement precis.",
            "step1": "Ouvrez sur la carte l emplacement qui vous interesse.",
            "step2": "Cliquez dans la popup sur Montrer l interet.",
            "step3": "Verifiez la confirmation et terminez les etapes d acces si necessaire.",
            "step4": "L emplacement apparait ensuite dans l onglet Interets.",
            "step5": "L interet reste actif jusqu a ce que vous le retiriez.",
            "note1": "Votre interet est enregistre sur le bien precis, pas seulement dans votre propre vue.",
            "note2": "Le locataire actuel, le proprietaire et les courtiers concernes peuvent voir l interet lorsqu ils ont acces."
          },
          "analysis": {
            "title": "Utiliser l analyse",
            "summary": "Comparez des emplacements et consultez les calculs importants.",
            "step1": "Selectionnez un bien ou un magasin dans votre vue.",
            "step2": "Choisissez l action Analyse.",
            "step3": "Ajoutez plusieurs emplacements si necessaire.",
            "step4": "Ouvrez Analyse pour voir notamment le loyer par m2, le WALT, la duree restante et les ratios."
          }
        },
        "title": "Comment ca marche ?",
        "tab": "Comment ca marche ?"
      },
      "legal": {
        "disclaimer": "Document conceptuel pour Retailmaps. Completez les informations de l entreprise avant publication definitive.",
        "lastUpdated": "Derniere mise a jour : 28 mai 2026",
        "privacy": {
          "title": "Declaration de confidentialite",
          "intro": "Retailmaps processes business account, company, property, listing, interest and usage data to provide the platform.",
          "roles": "Data can be visible to relevant users depending on their role, access rights, subscriptions and actions within the platform.",
          "providers": "Retailmaps may use external providers for hosting, maps, payments, email, analytics and AI functionality.",
          "rights": "Users can request access, correction or deletion of personal data where applicable.",
          "contact": "For privacy questions, contact Retailmaps through the published contact details."
        },
        "terms": {
          "title": "Conditions generales",
          "intro": "Retailmaps is a professional platform for retail real estate information, listings, interests, requests and related collaboration.",
          "account": "Users are responsible for correct account details, secure login credentials and lawful use of the platform.",
          "data": "Users remain responsible for the accuracy and rights to information, photos, documents and contact details they upload or publish.",
          "uploadLicense": "En fournissant des plans, des fichiers IMDF, GeoJSON, CAD, SVG ou d'autres fichiers de localisation, l'utilisateur confirme qu'il est autorisé à le faire et accorde à Retailmaps une licence non exclusive et libre de redevance permettant de stocker, héberger, copier, analyser, convertir, géoréférencer, adapter et combiner ces fichiers, de créer des plans et couches cartographiques dérivés et de les afficher dans le service Retailmaps. Retailmaps peut accorder les droits strictement nécessaires à ses prestataires techniques. L'utilisateur doit signaler toute attribution requise, licence de tiers ou autre restriction lors de la fourniture du fichier.",
          "payments": "Paid features, subscriptions, bundles and transaction fees can apply where clearly shown in the dashboard or order flow.",
          "liability": "Retailmaps is an information and networking platform and does not guarantee that a property is available or that a transaction will be completed."
        }
      },
      "popup": {
        "autosaveActive": "Enregistrement automatique actif"
      },
      "alerts": {
        "daysBefore": "jours avant",
        "enterDaysBefore": "Saisissez le nombre de jours avant",
        "title": "Alertes",
        "loading": "Chargement des alertes...",
        "empty": "Aucune alerte ne demande votre attention pour le moment.",
        "toggleLabel": "Alerte",
        "dismiss": "Traiter",
        "columns": {
          "property": "Bien",
          "field": "Champ",
          "date": "Date",
          "alertDate": "Date d’alerte",
          "daysBefore": "Jours avant",
          "status": "Statut",
          "actions": "Actions"
        },
        "status": {
          "expired": "Expirée",
          "actionNeeded": "Action requise",
          "upcoming": "ì venir"
        },
        "fields": {
          "expiryDate": "Date d’expiration",
          "indexationDate": "Date d’indexation",
          "terminationDate": "Date de résiliation",
          "availableFrom": "Disponible à partir du",
          "startDate": "Date de début"
        }
      },
      "analysis": {
        "title": "Analyse",
        "empty": "Ajoutez des biens a l analyse pour afficher les chiffres.",
        "summary": {
          "totalRent": "Loyer annuel total",
          "totalAskingRent": "Loyer demande total",
          "weightedArea": "m2 ponderes",
          "avgAskingRentPerM2": "Loyer demande moyen/m2/an",
          "avgRentPerM2": "Loyer moyen/m2/an",
          "wault": "WAULT"
        },
        "values": {
          "years": "{{value}} ans"
        },
        "metrics": {
          "waltYears": "WALT : {{value}} ans",
          "expiry12": "Expiration 12 m : {{value}}",
          "expiry24": "Expiration 24 m : {{value}}",
          "expiry36": "Expiration 36 m : {{value}}"
        },
        "actions": {
          "clear": "Vider l analyse",
          "collapseSurfaces": "Replier les surfaces",
          "expandSurfaces": "Deplier les surfaces",
          "remove": "Supprimer"
        },
        "table": {
          "property": "Bien",
          "tenant": "Locataire",
          "annualRent": "Loyer annuel",
          "askingRent": "Loyer demande",
          "weightedM2": "m2 ponderes",
          "rentPerM2": "Loyer/m2",
          "askingRentPerM2": "Loyer demande/m2",
          "expiry": "Expiration",
          "remainingTerm": "Duree restante",
          "remainingMonths": "Mois restants",
          "guaranteeMonths": "Mois de garantie",
          "surfaces": "Surfaces",
          "rentCoverage": "Couverture du loyer",
          "interestCoverage": "Couverture des interets",
          "front": "Facade",
          "weightedArea": "m2 ponderes",
          "ltv": "LTV"
        },
        "surfaces": {
          "title": "Surfaces",
          "helper": "Par defaut : retail 100 %, secondaire 50 %. Ajustez par etage ici.",
          "weightedTotal": "Total pondere",
          "grossM2": "{{value}} m2 brut",
          "weightedM2Value": "= {{value}} m2",
          "empty": "Aucune surface trouvee. Renseignez les surfaces retail et secondaires dans les donnees publiques.",
          "button": "Surfaces"
        },
        "surfaceFields": {
          "beganeGrondWinkel": "Rez-de-chaussee commerce",
          "beganeGrondSecundair": "Rez-de-chaussee secondaire",
          "kelderWinkel": "Sous-sol commerce",
          "kelderSecundair": "Sous-sol secondaire",
          "eersteVerdiepingWinkel": "1er etage commerce",
          "eersteVerdiepingSecundair": "1er etage secondaire",
          "tweedeVerdiepingWinkel": "2e etage commerce",
          "tweedeVerdiepingSecundair": "2e etage secondaire",
          "derdeVerdiepingWinkel": "3e etage commerce",
          "derdeVerdiepingSecundair": "3e etage secondaire",
          "entresolWinkel": "Entresol commerce",
          "entresolSecundair": "Entresol secondaire",
          "soussolWinkel": "Sous-sol commerce",
          "soussolSecundair": "Sous-sol secondaire",
          "front": "Facade",
          "winkel": "Boutique",
          "secundair": "Secondaire",
          "begane_grond_winkel": "Rez-de-chaussee boutique",
          "begane_grond_secundair": "Rez-de-chaussee secondaire",
          "kelder_winkel": "Sous-sol boutique",
          "kelder_secundair": "Sous-sol secondaire",
          "shop": "Magasin",
          "secondary": "Secondaire"
        },
        "chips": {
          "wault": "WAULT : {{value}} ans",
          "expiry12": "Expiration 12m : {{value}}",
          "expiry24": "Expiration 24m : {{value}}",
          "expiry36": "Expiration 36m : {{value}}"
        }
      },
      "brokerRequests": {
        "title": "Demandes courtier",
        "overview": "Apercu",
        "empty": "Aucune demande",
        "interestCount": "{{count}} interet(s)",
        "buyContact": "Acheter (9 EUR)",
        "profile": {
          "industry": "Secteur",
          "stores": "Magasins",
          "activeIn": "Actif dans",
          "founded": "Annee de creation",
          "revenue": "Chiffre d'affaires"
        }
      },
      "retailerProperties": {
        "sameBrandInterestBlocked": "Il n'est pas permis de manifester un interet pour un bien de votre propre marque ou groupe."
      },
      "landing": {
        "language": {
          "select": "Choisir la langue"
        },
        "nav": {
          "aria": "Navigation principale",
          "forWho": "Pour qui",
          "howItWorks": "Fonctionnement",
          "product": "Produit",
          "price": "Prix"
        },
        "actions": {
          "login": "Connexion",
          "register": "Créer un compte",
          "startFree": "Inscrivez-vous gratuitement",
          "start60": "60 jours gratuits",
          "startTrial": "Démarrer l’essai gratuit",
          "viewProduct": "Voir le produit"
        },
        "auth": {
          "tag": "Compte",
          "close": "Fermer le formulaire",
          "copy": {
            "loginTitle": "Bon retour.",
            "loginText": "Connectez-vous avec votre e-mail professionnel pour accéder à votre carte, vos biens et vos données.",
            "registerTitle": "Démarrez votre essai gratuit.",
            "registerText": "Créez un compte professionnel et testez la carte gratuitement pendant 60 jours. Après l’inscription, nous vous envoyons un e-mail pour vérifier votre compte.",
            "forgotTitle": "Récupérer l’accès.",
            "forgotText": "Saisissez votre adresse e-mail. Si un compte existe, nous vous envoyons un e-mail de récupération."
          },
          "twoFactor": {
            "help": "Saisissez le code à 6 chiffres de votre application d’authentification.",
            "label": "Code 2FA",
            "back": "Retour au mot de passe"
          },
          "forgot": {
            "link": "Mot de passe oublié ?",
            "help": "Saisissez votre adresse e-mail. Si le compte existe, nous enverrons un lien de réinitialisation.",
            "submit": "Envoyer l’e-mail de récupération",
            "back": "Retour à la connexion",
            "openLocal": "Ouvrir le lien local"
          },
          "fields": {
            "email": "Adresse e-mail",
            "businessEmail": "Adresse e-mail professionnelle",
            "password": "Mot de passe",
            "role": "Rôle",
            "chooseRole": "Choisissez votre rôle",
            "firstName": "Prénom",
            "lastName": "Nom",
            "companyName": "Nom de l’entreprise"
          },
          "registerNote": "60 jours gratuits. Aucune carte bancaire requise. Vous recevrez d’abord un e-mail de vérification pour activer votre compte.",
          "legalAccept": "J’accepte la <privacy>politique de confidentialité</privacy> et les <terms>conditions générales</terms>.",
          "notices": {
            "emailVerified": "Votre adresse e-mail est confirmée. Connectez-vous pour ouvrir Retailmaps.",
            "twoFactorRequired": "Saisissez votre code 2FA pour continuer.",
            "registerSuccess": "Inscription réussie. Nous avons envoyé un e-mail de confirmation à votre adresse.",
            "forgotSent": "Si cette adresse e-mail est connue, nous enverrons un e-mail de récupération."
          },
          "errors": {
            "loginFailed": "Connexion impossible. Vérifiez vos informations.",
            "twoFactorFailed": "Connexion impossible. Vérifiez votre code 2FA.",
            "businessEmail": "Utilisez une adresse e-mail professionnelle. Les adresses gratuites comme Gmail, Hotmail, Outlook ou iCloud ne sont pas autorisées.",
            "roleRequired": "Choisissez d’abord votre rôle : retailer, propriétaire ou broker.",
            "companyRequired": "Saisissez le nom de votre entreprise.",
            "legalRequired": "Acceptez la politique de confidentialité et les conditions pour créer votre compte.",
            "registerFailed": "Inscription impossible. Réessayez.",
            "forgotFailed": "La récupération du mot de passe a échoué."
          }
        },
        "roles": {
          "options": {
            "retailer": "Retailer",
            "owner": "Propriétaire",
            "broker": "Broker"
          },
          "tag": "Pour qui",
          "title": "Trois rôles, trois façons d’agir plus vite.",
          "intro": "Expansion, gestion de portefeuille et conseil — tout dans un seul environnement cartographique.",
          "retailer": {
            "kicker": "Pour retailers",
            "title": "Trouvez le bon emplacement avant sa mise sur le marché.",
            "text": "Suivez les biens, montrez un intérêt discret et ne manquez plus d’opportunités.",
            "points": {
              "1": {
                "title": "Montrer un intérêt proactif",
                "text": "Enregistrez votre intérêt pour un bien précis, même avant sa disponibilité officielle."
              },
              "2": {
                "title": "Rester anonyme jusqu’au bon moment",
                "text": "Les propriétaires, brokers et retailers actuels voient votre intérêt anonyme et peuvent vous contacter lorsque le moment est opportun."
              },
              "3": {
                "title": "Suivre les emplacements",
                "text": "Conservez les informations de projet, photos et notes <underline>par bien</underline> et partagez-les avec votre équipe. Suivez les biens et recevez des notifications dès qu’il y a du mouvement. Vous ne perdez plus de données importantes."
              }
            }
          },
          "owner": {
            "kicker": "Pour propriétaires",
            "title": "Plus de contrôle sur votre portefeuille, la demande du marché et votre stratégie locative.",
            "text": "Les propriétaires gèrent leur immobilier commercial depuis un environnement central. Mettez un bien en location en un clic, créez automatiquement les informations de projet si nécessaire, analysez votre portefeuille et répartissez les emplacements entre les membres de l’équipe.",
            "points": {
              "1": {
                "title": "Gérer votre portefeuille",
                "text": "Gardez les données de biens, baux et contacts, documents et notes organisés <underline>par bien</underline>, visibles pour toute votre équipe. Ajoutez des champs et sections pour créer une base immobilière entièrement adaptable à votre méthode de travail."
              },
              "2": {
                "title": "Recevoir l’intérêt des retailers",
                "text": "Voyez quels retailers intéressés se manifestent, avec secteur et type d’intérêt. Même lorsque le bien est encore loué."
              },
              "3": {
                "title": "Configurer des alertes",
                "text": "N’oubliez plus jamais une indexation, une date de résiliation ou un autre moment important."
              }
            }
          },
          "broker": {
            "kicker": "Pour brokers",
            "title": "Conseiller plus efficacement grâce à une demande visible.",
            "text": "Combinez données de localisation, statut locatif, labels retailers et intérêt depuis un seul espace de travail. Le conseil dépend moins de listes séparées et davantage de données actuelles.",
            "points": {
              "1": {
                "title": "Carte interactive",
                "text": "Recherchez des retailers, adaptez les labels à la situation actuelle et contribuez à la retailmap open source la plus complète au monde."
              },
              "2": {
                "title": "Trouver des leads et mieux conseiller",
                "text": "Utilisez les leads pour travailler plus précisément et conseiller les propriétaires avec de meilleures informations de marché."
              },
              "3": {
                "title": "Toutes les données immobilières au même endroit",
                "text": "Consultez, analysez et partagez les données immobilières avec les membres de l’équipe, sur mobile comme sur desktop."
              },
              "4": {
                "title": "Mettre des biens en location facilement",
                "text": "Mettez rapidement des biens en location et ajustez la visibilité lorsque la situation l’exige."
              }
            }
          }
        },
        "hero": {
          "eyebrow": "Retail Real Estate Intelligence",
          "title": "Retailmaps est LA carte interactive de l’immobilier commercial.",
          "line1": "Par et pour les professionnels du retail.",
          "line2": "Trouvez des emplacements intéressants, montrez votre intérêt anonymement, suivez les évolutions et gérez les informations des biens dans un environnement central — sur ordinateur et mobile.",
          "line3": "Pour les retailers, propriétaires et brokers qui veulent voir plus vite où la demande, l’offre et l’emplacement se rencontrent.",
          "proofs": {
            "trial": "60 jours gratuits. Sans engagement.",
            "price": "Puis 19 € par mois",
            "cancel": "Rien à résilier",
            "noCard": "Aucune carte bancaire requise",
            "noCharges": "Aucun prélèvement automatique",
            "afterTrial": "Après 60 jours, vous décidez de continuer ou non avec une offre payante. Si vous ne faites rien, vous ne payez rien.",
            "cta": "Commencer mon essai gratuit"
          }
        },
        "how": {
          "tag": "Fonctionnement",
          "title": "Travaillez depuis la carte, pas depuis des listes séparées.",
          "steps": {
            "1": {
              "title": "Zoomez sur la zone commerciale",
              "text": "Consultez biens, retailers et disponibilités directement au niveau de la rue."
            },
            "2": {
              "title": "Ouvrez un bien",
              "text": "Toutes les informations pertinentes au même endroit : données privées, surfaces, données locatives, immobilières et financières, contacts, photos, notes et documents."
            },
            "3": {
              "title": "Enregistrez l’intérêt ou la disponibilité",
              "text": "Les retailers montrent un intérêt discret. Les brokers mettent des biens en location et décident eux-mêmes pour qui l’information est visible."
            }
          }
        },
        "product": {
          "tag": "Produit",
          "title": "Pas seulement des données. Un espace de travail quotidien.",
          "features": {
            "1": {
              "title": "Carte interactive",
              "text": "Travaillez visuellement depuis les rues commerçantes, biens et zones plutôt qu’uniquement depuis des tableaux."
            },
            "2": {
              "title": "Montrer son intérêt",
              "text": "Rendre la demande du marché visible sans exposer des stratégies sensibles."
            },
            "3": {
              "title": "Données privées",
              "text": "Données locatives, documents, photos et notes au même endroit, protégés au sein de l’organisation. Pas d’export possible et connexion à deux facteurs pour une protection optimale."
            },
            "4": {
              "title": "Contexte Street View",
              "text": "Consultez et analysez les emplacements directement depuis la rue, à côté de la carte, pour mieux comprendre le lieu."
            }
          }
        },
        "visual": {
          "tag": "En image",
          "title": "Contexte de localisation sans changer d’écran",
          "text": "Street View aide à évaluer rapidement la façade, la situation et l’environnement."
        },
        "price": {
          "tag": "Prix",
          "title": "Démarrer simplement, sans long processus.",
          "text": "Testez Retailmaps gratuitement pendant 60 jours. Après l’essai, vous décidez si vous continuez. Le prix reste simple, afin que la plateforme soit aussi logique pour les petites équipes.",
          "cardTitle": "Retailmaps Professional",
          "amount": "19 €",
          "period": "/ mois",
          "cardText": "Testez Retailmaps gratuitement pendant 60 jours. Aucune carte bancaire requise.",
          "items": {
            "1": "Carte interactive et liste des biens",
            "2": "Intérêt et alertes",
            "3": "Données de biens, documents et notes",
            "4": "Fonctionne sur ordinateur et mobile"
          }
        },
        "final": {
          "title": "Voyez où l’immobilier commercial se met en mouvement.",
          "text": "Commencez avec la carte, suivez les biens pertinents et voyez plus vite où demande, offre et emplacement se rencontrent."
        },
        "images": {
          "interestStackAria": "Fonction mobile d’intérêt",
          "interestSavedAlt": "Retirer l’intérêt sur mobile",
          "interestAlt": "Montrer son intérêt pour un bien sur mobile",
          "interestCaption": "Montrez votre intérêt pour votre bien favori.",
          "ownerAlt": "Vue propriétaire avec intérêts reçus",
          "ownerCaption": "Voyez l’intérêt reçu par bien et décidez quand demander les coordonnées.",
          "brokerAlt": "Tableau de bord broker avec biens, retailers et leads",
          "brokerCaption": "Consultez facilement biens, retailers et leads dans une seule vue.",
          "rentalAlt": "Information mobile du bien avec offre locative",
          "streetViewAlt": "Carte et Street View côte à côte"
        },
        "footer": {
          "copyright": "© 2026 Retailmaps.com",
          "security": "Données et sécurité",
          "privacy": "Confidentialité",
          "terms": "Conditions",
          "contact": "Contact"
        }
      },
      "popup.autosaveActive": "Enregistrement automatique actif",
      "retailerMap.mobileZoomFeedback": "Zoom {{zoom}} - appuyez deux fois à partir de 19 pour ajouter",
      "retailerMap.installPrompt.title": "Ouvrir Retailmaps plus vite",
      "retailerMap.installPrompt.subtitle": "Ajoutez Retailmaps à votre écran d’accueil.",
      "retailerMap.installPrompt.install": "Ajouter au mobile",
      "retailerMap.installPrompt.later": "Plus tard",
      "retailerMap.iosInstall.title": "Ajouter Retailmaps à l’écran d’accueil",
      "retailerMap.iosInstall.intro": "Sur iPhone, Safari ne peut pas le faire automatiquement. Suivez ces étapes :",
      "retailerMap.iosInstall.step1": "1. Touchez le bouton de partage en bas",
      "retailerMap.iosInstall.step2": "2. Choisissez Sur l’écran d’accueil.",
      "retailerMap.iosInstall.step3": "3. Touchez Ajouter.",
      "common.understood": "Compris",
      "propertyList.filters.country": "Pays",
      "propertyList.filters.allCountries": "Tous les pays",
      "propertyList.interest.changeFailed": "La modification de l interet a echoue.",
      "propertyList.interest.ownGroup": "Meme groupe",
      "propertyList.interest.viaColleague": "Via un collegue",
      "propertyList.interest.withdraw": "Retirer",
      "propertyList.interest.show": "Montrer l interet",
      "propertyList.rental.stop": "Arreter la location",
      "propertyList.rental.setForRent": "Mettre en location",
      "ownerListings": {
        "currentOffer": "Mes offres de location"
      },
      "broker": {
        "listingsTitle": "Mes offres de location"
      },
      "retailer": {
        "listingsTitle": "Mes offres de location",
        "contactgegevensBlock": {
          "title": "Contacts",
          "phone": "Téléphone",
          "function": "Rôle",
          "add": "Ajouter un contact",
          "remove": "Supprimer le contact",
          "company": "Entreprise",
          "name": "Nom",
          "email": "E-mail"
        }
      },
      "retailer.listingsTitle": "Mes offres de location",
      "owner": {
        "ownerFields": {
          "title": "Données propriétaire",
          "parentCompany": "Société mère propriétaire",
          "owner": "Propriétaire",
          "contactPerson": "Personne de contact",
          "email": "Adresse e-mail",
          "phone": "Numéro de téléphone"
        },
        "huurgegevensBlock": {
          "title": "Données locatives",
          "formeleHuurder": "Locataire officiel",
          "huurprijs": "Loyer",
          "ingangsdatum": "Date de début",
          "expiratiedatum": "Date d’expiration",
          "resterendeLooptijdMaanden": "Durée restante du bail",
          "huurtermijn": "Durée du bail",
          "verlengingsjaren": "Années de prolongation",
          "huurvrijePeriodeMaanden": "Période sans loyer",
          "indexatiedatum": "Date d’indexation",
          "opzegdatum": "Date de préavis",
          "opzegtermijn": "Délai de préavis",
          "garantiesoort": "Type de garantie",
          "kiesOptie": "Choisir une option",
          "waarborgsom": "Dépôt de garantie",
          "bankgarantie": "Garantie bancaire",
          "concerngarantie": "Garantie de groupe",
          "garantiebedrag": "Montant de la garantie",
          "noGuarantee": "Aucune garantie"
        },
        "financieringBlock": {
          "title": "Données financières",
          "koopsom": "Prix d’achat",
          "aankoopdatum": "Date d’achat",
          "actueleMarktwaarde": "Valeur de marché actuelle",
          "taxatiedatum": "Date d’évaluation",
          "hypotheek": "Montant hypothécaire",
          "actueleHypotheekschuld": "Dette hypothécaire actuelle",
          "actueleHypotheekrente": "Taux hypothécaire actuel (%)",
          "rentevastTot": "Taux fixe jusqu’au",
          "aflossingspercentage": "Pourcentage de remboursement (%)",
          "looptijd": "Durée (années)",
          "jaarlijkseRentelasten": "Charges d’intérêt annuelles",
          "jaarlijkseAflossing": "Remboursement annuel",
          "bank": "Banque",
          "jaarlijkseOverigeLasten": "Autres charges annuelles",
          "netOperatingIncome": "Résultat opérationnel net",
          "markthuurPerM2": "Loyer de marché par m²",
          "servicekostenPerJaar": "Charges de service par an",
          "rentepercentage": "Taux d’intérêt",
          "jaar": "année",
          "vraagprijs": "Prix demande"
        },
        "opmerkingen": {
          "title": "Notes",
          "none": "Aucune note ajoutée.",
          "unknownAuthor": "Auteur inconnu",
          "add": "Ajouter une note",
          "placeholder": "Saisissez votre note ici..."
        },
        "contactgegevensBlock": {
          "title": "Coordonnees",
          "add": "Ajouter un contact",
          "remove": "Supprimer le contact",
          "company": "Entreprise",
          "name": "Nom",
          "phone": "Telephone",
          "email": "E-mail",
          "function": "Fonction"
        }
      },
      "owner.financieringBlock.actueleMarktwaarde": "Valeur de marché actuelle",
      "owner.financieringBlock.taxatiedatum": "Date d’évaluation",
      "owner.financieringBlock.actueleHypotheekschuld": "Dette hypothécaire actuelle",
      "owner.financieringBlock.actueleHypotheekrente": "Taux hypothécaire actuel (%)",
      "owner.financieringBlock.rentevastTot": "Taux fixe jusqu’au",
      "owner.financieringBlock.aflossingspercentage": "Pourcentage de remboursement (%)",
      "owner.financieringBlock.jaarlijkseRentelasten": "Charges d’intérêt annuelles",
      "owner.financieringBlock.jaarlijkseAflossing": "Remboursement annuel",
      "owner.financieringBlock.jaarlijkseOverigeLasten": "Autres charges annuelles",
      "owner.financieringBlock.netOperatingIncome": "Résultat opérationnel net",
      "owner.financieringBlock.markthuurPerM2": "Loyer de marché par m²",
      "owner.financieringBlock.servicekostenPerJaar": "Charges de service par an",
      "propertyDetails.objectInfoDivider": "Informations objet",
      "propertyDetails.addObjectInfo": "Ajouter des informations objet",
      "listings.common.forRentSince": "ì louer depuis",
      "listings.common.broker": "Courtier",
      "listings.common.edit": "Modifier",
      "listings.common.save": "Enregistrer",
      "listings.common.cancel": "Annuler",
      "roles": {
        "owner": "Propriétaire",
        "retailer": "Retailer",
        "broker": "Courtier"
      },
      "listings.common.noDocuments": "Aucun document disponible.",
      "listings.common.fileCountOne": "{{count}} fichier",
      "listings.common.fileCountOther": "{{count}} fichiers",
      "listings.common.addedOn": "Ajoute le {{date}}",
      "listings.common.deleteDocumentAria": "Supprimer {{name}}",
      "common.open": "Ouvrir",
      "photos": {
        "title": "Photos",
        "add": "Ajouter une photo",
        "remove": "Supprimer la photo",
        "useAsCover": "Utiliser comme photo de couverture",
        "cover": "Couverture",
        "chooseCover": "Choisir",
        "openPreview": "Ouvrir l’aperçu",
        "error": {
          "tooLarge": "depasse 10 Mo et a ete ignore."
        }
      },
      "photos.useAsCover": "Utiliser comme photo de couverture",
      "photos.cover": "Couverture",
      "photos.chooseCover": "Choisir",
      "photos.openPreview": "Ouvrir l’aperçu",
      "propertyDetails.notesDivider": "Notes",
      "retailerProperty": {
        "contactsDivider": "Contacts",
        "notesDivider": "Notes",
        "photosDivider": "Photos",
        "publicDataDivider": "Données publiques",
        "privateDataDivider": "Données privées"
      },
      "retailerProperty.notesDivider": "Notes",
      "accountSettings": {
        "company": {
          "brandLogoTitle": "Marque et logo",
          "brandLogoDescription": "Nous utilisons ce logo sur les fiches de biens et autres emplacements visibles.",
          "title": "Profil entreprise",
          "description": "Donnees entreprise, informations de marque et facturation pour les comptes courtiers et proprietaires. Les modifications sont enregistrees automatiquement.",
          "readOnlyNotice": "Le groupe d entreprise et le domaine pilotent les connexions, la visibilite et les profils IA et restent donc en lecture seule.",
          "companyName": "Nom de l entreprise",
          "companyGroup": "Groupe d entreprise",
          "domain": "Domaine",
          "legalName": "Raison sociale",
          "website": "Site web",
          "roleType": "Type de role",
          "headquartersTitle": "Siege",
          "headquartersAddress": "Adresse du siege",
          "postalCode": "Code postal",
          "city": "Ville",
          "country": "Pays",
          "billingTitle": "Facturation",
          "billingDescription": "Nous utilisons ces informations pour les abonnements, factures et administration financiere.",
          "billingEmail": "E-mail de facturation",
          "invoiceReference": "Reference facture / PO",
          "chamberOfCommerce": "Numero registre du commerce",
          "vatNumber": "Numero TVA",
          "billingAddress": "Adresse de facturation",
          "taxIdType": "Type d identifiant fiscal",
          "taxIdValue": "Numero TVA / fiscal",
          "taxIdPlaceholder": "FR12345678901",
          "peopleTitle": "Personnes",
          "peopleDescription": "Comptes rattaches a la meme organisation. Les statuts sont bases sur l abonnement et la periode d essai.",
          "peopleName": "Nom",
          "peopleEmail": "E-mail",
          "peopleRole": "Role",
          "peopleStatus": "Statut",
          "peopleTrialUntil": "Essai jusqu au",
          "peopleYou": "Vous",
          "peopleEmpty": "Aucun autre compte n a encore ete trouve dans cette organisation.",
          "statusActive": "Actif",
          "statusTrial": "Essai",
          "statusInactive": "Inactif",
          "taxTypes": {
            "euVat": "Numero de TVA europeen",
            "gbVat": "Numero de TVA britannique",
            "auAbn": "Numero d entreprise australien (AU ABN)",
            "auArn": "Numero de reference fiscale australien",
            "brCnpj": "Numero CNPJ bresilien",
            "brCpf": "Numero CPF bresilien",
            "caBn": "BN canadien",
            "caGstHst": "Numero GST/HST canadien",
            "chVat": "Numero de TVA suisse",
            "clTin": "TIN chilien",
            "egTin": "Identifiant fiscal egyptien",
            "inGst": "Numero GST indien",
            "jpCn": "Numero d entreprise japonais",
            "jpRn": "Numero japonais d entreprise etrangere enregistree",
            "mxRfc": "Numero RFC mexicain",
            "noVat": "Numero de TVA norvegien",
            "nzGst": "Numero GST neo-zelandais",
            "sgGst": "Numero GST singapourien",
            "usEin": "EIN americain",
            "zaVat": "Numero de TVA sud-africain"
          }
        },
        "title": "Parametres",
        "tabs": {
          "profile": "Profil",
          "company": "Entreprise",
          "preferences": "Preferences",
          "security": "Securite",
          "billing": "Facturation"
        },
        "descriptions": {
          "profile": "Coordonnees et role de votre compte.",
          "company": "Donnees entreprise, marque et facturation.",
          "preferences": "Langue, devise, unites et affichage de la carte.",
          "security": "Connexion et securite du compte.",
          "billing": "Abonnement, utilisation et achats ponctuels."
        },
        "personal": {
          "title": "Profil personnel",
          "description": "Coordonnees et role de votre compte. Les modifications sont enregistrees automatiquement.",
          "firstName": "Prenom",
          "lastName": "Nom",
          "role": "Fonction",
          "phone": "Telephone",
          "email": "Adresse e-mail",
          "linkedin": "LinkedIn",
          "address": "Adresse"
        }
      },
      "account.noLogo": "Aucun logo pour le moment",
      "listings.common.uploading": "Telechargement...",
      "propertyDetails.detailsDivider": "Details",
      "common.saved": "Enregistre",
      "common.saving": "Enregistrement...",
      "common.saveFailed": "Echec de l enregistrement",
      "common.ready": "Pret",
      "common.active": "Actif",
      "common.inactive": "Inactif",
      "common.canceled": "Annule",
      "accountSettings.tabs.security": "Securite",
      "accountSettings.descriptions.security": "Connexion et securite du compte.",
      "accountSettings.company.taxIdType": "Type d identifiant fiscal",
      "accountSettings.company.taxIdValue": "Numero TVA / fiscal",
      "accountSettings.company.taxIdPlaceholder": "FR12345678901",
      "accountSettings.company.peopleTitle": "Personnes",
      "accountSettings.company.peopleDescription": "Comptes rattaches a la meme organisation. Les statuts sont bases sur l abonnement et la periode d essai.",
      "accountSettings.company.peopleName": "Nom",
      "accountSettings.company.peopleEmail": "E-mail",
      "accountSettings.company.peopleRole": "Role",
      "accountSettings.company.peopleStatus": "Statut",
      "accountSettings.company.peopleTrialUntil": "Essai jusqu au",
      "accountSettings.company.peopleYou": "Vous",
      "accountSettings.company.peopleEmpty": "Aucun autre compte n a encore ete trouve dans cette organisation.",
      "accountSettings.company.statusTrial": "Essai",
      "accountSettings.company.statusActive": "Actif",
      "accountSettings.company.statusInactive": "Inactif",
      "accountSettings.company.taxTypes.euVat": "Numero de TVA europeen",
      "accountSettings.company.taxTypes.gbVat": "Numero de TVA britannique",
      "accountSettings.company.taxTypes.auAbn": "Numero d entreprise australien (AU ABN)",
      "accountSettings.company.taxTypes.auArn": "Numero de reference fiscale australien",
      "accountSettings.company.taxTypes.brCnpj": "Numero CNPJ bresilien",
      "accountSettings.company.taxTypes.brCpf": "Numero CPF bresilien",
      "accountSettings.company.taxTypes.caBn": "BN canadien",
      "accountSettings.company.taxTypes.caGstHst": "Numero GST/HST canadien",
      "accountSettings.company.taxTypes.chVat": "Numero de TVA suisse",
      "accountSettings.company.taxTypes.clTin": "TIN chilien",
      "accountSettings.company.taxTypes.egTin": "Identifiant fiscal egyptien",
      "accountSettings.company.taxTypes.inGst": "Numero GST indien",
      "accountSettings.company.taxTypes.jpCn": "Numero d entreprise japonais",
      "accountSettings.company.taxTypes.jpRn": "Numero japonais d entreprise etrangere enregistree",
      "accountSettings.company.taxTypes.mxRfc": "Numero RFC mexicain",
      "accountSettings.company.taxTypes.noVat": "Numero de TVA norvegien",
      "accountSettings.company.taxTypes.nzGst": "Numero GST neo-zelandais",
      "accountSettings.company.taxTypes.sgGst": "Numero GST singapourien",
      "accountSettings.company.taxTypes.usEin": "EIN americain",
      "accountSettings.company.taxTypes.zaVat": "Numero de TVA sud-africain",
      "security.twoFactor.title": "Authentification a deux facteurs",
      "security": {
        "twoFactor": {
          "title": "Authentification a deux facteurs",
          "subtitle": "Protegez votre compte avec un code a 6 chiffres depuis une application d authentification.",
          "setup": "Configurer la 2FA",
          "scanQr": "Scannez le QR code avec votre application d authentification. Si cela ne fonctionne pas, utilisez le code de configuration manuellement.",
          "openAuthenticator": "Ouvrir dans l application d authentification",
          "sixDigitCode": "Code a 6 chiffres",
          "enable": "Activer la 2FA",
          "disableWarning": "Desactivez la 2FA uniquement si vous etes sur que ce compte est protege autrement.",
          "code": "Code 2FA",
          "disable": "Desactiver la 2FA"
        },
        "password": "Mot de passe"
      },
      "security.twoFactor.subtitle": "Protegez votre compte avec un code a 6 chiffres depuis une application d authentification.",
      "security.twoFactor.setup": "Configurer la 2FA",
      "security.twoFactor.scanQr": "Scannez le QR code avec votre application d authentification. Si cela ne fonctionne pas, utilisez le code de configuration manuellement.",
      "security.twoFactor.openAuthenticator": "Ouvrir dans l application d authentification",
      "security.twoFactor.sixDigitCode": "Code a 6 chiffres",
      "security.twoFactor.enable": "Activer la 2FA",
      "security.twoFactor.disableWarning": "Desactivez la 2FA uniquement si vous etes sur que ce compte est protege autrement.",
      "security.password": "Mot de passe",
      "security.twoFactor.code": "Code 2FA",
      "security.twoFactor.disable": "Desactiver la 2FA",
      "billing.baseSubscription": "Abonnement de base",
      "billing.baseSubscriptionDescription": "Acces a Retailmaps et aux fonctions de base.",
      "billing.forRent": "A louer",
      "billing.forRentDescription": "Biens a louer actifs actives par ce compte utilisateur.",
      "billing.totals.trialDiscount": "Remise essai",
      "billing.totals.vat": "TVA",
      "billing.totals.totalInclVat": "Total TTC",
      "settingsPanel.mailTest.previewLogged": "{{provider}} n est pas encore entierement configure. L e-mail de test a ete enregistre comme apercu pour {{recipient}}.",
      "settingsPanel.mailTest.sentMessage": "E-mail de test envoye a {{recipient}} via {{provider}}.",
      "settingsPanel.mailTest.failed": "L envoi de l e-mail de test a echoue.",
      "settingsPanel.mailTest.yourInbox": "votre boite de reception",
      "propertyDetails.datePlaceholder": "jj-mm-aaaa",
      "brokerProperty": {
        "askingPrice": "Prix demande"
      },
      "owner.financieringBlock.vraagprijs": "Prix demande",
      "propertyDetails.askingRentPrice": "Loyer demande",
      "propertyDetails.serviceCosts": "Charges de service",
      "propertyDetails.takeoverPrice": "Pas-de-porte",
      "propertyDetails.availableFrom": "Disponible a partir de",
      "propertyDetails.projectInfoDivider": "Informations projet",
      "propertyDetails.addProjectInfo": "Ajouter des informations projet",
      "extraSections": {
        "addField": "Ajouter un champ",
        "addSection": "Ajouter une section",
        "newTab": "Nouvel onglet"
      },
      "extraFields.addField": "Ajouter un champ",
      "extraFields": {
        "addField": "Ajouter un champ",
        "addSection": "Ajouter une section"
      },
      "extraFields.addSection": "Ajouter une section",
      "extraFieldsBlock": {
        "addField": "Ajouter un champ",
        "addHeader": "Ajouter une section",
        "title": "Champs supplementaires"
      },
      "listings.common.roles.owner": "Proprietaire",
      "listings.common.roles.brokerOnBehalfOwner": "Courtier (pour le proprietaire)",
      "brokerRequests.overview": "Apercu",
      "brokerRequests.interestCount": "{{count}} interet(s)",
      "brokerRequests.buyContact": "Acheter (9 EUR)",
      "brokerRequests.profile.founded": "Annee de creation",
      "brokerRequests.profile.revenue": "Chiffre d'affaires",
      "retailerProperties.sameBrandInterestBlocked": "Il n'est pas permis de manifester un interet pour un bien de votre propre marque ou groupe.",
      "settingsPanel.map.fetchWarn": "Impossible de charger les parametres",
      "settingsPanel.map.saved": "Parametres enregistres.",
      "settingsPanel.map.saveFailed": "Echec de l'enregistrement.",
      "settingsPanel.map.colors.retail.picker": "Choisir la couleur des batiments retail",
      "settingsPanel.map.colors.other.picker": "Choisir la couleur des autres batiments",
      "settingsPanel.map.opacityLabel": "Opacite des autres batiments : {{value}}",
      "settingsPanel.map.previewOther": "Autres batiments",
      "settingsPanel.map.save": "Enregistrer les parametres",
      "retailerMap.downloadSvg": "Telecharger SVG",
      "retailerMap.downloadSvgTooltip": "Telecharger la carte au format SVG",
      "retailerMap.printMenu.paper": "Imprimer sur papier",
      "retailerMap.printMenu.pdf": "Enregistrer en PDF",
      "retailerMap.printMenu.svg": "Telecharger image carte SVG",
      "dashboardOverlay": {
        "shared": {
          "assistant": "Comment ca marche",
          "forRent": "A louer",
          "requests": "Demandes",
          "alerts": "Alertes",
          "analysis": "Analyse",
          "settings": "Parametres"
        },
        "broker": {
          "properties": "Biens"
        },
        "owner": {
          "forRent": "A louer"
        },
        "retailer": {
          "interests": "Interets"
        }
      },
      "myProperties.nr": "No.",
      "myProperties.tenant": "Locataire",
      "myProperties.status": "Statut",
      "myProperties.actions": "Actions",
      "myProperties.assetManager": "Asset manager",
      "myProperties.noAssetManager": "- aucun -",
      "myProperties.noPaidSubscriptionSuffix": " - aucun abonnement payant",
      "myProperties.noResults": "Aucun resultat",
      "myProperties.ownProperties": "Mes biens",
      "myProperties.groupProperties": "Portefeuille de l'organisation",
      "myProperties.stopRent": "Arreter la location",
      "myProperties.setForRent": "Mettre en location",
      "myProperties.street": "Rue",
      "myProperties.allCities": "Toutes les villes",
      "myProperties.allStreets": "Toutes les rues",
      "myProperties.status.forRent": "A louer",
      "myProperties.status.rented": "Loue",
      "myProperties.bulk.assignToSelection": "Attribuer la selection",
      "myProperties.bulk.onlyUnassigned": "Uniquement sans asset manager",
      "myProperties.bulk.selectAllVisible": "Tout selectionner",
      "myProperties.bulk.noManagerSelected": "Choisissez un asset manager.",
      "myProperties.bulk.noSelection": "Aucun bien selectionne.",
      "myProperties.loading": "Chargement...",
      "myProperties.assignToMe": "M'attribuer",
      "myProperties.analysis": "Analyse",
      "myProperties.view": "Voir",
      "myProperties.assignError": "Attribution echouee.",
      "myProperties.assignRequiresPaidSubscription": "Cet utilisateur a besoin d'un abonnement actif.",
      "myProperties.importPortfolio": "Importer le portefeuille",
      "myProperties.rentToggleError": "La modification du statut de location a echoue.",
      "popup2": {
        "addedState": "Ajouté",
        "addToMyProperties": "Ajouter à mes biens",
        "front": "Façade",
        "groundFloor": "Rez-de-chaussée",
        "basement": "Sous-sol",
        "firstFloor": "1er étage",
        "secondFloor": "2e étage",
        "thirdFloor": "3e étage",
        "entresol": "Entresol",
        "soussol": "Sous-sol",
        "retailSpace": "Commerce",
        "secondarySpace": "Secondaire",
        "adding": "Ajout...",
        "publicData": "Données publiques",
        "privateData": "Données privées",
        "surface": "Surface",
        "unit": "Unité",
        "m2": "m²",
        "ft2": "ft²",
        "addToList": "Ajouter à mes biens",
        "saved": "Enregistré",
        "confirmRemove": "Êtes-vous sûr de vouloir supprimer ce bien de votre liste ?",
        "pandVerwijderd": "Bien supprimé de votre liste.",
        "verwijderenMislukt": "La suppression a échoué.",
        "removeFailed": "Échec de la suppression.",
        "pandToegevoegd": "Bien ajouté à votre liste.",
        "toevoegenMislukt": "L’ajout a échoué.",
        "viewRequests": "Voir les demandes dans le tableau de bord",
        "teHuurGestopt": "Le statut À louer a été arrêté et l’abonnement a été stoppé.",
        "invalidSession": "Session invalide. Connectez-vous à nouveau.",
        "subscriptionPrice": "19 € par mois",
        "extraPropertyPrice": "5 € par bien supplémentaire",
        "listingPrice": "Normalement 15 € par mois pour publier un bien à louer, temporairement gratuit"
      },
      "retailerMap": {
        "dashboard": "Tableau de bord",
        "loading": {
          "zoomInToLoad": "Zoomez jusqu'a {{zoom}} pour charger les enseignes",
          "fillingStreet": "Chargement des nouveaux locaux. Cela peut prendre jusqu'a 2 min...",
          "paintingFromCenter": "Chargement des locaux depuis le centre..."
        },
        "highlightEdit": {
          "adminHint": "Outil admin pour les formes de bâtiments incorrectes."
        },
        "installPrompt": {
          "subtitle": "Ajoutez Retailmaps à votre écran d’accueil."
        },
        "iosInstall": {
          "title": "Ajouter Retailmaps à l’écran d’accueil",
          "step2": "2. Choisissez Sur l’écran d’accueil."
        }
      },
      "propertyFields": {
        "shop": "Boutique",
        "storage": "Stockage",
        "secondary": "Secondaire"
      },
      "propertyList": {
        "filters": {
          "country": "Pays",
          "allCountries": "Tous les pays",
          "city": "Ville",
          "select": "Selectionner...",
          "street": "Rue",
          "typeStreet": "Saisir une rue...",
          "retailer": "Retailer",
          "retailerExampleShort": "Retailer",
          "searchAddress": "Rechercher une adresse",
          "scopeHint": "Choisissez une rue ou recherchez un retailer pour charger la liste des biens.",
          "noStreets": "Aucune rue trouvee",
          "cityRequiredForStreet": "Choisissez d abord une ville pour selectionner des rues."
        },
        "columns": {
          "number": "N.",
          "country": "Pays",
          "city": "Ville",
          "address": "Adresse",
          "retailer": "Retailer",
          "status": "Statut",
          "interests": "Interets",
          "purchased": "Achete",
          "details": "Details",
          "analysis": "Analyse",
          "rental": "Location",
          "showInterest": "Manifester son interet"
        },
        "status": {
          "forRent": "A louer",
          "notForRent": "Non disponible a la location"
        },
        "rental": {
          "setForRent": "Mettre en location",
          "stop": "Arreter la location",
          "stopForRent": "Arreter la location"
        },
        "pagination": {
          "rowsPerPage": "Lignes par page"
        },
        "interests": {
          "none": "Aucun interet",
          "date": "Date",
          "interestedParty": "Interesse",
          "type": "Type",
          "branch": "Secteur",
          "stores": "Magasins",
          "contactDetails": "Coordonnees",
          "protected": "Masque",
          "interest": "Interet",
          "generalInterest": "Interet general",
          "forRentInterest": "Interet pour location",
          "downloadContact": "Telecharger les coordonnees",
          "buyContact": "Acheter les coordonnees (EUR 9)"
        },
        "contactPurchase": {
          "title": "Acheter les coordonnees",
          "description": "Acceptez le prix unique de 9 EUR pour deverrouiller ces coordonnees.",
          "invoiceNotice": "9 EUR seront ajoutes a votre prochaine facture mensuelle de carte bancaire.",
          "buy": "Accepter 9 EUR et deverrouiller"
        },
        "openDetails": "Ouvrir les details",
        "loading": "Chargement des biens...",
        "noPropertiesFound": "Aucun bien trouve",
        "interest": {
          "changeFailed": "La modification de l interet a echoue.",
          "ownGroup": "Meme groupe",
          "viaColleague": "Via un collegue",
          "show": "Montrer l interet"
        }
      },
      "analysis.title": "Analyse",
      "analysis.empty": "Ajoutez des biens a l analyse pour afficher les chiffres.",
      "analysis.summary.totalRent": "Loyer annuel total",
      "analysis.summary.totalAskingRent": "Loyer demande total",
      "analysis.summary.weightedArea": "m2 ponderes",
      "analysis.summary.avgRentPerM2": "Loyer moyen/m2/an",
      "analysis.summary.avgAskingRentPerM2": "Loyer demande moyen/m2/an",
      "analysis.metrics.waltYears": "WALT : {{value}} ans",
      "analysis.metrics.expiry12": "Expiration 12 m : {{value}}",
      "analysis.metrics.expiry24": "Expiration 24 m : {{value}}",
      "analysis.metrics.expiry36": "Expiration 36 m : {{value}}",
      "analysis.values.years": "{{value}} ans",
      "analysis.actions.clear": "Vider l analyse",
      "analysis.actions.collapseSurfaces": "Replier les surfaces",
      "analysis.actions.expandSurfaces": "Deplier les surfaces",
      "analysis.table.property": "Bien",
      "analysis.table.tenant": "Locataire",
      "analysis.table.front": "Facade",
      "analysis.table.annualRent": "Loyer annuel",
      "analysis.table.askingRent": "Loyer demande",
      "analysis.table.weightedM2": "m2 ponderes",
      "analysis.table.rentPerM2": "Loyer/m2",
      "analysis.table.askingRentPerM2": "Loyer demande/m2",
      "analysis.table.expiry": "Expiration",
      "analysis.table.remainingTerm": "Duree restante",
      "analysis.table.remainingMonths": "Mois restants",
      "analysis.table.rentCoverage": "Couverture du loyer",
      "analysis.table.interestCoverage": "Couverture des interets",
      "analysis.table.guaranteeMonths": "Mois de garantie",
      "analysis.table.surfaces": "Surfaces",
      "analysis.surfaces.title": "Surfaces",
      "analysis.surfaces.helper": "Par defaut : retail 100 %, secondaire 50 %. Ajustez par etage ici.",
      "analysis.surfaces.weightedTotal": "Total pondere",
      "analysis.surfaces.grossM2": "{{value}} m2 brut",
      "analysis.surfaces.weightedM2Value": "= {{value}} m2",
      "analysis.surfaces.empty": "Aucune surface trouvee. Renseignez les surfaces retail et secondaires dans les donnees publiques.",
      "analysis.surfaceFields.front": "Facade",
      "analysis.surfaceFields.winkel": "Boutique",
      "analysis.surfaceFields.secundair": "Secondaire",
      "analysis.surfaceFields.begane_grond_winkel": "Rez-de-chaussee boutique",
      "analysis.surfaceFields.begane_grond_secundair": "Rez-de-chaussee secondaire",
      "analysis.surfaceFields.kelder_winkel": "Sous-sol boutique",
      "analysis.surfaceFields.kelder_secundair": "Sous-sol secondaire",
      "propertyList.rental.stopForRent": "Arreter la location",
      "analysis.summary.wault": "WAULT",
      "analysis.actions.remove": "Supprimer",
      "analysis.chips.wault": "WAULT : {{value}} ans",
      "analysis.chips.expiry12": "Expiration 12m : {{value}}",
      "analysis.chips.expiry24": "Expiration 24m : {{value}}",
      "analysis.chips.expiry36": "Expiration 36m : {{value}}",
      "analysis.table.weightedArea": "m2 ponderes",
      "analysis.table.ltv": "LTV",
      "analysis.surfaces.button": "Surfaces",
      "analysis.surfaceFields.shop": "Magasin",
      "analysis.surfaceFields.secondary": "Secondaire",
      "analysis.surfaceFields.beganeGrondWinkel": "Rez-de-chaussee commerce",
      "analysis.surfaceFields.beganeGrondSecundair": "Rez-de-chaussee secondaire",
      "analysis.surfaceFields.eersteVerdiepingWinkel": "1er etage commerce",
      "analysis.surfaceFields.eersteVerdiepingSecundair": "1er etage secondaire",
      "analysis.surfaceFields.tweedeVerdiepingWinkel": "2e etage commerce",
      "analysis.surfaceFields.tweedeVerdiepingSecundair": "2e etage secondaire",
      "analysis.surfaceFields.derdeVerdiepingWinkel": "3e etage commerce",
      "analysis.surfaceFields.derdeVerdiepingSecundair": "3e etage secondaire",
      "popup2.saved": "Enregistré",
      "propertyDetails.surface": "Surface",
      "interestButton": {
        "showInterest": "Manifester son intérêt",
        "withdraw": "Retirer"
      },
      "documents": {
        "add": "Ajouter un document"
      },
      "successPage": {
        "notLoggedIn": "Non connecté. Réessayez.",
        "subscriptionActivated": "Votre abonnement a été activé avec succès !",
        "subscriptionFailed": "Échec de l’activation : ",
        "subscriptionError": "Une erreur est survenue.",
        "propertyForRent": "Le bien est maintenant à louer.",
        "propertyUpdateError": "Erreur lors de la mise à jour du retailer : ",
        "serverError": "Erreur serveur lors de la mise à jour du retailer.",
        "bundleActivated": "Pack activé avec succès.",
        "bundleFailed": "Échec de l’activation du pack.",
        "bundleError": "Erreur lors de l’activation du pack.",
        "interestRegistered": "Intérêt enregistré avec succès.",
        "interestStoredFailed": "Paiement effectué, mais profil non enregistré.",
        "interestStoreError": "Une erreur est survenue lors de l’enregistrement de votre intérêt.",
        "missingContactData": "Informations insuffisantes pour accorder l’accès.",
        "contactConfirmed": "Vos coordonnées sont maintenant disponibles. Redirection en cours...",
        "contactConfirmFailed": "Paiement effectué, mais l’accès n’est pas encore accordé.",
        "contactError": "Une erreur est survenue lors de l’accord de l’accès.",
        "incompleteOrUnknown": "Informations incomplètes ou inconnues.",
        "propertyAddFailed": "Échec de l’ajout du bien : ",
        "propertyAddError": "Erreur lors de l’ajout du bien.",
        "comboSuccess": "Bien ajouté et abonnement actif.",
        "comboFailed": "Échec de l’ajout après le paiement combiné : ",
        "extraPropertyAdded": "Bien supplémentaire ajouté avec succès.",
        "extraPropertyFailed": "Échec de l’ajout après paiement : ",
        "missingRetailerId": "Aucun retailerId renseigné."
      },
      "bundelSelector": {
        "option5": "5 biens (22,50 € / mois)",
        "option15": "15 biens (60 € / mois)",
        "option30": "30 biens (100 € / mois)",
        "option100": "100 biens (300 € / mois)"
      },
      "interest": {
        "completeProfileFirst": "Complétez d’abord votre profil (au moins 3 champs sur 6).",
        "confirmWithdraw": "Retirer l’intérêt ?",
        "withdrawnSuccess": "Intérêt retiré.",
        "bundleFull": "Votre pack est complet. Retirez un intérêt ou passez à une formule supérieure.",
        "saved": "Intérêt enregistré.",
        "noBundlePrompt": "Vous n’avez pas de pack d’intérêts actif.\n\nTapez :\n  « bundle » pour voir les packs,\n  « pay » pour payer 5 € hors TVA pour cette localisation,\nou autre chose pour annuler."
      },
      "account": {
        "saved": "Données du compte enregistrées",
        "saveSuccess": "Données du compte enregistrées avec succès",
        "saveFailed": "Échec de l’enregistrement",
        "logoUploaded": "Logo téléversé"
      },
      "myInterests": {
        "removeSuccess": "Intérêt supprimé",
        "removeError": "Erreur lors de la suppression de l’intérêt"
      },
      "subscriptionPage": {
        "subscription": {
          "extra": "Biens supplémentaires"
        }
      },
      "alerts.columns.alertDate": "Date d’alerte",
      "alerts.fields.expiryDate": "Date d’expiration",
      "alerts.fields.indexationDate": "Date d’indexation",
      "landing.roles.broker.title": "Conseiller plus efficacement grâce à une demande visible.",
      "registerPage": {
        "registrationSuccess": "Inscription réussie. Votre période d’essai gratuite a commencé."
      },
      "dashboardOverlay.shared.support": "Assistance",
      "support": {
        "title": "Assistance",
        "intro": "Besoin d’aide ? Envoyez votre question directement à notre équipe d’assistance.",
        "emailIntro": "Vous pouvez également nous envoyer un e-mail directement.",
        "category": "Sujet",
        "categoryGeneral": "Question générale",
        "categoryAccount": "Compte et abonnement",
        "categoryBilling": "Facturation et paiements",
        "categoryMap": "Carte et données",
        "categoryForRent": "À louer",
        "categoryBug": "Signaler un problème",
        "subject": "Objet",
        "message": "Votre question",
        "subjectPlaceholder": "Décrivez brièvement votre question",
        "messagePlaceholder": "Dites-nous comment nous pouvons vous aider",
        "send": "Envoyer à l’assistance",
        "sending": "Envoi en cours…",
        "successTitle": "Votre demande d’assistance a été envoyée",
        "success": "Nous avons reçu votre question. Votre référence est {{ticketNumber}}. Vous recevrez également une confirmation par e-mail.",
        "context": "Votre message est lié à votre compte {{role}} et à la page que vous consultez.",
        "validation": "Veuillez saisir un objet et votre question.",
        "error": "Votre demande n’a pas pu être envoyée. Réessayez ou écrivez à support@retailmaps.com."
      }
    }
  },
  "it": {
    "translation": {
      "popup2.trialPaywallTitle": "Hai utilizzato le tue 10 manifestazioni di interesse gratuite",
      "popup2.trialPaywallDescription": "Per manifestare interesse anche per questo immobile, è necessario un abbonamento. Le tue 10 manifestazioni di interesse di prova attuali verranno convertite in manifestazioni di interesse a pagamento.",
      "popup2.trialPaywallManage": "In seguito potrai gestire queste manifestazioni di interesse nella dashboard (modificarle o rimuoverle).",
      "popup2.trialPaywallActivate": "Attiva abbonamento",
      "popup2": {
        "userRoleInLog": "User role in Popup2:",
        "checkIfPropertyInList": "Check if property is in list:",
        "userHasProperties": "User has properties:",
        "errorFetchingUser": "Error fetching user:",
        "noUserEmail": "No userEmail available. Please check if you are logged in.",
        "loginRequired": "Non hai effettuato l accesso. Accedi di nuovo per aggiungere immobili.",
        "publicStatusUpdated": "Public visibility successfully updated:",
        "publicStatusUpdateFailed": "Error saving public visibility status",
        "publicStatusUpdateError": "Error while making public:",
        "saveFailed": "Salvataggio non riuscito.",
        "invalidJSON": "Invalid JSON, using fallback:",
        "saveSummary": "onSave() summary:",
        "inList": "Questo immobile ? nella tua lista",
        "confirmRemove": "Sei sicuro di voler rimuovere questo immobile dalla lista?",
        "removed": "Property removed from your list.",
        "removeError": "Error removing property:",
        "removeFailed": "Rimozione non riuscita.",
        "removeFromList": "Rimuovi dai miei immobili",
        "addRequestLog": "Send request: add-property",
        "addResponseLog": "Server response:",
        "added": "Property added to your list!",
        "addFailed": "Adding failed.",
        "addError": "Error adding property:",
        "addToList": "Aggiungi ai miei immobili",
        "addToMyProperties": "Aggiungi ai miei immobili",
        "addedState": "Aggiunto",
        "adding": "Aggiunta...",
        "localStorageUpdated": "localStorage user updated with property:",
        "interestedRetailers": "Retailer interessati",
        "retailersHaveInterest": "retailer hanno mostrato interesse",
        "viewRequests": "Vedi interesse negli immobili",
        "publicData": "Dati pubblici",
        "privateData": "Dati privati",
        "publicDataHint": "Informazioni visibili per offerte, brochure e visualizzazioni mappa.",
        "privateDataHint": "Le informazioni interne restano nel workspace sicuro e sono visibili solo agli utenti autorizzati.",
        "privateWorkspace": "Workspace privato",
        "privateWorkspaceHint": "Usa queste schede per gestire in modo chiaro e sicuro note riservate del proprietario, dati finanziari, contatti, foto e documenti.",
        "cancel": "Annulla",
        "busy": "Operazione in corso...",
        "confirm": "Conferma",
        "surface": "Superficie",
        "retailSpace": "Negozio",
        "secondarySpace": "Secondaria",
        "address": "Indirizzo",
        "city": "Citt?",
        "website": "Sito web",
        "front": "Fronte",
        "groundFloor": "Piano terra",
        "basement": "Seminterrato",
        "firstFloor": "1o piano",
        "secondFloor": "2o piano",
        "thirdFloor": "3o piano",
        "entresol": "Soppalco",
        "soussol": "Seminterrato",
        "unit": "Unit?",
        "m2": "m2",
        "ft2": "ft2",
        "manageRentalStatus": "Gestisci stato affitto",
        "forRent": "In affitto",
        "confirmRent": "You are about to list this property for rent.\n- The cost is EUR 19 per month\n- The status will be visible to other parties\n\nClick OK to proceed.",
        "confirmStopRent": "You are about to stop the rental status.\n- This will also cancel your Stripe subscription for this property.\n\nAre you sure you want to continue?",
        "rentCancelled": "The rental status has been cancelled and the subscription has been stopped.",
        "stripeStartError": "Something went wrong while starting Stripe.",
        "stripeError": "Stripe error: ",
        "cancelError": "Error cancelling subscription:",
        "cancelStripeError": "Stripe cancellation failed: ",
        "makePublic": "Make publicly visible",
        "mustRentFirst": "List the property for rent before making it public.",
        "saveChanges": "Save changes",
        "visibilityUpdateFailed": "Changing visibility failed.",
        "extraPropertyFailed": "Adding an extra property failed.",
        "stripeStartFailed": "Starting Stripe failed.",
        "stripeErrorPrefix": "Stripe error: ",
        "interestAddFailed": "Adding interest failed.",
        "ownerMustAddFirst": "Add this property to your portfolio first.",
        "retailerBrandClaimRequired": "A brand claim is required to manage rental visibility.",
        "roleNotSupported": "Your current role does not support this action.",
        "saveError": "Error saving changes.",
        "extraPropertyTitle": "Add extra property",
        "setForRent": "Metti in affitto",
        "rentStatusActive": "In affitto (attivo)",
        "rentActionErrorPrefix": "Error changing rental status: ",
        "rentConfirmTitle": "Mettere immobile in affitto",
        "rentConfirmDescription": "Listing this property for rent normally costs EUR 15 per month, but is currently free during the launch period.",
        "rentLaunchFree": "Ora gratis",
        "dontShowAgain": "Non mostrare pi?",
        "openbaarZichtbaarMaken": "Rendi visibile pubblicamente",
        "opslaanWijzigingen": "Salva modifiche",
        "inPortfolio": "In portafoglio",
        "alreadyInOrgPortfolio": "Immobile gi? nel portafoglio dell organizzazione",
        "alreadyInOwnPortfolio": "Immobile gi? nel tuo portafoglio",
        "invalidSession": "Sessione non valida, accedi di nuovo",
        "trialLimitReachedTitle": "Limite raggiunto",
        "trialLimitReachedDesc1": "Massimo 10 interessi gratuiti nel periodo di prova",
        "trialLimitReachedDesc2": "Attiva l abbonamento per continuare:",
        "pandVerwijderd": "Immobile rimosso dalla tua lista.",
        "verwijderenMislukt": "Rimozione non riuscita.",
        "pandToegevoegd": "Immobile aggiunto alla tua lista.",
        "toevoegenMislukt": "Aggiunta non riuscita.",
        "stripeStartFout": "Qualcosa ? andato storto avviando Stripe.",
        "confirmTeHuurZetten": "Stai per mettere questo immobile in affitto.\n? Normalmente {{prijs}} al mese, ora temporaneamente gratis\n? Lo stato sar? visibile ad altre parti\n\nClicca OK per confermare.",
        "confirmStopTeHuurStatus": "Stai per terminare lo stato in affitto. Questo fermer? anche l abbonamento Stripe per questo immobile. Vuoi continuare?",
        "teHuurGestopt": "Lo stato in affitto ? terminato e l abbonamento ? stato fermato.",
        "stripeAnnuleringMislukt": "Annullamento Stripe non riuscito",
        "zetEerstTeHuur": "Metti prima l immobile in affitto prima di renderlo pubblico.",
        "addPropertyError": "Errore durante l aggiunta dell immobile",
        "subscriptionPrice": "?19 al mese",
        "extraPropertyPrice": "?5 per immobile extra",
        "listingPrice": "Normalmente ?15 al mese per mettere un immobile in affitto, ora temporaneamente gratis",
        "stripeSessionFailed": "Avvio sessione Stripe non riuscito",
        "stripeNotLoaded": "Stripe.js non caricato",
        "extraPandFailed": "Impossibile avviare checkout per immobile extra",
        "onlyMineHeader": "Gestione stato non possibile",
        "onlyMineMessage": "Non puoi modificare lo stato. Per modificarlo devi aggiungere l immobile a I miei immobili.",
        "interestConfirmBody": "Questo interesse viene salvato su questo immobile e aggiunto alla tua panoramica. Finch? resti entro il limite di prova o hai accesso attivo, non vengono addebitati costi extra. Se ? richiesto un pagamento, lo chiederemo separatamente prima di generare costi.",
        "skipConfirmation": "Non mostrare pi? questa conferma"
      },
      "authLanding": {
        "tabs": {
          "login": "Accedi",
          "register": "Registrati"
        },
        "roles": {
          "retailer": "Retailer",
          "owner": "Proprietario",
          "broker": "Broker"
        },
        "headlines": {
          "login": {
            "eyebrow": "Intelligence per immobili retail",
            "subtitle": "Accedi e lavora da una mappa live per portafoglio, locazioni e interessi."
          },
          "register": {
            "eyebrow": "Una piattaforma per broker, proprietari e retailer",
            "subtitle": "Crea un account e costruisci portafoglio, offerte e intelligence di mercato direttamente dalla mappa."
          },
          "forgot": {
            "eyebrow": "Recupera accesso",
            "subtitle": "Richiedi un link di reset e imposta rapidamente una nuova password."
          }
        },
        "forgot": {
          "helper": "Inserisci il tuo indirizzo e-mail. Se l account esiste, invieremo subito un link di reset."
        },
        "roleSlides": {
          "broker": {
            "label": "Broker",
            "eyebrow": "For brokers",
            "subtitle": "Bring listings to market, track interest and unlock contact details directly from the same map workspace.",
            "featureCards": {
              "0": "Publish available locations faster.",
              "1": "Work with live interest, documents and project information.",
              "2": "Keep listings, leads and analysis in one place."
            },
            "workflowSteps": {
              "0": "From property to listing",
              "1": "Interest and contact details",
              "2": "Analysis per location"
            },
            "footer": {
              "0": "Listings",
              "1": "Lead intelligence",
              "2": "Broker intelligence"
            }
          },
          "owner": {
            "label": "Owner",
            "eyebrow": "For owners",
            "subtitle": "Manage portfolio, lease data, documents and alerts from a map that fits real estate workflows.",
            "featureCards": {
              "0": "Store lease, ownership and financial data centrally.",
              "1": "List properties for rent and follow status on the map.",
              "2": "Use alerts and analysis without separate spreadsheets."
            },
            "workflowSteps": {
              "0": "Portfolio control",
              "1": "Lease data and alerts",
              "2": "Asset analysis"
            },
            "footer": {
              "0": "Portfolio management",
              "1": "Lease information",
              "2": "Owner analytics"
            }
          },
          "retailer": {
            "label": "Retailer",
            "eyebrow": "For retailers",
            "subtitle": "Discover streets, manage stores, show interest and analyse locations before taking the next step.",
            "featureCards": {
              "0": "See relevant retail streets and available properties.",
              "1": "Add stores to your own portfolio.",
              "2": "Show interest and compare locations in analysis."
            },
            "workflowSteps": {
              "0": "Manage stores",
              "1": "Show interest",
              "2": "Compare locations"
            },
            "footer": {
              "0": "My stores",
              "1": "Interest",
              "2": "Retail analysis"
            }
          }
        },
        "platformSubtitle": "Per e da professionisti retail",
        "heroSubtitle": "La mappa retail live per aree commerciali nel mondo, locazioni, interessi, lead e analisi location. Tutto in una sola piattaforma.",
        "trialIntro": "Inizia qui la prova gratuita di 60 giorni",
        "trialCta": "Registrati",
        "marketTagline": "Vie prime retail ? contesto di mercato live",
        "featureCards": {
          "0": "Work from a live map layer with retail context.",
          "1": "Manage portfolio, leasing and interest in one place.",
          "2": "Connect broker, owner and retailer in one workflow."
        },
        "workflowSteps": {
          "0": "Portfolio and listing control",
          "1": "Live market signals on the map",
          "2": "One workflow for every role"
        },
        "footer": {
          "0": "Portfolio management",
          "1": "For-rent listings",
          "2": "Retail intelligence"
        },
        "modeLabel": {
          "login": "Bentornato",
          "register": "Nuovo account",
          "forgot": "Password dimenticata"
        },
        "panelTitle": {
          "login": "Accedi a Retailmaps",
          "register": "Inizia con Retailmaps",
          "forgot": "Reimposta la password"
        },
        "fields": {
          "email": "Indirizzo e-mail",
          "password": "Password",
          "firstName": "Nome",
          "lastName": "Cognome",
          "role": "Ruolo",
          "phone": "Telefono",
          "companyName": "Nome azienda",
          "website": "Sito web"
        },
        "actions": {
          "forgotPassword": "Password dimenticata?",
          "login": "Accedi",
          "register": "Registrati",
          "startTrial": "Avvia prova gratuita",
          "sendReset": "Invia link di reset",
          "backToLogin": "Torna al login",
          "openLocalReset": "Open local reset link"
        },
        "legal": {
          "acceptPrefix": "Accetto la",
          "privacy": "informativa privacy",
          "and": "e i",
          "terms": "termini e condizioni"
        },
        "errors": {
          "loginFailed": "Accesso non riuscito. Controlla i dati inseriti.",
          "registerFailed": "Registrazione non riuscita. Riprova.",
          "companyRequired": "Il nome azienda ? obbligatorio.",
          "forgotNotice": "If this email address is known, we have sent a reset link.",
          "forgotFailed": "We could not send the reset link right now."
        }
      },
      "successStripe": {
        "title": "Stripe success",
        "waitTitle": "Payment received",
        "waitDescription": "We are finishing the activation now. This can take a few seconds. Keep this screen open; you will be redirected automatically when everything is ready.",
        "stepPayment": "Payment confirmed",
        "stepActivation": "Account or listing is being activated",
        "stepRedirect": "You will return to Retailmaps automatically",
        "back": "Back",
        "processing": "Processing...",
        "missingToken": "No valid token found. Please log in again.",
        "missingParams": "Missing parameters in the URL.",
        "unknownError": "Unknown error",
        "missingSessionId": "session_id is missing.",
        "missingRetailerId": "retailerId is missing.",
        "paymentReceivedActivating": "Payment received! The subscription is being activated...",
        "retailerListingActive": "The store is now for rent and publicly visible.",
        "ownerListingActive": "The property is now for rent.",
        "subscriptionActivating": "Subscription is being activated...",
        "subscriptionNotConfirmed": "The subscription could not be confirmed.",
        "subscriptionActive": "Subscription active.",
        "extraPropertyAdded": "Extra property added successfully.",
        "contactAccessUnlocked": "Payment received. We are preparing the contact details and returning you to the right property.",
        "interestProcessed": "Interest processed successfully.",
        "retailerSubscriptionActivating": "Retailer subscription is being activated...",
        "retailerSubscriptionActive": "Retailer subscription active.",
        "brokerSubscriptionActivating": "Payment received! The broker subscription is being activated...",
        "invalidType": "Unknown or invalid type.",
        "genericFailure": "Something went wrong: {{message}}"
      },
      "common": {
        "loading": "Caricamento...",
        "save": "Salva",
        "cancel": "Annulla",
        "edit": "Modifica",
        "delete": "Elimina",
        "close": "Chiudi",
        "yes": "Si",
        "no": "No",
        "localeCode": "en-GB",
        "backToDashboard": "Torna alla dashboard",
        "back": "Indietro",
        "busy": "In corso...",
        "open": "Apri",
        "active": "Attivo",
        "inactive": "Non attivo",
        "download": "Scarica",
        "canceled": "Annullato",
        "saved": "Salvato",
        "saving": "Salvataggio...",
        "saveFailed": "Salvataggio non riuscito",
        "ready": "Pronto",
        "confirm": "Conferma"
      },
      "roles": {
        "owner": "Proprietario",
        "retailer": "Retailer",
        "broker": "Agente"
      },
      "listings": {
        "common": {
          "country": "Paese",
          "city": "Città",
          "address": "Indirizzo",
          "askingPrice": "Prezzo richiesto",
          "currentRent": "Canone attuale",
          "keyMoney": "Buonuscita",
          "expiryDate": "Data di scadenza",
          "availableFrom": "Disponibile dal",
          "projectInformation": "Informazioni progetto",
          "onBehalfOf": "Per conto di",
          "visibility": "Visibilità",
          "actions": "Azioni",
          "upload": "Carica",
          "uploadDocument": "Carica documento",
          "chooseFile": "Scegli file",
          "noFileChosen": "Nessun file selezionato",
          "projectDocuments": "Documenti del progetto",
          "empty": "Al momento non ci sono locali in affitto.",
          "selectFileFirst": "Seleziona prima un file.",
          "uploadFailed": "Caricamento non riuscito.",
          "confirmDeleteDocument": "Sei sicuro di voler eliminare \"{{name}}\"?",
          "documentDeleteFailed": "Eliminazione del documento non riuscita.",
          "brochureFailed": "Generazione o caricamento della brochure non riusciti.",
          "stopForRent": "Ferma",
          "forRent": "In affitto",
          "documentTypes": {
            "document": "Documento",
            "floorplan": "Planimetria",
            "brochure": "Brochure",
            "photo": "Foto"
          },
          "visibilityOptions": {
            "public": "Tutti",
            "retailers": "Tutti i retailer",
            "interested": "Solo interessati"
          },
          "interestAndDocuments": "Mostra interesse e ricevi documenti",
          "deleteDocumentAria": "Elimina {{name}}",
          "selectDocumentFirst": "Seleziona prima almeno un documento.",
          "documentsSavedToProject": "I documenti selezionati sono stati aggiunti alle mie informazioni di progetto.",
          "documentsSaveFailed": "Salvataggio delle informazioni di progetto non riuscito.",
          "projectDocumentsHelp": "Apri i documenti tramite il link oppure selezionali per aggiungerli alle mie informazioni di progetto.",
          "addedOn": "Aggiunto il {{date}}",
          "saveToProjectInformation": "Aggiungi alle mie informazioni di progetto",
          "forRentSince": "In affitto dal",
          "onRequest": "Su richiesta",
          "broker": "Agente",
          "edit": "Modifica",
          "save": "Salva",
          "cancel": "Annulla",
          "noDocuments": "Nessun documento",
          "fileCountOne": "{{count}} file",
          "fileCountOther": "{{count}} file",
          "available": "Disponibile",
          "surface": "Superficie",
          "total": "Totale",
          "contactBroker": "Contatta il broker per la locazione",
          "thirdPartyNotice": "Informazioni provenienti da terzi. Verifica i dettagli presso il fornitore.",
          "goToInformation": "Vai alle informazioni",
          "viewDocuments": "Visualizza documenti",
          "unlockForPrice": "Sblocca gratis",
          "unlockDocuments": "Sblocca documenti",
          "oneTimeAccessPrice": "L’accesso ai documenti è attualmente gratuito."
        },
        "roles": {
          "external": "Offerta esterna",
          "owner": "Proprietario",
          "tenant": "Retailer",
          "brokerOnBehalfOwner": "Broker (per conto del proprietario)",
          "provider": "Fornitore"
        }
      },
      "ownerListings": {
        "currentOffer": "Le mie offerte in affitto"
      },
      "accountSettings": {
        "title": "Impostazioni",
        "tabs": {
          "profile": "Profilo",
          "company": "Azienda",
          "preferences": "Preferenze",
          "billing": "Fatturazione",
          "security": "Sicurezza"
        },
        "descriptions": {
          "profile": "Dati di contatto e ruolo del tuo account.",
          "company": "Dati aziendali, brand e fatturazione.",
          "preferences": "Lingua, valuta, unita e visualizzazione mappa.",
          "billing": "Abbonamento, utilizzo e acquisti singoli.",
          "security": "Accesso e sicurezza dell account."
        },
        "personal": {
          "title": "Profilo personale",
          "description": "Dati di contatto e ruolo del tuo account. Le modifiche vengono salvate automaticamente.",
          "firstName": "Nome",
          "lastName": "Cognome",
          "role": "Posizione",
          "phone": "Telefono",
          "email": "E-mail",
          "linkedin": "LinkedIn",
          "address": "Indirizzo"
        },
        "company": {
          "brandLogoTitle": "Brand e logo",
          "brandLogoDescription": "Usiamo questo logo nelle schede immobili e in altri spazi visibili del brand.",
          "title": "Profilo aziendale",
          "description": "Dati aziendali, informazioni del brand e fatturazione per account agenti e proprietari. Le modifiche vengono salvate automaticamente.",
          "readOnlyNotice": "Gruppo aziendale e dominio gestiscono collegamenti, visibilita e profili IA, quindi restano in sola lettura.",
          "companyName": "Nome azienda",
          "companyGroup": "Gruppo aziendale",
          "domain": "Dominio",
          "legalName": "Ragione sociale",
          "website": "Sito web",
          "roleType": "Tipo di ruolo",
          "headquartersTitle": "Sede",
          "headquartersAddress": "Indirizzo sede",
          "postalCode": "CAP",
          "city": "Citta",
          "country": "Paese",
          "billingTitle": "Fatturazione",
          "billingDescription": "Usiamo questi dati per abbonamenti, fatture e amministrazione finanziaria.",
          "billingEmail": "E-mail fatturazione",
          "invoiceReference": "Riferimento fattura / PO",
          "chamberOfCommerce": "Numero registro imprese",
          "vatNumber": "Partita IVA",
          "billingAddress": "Indirizzo fatturazione",
          "taxIdType": "Tipo codice fiscale",
          "taxIdValue": "Partita IVA / codice fiscale",
          "taxIdPlaceholder": "IT12345678901",
          "peopleTitle": "Persone",
          "peopleDescription": "Account collegati alla stessa organizzazione. Gli stati sono basati su abbonamento e periodo di prova.",
          "peopleName": "Nome",
          "peopleEmail": "E-mail",
          "peopleRole": "Ruolo",
          "peopleStatus": "Stato",
          "peopleTrialUntil": "Prova fino al",
          "peopleYou": "Tu",
          "peopleEmpty": "Non sono stati ancora trovati altri account in questa organizzazione.",
          "statusActive": "Attivo",
          "statusTrial": "Prova",
          "statusInactive": "Non attivo",
          "taxTypes": {
            "euVat": "Numero IVA europeo",
            "gbVat": "Numero IVA Regno Unito",
            "auAbn": "Numero aziendale australiano (AU ABN)",
            "auArn": "Numero riferimento fiscale australiano",
            "brCnpj": "Numero CNPJ brasiliano",
            "brCpf": "Numero CPF brasiliano",
            "caBn": "BN canadese",
            "caGstHst": "Numero GST/HST canadese",
            "chVat": "Numero IVA svizzero",
            "clTin": "TIN cileno",
            "egTin": "Codice fiscale egiziano",
            "inGst": "Numero GST indiano",
            "jpCn": "Numero aziendale giapponese",
            "jpRn": "Numero registrazione giapponese imprese estere",
            "mxRfc": "Numero RFC messicano",
            "noVat": "Numero IVA norvegese",
            "nzGst": "Numero GST neozelandese",
            "sgGst": "Numero GST Singapore",
            "usEin": "EIN Stati Uniti",
            "zaVat": "Numero IVA sudafricano"
          }
        }
      },
      "billing": {
        "title": "Fatturazione",
        "description": "Tutto per {{account}} in un unico riepilogo: abbonamenti, acquisti singoli e costi aperti di {{period}}.",
        "yourAccount": "il tuo account",
        "currentMonth": "questo mese",
        "currentPeriod": "Periodo corrente",
        "preparingPdf": "Preparazione PDF...",
        "downloadPdf": "Scarica fattura (PDF)",
        "downloadError": "Download della fattura non riuscito.",
        "loadError": "Impossibile caricare i dati di fatturazione.",
        "amountDueThisMonth": "Importo dovuto questo mese",
        "subscriptionStatus": "Stato abbonamento",
        "subscriptionActive": "Attivo",
        "subscriptionInactive": "Non attivo",
        "nextRenewal": "Prossimo rinnovo",
        "stripeCustomer": "Cliente Stripe",
        "paidSince": "Pagato da",
        "infoNotice": "I dati utente si trovano ora in Profilo e Azienda. Qui mostriamo solo cio che e rilevante dal punto di vista finanziario: costi ricorrenti, acquisti singoli e totale del mese corrente.",
        "summary": {
          "title": "Riepilogo"
        },
        "recurring": {
          "title": "Abbonamenti e utilizzo",
          "description": "Costi ricorrenti per abbonamento, immobili in affitto attivi e altri componenti mensili."
        },
        "oneOff": {
          "title": "Acquisti singoli",
          "description": "Costi una tantum, come sblocchi documenti o altri eventi di fatturazione separati.",
          "none": "Nessun acquisto singolo in questo periodo.",
          "noneTitle": "Nessun acquisto singolo in questo periodo",
          "noneDescription": "Non appena un acquisto singolo viene completato, apparira automaticamente qui.",
          "invoiceDescription": "Dati di contatto e altri acquisti singoli in questo periodo."
        },
        "totals": {
          "subscriptions": "Abbonamenti",
          "oneOff": "Acquisti singoli",
          "totalDue": "Totale dovuto",
          "trialDiscount": "Sconto prova",
          "vat": "IVA",
          "totalInclVat": "Totale incl. IVA"
        },
        "history": {
          "title": "Cronologia fatturazione",
          "description": "Eventi di fatturazione recenti e transazioni singole per questo account.",
          "none": "Non sono ancora stati trovati eventi di fatturazione per questo account.",
          "documentUnlock": "Sblocco documento"
        },
        "columns": {
          "description": "Descrizione",
          "quantity": "Qta",
          "unitPrice": "Unita",
          "total": "Totale",
          "date": "Data",
          "amount": "Importo",
          "status": "Stato"
        },
        "invoice": {
          "overview": "Invoice overview {{period}}",
          "invoiceDate": "Data fattura",
          "period": "Periodo",
          "statusOpen": "Stato: aperta",
          "billTo": "Fatturare a",
          "footer": "This overview was generated from the current Retailmaps billing data for this period.",
          "extraLocations": "+ {{count}} immobili extra"
        },
        "user": "Utente",
        "subscription": "Abbonamento",
        "trialUntil": "Periodo di prova fino al",
        "trialEndedOn": "Periodo di prova terminato il",
        "baseSubscription": "Abbonamento base",
        "perMonth": "al mese",
        "totalMonthlyCosts": "Costi mensili totali",
        "renewsOn": "Si rinnova il {{date}}",
        "noticePeriod": "Preavviso: 1 mese. L’abbonamento resta attivo finché non viene annullato.",
        "includesProperties": "include {{count}} immobili",
        "extraProperties": "Immobili extra",
        "totalProperties": "Totale immobili",
        "monthlyCosts": "Costi mensili",
        "cancelSubscription": "Annulla abbonamento",
        "cancellationScheduled": "Il tuo abbonamento terminerà il {{date}}. I tuoi dati resteranno archiviati e potranno essere ripristinati alla riattivazione.",
        "cancelDialog": {
          "title": "Annulla abbonamento",
          "retention": "L’abbonamento terminerà dopo il periodo pagato corrente. Non viene eliminato nulla: portafoglio, documenti, cronologia e fatture restano archiviati per la riattivazione.",
          "endsOn": "L’accesso resta attivo fino al {{date}}.",
          "ownerProperties": "I miei immobili",
          "retailerStores": "I miei negozi",
          "returnPortfolio": "Restituisci al portafoglio dell’organizzazione (non assegnato)",
          "transferColleague": "Trasferisci a un collega",
          "listings": "Annunci di affitto attivi",
          "archiveListings": "Interrompi e archivia alla data di fine",
          "transferListings": "Trasferisci a un collega",
          "interests": "Gli interessi attivi saranno ritirati alla data di fine. La cronologia protetta resterà archiviata.",
          "contacts": "I contatti acquistati e le fatture restano nella cronologia e vengono ripristinati alla riattivazione.",
          "recipient": "Collega destinatario",
          "confirm": "Programma annullamento"
        },
        "subtitle": "Abbonamenti, acquisti singoli e costi mensili in un unico riepilogo.",
        "forRent": "In affitto",
        "trial": {
          "title": "Periodo di prova",
          "active": "Il tuo periodo di prova di 60 giorni è attivo",
          "description": "Durante il periodo di prova puoi usare Retailmaps senza costi di abbonamento.",
          "daysRemainingLabel": "giorni rimanenti"
        },
        "baseSubscriptionDescription": "Accesso a Retailmaps e funzionalita di base.",
        "forRentDescription": "Immobili in affitto attivi abilitati da questo account utente."
      },
      "requests": {
        "title": "Richieste",
        "overview": "Panoramica",
        "loading": "Caricamento...",
        "none": "Nessuna richiesta ricevuta per i tuoi immobili.",
        "columns": {
          "number": "N.",
          "city": "Citt?",
          "address": "Indirizzo",
          "tenant": "Conduttore",
          "forRent": "In affitto",
          "total": "Totale",
          "purchased": "Acquistato",
          "date": "Data",
          "interestedParty": "Parte interessata",
          "type": "Tipo",
          "actions": "Azioni",
          "location": "Location",
          "profile": "Profilo"
        },
        "profile": {
          "branch": "Settore",
          "shops": "Negozi",
          "countries": "Paesi",
          "revenue": "Fatturato"
        },
        "interestTypes": {
          "forRent": "Interesse per affitto",
          "general": "Interesse generale"
        },
        "download": "Scarica contatti",
        "payToView": "Mostra contatti (€49)",
        "downloadLabel": "Download contact details",
        "payToViewLabel": "Buy contact details (€49)",
        "shielded": "Protetto",
        "removeError": "Removing the request failed.",
        "paymentError": "payment error",
        "branches": {
          "fashionAndApparel": "Fashion and apparel",
          "footwear": "Footwear",
          "foodAndBeverage": "Food and beverage",
          "beautyAndPersonalCare": "Beauty and personal care",
          "jewelleryAndWatches": "Jewellery and watches",
          "supermarketAndGrocery": "Supermarket and grocery",
          "electronics": "Electronics",
          "homeAndLiving": "Home and living",
          "sportsAndOutdoor": "Sports and outdoor",
          "booksAndMedia": "Books and media"
        },
        "empty": "Nessuna richiesta",
        "removeFailed": "Impossibile rimuovere la richiesta.",
        "total": "Totale",
        "purchased": "Acquistati",
        "date": "Data",
        "interestedParty": "Parte interessata",
        "hidden": "Nascosto",
        "downloadContact": "Scarica contatti",
        "buyContact": "Acquista contatti (49 €)",
        "interests": "Interessi"
      },
      "stores": {
        "common": {
          "number": "N.",
          "storeName": "Nome negozio",
          "status": "Stato",
          "byWho": "Da chi",
          "details": "Dettagli",
          "retailManager": "Retail manager",
          "brokerOnBehalfOfOwner": "Broker (on behalf of owner)"
        },
        "status": {
          "forRent": "In affitto",
          "rented": "Affittato"
        },
        "actions": {
          "stopRent": "Ferma affitto",
          "setForRent": "Metti in affitto"
        },
        "sections": {
          "mine": "I miei negozi",
          "organization": "Negozi della mia organizzazione"
        },
        "filters": {
          "allCountries": "Tutti i paesi",
          "allCities": "Tutte le citt?"
        },
        "messages": {
          "addedToPortfolio": "Store added to your portfolio.",
          "addFailed": "The store could not be added.",
          "removeFailed": "The store could not be removed.",
          "toggleRentFailed": "Changing rental status failed.",
          "subscriptionRequired": "An active subscription is required for this action.",
          "assignFailed": "Assigning failed."
        }
      },
      "admin": {
        "common": {
          "openModule": "Open module",
          "refreshing": "Refreshing...",
          "today": "Today",
          "week": "Week",
          "month": "Month",
          "year": "Year",
          "noData": "No data available yet.",
          "unknown": "unknown",
          "loading": "Loading...",
          "userLoadFailed": "User could not be loaded."
        },
        "dashboard": {
          "aiReview": "AI review"
        },
        "home": {
          "title": "Retailmaps Admin Ops",
          "subtitle": "Central control layer for mail, AI review, analytics and administration. This is where agents, teams and operational processes come together.",
          "heroStats": {
            "openReview": "Open review",
            "inbox7d": "Inbox 7d",
            "activeLanguages": "Active languages",
            "agentLanes": "Agent lanes"
          },
          "sections": {
            "alerts": "Operational alerts",
            "snapshot": "Operational snapshot"
          },
          "alerts": {
            "reviewBacklog": {
              "label": "Review backlog",
              "text": "{{count}} threads are waiting for review."
            },
            "draftsReady": {
              "label": "Drafts ready",
              "text": "{{count}} drafts are ready to review."
            },
            "escalations": {
              "label": "Escalations",
              "text": "{{count}} threads need manual follow-up."
            },
            "stable": {
              "label": "Stable",
              "text": "No urgent operational alerts right now."
            }
          },
          "snapshot": {
            "draftsReady": "{{count}} drafts ready",
            "laneDistribution": "Lane distribution",
            "languages": "Languages",
            "reviewActions": "Review actions",
            "approved": "Approved",
            "edited": "Edited",
            "escalated": "Escalated",
            "rejected": "Rejected"
          },
          "modules": {
            "emailOps": {
              "title": "Email Agent Ops",
              "description": "Triage, review, drafts, knowledge base and escalations for all incoming Retailmaps emails."
            },
            "aiQueue": {
              "title": "AI Queue",
              "description": "Brand validation and other AI-driven review flows that still need human control."
            },
            "statistics": {
              "title": "Statistics",
              "description": "Central overview of volumes, languages, response times, conversions and agent performance."
            },
            "administration": {
              "title": "Administration",
              "description": "Operational backoffice for billing, subscriptions, mailbox management and internal processes."
            }
          }
        },
        "emailDashboard": {
          "title": "Email Agent Ops",
          "subtitle": "Review incoming email, improve drafts and grow the knowledge base for the role agents.",
          "refreshMetrics": "Refresh metrics",
          "badges": {
            "aiActive": "AI active",
            "aiFallback": "AI fallback",
            "inboundActive": "Inbound active",
            "inboundMissing": "Inbound missing"
          },
          "metrics": {
            "openReview": "Open review",
            "draftsReady": "Drafts ready",
            "activeLanguages": "Active languages",
            "brokerLane": "Broker lane"
          },
          "helpers": {
            "openReview": "Threads waiting for review or approval.",
            "draftsReady": "Drafts currently ready to send.",
            "activeLanguages": "Languages currently seen in the inbox.",
            "brokerLane": "Threads currently routed to the broker agent."
          }
        },
        "brandQueue": {
          "title": "AI Queue",
          "pendingTitle": "Brands awaiting review",
          "verifiedTitle": "Verified brands",
          "reject": "Reject",
          "columns": {
            "name": "Name",
            "status": "Status",
            "createdAt": "Created",
            "actions": "Actions",
            "group": "Group",
            "domain": "Domain",
            "brands": "Brands"
          },
          "prompts": {
            "domain": "Domain for {{name}}? (e.g. levi.com)",
            "group": "Group / parent company for {{name}}? (e.g. Levi Strauss & Co.)",
            "reject": "Are you sure you want to reject '{{name}}'?"
          }
        },
        "mailPanel": {
          "title": "Agent review inbox",
          "subtitle": "Review, edit and respond to incoming email conversations from one central ops inbox.",
          "refreshInbox": "Refresh inbox",
          "mode": "Mode",
          "threads": "threads",
          "messages": "messages",
          "inbound": "inbound",
          "aiInactive": "AI is inactive, fallback drafts are being used.",
          "quickFilters": {
            "all": "All",
            "broker": "Broker inbox",
            "retailer": "Retailer inbox",
            "owner": "Owner inbox",
            "support": "Support inbox",
            "router": "Router inbox"
          },
          "filters": {
            "search": "Search",
            "lane": "Lane",
            "status": "Status",
            "agent": "Agent",
            "language": "Language",
            "review": "Review",
            "all": "All",
            "allLanes": "All lanes",
            "allStatuses": "All statuses",
            "allAgents": "All agents",
            "allLanguages": "All languages",
            "onlyNeedsReview": "Only needs review",
            "noReview": "No review filter",
            "clear": "Clear filters"
          },
          "inbox": "Inbox",
          "noSubject": "No subject",
          "unknownSender": "Unknown sender",
          "noThreads": "No threads match the current filters.",
          "threadDetail": "Thread detail",
          "loadingThread": "Loading thread...",
          "agentLabel": "Agent",
          "languageLabel": "Language",
          "statusLabel": "Status",
          "autoReplyEligible": "Auto-reply eligible",
          "reviewRequired": "Review required",
          "lastActivity": "Last activity",
          "escalation": "Escalation",
          "incomingMail": "Incoming mail",
          "incomingFrom": "Incoming from",
          "noPlainText": "No plain text body available.",
          "agentDraft": "Agent draft",
          "subject": "Subject",
          "reply": "Reply",
          "saveEditedAsKnowledge": "Save edited version as knowledge article",
          "sending": "Sending...",
          "sendReply": "Send reply",
          "approve": "Approve",
          "saveEdited": "Save edited",
          "escalate": "Escalate",
          "reject": "Reject",
          "feedbackProcessed": "Feedback processed successfully.",
          "feedbackFailed": "Processing feedback failed.",
          "replySentVia": "Reply sent to {{recipient}} via {{provider}}.",
          "replySendFailed": "Sending reply failed.",
          "manualEscalationNote": "Manual escalation requested by admin review.",
          "noDraft": "No draft is available yet for this thread.",
          "selectThread": "Select a thread to review its details and draft.",
          "knowledgeBase": "Knowledge base",
          "knowledgeTitle": "Title",
          "knowledgeContent": "Content",
          "knowledgeKeywords": "Keywords (comma separated)",
          "addKnowledgeArticle": "Add knowledge article",
          "knowledgeSaved": "Knowledge article saved.",
          "knowledgeSaveFailed": "Saving knowledge article failed.",
          "noKnowledgeArticles": "No knowledge articles available yet."
        },
        "statistics": {
          "title": "Statistics",
          "subtitle": "Live operations overview of volumes, review load, languages and feedback on agent answers.",
          "meta": {
            "generatedAt": "Generated at",
            "mailThreads": "Mail threads",
            "activeInboxCountries": "Active inbox countries"
          },
          "overview": {
            "users": "Users",
            "totalInterests": "Total interests",
            "totalProperties": "Total properties",
            "activeForRent": "Active for-rent stock",
            "activeListings": "Active listings",
            "activeSubscriptions": "Active subscriptions"
          },
          "roles": {
            "admins": "Admins",
            "brokers": "Brokers",
            "retailers": "Retailers",
            "owners": "Owners"
          },
          "conversion": {
            "interestsPerActiveProperty": "Interests per active property",
            "propertiesWithInterest": "Properties with interest",
            "propertiesWithInterestShare": "Share of properties with interest",
            "listingUnlockRate": "Listing unlock rate",
            "contactUnlocks": "Contact unlocks",
            "unlockRevenue": "Unlock revenue"
          },
          "manual": {
            "manualAddedToday": "Manually added today",
            "manualAddedMonth": "Manually added this month",
            "manualEditedToday": "Manually edited today",
            "manualEditedMonth": "Manually edited this month",
            "topCreators": "Top manual creators",
            "topEditors": "Top manual editors"
          },
          "sections": {
            "rolesAndGrowth": "Roles and growth",
            "accountsPerRole": "Accounts per role",
            "newUsers": "New users",
            "userCountries": "User countries",
            "userCountriesHelp": "Top countries based on user/company profile data.",
            "interestsByPeriod": "Interests by period",
            "manualInteraction": "Manual system interaction",
            "manualInteractionHelp": "User actions in which properties were manually added or edited.",
            "heatmapHotspots": "Interest hotspots",
            "heatmapHotspotsHelp": "Top city-country combinations based on recorded interests.",
            "interestsByCity": "Interests by city",
            "propertiesAdded": "Properties added",
            "topPropertyCountries": "Top countries in the property database",
            "activeForRentStock": "Active for-rent stock",
            "conversionSignals": "Conversion & commercial signals",
            "agentMailContext": "Agent mail context"
          }
        },
        "administration": {
          "title": "Administration",
          "subtitle": "Operational backoffice for mail health, environment status and internal ops readiness.",
          "sections": {
            "mailInfrastructure": "Mail infrastructure",
            "healthCheck": "Health check",
            "operationalStatus": "Operational status",
            "roadmap": "Next backoffice steps"
          },
          "fields": {
            "provider": "Provider",
            "from": "From",
            "frontendUrl": "Frontend URL",
            "internalInboxes": "Internal inboxes",
            "testRecipient": "Test recipient"
          },
          "health": {
            "mailProvider": "Mail provider",
            "mailProviderActive": "{{provider}} active",
            "notConfigured": "Not configured",
            "inboundAgent": "Inbound agent",
            "inboundActive": "Inbound receiving active",
            "inboundMissing": "Inbound receiving not configured",
            "aiClassification": "AI classification",
            "aiActive": "OpenAI active",
            "fallbackOnly": "Fallback only",
            "internalInboxes": "Internal inboxes",
            "internalRecipientsConfigured": "{{count}} internal recipients configured",
            "noInternalRecipients": "No internal recipients configured",
            "actionNeeded": "Action needed"
          },
          "status": {
            "threads": "Threads",
            "openReview": "Open review",
            "draftsReady": "Drafts ready",
            "escalations": "Escalations"
          },
          "roadmap": {
            "subscriptions": "Subscription and billing controls per role",
            "mailboxes": "Mailbox routing and alias management",
            "internalNotifications": "Internal notification preferences",
            "billing": "Billing exports and invoice overviews",
            "escalations": "Escalation rules and SLA monitoring",
            "agentPolicies": "Agent policies and role-specific automations",
            "footer": "This page is intentionally operational and will expand into the central Retailmaps backoffice."
          }
        }
      },
      "dashboardOverlay": {
        "shared": {
          "forRent": "In affitto",
          "requests": "Richieste",
          "alerts": "Alert",
          "analysis": "Analisi",
          "assistant": "Come funziona",
          "settings": "Impostazioni"
        },
        "owner": {
          "properties": "Immobili",
          "forRent": "In affitto"
        },
        "retailer": {
          "stores": "Negozi",
          "interests": "Interessi"
        },
        "broker": {
          "properties": "Immobili"
        },
        "admin": {
          "ops": "Ops",
          "mail": "Mail",
          "aiQueue": "Coda AI",
          "statistics": "Statistiche",
          "administration": "Amministrazione"
        }
      },
      "settingsPanel": {
        "common": {
          "saving": "Salvataggio...",
          "saved": "Salvato",
          "saveFailed": "Salvataggio non riuscito",
          "ready": "Pronto",
          "cancel": "cancel"
        },
        "regional": {
          "title": "Impostazioni regionali",
          "subtitle": "Scegli come funzionano lingua, valuta e unita. Browser e dati regionali vengono usati automaticamente.",
          "language": "Lingua",
          "currency": "Valuta",
          "units": "Unita",
          "autoLanguage": "Automatico ({{language}})",
          "autoCurrency": "Automatico ({{currency}})",
          "autoUnits": "Automatico ({{units}})",
          "metric": "Metrico",
          "imperial": "Imperiale",
          "detectedRegion": "Regione rilevata: {{region}}"
        },
        "mailTest": {
          "title": "E-mail di test",
          "subtitle": "Controlla se le impostazioni e-mail funzionano correttamente.",
          "send": "Invia e-mail di test",
          "sending": "Invio...",
          "status": "Stato: {{status}}",
          "providerActive": "{{provider}} attivo",
          "devPreviewOnly": "Solo anteprima dev",
          "from": "Da: {{value}}",
          "testRecipient": "Destinatario test: {{value}}",
          "internalInboxes": "Inbox interne: {{value}}",
          "noneConfigured": "Nessuna configurata",
          "notConfigured": "Non configurato",
          "previewLogged": "{{provider}} non e ancora configurato completamente. L e-mail di test e stata registrata come anteprima per {{recipient}}.",
          "sentMessage": "E-mail di test inviata a {{recipient}} tramite {{provider}}.",
          "failed": "Invio dell e-mail di test non riuscito.",
          "yourInbox": "la tua inbox"
        },
        "map": {
          "title": "Impostazioni mappa",
          "subtitle": "Regola colori, bordi, etichette e visibilita della mappa.",
          "invalidOrSaveFailed": "Colore non valido o salvataggio non riuscito.",
          "highlight": {
            "title": "Highlight intensity",
            "description": "Controls how strongly active polygons and selections stand out.",
            "retailTitle": "Intensita evidenziazione retail",
            "retailDescription": "Determina quanto gli immobili retail risaltano sulla mappa.",
            "otherTitle": "Intensita altri immobili",
            "otherDescription": "Determina quanto gli altri immobili sono visibili come livello di sfondo.",
            "opacity": "Intensita: {{value}}"
          },
          "markerFont": {
            "title": "Dimensione testo marker",
            "description": "Determina quanto grandi appaiono nomi ed etichette sulla mappa.",
            "size": "Scala: {{value}}"
          },
          "preview": {
            "title": "Anteprima",
            "description": "Una rapida anteprima delle impostazioni della mappa."
          },
          "colors": {
            "retail": {
              "label": "Colore retail",
              "description": "Colore base degli immobili retail sulla mappa."
            },
            "other": {
              "label": "Altri immobili",
              "description": "Colore base degli altri immobili sulla mappa."
            },
            "retailOutline": {
              "label": "Bordo immobili attivi",
              "description": "Colore del bordo per immobili attivi ed evidenziazioni."
            },
            "otherOutline": {
              "label": "Bordo altri immobili",
              "description": "Colore del bordo per immobili non attivi."
            },
            "markerName": {
              "label": "Colore nome marker",
              "description": "Colore del testo delle etichette sulla mappa."
            },
            "markerHover": {
              "label": "Colore hover",
              "description": "Colore di sfondo al passaggio sulle etichette."
            },
            "forRentMarker": {
              "label": "Marker in affitto",
              "description": "Colore del testo per i marker degli immobili in affitto."
            }
          }
        },
        "retailerMap": {
          "loading": {
            "zoomInToLoad": "Ingrandisci fino a {{zoom}} per caricare i retailer",
            "fillingStreet": "Caricamento di nuovi immobili. Puo richiedere fino a 2 min...",
            "paintingFromCenter": "Caricamento degli immobili dal centro..."
          },
          "errors": {
            "invalidSession": "invalid session",
            "noUserInfo": "no user info",
            "unknownRoleSubscription": "unknown role subscription"
          }
        },
        "dashboardOverlay": {
          "owner": {
            "properties": "properties",
            "forRent": "for rent"
          },
          "shared": {
            "requests": "requests",
            "alerts": "alerts",
            "analysis": "analysis",
            "assistant": "Come funziona",
            "settings": "settings"
          }
        },
        "myProperties": {
          "nr": "nr",
          "city": "city",
          "address": "address",
          "tenant": "tenant",
          "link": "link",
          "status": {
            "forRent": "In affitto",
            "rented": "Affittato"
          },
          "actions": "actions",
          "assetManager": "asset manager",
          "noAssetManager": "no asset manager",
          "noResults": "no results",
          "ownProperties": "own properties",
          "groupProperties": "group properties",
          "stopRent": "stop rent",
          "setForRent": "set for rent",
          "street": "street",
          "allCities": "all cities",
          "allStreets": "all streets",
          "bulk": {
            "assignToSelection": "assign to selection",
            "onlyUnassigned": "only unassigned",
            "selectAllVisible": "select all visible",
            "noManagerSelected": "no manager selected",
            "noSelection": "no selection"
          },
          "loading": "loading",
          "assignToMe": "assign to me",
          "view": "view",
          "assignError": "assign error",
          "claimSuccess": "claim success",
          "claimError": "claim error",
          "rentToggleError": "rent toggle error",
          "subscription": {
            "required": "required",
            "badge": "badge",
            "title": "title",
            "description": "description",
            "activate": "activate",
            "sessionError": "session error",
            "stripeMissing": "stripe missing",
            "startError": "start error"
          }
        },
        "requests": {
          "branches": {
            "fashionAndApparel": "fashion and apparel",
            "footwear": "footwear",
            "foodAndBeverage": "food and beverage",
            "beautyAndPersonalCare": "beauty and personal care",
            "jewelleryAndWatches": "jewellery and watches",
            "supermarketAndGrocery": "supermarket and grocery",
            "electronics": "electronics",
            "homeAndLiving": "home and living",
            "sportsAndOutdoor": "sports and outdoor",
            "booksAndMedia": "books and media"
          }
        },
        "countries": {
          "nl": "nl",
          "be": "be",
          "de": "de",
          "fr": "fr",
          "gb": "gb",
          "es": "es",
          "it": "it"
        },
        "branding": {
          "title": "Branding del broker",
          "subtitle": "Carica il tuo logo. Sara mostrato nelle tue inserzioni."
        }
      },
      "propertyDetails.back": "Torna alla panoramica",
      "propertyDetails.address": "Address",
      "propertyDetails.publicDataDivider": "Public data",
      "propertyDetails.privateDataDivider": "Dati privati",
      "propertyDetails.documentsDivider": "Documenti",
      "propertyDetails.photosDivider": "Foto",
      "propertyDetails.floorplansDivider": "Planimetrie",
      "propertyDetails.addFloorplan": "Aggiungi planimetria",
      "propertyDetails.removeFloorplan": "Rimuovi planimetria",
      "propertyDetails.floorplansInfo": "Carica le planimetrie come JPG o PNG. Questi disegni vengono usati nei layout delle brochure. I file PDF possono essere salvati in Documenti.",
      "propertyDetails.commentsDivider": "Note",
      "propertyDetails.contactsDivider": "Contatti",
      "propertyDetails.website": "Website",
      "propertyDetails.front": "Front",
      "propertyDetails.formalTenant": "Formal tenant",
      "propertyDetails.huurprijs": "Rent",
      "propertyDetails.startDate": "Start date",
      "propertyDetails.endDate": "Expiry date",
      "propertyDetails.remainingLeaseTermMonths": "Remaining lease term (months)",
      "propertyDetails.leaseTerm": "Lease term (years)",
      "propertyDetails.extensionYears": "Extension years",
      "propertyDetails.rentFreePeriodMonths": "Rent-free period (months)",
      "propertyDetails.indexDate": "Indexation date",
      "propertyDetails.cancelDate": "Notice date",
      "propertyDetails.cancelNotice": "Notice period",
      "propertyDetails.guaranteeAmount": "Guarantee amount",
      "propertyDetails.rentalData": "Dati locativi",
      "propertyDetails.financialData": "Dati finanziari",
      "propertyDetails.ownerData": "Dati proprietario",
      "propertyDetails.groundFloor": "Ground floor",
      "propertyDetails.basement": "Basement",
      "propertyDetails.firstFloor": "1st floor",
      "propertyDetails.secondFloor": "2nd floor",
      "propertyDetails.thirdFloor": "3rd floor",
      "propertyDetails.entresol": "Entresol",
      "propertyDetails.floorAreaTitle": "Superficie per piano (SLP)",
      "propertyDetails.retailSurface": "GLA",
      "propertyDetails.secondarySurface": "Secondary surface",
      "propertyDetails.retailSpace": "Retail",
      "propertyDetails.secondarySpace": "Secondary",
      "propertyDetails.sessionExpired": "Session expired, please log in again.",
      "propertyDetails.removeField": "Rimuovi campo",
      "propertyDetails.removeFieldHint": "Rimuovi i campi personalizzati facendo doppio clic sul campo e scegliendo Rimuovi campo.",
      "propertyDetails.autosave.saving": "Salvataggio...",
      "propertyDetails.autosave.saved": "Salvato",
      "propertyDetails.autosave.error": "Salvataggio non riuscito",
      "propertyDetails.autosave.active": "Autosave attivo",
      "propertyDetails.popupSettings.open": "Apri impostazioni",
      "propertyDetails.popupSettings.hide": "Nascondi impostazioni",
      "propertyDetails.popupSettings.title": "Impostazioni popup",
      "propertyDetails.popupSettings.description": "Scegli quali campi sono visibili nel popup della mappa. Vale per i campi standard e per i tuoi campi aggiuntivi.",
      "propertyDetails.popupSettings.extraFields": "campi aggiuntivi",
      "propertyDetails.popupSettings.noExtraFields": "Non ci sono ancora campi aggiuntivi in questa sezione.",
      "propertyDetails.popupSettings.showInPopup": "Mostra nel popup",
      "propertyDetails.popupSettings.hideInPopup": "Nascondi nel popup",
      "owner.ownerFields.title": "Dati proprietario",
      "owner.ownerFields.parentCompany": "Società madre proprietaria",
      "owner.ownerFields.owner": "Proprietario",
      "owner.ownerFields.contactPerson": "Persona di contatto",
      "owner.ownerFields.email": "Indirizzo e-mail",
      "owner.ownerFields.phone": "Numero di telefono",
      "owner.financieringBlock.title": "Dati finanziari",
      "owner.financieringBlock.koopsom": "Prezzo di acquisto",
      "owner.financieringBlock.aankoopdatum": "Data di acquisto",
      "owner.financieringBlock.hypotheek": "Importo del mutuo",
      "owner.financieringBlock.rentepercentage": "Tasso di interesse",
      "owner.financieringBlock.bank": "Banca",
      "owner.financieringBlock.looptijd": "Durata (anni)",
      "owner.financieringBlock.jaar": "anno",
      "owner.huurgegevensBlock.title": "Dati locativi",
      "owner.huurgegevensBlock.formeleHuurder": "Conduttore formale",
      "owner.huurgegevensBlock.huurprijs": "Canone",
      "owner.huurgegevensBlock.ingangsdatum": "Data di inizio",
      "owner.huurgegevensBlock.expiratiedatum": "Data di scadenza",
      "owner.huurgegevensBlock.resterendeLooptijdMaanden": "Durata residua del contratto",
      "owner.huurgegevensBlock.huurtermijn": "Durata del contratto",
      "owner.huurgegevensBlock.verlengingsjaren": "Anni di rinnovo",
      "owner.huurgegevensBlock.huurvrijePeriodeMaanden": "Periodo gratuito",
      "owner.huurgegevensBlock.indexatiedatum": "Data di indicizzazione",
      "owner.huurgegevensBlock.opzegdatum": "Data di disdetta",
      "owner.huurgegevensBlock.opzegtermijn": "Periodo di preavviso",
      "owner.huurgegevensBlock.garantiesoort": "Tipo di garanzia",
      "owner.huurgegevensBlock.kiesOptie": "Scegli un’opzione",
      "owner.huurgegevensBlock.waarborgsom": "Deposito cauzionale",
      "owner.huurgegevensBlock.bankgarantie": "Garanzia bancaria",
      "owner.huurgegevensBlock.concerngarantie": "Garanzia societaria",
      "owner.huurgegevensBlock.garantiebedrag": "Importo della garanzia",
      "owner.huurgegevensBlock.noGuarantee": "Nessuna garanzia",
      "owner.contactgegevensBlock.title": "Contatti",
      "owner.contactgegevensBlock.company": "Azienda",
      "owner.contactgegevensBlock.name": "Nome",
      "owner.contactgegevensBlock.phone": "Telefono",
      "owner.contactgegevensBlock.email": "E-mail",
      "owner.contactgegevensBlock.function": "Ruolo",
      "owner.contactgegevensBlock.remove": "Rimuovi contatto",
      "owner.contactgegevensBlock.add": "Aggiungi contatto",
      "owner.opmerkingen.title": "Note",
      "owner.opmerkingen.none": "Nessuna nota aggiunta.",
      "owner.opmerkingen.unknownAuthor": "Autore sconosciuto",
      "owner.opmerkingen.add": "Aggiungi nota",
      "owner.opmerkingen.placeholder": "Scrivi qui la tua nota...",
      "retailer.contactgegevensBlock.title": "Contact details",
      "retailer.contactgegevensBlock.company": "Company",
      "retailer.contactgegevensBlock.name": "Name",
      "retailer.contactgegevensBlock.phone": "Phone",
      "retailer.contactgegevensBlock.email": "Email",
      "retailer.contactgegevensBlock.function": "Role",
      "retailer.contactgegevensBlock.add": "Add contact",
      "retailer.contactgegevensBlock.remove": "Remove contact",
      "brokerContact.retailerContacts": "Retailer contacts",
      "brokerContact.ownerContacts": "Owner contacts",
      "brokerContact.company": "Company",
      "brokerContact.name": "Name",
      "brokerContact.phone": "Phone",
      "brokerContact.email": "Email",
      "brokerContact.position": "Role",
      "brokerContact.add": "Add contact",
      "brokerContact.remove": "Remove contact",
      "photos.title": "Foto",
      "photos.add": "Aggiungi foto",
      "photos.remove": "Rimuovi foto",
      "photos.error.tooLarge": "? pi? grande di 10 MB ed ? stato saltato.",
      "documents.title": "Documents",
      "documents.add": "Add document",
      "documents.remove": "Remove document",
      "documents.error.tooLarge": "is larger than 10 MB and was skipped.",
      "retailerMap.loading.zoomInToLoad": "Ingrandisci fino a {{zoom}} per caricare i retailer",
      "retailerMap.loading.fillingStreet": "Caricamento di nuovi immobili. Puo richiedere fino a 2 min...",
      "retailerMap.loading.paintingFromCenter": "Caricamento degli immobili dal centro...",
      "retailerMap.errors.invalidSession": "No valid session found. Please log in again.",
      "retailerMap.errors.noUserInfo": "No user information available.",
      "retailerMap.errors.unknownRoleSubscription": "Unknown user role. Subscription could not be started.",
      "retailerMap.dashboard": "Pannello",
      "retailerMap.addressPlaceholder": "Inserisci un indirizzo...",
      "retailerMap.flyButton": "Vai",
      "dashboardOverlay.owner.properties": "Immobili",
      "dashboardOverlay.owner.forRent": "In affitto",
      "dashboardOverlay.shared.requests": "Richieste",
      "dashboardOverlay.shared.alerts": "Alert",
      "dashboardOverlay.shared.analysis": "Analisi",
      "dashboardOverlay.shared.assistant": "Come funziona",
      "dashboardOverlay.shared.settings": "Impostazioni",
      "myProperties.nr": "N.",
      "myProperties.city": "Citta",
      "myProperties.address": "Indirizzo",
      "myProperties.tenant": "Conduttore",
      "myProperties.link": "Dettagli",
      "myProperties.status": "Stato",
      "myProperties.actions": "Azioni",
      "myProperties.assetManager": "Asset manager",
      "myProperties.noAssetManager": "- nessuno -",
      "myProperties.noResults": "Nessun risultato",
      "myProperties.ownProperties": "I miei immobili",
      "myProperties.groupProperties": "Portafoglio dell'organizzazione",
      "myProperties.stopRent": "Ferma affitto",
      "myProperties.setForRent": "Metti in affitto",
      "myProperties.street": "Via",
      "myProperties.allCities": "Tutte le citta",
      "myProperties.allStreets": "Tutte le vie",
      "myProperties.status.forRent": "In affitto",
      "myProperties.status.rented": "Affittato",
      "myProperties.bulk.assignToSelection": "Assegna alla selezione",
      "myProperties.bulk.onlyUnassigned": "Solo senza asset manager",
      "myProperties.bulk.selectAllVisible": "Seleziona tutti i visibili",
      "myProperties.bulk.noManagerSelected": "Scegli un asset manager.",
      "myProperties.bulk.noSelection": "Nessun immobile selezionato.",
      "myProperties.loading": "Caricamento...",
      "myProperties.assignToMe": "Assegna a me",
      "myProperties.view": "Visualizza",
      "myProperties.assignError": "Assegnazione non riuscita.",
      "myProperties.claimSuccess": "Property added to your portfolio.",
      "myProperties.claimError": "Adding the property failed.",
      "myProperties.rentToggleError": "Modifica dello stato di affitto non riuscita.",
      "myProperties.subscription.required": "An active subscription is required for this action.",
      "myProperties.subscription.badge": "Owner subscription",
      "myProperties.subscription.title": "Ready for your next property",
      "myProperties.subscription.description": "Your trial includes 3 properties. To claim the next property through the organisation, activate the owner subscription and continue right away.",
      "myProperties.subscription.activate": "Activate owner subscription",
      "myProperties.subscription.sessionError": "Could not start the Stripe session.",
      "myProperties.subscription.stripeMissing": "Stripe.js is not loaded.",
      "myProperties.subscription.startError": "Could not start the subscription.",
      "requests.branches.fashionAndApparel": "Fashion and apparel",
      "requests.branches.footwear": "Footwear",
      "requests.branches.foodAndBeverage": "Food and beverage",
      "requests.branches.beautyAndPersonalCare": "Beauty and personal care",
      "requests.branches.jewelleryAndWatches": "Jewellery and watches",
      "requests.branches.supermarketAndGrocery": "Supermarket and grocery",
      "requests.branches.electronics": "Electronics",
      "requests.branches.homeAndLiving": "Home and living",
      "requests.branches.sportsAndOutdoor": "Sports and outdoor",
      "requests.branches.booksAndMedia": "Books and media",
      "common.cancel": "Annulla",
      "countries.nl": "Netherlands",
      "countries.be": "Belgium",
      "countries.de": "Germany",
      "countries.fr": "France",
      "countries.gb": "United Kingdom",
      "countries.es": "Spain",
      "countries.it": "Italy",
      "common.back": "Back",
      "common.save": "Salva",
      "common.busy": "In corso...",
      "propertyDrawer.title": "Property details",
      "propertyDrawer.loadFailed": "Could not load property details.",
      "propertyDrawer.openInNewTab": "Open in new tab",
      "propertyDrawer.address": "Address",
      "propertyDrawer.status": "Status",
      "propertyDrawer.forRent": "For rent",
      "propertyDrawer.rented": "Rented",
      "propertyDrawer.assetManager": "Asset manager",
      "propertyDrawer.openInMaps": "Open in Maps",
      "interestButton.invalidSession": "No valid session.",
      "interestButton.withdraw": "Withdraw",
      "interestButton.showInterest": "Show interest",
      "retailerMap.printTooltip": "Scegli come esportare la mappa",
      "retailerMap.print": "Stampa",
      "retailerMap.openStreetView": "Apri Street View",
      "retailerMap.closeStreetView": "Chiudi Street View",
      "retailerMap.streetView": "Street View",
      "retailerMap.zoomIn": "Zoom in",
      "retailerMap.zoomOut": "Zoom out",
      "retailerMap.highlightEdit.dragHint": "Drag points, remove points or add a point.",
      "retailerMap.highlightEdit.selectHint": "Click a blue highlight to edit it.",
      "retailerMap.highlightEdit.adminHint": "Admin tool for incorrect building shapes.",
      "retailerMap.highlightEdit.disable": "Turn edit mode off",
      "retailerMap.highlightEdit.edit": "Edit highlight",
      "retailerMap.highlightEdit.merge": "Merge",
      "retailerMap.highlightEdit.reset": "Reset",
      "retailerMap.highlightEdit.mergeHint": "Select at least two blue highlights. Selected: {{count}}",
      "retailerMap.highlightEdit.mergeNow": "Merge now",
      "retailerMap.highlightEdit.buildingId": "Building ID",
      "retailerMap.highlightEdit.addPoint": "Add point",
      "retailerMap.highlightEdit.removePoint": "Remove point",
      "retailerMap.highlightEdit.makeOneShape": "Make one shape",
      "retailerMap.highlightEdit.removeCorrection": "Remove correction",
      "retailerMap.highlightEdit.restore": "Restore highlight",
      "propertyList.filters.city": "Citta",
      "propertyList.filters.street": "Via",
      "propertyList.filters.retailer": "Retailer",
      "propertyList.filters.select": "Seleziona...",
      "propertyList.filters.typeStreet": "Digita via...",
      "propertyList.filters.chooseCityFirst": "Scegli prima una citta",
      "propertyList.filters.noStreets": "No streets found",
      "propertyList.filters.cityRequiredForStreet": "Choose a city before selecting streets.",
      "propertyList.filters.retailerExample": "E.g. Suit Supply",
      "propertyList.filters.retailerExampleShort": "Retailer",
      "propertyList.filters.searchAddress": "Cerca indirizzo",
      "propertyList.filters.scopeHint": "Scegli una via o cerca un retailer per caricare l elenco degli immobili.",
      "propertyList.loading": "Caricamento immobili...",
      "propertyList.noPropertiesFound": "Nessun immobile trovato",
      "propertyList.openDetails": "Apri dettagli",
      "propertyList.pagination.rowsPerPage": "Righe per pagina",
      "propertyList.columns.number": "N.",
      "propertyList.columns.country": "Paese",
      "propertyList.columns.city": "Citta",
      "propertyList.columns.address": "Indirizzo",
      "propertyList.columns.retailer": "Retailer",
      "propertyList.columns.status": "Stato",
      "propertyList.columns.showInterest": "Show interest",
      "propertyList.columns.details": "Dettagli",
      "propertyList.columns.analysis": "Analisi",
      "propertyList.columns.interests": "Interessi",
      "propertyList.columns.purchased": "Acquistato",
      "propertyList.columns.rental": "Affitto",
      "propertyList.status.forRent": "In affitto",
      "propertyList.status.notForRent": "Non in affitto",
      "propertyList.interests.none": "Nessun interesse",
      "propertyList.interests.date": "Data",
      "propertyList.interests.interestedParty": "Interessato",
      "propertyList.interests.type": "Tipo",
      "propertyList.interests.branch": "Settore",
      "propertyList.interests.stores": "Negozi",
      "propertyList.interests.contactDetails": "Dati di contatto",
      "propertyList.interests.protected": "Nascosto",
      "propertyList.interests.forRentInterest": "Interesse per affitto",
      "propertyList.interests.generalInterest": "Interesse generale",
      "propertyList.interests.downloadContact": "Scarica dati di contatto",
      "propertyList.interests.buyContact": "Acquista dati di contatto (EUR 9)",
      "propertyList.interests.interest": "Interesse",
      "propertyList.contactPurchase.title": "Acquista dati di contatto",
      "propertyList.contactPurchase.description": "Stai acquistando i dati di contatto per questo interesse.",
      "propertyList.contactPurchase.invoiceNotice": "I costi vengono fatturati separatamente.",
      "propertyList.contactPurchase.buy": "Acquista dati di contatto",
      "dashboard": {
        "title": "Dashboard",
        "logout": "Esci",
        "backToMap": "Torna alla mappa",
        "trialExpiredTitle": "Periodo di prova scaduto",
        "trialExpiredText": "Attiva l abbonamento per continuare.",
        "activateSubscription": "Attiva abbonamento",
        "daysLeft": "{{count}} giorni rimanenti",
        "profile": "Profilo",
        "myInterests": "I miei interessi",
        "myProperties": "I miei immobili",
        "requests": "Richieste",
        "subscription": "Abbonamento",
        "bundles": "Pacchetti",
        "settings": "Impostazioni",
        "backToDashboard": "Torna alla dashboard",
        "brokerListings": "Offerte broker",
        "verhuurAanbod": "Offerte in affitto",
        "myStores": "I miei negozi",
        "brokerInterests": "broker interests",
        "subscriptionComingSoon": "subscription coming soon",
        "brokerAccount": "broker account"
      },
      "propertyDetails": {
        "back": "Torna alla panoramica",
        "address": "Indirizzo",
        "publicData": "Dati pubblici",
        "privateData": "Dati privati",
        "groundFloor": "Piano terra",
        "firstFloor": "1? piano",
        "secondFloor": "2? piano",
        "thirdFloor": "3? piano",
        "basement": "Seminterrato",
        "entresol": "Soppalco",
        "soussol": "Sottosuolo",
        "rentalData": "Dati locativi",
        "formalTenant": "Conduttore formale",
        "huurprijs": "Canone di locazione",
        "startDate": "Data inizio",
        "endDate": "Data scadenza",
        "remainingLeaseTermMonths": "Durata residua (mesi)",
        "indexDate": "Data indicizzazione",
        "cancelDate": "Data disdetta",
        "cancelNotice": "Preavviso disdetta (mesi)",
        "financialData": "Dati finanziari",
        "purchasePrice": "Prezzo di acquisto",
        "purchaseDate": "Data acquisto",
        "mortgage": "Importo mutuo",
        "interestRate": "Tasso interesse",
        "bank": "Banca",
        "loanDuration": "Durata (anni)",
        "comments": "Note",
        "addComment": "Aggiungi nota",
        "contacts": "Contatti conduttore",
        "documents": "Documenti",
        "photos": "Foto",
        "save": "Salva modifiche",
        "saveSuccess": "Dati salvati",
        "saveError": "Salvataggio non riuscito",
        "loading": "Caricamento...",
        "notFound": "Questa location non esiste pi?.",
        "contactName": "Nome",
        "role": "Funzione",
        "phone": "Telefono",
        "email": "E-mail",
        "addContact": "Aggiungi contatto",
        "delete": "Elimina",
        "addDocument": "Aggiungi documento",
        "addPhoto": "Aggiungi foto",
        "publicDataDivider": "Dati pubblici",
        "privateDataDivider": "Dati privati",
        "commentsDivider": "Note",
        "contactsDivider": "Contatti",
        "documentsDivider": "Documenti",
        "photosDivider": "Foto",
        "floorplansDivider": "Planimetrie",
        "addFloorplan": "Aggiungi planimetria",
        "removeFloorplan": "Rimuovi planimetria",
        "ownerData": "Dati proprietario",
        "floorAreaTitle": "Superficie per piano (SLP)",
        "retailSurface": "Superficie GLA",
        "secondarySurface": "Superficie secondaria",
        "retailSpace": "Negozio",
        "secondarySpace": "Secondaria",
        "sessionExpired": "Sessione scaduta, accedi di nuovo.",
        "autosave": {
          "saving": "Salvataggio...",
          "saved": "Salvato",
          "error": "Salvataggio non riuscito",
          "active": "Autosave attivo"
        },
        "popupSettings": {
          "open": "Apri impostazioni",
          "hide": "Nascondi impostazioni",
          "title": "Impostazioni popup",
          "showInPopup": "Mostra nel popup",
          "hideInPopup": "Nascondi nel popup",
          "description": "Scegli quali campi sono visibili nel popup della mappa. Vale per i campi standard e per i tuoi campi aggiuntivi.",
          "extraFields": "campi aggiuntivi",
          "noExtraFields": "Non ci sono ancora campi aggiuntivi in questa sezione."
        },
        "leaseTerm": "Durata locazione (anni)",
        "front": "Fronte",
        "noComments": "Nessuna nota",
        "guaranteeType": "guarantee type",
        "guaranteeAmount": "Guarantee amount",
        "addCommentPrompt": "add comment prompt",
        "addCommentPlaceholder": "add comment placeholder",
        "contactpersonen": "contactpersonen",
        "documentLabel": "document label",
        "floorplansInfo": "Carica le planimetrie come JPG o PNG. Questi disegni vengono usati nei layout delle brochure. I file PDF possono essere salvati in Documenti.",
        "removeField": "Rimuovi campo",
        "removeFieldHint": "Rimuovi i campi personalizzati facendo doppio clic sul campo e scegliendo Rimuovi campo.",
        "extensionYears": "Extension years",
        "rentFreePeriodMonths": "Rent-free period (months)",
        "extraFieldsDivider": "extra fields divider",
        "website": "Website",
        "floors": {
          "ground": "Piano terra",
          "basement": "Seminterrato",
          "first": "1? piano",
          "second": "2? piano",
          "third": "3? piano",
          "entresol": "Mezzanino",
          "soussol": "Sottosuolo"
        },
        "frontWidth": "Larghezza fronte",
        "objectInfoDivider": "Informazioni immobile",
        "addObjectInfo": "Aggiungi informazioni oggetto",
        "notesDivider": "Note",
        "datePlaceholder": "gg-mm-aaaa",
        "askingRentPrice": "Canone richiesto",
        "serviceCosts": "Spese di servizio",
        "takeoverPrice": "Buonuscita",
        "availableFrom": "Disponibile dal",
        "projectInfoDivider": "Informazioni progetto",
        "addProjectInfo": "Aggiungi informazioni progetto"
      },
      "retailerMap": {
        "dashboard": "Pannello",
        "addressPlaceholder": "Digita un indirizzo...",
        "flyButton": "Vai",
        "print": "Stampa",
        "openStreetView": "Apri Street View",
        "closeStreetView": "Chiudi Street View",
        "streetView": "Street View",
        "zoomIn": "Zoom avanti",
        "zoomOut": "Zoom indietro",
        "highlightEdit": {
          "disable": "Disattiva modalit? modifica",
          "edit": "Modifica highlight",
          "merge": "Unisci",
          "reset": "Reset",
          "mergeNow": "Unisci ora",
          "addPoint": "Aggiungi punto",
          "removePoint": "Rimuovi punto",
          "makeOneShape": "Crea una forma unica",
          "restore": "Ripristina highlight",
          "dragHint": "Drag points, remove points or add a point.",
          "selectHint": "Click a blue highlight to edit it.",
          "adminHint": "Admin tool for incorrect building shapes.",
          "mergeHint": "Select at least two blue highlights. Selected: {{count}}",
          "buildingId": "Building ID",
          "removeCorrection": "Remove correction"
        },
        "unnamed": "unnamed",
        "paywall": {
          "title": "title",
          "body": "body",
          "activate": "activate",
          "openDashboard": "open dashboard",
          "error": {
            "noJwt": "no jwt",
            "sessionExpired": "session expired",
            "noSubscription": "no subscription",
            "accessDenied": "access denied",
            "serverError": "server error",
            "network": "network",
            "trialExpired": "trial expired"
          }
        },
        "loading": {
          "zoomInToLoad": "Ingrandisci fino a {{zoom}} per caricare i retailer",
          "fillingStreet": "Caricamento di nuovi immobili. Puo richiedere fino a 2 min...",
          "paintingFromCenter": "Caricamento degli immobili dal centro...",
          "stores": "Caricamento negozi..."
        },
        "errors": {
          "invalidSession": "No valid session found. Please log in again.",
          "noUserInfo": "No user information available.",
          "unknownRoleSubscription": "Unknown user role. Subscription could not be started."
        },
        "printTooltip": "Print this map or save as PDF"
      },
      "interestButton": {
        "invalidSession": "Sessione non valida.",
        "withdraw": "Ritira",
        "showInterest": "Mostra interesse"
      },
      "propertyList": {
        "filters": {
          "city": "Citta",
          "street": "Via",
          "retailer": "Retailer",
          "select": "Seleziona...",
          "typeStreet": "Digita via...",
          "chooseCityFirst": "Scegli prima una citta",
          "noStreets": "Nessuna via trovata",
          "searchAddress": "Cerca indirizzo",
          "cityRequiredForStreet": "Choose a city before selecting streets.",
          "retailerExample": "E.g. Suit Supply",
          "retailerExampleShort": "Retailer",
          "scopeHint": "Scegli una via o cerca un retailer per caricare l elenco degli immobili.",
          "country": "Paese",
          "allCountries": "Tutti i paesi"
        },
        "loading": "Caricamento immobili...",
        "noPropertiesFound": "Nessun immobile trovato",
        "openDetails": "Apri dettagli",
        "pagination": {
          "rowsPerPage": "Righe per pagina"
        },
        "columns": {
          "number": "N.",
          "country": "Paese",
          "city": "Citta",
          "address": "Indirizzo",
          "retailer": "Retailer",
          "status": "Stato",
          "showInterest": "Mostra interesse",
          "details": "Dettagli",
          "analysis": "Analisi",
          "interests": "Interessi",
          "purchased": "Acquistato",
          "rental": "Affitto"
        },
        "status": {
          "forRent": "In affitto",
          "notForRent": "Non in affitto"
        },
        "interests": {
          "none": "Nessun interesse",
          "date": "Data",
          "interestedParty": "Interessato",
          "type": "Tipo",
          "branch": "Settore",
          "stores": "Negozi",
          "contactDetails": "Dati di contatto",
          "protected": "Nascosto",
          "forRentInterest": "Interesse per affitto",
          "generalInterest": "Interesse generale",
          "downloadContact": "Scarica dati di contatto",
          "buyContact": "Acquista dati di contatto (EUR 9)",
          "interest": "Interesse"
        },
        "contactPurchase": {
          "title": "Acquista dati di contatto",
          "buy": "Approva EUR 9 e sblocca",
          "description": "Approva il prezzo una tantum di EUR 9 per sbloccare questi dati di contatto.",
          "invoiceNotice": "EUR 9 saranno aggiunti alla prossima fattura mensile della carta di credito."
        },
        "rental": {
          "setForRent": "Metti in affitto",
          "stop": "Ferma affitto",
          "stopForRent": "Ferma affitto"
        }
      },
      "photos": {
        "title": "Foto",
        "add": "Aggiungi foto",
        "remove": "Rimuovi foto",
        "error": {
          "tooLarge": "? pi? grande di 10 MB ed ? stato saltato."
        },
        "useAsCover": "Usa come foto di copertina",
        "cover": "Copertina",
        "chooseCover": "Scegli",
        "openPreview": "Apri anteprima"
      },
      "documents": {
        "title": "Documenti",
        "add": "Aggiungi documento",
        "remove": "Rimuovi documento",
        "error": {
          "tooLarge": "is larger than 10 MB and was skipped."
        },
        "photoUpload": {
          "title": "title",
          "add": "add",
          "remove": "remove"
        },
        "rentDetails": {
          "title": "title",
          "rent": "rent",
          "startDate": "start date",
          "expiryDate": "expiry date",
          "indexationDate": "indexation date",
          "terminationDate": "termination date",
          "noticePeriod": "notice period",
          "guaranteeType": "guarantee type",
          "guaranteeAmount": "guarantee amount",
          "selectOption": "select option",
          "securityDeposit": "security deposit",
          "bankGuarantee": "bank guarantee"
        }
      },
      "retailer": {
        "contactgegevensBlock": {
          "title": "Contatti",
          "company": "Azienda",
          "name": "Nome",
          "phone": "Telefono",
          "email": "E-mail",
          "function": "Funzione",
          "add": "Aggiungi contatto",
          "remove": "Rimuovi"
        },
        "huurgegevensBlock": {
          "title": "title",
          "huurprijs": "huurprijs",
          "ingangsdatum": "ingangsdatum",
          "expiratiedatum": "expiratiedatum",
          "indexatiedatum": "indexatiedatum",
          "opzegdatum": "opzegdatum",
          "opzegtermijn": "opzegtermijn",
          "garantiesoort": "garantiesoort",
          "garantiebedrag": "garantiebedrag",
          "kiesOptie": "kies optie",
          "waarborgsom": "waarborgsom",
          "bankgarantie": "bankgarantie",
          "concerngarantie": "concerngarantie"
        },
        "listingsTitle": "Le mie offerte in affitto"
      },
      "brokerContact": {
        "retailerContacts": "Contatti retailer",
        "ownerContacts": "Contatti proprietario",
        "company": "Azienda",
        "name": "Nome",
        "phone": "Telefono",
        "email": "E-mail",
        "position": "Funzione",
        "add": "Aggiungi",
        "remove": "Rimuovi",
        "title": "title"
      },
      "successPage": {
        "processing": "Elaborazione...",
        "notLoggedIn": "Non hai effettuato l accesso.",
        "subscriptionActivated": "Abbonamento attivato.",
        "subscriptionFailed": "Attivazione abbonamento non riuscita.",
        "subscriptionError": "Errore abbonamento.",
        "propertyForRent": "Immobile messo in affitto.",
        "propertyUpdateError": "Aggiornamento immobile non riuscito.",
        "serverError": "Errore server.",
        "bundleActivated": "Pacchetto attivato.",
        "bundleFailed": "Attivazione pacchetto non riuscita.",
        "bundleError": "Errore pacchetto.",
        "interestRegistered": "Interesse registrato.",
        "interestStoredFailed": "Salvataggio interesse non riuscito.",
        "interestStoreError": "Errore salvataggio interesse.",
        "missingContactData": "Dati di contatto mancanti.",
        "contactConfirmed": "Contatto confermato.",
        "contactConfirmFailed": "Conferma contatto non riuscita.",
        "contactError": "Errore contatto.",
        "incompleteOrUnknown": "Flusso incompleto o sconosciuto.",
        "propertyAddFailed": "Aggiunta immobile non riuscita.",
        "propertyAddError": "Errore aggiunta immobile.",
        "success": "Operazione riuscita",
        "loading": "Caricamento...",
        "comboSuccess": "Operazione completata.",
        "comboFailed": "Operazione non riuscita.",
        "extraPropertyAdded": "Immobile extra aggiunto.",
        "extraPropertyFailed": "Aggiunta immobile extra non riuscita.",
        "missingRetailerId": "Retailer ID mancante."
      },
      "myProperties": {
        "title": "title",
        "back": "back",
        "empty": "empty",
        "name": "name",
        "address": "Address",
        "city": "City",
        "country": "country",
        "link": "Details",
        "action": "action",
        "remove": "Rimuovi",
        "confirmRemove": "confirm remove",
        "nr": "No.",
        "tenant": "Tenant",
        "status": {
          "forRent": "For rent",
          "rented": "Rented"
        },
        "actions": "Actions",
        "assetManager": "Asset manager",
        "noAssetManager": "â€” none â€”",
        "noResults": "No results",
        "ownProperties": "My properties",
        "groupProperties": "Organisation portfolio",
        "stopRent": "Stop rental",
        "setForRent": "Set for rent",
        "street": "Street",
        "allCities": "All cities",
        "allStreets": "All streets",
        "bulk": {
          "assignToSelection": "Assign to selection",
          "onlyUnassigned": "Only without asset manager",
          "selectAllVisible": "Select all visible",
          "noManagerSelected": "Choose an asset manager.",
          "noSelection": "No properties selected."
        },
        "loading": "Loading...",
        "assignToMe": "Assign to me",
        "view": "View",
        "assignError": "Assigning failed.",
        "claimSuccess": "Property added to your portfolio.",
        "claimError": "Adding the property failed.",
        "rentToggleError": "Changing the rental status failed.",
        "subscription": {
          "required": "An active subscription is required for this action.",
          "badge": "Owner subscription",
          "title": "Ready for your next property",
          "description": "Your trial includes 3 properties. To claim the next property through the organisation, activate the owner subscription and continue right away.",
          "activate": "Activate owner subscription",
          "sessionError": "Could not start the Stripe session.",
          "stripeMissing": "Stripe.js is not loaded.",
          "startError": "Could not start the subscription."
        }
      },
      "registerPage": {
        "title": "title",
        "email": "email",
        "password": "password",
        "role": "role",
        "retailer": "retailer",
        "owner": "owner",
        "broker": "broker",
        "brand": "brand",
        "website": "website",
        "firstName": "first name",
        "lastName": "last name",
        "phone": "phone",
        "register": "register",
        "registrationSuccess": "registration success"
      },
      "login": {
        "title": "title",
        "email": "email",
        "password": "password",
        "loginButton": "login button",
        "noAccount": "no account",
        "registerLink": "register link"
      },
      "bundelSelector": {
        "title": "title",
        "usage": "usage",
        "selectLabel": "select label",
        "option5": "option5",
        "option15": "option15",
        "option30": "option30",
        "option100": "option100",
        "upgradeButton": "upgrade button"
      },
      "retailerProfile": {
        "title": "title",
        "backToDashboard": "back to dashboard",
        "aantalWinkels": "aantal negozi",
        "actiefInLanden": "actief in landen",
        "oprichtingsjaar": "oprichtingsjaar",
        "aantalMedewerkers": "aantal medewerkers",
        "omzetIndicatie": "omzet indicatie",
        "branche": "branche",
        "saveButton": "save button",
        "back": "back",
        "personalTab": "personal tab",
        "companyTab": "company tab",
        "firstName": "first name",
        "lastName": "last name",
        "function": "function",
        "phone": "phone",
        "email": "email",
        "linkedin": "linkedin",
        "loading": "loading",
        "loadingText": "loading text",
        "success": "success",
        "error": "error",
        "bedrijfsnaam": "bedrijfsnaam",
        "website": "website",
        "hoofdkantoor": "hoofdkantoor",
        "logo": "logo",
        "kvkNummer": "kvk nummer",
        "btwNummer": "btw nummer",
        "personalTitle": "Profilo personale",
        "companyTitle": "Profilo aziendale",
        "autosaveHint": "Le modifiche vengono salvate automaticamente.",
        "companyProtectedHint": "Gruppo aziendale e nome azienda guidano i profili AI e i collegamenti interni, quindi restano protetti.",
        "parentCompany": "Societa madre",
        "company": "Azienda",
        "companyName": "Nome azienda",
        "name": "Nome",
        "legalName": "Ragione sociale",
        "headquartersAddress": "Indirizzo sede centrale",
        "headquartersPostalCode": "CAP sede centrale",
        "headquartersCity": "Citta sede centrale",
        "headquartersCountry": "Paese sede centrale",
        "industry": "Settore",
        "organization": "Organizzazione",
        "foundingYear": "Anno di fondazione",
        "storeCount": "Numero di negozi",
        "activeCountries": "Attivo nei Paesi",
        "employeeCount": "Numero di dipendenti",
        "revenueIndication": "Indicazione fatturato",
        "billingHint": "Utile per abbonamenti, fatture e amministrazione interna.",
        "billingEmail": "Email fatturazione",
        "invoiceReference": "Riferimento fattura / PO",
        "billingAddress": "Indirizzo di fatturazione",
        "chamberOfCommerceNumber": "Numero registro imprese",
        "vatNumber": "Partita IVA",
        "postalCode": "CAP",
        "city": "Citta",
        "country": "Paese"
      },
      "interest": {
        "completeProfileFirst": "complete profile first",
        "confirmWithdraw": "confirm withdraw",
        "withdrawnSuccess": "withdrawn success",
        "bundleFull": "bundle full",
        "saved": "saved",
        "noBundlePrompt": "no bundle prompt",
        "processing": "processing",
        "withdraw": "withdraw",
        "show": "show"
      },
      "brokerProperty": {
        "title": "title",
        "commencementRent": "commencement rent",
        "currentRent": "current rent",
        "askingPrice": "Prezzo richiesto",
        "keyMoney": "key money",
        "commencementDate": "commencement date",
        "expirationDate": "expiration date",
        "indexationDate": "indexation date",
        "terminationDate": "termination date",
        "noticePeriod": "notice period",
        "guarantee": "guarantee",
        "select": "select",
        "securityDeposit": "security deposit",
        "bankGuarantee": "bank guarantee",
        "guaranteeAmount": "guarantee amount",
        "purchasePrice": "purchase price",
        "landlord": "landlord",
        "purchaseYear": "purchase year",
        "cadastralMunicipality": "cadastral municipality",
        "section": "section",
        "number": "number",
        "cadastralSize": "cadastral size"
      },
      "comments": {
        "title": "title",
        "none": "none",
        "placeholder": "placeholder",
        "add": "add"
      },
      "huur": {
        "title": "title",
        "rent": "rent",
        "commencementDate": "commencement date",
        "expirationDate": "expiration date",
        "indexationDate": "indexation date",
        "terminationDate": "termination date",
        "noticePeriod": "notice period",
        "guaranteeType": "guarantee type",
        "selecteer": "selecteer",
        "securityDeposit": "security deposit",
        "bankGuarantee": "bank guarantee",
        "guaranteeAmount": "guarantee amount"
      },
      "contact": {
        "title": "title",
        "landlord": "landlord",
        "staff": "staff",
        "broker": "broker",
        "name": "name",
        "phone": "phone",
        "email": "email",
        "position": "position",
        "remove": "remove",
        "add": "add"
      },
      "brokerComments": {
        "title": "title",
        "noComments": "no comments",
        "placeholder": "placeholder",
        "add": "add"
      },
      "brokerPhotos": {
        "title": "title",
        "add": "add",
        "remove": "remove",
        "photo": "photo",
        "tooLarge": "too large"
      },
      "brokerDocs": {
        "title": "title",
        "add": "add",
        "delete": "delete",
        "tooLarge2": "too large2"
      },
      "account": {
        "title": "title",
        "name": "name",
        "email": "email",
        "phone": "phone",
        "address": "address",
        "website": "website",
        "linkedin": "linkedin",
        "logo": "logo",
        "chooseFile": "choose file",
        "selectedFile": "selected file",
        "uploadLogo": "upload logo",
        "save": "save",
        "saved": "saved",
        "saveSuccess": "save success",
        "saveFailed": "save failed",
        "logoUploaded": "logo uploaded",
        "logoTooLarge": "logo too large",
        "noFileChosen": "no file chosen",
        "loading": "loading",
        "invalidEmail": "invalid email",
        "invalidPhone": "invalid phone",
        "fetchError": "fetch error",
        "saveError": "save error",
        "logoUploadError": "logo upload error"
      },
      "myInterests": {
        "title": "title",
        "backToDashboard": "back to dashboard",
        "loading": "loading",
        "noResults": "no results",
        "ownInterests": "own interests",
        "groupInterests": "group interests",
        "country": "country",
        "city": "city",
        "address": "address",
        "currentRetailer": "current retailer",
        "date": "date",
        "shownBy": "shown by",
        "link": "link",
        "action": "action",
        "remove": "remove",
        "removeSuccess": "remove success",
        "removeError": "remove error"
      },
      "broker": {
        "listingsTitle": "Le mie offerte in affitto"
      },
      "subscriptionPage": {
        "loading": "loading",
        "backToDashboard": "back to dashboard",
        "title": "title",
        "userSection": {
          "title": "title",
          "name": "name",
          "email": "email",
          "company": "company",
          "kvk": "kvk"
        },
        "subscription": {
          "trialUntil": "trial until",
          "unknown": "unknown",
          "base": "base",
          "perMonth": "per month",
          "includes3": "includes3",
          "extra": "extra",
          "paidStart": "paid start",
          "notStarted": "not started",
          "totalProperties": "total properties",
          "forRent": "for rent",
          "totalMonthly": "total monthly",
          "renewsOn": "renews on",
          "note": "note",
          "trialEnded": "trial ended",
          "forRentBackend": "for rent backend"
        }
      },
      "owner": {
        "listingsPage": {
          "title": "title",
          "column": {
            "country": "country",
            "city": "city",
            "address": "address",
            "name": "name",
            "website": "website",
            "owner": "owner",
            "currentRetailer": "current retailer",
            "opdrachtgever": "opdrachtgever",
            "broker": "broker"
          }
        },
        "financieringBlock": {
          "title": "Dati finanziari",
          "koopsom": "Prezzo di acquisto",
          "aankoopdatum": "Data di acquisto",
          "hypotheek": "Importo del mutuo",
          "rentepercentage": "Tasso di interesse",
          "bank": "Banca",
          "looptijd": "Durata (anni)",
          "jaar": "anno",
          "actueleMarktwaarde": "Valore di mercato attuale",
          "taxatiedatum": "Data di valutazione",
          "actueleHypotheekschuld": "Debito ipotecario attuale",
          "actueleHypotheekrente": "Tasso ipotecario attuale (%)",
          "rentevastTot": "Tasso fisso fino al",
          "aflossingspercentage": "Percentuale di rimborso (%)",
          "jaarlijkseRentelasten": "Interessi annui",
          "jaarlijkseAflossing": "Rimborso annuo",
          "jaarlijkseOverigeLasten": "Altri costi annui",
          "netOperatingIncome": "Reddito operativo netto",
          "markthuurPerM2": "Canone di mercato per m²",
          "servicekostenPerJaar": "Spese di servizio annue",
          "vraagprijs": "Prezzo richiesto"
        },
        "ownerFields": {
          "title": "Dati proprietario",
          "parentCompany": "Società madre proprietaria",
          "owner": "Proprietario",
          "contactPerson": "Persona di contatto",
          "email": "Indirizzo e-mail",
          "phone": "Numero di telefono"
        },
        "huurgegevensBlock": {
          "title": "Dati locativi",
          "formeleHuurder": "Conduttore formale",
          "huurprijs": "Canone",
          "ingangsdatum": "Data di inizio",
          "expiratiedatum": "Data di scadenza",
          "resterendeLooptijdMaanden": "Durata residua del contratto",
          "huurtermijn": "Durata del contratto",
          "verlengingsjaren": "Anni di rinnovo",
          "huurvrijePeriodeMaanden": "Periodo gratuito",
          "indexatiedatum": "Data di indicizzazione",
          "opzegdatum": "Data di disdetta",
          "opzegtermijn": "Periodo di preavviso",
          "garantiesoort": "Tipo di garanzia",
          "kiesOptie": "Scegli un’opzione",
          "waarborgsom": "Deposito cauzionale",
          "bankgarantie": "Garanzia bancaria",
          "concerngarantie": "Garanzia societaria",
          "garantiebedrag": "Importo della garanzia",
          "noGuarantee": "Nessuna garanzia"
        },
        "contactgegevensBlock": {
          "title": "Contatti",
          "company": "Azienda",
          "name": "Nome",
          "phone": "Telefono",
          "email": "E-mail",
          "function": "Ruolo",
          "remove": "Rimuovi contatto",
          "add": "Aggiungi contatto"
        },
        "photoUpload": {
          "title": "title",
          "add": "add",
          "remove": "remove",
          "tooLarge": "too large"
        },
        "opmerkingen": {
          "title": "Note",
          "none": "Nessuna nota aggiunta.",
          "unknownAuthor": "Autore sconosciuto",
          "add": "Aggiungi nota",
          "placeholder": "Scrivi qui la tua nota..."
        }
      },
      "mapSettings": {
        "backToDashboard": "Torna alla dashboard",
        "title": "Impostazioni mappa",
        "subtitle": "Regola i colori degli edifici e dei nomi marker",
        "fetchWarn": "Impossibile caricare le impostazioni",
        "noUser": "Nessun utente trovato.",
        "invalidHex": "Colore hex non valido. Usa ad es. #0077cc.",
        "saved": "Impostazioni salvate.",
        "saveFailed": "Salvataggio non riuscito.",
        "retailColorLabel": "Colore edifici retail",
        "retailColorPicker": "Scegli colore edifici retail",
        "otherColorLabel": "Colore altri edifici",
        "otherColorPicker": "Scegli colore altri edifici",
        "opacityLabel": "Opacit? altri edifici: {{value}}",
        "opacityAria": "Slider opacita",
        "markerNameColorLabel": "Colore nome marker",
        "markerNameColorPicker": "Scegli colore nome marker",
        "markerNameHoverColorLabel": "Colore hover marker",
        "markerNameHoverColorPicker": "Scegli colore hover marker",
        "previewRetail": "Highlight retail",
        "previewOther": "Altri edifici",
        "previewMarkerNormal": "Marker normale",
        "previewMarkerHover": "Marker hover",
        "saving": "Salvataggio...",
        "save": "Salva impostazioni",
        "reset": "Ripristina predefiniti",
        "cancel": "Annulla",
        "hexHelp": "Usa hex, ad es. #0077cc",
        "activeOutlineLabel": "Bordo immobili attivi",
        "otherOutlineLabel": "Bordo altri immobili",
        "hoverColorLabel": "Colore hover"
      },
      "myStores": {
        "title": "title",
        "ownStores": "own stores",
        "groupStores": "group stores",
        "noResults": "no results",
        "loading": "loading",
        "backToDashboard": "back to dashboard",
        "nr": "nr",
        "city": "city",
        "address": "address",
        "name": "name",
        "source": "source",
        "link": "link",
        "country": "country",
        "allCountries": "all countries",
        "allCities": "all cities"
      },
      "retailerProperty": {
        "loading": "loading",
        "notFound": "not found",
        "back": "back",
        "address": "address",
        "country": "country",
        "source": "source",
        "publicDataDivider": "public data divider",
        "privateDataDivider": "Dati privati",
        "commentsDivider": "comments divider",
        "contactsDivider": "Contatti",
        "documentsDivider": "documents divider",
        "photosDivider": "Foto",
        "notesDivider": "Note"
      },
      "extraFieldsBlock": {
        "title": "Campi aggiuntivi",
        "showInPopup": "show in popup",
        "addField": "Aggiungi campo",
        "addHeader": "Aggiungi sezione"
      },
      "extraSections": {
        "titleLabel": "title label",
        "fieldLabel": "field label",
        "fieldType": "field type",
        "value": "value",
        "addField": "Aggiungi campo",
        "addSection": "Aggiungi sezione",
        "newTab": "Nuova scheda"
      },
      "rentalData": {
        "addField": "add field"
      },
      "financialData": {
        "addField": "add field"
      },
      "addMarker": {
        "retailerName": "retailer name",
        "unknownAddress": "unknown address",
        "unknownCity": "unknown city"
      },
      "owners": {
        "add": {
          "success": "success",
          "missingParameters": "missing parameters",
          "invalidId": "invalid id",
          "noAccess": "no access",
          "alreadyInMine": "already in mine",
          "alreadyInOrgPortfolio": "already in org portfolio",
          "extraRequiresPayment": "extra requires payment",
          "trialLimitReached": "trial limit reached",
          "trialExpired": "trial expired",
          "error": "error"
        }
      },
      "propertyDrawer": {
        "title": "Property details",
        "loadFailed": "Could not load property details.",
        "openInNewTab": "Open in new tab",
        "address": "Address",
        "status": "Status",
        "forRent": "For rent",
        "rented": "Rented",
        "assetManager": "Asset manager",
        "openInMaps": "Open in Maps"
      },
      "countries": {
        "nl": "Netherlands",
        "be": "Belgium",
        "de": "Germany",
        "fr": "France",
        "gb": "United Kingdom",
        "es": "Spain",
        "it": "Italy"
      },
      "settingsPanel.myProperties.status": "Stato",
      "subscriptionRequired": {
        "title": "Abbonamento richiesto",
        "body": "Per pubblicare un immobile in affitto su Retailmaps e necessario un abbonamento attivo.",
        "details": "Con un abbonamento puoi pubblicare immobili in affitto e renderli visibili a tutti gli utenti della piattaforma o a gruppi selezionati.",
        "activate": "Attiva abbonamento"
      },
      "security": {
        "password": "Password",
        "errors": {
          "statusFailed": "Impossibile recuperare lo stato di sicurezza.",
          "setupFailed": "Impossibile avviare la configurazione 2FA.",
          "enableFailed": "Impossibile attivare la 2FA.",
          "disableFailed": "Impossibile disattivare la 2FA."
        },
        "notices": {
          "enabled": "La 2FA e stata attivata per il tuo account.",
          "disabled": "La 2FA e stata disattivata per il tuo account."
        },
        "twoFactor": {
          "title": "Autenticazione a due fattori",
          "subtitle": "Proteggi il tuo account con un codice a 6 cifre da un app di autenticazione.",
          "setup": "Configura 2FA",
          "scanQr": "Scansiona il codice QR con la tua app di autenticazione. Se non funziona, usa manualmente il codice di configurazione.",
          "openAuthenticator": "Apri nell app di autenticazione",
          "sixDigitCode": "Codice a 6 cifre",
          "enable": "Attiva 2FA",
          "disableWarning": "Disattiva la 2FA solo se sei sicuro che questo account sia protetto in altro modo.",
          "code": "Codice 2FA",
          "disable": "Disattiva 2FA"
        }
      },
      "auth": {
        "twoFactor": {
          "prompt": "Inserisci il codice a 6 cifre della tua app di autenticazione.",
          "backToPassword": "Torna alla password"
        }
      },
      "paidInterest": {
        "title": "Interesse extra",
        "bodyPrefix": "Questo interesse costa",
        "price": "5 € IVA esclusa al mese",
        "bodySuffix": "e sara aggiunto al tuo abbonamento. Puoi ritirare questo interesse in qualsiasi momento.",
        "confirm": "Accetta e continua",
        "paymentStartFailed": "Impossibile avviare il pagamento."
      },
      "forRentTab": {
        "selectActingRole": "Seleziona per conto di chi pubblichi.",
        "created": "L immobile e ora pubblicato in affitto.",
        "updated": "Inserzione aggiornata.",
        "updateFailed": "Aggiornamento non riuscito.",
        "confirmDelete": "Sei sicuro di voler rimuovere questa inserzione di affitto?",
        "deleteFailed": "Eliminazione non riuscita.",
        "listProperty": "Pubblica immobile in affitto",
        "missingData": "Dati mancanti per pubblicare questo immobile in affitto.",
        "activateFailed": "Attivazione dell inserzione non riuscita.",
        "activating": "Attivazione inserzione..."
      },
      "verifyEmail": {
        "loadingMessage": "Stiamo confermando il tuo indirizzo email...",
        "invalidLink": "Questo link di verifica non e valido.",
        "successMessage": "Il tuo indirizzo email e stato confermato. Accedi per aprire Retailmaps.",
        "failedMessage": "Verifica non riuscita.",
        "expiredOrInvalid": "Questo link di verifica e scaduto o non e valido.",
        "successTitle": "Indirizzo email confermato",
        "failedTitle": "Verifica non riuscita",
        "checkingTitle": "Controllo in corso",
        "backToLogin": "Torna al login",
        "openLogin": "Accedi e apri Retailmaps"
      },
      "help": {
        "tab": "Come funziona",
        "title": "Come funziona",
        "subtitle": "Brevi spiegazioni per le azioni piu usate in Retailmaps.",
        "howItWorks": "Come funziona",
        "goodToKnow": "Da sapere",
        "empty": "Non ci sono ancora argomenti per questo ruolo.",
        "actions": {
          "openListings": "Apri affitti",
          "openInterests": "Apri interessi",
          "openProperties": "Apri immobili",
          "openAlerts": "Apri alert",
          "openRequests": "Apri richieste",
          "openAnalysis": "Apri analisi"
        },
        "topics": {
          "ownerForRent": {
            "title": "Mettere un immobile in affitto",
            "summary": "Pubblica un immobile come offerta di affitto e aggiungi le informazioni corrette.",
            "step1": "Apri la scheda Immobili.",
            "step2": "Cerca l immobile che vuoi proporre.",
            "step3": "Clicca su Metti in affitto.",
            "step4": "Apri In affitto e completa prezzo richiesto, key money e data di disponibilita.",
            "step5": "Controlla i dati gia copiati, come affitto attuale e data di scadenza.",
            "step6": "Aggiungi le informazioni di progetto. Puoi caricare una brochure o generare automaticamente le informazioni di progetto.",
            "note1": "Come proprietario non devi scegliere la visibilita. L immobile viene mostrato automaticamente come offerta di affitto.",
            "note2": "Le informazioni di progetto automatiche usano i dati inseriti, foto, planimetrie e un immagine della mappa."
          },
          "retailerStore": {
            "title": "Collegare un negozio ai miei negozi",
            "summary": "Aggiungi una posizione esistente alla panoramica dei tuoi negozi.",
            "step1": "Apri la scheda Negozi.",
            "step2": "Cerca il negozio per paese, citta o indirizzo.",
            "step3": "Seleziona te stesso o un collega come retail manager.",
            "step4": "Il negozio appare poi in I miei negozi.",
            "note1": "Puoi mettere un negozio in affitto solo dopo averlo collegato a I miei negozi.",
            "note2": "La posizione non e ancora sulla mappa? Aggiungi prima un nuovo marker."
          },
          "newMarker": {
            "title": "Aggiungere un nuovo marker",
            "summary": "Aggiungi una nuova posizione sulla mappa.",
            "step1": "Apri la mappa.",
            "step2": "Desktop: fai doppio clic su un punto vuoto della mappa.",
            "step3": "Mobile: tocca due volte un punto vuoto della mappa.",
            "step4": "Compila poi i dati della posizione.",
            "note1": "Controlla prima se la posizione esiste gia sulla mappa. In quel caso usa il marker esistente.",
            "note2": "Se posizioni male un nuovo marker, puoi eliminarlo tu stesso se lo hai aggiunto tu."
          },
          "moveDeleteMarker": {
            "title": "Spostare o eliminare un marker",
            "summary": "Correggi la posizione di un marker o rimuovi un marker che hai aggiunto tu.",
            "step1": "Desktop: clicca con il tasto destro sul marker.",
            "step2": "Mobile: tieni premuto il marker.",
            "step3": "Scegli Sposta marker e clicca o tocca la nuova posizione.",
            "step4": "Scegli Elimina marker per rimuovere un marker che hai aggiunto tu.",
            "note1": "I marker esistenti e quelli aggiunti da altri utenti possono essere eliminati solo da un admin.",
            "note2": "Dopo lo spostamento, riapri il marker se vuoi controllare o modificare i dati."
          },
          "mobile": {
            "title": "Usare Retailmaps su mobile",
            "summary": "Aggiungi Retailmaps alla schermata iniziale per un accesso rapido.",
            "step1": "Apri www.retailmaps.com sul telefono.",
            "step2": "iPhone o iPad: usa Safari, tocca Condividi e scegli Aggiungi alla schermata iniziale.",
            "step3": "Chrome su Android: tocca i tre puntini e scegli Installa app o Aggiungi alla schermata iniziale.",
            "step4": "Samsung Internet: apri il menu e scegli Aggiungi pagina a o Aggiungi alla schermata iniziale.",
            "step5": "Chiama il collegamento Retailmaps e tocca Aggiungi.",
            "step6": "Apri poi Retailmaps dall icona sulla schermata iniziale.",
            "note1": "Su iPhone questo funziona normalmente con Safari. Chrome su iPhone di solito non lo permette direttamente.",
            "note2": "Accedi con lo stesso account che usi sul desktop."
          },
          "security": {
            "title": "Attivare o disattivare l autenticazione a due fattori",
            "summary": "Proteggi il tuo account con un codice extra da un app di autenticazione.",
            "step1": "Apri Impostazioni.",
            "step2": "Vai a Sicurezza o Autenticazione a due fattori.",
            "step3": "Clicca su Attiva 2FA.",
            "step4": "Apri un app di autenticazione, come Google Authenticator, Microsoft Authenticator o 1Password.",
            "step5": "Scansiona il QR code con l app di autenticazione.",
            "step6": "Inserisci il codice a 6 cifre dell app e conferma.",
            "step7": "Da ora accedi con password piu codice a 6 cifre.",
            "step8": "Vuoi disattivare 2FA? Torna in Impostazioni e clicca su Disattiva 2FA.",
            "note1": "Conserva bene l accesso alla tua app di autenticazione. Senza l app puo diventare difficile accedere.",
            "note2": "Il codice cambia circa ogni 30 secondi. Usa sempre il codice piu recente."
          },
          "popupMedia": {
            "title": "Foto, documenti e planimetrie",
            "summary": "Aggiungi file a una posizione.",
            "step1": "Apri la popup della posizione.",
            "step2": "Vai a Dati privati.",
            "step3": "Scegli Foto, Documenti o Planimetrie.",
            "step4": "Aggiungi un file o scatta direttamente una foto da mobile.",
            "note1": "Le foto vengono mostrate come anteprime.",
            "note2": "Le planimetrie funzionano meglio come immagini, ad esempio jpg o png."
          },
          "alerts": {
            "title": "Impostare alert",
            "summary": "Imposta un promemoria per date importanti.",
            "step1": "Apri i dettagli dell immobile o la popup.",
            "step2": "Inserisci una data, ad esempio data di scadenza, indicizzazione o disdetta.",
            "step3": "Spunta Alert.",
            "step4": "Inserisci quanti giorni prima vuoi ricevere l alert.",
            "step5": "Visualizza gli alert attivi nella scheda Alert.",
            "note1": "Gli alert attivi sono visibili nella scheda Alert.",
            "note2": "Alla data del promemoria ricevi automaticamente una e-mail."
          },
          "ownerRequests": {
            "title": "Vedere le richieste",
            "summary": "Vedi chi e interessato alla tua offerta di affitto o al tuo immobile.",
            "step1": "Apri la scheda Richieste.",
            "step2": "Controlla a quale immobile appartiene la richiesta.",
            "step3": "Verifica quali dati del richiedente sono disponibili.",
            "step4": "Apri la richiesta per maggiori dettagli.",
            "note1": "Le richieste nascono quando i retailer mostrano interesse per una posizione retail, anche se non e attivamente in affitto."
          },
          "retailerRequests": {
            "title": "Vedere le richieste",
            "summary": "Vedi quali retailer sono interessati alle tue posizioni.",
            "step1": "Apri la scheda Richieste.",
            "step2": "Vedi quale retailer ha mostrato interesse.",
            "step3": "Controlla a quale posizione appartiene la richiesta.",
            "step4": "Clicca sull indirizzo per aprire la posizione sulla mappa.",
            "note1": "Le richieste sono interessi in entrata per posizioni collegate alla tua organizzazione."
          },
          "interest": {
            "title": "Mostrare interesse",
            "summary": "Rendi visibile che sei interessato a una posizione specifica.",
            "step1": "Apri sulla mappa la posizione che ti interessa.",
            "step2": "Clicca nella popup su Mostra interesse.",
            "step3": "Controlla la conferma e completa eventuali passaggi di accesso.",
            "step4": "La posizione appare poi nella scheda Interessi.",
            "step5": "L interesse resta attivo finche non lo ritiri tu.",
            "note1": "Il tuo interesse viene salvato sull immobile specifico, non solo nella tua panoramica.",
            "note2": "L attuale conduttore, il proprietario e i broker rilevanti possono vedere l interesse se hanno accesso."
          },
          "analysis": {
            "title": "Usare analisi",
            "summary": "Confronta posizioni e consulta calcoli importanti.",
            "step1": "Seleziona un immobile o negozio nella tua panoramica.",
            "step2": "Scegli l azione Analisi.",
            "step3": "Aggiungi piu posizioni se necessario.",
            "step4": "Apri Analisi per vedere tra l altro affitto per m2, WALT, durata residua e indicatori."
          }
        }
      },
      "legal": {
        "disclaimer": "Documento bozza per Retailmaps. Completa i dati aziendali prima della pubblicazione definitiva.",
        "lastUpdated": "Ultimo aggiornamento: 28 maggio 2026",
        "privacy": {
          "title": "Informativa sulla privacy",
          "intro": "Retailmaps processes business account, company, property, listing, interest and usage data to provide the platform.",
          "roles": "Data can be visible to relevant users depending on their role, access rights, subscriptions and actions within the platform.",
          "providers": "Retailmaps may use external providers for hosting, maps, payments, email, analytics and AI functionality.",
          "rights": "Users can request access, correction or deletion of personal data where applicable.",
          "contact": "For privacy questions, contact Retailmaps through the published contact details."
        },
        "terms": {
          "title": "Termini e condizioni",
          "intro": "Retailmaps is a professional platform for retail real estate information, listings, interests, requests and related collaboration.",
          "account": "Users are responsible for correct account details, secure login credentials and lawful use of the platform.",
          "data": "Users remain responsible for the accuracy and rights to information, photos, documents and contact details they upload or publish.",
          "uploadLicense": "Fornendo planimetrie, file IMDF, GeoJSON, CAD, SVG o altri file relativi a una posizione, l'utente conferma di essere autorizzato a farlo e concede a Retailmaps una licenza non esclusiva e priva di royalty per archiviare, ospitare, copiare, analizzare, convertire, georeferenziare, adattare e combinare tali file, creare planimetrie e livelli cartografici derivati e mostrarli nel servizio Retailmaps. Retailmaps può concedere ai propri fornitori tecnici i diritti strettamente necessari. L'utente deve comunicare, al momento della fornitura, eventuali attribuzioni obbligatorie, licenze di terzi o altre restrizioni.",
          "payments": "Paid features, subscriptions, bundles and transaction fees can apply where clearly shown in the dashboard or order flow.",
          "liability": "Retailmaps is an information and networking platform and does not guarantee that a property is available or that a transaction will be completed."
        }
      },
      "popup": {
        "autosaveActive": "Salvataggio automatico attivo"
      },
      "alerts": {
        "daysBefore": "giorni prima",
        "enterDaysBefore": "Inserisci i giorni prima",
        "title": "Avvisi",
        "loading": "Caricamento avvisi...",
        "empty": "Al momento non ci sono avvisi che richiedono attenzione.",
        "toggleLabel": "Avviso",
        "dismiss": "Gestisci",
        "columns": {
          "property": "Immobile",
          "field": "Campo",
          "date": "Data",
          "alertDate": "Data avviso",
          "daysBefore": "Giorni prima",
          "status": "Stato",
          "actions": "Azioni"
        },
        "status": {
          "expired": "Scaduto",
          "actionNeeded": "Azione necessaria",
          "upcoming": "In arrivo"
        },
        "fields": {
          "expiryDate": "Data di scadenza",
          "indexationDate": "Data di indicizzazione",
          "terminationDate": "Data di disdetta",
          "availableFrom": "Disponibile dal",
          "startDate": "Data di inizio"
        }
      },
      "analysis": {
        "title": "Analisi",
        "empty": "Aggiungi immobili all analisi per visualizzare i dati.",
        "summary": {
          "totalRent": "Canone annuo totale",
          "totalAskingRent": "Prezzo richiesto totale",
          "weightedArea": "m2 ponderati",
          "avgAskingRentPerM2": "Prezzo richiesto medio/m2/anno",
          "avgRentPerM2": "Canone medio/m2/anno",
          "wault": "WAULT"
        },
        "values": {
          "years": "{{value}} anni"
        },
        "metrics": {
          "waltYears": "WALT: {{value}} anni",
          "expiry12": "Scadenza 12m: {{value}}",
          "expiry24": "Scadenza 24m: {{value}}",
          "expiry36": "Scadenza 36m: {{value}}"
        },
        "actions": {
          "clear": "Svuota analisi",
          "collapseSurfaces": "Comprimi superfici",
          "expandSurfaces": "Espandi superfici",
          "remove": "Rimuovi"
        },
        "table": {
          "property": "Immobile",
          "tenant": "Conduttore",
          "annualRent": "Canone annuo",
          "askingRent": "Prezzo richiesto",
          "weightedM2": "m2 ponderati",
          "rentPerM2": "Canone/m2",
          "askingRentPerM2": "Prezzo richiesto/m2",
          "expiry": "Scadenza",
          "remainingTerm": "Durata residua",
          "remainingMonths": "Mesi residui",
          "guaranteeMonths": "Mesi garanzia",
          "surfaces": "Superfici",
          "front": "Fronte",
          "rentCoverage": "Copertura affitto",
          "interestCoverage": "Copertura interessi",
          "weightedArea": "m2 ponderati",
          "ltv": "LTV"
        },
        "surfaces": {
          "title": "Superfici",
          "helper": "Predefinito: retail 100%, secondaria 50%. Regola qui per piano.",
          "weightedTotal": "Totale ponderato",
          "grossM2": "{{value}} m2 lordi",
          "weightedM2Value": "= {{value}} m2",
          "empty": "Nessuna superficie trovata. Compila superfici retail e secondarie nei dati pubblici.",
          "button": "Superfici"
        },
        "surfaceFields": {
          "beganeGrondWinkel": "Piano terra retail",
          "beganeGrondSecundair": "Piano terra secondario",
          "kelderWinkel": "Interrato retail",
          "kelderSecundair": "Interrato secondario",
          "eersteVerdiepingWinkel": "1 piano retail",
          "eersteVerdiepingSecundair": "1 piano secondario",
          "tweedeVerdiepingWinkel": "2 piano retail",
          "tweedeVerdiepingSecundair": "2 piano secondario",
          "derdeVerdiepingWinkel": "3 piano retail",
          "derdeVerdiepingSecundair": "3 piano secondario",
          "entresolWinkel": "Mezzanino retail",
          "entresolSecundair": "Mezzanino secondario",
          "soussolWinkel": "Seminterrato retail",
          "soussolSecundair": "Seminterrato secondario",
          "front": "Fronte",
          "winkel": "Negozio",
          "secundair": "Secondaria",
          "begane_grond_winkel": "Piano terra negozio",
          "begane_grond_secundair": "Piano terra secondaria",
          "kelder_winkel": "Seminterrato negozio",
          "kelder_secundair": "Seminterrato secondaria",
          "shop": "Negozio",
          "secondary": "Secondaria"
        },
        "chips": {
          "wault": "WAULT: {{value}} anni",
          "expiry12": "Scadenza 12m: {{value}}",
          "expiry24": "Scadenza 24m: {{value}}",
          "expiry36": "Scadenza 36m: {{value}}"
        }
      },
      "brokerRequests": {
        "title": "Richieste broker",
        "overview": "Panoramica",
        "empty": "Nessuna richiesta",
        "interestCount": "{{count}} interesse/i",
        "buyContact": "Acquista (€9)",
        "profile": {
          "industry": "Settore",
          "stores": "Negozi",
          "activeIn": "Attivo in",
          "founded": "Anno di fondazione",
          "revenue": "Fatturato"
        }
      },
      "retailerProperties": {
        "sameBrandInterestBlocked": "Non ? consentito mostrare interesse per un immobile del proprio marchio o gruppo."
      },
      "landing": {
        "language": {
          "select": "Scegli lingua"
        },
        "nav": {
          "aria": "Navigazione principale",
          "forWho": "Per chi",
          "howItWorks": "Come funziona",
          "product": "Prodotto",
          "price": "Prezzo"
        },
        "actions": {
          "login": "Accedi",
          "register": "Registrati",
          "startFree": "Registrati gratis",
          "start60": "60 giorni gratis",
          "startTrial": "Avvia prova gratuita",
          "viewProduct": "Guarda il prodotto"
        },
        "auth": {
          "tag": "Account",
          "close": "Chiudi modulo",
          "copy": {
            "loginTitle": "Bentornato.",
            "loginText": "Accedi con la tua e-mail aziendale per aprire mappa, immobili e dati.",
            "registerTitle": "Avvia la prova gratuita.",
            "registerText": "Crea un account aziendale e prova la mappa gratis per 60 giorni. Dopo la registrazione ti invieremo un’e-mail per verificare l’account.",
            "forgotTitle": "Recupera accesso.",
            "forgotText": "Inserisci la tua e-mail. Se esiste un account, invieremo un’e-mail di recupero."
          },
          "twoFactor": {
            "help": "Inserisci il codice di 6 cifre della tua app di autenticazione.",
            "label": "Codice 2FA",
            "back": "Torna alla password"
          },
          "forgot": {
            "link": "Password dimenticata?",
            "help": "Inserisci la tua e-mail. Se l’account esiste, invieremo un link per reimpostare la password.",
            "submit": "Invia e-mail di recupero",
            "back": "Torna al login",
            "openLocal": "Apri link locale"
          },
          "fields": {
            "email": "E-mail",
            "businessEmail": "E-mail aziendale",
            "password": "Password",
            "role": "Ruolo",
            "chooseRole": "Scegli il ruolo",
            "firstName": "Nome",
            "lastName": "Cognome",
            "companyName": "Nome azienda"
          },
          "registerNote": "60 giorni gratis. Nessuna carta di credito richiesta. Riceverai prima un’e-mail di verifica per attivare l’account.",
          "legalAccept": "Accetto la <privacy>privacy policy</privacy> e i <terms>termini e condizioni</terms>.",
          "notices": {
            "emailVerified": "La tua e-mail è stata confermata. Accedi per aprire Retailmaps.",
            "twoFactorRequired": "Inserisci il codice 2FA per continuare.",
            "registerSuccess": "Registrazione completata. Abbiamo inviato un’e-mail di conferma al tuo indirizzo.",
            "forgotSent": "Se questa e-mail è registrata, invieremo un messaggio di recupero."
          },
          "errors": {
            "loginFailed": "Accesso non riuscito. Controlla i dati inseriti.",
            "twoFactorFailed": "Accesso non riuscito. Controlla il codice 2FA.",
            "businessEmail": "Usa un’e-mail aziendale. Indirizzi gratuiti come Gmail, Hotmail, Outlook o iCloud non sono consentiti.",
            "roleRequired": "Scegli prima il tuo ruolo: retailer, proprietario o broker.",
            "companyRequired": "Inserisci il nome della tua azienda.",
            "legalRequired": "Accetta privacy policy e condizioni per creare l’account.",
            "registerFailed": "Registrazione non riuscita. Riprova.",
            "forgotFailed": "Recupero password non riuscito."
          }
        },
        "roles": {
          "options": {
            "retailer": "Retailer",
            "owner": "Proprietario",
            "broker": "Broker"
          },
          "tag": "Per chi",
          "title": "Tre ruoli, tre modi per agire più velocemente.",
          "intro": "Espansione, gestione del portafoglio e consulenza — tutto in un unico ambiente cartografico.",
          "retailer": {
            "kicker": "Per retailer",
            "title": "Trova la location giusta prima che arrivi sul mercato.",
            "text": "Segui gli immobili, mostra interesse in modo discreto e non perdere più opportunità.",
            "points": {
              "1": {
                "title": "Mostrare interesse in modo proattivo",
                "text": "Registra interesse per un immobile specifico, anche quando non è ancora ufficialmente disponibile."
              },
              "2": {
                "title": "Resta anonimo fino al momento giusto",
                "text": "Proprietari, broker e retailer attuali vedono il tuo interesse anonimo e possono contattarti quando è opportuno."
              },
              "3": {
                "title": "Seguire e gestire location",
                "text": "Salva informazioni di progetto, foto e note <underline>per immobile</underline> e condividile con il tuo team. Segui gli immobili e ricevi notifiche quando qualcosa si muove. Così non perdi più dati preziosi."
              }
            }
          },
          "owner": {
            "kicker": "Per proprietari",
            "title": "Più controllo su portafoglio, domanda di mercato e strategia di locazione.",
            "text": "I proprietari gestiscono immobili commerciali da un ambiente centrale. Metti un immobile in locazione con un clic, crea automaticamente informazioni di progetto quando serve, analizza il portafoglio e assegna le location ai membri del team.",
            "points": {
              "1": {
                "title": "Gestisci il portafoglio",
                "text": "Mantieni dati di immobili, contratti e contatti, documenti e note ordinati <underline>per immobile</underline>, visibili a tutto il team. Aggiungi campi e sezioni e costruisci un database immobiliare completamente adattabile al tuo modo di lavorare."
              },
              "2": {
                "title": "Ricevi interessi dai retailer",
                "text": "Vedi quali retailer interessati si fanno avanti, inclusi settore e tipo di interesse. Anche quando l’immobile è ancora affittato."
              },
              "3": {
                "title": "Imposta alert",
                "text": "Non dimenticare più un’indicizzazione, una scadenza di disdetta o un altro momento importante."
              }
            }
          },
          "broker": {
            "kicker": "Per broker",
            "title": "Consiglia meglio con domanda di mercato visibile.",
            "text": "Combina dati di localizzazione, stato locativo, etichette retailer e interesse da un unico spazio di lavoro. La consulenza dipende meno da liste separate e più da dati aggiornati.",
            "points": {
              "1": {
                "title": "Mappa interattiva",
                "text": "Cerca retailer, aggiorna le etichette alla situazione attuale e contribuisci alla retailmap open source più completa al mondo."
              },
              "2": {
                "title": "Trova lead e consiglia meglio",
                "text": "Usa i lead per lavorare in modo più mirato e consigliare i proprietari con migliori informazioni di mercato."
              },
              "3": {
                "title": "Tutti i dati immobiliari in un unico posto",
                "text": "Consulta, analizza e condividi dati immobiliari con i membri del team, sia da mobile sia da desktop."
              },
              "4": {
                "title": "Metti immobili in locazione facilmente",
                "text": "Pubblica immobili in locazione rapidamente e regola la visibilità quando la situazione lo richiede."
              }
            }
          }
        },
        "hero": {
          "eyebrow": "Retail Real Estate Intelligence",
          "title": "Retailmaps è LA mappa interattiva per immobili commerciali.",
          "line1": "Per e da professionisti del retail.",
          "line2": "Trova location interessanti, mostra interesse in modo anonimo, segui gli sviluppi e gestisci le informazioni degli immobili da un unico ambiente — su laptop e mobile.",
          "line3": "Per retailer, proprietari e broker che vogliono vedere più rapidamente dove domanda, offerta e posizione si incontrano.",
          "proofs": {
            "trial": "60 giorni gratis. Senza impegno.",
            "price": "Poi 19 € al mese",
            "cancel": "Non devi disdire nulla",
            "noCard": "Nessuna carta di credito richiesta",
            "noCharges": "Nessun addebito automatico",
            "afterTrial": "Dopo 60 giorni, decidi tu se continuare con un piano a pagamento. Se non fai nulla, non paghi nulla.",
            "cta": "Inizia la mia prova gratuita"
          }
        },
        "how": {
          "tag": "Come funziona",
          "title": "Lavora dalla mappa, non da liste separate.",
          "steps": {
            "1": {
              "title": "Ingrandisci l’area commerciale",
              "text": "Visualizza immobili, retailer e disponibilità direttamente a livello strada."
            },
            "2": {
              "title": "Apri un immobile",
              "text": "Tutte le informazioni rilevanti in un unico posto: dati privati, superfici, dati di locazione, immobile e finanza, contatti, foto, note e documenti."
            },
            "3": {
              "title": "Registra interesse o disponibilità",
              "text": "I retailer mostrano interesse in modo discreto. I broker pubblicano immobili e decidono per chi le informazioni sono visibili."
            }
          }
        },
        "product": {
          "tag": "Prodotto",
          "title": "Non solo dati. Uno spazio di lavoro quotidiano.",
          "features": {
            "1": {
              "title": "Mappa interattiva",
              "text": "Lavora visivamente da vie commerciali, immobili e aree invece che solo da tabelle."
            },
            "2": {
              "title": "Mostrare interesse",
              "text": "Rendi visibile la domanda di mercato senza esporre strategie sensibili."
            },
            "3": {
              "title": "Dati privati",
              "text": "Dati di locazione, documenti, foto e note da un unico luogo, protetti all’interno dell’organizzazione. Nessuna esportazione e accesso a due fattori per una protezione ottimale."
            },
            "4": {
              "title": "Contesto Street View",
              "text": "Visualizza e analizza le location direttamente dalla strada, accanto alla mappa, per comprendere meglio la posizione."
            }
          }
        },
        "visual": {
          "tag": "In evidenza",
          "title": "Contesto della location senza cambiare schermata",
          "text": "Street View aiuta a valutare rapidamente facciata, posizione e contesto."
        },
        "price": {
          "tag": "Prezzo",
          "title": "Inizia facilmente, senza un processo lungo.",
          "text": "Prova Retailmaps gratis per 60 giorni. Dopo la prova decidi tu se continuare. Il prezzo resta semplice, anche per piccoli team.",
          "cardTitle": "Retailmaps Professional",
          "amount": "19 €",
          "period": "/ mese",
          "cardText": "Prova Retailmaps gratis per 60 giorni. Nessuna carta di credito richiesta.",
          "items": {
            "1": "Mappa interattiva e lista immobili",
            "2": "Interesse e alert",
            "3": "Dati immobili, documenti e note",
            "4": "Funziona su laptop e mobile"
          }
        },
        "final": {
          "title": "Scopri dove il retail real estate si mette in movimento.",
          "text": "Inizia dalla mappa, segui gli immobili rilevanti e vedi prima dove domanda, offerta e posizione si incontrano."
        },
        "images": {
          "interestStackAria": "Funzione mobile di interesse",
          "interestSavedAlt": "Ritirare interesse su mobile",
          "interestAlt": "Mostrare interesse per un immobile su mobile",
          "interestCaption": "Mostra interesse per il tuo immobile preferito.",
          "ownerAlt": "Vista proprietario con interessi ricevuti",
          "ownerCaption": "Vedi l’interesse ricevuto per immobile e decidi quando richiedere i dati di contatto.",
          "brokerAlt": "Dashboard broker con immobili, retailer e lead",
          "brokerCaption": "Visualizza immobili, retailer e lead facilmente da un’unica panoramica.",
          "rentalAlt": "Informazioni mobile dell’immobile con offerta di locazione",
          "streetViewAlt": "Mappa e Street View affiancate"
        },
        "footer": {
          "copyright": "© 2026 Retailmaps.com",
          "security": "Dati e sicurezza",
          "privacy": "Privacy",
          "terms": "Condizioni",
          "contact": "Contatto"
        }
      },
      "popup.autosaveActive": "Autosave attivo",
      "retailerMap.mobileZoomFeedback": "Zoom {{zoom}} - doppio tap da 19 per aggiungere",
      "retailerMap.installPrompt.title": "Apri Retailmaps più velocemente",
      "retailerMap.installPrompt.subtitle": "Aggiungi Retailmaps alla schermata Home.",
      "retailerMap.installPrompt.install": "Aggiungi al telefono",
      "retailerMap.installPrompt.later": "Più tardi",
      "retailerMap.iosInstall.title": "Aggiungi Retailmaps alla schermata Home",
      "retailerMap.iosInstall.intro": "Su iPhone Safari non può farlo automaticamente. Segui questi passaggi:",
      "retailerMap.iosInstall.step1": "1. Tocca il pulsante di condivisione in basso",
      "retailerMap.iosInstall.step2": "2. Scegli Aggiungi alla schermata Home.",
      "retailerMap.iosInstall.step3": "3. Tocca Aggiungi.",
      "common.understood": "Capito",
      "propertyList.filters.country": "Paese",
      "propertyList.filters.allCountries": "Tutti i paesi",
      "propertyList.interest.changeFailed": "Modifica dellâ€™interesse non riuscita.",
      "propertyList.interest.ownGroup": "Gruppo proprio",
      "propertyList.interest.viaColleague": "Tramite collega",
      "propertyList.interest.withdraw": "Ritira",
      "propertyList.interest.show": "Mostra interesse",
      "propertyList.rental.stop": "Ferma affitto",
      "propertyList.rental.setForRent": "Metti in affitto",
      "dashboardOverlay.retailer.stores": "Negozi",
      "dashboardOverlay.retailer.interests": "Interessi",
      "dashboardOverlay.broker.properties": "Immobili",
      "ownerListings.currentOffer": "Le mie offerte in affitto",
      "broker.listingsTitle": "Le mie offerte in affitto",
      "retailer.listingsTitle": "Le mie offerte in affitto",
      "listings.common.empty": "Al momento non ci sono locali in affitto.",
      "owner.financieringBlock.actueleMarktwaarde": "Valore di mercato attuale",
      "owner.financieringBlock.taxatiedatum": "Data di valutazione",
      "owner.financieringBlock.actueleHypotheekschuld": "Debito ipotecario attuale",
      "owner.financieringBlock.actueleHypotheekrente": "Tasso ipotecario attuale (%)",
      "owner.financieringBlock.rentevastTot": "Tasso fisso fino al",
      "owner.financieringBlock.aflossingspercentage": "Percentuale di rimborso (%)",
      "owner.financieringBlock.jaarlijkseRentelasten": "Interessi annui",
      "owner.financieringBlock.jaarlijkseAflossing": "Rimborso annuo",
      "owner.financieringBlock.jaarlijkseOverigeLasten": "Altri costi annui",
      "owner.financieringBlock.netOperatingIncome": "Reddito operativo netto",
      "owner.financieringBlock.markthuurPerM2": "Canone di mercato per m²",
      "owner.financieringBlock.servicekostenPerJaar": "Spese di servizio annue",
      "propertyDetails.objectInfoDivider": "Informazioni immobile",
      "propertyDetails.addObjectInfo": "Aggiungi informazioni oggetto",
      "listings.common.country": "Paese",
      "listings.common.city": "Città",
      "listings.common.address": "Indirizzo",
      "listings.common.askingPrice": "Prezzo richiesto",
      "listings.common.currentRent": "Canone attuale",
      "listings.common.keyMoney": "Buonuscita",
      "listings.common.expiryDate": "Data di scadenza",
      "listings.common.availableFrom": "Disponibile dal",
      "listings.common.forRentSince": "In affitto dal",
      "listings.common.projectInformation": "Informazioni progetto",
      "listings.common.onBehalfOf": "Per conto di",
      "listings.common.visibility": "Visibilità",
      "listings.common.broker": "Agente",
      "listings.common.actions": "Azioni",
      "listings.common.upload": "Carica",
      "listings.common.uploadDocument": "Carica documento",
      "listings.common.stopForRent": "Ferma",
      "listings.common.brochureFailed": "Generazione o caricamento della brochure non riusciti.",
      "listings.common.projectDocuments": "Documenti del progetto",
      "listings.common.chooseFile": "Scegli file",
      "listings.common.noFileChosen": "Nessun file selezionato",
      "listings.common.selectFileFirst": "Seleziona prima un file.",
      "listings.common.uploadFailed": "Caricamento non riuscito.",
      "listings.common.documentDeleteFailed": "Eliminazione del documento non riuscita.",
      "listings.common.confirmDeleteDocument": "Sei sicuro di voler eliminare \"{{name}}\"?",
      "listings.common.forRent": "In affitto",
      "listings.common.edit": "Modifica",
      "listings.common.save": "Salva",
      "listings.common.cancel": "Annulla",
      "listings.common.documentTypes.document": "Documento",
      "listings.common.documentTypes.floorplan": "Planimetria",
      "listings.common.documentTypes.brochure": "Brochure",
      "listings.common.documentTypes.photo": "Foto",
      "listings.common.visibilityOptions.public": "Tutti",
      "listings.common.visibilityOptions.retailers": "Tutti i retailer",
      "listings.common.visibilityOptions.interested": "Solo interessati",
      "roles.owner": "Proprietario",
      "roles.retailer": "Retailer",
      "roles.broker": "Agente",
      "common.edit": "Modifica",
      "listings.common.noDocuments": "Nessun documento disponibile.",
      "listings.common.fileCountOne": "{{count}} file",
      "listings.common.fileCountOther": "{{count}} file",
      "listings.common.addedOn": "Aggiunto il {{date}}",
      "listings.common.deleteDocumentAria": "Elimina {{name}}",
      "common.close": "Chiudi",
      "common.open": "Apri",
      "common.delete": "Elimina",
      "photos.useAsCover": "Usa come foto di copertina",
      "photos.cover": "Copertina",
      "photos.chooseCover": "Scegli",
      "photos.openPreview": "Apri anteprima",
      "propertyDetails.notesDivider": "Note",
      "retailerProperty.contactsDivider": "Contatti",
      "retailerProperty.notesDivider": "Note",
      "retailerProperty.photosDivider": "Foto",
      "status": {
        "active": "Attivo",
        "canceled": "Annullato",
        "cancelled": "Annullato"
      },
      "account.noLogo": "Nessun logo ancora",
      "listings.common.uploading": "Caricamento...",
      "extraFieldsBlock.addField": "Aggiungi campo",
      "extraFieldsBlock.addHeader": "Aggiungi sezione",
      "extraSections.fieldLabel": "Nome campo",
      "extraSections.fieldType": "Tipo",
      "extraSections.addField": "Aggiungi campo",
      "extraSections.addSection": "Aggiungi sezione",
      "extraSections.newTab": "Nuova scheda",
      "extraSections.tabName": "Nome scheda",
      "extraSections.renameTab": "Rinomina scheda",
      "extraSections.untitledTab": "Nome scheda",
      "extraSections.sectionName": "Nome sezione",
      "rentalData.addField": "Aggiungi campo",
      "financialData.addField": "Aggiungi campo",
      "propertyDetails.detailsDivider": "Dettagli",
      "common.saved": "Salvato",
      "common.saving": "Salvataggio...",
      "common.saveFailed": "Salvataggio non riuscito",
      "common.ready": "Pronto",
      "common.active": "Attivo",
      "common.inactive": "Non attivo",
      "common.canceled": "Annullato",
      "common.loading": "Caricamento...",
      "accountSettings.title": "Impostazioni",
      "accountSettings.tabs.profile": "Profilo",
      "accountSettings.tabs.company": "Azienda",
      "accountSettings.tabs.preferences": "Preferenze",
      "accountSettings.tabs.security": "Sicurezza",
      "accountSettings.tabs.billing": "Fatturazione",
      "accountSettings.descriptions.profile": "Dati di contatto e ruolo del tuo account.",
      "accountSettings.descriptions.company": "Dati aziendali, brand e fatturazione.",
      "accountSettings.descriptions.preferences": "Lingua, valuta, unita e visualizzazione mappa.",
      "accountSettings.descriptions.security": "Accesso e sicurezza dell account.",
      "accountSettings.descriptions.billing": "Abbonamento, utilizzo e acquisti singoli.",
      "accountSettings.personal.title": "Profilo personale",
      "accountSettings.personal.description": "Dati di contatto e ruolo del tuo account. Le modifiche vengono salvate automaticamente.",
      "accountSettings.personal.firstName": "Nome",
      "accountSettings.personal.lastName": "Cognome",
      "accountSettings.personal.role": "Posizione",
      "accountSettings.personal.phone": "Telefono",
      "accountSettings.personal.email": "E-mail",
      "accountSettings.personal.linkedin": "LinkedIn",
      "accountSettings.personal.address": "Indirizzo",
      "accountSettings.company.title": "Profilo aziendale",
      "accountSettings.company.description": "Dati aziendali, informazioni del brand e fatturazione per account agenti e proprietari. Le modifiche vengono salvate automaticamente.",
      "accountSettings.company.brandLogoTitle": "Brand e logo",
      "accountSettings.company.brandLogoDescription": "Usiamo questo logo nelle schede immobili e in altri spazi visibili del brand.",
      "accountSettings.company.readOnlyNotice": "Gruppo aziendale e dominio gestiscono collegamenti, visibilita e profili IA, quindi restano in sola lettura.",
      "accountSettings.company.companyName": "Nome azienda",
      "accountSettings.company.companyGroup": "Gruppo aziendale",
      "accountSettings.company.domain": "Dominio",
      "accountSettings.company.legalName": "Ragione sociale",
      "accountSettings.company.website": "Sito web",
      "accountSettings.company.roleType": "Tipo di ruolo",
      "accountSettings.company.headquartersTitle": "Sede",
      "accountSettings.company.headquartersAddress": "Indirizzo sede",
      "accountSettings.company.postalCode": "CAP",
      "accountSettings.company.city": "Citta",
      "accountSettings.company.country": "Paese",
      "accountSettings.company.billingTitle": "Fatturazione",
      "accountSettings.company.billingDescription": "Usiamo questi dati per abbonamenti, fatture e amministrazione finanziaria.",
      "accountSettings.company.billingEmail": "E-mail fatturazione",
      "accountSettings.company.invoiceReference": "Riferimento fattura / PO",
      "accountSettings.company.chamberOfCommerce": "Numero registro imprese",
      "accountSettings.company.vatNumber": "Partita IVA",
      "accountSettings.company.billingAddress": "Indirizzo fatturazione",
      "accountSettings.company.taxIdType": "Tipo codice fiscale",
      "accountSettings.company.taxIdValue": "Partita IVA / codice fiscale",
      "accountSettings.company.taxIdPlaceholder": "IT12345678901",
      "accountSettings.company.peopleTitle": "Persone",
      "accountSettings.company.peopleDescription": "Account collegati alla stessa organizzazione. Gli stati sono basati su abbonamento e periodo di prova.",
      "accountSettings.company.peopleName": "Nome",
      "accountSettings.company.peopleEmail": "E-mail",
      "accountSettings.company.peopleRole": "Ruolo",
      "accountSettings.company.peopleStatus": "Stato",
      "accountSettings.company.peopleTrialUntil": "Prova fino al",
      "accountSettings.company.peopleYou": "Tu",
      "accountSettings.company.peopleEmpty": "Non sono stati ancora trovati altri account in questa organizzazione.",
      "accountSettings.company.statusTrial": "Prova",
      "accountSettings.company.statusActive": "Attivo",
      "accountSettings.company.statusInactive": "Non attivo",
      "accountSettings.company.taxTypes.euVat": "Numero IVA europeo",
      "accountSettings.company.taxTypes.gbVat": "Numero IVA Regno Unito",
      "accountSettings.company.taxTypes.auAbn": "Numero aziendale australiano (AU ABN)",
      "accountSettings.company.taxTypes.auArn": "Numero riferimento fiscale australiano",
      "accountSettings.company.taxTypes.brCnpj": "Numero CNPJ brasiliano",
      "accountSettings.company.taxTypes.brCpf": "Numero CPF brasiliano",
      "accountSettings.company.taxTypes.caBn": "BN canadese",
      "accountSettings.company.taxTypes.caGstHst": "Numero GST/HST canadese",
      "accountSettings.company.taxTypes.chVat": "Numero IVA svizzero",
      "accountSettings.company.taxTypes.clTin": "TIN cileno",
      "accountSettings.company.taxTypes.egTin": "Codice fiscale egiziano",
      "accountSettings.company.taxTypes.inGst": "Numero GST indiano",
      "accountSettings.company.taxTypes.jpCn": "Numero aziendale giapponese",
      "accountSettings.company.taxTypes.jpRn": "Numero registrazione giapponese imprese estere",
      "accountSettings.company.taxTypes.mxRfc": "Numero RFC messicano",
      "accountSettings.company.taxTypes.noVat": "Numero IVA norvegese",
      "accountSettings.company.taxTypes.nzGst": "Numero GST neozelandese",
      "accountSettings.company.taxTypes.sgGst": "Numero GST Singapore",
      "accountSettings.company.taxTypes.usEin": "EIN Stati Uniti",
      "accountSettings.company.taxTypes.zaVat": "Numero IVA sudafricano",
      "security.twoFactor.title": "Autenticazione a due fattori",
      "security.twoFactor.subtitle": "Proteggi il tuo account con un codice a 6 cifre da un app di autenticazione.",
      "security.twoFactor.setup": "Configura 2FA",
      "security.twoFactor.scanQr": "Scansiona il codice QR con la tua app di autenticazione. Se non funziona, usa manualmente il codice di configurazione.",
      "security.twoFactor.openAuthenticator": "Apri nell app di autenticazione",
      "security.twoFactor.sixDigitCode": "Codice a 6 cifre",
      "security.twoFactor.enable": "Attiva 2FA",
      "security.twoFactor.disableWarning": "Disattiva la 2FA solo se sei sicuro che questo account sia protetto in altro modo.",
      "security.password": "Password",
      "security.twoFactor.code": "Codice 2FA",
      "security.twoFactor.disable": "Disattiva 2FA",
      "settingsPanel.regional.title": "Impostazioni regionali",
      "settingsPanel.regional.subtitle": "Scegli come funzionano lingua, valuta e unita. Browser e dati regionali vengono usati automaticamente.",
      "settingsPanel.regional.language": "Lingua",
      "settingsPanel.regional.currency": "Valuta",
      "settingsPanel.regional.units": "Unita",
      "settingsPanel.regional.autoLanguage": "Automatico ({{language}})",
      "settingsPanel.regional.autoCurrency": "Automatico ({{currency}})",
      "settingsPanel.regional.autoUnits": "Automatico ({{units}})",
      "settingsPanel.regional.metric": "Metrico",
      "settingsPanel.regional.imperial": "Imperiale",
      "settingsPanel.regional.detectedRegion": "Regione rilevata: {{region}}",
      "settingsPanel.map.title": "Impostazioni mappa",
      "settingsPanel.map.subtitle": "Regola colori, bordi, etichette e visibilita della mappa.",
      "settingsPanel.map.invalidOrSaveFailed": "Colore non valido o salvataggio non riuscito.",
      "settingsPanel.map.highlight.retailTitle": "Intensita evidenziazione retail",
      "settingsPanel.map.highlight.retailDescription": "Determina quanto gli immobili retail risaltano sulla mappa.",
      "settingsPanel.map.highlight.otherTitle": "Intensita altri immobili",
      "settingsPanel.map.highlight.otherDescription": "Determina quanto gli altri immobili sono visibili come livello di sfondo.",
      "settingsPanel.map.highlight.opacity": "Intensita: {{value}}",
      "settingsPanel.map.markerFont.title": "Dimensione testo marker",
      "settingsPanel.map.markerFont.description": "Determina quanto grandi appaiono nomi ed etichette sulla mappa.",
      "settingsPanel.map.markerFont.size": "Scala: {{value}}",
      "settingsPanel.map.preview.title": "Anteprima",
      "settingsPanel.map.preview.description": "Una rapida anteprima delle impostazioni della mappa.",
      "settingsPanel.common.saved": "Salvato",
      "settingsPanel.common.saving": "Salvataggio...",
      "settingsPanel.common.saveFailed": "Salvataggio non riuscito",
      "settingsPanel.common.ready": "Pronto",
      "billing.title": "Fatturazione",
      "billing.recurring.title": "Abbonamenti e utilizzo",
      "billing.recurring.description": "Costi ricorrenti per abbonamento, immobili in affitto attivi e altri componenti mensili.",
      "billing.baseSubscription": "Abbonamento base",
      "billing.baseSubscriptionDescription": "Accesso a Retailmaps e funzionalita di base.",
      "billing.forRent": "In affitto",
      "billing.forRentDescription": "Immobili in affitto attivi abilitati da questo account utente.",
      "billing.oneOff.title": "Acquisti singoli",
      "billing.oneOff.description": "Costi una tantum, come sblocchi documenti o altri eventi di fatturazione separati.",
      "billing.oneOff.noneTitle": "Nessun acquisto singolo in questo periodo",
      "billing.oneOff.noneDescription": "Non appena un acquisto singolo viene completato, apparira automaticamente qui.",
      "billing.oneOff.none": "Nessun acquisto singolo in questo periodo.",
      "billing.totals.subscriptions": "Abbonamenti",
      "billing.totals.trialDiscount": "Sconto prova",
      "billing.totals.oneOff": "Acquisti singoli",
      "billing.totals.vat": "IVA",
      "billing.totals.totalInclVat": "Totale incl. IVA",
      "billing.history.title": "Cronologia fatturazione",
      "billing.history.description": "Eventi di fatturazione recenti e transazioni singole per questo account.",
      "billing.history.none": "Non sono ancora stati trovati eventi di fatturazione per questo account.",
      "billing.history.documentUnlock": "Sblocco documento",
      "billing.columns.date": "Data",
      "billing.columns.description": "Descrizione",
      "billing.columns.status": "Stato",
      "billing.columns.amount": "Importo",
      "billing.columns.quantity": "Qta",
      "billing.columns.unitPrice": "Unita",
      "billing.columns.total": "Totale",
      "billing.description": "Tutto per {{account}} in un unico riepilogo: abbonamenti, acquisti singoli e costi aperti di {{period}}.",
      "billing.yourAccount": "il tuo account",
      "billing.currentMonth": "questo mese",
      "billing.currentPeriod": "Periodo corrente",
      "billing.downloadPdf": "Scarica fattura (PDF)",
      "billing.preparingPdf": "Preparazione PDF...",
      "billing.amountDueThisMonth": "Importo dovuto questo mese",
      "billing.subscriptionStatus": "Stato abbonamento",
      "billing.subscriptionActive": "Attivo",
      "billing.subscriptionInactive": "Non attivo",
      "billing.nextRenewal": "Prossimo rinnovo",
      "billing.stripeCustomer": "Cliente Stripe",
      "billing.paidSince": "Pagato da",
      "settingsPanel.mailTest.previewLogged": "{{provider}} non e ancora configurato completamente. L e-mail di test e stata registrata come anteprima per {{recipient}}.",
      "settingsPanel.mailTest.failed": "Invio dell e-mail di test non riuscito.",
      "billing.infoNotice": "I dati utente si trovano ora in Profilo e Azienda. Qui mostriamo solo cio che e rilevante dal punto di vista finanziario: costi ricorrenti, acquisti singoli e totale del mese corrente.",
      "propertyDetails.datePlaceholder": "gg-mm-aaaa",
      "propertyDetails.addContact": "Aggiungi contatto",
      "brokerProperty.askingPrice": "Prezzo richiesto",
      "owner.financieringBlock.vraagprijs": "Prezzo richiesto",
      "propertyDetails.askingRentPrice": "Canone richiesto",
      "propertyDetails.serviceCosts": "Spese di servizio",
      "propertyDetails.takeoverPrice": "Buonuscita",
      "propertyDetails.availableFrom": "Disponibile dal",
      "propertyDetails.projectInfoDivider": "Informazioni progetto",
      "propertyDetails.addProjectInfo": "Aggiungi informazioni progetto",
      "extraFields.addField": "Aggiungi campo",
      "extraFields": {
        "addField": "Aggiungi campo",
        "addSection": "Aggiungi sezione"
      },
      "extraFields.addSection": "Aggiungi sezione",
      "extraFieldsBlock.title": "Campi aggiuntivi",
      "mapSettings.opacityAria": "Slider opacita",
      "retailerMap.downloadSvg": "Scarica SVG",
      "retailerMap.downloadSvgTooltip": "Scarica la mappa come file SVG",
      "retailerMap.printMenu.paper": "Stampa su carta",
      "retailerMap.printMenu.pdf": "Salva come PDF",
      "retailerMap.printMenu.svg": "Scarica immagine mappa SVG",
      "settingsPanel.dashboardOverlay.shared.assistant": "Come funziona",
      "myProperties.noPaidSubscriptionSuffix": " - nessun abbonamento attivo",
      "myProperties.analysis": "Analisi",
      "myProperties.assignRequiresPaidSubscription": "Questo utente ha bisogno di un abbonamento attivo.",
      "myProperties.importPortfolio": "Importa portafoglio",
      "myProperties.remove": "Rimuovi",
      "myProperties.confirmRemove": "Vuoi davvero rimuovere questo immobile dal portafoglio dell'organizzazione? Se nessun collega ha lo stesso immobile, scomparira completamente dall'organizzazione.",
      "myProperties.removeFailed": "Rimozione non riuscita.",
      "popup2.addedState": "Aggiunto",
      "popup2.addToMyProperties": "Aggiungi ai miei immobili",
      "popup2.front": "Fronte",
      "popup2.groundFloor": "Piano terra",
      "popup2.basement": "Seminterrato",
      "popup2.firstFloor": "1o piano",
      "popup2.secondFloor": "2o piano",
      "popup2.thirdFloor": "3o piano",
      "popup2.entresol": "Soppalco",
      "popup2.soussol": "Seminterrato",
      "popup2.retailSpace": "Negozio",
      "popup2.secondarySpace": "Secondaria",
      "popup2.adding": "Aggiunta...",
      "popup2.publicData": "Dati pubblici",
      "popup2.privateData": "Dati privati",
      "popup2.surface": "Superficie",
      "settingsPanel.retailerMap.loading.zoomInToLoad": "Ingrandisci fino a {{zoom}} per caricare i retailer",
      "settingsPanel.retailerMap.loading.fillingStreet": "Caricamento di nuovi immobili. Puo richiedere fino a 2 min...",
      "settingsPanel.retailerMap.loading.paintingFromCenter": "Caricamento degli immobili dal centro...",
      "propertyFields": {
        "shop": "Negozio",
        "storage": "Magazzino",
        "secondary": "Secondaria"
      },
      "dashboardOverlay.shared.forRent": "In affitto",
      "analysis.title": "Analisi",
      "analysis.empty": "Aggiungi immobili all analisi per visualizzare i dati.",
      "analysis.summary.totalRent": "Canone annuo totale",
      "analysis.summary.totalAskingRent": "Prezzo richiesto totale",
      "analysis.summary.weightedArea": "m2 ponderati",
      "analysis.summary.avgRentPerM2": "Canone medio/m2/anno",
      "analysis.summary.avgAskingRentPerM2": "Prezzo richiesto medio/m2/anno",
      "analysis.metrics.waltYears": "WALT: {{value}} anni",
      "analysis.metrics.expiry12": "Scadenza 12m: {{value}}",
      "analysis.metrics.expiry24": "Scadenza 24m: {{value}}",
      "analysis.metrics.expiry36": "Scadenza 36m: {{value}}",
      "analysis.values.years": "{{value}} anni",
      "analysis.actions.clear": "Svuota analisi",
      "analysis.actions.collapseSurfaces": "Comprimi superfici",
      "analysis.actions.expandSurfaces": "Espandi superfici",
      "analysis.table.property": "Immobile",
      "analysis.table.tenant": "Conduttore",
      "analysis.table.front": "Fronte",
      "analysis.table.annualRent": "Canone annuo",
      "analysis.table.askingRent": "Prezzo richiesto",
      "analysis.table.weightedM2": "m2 ponderati",
      "analysis.table.rentPerM2": "Canone/m2",
      "analysis.table.askingRentPerM2": "Prezzo richiesto/m2",
      "analysis.table.expiry": "Scadenza",
      "analysis.table.remainingTerm": "Durata residua",
      "analysis.table.remainingMonths": "Mesi residui",
      "analysis.table.rentCoverage": "Copertura affitto",
      "analysis.table.interestCoverage": "Copertura interessi",
      "analysis.table.guaranteeMonths": "Mesi garanzia",
      "analysis.table.surfaces": "Superfici",
      "analysis.surfaces.title": "Superfici",
      "analysis.surfaces.helper": "Predefinito: retail 100%, secondaria 50%. Regola qui per piano.",
      "analysis.surfaces.weightedTotal": "Totale ponderato",
      "analysis.surfaces.grossM2": "{{value}} m2 lordi",
      "analysis.surfaces.weightedM2Value": "= {{value}} m2",
      "analysis.surfaces.empty": "Nessuna superficie trovata. Compila superfici retail e secondarie nei dati pubblici.",
      "analysis.surfaceFields.front": "Fronte",
      "analysis.surfaceFields.winkel": "Negozio",
      "analysis.surfaceFields.secundair": "Secondaria",
      "analysis.surfaceFields.begane_grond_winkel": "Piano terra negozio",
      "analysis.surfaceFields.begane_grond_secundair": "Piano terra secondaria",
      "analysis.surfaceFields.kelder_winkel": "Seminterrato negozio",
      "analysis.surfaceFields.kelder_secundair": "Seminterrato secondaria",
      "propertyList.rental.stopForRent": "Ferma affitto",
      "analysis.summary.wault": "WAULT",
      "analysis.actions.remove": "Rimuovi",
      "analysis.chips.wault": "WAULT: {{value}} anni",
      "analysis.chips.expiry12": "Scadenza 12m: {{value}}",
      "analysis.chips.expiry24": "Scadenza 24m: {{value}}",
      "analysis.chips.expiry36": "Scadenza 36m: {{value}}",
      "analysis.table.weightedArea": "m2 ponderati",
      "analysis.table.ltv": "LTV",
      "analysis.surfaces.button": "Superfici",
      "analysis.surfaceFields.shop": "Negozio",
      "analysis.surfaceFields.secondary": "Secondaria",
      "analysis.surfaceFields.eersteVerdiepingWinkel": "1 piano retail",
      "analysis.surfaceFields.eersteVerdiepingSecundair": "1 piano secondario",
      "analysis.surfaceFields.tweedeVerdiepingWinkel": "2 piano retail",
      "analysis.surfaceFields.tweedeVerdiepingSecundair": "2 piano secondario",
      "analysis.surfaceFields.derdeVerdiepingWinkel": "3 piano retail",
      "analysis.surfaceFields.derdeVerdiepingSecundair": "3 piano secondario",
      "dashboardOverlay.shared.support": "Supporto",
      "support": {
        "title": "Supporto",
        "intro": "Hai bisogno di aiuto? Invia la tua domanda direttamente al nostro team di supporto.",
        "emailIntro": "Puoi anche inviarci un’e-mail direttamente.",
        "category": "Argomento",
        "categoryGeneral": "Domanda generale",
        "categoryAccount": "Account e abbonamento",
        "categoryBilling": "Fatturazione e pagamenti",
        "categoryMap": "Mappa e dati",
        "categoryForRent": "In affitto",
        "categoryBug": "Segnala un problema",
        "subject": "Oggetto",
        "message": "La tua domanda",
        "subjectPlaceholder": "Descrivi brevemente la tua domanda",
        "messagePlaceholder": "Dicci come possiamo aiutarti",
        "send": "Invia al supporto",
        "sending": "Invio in corso…",
        "successTitle": "La tua richiesta di supporto è stata inviata",
        "success": "Abbiamo ricevuto la tua domanda. Il tuo riferimento è {{ticketNumber}}. Riceverai anche una conferma via e-mail.",
        "context": "Il tuo messaggio è collegato al tuo account {{role}} e alla pagina che stai visualizzando.",
        "validation": "Inserisci sia l’oggetto sia la tua domanda.",
        "error": "Non è stato possibile inviare la richiesta. Riprova o scrivi a support@retailmaps.com."
      }
    }
  },
  "nl": {
    "translation": {
      "popup2.trialPaywallTitle": "Je hebt je 10 gratis proef-interesses gebruikt",
      "popup2.trialPaywallDescription": "Om ook interesse te tonen in dit pand heb je een abonnement nodig. Je huidige 10 proef-interesses worden omgezet naar betaalde interesses.",
      "popup2.trialPaywallManage": "Je kunt deze interesses later beheren in je dashboard (aanpassen of verwijderen).",
      "popup2.trialPaywallActivate": "Activeer abonnement",
      "popup2.address": "Adres",
      "popup2.city": "Stad",
      "popup2.website": "Website",
      "popup2.groundFloor": "Begane grond",
      "popup2.loginRequired": "Je bent niet ingelogd. Log opnieuw in om panden toe te voegen.",
      "popup2.basement": "Kelder",
      "popup2.firstFloor": "1e verdieping",
      "popup2.secondFloor": "2e verdieping",
      "popup2.thirdFloor": "3e verdieping",
      "popup2.entresol": "Entresol",
      "popup2.soussol": "Sous-sol",
      "popup2.unit": "Eenheid",
      "popup2.m2": "m²",
      "popup2.ft2": "ft²",
      "popup2.inList": "Dit pand staat in jouw lijst",
      "popup2.confirmRemove": "Weet je zeker dat je dit pand uit je lijst wilt verwijderen?",
      "popup2.pandVerwijderd": "❌ Pand verwijderd uit je lijst.",
      "popup2.verwijderenMislukt": "❌ Verwijderen mislukt.",
      "popup2.removeFailed": "Verwijderen mislukt.",
      "popup2.saveFailed": "Fout bij opslaan.",
      "popup2.removeFromList": "Verwijder uit mijn panden",
      "popup2.pandToegevoegd": "✅ Pand toegevoegd aan je lijst!",
      "popup2.toevoegenMislukt": "❌ Toevoegen mislukt.",
      "popup2.addToList": "Voeg toe aan mijn panden",
      "popup2.interestedRetailers": "Geïnteresseerde retailers",
      "popup2.retailersHaveInterest": "retailers hebben interesse getoond",
      "popup2.stripeStartFout": "Er is iets misgegaan bij het starten van Stripe.",
      "popup2.viewRequests": "Bekijk de interesse in Panden",
      "popup2.publicData": "Openbare gegevens",
      "popup2.privateData": "Privégegevens",
      "popup2.publicDataHint": "Zichtbare pandinformatie voor listings, brochures en kaartweergaven.",
      "popup2.privateDataHint": "Interne informatie blijft binnen je beveiligde workspace en is alleen zichtbaar voor geautoriseerde gebruikers.",
      "popup2.privateWorkspace": "Privéworkspace",
      "popup2.privateWorkspaceHint": "Gebruik deze tabs om eigenaarsgevoelige notities, financiën, contacten, foto's en documenten overzichtelijk en veilig te beheren.",
      "popup2.manageRentalStatus": "Te huur status beheren",
      "popup2.forRent": "Te huur",
      "popup2.confirmTeHuurZetten": "Je staat op het punt om dit pand te huur te zetten.\nâ€¢ Normaal {{prijs}} per maand, nu tijdelijk gratis\nâ€¢ De status wordt zichtbaar voor andere partijen\n\nKlik op OK om akkoord te gaan.",
      "popup2.confirmStopTeHuurStatus": "Je staat op het punt om de te huur status te beëindigen.\n• Hiermee wordt ook je Stripe abonnement voor dit pand gestopt.\n\nWeet je zeker dat je wilt doorgaan?",
      "popup2.teHuurGestopt": "✅ De te huur status is beëindigd en het abonnement is gestopt.",
      "popup2.openbaarZichtbaarMaken": "Openbaar zichtbaar maken",
      "popup2.stripeAnnuleringMislukt": "Stripe annulering mislukt",
      "popup2.zetEerstTeHuur": "Zet eerst het pand te huur voordat je openbaar kunt maken.",
      "popup2.opslaanWijzigingen": "Wijzigingen opslaan",
      "popup2.front": "Front",
      "popup2.inPortfolio": "In portefeuille",
      "popup2.addToMyProperties": "Toevoegen aan mijn panden",
      "popup2.alreadyInOrgPortfolio": "Pand zit al in organisatieportefeuille",
      "popup2.alreadyInOwnPortfolio": "Pand zit al in eigen portefeuille",
      "popup2.addPropertyError": "Fout bij toevoegen van pand",
      "popup2.invalidSession": "Geen geldige sessie â€“ log opnieuw in",
      "popup2.trialLimitReachedTitle": "🚧 Limiet bereikt",
      "popup2.trialLimitReachedDesc1": "Maximaal 3 panden tijdens proefperiode toegestaan",
      "popup2.trialLimitReachedDesc2": "Activeer abonnement om verder te gaan:",
      "popup2.subscriptionPrice": "📅 €19 per maand",
      "popup2.extraPropertyPrice": "➕ €5 per extra pand",
      "popup2.listingPrice": "➕ Normaal €15 per maand (pand te huur zetten), nu tijdelijk gratis",
      "popup2.stripeSessionFailed": "Stripe-sessie starten mislukt",
      "popup2.stripeError": "Stripe-fout",
      "popup2.noUserEmail": "Geen e-mailadres gevonden (ingelogd?)",
      "popup2.stripeNotLoaded": "Stripe.js niet geladen",
      "popup2.extraPandFailed": "Kon extra pand-checkout niet starten",
      "popup2.onlyMineHeader": "Status beheren niet mogelijk",
      "popup2.onlyMineMessage": "Je kan de status niet wijzigen. Als je de status wil aanpassen moet je het pand aan 'mijn panden' toevoegen",
      "popup2.cancel": "Annuleren",
      "popup2.busy": "Bezig...",
      "popup2.confirm": "Bevestigen",
      "popup2.saveError": "Fout bij opslaan.",
      "popup2.surface": "Oppervlakte",
      "popup2.retailSpace": "Winkel",
      "popup2.secondarySpace": "Secundair",
      "popup2.visibilityUpdateFailed": "Wijzigen van zichtbaarheid mislukt.",
      "popup2.extraPropertyFailed": "Extra pand toevoegen mislukt.",
      "popup2.stripeStartFailed": "Stripe starten mislukt.",
      "popup2.stripeErrorPrefix": "Stripe-fout: ",
      "popup2.interestAddFailed": "Interesse toevoegen mislukt.",
      "popup2.ownerMustAddFirst": "Voeg dit pand eerst toe aan je portefeuille.",
      "popup2.retailerBrandClaimRequired": "Een merkclaim is vereist om verhuurzichtbaarheid te beheren.",
      "popup2.roleNotSupported": "Je huidige rol ondersteunt deze actie niet.",
      "photos.title": "Foto's",
      "photos.add": "Foto toevoegen",
      "photos.remove": "Foto verwijderen",
      "photos.error.tooLarge": "is groter dan 10 MB en is overgeslagen.",
      "documents.title": "Documenten",
      "documents.add": "Document toevoegen",
      "documents.remove": "Verwijderen",
      "documents.error.tooLarge": "is groter dan 10 MB en is overgeslagen.",
      "retailer.contactgegevensBlock.title": "Contactgegevens",
      "retailer.contactgegevensBlock.company": "Bedrijf",
      "retailer.contactgegevensBlock.name": "Naam",
      "retailer.contactgegevensBlock.phone": "Telefoon",
      "retailer.contactgegevensBlock.email": "E-mail",
      "retailer.contactgegevensBlock.function": "Functie",
      "retailer.contactgegevensBlock.add": "Contact toevoegen",
      "retailer.contactgegevensBlock.remove": "Verwijder contact",
      "brokerContact.retailerContacts": "Contactpersonen namens retailer",
      "brokerContact.ownerContacts": "Contactpersonen namens eigenaar",
      "brokerContact.company": "Bedrijf",
      "brokerContact.name": "Naam",
      "brokerContact.phone": "Telefoonnummer",
      "brokerContact.email": "E-mailadres",
      "brokerContact.position": "Functie",
      "brokerContact.add": "Contact toevoegen",
      "brokerContact.remove": "Verwijder contact",
      "dashboard.title": "Dashboard",
      "dashboard.logout": "Uitloggen",
      "dashboard.backToMap": "← Terug naar kaart",
      "dashboard.trialExpiredTitle": "Je proefperiode is verlopen.",
      "dashboard.trialExpiredText": "Activeer je abonnement om door te gaan.",
      "dashboard.activateSubscription": "Abonnement activeren",
      "dashboard.daysLeft": "dagen resterend in gratis proefperiode",
      "dashboard.profile": "Profiel",
      "dashboard.brokerInterests": "Geïnteresseerde retailers",
      "dashboard.myInterests": "Mijn interesses",
      "dashboard.myProperties": "Mijn portefeuille",
      "dashboard.requests": "Aanvragen",
      "dashboard.subscription": "Abonnement",
      "dashboard.subscriptionComingSoon": "Abonnement (binnenkort beschikbaar)",
      "dashboard.bundles": "Bundelbeheer",
      "dashboard.settings": "Instellingen",
      "dashboard.brokerAccount": "Mijn account",
      "dashboard.backToDashboard": "Terug naar dashboard",
      "dashboard.brokerListings": "Mijn verhuuraanbod",
      "authLanding": {
        "tabs": {
          "login": "Login",
          "register": "Registreer"
        },
        "roles": {
          "retailer": "Retailer",
          "owner": "Owner",
          "broker": "Broker"
        },
        "headlines": {
          "login": {
            "eyebrow": "Retail real estate intelligence",
            "subtitle": "Log in en werk vanuit een live kaartlaag aan portefeuille, verhuur en interesse."
          },
          "register": {
            "eyebrow": "Eén platform voor brokers, owners en retailers",
            "subtitle": "Start met een account en bouw je portefeuille, verhuuraanbod en marktinzicht op vanuit de kaart."
          },
          "forgot": {
            "eyebrow": "Toegang herstellen",
            "subtitle": "Vraag een resetlink aan en stel snel een nieuw wachtwoord in voor je account."
          }
        },
        "forgot": {
          "helper": "Voer hieronder je e-mailadres in. Als het account bestaat, sturen we direct een resetlink."
        },
        "roleSlides": {
          "broker": {
            "label": "Broker",
            "eyebrow": "Voor brokers",
            "subtitle": "Maak verhuuraanbod zichtbaar, volg interesse en koop contactgegevens direct vanuit dezelfde kaartomgeving.",
            "featureCards": {
              "0": "Zet beschikbare locaties sneller in de markt.",
              "1": "Werk met live interesse, documenten en projectinformatie.",
              "2": "Houd aanbod, leads en analyse bij elkaar."
            },
            "workflowSteps": {
              "0": "Van pand naar listing",
              "1": "Interesse en contactgegevens",
              "2": "Analyse per locatie"
            },
            "footer": {
              "0": "Verhuuraanbod",
              "1": "Leadinformatie",
              "2": "Broker intelligence"
            }
          },
          "owner": {
            "label": "Owner",
            "eyebrow": "Voor owners",
            "subtitle": "Beheer portefeuille, huurdata, documenten en alerts vanuit een kaart die aansluit op je vastgoedpraktijk.",
            "featureCards": {
              "0": "Leg huur, eigenaar en financiele data centraal vast.",
              "1": "Zet panden te huur en volg de status op de kaart.",
              "2": "Gebruik alerts en analyse zonder losse spreadsheets."
            },
            "workflowSteps": {
              "0": "Portefeuillecontrole",
              "1": "Huurdata en alerts",
              "2": "Asset analyse"
            },
            "footer": {
              "0": "Portefeuillebeheer",
              "1": "Huurinformatie",
              "2": "Owner analytics"
            }
          },
          "retailer": {
            "label": "Retailer",
            "eyebrow": "Voor retailers",
            "subtitle": "Ontdek straten, beheer je winkels, toon interesse en analyseer locaties voordat je de volgende stap zet.",
            "featureCards": {
              "0": "Zie relevante retailstraten en beschikbare panden.",
              "1": "Voeg winkels toe aan je eigen portefeuille.",
              "2": "Toon interesse en vergelijk locaties in analyse."
            },
            "workflowSteps": {
              "0": "Winkels beheren",
              "1": "Interesse tonen",
              "2": "Locaties vergelijken"
            },
            "footer": {
              "0": "My stores",
              "1": "Interesse",
              "2": "Retail analyse"
            }
          }
        },
        "platformSubtitle": "Voor en door retailprofessionals",
        "heroSubtitle": "De live retailmap voor alle winkelgebieden wereldwijd, verhuren, interesse tonen, leads en locatieanalyse. Alles in 1 platform voor EUR 19 per maand.",
        "trialIntro": "Start je gratis 60 dagen proefperiode hier",
        "trialCta": "Registreer gratis",
        "marketTagline": "Prime retail streets · live market context",
        "featureCards": {
          "0": "Werk vanuit een live kaartlaag met retailcontext.",
          "1": "Beheer portefeuille, verhuur en interesse centraal.",
          "2": "Sluit broker, owner en retailer in één platform aan."
        },
        "workflowSteps": {
          "0": "Portefeuille- en listingcontrole",
          "1": "Live marktsignalen op de kaart",
          "2": "Één workflow voor iedere rol"
        },
        "footer": {
          "0": "Portefeuillebeheer",
          "1": "Verhuuraanbod",
          "2": "Retail intelligence"
        },
        "modeLabel": {
          "login": "Welkom terug",
          "register": "Nieuw account",
          "forgot": "Wachtwoord vergeten"
        },
        "panelTitle": {
          "login": "Log in op Retailmaps",
          "register": "Start met Retailmaps",
          "forgot": "Reset je wachtwoord"
        },
        "fields": {
          "email": "E-mailadres",
          "password": "Wachtwoord",
          "firstName": "Voornaam",
          "lastName": "Achternaam",
          "role": "Rol",
          "phone": "Telefoon",
          "companyName": "Bedrijfsnaam",
          "website": "Website"
        },
        "actions": {
          "forgotPassword": "Wachtwoord vergeten?",
          "login": "Login",
          "register": "Registreer",
          "startTrial": "Start gratis proefperiode",
          "sendReset": "Verstuur resetlink",
          "backToLogin": "Terug naar login",
          "openLocalReset": "Open lokale resetlink"
        },
        "legal": {
          "acceptPrefix": "Ik ga akkoord met de",
          "privacy": "privacyverklaring",
          "and": "en de",
          "terms": "algemene voorwaarden"
        },
        "errors": {
          "loginFailed": "Inloggen is niet gelukt. Controleer je gegevens.",
          "registerFailed": "Registreren is niet gelukt. Probeer het opnieuw.",
          "companyRequired": "Bedrijfsnaam is verplicht.",
          "forgotNotice": "Als dit e-mailadres bekend is, hebben we een resetlink verstuurd.",
          "forgotFailed": "We konden de resetlink nu niet versturen."
        }
      },
      "successStripe": {
        "title": "Stripe succes",
        "waitTitle": "Betaling ontvangen",
        "waitDescription": "We ronden nu de activatie af. Dit kan enkele seconden duren. Laat dit scherm open; je wordt automatisch doorgestuurd zodra alles klaarstaat.",
        "stepPayment": "Betaling bevestigd",
        "stepActivation": "Account of listing wordt geactiveerd",
        "stepRedirect": "Je gaat automatisch terug naar Retailmaps",
        "back": "Terug",
        "processing": "Bezig met verwerken...",
        "missingToken": "Geen geldig token gevonden. Log opnieuw in.",
        "missingParams": "Ontbrekende parameters in de URL.",
        "unknownError": "Onbekende fout",
        "missingSessionId": "session_id ontbreekt.",
        "missingRetailerId": "retailerId ontbreekt.",
        "paymentReceivedActivating": "Betaling ontvangen! Het abonnement wordt geactiveerd...",
        "retailerListingActive": "Winkel staat nu te huur en is openbaar zichtbaar.",
        "ownerListingActive": "Pand staat nu te huur.",
        "subscriptionActivating": "Abonnement wordt geactiveerd...",
        "subscriptionNotConfirmed": "Abonnement kon niet bevestigd worden.",
        "subscriptionActive": "Abonnement actief.",
        "extraPropertyAdded": "Extra pand succesvol toegevoegd.",
        "contactAccessUnlocked": "Betaling ontvangen. We zetten de contactgegevens klaar en sturen je terug naar het juiste pand.",
        "interestProcessed": "Interesse succesvol verwerkt.",
        "retailerSubscriptionActivating": "Retailer-abonnement wordt geactiveerd...",
        "retailerSubscriptionActive": "Retailer-abonnement actief.",
        "brokerSubscriptionActivating": "Betaling ontvangen! Het broker-abonnement wordt geactiveerd...",
        "invalidType": "Onbekend of ongeldig type.",
        "genericFailure": "Er ging iets mis: {{message}}"
      },
      "common": {
        "loading": "Laden...",
        "save": "Opslaan",
        "cancel": "Annuleren",
        "edit": "Bewerken",
        "delete": "Verwijderen",
        "close": "Sluiten",
        "yes": "Ja",
        "no": "Nee",
        "localeCode": "nl-NL",
        "open": "Openen",
        "active": "Actief",
        "inactive": "Niet actief",
        "busy": "Bezig...",
        "backToDashboard": "Terug naar dashboard",
        "download": "Download",
        "saved": "Opgeslagen",
        "saving": "Opslaan...",
        "saveFailed": "Opslaan mislukt",
        "ready": "Gereed",
        "canceled": "Geannuleerd",
        "confirm": "Bevestigen"
      },
      "roles": {
        "owner": "Eigenaar",
        "retailer": "Retailer",
        "broker": "Makelaar"
      },
      "listings": {
        "common": {
          "country": "Land",
          "city": "Stad",
          "address": "Adres",
          "askingPrice": "Vraagprijs",
          "currentRent": "Huidige huurprijs",
          "keyMoney": "Overnamesom",
          "expiryDate": "Expiratiedatum",
          "availableFrom": "Beschikbaar per",
          "projectInformation": "Projectinformatie",
          "onBehalfOf": "Namens",
          "visibility": "Zichtbaarheid",
          "actions": "Acties",
          "upload": "Uploaden",
          "uploadDocument": "Document uploaden",
          "chooseFile": "Bestand kiezen",
          "noFileChosen": "Geen bestand gekozen",
          "projectDocuments": "Projectdocumenten",
          "empty": "Er zijn momenteel geen locaties te huur.",
          "selectFileFirst": "Selecteer eerst een bestand.",
          "uploadFailed": "Upload mislukt.",
          "confirmDeleteDocument": "Weet je zeker dat je \"{{name}}\" wilt verwijderen?",
          "documentDeleteFailed": "Document verwijderen mislukt.",
          "brochureFailed": "Brochure genereren of uploaden mislukt.",
          "stopForRent": "Stop",
          "forRent": "Te huur",
          "documentTypes": {
            "document": "Document",
            "floorplan": "Plattegrond",
            "brochure": "Brochure",
            "photo": "Foto"
          },
          "visibilityOptions": {
            "public": "Iedereen",
            "retailers": "Alle retailers",
            "interested": "Alleen geïnteresseerden"
          },
          "interestAndDocuments": "Toon interesse en ontvang documenten",
          "deleteDocumentAria": "Verwijder {{name}}",
          "selectDocumentFirst": "Selecteer eerst minimaal een document.",
          "documentsSavedToProject": "De geselecteerde documenten zijn toegevoegd aan mijn projectinformatie.",
          "documentsSaveFailed": "Opslaan van projectinformatie is niet gelukt.",
          "projectDocumentsHelp": "Open documenten via de link of vink ze aan om ze in mijn projectinformatie te zetten.",
          "addedOn": "Toegevoegd {{date}}",
          "saveToProjectInformation": "Zet in mijn projectinformatie",
          "forRentSince": "Te huur sinds",
          "onRequest": "Op aanvraag",
          "broker": "Makelaar",
          "edit": "Bewerken",
          "save": "Opslaan",
          "cancel": "Annuleren",
          "noDocuments": "Geen documenten",
          "fileCountOne": "{{count}} bestand",
          "fileCountOther": "{{count}} bestanden",
          "available": "Beschikbaar",
          "surface": "Metrage",
          "total": "Totaal",
          "contactBroker": "Contact verhuurmakelaar",
          "thirdPartyNotice": "Informatie afkomstig van derden. Controleer details bij de aanbieder.",
          "goToInformation": "Ga naar informatie",
          "viewDocuments": "Bekijk documenten",
          "unlockForPrice": "Gratis ontgrendelen",
          "unlockDocuments": "Ontgrendel documenten",
          "oneTimeAccessPrice": "Toegang tot de documenten is momenteel gratis."
        },
        "roles": {
          "external": "Extern aanbod",
          "owner": "Eigenaar",
          "tenant": "Retailer",
          "brokerOnBehalfOwner": "Broker (namens eigenaar)",
          "provider": "Aanbieder"
        }
      },
      "ownerListings": {
        "currentOffer": "Mijn verhuuraanbod"
      },
      "accountSettings": {
        "title": "Instellingen",
        "tabs": {
          "profile": "Profiel",
          "company": "Bedrijf",
          "preferences": "Voorkeuren",
          "billing": "Facturatie",
          "security": "Beveiliging"
        },
        "descriptions": {
          "profile": "Contactgegevens en rolgegevens voor je account.",
          "company": "Bedrijfsgegevens, merk en facturatie.",
          "preferences": "Taal, valuta, eenheden en kaartweergave.",
          "billing": "Abonnement, gebruik en losse aankopen.",
          "security": "Inloggen en accountbeveiliging."
        },
        "personal": {
          "title": "Persoonlijk profiel",
          "description": "Contactgegevens en rolgegevens voor je account. Wijzigingen worden automatisch opgeslagen.",
          "firstName": "Voornaam",
          "lastName": "Achternaam",
          "role": "Functie",
          "phone": "Telefoonnummer",
          "email": "E-mailadres",
          "linkedin": "LinkedIn",
          "address": "Adres"
        },
        "company": {
          "brandLogoTitle": "Merk en logo",
          "brandLogoDescription": "We gebruiken dit logo op pandkaarten en andere zichtbare merkplekken.",
          "title": "Bedrijfsprofiel",
          "description": "Bedrijfsgegevens, merkinformatie en facturatie voor makelaars- en eigenaarsaccounts. Wijzigingen worden automatisch opgeslagen.",
          "readOnlyNotice": "Bedrijfsgroep en domein sturen koppelingen, zichtbaarheid en AI-profielen en blijven daarom alleen-lezen.",
          "companyName": "Bedrijfsnaam",
          "companyGroup": "Bedrijfsgroep",
          "domain": "Domein",
          "legalName": "Juridische naam",
          "website": "Website",
          "roleType": "Roltype",
          "headquartersTitle": "Hoofdkantoor",
          "headquartersAddress": "Adres hoofdkantoor",
          "postalCode": "Postcode",
          "city": "Plaats",
          "country": "Land",
          "billingTitle": "Facturatie",
          "billingDescription": "We gebruiken deze gegevens voor abonnementen, facturen en financiele administratie.",
          "billingEmail": "Facturatie e-mail",
          "invoiceReference": "Factuurreferentie / PO",
          "chamberOfCommerce": "KvK-nummer",
          "vatNumber": "Btw-nummer",
          "billingAddress": "Factuuradres",
          "taxIdType": "Type belastingnummer",
          "taxIdValue": "Btw- / belastingnummer",
          "taxIdPlaceholder": "NL123456789B01",
          "peopleTitle": "Personen",
          "peopleDescription": "Accounts die aan dezelfde organisatie zijn gekoppeld. Statussen zijn gebaseerd op abonnement en proefperiode.",
          "peopleName": "Naam",
          "peopleEmail": "E-mail",
          "peopleRole": "Rol",
          "peopleStatus": "Status",
          "peopleTrialUntil": "Proefperiode tot",
          "peopleYou": "Jij",
          "peopleEmpty": "Er zijn nog geen andere accounts binnen deze organisatie gevonden.",
          "statusActive": "Actief",
          "statusTrial": "Proefperiode",
          "statusInactive": "Niet actief",
          "taxTypes": {
            "euVat": "Europees btw-nummer",
            "gbVat": "Brits btw-nummer",
            "auAbn": "Australisch bedrijfsnummer (AU ABN)",
            "auArn": "Australisch belastingreferentienummer",
            "brCnpj": "Braziliaans CNPJ-nummer",
            "brCpf": "Braziliaans CPF-nummer",
            "caBn": "Canadees BN",
            "caGstHst": "Canadees GST/HST-nummer",
            "chVat": "Zwitsers btw-nummer",
            "clTin": "Chileens TIN",
            "egTin": "Egyptisch fiscaal nummer",
            "inGst": "Indiaas GST-nummer",
            "jpCn": "Japans ondernemingsnummer",
            "jpRn": "Japans registratienummer buitenlandse onderneming",
            "mxRfc": "Mexicaans RFC-nummer",
            "noVat": "Noors btw-nummer",
            "nzGst": "Nieuw-Zeelands GST-nummer",
            "sgGst": "Singaporees GST-nummer",
            "usEin": "Amerikaans EIN",
            "zaVat": "Zuid-Afrikaans btw-nummer"
          }
        }
      },
      "billing": {
        "title": "Facturatie",
        "description": "Alles voor {{account}} in één overzicht: abonnementen, losse aankopen en de open kosten van {{period}}.",
        "yourAccount": "je account",
        "currentMonth": "deze maand",
        "currentPeriod": "Huidige periode",
        "preparingPdf": "PDF voorbereiden...",
        "downloadPdf": "Factuur downloaden (PDF)",
        "downloadError": "Factuur downloaden mislukt.",
        "loadError": "Facturatiegegevens konden niet worden geladen.",
        "amountDueThisMonth": "Verschuldigd deze maand",
        "subscriptionStatus": "Abonnementsstatus",
        "subscriptionActive": "Actief",
        "subscriptionInactive": "Niet actief",
        "nextRenewal": "Volgende verlenging",
        "stripeCustomer": "Stripe klant",
        "paidSince": "Betaald sinds",
        "infoNotice": "Gebruikersgegevens staan nu in Profiel en Bedrijf. Hier tonen we alleen wat financieel relevant is: terugkerende abonnementskosten, losse aankopen en het totaal voor deze maand.",
        "summary": {
          "title": "Samenvatting"
        },
        "recurring": {
          "title": "Abonnementen en gebruik",
          "description": "Terugkerende kosten voor je abonnement, actieve te-huur locaties en andere maandelijkse componenten."
        },
        "oneOff": {
          "title": "Losse aankopen",
          "description": "Eenmalige kosten, zoals documentontgrendelingen of andere losse billing events.",
          "none": "Geen losse aankopen in deze periode.",
          "noneTitle": "Geen losse aankopen in deze periode",
          "noneDescription": "Zodra er een losse aankoop wordt afgerekend, verschijnt die hier automatisch."
        },
        "totals": {
          "subscriptions": "Abonnementen",
          "oneOff": "Losse aankopen",
          "totalDue": "Totaal verschuldigd"
        },
        "history": {
          "title": "Billinghistorie",
          "description": "Recente billing events en losse transacties voor dit account.",
          "none": "Er zijn nog geen billing events gevonden voor dit account.",
          "documentUnlock": "Documentontgrendeling"
        },
        "columns": {
          "description": "Omschrijving",
          "quantity": "Aantal",
          "unitPrice": "Per stuk",
          "total": "Totaal",
          "date": "Datum",
          "amount": "Bedrag",
          "status": "Status"
        },
        "invoice": {
          "overview": "Factuuroverzicht {{period}}",
          "invoiceDate": "Factuurdatum",
          "period": "Periode",
          "statusOpen": "Status: open",
          "billTo": "Factuur aan",
          "footer": "Dit overzicht is gegenereerd vanuit de actuele Retailmaps-facturatiegegevens voor deze periode."
        },
        "user": "Gebruiker",
        "subscription": "Abonnement",
        "trialUntil": "Proefperiode tot",
        "trialEndedOn": "Proefperiode beeindigd op",
        "baseSubscription": "Basisabonnement",
        "perMonth": "per maand",
        "totalMonthlyCosts": "Totale maandkosten",
        "renewsOn": "Verlengt op {{date}}",
        "noticePeriod": "Opzegtermijn: 1 maand. Abonnement blijft actief tenzij je het opzegt.",
        "includesProperties": "incl. {{count}} panden",
        "extraProperties": "Extra panden",
        "totalProperties": "Totaal panden",
        "monthlyCosts": "Maandelijkse kosten",
        "cancelSubscription": "Abonnement opzeggen",
        "cancellationScheduled": "Je abonnement is ingepland om te stoppen op {{date}}. Je gegevens blijven veilig gearchiveerd en worden hersteld wanneer je opnieuw activeert.",
        "cancelDialog": {
          "title": "Abonnement opzeggen",
          "retention": "Je abonnement stopt na de huidige betaalperiode. Er wordt niets verwijderd: je portefeuille, documenten, historie en facturen blijven veilig gearchiveerd voor heractivatie.",
          "endsOn": "Je toegang blijft actief tot {{date}}.",
          "ownerProperties": "Mijn panden",
          "retailerStores": "Mijn winkels",
          "returnPortfolio": "Terugzetten naar de organisatieportefeuille (niet toegewezen)",
          "transferColleague": "Overdragen aan een collega",
          "listings": "Actieve te-huurplaatsingen",
          "archiveListings": "Stoppen en archiveren op de einddatum",
          "transferListings": "Overdragen aan een collega",
          "interests": "Actieve interesses worden op de einddatum ingetrokken. De afgeschermde historie blijft in je account gearchiveerd.",
          "contacts": "Eerder gekochte contactgegevens en facturen blijven als aankoophistorie bewaard en worden hersteld wanneer dit account opnieuw wordt geactiveerd.",
          "recipient": "Ontvangende collega",
          "confirm": "Opzegging inplannen"
        }
      },
      "stores": {
        "common": {
          "number": "Nr.",
          "storeName": "Naam winkel",
          "status": "Status",
          "byWho": "Door wie",
          "details": "Details",
          "retailManager": "Retailmanager",
          "brokerOnBehalfOfOwner": "Broker (namens owner)"
        },
        "status": {
          "forRent": "Te huur",
          "rented": "Verhuurd"
        },
        "actions": {
          "stopRent": "Stop verhuur",
          "setForRent": "Zet te huur"
        },
        "sections": {
          "mine": "Mijn winkels",
          "organization": "Winkels van mijn organisatie"
        },
        "filters": {
          "allCountries": "Alle landen",
          "allCities": "Alle steden"
        },
        "messages": {
          "addedToPortfolio": "Winkel toegevoegd aan je portfolio.",
          "addFailed": "Kon winkel niet toevoegen.",
          "removeFailed": "Kon winkel niet verwijderen.",
          "toggleRentFailed": "Wijzigen van verhuurstatus mislukt.",
          "subscriptionRequired": "Voor deze actie is een actief abonnement nodig.",
          "assignFailed": "Toewijzen mislukt."
        }
      },
      "dashboard.verhuurAanbod": "Mijn verhuuraanbod",
      "successPage.processing": "Even geduld... we verwerken je gegevens...",
      "successPage.notLoggedIn": "❌ Niet ingelogd. Probeer opnieuw.",
      "successPage.subscriptionActivated": "✅ Je abonnement is succesvol geactiveerd!",
      "successPage.subscriptionFailed": "❌ Activatie mislukt: ",
      "successPage.subscriptionError": "❌ Serverfout bij activeren abonnement.",
      "successPage.propertyForRent": "✅ Pand staat nu als 'te huur'.",
      "successPage.propertyUpdateError": "❌ Fout bij updaten pandstatus: ",
      "successPage.serverError": "❌ Serverfout.",
      "successPage.bundleActivated": "✅ Bundel succesvol geactiveerd.",
      "successPage.bundleFailed": "❌ Bundelactivatie mislukt.",
      "successPage.bundleError": "❌ Fout bij bundelactivatie.",
      "successPage.interestRegistered": "✅ Interesse is succesvol geregistreerd.",
      "successPage.interestStoredFailed": "❌ Opslaan interesse mislukt.",
      "successPage.interestStoreError": "❌ Fout bij opslaan interesse.",
      "successPage.missingContactData": "❌ Onvoldoende gegevens om toegang te verlenen.",
      "successPage.contactConfirmed": "✅ Contactgegevens zijn nu beschikbaar. Je wordt doorgestuurd...",
      "successPage.contactConfirmFailed": "⚠️ Betaling gelukt, maar toegang nog niet verleend.",
      "successPage.contactError": "❌ Serverfout bij bevestigen contacttoegang.",
      "successPage.incompleteOrUnknown": "❌ Onvolledige of onbekende sessiegegevens.",
      "successPage.propertyAddFailed": "❌ Pand toevoegen mislukt: ",
      "successPage.propertyAddError": "❌ Fout bij toevoegen pand.",
      "successPage.success": "Gelukt!",
      "successPage.loading": "Bezig...",
      "successPage.comboSuccess": "✅ Combo: pand toegevoegd én abonnement actief.",
      "successPage.comboFailed": "❌ Toevoegen mislukt na combo-betaling: ",
      "successPage.extraPropertyAdded": "✅ Extra pand succesvol toegevoegd.",
      "successPage.extraPropertyFailed": "❌ Toevoegen mislukt na betaling: ",
      "successPage.missingRetailerId": "❌ Geen retailerId opgegeven.",
      "myProperties.title": "Mijn Portefeuille",
      "myProperties.back": "Terug naar Dashboard",
      "myProperties.empty": "Je hebt nog geen panden toegevoegd.",
      "myProperties.name": "Naam",
      "myProperties.address": "Adres",
      "myProperties.city": "Stad",
      "myProperties.country": "Land",
      "myProperties.link": "Details",
      "myProperties.action": "Actie",
      "myProperties.remove": "Verwijder",
      "myProperties.confirmRemove": "Weet je zeker dat je dit pand uit de organisatieportefeuille wilt verwijderen? Als dit pand niet ook bij een collega staat, verdwijnt het volledig uit de organisatie.",
      "myProperties.removeFailed": "Verwijderen mislukt.",
      "propertyDetails.back": "Terug naar overzicht",
      "propertyDetails.address": "Adres",
      "propertyDetails.publicData": "Publieke gegevens",
      "propertyDetails.privateData": "Privégegevens",
      "propertyDetails.groundFloor": "Begane grond",
      "propertyDetails.firstFloor": "1e verdieping",
      "propertyDetails.secondFloor": "2e verdieping",
      "propertyDetails.thirdFloor": "3e verdieping",
      "propertyDetails.basement": "Kelder",
      "propertyDetails.entresol": "Entresol",
      "propertyDetails.soussol": "Sous-sol",
      "propertyDetails.rentalData": "Huurgegevens",
      "propertyDetails.formalTenant": "Formele huurder",
      "propertyDetails.huurprijs": "Huurprijs",
      "propertyDetails.startDate": "Ingangsdatum",
      "propertyDetails.endDate": "Expiratiedatum",
      "propertyDetails.remainingLeaseTermMonths": "Resterende looptijd (maanden)",
      "propertyDetails.indexDate": "Indexatiedatum",
      "propertyDetails.cancelDate": "Opzegdatum",
      "propertyDetails.cancelNotice": "Opzegtermijn (maanden)",
      "propertyDetails.guaranteeType": "$t(owner.huurgegevensBlock.garantiesoort)",
      "propertyDetails.guaranteeAmount": "$t(owner.huurgegevensBlock.garantiebedrag)",
      "propertyDetails.financialData": "Financiele gegevens",
      "propertyDetails.purchasePrice": "Koopsom",
      "propertyDetails.purchaseDate": "Aankoopdatum",
      "propertyDetails.mortgage": "Hypotheekbedrag",
      "propertyDetails.interestRate": "Rentepercentage",
      "propertyDetails.bank": "Bank",
      "propertyDetails.loanDuration": "Looptijd (jaren)",
      "propertyDetails.comments": "Opmerkingen",
      "propertyDetails.addComment": "Voeg opmerking toe",
      "propertyDetails.addCommentPrompt": "Voeg een opmerking toe:",
      "propertyDetails.contacts": "Huurderscontacten",
      "propertyDetails.documents": "Documenten",
      "propertyDetails.photos": "Foto's",
      "propertyDetails.save": "Wijzigingen opslaan",
      "propertyDetails.saveSuccess": "✅ Gegevens opgeslagen",
      "propertyDetails.saveError": "❌ Opslaan mislukt",
      "propertyDetails.loading": "📦 Laden...",
      "propertyDetails.notFound": "❌ Deze locatie bestaat niet (meer).",
      "registerPage.title": "📝 Registreren",
      "registerPage.email": "E-mailadres",
      "registerPage.password": "Wachtwoord",
      "registerPage.role": "Rol",
      "registerPage.retailer": "Retailer",
      "registerPage.owner": "Eigenaar",
      "registerPage.broker": "Makelaar",
      "registerPage.brand": "Merknaam",
      "registerPage.website": "Website",
      "registerPage.firstName": "Voornaam",
      "registerPage.lastName": "Achternaam",
      "registerPage.phone": "Telefoonnummer",
      "registerPage.register": "Registreren",
      "registerPage.registrationSuccess": "Registratie succesvol! Je proefperiode is gestart.",
      "login.title": "🔐 Login",
      "login.email": "E-mailadres",
      "login.password": "Wachtwoord",
      "login.loginButton": "Inloggen",
      "login.noAccount": "Nog geen account?",
      "login.registerLink": "Registreren",
      "retailerMap.unnamed": "Naamloos",
      "retailerMap.dashboard": "Dashboard",
      "retailerMap.addressPlaceholder": "Typ een adres...",
      "retailerMap.flyButton": "Vlieg",
      "bundelSelector.title": "📦 Bundelbeheer",
      "bundelSelector.usage": "Je gebruikt momenteel {{active}} van {{max}} beschikbare interesses.",
      "bundelSelector.selectLabel": "Kies een nieuwe bundel:",
      "bundelSelector.option5": "5 panden (€22,50 / maand)",
      "bundelSelector.option15": "15 panden (€60 / maand)",
      "bundelSelector.option30": "30 panden (€100 / maand)",
      "bundelSelector.option100": "100 panden (€300 / maand)",
      "bundelSelector.upgradeButton": "Bundel upgraden via Stripe",
      "retailerProfile.title": "Retailer Profiel",
      "retailerProfile.backToDashboard": "Terug naar dashboard",
      "retailerProfile.aantalWinkels": "Aantal winkels",
      "retailerProfile.actiefInLanden": "Actief in landen",
      "retailerProfile.oprichtingsjaar": "Oprichtingsjaar",
      "retailerProfile.aantalMedewerkers": "Aantal medewerkers",
      "retailerProfile.omzetIndicatie": "Omzetindicatie",
      "retailerProfile.branche": "Branche",
      "retailerProfile.saveButton": "Opslaan",
      "interest.completeProfileFirst": "⚠️ Vul eerst je profiel in (minimaal 3 van de 6 velden).",
      "interest.confirmWithdraw": "❌ Interesse intrekken?",
      "interest.withdrawnSuccess": "✅ Interesse ingetrokken.",
      "interest.bundleFull": "❌ Je bundel is vol. Trek een interesse in of upgrade.",
      "interest.saved": "✅ Interesse opgeslagen.",
      "interest.noBundlePrompt": "ℹ️ Je hebt geen actieve interessebundel.\n\nTyp:\n  'bundle' om bundels te bekijken,\n  'pay' om €5 ex. btw te betalen voor deze locatie,\nof iets anders om te annuleren.",
      "interest.processing": "Bezig...",
      "interest.withdraw": "Trek interesse in",
      "interest.show": "Toon interesse",
      "documents.photoUpload.title": "Foto's",
      "documents.photoUpload.add": "Voeg foto's toe",
      "documents.photoUpload.remove": "Verwijder",
      "documents.rentDetails.title": "Huurgegevens",
      "documents.rentDetails.rent": "Huurprijs",
      "documents.rentDetails.startDate": "Ingangsdatum",
      "documents.rentDetails.expiryDate": "Expiratiedatum",
      "documents.rentDetails.indexationDate": "Indexatiedatum",
      "documents.rentDetails.terminationDate": "Opzegdatum",
      "documents.rentDetails.noticePeriod": "Opzegtermijn (maanden)",
      "documents.rentDetails.guaranteeType": "Garantie",
      "documents.rentDetails.guaranteeAmount": "Garantiebedrag",
      "documents.rentDetails.selectOption": "-- Selecteer --",
      "documents.rentDetails.securityDeposit": "Waarborgsom",
      "documents.rentDetails.bankGuarantee": "Bankgarantie",
      "brokerProperty.title": "Pandgegevens",
      "brokerProperty.commencementRent": "Aanvangshuurprijs",
      "brokerProperty.currentRent": "Huidige huurprijs",
      "brokerProperty.askingPrice": "Vraagprijs",
      "brokerProperty.keyMoney": "Overnamesom",
      "brokerProperty.commencementDate": "Ingangsdatum",
      "brokerProperty.expirationDate": "Expiratiedatum",
      "brokerProperty.indexationDate": "Indexatiedatum",
      "brokerProperty.terminationDate": "Opzegdatum",
      "brokerProperty.noticePeriod": "Opzegtermijn (maanden)",
      "brokerProperty.guarantee": "Garantie",
      "brokerProperty.select": "-- Selecteer --",
      "brokerProperty.securityDeposit": "Waarborgsom",
      "brokerProperty.bankGuarantee": "Bankgarantie",
      "brokerProperty.guaranteeAmount": "Garantiebedrag",
      "brokerProperty.purchasePrice": "Koopsom",
      "brokerProperty.landlord": "Eigenaar",
      "brokerProperty.purchaseYear": "Koopjaar",
      "brokerProperty.cadastralMunicipality": "Kadastrale gemeente",
      "brokerProperty.section": "Sectie",
      "brokerProperty.number": "Nummer",
      "brokerProperty.cadastralSize": "Kadastrale grootte",
      "comments.title": "Opmerkingen",
      "comments.none": "Geen opmerkingen toegevoegd.",
      "comments.placeholder": "Typ hier een nieuwe opmerking...",
      "comments.add": "Voeg opmerking toe",
      "huur.title": "Huurgegevens",
      "huur.rent": "Huurprijs",
      "huur.commencementDate": "Ingangsdatum",
      "huur.expirationDate": "Expiratiedatum",
      "huur.indexationDate": "Indexatiedatum",
      "huur.terminationDate": "Opzegdatum",
      "huur.noticePeriod": "Opzegtermijn (maanden)",
      "huur.guaranteeType": "Garantievorm",
      "huur.selecteer": "-- Selecteer --",
      "huur.securityDeposit": "Waarborgsom",
      "huur.bankGuarantee": "Bankgarantie",
      "huur.guaranteeAmount": "Garantiebedrag",
      "contact.title": "Contactpersonen",
      "contact.landlord": "Eigenaar",
      "contact.staff": "Personeel",
      "contact.broker": "Makelaar",
      "contact.name": "Naam",
      "contact.phone": "Telefoon",
      "contact.email": "E-mailadres",
      "contact.position": "Functie",
      "contact.remove": "Verwijderen",
      "contact.add": "Contactpersoon toevoegen",
      "brokerContact.title": "Contactgegevens (Broker)",
      "brokerComments.title": "Opmerkingen (Broker)",
      "brokerComments.noComments": "Nog geen opmerkingen toegevoegd.",
      "brokerComments.placeholder": "Typ hier je opmerking...",
      "brokerComments.add": "Opmerking toevoegen",
      "brokerPhotos.title": "Foto's (Broker)",
      "brokerPhotos.add": "Foto toevoegen",
      "brokerPhotos.remove": "Verwijder foto",
      "brokerPhotos.photo": "Foto",
      "brokerPhotos.tooLarge": "is te groot (max 10MB)",
      "brokerDocs.title": "Documenten (Broker)",
      "brokerDocs.add": "Document toevoegen",
      "brokerDocs.delete": "Verwijder document",
      "brokerDocs.tooLarge2": "is te groot (max 10MB)",
      "account.title": "Accountgegevens",
      "account.name": "Naam",
      "account.email": "E-mailadres",
      "account.phone": "Telefoonnummer",
      "account.address": "Adres",
      "account.website": "Website",
      "account.linkedin": "LinkedIn-profiel",
      "account.logo": "Logo",
      "account.chooseFile": "Kies een bestand",
      "account.selectedFile": "Gekozen bestand",
      "account.uploadLogo": "Upload logo",
      "account.save": "Opslaan",
      "account.saved": "✅ Accountgegevens opgeslagen",
      "account.saveSuccess": "✅ Accountgegevens succesvol opgeslagen",
      "account.saveFailed": "❌ Opslaan mislukt",
      "account.logoUploaded": "✅ Logo geüpload",
      "account.logoTooLarge": "Logo is te groot (max 2MB)",
      "account.noFileChosen": "Geen bestand gekozen",
      "account.loading": "Bezig met laden...",
      "account.invalidEmail": "Ongeldig e-mailadres",
      "account.invalidPhone": "Ongeldig telefoonnummer",
      "account.fetchError": "Fout bij ophalen profiel",
      "account.saveError": "Fout bij opslaan profiel",
      "account.logoUploadError": "Fout bij uploaden logo",
      "myInterests.title": "⭐ Mijn interesses",
      "myInterests.backToDashboard": "Terug naar dashboard",
      "myInterests.loading": "Interesses laden...",
      "myInterests.noResults": "Geen resultaten",
      "myInterests.ownInterests": "👤 Je eigen interesses",
      "myInterests.groupInterests": "👥 Interesses van je organisatie",
      "myInterests.country": "Land",
      "myInterests.city": "Stad",
      "myInterests.address": "Adres",
      "myInterests.currentRetailer": "Huidige retailer",
      "myInterests.date": "Datum",
      "myInterests.shownBy": "Getoond door",
      "myInterests.link": "Link",
      "myInterests.action": "Actie",
      "myInterests.remove": "Verwijder",
      "myInterests.removeSuccess": "✅ Interesse verwijderd",
      "myInterests.removeError": "❌ Fout bij verwijderen interesse",
      "broker.listingsTitle": "Mijn verhuuraanbod",
      "subscriptionPage.loading": "Laden...",
      "subscriptionPage.backToDashboard": "Terug naar dashboard",
      "subscriptionPage.title": "📦 Abonnement",
      "subscriptionPage.userSection.title": "👤 Gebruiker",
      "subscriptionPage.userSection.name": "Naam",
      "subscriptionPage.userSection.email": "Emailadres",
      "subscriptionPage.userSection.company": "Bedrijfsnaam",
      "subscriptionPage.userSection.kvk": "KVK nummer",
      "subscriptionPage.subscription.trialUntil": "📅 Proefperiode tot",
      "subscriptionPage.subscription.unknown": "Onbekend",
      "subscriptionPage.subscription.base": "📦 Basisabonnement",
      "subscriptionPage.subscription.perMonth": "per maand",
      "subscriptionPage.subscription.includes3": "inclusief 3 panden",
      "subscriptionPage.subscription.extra": "➕ Extra panden",
      "subscriptionPage.subscription.paidStart": "📆 Start betaald abonnement",
      "subscriptionPage.subscription.notStarted": "Nog niet gestart",
      "subscriptionPage.subscription.totalProperties": "🧾 Totaal aantal panden",
      "subscriptionPage.subscription.forRent": "🏷️ Te huur",
      "subscriptionPage.subscription.totalMonthly": "💰 Totale maandkosten",
      "subscriptionPage.subscription.renewsOn": "Abonnement wordt verlengd op",
      "subscriptionPage.subscription.note": "Opzegtermijn: 1 maand â€¢ Abonnement blijft actief tenzij je het hebt opgezegd.",
      "subscriptionPage.subscription.trialEnded": "Proefperiode beëindigd op",
      "owner.listingsPage.title": "Mijn verhuuraanbod",
      "owner.listingsPage.column.country": "Land",
      "owner.listingsPage.column.city": "Stad",
      "owner.listingsPage.column.address": "Adres",
      "owner.listingsPage.column.name": "Huidige huurder",
      "owner.listingsPage.column.website": "Website",
      "owner.listingsPage.column.owner": "Eigenaar",
      "owner.listingsPage.column.currentRetailer": "Huidige huurder",
      "owner.listingsPage.column.opdrachtgever": "Asset Manager",
      "owner.listingsPage.column.broker": "Makelaar",
      "owner.financieringBlock.title": "Financiele gegevens",
      "owner.financieringBlock.koopsom": "Koopsom",
      "owner.financieringBlock.aankoopdatum": "Aankoopdatum",
      "owner.financieringBlock.hypotheek": "Hypotheekbedrag",
      "owner.financieringBlock.rentepercentage": "Rentepercentage",
      "owner.financieringBlock.bank": "Bank",
      "owner.financieringBlock.looptijd": "Looptijd (jaren)",
      "owner.financieringBlock.jaar": "jaar",
      "owner.ownerFields.title": "Eigenaarsgegevens",
      "owner.ownerFields.parentCompany": "Eigenaar moedermaatschappij",
      "owner.ownerFields.owner": "Eigenaar",
      "owner.ownerFields.contactPerson": "Contactpersoon",
      "owner.ownerFields.email": "E-mailadres",
      "owner.ownerFields.phone": "Telefoonnummer",
      "owner.huurgegevensBlock.title": "Huurgegevens",
      "owner.huurgegevensBlock.formeleHuurder": "Formele huurder",
      "owner.huurgegevensBlock.huurprijs": "Huurprijs",
      "owner.huurgegevensBlock.ingangsdatum": "Ingangsdatum",
      "owner.huurgegevensBlock.expiratiedatum": "Expiratiedatum",
      "owner.huurgegevensBlock.resterendeLooptijdMaanden": "Resterende looptijd",
      "owner.huurgegevensBlock.huurtermijn": "Huurtermijn",
      "owner.huurgegevensBlock.verlengingsjaren": "Verlengingsjaren",
      "owner.huurgegevensBlock.huurvrijePeriodeMaanden": "Huurvrije periode",
      "owner.huurgegevensBlock.indexatiedatum": "Indexatiedatum",
      "owner.huurgegevensBlock.opzegdatum": "Opzegdatum",
      "owner.huurgegevensBlock.opzegtermijn": "Opzegtermijn",
      "owner.huurgegevensBlock.garantiesoort": "Garantiesoort",
      "owner.huurgegevensBlock.kiesOptie": "Kies optie",
      "owner.huurgegevensBlock.waarborgsom": "Waarborgsom",
      "owner.huurgegevensBlock.bankgarantie": "Bankgarantie",
      "owner.huurgegevensBlock.concerngarantie": "Concerngarantie",
      "owner.huurgegevensBlock.garantiebedrag": "Garantiebedrag",
      "owner.huurgegevensBlock.noGuarantee": "Geen garantie",
      "owner.contactgegevensBlock.title": "Contactgegevens",
      "owner.contactgegevensBlock.company": "Bedrijf",
      "owner.contactgegevensBlock.name": "Naam",
      "owner.contactgegevensBlock.phone": "Telefoon",
      "owner.contactgegevensBlock.email": "E-mail",
      "owner.contactgegevensBlock.function": "Functie",
      "owner.contactgegevensBlock.remove": "Contact verwijderen",
      "owner.contactgegevensBlock.add": "Contact toevoegen",
      "owner.photoUpload.title": "Foto's uploaden",
      "owner.photoUpload.add": "Foto toevoegen",
      "owner.photoUpload.remove": "Verwijderen",
      "owner.photoUpload.tooLarge": "is te groot (max 10MB)",
      "owner.opmerkingen.title": "Notities",
      "owner.opmerkingen.none": "Geen opmerkingen toegevoegd.",
      "owner.opmerkingen.unknownAuthor": "Onbekende auteur",
      "owner.opmerkingen.add": "Voeg opmerking toe",
      "owner.opmerkingen.placeholder": "Typ hier je opmerking...",
      "popup2.addedState": "Toegevoegd",
      "popup2.adding": "Toevoegen...",
      "popup2.extraPropertyTitle": "Extra pand toevoegen",
      "popup2.setForRent": "Zet te huur",
      "popup2.rentStatusActive": "Te huur (actief)",
      "popup2.rentActionErrorPrefix": "Fout bij wijzigen verhuurstatus: ",
      "popup2.rentConfirmTitle": "Pand te huur zetten",
      "popup2.rentConfirmDescription": "Door dit pand te huur te zetten, wordt het zichtbaar als verhuuraanbod. Normaal kost dit EUR 15 per maand, nu tijdelijk gratis.",
      "popup2.rentLaunchFree": "Nu gratis",
      "popup2.dontShowAgain": "Niet meer tonen",
      "propertyDetails.addCommentPlaceholder": "Voeg opmerking toe",
      "propertyDetails.contactName": "Naam",
      "propertyDetails.role": "Functie",
      "propertyDetails.phone": "Telefoon",
      "propertyDetails.email": "E-mailadres",
      "propertyDetails.addContact": "Contact toevoegen",
      "propertyDetails.contactpersonen": "Contactpersonen",
      "propertyDetails.delete": "Verwijderen",
      "propertyDetails.addDocument": "Document toevoegen",
      "propertyDetails.documentLabel": "Document",
      "propertyDetails.addPhoto": "Foto toevoegen",
      "propertyDetails.publicDataDivider": "Publieke Data",
      "propertyDetails.privateDataDivider": "Privégegevens",
      "propertyDetails.commentsDivider": "Notities",
      "propertyDetails.contactsDivider": "Contactpersonen",
      "propertyDetails.documentsDivider": "Documenten",
      "propertyDetails.photosDivider": "Fotos",
      "propertyDetails.floorplansDivider": "Plattegronden",
      "propertyDetails.addFloorplan": "Plattegrond toevoegen",
      "propertyDetails.removeFloorplan": "Plattegrond verwijderen",
      "propertyDetails.floorplansInfo": "Upload plattegronden als JPG of PNG. Deze tekeningen worden gebruikt in brochurelayouts. Pdf-bestanden kun je opslaan onder Documenten.",
      "propertyDetails.ownerData": "Eigenaarsgegevens",
      "propertyDetails.floorAreaTitle": "Metrage per verdieping (b.v.o.)",
      "propertyDetails.retailSurface": "Oppervlakte b.v.o",
      "propertyDetails.secondarySurface": "Secundaire oppervlakte",
      "propertyDetails.retailSpace": "Winkel",
      "propertyDetails.secondarySpace": "Secundair",
      "propertyDetails.sessionExpired": "Sessie verlopen, log opnieuw in.",
      "propertyDetails.removeField": "Veld verwijderen",
      "propertyDetails.removeFieldHint": "Eigen extra velden verwijder je door op het veld te dubbelklikken en daarna Veld verwijderen te kiezen.",
      "propertyDetails.autosave.saving": "Opslaan...",
      "propertyDetails.autosave.saved": "Opgeslagen",
      "propertyDetails.autosave.error": "Opslaan mislukt",
      "propertyDetails.autosave.active": "Autosave actief",
      "propertyDetails.popupSettings.open": "Open instellingen",
      "propertyDetails.popupSettings.hide": "Verberg instellingen",
      "propertyDetails.popupSettings.title": "Popup instellingen",
      "propertyDetails.popupSettings.description": "Kies welke velden zichtbaar zijn in de kaartpopup. Dit geldt voor standaardvelden en je eigen extra velden.",
      "propertyDetails.popupSettings.extraFields": "extra velden",
      "propertyDetails.popupSettings.noExtraFields": "Nog geen extra velden in deze sectie.",
      "propertyDetails.popupSettings.showInPopup": "Toon in popup",
      "propertyDetails.popupSettings.hideInPopup": "Verberg in popup",
      "propertyDetails.leaseTerm": "Huurtermijn (jaren)",
      "propertyDetails.extensionYears": "Verlengingsjaren",
      "propertyDetails.rentFreePeriodMonths": "Huurvrije periode (maanden)",
      "propertyDetails.front": "Front",
      "mapSettings.backToDashboard": "Terug naar dashboard",
      "mapSettings.title": "Kaartinstellingen",
      "mapSettings.subtitle": "Pas de kleuren van gebouwen en markernamen aan",
      "mapSettings.fetchWarn": "Kon instellingen niet ophalen",
      "mapSettings.noUser": "Geen gebruiker gevonden.",
      "mapSettings.invalidHex": "Ongeldige hexkleur. Gebruik bijv. #0077cc.",
      "mapSettings.saved": "Instellingen opgeslagen.",
      "mapSettings.saveFailed": "Opslaan mislukt.",
      "mapSettings.retailColorLabel": "Retailgebouwkleur",
      "mapSettings.retailColorPicker": "Kies retailgebouwkleur",
      "mapSettings.otherColorLabel": "Overige gebouwkleur",
      "mapSettings.otherColorPicker": "Kies overige gebouwkleur",
      "mapSettings.opacityLabel": "Opacity overige gebouwen: {{value}}",
      "mapSettings.opacityAria": "Opacity schuifregelaar",
      "mapSettings.markerNameColorLabel": "Marker naamkleur (normaal)",
      "mapSettings.markerNameColorPicker": "Kies marker naamkleur (normaal)",
      "mapSettings.markerNameHoverColorLabel": "Marker naamkleur (hover)",
      "mapSettings.markerNameHoverColorPicker": "Kies marker naamkleur (hover)",
      "mapSettings.previewRetail": "Retail highlight",
      "mapSettings.previewOther": "Overige gebouwen",
      "mapSettings.previewMarkerNormal": "Marker (normaal)",
      "mapSettings.previewMarkerHover": "Marker (hover)",
      "mapSettings.saving": "Opslaanâ€¦",
      "mapSettings.save": "Instellingen opslaan",
      "mapSettings.reset": "Reset naar standaard",
      "mapSettings.cancel": "Annuleren",
      "mapSettings.hexHelp": "Gebruik hex, bijv. #0077cc",
      "common.backToDashboard": "Terug naar dashboard",
      "requests.title": "Aanvragen",
      "requests.overview": "Overzicht",
      "requests.loading": "Laden...",
      "requests.none": "Geen aanvragen ontvangen voor jouw panden.",
      "requests.columns.location": "Locatie",
      "requests.columns.number": "Nr.",
      "requests.columns.city": "Stad",
      "requests.columns.address": "Adres",
      "requests.columns.tenant": "Huurder",
      "requests.columns.forRent": "Te huur",
      "requests.columns.total": "Totaal",
      "requests.columns.purchased": "Gekocht",
      "requests.columns.date": "Datum",
      "requests.columns.interestedParty": "Geïnteresseerde",
      "requests.columns.profile": "Profiel",
      "requests.columns.type": "Type",
      "requests.columns.actions": "Acties",
      "requests.interestTypes.forRent": "Te huur interesse",
      "requests.interestTypes.general": "Algemene interesse",
      "requests.profile.branch": "Branche",
      "requests.profile.shops": "Winkels",
      "requests.profile.countries": "Landen",
      "requests.profile.revenue": "Omzet",
      "requests.download": "Contactgegevens downloaden",
      "requests.downloadLabel": "Contactgegevens downloaden",
      "requests.payToView": "Contactgegevens tonen (€49)",
      "requests.payToViewLabel": "Contactgegevens tonen (€49)",
      "requests.shielded": "Afgeschermd",
      "requests.removeError": "Verwijderen van de aanvraag is niet gelukt.",
      "requests.paymentError": "Er is iets misgegaan bij het starten van de betaling.",
      "retailerProfile.back": "Terug",
      "retailerProfile.personalTab": "Persoonlijk profiel",
      "retailerProfile.companyTab": "Bedrijfsprofiel",
      "retailerProfile.firstName": "Voornaam",
      "retailerProfile.lastName": "Achternaam",
      "retailerProfile.function": "Functie",
      "retailerProfile.phone": "Telefoonnummer",
      "retailerProfile.email": "E-mailadres",
      "retailerProfile.linkedin": "LinkedIn-profiel",
      "retailerProfile.loading": "Laden...",
      "retailerProfile.loadingText": "Even geduld a.u.b...",
      "retailerProfile.success": "Profiel succesvol opgeslagen",
      "retailerProfile.error": "Opslaan mislukt",
      "retailerProfile.bedrijfsnaam": "Bedrijfsnaam",
      "retailerProfile.website": "Website",
      "retailerProfile.hoofdkantoor": "Hoofdkantoor",
      "retailerProfile.logo": "Logo",
      "retailerProfile.kvkNummer": "KvK-nummer",
      "retailerProfile.btwNummer": "BTW-nummer",
      "dashboard.myStores": "Mijn winkels",
      "myStores.title": "Mijn winkels",
      "myStores.ownStores": "Mijn winkels",
      "myStores.groupStores": "Winkels van mijn organisatie",
      "myStores.noResults": "Geen resultaten",
      "myStores.loading": "Laden...",
      "myStores.backToDashboard": "Terug naar dashboard",
      "myStores.nr": "Nr.",
      "myStores.city": "Stad",
      "myStores.address": "Adres",
      "myStores.name": "Naam winkel",
      "myStores.source": "Bron",
      "myStores.link": "Details",
      "myStores.country": "Land",
      "myStores.allCountries": "Alle landen",
      "myStores.allCities": "Alle steden",
      "retailerProperty.loading": "Winkel laden...",
      "retailerProperty.notFound": "Winkel niet gevonden",
      "retailerProperty.back": "Terug",
      "retailerProperty.address": "Adres",
      "retailerProperty.country": "Land",
      "retailerProperty.source": "Bron",
      "retailerProperty.publicDataDivider": "Publieke data",
      "retailerProperty.privateDataDivider": "Privé data",
      "retailerProperty.commentsDivider": "Opmerkingen",
      "retailerProperty.contactsDivider": "Contactpersonen",
      "retailerProperty.documentsDivider": "Documenten",
      "retailerProperty.photosDivider": "Foto's",
      "retailer.huurgegevensBlock.title": "Huurgegevens",
      "retailer.huurgegevensBlock.huurprijs": "Huurprijs",
      "retailer.huurgegevensBlock.ingangsdatum": "Ingangsdatum",
      "retailer.huurgegevensBlock.expiratiedatum": "Expiratiedatum",
      "retailer.huurgegevensBlock.indexatiedatum": "Indexatiedatum",
      "retailer.huurgegevensBlock.opzegdatum": "Opzegdatum",
      "retailer.huurgegevensBlock.opzegtermijn": "Opzegtermijn (maanden)",
      "retailer.huurgegevensBlock.garantiesoort": "Garantiesoort",
      "retailer.huurgegevensBlock.garantiebedrag": "Garantiebedrag",
      "retailer.huurgegevensBlock.kiesOptie": "Kies een optie",
      "retailer.huurgegevensBlock.waarborgsom": "Waarborgsom",
      "retailer.huurgegevensBlock.bankgarantie": "Bankgarantie",
      "retailer.huurgegevensBlock.concerngarantie": "Concerngarantie",
      "propertyDetails.extraFieldsDivider": "Extra velden",
      "propertyDetails.noComments": "Geen opmerkingen",
      "extraFieldsBlock.title": "Extra velden",
      "extraFieldsBlock.showInPopup": "Zichtbaar in popup",
      "extraFieldsBlock.addField": "Veld toevoegen",
      "extraFieldsBlock.addHeader": "Sectie toevoegen",
      "extraSections.titleLabel": "Titel",
      "extraSections.fieldLabel": "Veldnaam",
      "extraSections.fieldType": "Type",
      "extraSections.value": "Waarde",
      "extraSections.addField": "Veld toevoegen",
      "extraSections.addSection": "Sectie toevoegen",
      "extraSections.newTab": "Nieuw tabblad",
      "extraSections.tabName": "Naam tabblad",
      "extraSections.renameTab": "Tabblad hernoemen",
      "extraSections.untitledTab": "Naam tabblad",
      "extraSections.sectionName": "Naam sectie",
      "rentalData.addField": "Veld toevoegen",
      "financialData.addField": "Veld toevoegen",
      "addMarker.retailerName": "Naam winkel",
      "addMarker.unknownAddress": "Onbekend adres",
      "addMarker.unknownCity": "Onbekende stad",
      "owners.add.success": "Pand succesvol toegevoegd aan je portefeuille.",
      "owners.add.missingParameters": "Ontbrekende gegevens: e-mailadres of pand-ID.",
      "owners.add.invalidId": "Ongeldig pand-ID.",
      "owners.add.noAccess": "Alleen eigenaren kunnen panden toevoegen.",
      "owners.add.alreadyInMine": "Dit pand staat al in je eigen portefeuille.",
      "owners.add.alreadyInOrgPortfolio": "Dit pand staat al in de organisatieportefeuille.",
      "owners.add.extraRequiresPayment": "Voor dit extra pand is een aanvullende betaling vereist.",
      "owners.add.trialLimitReached": "Je proefperiode staat maximaal 3 panden toe. Activeer een abonnement om meer panden toe te voegen.",
      "owners.add.trialExpired": "Je proefperiode is verlopen. Activeer een abonnement om panden toe te voegen.",
      "owners.add.error": "Er is een fout opgetreden bij het toevoegen van het pand.",
      "retailerMap.paywall.title": "Je abonnement is verlopen",
      "retailerMap.paywall.body": "Activeer je abonnement om de kaart, panddetails en bewerkingen te gebruiken.",
      "retailerMap.paywall.activate": "Activeer abonnement",
      "retailerMap.paywall.openDashboard": "Open dashboard",
      "retailerMap.paywall.error.noJwt": "Je bent niet ingelogd. Log in om de kaart te gebruiken.",
      "retailerMap.paywall.error.sessionExpired": "Je sessie is verlopen. Log opnieuw in om verder te gaan.",
      "retailerMap.paywall.error.noSubscription": "Je hebt nog geen actief abonnement.",
      "retailerMap.paywall.error.accessDenied": "Je hebt geen toegang tot deze kaart.",
      "retailerMap.paywall.error.serverError": "Er is een interne fout opgetreden. Probeer het later opnieuw.",
      "retailerMap.paywall.error.network": "We konden je abonnement niet controleren. Controleer je internetverbinding of probeer het later opnieuw.",
      "retailerMap.paywall.error.trialExpired": "Je proefperiode is verlopen en er is geen actief abonnement. Activeer je abonnement om verder te gaan.",
      "subscriptionPage.subscription.forRentBackend": "🏷️ Te huur",
      "admin": {
        "common": {
          "openModule": "Open module",
          "refreshing": "Verversen...",
          "today": "Vandaag",
          "week": "Week",
          "month": "Maand",
          "year": "Jaar",
          "noData": "Nog geen data beschikbaar.",
          "unknown": "onbekend",
          "loading": "Laden...",
          "userLoadFailed": "Gebruiker kon niet worden geladen."
        },
        "dashboard": {
          "aiReview": "AI review"
        },
        "home": {
          "title": "Retailmaps Admin Ops",
          "subtitle": "Centrale beheerlaag voor mail, AI-review, statistieken en administratie. Dit is de plek waar agents, teams en operationele processen samenkomen.",
          "heroStats": {
            "openReview": "Open review",
            "inbox7d": "Inbox 7d",
            "activeLanguages": "Actieve talen",
            "agentLanes": "Agent lanes"
          },
          "sections": {
            "alerts": "Operationele alerts",
            "snapshot": "Operationele snapshot"
          },
          "alerts": {
            "reviewBacklog": {
              "label": "Review backlog",
              "text": "{{count}} threads wachten op beoordeling."
            },
            "draftsReady": {
              "label": "Drafts klaar",
              "text": "{{count}} drafts staan klaar om te reviewen."
            },
            "escalations": {
              "label": "Escalaties",
              "text": "{{count}} threads hebben handmatige opvolging nodig."
            },
            "stable": {
              "label": "Stabiel",
              "text": "Er zijn nu geen urgente operationele alerts."
            }
          },
          "snapshot": {
            "draftsReady": "{{count}} drafts klaar",
            "laneDistribution": "Lane-verdeling",
            "languages": "Talen",
            "reviewActions": "Review-acties",
            "approved": "Goedgekeurd",
            "edited": "Bewerkt",
            "escalated": "Geescaleerd",
            "rejected": "Afgewezen"
          },
          "modules": {
            "emailOps": {
              "title": "Email Agent Ops",
              "description": "Triage, review, drafts, kennisbank en escalaties voor alle inkomende Retailmaps-mails."
            },
            "aiQueue": {
              "title": "AI Wachtrij",
              "description": "Merkvalidatie en andere AI-gedreven reviewstromen die nog menselijke controle vragen."
            },
            "statistics": {
              "title": "Statistieken",
              "description": "Centraal overzicht van volumes, talen, responstijden, conversies en agentperformance."
            },
            "administration": {
              "title": "Administratie",
              "description": "Operationele backoffice voor facturatie, abonnementen, mailboxbeheer en interne processen."
            }
          }
        },
        "emailDashboard": {
          "title": "Email Agent Ops",
          "subtitle": "Beoordeel inkomende mail, verbeter drafts en laat de kennisbank groeien voor de rol-agents.",
          "refreshMetrics": "Metrics verversen",
          "badges": {
            "aiActive": "AI actief",
            "aiFallback": "AI fallback",
            "inboundActive": "Inbound actief",
            "inboundMissing": "Inbound ontbreekt"
          },
          "metrics": {
            "openReview": "Open review",
            "draftsReady": "Drafts klaar",
            "activeLanguages": "Actieve talen",
            "brokerLane": "Broker lane"
          },
          "helpers": {
            "openReview": "Threads die wachten op review of goedkeuring.",
            "draftsReady": "Drafts die nu klaarstaan om te versturen.",
            "activeLanguages": "Talen die momenteel in de inbox voorkomen.",
            "brokerLane": "Threads die nu naar de broker-agent zijn gerouteerd."
          }
        },
        "brandQueue": {
          "title": "AI Wachtrij",
          "pendingTitle": "Merken in beoordeling",
          "verifiedTitle": "Bevestigde merken",
          "reject": "Afkeuren",
          "columns": {
            "name": "Naam",
            "status": "Status",
            "createdAt": "Aangemaakt",
            "actions": "Acties",
            "group": "Groep",
            "domain": "Domein",
            "brands": "Merken"
          },
          "prompts": {
            "domain": "Domein voor {{name}}? (bijv. levi.com)",
            "group": "Groepsnaam / moederbedrijf voor {{name}}? (bijv. Levi Strauss & Co.)",
            "reject": "Weet je zeker dat je '{{name}}' wilt afkeuren?"
          }
        },
        "mailPanel": {
          "title": "Agent review inbox",
          "subtitle": "Beoordeel, bewerk en beantwoord inkomende mailgesprekken vanuit een centrale ops-inbox.",
          "refreshInbox": "Inbox verversen",
          "mode": "Modus",
          "threads": "threads",
          "messages": "berichten",
          "inbound": "inbound",
          "aiInactive": "AI staat uit, fallback-drafts worden gebruikt.",
          "quickFilters": {
            "all": "Alles",
            "broker": "Broker inbox",
            "retailer": "Retailer inbox",
            "owner": "Owner inbox",
            "support": "Support inbox",
            "router": "Router inbox"
          },
          "filters": {
            "search": "Zoeken",
            "lane": "Lane",
            "status": "Status",
            "agent": "Agent",
            "language": "Taal",
            "review": "Review",
            "all": "Alles",
            "allLanes": "Alle lanes",
            "allStatuses": "Alle statussen",
            "allAgents": "Alle agents",
            "allLanguages": "Alle talen",
            "onlyNeedsReview": "Alleen review nodig",
            "noReview": "Geen reviewfilter",
            "clear": "Filters wissen"
          },
          "inbox": "Inbox",
          "noSubject": "Geen onderwerp",
          "unknownSender": "Onbekende afzender",
          "noThreads": "Geen threads gevonden voor de huidige filters.",
          "threadDetail": "Threaddetail",
          "loadingThread": "Thread laden...",
          "agentLabel": "Agent",
          "languageLabel": "Taal",
          "statusLabel": "Status",
          "autoReplyEligible": "Geschikt voor auto-reply",
          "reviewRequired": "Review nodig",
          "lastActivity": "Laatste activiteit",
          "escalation": "Escalatie",
          "incomingMail": "Inkomende mail",
          "incomingFrom": "Inkomend van",
          "noPlainText": "Geen plain text body beschikbaar.",
          "agentDraft": "Agent draft",
          "subject": "Onderwerp",
          "reply": "Antwoord",
          "saveEditedAsKnowledge": "Bewerkte versie opslaan als kennisartikel",
          "sending": "Versturen...",
          "sendReply": "Verstuur antwoord",
          "approve": "Goedkeuren",
          "saveEdited": "Bewerkt opslaan",
          "escalate": "Escaleren",
          "reject": "Afwijzen",
          "feedbackProcessed": "Feedback succesvol verwerkt.",
          "feedbackFailed": "Feedback verwerken is mislukt.",
          "replySentVia": "Antwoord verstuurd naar {{recipient}} via {{provider}}.",
          "replySendFailed": "Antwoord versturen is mislukt.",
          "manualEscalationNote": "Handmatige escalatie aangevraagd vanuit admin review.",
          "noDraft": "Er is nog geen draft beschikbaar voor deze thread.",
          "selectThread": "Selecteer een thread om details en draft te bekijken.",
          "knowledgeBase": "Kennisbank",
          "knowledgeTitle": "Titel",
          "knowledgeContent": "Inhoud",
          "knowledgeKeywords": "Keywords (komma gescheiden)",
          "addKnowledgeArticle": "Kennisartikel toevoegen",
          "knowledgeSaved": "Kennisartikel opgeslagen.",
          "knowledgeSaveFailed": "Opslaan van kennisartikel is mislukt.",
          "noKnowledgeArticles": "Nog geen kennisartikelen beschikbaar."
        },
        "statistics": {
          "title": "Statistieken",
          "subtitle": "Live operations-overzicht van volumes, reviewdruk, talen en feedback op agentantwoorden.",
          "meta": {
            "generatedAt": "Gegenereerd om",
            "mailThreads": "Mailthreads",
            "activeInboxCountries": "Actieve inboxlanden"
          },
          "overview": {
            "users": "Gebruikers",
            "totalInterests": "Totaal interesses",
            "totalProperties": "Totaal panden",
            "activeForRent": "Actieve te-huur voorraad",
            "activeListings": "Actieve listings",
            "activeSubscriptions": "Actieve abonnementen"
          },
          "roles": {
            "admins": "Admins",
            "brokers": "Brokers",
            "retailers": "Retailers",
            "owners": "Owners"
          },
          "conversion": {
            "interestsPerActiveProperty": "Interesses per actief pand",
            "propertiesWithInterest": "Panden met interesse",
            "propertiesWithInterestShare": "Aandeel panden met interesse",
            "listingUnlockRate": "Listing unlock-rate",
            "contactUnlocks": "Contact unlocks",
            "unlockRevenue": "Unlock-omzet"
          },
          "manual": {
            "manualAddedToday": "Handmatig toegevoegd vandaag",
            "manualAddedMonth": "Handmatig toegevoegd deze maand",
            "manualEditedToday": "Handmatig gewijzigd vandaag",
            "manualEditedMonth": "Handmatig gewijzigd deze maand",
            "topCreators": "Top handmatige toevoegrs",
            "topEditors": "Top handmatige bewerkers"
          },
          "sections": {
            "rolesAndGrowth": "Rollen en groei",
            "accountsPerRole": "Accounts per rol",
            "newUsers": "Nieuwe gebruikers",
            "userCountries": "Gebruikerslanden",
            "userCountriesHelp": "Toplanden op basis van user- en bedrijfsprofieldata.",
            "interestsByPeriod": "Interesses per periode",
            "manualInteraction": "Handmatige systeeminteractie",
            "manualInteractionHelp": "Gebruikersacties waarbij panden handmatig zijn toegevoegd of gewijzigd.",
            "heatmapHotspots": "Interesse-hotspots",
            "heatmapHotspotsHelp": "Top stad-landcombinaties op basis van geregistreerde interesses.",
            "interestsByCity": "Interesses per stad",
            "propertiesAdded": "Panden toegevoegd",
            "topPropertyCountries": "Toplanden in de pandendatabase",
            "activeForRentStock": "Actieve te-huur voorraad",
            "conversionSignals": "Conversie & commerciele signalen",
            "agentMailContext": "Agent mail context"
          }
        },
        "administration": {
          "title": "Administratie",
          "subtitle": "Operationele backoffice voor mail-health, omgevingsstatus en interne gereedheid.",
          "sections": {
            "mailInfrastructure": "Mailinfrastructuur",
            "healthCheck": "Health-check",
            "operationalStatus": "Operationele status",
            "roadmap": "Volgende backoffice-stappen"
          },
          "fields": {
            "provider": "Provider",
            "from": "Van",
            "frontendUrl": "Frontend URL",
            "internalInboxes": "Interne inboxen",
            "testRecipient": "Testontvanger"
          },
          "health": {
            "mailProvider": "Mailprovider",
            "mailProviderActive": "{{provider}} actief",
            "notConfigured": "Niet geconfigureerd",
            "inboundAgent": "Inbound agent",
            "inboundActive": "Inbound receiving actief",
            "inboundMissing": "Inbound receiving niet geconfigureerd",
            "aiClassification": "AI-classificatie",
            "aiActive": "OpenAI actief",
            "fallbackOnly": "Alleen fallback",
            "internalInboxes": "Interne inboxen",
            "internalRecipientsConfigured": "{{count}} interne ontvangers geconfigureerd",
            "noInternalRecipients": "Geen interne ontvangers geconfigureerd",
            "actionNeeded": "Actie nodig"
          },
          "status": {
            "threads": "Threads",
            "openReview": "Open review",
            "draftsReady": "Drafts klaar",
            "escalations": "Escalaties"
          },
          "roadmap": {
            "subscriptions": "Abonnements- en facturatiebeheer per rol",
            "mailboxes": "Mailboxrouting en aliasbeheer",
            "internalNotifications": "Voorkeuren voor interne notificaties",
            "billing": "Facturatie-export en factuuroverzichten",
            "escalations": "Escalatieregels en SLA-monitoring",
            "agentPolicies": "Agent policies en rolspecifieke automatiseringen",
            "footer": "Deze pagina is bewust operationeel opgezet en groeit uit tot de centrale Retailmaps backoffice."
          }
        }
      },
      "dashboardOverlay": {
        "shared": {
          "forRent": "Te huur",
          "requests": "Aanvragen",
          "alerts": "Alerts",
          "analysis": "Analyse",
          "assistant": "Hoe werkt het?",
          "settings": "Instellingen"
        },
        "owner": {
          "properties": "Panden",
          "forRent": "Te huur"
        },
        "retailer": {
          "stores": "Winkels",
          "interests": "Interesses"
        },
        "broker": {
          "properties": "Panden"
        },
        "admin": {
          "ops": "Ops",
          "mail": "Mail",
          "aiQueue": "AI Wachtrij",
          "statistics": "Statistieken",
          "administration": "Administratie"
        }
      },
      "retailerMap.loading.zoomInToLoad": "Zoom in tot {{zoom}} om retailers te laden",
      "retailerMap.loading.fillingStreet": "Nieuwe panden laden. Dit kan tot 2 min duren...",
      "retailerMap.loading.paintingFromCenter": "Panden laden vanaf het midden...",
      "retailerMap.errors.invalidSession": "Geen geldige sessie gevonden. Log opnieuw in.",
      "retailerMap.errors.noUserInfo": "Geen gebruikersinformatie beschikbaar.",
      "retailerMap.errors.unknownRoleSubscription": "Onbekende gebruikersrol. Abonnement kan niet worden gestart.",
      "settingsPanel": {
        "common": {
          "saving": "Opslaan...",
          "saved": "Opgeslagen",
          "saveFailed": "Opslaan mislukt",
          "ready": "Gereed"
        },
        "regional": {
          "title": "Regionale voorkeuren",
          "subtitle": "Kies hoe taal, valuta en eenheden werken. Browser- en regiogegevens worden automatisch gebruikt.",
          "language": "Taal",
          "currency": "Valuta",
          "units": "Eenheden",
          "autoLanguage": "Automatisch ({{language}})",
          "autoCurrency": "Automatisch ({{currency}})",
          "autoUnits": "Automatisch ({{units}})",
          "metric": "Metrisch",
          "imperial": "Imperiaal",
          "detectedRegion": "Gedetecteerde regio: {{region}}"
        },
        "mailTest": {
          "title": "Testmail",
          "subtitle": "Controleer of de mailinstellingen goed werken.",
          "send": "Testmail versturen",
          "sending": "Versturen...",
          "status": "Status: {{status}}",
          "providerActive": "{{provider}} actief",
          "devPreviewOnly": "Alleen dev-preview",
          "from": "Van: {{value}}",
          "testRecipient": "Testontvanger: {{value}}",
          "internalInboxes": "Interne inboxen: {{value}}",
          "noneConfigured": "Geen ingesteld",
          "notConfigured": "Niet ingesteld",
          "previewLogged": "{{provider}} is nog niet volledig ingesteld. De testmail is als preview gelogd voor {{recipient}}.",
          "sentMessage": "Testmail verstuurd naar {{recipient}} via {{provider}}.",
          "failed": "Testmail versturen is mislukt.",
          "yourInbox": "je inbox"
        },
        "map": {
          "title": "Kaartvoorkeuren",
          "subtitle": "Pas kleuren, outlines, labels en zichtbaarheid van de kaart aan.",
          "invalidOrSaveFailed": "Ongeldige kleur of opslaan mislukt.",
          "highlight": {
            "title": "Highlight intensiteit",
            "description": "Bepaalt hoe sterk actieve polygonen en selecties opvallen.",
            "retailTitle": "Winkelpanden highlight intensiteit",
            "retailDescription": "Bepaalt hoe sterk winkelpanden oplichten op de kaart.",
            "otherTitle": "Overige panden intensiteit",
            "otherDescription": "Bepaalt hoe zichtbaar overige panden als achtergrondlaag zijn.",
            "opacity": "Intensiteit: {{value}}"
          },
          "markerFont": {
            "title": "Lettergrootte markers",
            "description": "Bepaalt hoe groot namen en labels op de kaart worden getoond.",
            "size": "Schaal: {{value}}"
          },
          "preview": {
            "title": "Preview",
            "description": "Een snelle indicatie van hoe je kaartinstellingen eruitzien."
          },
          "colors": {
            "retail": {
              "label": "Retailkleur",
              "description": "Basiskleur voor winkelpanden op de kaart."
            },
            "other": {
              "label": "Overige panden",
              "description": "Basiskleur voor overige panden op de kaart."
            },
            "retailOutline": {
              "label": "Outline actieve panden",
              "description": "Randkleur voor actieve panden en highlights."
            },
            "otherOutline": {
              "label": "Outline overige panden",
              "description": "Randkleur voor niet-actieve panden."
            },
            "markerName": {
              "label": "Marker naamkleur",
              "description": "Tekstkleur voor labels op de kaart."
            },
            "markerHover": {
              "label": "Hover kleur",
              "description": "Achtergrondkleur wanneer je over labels beweegt."
            },
            "forRentMarker": {
              "label": "Te huur marker",
              "description": "Tekstkleur van markers voor panden die te huur staan."
            }
          }
        },
        "retailerMap.loading.zoomInToLoad": "Zoom in tot {{zoom}} om retailers te laden",
        "retailerMap.loading.fillingStreet": "Nieuwe panden laden. Dit kan tot 2 min duren...",
        "retailerMap.loading.paintingFromCenter": "Panden schilderen vanaf het midden...",
        "retailerMap.errors.invalidSession": "Geen geldige sessie gevonden. Log opnieuw in.",
        "retailerMap.errors.noUserInfo": "Geen gebruikersinformatie beschikbaar.",
        "retailerMap.errors.unknownRoleSubscription": "Onbekende gebruikersrol. Abonnement kan niet worden gestart.",
        "dashboardOverlay.owner.properties": "Panden",
        "dashboardOverlay.owner.forRent": "Te huur",
        "dashboardOverlay.shared.requests": "Aanvragen",
        "dashboardOverlay.shared.alerts": "Alerts",
        "dashboardOverlay.shared.analysis": "Analyse",
        "dashboardOverlay.shared.assistant": "Assistent",
        "dashboardOverlay.shared.settings": "Instellingen",
        "myProperties.nr": "Nr.",
        "myProperties.city": "Stad",
        "myProperties.address": "Adres",
        "myProperties.tenant": "Huurder",
        "myProperties.link": "Details",
        "myProperties.status": "Status",
        "myProperties.actions": "Acties",
        "myProperties.assetManager": "Assetmanager",
        "myProperties.noAssetManager": "â€” geen â€”",
        "myProperties.noResults": "Geen resultaten",
        "myProperties.ownProperties": "Mijn panden",
        "myProperties.groupProperties": "Organisatieportefeuille",
        "myProperties.stopRent": "Stop verhuur",
        "myProperties.setForRent": "Zet te huur",
        "myProperties.street": "Straat",
        "myProperties.allCities": "Alle steden",
        "myProperties.allStreets": "Alle straten",
        "myProperties.status.forRent": "Te huur",
        "myProperties.status.rented": "Verhuurd",
        "myProperties.bulk.assignToSelection": "Toewijzen aan selectie",
        "myProperties.bulk.onlyUnassigned": "Alleen zonder assetmanager",
        "myProperties.bulk.selectAllVisible": "Alles selecteren",
        "myProperties.bulk.noManagerSelected": "Kies een assetmanager.",
        "myProperties.bulk.noSelection": "Geen panden geselecteerd.",
        "myProperties.loading": "Laden...",
        "myProperties.assignToMe": "Naar mij",
        "myProperties.view": "Bekijken",
        "myProperties.assignError": "Toewijzen mislukt.",
        "myProperties.claimSuccess": "Pand toegevoegd aan je portefeuille.",
        "myProperties.claimError": "Toevoegen mislukt.",
        "myProperties.rentToggleError": "Wijzigen van verhuurstatus mislukt.",
        "myProperties.subscription.required": "Voor deze actie is een actief abonnement nodig.",
        "myProperties.subscription.badge": "Owner-abonnement",
        "myProperties.subscription.title": "Klaar voor je volgende pand",
        "myProperties.subscription.description": "Je trial bevat 3 panden. Voor het volgende pand via de organisatie activeer je het owner-abonnement, waarna je direct verder kunt.",
        "myProperties.subscription.activate": "Activeer owner-abonnement",
        "myProperties.subscription.sessionError": "Kan Stripe sessie niet starten.",
        "myProperties.subscription.stripeMissing": "Stripe.js niet geladen.",
        "myProperties.subscription.startError": "Kon abonnement niet starten.",
        "requests.branches.fashionAndApparel": "Kleding en mode",
        "requests.branches.footwear": "Schoenen",
        "requests.branches.foodAndBeverage": "Food en beverage",
        "requests.branches.beautyAndPersonalCare": "Beauty en persoonlijke verzorging",
        "requests.branches.jewelleryAndWatches": "Juwelen en horloges",
        "requests.branches.supermarketAndGrocery": "Supermarkt en boodschappen",
        "requests.branches.electronics": "Elektronica",
        "requests.branches.homeAndLiving": "Wonen en interieur",
        "requests.branches.sportsAndOutdoor": "Sport en outdoor",
        "requests.branches.booksAndMedia": "Boeken en media",
        "common.cancel": "Annuleren",
        "countries.nl": "Nederland",
        "countries.be": "België",
        "countries.de": "Duitsland",
        "countries.fr": "Frankrijk",
        "countries.gb": "Verenigd Koninkrijk",
        "countries.es": "Spanje",
        "countries.it": "Italië",
        "branding": {
          "title": "Broker branding",
          "subtitle": "Upload je logo. Dit wordt zichtbaar bij jouw listings."
        },
        "dashboardOverlay": {
          "shared": {
            "assistant": "Hoe werkt het?"
          }
        },
        "retailerMap": {
          "loading": {
            "zoomInToLoad": "Zoom in tot {{zoom}} om retailers te laden",
            "fillingStreet": "Nieuwe panden laden. Dit kan tot 2 min duren...",
            "paintingFromCenter": "Panden laden vanaf het midden..."
          }
        }
      },
      "common.back": "Terug",
      "common.save": "Opslaan",
      "common.busy": "Bezig...",
      "propertyDrawer.title": "Panddetails",
      "propertyDrawer.loadFailed": "Kon panddetails niet laden.",
      "propertyDrawer.openInNewTab": "Open in nieuw tabblad",
      "propertyDrawer.address": "Adres",
      "propertyDrawer.status": "Status",
      "propertyDrawer.forRent": "Te huur",
      "propertyDrawer.rented": "Verhuurd",
      "propertyDrawer.assetManager": "Assetmanager",
      "propertyDrawer.openInMaps": "Open in Maps",
      "interestButton.invalidSession": "Geen geldige sessie.",
      "interestButton.withdraw": "Intrekken",
      "interestButton.showInterest": "Toon interesse",
      "retailerMap.printTooltip": "Kies hoe je de kaart wilt exporteren",
      "retailerMap.print": "Afdrukken",
      "retailerMap.openStreetView": "Open Street View",
      "retailerMap.closeStreetView": "Sluit Street View",
      "retailerMap.streetView": "Street View",
      "retailerMap.zoomIn": "Inzoomen",
      "retailerMap.zoomOut": "Uitzoomen",
      "retailerMap.highlightEdit.dragHint": "Versleep punten, verwijder punten of voeg een punt toe.",
      "retailerMap.highlightEdit.selectHint": "Klik op een blauwe highlight om te bewerken.",
      "retailerMap.highlightEdit.adminHint": "Admin-tool voor foutieve gebouwvormen.",
      "retailerMap.highlightEdit.disable": "Bewerkmodus uit",
      "retailerMap.highlightEdit.edit": "Highlight bewerken",
      "retailerMap.highlightEdit.merge": "Samenvoegen",
      "retailerMap.highlightEdit.reset": "Reset",
      "retailerMap.highlightEdit.mergeHint": "Selecteer minimaal twee blauwe highlights. Geselecteerd: {{count}}",
      "retailerMap.highlightEdit.mergeNow": "Voeg samen",
      "retailerMap.highlightEdit.buildingId": "Building ID",
      "retailerMap.highlightEdit.addPoint": "Punt toevoegen",
      "retailerMap.highlightEdit.removePoint": "Punt weg",
      "retailerMap.highlightEdit.makeOneShape": "Maak 1 vlak",
      "retailerMap.highlightEdit.removeCorrection": "Correctie verwijderen",
      "retailerMap.highlightEdit.restore": "Herstel highlight",
      "propertyList.filters.city": "Stad",
      "propertyList.filters.street": "Straat",
      "propertyList.filters.retailer": "Retailer",
      "propertyList.filters.select": "Selecteer...",
      "propertyList.filters.typeStreet": "Typ straat...",
      "propertyList.filters.chooseCityFirst": "Kies eerst een stad",
      "propertyList.filters.noStreets": "Geen straten gevonden",
      "propertyList.filters.cityRequiredForStreet": "Vul eerst een stad in om straten te kiezen.",
      "propertyList.filters.retailerExample": "Bijv. Suit Supply",
      "propertyList.filters.retailerExampleShort": "Retailer",
      "propertyList.filters.searchAddress": "Zoek adres",
      "propertyList.filters.scopeHint": "Kies een straat of zoek op retailer om de pandenlijst te laden.",
      "propertyList.loading": "Panden laden...",
      "propertyList.noPropertiesFound": "Geen panden gevonden",
      "propertyList.openDetails": "Details openen",
      "propertyList.pagination.rowsPerPage": "Rijen per pagina",
      "propertyList.columns.number": "Nr.",
      "propertyList.columns.country": "Land",
      "propertyList.columns.city": "Stad",
      "propertyList.columns.address": "Adres",
      "propertyList.columns.retailer": "Retailer",
      "propertyList.columns.status": "Status",
      "propertyList.columns.showInterest": "Interesse tonen",
      "propertyList.columns.details": "Details",
      "propertyList.columns.analysis": "Analyse",
      "propertyList.columns.interests": "Interesses",
      "propertyList.columns.purchased": "Gekocht",
      "propertyList.columns.rental": "Verhuur",
      "propertyList.status.forRent": "Te huur",
      "propertyList.status.notForRent": "Niet te huur",
      "propertyList.interests.none": "Geen interesses",
      "propertyList.interests.date": "Datum",
      "propertyList.interests.interestedParty": "Geinteresseerde",
      "propertyList.interests.type": "Type",
      "propertyList.interests.branch": "Branche",
      "propertyList.interests.stores": "Winkels",
      "propertyList.interests.contactDetails": "Contactgegevens",
      "propertyList.interests.protected": "Afgeschermd",
      "propertyList.interests.forRentInterest": "Te huur interesse",
      "propertyList.interests.generalInterest": "Algemene interesse",
      "propertyList.interests.downloadContact": "Download contactgegevens",
      "propertyList.interests.buyContact": "Koop contactgegevens (EUR 9)",
      "propertyList.interests.interest": "Interesse",
      "propertyList.contactPurchase.title": "Contactgegevens kopen",
      "propertyList.contactPurchase.description": "Je koopt de contactgegevens van deze interesse.",
      "propertyList.contactPurchase.invoiceNotice": "De kosten worden apart gefactureerd.",
      "propertyList.contactPurchase.buy": "Koop contactgegevens",
      "retailerMap": {
        "loading": {
          "stores": "Winkels laden...",
          "zoomInToLoad": "Zoom in tot {{zoom}} om retailers te laden",
          "fillingStreet": "Nieuwe panden laden. Dit kan tot 2 min duren...",
          "paintingFromCenter": "Panden laden vanaf het midden..."
        },
        "dashboard": "Dashboard"
      },
      "popup2": {
        "interestConfirmBody": "Deze interesse wordt opgeslagen op dit pand en toegevoegd aan je overzicht. Zolang je binnen je proeflimiet of actieve toegang zit, worden er geen extra kosten in rekening gebracht. Als betaling nodig is, vragen we dat apart voordat er kosten ontstaan.",
        "skipConfirmation": "Deze bevestiging voortaan overslaan",
        "addedState": "Toegevoegd",
        "addToMyProperties": "Toevoegen aan mijn panden",
        "front": "Front",
        "groundFloor": "Begane grond",
        "basement": "Kelder",
        "firstFloor": "1e verdieping",
        "secondFloor": "2e verdieping",
        "thirdFloor": "3e verdieping",
        "entresol": "Entresol",
        "soussol": "Sous-sol",
        "retailSpace": "Winkel",
        "secondarySpace": "Secundair",
        "adding": "Toevoegen...",
        "publicData": "Openbare gegevens",
        "privateData": "Privégegevens",
        "surface": "Oppervlakte"
      },
      "subscriptionRequired": {
        "title": "Abonnement vereist",
        "body": "Om een pand te huur te zetten op Retailmaps heb je een actief abonnement nodig.",
        "details": "Met een abonnement kun je panden te huur zetten en zichtbaar maken voor alle gebruikers op het platform of specifieke groepen.",
        "activate": "Activeer abonnement"
      },
      "security": {
        "password": "Wachtwoord",
        "errors": {
          "statusFailed": "Kon de beveiligingsstatus niet ophalen.",
          "setupFailed": "Kon 2FA-setup niet starten.",
          "enableFailed": "Kon 2FA niet inschakelen.",
          "disableFailed": "Kon 2FA niet uitschakelen."
        },
        "notices": {
          "enabled": "2FA is ingeschakeld voor je account.",
          "disabled": "2FA is uitgeschakeld voor je account."
        },
        "twoFactor": {
          "title": "Twee-factor-authenticatie",
          "subtitle": "Bescherm je account met een 6-cijferige code uit een authenticator-app.",
          "setup": "2FA instellen",
          "scanQr": "Scan de QR-code met je authenticator-app. Lukt dat niet, gebruik dan de setup-code handmatig.",
          "openAuthenticator": "Open in authenticator-app",
          "sixDigitCode": "6-cijferige code",
          "enable": "2FA inschakelen",
          "disableWarning": "Schakel 2FA alleen uit als je zeker weet dat dit account op een andere manier goed beschermd is.",
          "code": "2FA-code",
          "disable": "2FA uitschakelen"
        }
      },
      "auth": {
        "twoFactor": {
          "prompt": "Vul de 6-cijferige code uit je authenticator-app in.",
          "backToPassword": "Terug naar wachtwoord"
        }
      },
      "mapSettings": {
        "activeOutlineLabel": "Outline actieve panden",
        "otherOutlineLabel": "Outline overige panden",
        "markerNameColorLabel": "Marker naamkleur",
        "hoverColorLabel": "Hover kleur",
        "backToDashboard": "Terug naar dashboard",
        "title": "Kaartinstellingen",
        "subtitle": "Pas de kleuren van gebouwen en markernamen aan",
        "fetchWarn": "Kon instellingen niet ophalen",
        "noUser": "Geen gebruiker gevonden.",
        "invalidHex": "Ongeldige hexkleur. Gebruik bijv. #0077cc.",
        "saved": "Instellingen opgeslagen.",
        "saveFailed": "Opslaan mislukt.",
        "retailColorLabel": "Retailgebouwkleur",
        "retailColorPicker": "Kies retailgebouwkleur",
        "otherColorLabel": "Overige gebouwkleur",
        "otherColorPicker": "Kies overige gebouwkleur",
        "opacityLabel": "Opacity overige gebouwen: {{value}}",
        "opacityAria": "Opacity schuifregelaar",
        "markerNameColorPicker": "Kies marker naamkleur",
        "markerNameHoverColorLabel": "Marker hoverkleur",
        "markerNameHoverColorPicker": "Kies marker hoverkleur",
        "previewRetail": "Retail highlight",
        "previewOther": "Overige gebouwen",
        "previewMarkerNormal": "Marker normaal",
        "previewMarkerHover": "Marker hover",
        "saving": "Opslaan...",
        "save": "Instellingen opslaan",
        "reset": "Reset naar standaard",
        "cancel": "Annuleren",
        "hexHelp": "Gebruik hex, bijv. #0077cc"
      },
      "retailerProfile": {
        "personalTitle": "Persoonlijk profiel",
        "companyTitle": "Bedrijfsprofiel",
        "autosaveHint": "Wijzigingen worden automatisch opgeslagen.",
        "companyProtectedHint": "Bedrijfsgroep en bedrijfsnaam zijn leidend voor AI-profielen en interne koppelingen en blijven daarom beschermd.",
        "parentCompany": "Moedermaatschappij",
        "company": "Bedrijf",
        "companyName": "Bedrijfsnaam",
        "name": "Naam",
        "legalName": "Juridische naam",
        "headquartersAddress": "Hoofdkantooradres",
        "headquartersPostalCode": "Postcode hoofdkantoor",
        "headquartersCity": "Plaats hoofdkantoor",
        "headquartersCountry": "Land hoofdkantoor",
        "industry": "Branche",
        "organization": "Organisatie",
        "foundingYear": "Oprichtingsjaar",
        "storeCount": "Aantal winkels",
        "activeCountries": "Actief in landen",
        "employeeCount": "Aantal medewerkers",
        "revenueIndication": "Omzetindicatie",
        "billingHint": "Handig voor abonnementen, facturen en interne administratie.",
        "billingEmail": "Factuur e-mail",
        "invoiceReference": "Factuurreferentie / PO",
        "billingAddress": "Factuuradres",
        "chamberOfCommerceNumber": "KVK-nummer",
        "vatNumber": "BTW-nummer",
        "postalCode": "Postcode",
        "city": "Plaats",
        "country": "Land"
      },
      "paidInterest": {
        "title": "Extra interesse",
        "bodyPrefix": "Deze interesse kost",
        "price": "€5 ex. btw per maand",
        "bodySuffix": "en wordt toegevoegd aan je abonnement. Je kunt deze interesse later altijd weer intrekken.",
        "confirm": "Akkoord en doorgaan",
        "paymentStartFailed": "Fout bij starten betaling."
      },
      "forRentTab": {
        "selectActingRole": "Geef aan namens wie je verhuurt.",
        "created": "Pand staat nu te huur.",
        "updated": "Listing aangepast.",
        "updateFailed": "Aanpassen mislukt.",
        "confirmDelete": "Weet je zeker dat je de verhuurlisting wilt verwijderen?",
        "deleteFailed": "Verwijderen mislukt.",
        "listProperty": "Zet pand te huur",
        "missingData": "Ontbrekende gegevens voor te huur zetten.",
        "activateFailed": "Te huur zetten is niet gelukt.",
        "activating": "Te huur zetten wordt geactiveerd..."
      },
      "requests": {
        "empty": "Geen aanvragen",
        "removeFailed": "Verwijderen van de aanvraag is niet gelukt.",
        "total": "Totaal",
        "purchased": "Gekocht",
        "date": "Datum",
        "interestedParty": "Geinteresseerde",
        "hidden": "Afgeschermd",
        "downloadContact": "Download contactgegevens",
        "buyContact": "Koop contactgegevens (€49)",
        "interests": "Interesses",
        "interestTypes": {
          "forRent": "Te huur interesse",
          "general": "Algemene interesse"
        }
      },
      "verifyEmail": {
        "loadingMessage": "We bevestigen je e-mailadres...",
        "invalidLink": "Deze verificatielink is ongeldig.",
        "successMessage": "Je e-mailadres is bevestigd. Log in om Retailmaps te openen.",
        "failedMessage": "Verificatie is niet gelukt.",
        "expiredOrInvalid": "Deze verificatielink is verlopen of ongeldig.",
        "successTitle": "E-mailadres bevestigd",
        "failedTitle": "Verificatie mislukt",
        "checkingTitle": "Even controleren",
        "backToLogin": "Terug naar inloggen",
        "openLogin": "Inloggen en Retailmaps openen"
      },
      "propertyDetails": {
        "floors": {
          "ground": "Begane grond",
          "basement": "Kelder",
          "first": "1e verdieping",
          "second": "2e verdieping",
          "third": "3e verdieping",
          "entresol": "Entresol",
          "soussol": "Sous-sol"
        },
        "frontWidth": "Frontbreedte",
        "rentalData": "Huurgegevens",
        "financialData": "Financiele gegevens",
        "ownerData": "Eigenaarsgegevens",
        "commentsDivider": "Notities",
        "contactsDivider": "Contactpersonen",
        "photosDivider": "Fotos",
        "floorplansDivider": "Plattegronden",
        "documentsDivider": "Documenten",
        "objectInfoDivider": "Objectinformatie",
        "floorplansInfo": "Upload plattegronden als JPG of PNG. Deze tekeningen worden gebruikt in brochurelayouts. Pdf-bestanden kun je opslaan onder Documenten.",
        "addFloorplan": "Plattegrond toevoegen",
        "removeFloorplan": "Plattegrond verwijderen",
        "addObjectInfo": "Objectinformatie toevoegen",
        "notesDivider": "Notities",
        "datePlaceholder": "dd-mm-jjjj",
        "addContact": "Contact toevoegen",
        "removeField": "Veld verwijderen",
        "removeFieldHint": "Eigen extra velden verwijder je door op het veld te dubbelklikken en daarna Veld verwijderen te kiezen.",
        "popupSettings": {
          "open": "Open instellingen",
          "hide": "Verberg instellingen",
          "title": "Popup instellingen",
          "description": "Kies welke velden zichtbaar zijn in de kaartpopup. Dit geldt voor standaardvelden en je eigen extra velden.",
          "extraFields": "extra velden",
          "noExtraFields": "Nog geen extra velden in deze sectie.",
          "showInPopup": "Toon in popup",
          "hideInPopup": "Verberg in popup"
        },
        "askingRentPrice": "Vraaghuurprijs",
        "serviceCosts": "Servicekosten",
        "takeoverPrice": "Overnamesom",
        "availableFrom": "Beschikbaar per",
        "back": "Terug naar overzicht",
        "projectInfoDivider": "Projectinformatie",
        "addProjectInfo": "Projectinformatie toevoegen"
      },
      "help": {
        "subtitle": "Korte uitleg bij veelgebruikte acties in Retailmaps.",
        "howItWorks": "Zo werkt het",
        "goodToKnow": "Goed om te weten",
        "empty": "Er zijn nog geen onderwerpen voor deze rol.",
        "actions": {
          "openListings": "Open Te huur",
          "openInterests": "Open Interesses",
          "openProperties": "Open Panden",
          "openAlerts": "Open Alerts",
          "openRequests": "Open Aanvragen",
          "openAnalysis": "Open Analyse"
        },
        "topics": {
          "ownerForRent": {
            "title": "Pand te huur zetten",
            "summary": "Publiceer een pand als verhuuraanbod en voeg de juiste informatie toe.",
            "step1": "Open de tab Panden.",
            "step2": "Zoek het pand dat je wilt aanbieden.",
            "step3": "Klik op Zet te huur.",
            "step4": "Open Te huur en vul de vraagprijs, het sleutelgeld en de beschikbaarheidsdatum aan.",
            "step5": "Controleer gegevens die al zijn overgenomen, zoals huidige huurprijs en expiratiedatum.",
            "step6": "Voeg projectinformatie toe. Je kunt zelf een brochure uploaden of automatisch projectinformatie laten maken.",
            "note1": "Als eigenaar hoef je geen zichtbaarheid te kiezen. Het pand wordt automatisch zichtbaar als verhuuraanbod.",
            "note2": "Automatische projectinformatie gebruikt de ingevulde gegevens, foto's, plattegronden en een kaartbeeld."
          },
          "retailerStore": {
            "title": "Winkel aan mijn winkels koppelen",
            "summary": "Voeg een bestaande locatie toe aan jouw winkeloverzicht.",
            "step1": "Open de tab Winkels.",
            "step2": "Zoek de winkel via land, stad of adres.",
            "step3": "Kies bij Retailmanager jezelf of een collega.",
            "step4": "De winkel staat daarna in Mijn winkels.",
            "note1": "Je kunt een winkel pas te huur zetten nadat deze in Mijn winkels staat.",
            "note2": "Staat de locatie nog niet op de kaart? Voeg dan eerst een nieuwe marker toe."
          },
          "newMarker": {
            "title": "Nieuwe marker toevoegen",
            "summary": "Voeg een nieuwe locatie toe op de kaart.",
            "step1": "Open de kaart.",
            "step2": "Desktop: dubbelklik op een lege plek op de kaart.",
            "step3": "Mobiel: dubbeltik op een lege plek op de kaart.",
            "step4": "Vul daarna de gegevens van de locatie in.",
            "note1": "Controleer eerst of de locatie al op de kaart staat. Gebruik in dat geval de bestaande marker.",
            "note2": "Plaats je een nieuwe marker verkeerd, dan kun je die zelf weer verwijderen zolang jij de marker hebt toegevoegd."
          },
          "moveDeleteMarker": {
            "title": "Marker verplaatsen of verwijderen",
            "summary": "Corrigeer de positie van een marker of verwijder een marker die je zelf hebt toegevoegd.",
            "step1": "Desktop: klik met de rechtermuisknop op de marker.",
            "step2": "Mobiel: houd de marker langer ingedrukt.",
            "step3": "Kies Marker verplaatsen en klik of tik op de nieuwe locatie.",
            "step4": "Kies Marker verwijderen om een marker te verwijderen die je zelf hebt toegevoegd.",
            "note1": "Bestaande markers en markers van anderen kunnen alleen door een admin worden verwijderd.",
            "note2": "Na het verplaatsen open je de marker opnieuw als je de gegevens wilt controleren of aanpassen."
          },
          "mobile": {
            "title": "Retailmaps op mobiel gebruiken",
            "summary": "Zet Retailmaps op je beginscherm voor snelle toegang.",
            "step1": "Open www.retailmaps.com op je telefoon.",
            "step2": "iPhone of iPad: gebruik Safari, tik op de deelknop en kies Zet op beginscherm.",
            "step3": "Chrome op Android: tik op de drie puntjes en kies App installeren of Toevoegen aan startscherm.",
            "step4": "Samsung Internet: open het menu en kies Pagina toevoegen aan of Toevoegen aan startscherm.",
            "step5": "Geef de snelkoppeling de naam Retailmaps en tik op Toevoegen.",
            "step6": "Open Retailmaps daarna via het icoon op je beginscherm.",
            "note1": "Op iPhone werkt dit normaal via Safari. Chrome op iPhone kan dit meestal niet rechtstreeks.",
            "note2": "Je logt in met hetzelfde account als op desktop."
          },
          "security": {
            "title": "Twee-factor-authenticatie aan- of uitzetten",
            "summary": "Beveilig je account extra met een code uit een authenticator-app.",
            "step1": "Open Instellingen.",
            "step2": "Ga naar Beveiliging of Twee-factor-authenticatie.",
            "step3": "Klik op 2FA inschakelen.",
            "step4": "Open een authenticator-app, zoals Google Authenticator, Microsoft Authenticator of 1Password.",
            "step5": "Scan de QR-code met de authenticator-app.",
            "step6": "Vul de 6-cijferige code uit de app in en bevestig.",
            "step7": "Vanaf nu log je in met je wachtwoord plus de 6-cijferige code.",
            "step8": "Wil je 2FA uitzetten? Ga opnieuw naar Instellingen en klik op 2FA uitschakelen.",
            "note1": "Bewaar toegang tot je authenticator-app goed. Zonder die app kun je niet zomaar inloggen.",
            "note2": "De code verandert ongeveer elke 30 seconden. Gebruik altijd de nieuwste code."
          },
          "popupMedia": {
            "title": "Foto's, documenten en plattegronden",
            "summary": "Voeg bestanden toe aan een locatie.",
            "step1": "Open de popup van de locatie.",
            "step2": "Ga naar Privégegevens.",
            "step3": "Kies Foto's, Documenten of Plattegronden.",
            "step4": "Voeg een bestand toe of maak mobiel direct een foto.",
            "note1": "Foto's worden als miniatuur weergegeven.",
            "note2": "Plattegronden werken het best als afbeelding, bijvoorbeeld jpg of png."
          },
          "alerts": {
            "title": "Alerts instellen",
            "summary": "Stel een herinnering in voor belangrijke datums.",
            "step1": "Open Property Details of de popup.",
            "step2": "Vul een datum in, zoals expiratiedatum, indexatiedatum of opzegdatum.",
            "step3": "Vink Alert aan.",
            "step4": "Vul in hoeveel dagen van tevoren je de alert wilt ontvangen.",
            "step5": "Bekijk actieve alerts in de tab Alerts.",
            "note1": "Actieve alerts worden zichtbaar in de tab Alerts.",
            "note2": "Op de ingestelde herinneringsdatum ontvang je automatisch een e-mail."
          },
          "ownerRequests": {
            "title": "Aanvragen bekijken",
            "summary": "Bekijk wie interesse heeft in jouw verhuuraanbod of pand.",
            "step1": "Open de tab Aanvragen.",
            "step2": "Bekijk bij welk pand de aanvraag hoort.",
            "step3": "Controleer welke gegevens van de aanvrager beschikbaar zijn.",
            "step4": "Open de aanvraag voor meer details.",
            "note1": "Aanvragen ontstaan wanneer retailers interesse tonen in een winkelruimte, ook wanneer die niet actief te huur staat."
          },
          "retailerRequests": {
            "title": "Aanvragen bekijken",
            "summary": "Bekijk welke retailers interesse hebben in jouw locaties.",
            "step1": "Open de tab Aanvragen.",
            "step2": "Bekijk welke retailer interesse heeft getoond.",
            "step3": "Controleer bij welke locatie de aanvraag hoort.",
            "step4": "Klik op het adres om de locatie op de kaart te openen.",
            "note1": "Aanvragen zijn inkomende interesses in locaties die bij jouw organisatie horen."
          },
          "interest": {
            "title": "Interesse tonen",
            "summary": "Maak zichtbaar dat je interesse hebt in een specifieke locatie.",
            "step1": "Open op de kaart de locatie waarin je interesse hebt.",
            "step2": "Klik in de popup op Toon Interesse.",
            "step3": "Controleer de bevestiging en rond eventuele toegangsstappen af.",
            "step4": "De locatie verschijnt daarna in de tab Interesses.",
            "step5": "De interesse blijft actief totdat je deze zelf weer intrekt.",
            "note1": "Je interesse wordt opgeslagen op het specifieke pand, niet alleen in jouw eigen overzicht.",
            "note2": "De huidige huurder, eigenaar en relevante makelaars kunnen de interesse zien waar zij toegang hebben."
          },
          "analysis": {
            "title": "Analyse gebruiken",
            "summary": "Vergelijk locaties en bekijk belangrijke berekeningen.",
            "step1": "Selecteer een pand of winkel in je overzicht.",
            "step2": "Kies de actie Analyse.",
            "step3": "Voeg eventueel meerdere locaties toe.",
            "step4": "Open Analyse om onder andere huurprijs per m2, WALT, resterende looptijd en ratio's te bekijken."
          }
        },
        "title": "Hoe werkt het?"
      },
      "legal": {
        "disclaimer": "Conceptdocument voor Retailmaps. Vul de open bedrijfsgegevens aan voordat je dit definitief publiceert.",
        "lastUpdated": "Laatst bijgewerkt: 28 mei 2026",
        "privacy": {
          "title": "Privacyverklaring",
          "intro": "Retailmaps verwerkt zakelijke account-, bedrijfs-, pand-, listing-, interesse- en gebruiksgegevens om het platform te leveren.",
          "roles": "Gegevens kunnen zichtbaar zijn voor relevante gebruikers afhankelijk van rol, rechten, abonnementen en acties.",
          "providers": "Retailmaps kan externe providers gebruiken voor hosting, kaarten, betalingen, e-mail, analytics en AI.",
          "rights": "Gebruikers kunnen waar van toepassing inzage, correctie of verwijdering vragen.",
          "contact": "Neem voor privacyvragen contact op via de gepubliceerde contactgegevens."
        },
        "terms": {
          "title": "Algemene voorwaarden",
          "intro": "Retailmaps is een professioneel platform voor retailvastgoedinformatie, listings, interesses, aanvragen en samenwerking.",
          "account": "Gebruikers zijn verantwoordelijk voor juiste accountgegevens, veilige inloggegevens en rechtmatig gebruik.",
          "data": "Gebruikers blijven verantwoordelijk voor juistheid en rechten op informatie, foto?s, documenten en contactgegevens.",
          "uploadLicense": "Door plattegronden, IMDF-, GeoJSON-, CAD-, SVG- of andere locatiebestanden te verstrekken, bevestigt de gebruiker daartoe bevoegd te zijn en verleent hij Retailmaps een niet-exclusief en royaltyvrij recht om deze bestanden op te slaan, te hosten, te kopiëren, te analyseren, te converteren, te georefereren, aan te passen en te combineren, daarvan afgeleide plattegronden en kaartlagen te maken en deze binnen de Retailmaps-dienst te tonen. Retailmaps mag de strikt noodzakelijke rechten verlenen aan haar technische dienstverleners. De gebruiker moet bij het verstrekken verplichte bronvermelding, licenties van derden of andere beperkingen melden.",
          "payments": "Betaalde functies, abonnementen, bundels en transactiekosten kunnen gelden waar duidelijk vermeld.",
          "liability": "Retailmaps is een informatie- en netwerkplatform en garandeert niet dat een pand beschikbaar is of een transactie tot stand komt."
        }
      },
      "popup": {
        "autosaveActive": "Autosave actief"
      },
      "alerts": {
        "daysBefore": "dagen vooraf",
        "enterDaysBefore": "Vul dagen vooraf in",
        "title": "Alerts",
        "loading": "Alerts laden...",
        "empty": "Er zijn op dit moment geen alerts die aandacht vragen.",
        "toggleLabel": "Alert",
        "dismiss": "Afhandelen",
        "columns": {
          "property": "Pand",
          "field": "Veld",
          "date": "Datum",
          "alertDate": "Alertdatum",
          "daysBefore": "Dagen vooraf",
          "status": "Status",
          "actions": "Acties"
        },
        "status": {
          "expired": "Verlopen",
          "actionNeeded": "Actie nodig",
          "upcoming": "Aankomend"
        },
        "fields": {
          "expiryDate": "Expiratiedatum",
          "indexationDate": "Indexatiedatum",
          "terminationDate": "Opzegdatum",
          "availableFrom": "Beschikbaar per",
          "startDate": "Ingangsdatum"
        }
      },
      "analysis": {
        "title": "Analyse",
        "empty": "Voeg panden toe aan de analyse om de cijfers te bekijken.",
        "summary": {
          "totalRent": "Totale jaarhuur",
          "totalAskingRent": "Totale vraaghuur",
          "weightedArea": "Gewogen m2",
          "avgAskingRentPerM2": "Gem. vraaghuur/m2/jaar",
          "avgRentPerM2": "Gem. huur/m2/jaar",
          "wault": "WAULT"
        },
        "values": {
          "years": "{{value}} jaar"
        },
        "metrics": {
          "waltYears": "WALT: {{value}} jaar",
          "expiry12": "Expiratie 12m: {{value}}",
          "expiry24": "Expiratie 24m: {{value}}",
          "expiry36": "Expiratie 36m: {{value}}"
        },
        "actions": {
          "clear": "Analyse wissen",
          "collapseSurfaces": "Oppervlaktes inklappen",
          "expandSurfaces": "Oppervlaktes uitklappen",
          "remove": "Verwijderen"
        },
        "table": {
          "property": "Pand",
          "tenant": "Huurder",
          "annualRent": "Jaarhuur",
          "askingRent": "Vraaghuur",
          "weightedM2": "Gewogen m2",
          "rentPerM2": "Huur/m2",
          "askingRentPerM2": "Vraaghuur/m2",
          "expiry": "Expiratie",
          "remainingTerm": "Resterende looptijd",
          "remainingMonths": "Resterende maanden",
          "guaranteeMonths": "Garantiemaanden",
          "surfaces": "Oppervlaktes",
          "front": "Front",
          "rentCoverage": "Huurdekking",
          "interestCoverage": "Interest coverage",
          "weightedArea": "Gewogen m2",
          "ltv": "LTV"
        },
        "surfaces": {
          "title": "Oppervlaktes",
          "helper": "Standaard: winkel 100%, secundair 50%. Pas dit hier per verdieping aan.",
          "weightedTotal": "Gewogen totaal",
          "grossM2": "{{value}} m2 bruto",
          "weightedM2Value": "= {{value}} m2",
          "empty": "Geen oppervlaktes gevonden. Vul winkel- en secundaire oppervlaktes in bij publieke data.",
          "button": "Oppervlaktes"
        },
        "surfaceFields": {
          "beganeGrondWinkel": "BG winkel",
          "beganeGrondSecundair": "BG secundair",
          "kelderWinkel": "Kelder winkel",
          "kelderSecundair": "Kelder secundair",
          "eersteVerdiepingWinkel": "1e winkel",
          "eersteVerdiepingSecundair": "1e secundair",
          "tweedeVerdiepingWinkel": "2e winkel",
          "tweedeVerdiepingSecundair": "2e secundair",
          "derdeVerdiepingWinkel": "3e winkel",
          "derdeVerdiepingSecundair": "3e secundair",
          "entresolWinkel": "Entresol winkel",
          "entresolSecundair": "Entresol secundair",
          "soussolWinkel": "Sous-sol winkel",
          "soussolSecundair": "Sous-sol secundair",
          "front": "Front",
          "winkel": "Winkel",
          "secundair": "Secundair",
          "begane_grond_winkel": "Begane grond winkel",
          "begane_grond_secundair": "Begane grond secundair",
          "kelder_winkel": "Kelder winkel",
          "kelder_secundair": "Kelder secundair",
          "shop": "Winkel",
          "secondary": "Secundair"
        },
        "chips": {
          "wault": "WAULT: {{value}} jaar",
          "expiry12": "Expiratie 12m: {{value}}",
          "expiry24": "Expiratie 24m: {{value}}",
          "expiry36": "Expiratie 36m: {{value}}"
        }
      },
      "brokerRequests": {
        "title": "Broker aanvragen",
        "overview": "Overzicht",
        "empty": "Geen aanvragen",
        "interestCount": "{{count}} interesse(s)",
        "buyContact": "Koop (€9)",
        "profile": {
          "industry": "Branche",
          "stores": "Winkels",
          "activeIn": "Actief in",
          "founded": "Oprichtingsjaar",
          "revenue": "Omzet"
        }
      },
      "retailerProperties": {
        "sameBrandInterestBlocked": "Interesse tonen op een pand van je eigen merk of concern is niet toegestaan."
      },
      "landing": {
        "language": {
          "select": "Taal kiezen"
        },
        "nav": {
          "aria": "Hoofdnavigatie",
          "forWho": "Voor wie",
          "howItWorks": "Hoe het werkt",
          "product": "Product",
          "price": "Prijs"
        },
        "actions": {
          "login": "Login",
          "register": "Registreren",
          "startFree": "Registreer gratis",
          "start60": "Start 60 dagen gratis",
          "startTrial": "Start gratis proefperiode",
          "viewProduct": "Bekijk het product"
        },
        "auth": {
          "tag": "Account",
          "close": "Sluit formulier",
          "copy": {
            "loginTitle": "Welkom terug.",
            "loginText": "Log in met je zakelijke e-mailadres en ga verder naar je kaart, panden en data.",
            "registerTitle": "Start je gratis proefperiode.",
            "registerText": "Maak een zakelijk account aan en probeer de kaart 60 dagen gratis. Na registratie sturen we je een e-mail om je account te verifiëren.",
            "forgotTitle": "Herstel je toegang.",
            "forgotText": "Vul je e-mailadres in. Als er een account bestaat, sturen we je direct een herstelmail."
          },
          "twoFactor": {
            "help": "Vul de 6-cijferige code uit je authenticator-app in.",
            "label": "2FA-code",
            "back": "Terug naar wachtwoord"
          },
          "forgot": {
            "link": "Wachtwoord vergeten?",
            "help": "Vul je e-mailadres in. Als het account bestaat, sturen we een link om je wachtwoord te herstellen.",
            "submit": "Herstelmail versturen",
            "back": "Terug naar login",
            "openLocal": "Open lokale resetlink"
          },
          "fields": {
            "email": "E-mailadres",
            "businessEmail": "Zakelijk e-mailadres",
            "password": "Wachtwoord",
            "role": "Rol",
            "chooseRole": "Kies je rol",
            "firstName": "Voornaam",
            "lastName": "Achternaam",
            "companyName": "Bedrijfsnaam"
          },
          "registerNote": "60 dagen gratis. Geen creditcard nodig. Je ontvangt eerst een verificatiemail om je account te activeren.",
          "legalAccept": "Ik accepteer de <privacy>privacyverklaring</privacy> en <terms>algemene voorwaarden</terms>.",
          "notices": {
            "emailVerified": "Je e-mailadres is bevestigd. Log in om Retailmaps te openen.",
            "twoFactorRequired": "Voer je 2FA-code in om verder te gaan.",
            "registerSuccess": "Registratie gelukt. We hebben een bevestigingsmail naar je e-mailadres gestuurd.",
            "forgotSent": "Als dit e-mailadres bekend is, sturen we een herstelmail."
          },
          "errors": {
            "loginFailed": "Inloggen is niet gelukt. Controleer je gegevens.",
            "twoFactorFailed": "Inloggen is niet gelukt. Controleer je 2FA-code.",
            "businessEmail": "Gebruik een zakelijk e-mailadres. Gratis e-mailadressen zoals Gmail, Hotmail, Outlook of iCloud zijn niet toegestaan.",
            "roleRequired": "Kies eerst je rol: retailer, eigenaar of makelaar.",
            "companyRequired": "Vul je bedrijfsnaam in.",
            "legalRequired": "Accepteer de privacyverklaring en algemene voorwaarden om je account aan te maken.",
            "registerFailed": "Registreren is niet gelukt. Probeer het opnieuw.",
            "forgotFailed": "Wachtwoord herstellen is niet gelukt."
          }
        },
        "roles": {
          "options": {
            "retailer": "Retailer",
            "owner": "Eigenaar",
            "broker": "Makelaar"
          },
          "tag": "Voor wie",
          "title": "Drie rollen, drie manieren om sneller te handelen.",
          "intro": "Expansie, portefeuillebeheer en advisering — alles in één kaartomgeving.",
          "retailer": {
            "kicker": "Voor retailers",
            "title": "Vind de juiste locatie voordat die te huur staat.",
            "text": "Volg panden, toon discreet interesse en mis geen kansen meer!",
            "points": {
              "1": {
                "title": "Proactief interesse tonen",
                "text": "Leg interesse vast in een specifiek pand, ook wanneer het nog niet officieel beschikbaar is."
              },
              "2": {
                "title": "Anoniem blijven tot het juiste moment",
                "text": "Eigenaren, makelaars en de huidige retailers zien je anonieme interesse en kunnen contact opnemen zodra het opportuun is."
              },
              "3": {
                "title": "Locaties volgen en opvolgen",
                "text": "Bewaar projectinformatie, foto's en notities <underline>per pand</underline> en deel die met je team. Volg panden en ontvang meldingen wanneer er beweging ontstaat. Zo raak je nooit meer waardevolle data kwijt."
              }
            }
          },
          "owner": {
            "kicker": "Voor eigenaren",
            "title": "Meer grip op je portefeuille, marktvraag en verhuurstrategie.",
            "text": "Eigenaren beheren hun winkelvastgoed vanuit één centrale omgeving. Zet een pand met één knop te huur, maak automatisch projectinformatie aan wanneer dat nodig is, analyseer je portefeuille en verdeel locaties over teamleden.",
            "points": {
              "1": {
                "title": "Beheer je portefeuille",
                "text": "Houd pand-, huur- en contactgegevens, documenten en notities overzichtelijk bij, <underline>per pand</underline>, zichtbaar voor je hele team. Voeg velden en secties toe en bouw zo een volledig aanpasbare vastgoeddatabase die past bij jouw werkwijze."
              },
              "2": {
                "title": "Ontvang interesses van retailers",
                "text": "Zie welke geïnteresseerde retailers zich melden, inclusief branche en type interesse. Ook wanneer het pand nog gewoon verhuurd is."
              },
              "3": {
                "title": "Stel alerts in",
                "text": "Vergeet nooit meer een indexatie, opzegdatum of ander belangrijk moment."
              }
            }
          },
          "broker": {
            "kicker": "Voor makelaars",
            "title": "Sterker adviseren met zichtbare marktvraag.",
            "text": "Combineer locatiedata, huurstatus, retailerlabels en interesse vanuit één werkplek. Zo wordt advies minder afhankelijk van losse lijsten en meer gebaseerd op actuele data.",
            "points": {
              "1": {
                "title": "Interactieve kaart",
                "text": "Zoek retailers, pas labels aan naar de huidige situatie en draag bij aan de meest volledige open source retailmap van de wereld."
              },
              "2": {
                "title": "Vind leads en adviseer sterker",
                "text": "Gebruik leads om gerichter te werken en eigenaren met betere marktinformatie te adviseren."
              },
              "3": {
                "title": "Alle vastgoeddata op één plek",
                "text": "Raadpleeg, analyseer en deel vastgoeddata met teammembers, zowel mobiel als op desktop."
              },
              "4": {
                "title": "Zet panden eenvoudig te huur",
                "text": "Zet panden snel te huur en stuur bij op zichtbaarheid wanneer de situatie daarom vraagt."
              }
            }
          }
        },
        "hero": {
          "eyebrow": "Retail Real Estate Intelligence",
          "title": "Retailmaps is DE interactieve kaart voor winkelvastgoed.",
          "line1": "Voor en door retailprofessionals.",
          "line2": "Vind interessante locaties, toon anoniem interesse, volg ontwikkelingen en beheer pandinformatie vanuit één centrale omgeving — op laptop én mobiel.",
          "line3": "Voor retailers, eigenaren en makelaars die sneller willen zien waar vraag, aanbod en locatie samenkomen.",
          "proofs": {
            "trial": "60 dagen gratis. Zonder verplichtingen.",
            "price": "Daarna €19 per maand",
            "cancel": "Je hoeft niets op te zeggen",
            "noCard": "Geen creditcard nodig",
            "noCharges": "Geen automatische betaling",
            "afterTrial": "Na 60 dagen kies je zelf of je betaald verder wilt. Doe je niets? Dan betaal je niets.",
            "cta": "Start mijn gratis proefperiode"
          }
        },
        "how": {
          "tag": "Hoe het werkt",
          "title": "Werk vanuit de kaart, niet vanuit losse lijsten.",
          "steps": {
            "1": {
              "title": "Zoom in op het winkelgebied",
              "text": "Bekijk panden, retailers en beschikbaarheid direct op straatniveau."
            },
            "2": {
              "title": "Open een pand",
              "text": "Zie alle relevante informatie op één plek: privégegevens, oppervlaktes, huur-, pand- en financiële gegevens, contactpersonen, foto's, opmerkingen en documenten."
            },
            "3": {
              "title": "Leg interesse of beschikbaarheid vast",
              "text": "Retailers tonen discreet interesse. Makelaars zetten panden te huur en bepalen zelf voor wie de informatie zichtbaar is."
            }
          }
        },
        "product": {
          "tag": "Product",
          "title": "Niet alleen data. Een dagelijkse werkplek.",
          "features": {
            "1": {
              "title": "Interactieve kaart",
              "text": "Werk visueel vanuit winkelstraten, panden en gebieden in plaats van alleen tabellen."
            },
            "2": {
              "title": "Interesse tonen",
              "text": "Marktvraag zichtbaar maken zonder gevoelige strategieën openbaar te maken."
            },
            "3": {
              "title": "Privégegevens",
              "text": "Huurdata, documenten, foto's en notities vanaf één plek, beschermd binnen de organisatie. Geen exports mogelijk en 2-factor inlog voor optimale bescherming."
            },
            "4": {
              "title": "Street View context",
              "text": "Bekijk en onderzoek locaties direct vanaf de straat, naast de kaart, voor nog beter begrip van de locatie."
            }
          }
        },
        "visual": {
          "tag": "In beeld",
          "title": "Locatiecontext zonder wisselen",
          "text": "Street View helpt bij snelle beoordeling van gevel, ligging en omgeving."
        },
        "price": {
          "tag": "Prijs",
          "title": "Laagdrempelig starten, zonder lang traject.",
          "text": "Probeer Retailmaps 60 dagen gratis. Na de proefperiode kies je zelf of je doorgaat. De prijs blijft eenvoudig, zodat het platform ook voor kleine teams logisch is.",
          "cardTitle": "Retailmaps Professional",
          "amount": "€19",
          "period": "/ maand",
          "cardText": "Retailmaps 60 dagen gratis proberen. Geen creditcard nodig.",
          "items": {
            "1": "Interactieve kaart en pandenlijst",
            "2": "Interesse tonen en alerts",
            "3": "Pandgegevens, documenten en notities",
            "4": "Werkt op laptop en mobiel"
          }
        },
        "final": {
          "title": "Zie waar winkelvastgoed in beweging komt.",
          "text": "Start met de kaart, volg relevante panden en zie sneller waar vraag, aanbod en locatie samenkomen."
        },
        "images": {
          "interestStackAria": "Mobiele interessefunctie",
          "interestSavedAlt": "Interesse intrekken op mobiel",
          "interestAlt": "Toon interesse in een pand op mobiel",
          "interestCaption": "Toon interesse in je favoriete pand.",
          "ownerAlt": "Eigenarenoverzicht met ontvangen interesse",
          "ownerCaption": "Zie per pand welke interesse binnenkomt en beslis zelf wanneer je contactgegevens opvraagt.",
          "brokerAlt": "Makelaarsdashboard met panden, retailers en leads",
          "brokerCaption": "Bekijk panden, retailers en leads makkelijk vanuit 1 overzicht.",
          "rentalAlt": "Mobiele pandinformatie met verhuuraanbod",
          "streetViewAlt": "Kaart en Street View naast elkaar"
        },
        "footer": {
          "copyright": "© 2026 Retailmaps.com",
          "security": "Data & veiligheid",
          "privacy": "Privacyverklaring",
          "terms": "Voorwaarden",
          "contact": "Contact"
        }
      },
      "popup.autosaveActive": "Autosave actief",
      "retailerMap.mobileZoomFeedback": "Zoom {{zoom}} - dubbeltik vanaf 19 om toe te voegen",
      "retailerMap.installPrompt.title": "Retailmaps sneller openen",
      "retailerMap.installPrompt.subtitle": "Zet Retailmaps op je beginscherm.",
      "retailerMap.installPrompt.install": "Zet op mobiel",
      "retailerMap.installPrompt.later": "Later",
      "retailerMap.iosInstall.title": "Zet Retailmaps op beginscherm",
      "retailerMap.iosInstall.intro": "Op iPhone kan Safari dit niet automatisch doen. Volg deze stappen:",
      "retailerMap.iosInstall.step1": "1. Tik onderin op de deelknop",
      "retailerMap.iosInstall.step2": "2. Kies Zet op beginscherm.",
      "retailerMap.iosInstall.step3": "3. Tik op Voeg toe.",
      "common.understood": "Begrepen",
      "propertyList.filters.country": "Land",
      "propertyList.filters.allCountries": "Alle landen",
      "propertyList.interest.changeFailed": "Interesse wijzigen mislukt.",
      "propertyList.interest.ownGroup": "Eigen groep",
      "propertyList.interest.viaColleague": "Via collega",
      "propertyList.interest.withdraw": "Intrekken",
      "propertyList.interest.show": "Interesse",
      "propertyList.rental.stop": "Stop verhuur",
      "propertyList.rental.setForRent": "Zet te huur",
      "dashboardOverlay.shared.analysis": "Analyse",
      "broker": {
        "listingsTitle": "Mijn verhuuraanbod"
      },
      "retailer": {
        "listingsTitle": "Mijn verhuuraanbod"
      },
      "ownerListings.currentOffer": "Mijn verhuuraanbod",
      "retailer.listingsTitle": "Mijn verhuuraanbod",
      "listings.common.empty": "Er zijn momenteel geen locaties te huur.",
      "owner": {
        "ownerFields": {
          "title": "Eigenaarsgegevens",
          "parentCompany": "Eigenaar moedermaatschappij",
          "owner": "Eigenaar",
          "contactPerson": "Contactpersoon",
          "email": "E-mailadres",
          "phone": "Telefoonnummer"
        },
        "huurgegevensBlock": {
          "title": "Huurgegevens",
          "formeleHuurder": "Formele huurder",
          "huurprijs": "Huurprijs",
          "ingangsdatum": "Ingangsdatum",
          "expiratiedatum": "Expiratiedatum",
          "resterendeLooptijdMaanden": "Resterende looptijd",
          "huurtermijn": "Huurtermijn",
          "verlengingsjaren": "Verlengingsjaren",
          "huurvrijePeriodeMaanden": "Huurvrije periode",
          "indexatiedatum": "Indexatiedatum",
          "opzegdatum": "Opzegdatum",
          "opzegtermijn": "Opzegtermijn",
          "garantiesoort": "Garantiesoort",
          "kiesOptie": "Kies optie",
          "waarborgsom": "Waarborgsom",
          "bankgarantie": "Bankgarantie",
          "concerngarantie": "Concerngarantie",
          "garantiebedrag": "Garantiebedrag",
          "noGuarantee": "Geen garantie"
        },
        "financieringBlock": {
          "title": "Financiele gegevens",
          "koopsom": "Koopsom",
          "aankoopdatum": "Aankoopdatum",
          "actueleMarktwaarde": "Actuele marktwaarde",
          "taxatiedatum": "Taxatiedatum",
          "hypotheek": "Hypotheekbedrag",
          "actueleHypotheekschuld": "Actuele hypotheekschuld",
          "actueleHypotheekrente": "Actuele hypotheekrente (%)",
          "rentevastTot": "Rentevast tot",
          "aflossingspercentage": "Aflossingspercentage (%)",
          "looptijd": "Looptijd (jaren)",
          "jaarlijkseRentelasten": "Jaarlijkse rentelasten",
          "jaarlijkseAflossing": "Jaarlijkse aflossing",
          "bank": "Bank",
          "jaarlijkseOverigeLasten": "Jaarlijkse overige lasten",
          "netOperatingIncome": "Net operating income",
          "markthuurPerM2": "Markthuur per m2",
          "servicekostenPerJaar": "Servicekosten per jaar",
          "vraagprijs": "Vraagprijs"
        },
        "opmerkingen": {
          "title": "Notities",
          "none": "Geen opmerkingen toegevoegd.",
          "unknownAuthor": "Onbekende auteur",
          "add": "Voeg opmerking toe",
          "placeholder": "Typ hier je opmerking..."
        },
        "contactgegevensBlock": {
          "title": "Contactgegevens",
          "add": "Contact toevoegen",
          "remove": "Contact verwijderen",
          "company": "Bedrijf",
          "name": "Naam",
          "phone": "Telefoon",
          "email": "E-mail",
          "function": "Functie"
        }
      },
      "owner.financieringBlock.actueleMarktwaarde": "Actuele marktwaarde",
      "owner.financieringBlock.taxatiedatum": "Taxatiedatum",
      "owner.financieringBlock.actueleHypotheekschuld": "Actuele hypotheekschuld",
      "owner.financieringBlock.actueleHypotheekrente": "Actuele hypotheekrente (%)",
      "owner.financieringBlock.rentevastTot": "Rentevast tot",
      "owner.financieringBlock.aflossingspercentage": "Aflossingspercentage (%)",
      "owner.financieringBlock.jaarlijkseRentelasten": "Jaarlijkse rentelasten",
      "owner.financieringBlock.jaarlijkseAflossing": "Jaarlijkse aflossing",
      "owner.financieringBlock.jaarlijkseOverigeLasten": "Jaarlijkse overige lasten",
      "owner.financieringBlock.netOperatingIncome": "Net operating income",
      "owner.financieringBlock.markthuurPerM2": "Markthuur per m2",
      "owner.financieringBlock.servicekostenPerJaar": "Servicekosten per jaar",
      "propertyDetails.objectInfoDivider": "Objectinformatie",
      "propertyDetails.addObjectInfo": "Objectinformatie toevoegen",
      "listings.common.country": "Land",
      "listings.common.city": "Stad",
      "listings.common.address": "Adres",
      "listings.common.askingPrice": "Vraagprijs",
      "listings.common.currentRent": "Huidige huurprijs",
      "listings.common.keyMoney": "Sleutelgeld",
      "listings.common.expiryDate": "Expiratiedatum",
      "listings.common.availableFrom": "Beschikbaar per",
      "listings.common.forRentSince": "Te huur sinds",
      "listings.common.projectInformation": "Projectinformatie",
      "listings.common.onBehalfOf": "Namens",
      "listings.common.visibility": "Zichtbaarheid",
      "listings.common.broker": "Makelaar",
      "listings.common.actions": "Acties",
      "listings.common.upload": "Uploaden",
      "listings.common.uploadDocument": "Document uploaden",
      "listings.common.stopForRent": "Stop",
      "listings.common.brochureFailed": "Brochure genereren of uploaden mislukt.",
      "listings.common.projectDocuments": "Projectdocumenten",
      "listings.common.chooseFile": "Bestand kiezen",
      "listings.common.noFileChosen": "Geen bestand gekozen",
      "listings.common.selectFileFirst": "Selecteer eerst een bestand.",
      "listings.common.uploadFailed": "Upload mislukt.",
      "listings.common.documentDeleteFailed": "Document verwijderen mislukt.",
      "listings.common.confirmDeleteDocument": "Weet je zeker dat je \"{{name}}\" wilt verwijderen?",
      "listings.common.forRent": "Te huur",
      "listings.common.edit": "Bewerken",
      "listings.common.save": "Opslaan",
      "listings.common.cancel": "Annuleren",
      "listings.common.documentTypes.document": "Document",
      "listings.common.documentTypes.floorplan": "Plattegrond",
      "listings.common.documentTypes.brochure": "Brochure",
      "listings.common.documentTypes.photo": "Foto",
      "listings.common.visibilityOptions.public": "Iedereen",
      "listings.common.visibilityOptions.retailers": "Alle retailers",
      "listings.common.visibilityOptions.interested": "Alleen geïnteresseerden",
      "roles.owner": "Eigenaar",
      "roles.retailer": "Retailer",
      "roles.broker": "Makelaar",
      "common.edit": "Bewerken",
      "common.cancel": "Annuleren",
      "listings.common.noDocuments": "Geen documenten beschikbaar.",
      "listings.common.fileCountOne": "{{count}} bestand",
      "listings.common.fileCountOther": "{{count}} bestanden",
      "listings.common.addedOn": "Toegevoegd {{date}}",
      "listings.common.deleteDocumentAria": "Verwijder {{name}}",
      "common.close": "Sluiten",
      "common.open": "Openen",
      "common.delete": "Verwijderen",
      "photos": {
        "title": "Foto's",
        "add": "Foto toevoegen",
        "remove": "Foto verwijderen",
        "useAsCover": "Gebruik als voorblad",
        "cover": "Voorblad",
        "chooseCover": "Kies",
        "openPreview": "Voorbeeld openen",
        "error": {
          "tooLarge": "is groter dan 10 MB en is overgeslagen."
        }
      },
      "photos.useAsCover": "Gebruik als voorblad",
      "photos.cover": "Voorblad",
      "photos.chooseCover": "Kies",
      "photos.openPreview": "Voorbeeld openen",
      "propertyDetails.notesDivider": "Notities",
      "retailerProperty": {
        "contactsDivider": "Contactpersonen",
        "notesDivider": "Notities",
        "photosDivider": "Foto's"
      },
      "retailerProperty.notesDivider": "Notities",
      "account.noLogo": "Geen logo",
      "listings.common.uploading": "Uploaden...",
      "propertyDetails.detailsDivider": "Details",
      "common.saved": "Opgeslagen",
      "common.saving": "Opslaan...",
      "common.saveFailed": "Opslaan mislukt",
      "common.ready": "Gereed",
      "common.active": "Actief",
      "common.inactive": "Niet actief",
      "common.canceled": "Geannuleerd",
      "common.loading": "Laden...",
      "accountSettings.title": "Instellingen",
      "accountSettings.tabs.profile": "Profiel",
      "accountSettings.tabs.company": "Bedrijf",
      "accountSettings.tabs.preferences": "Voorkeuren",
      "accountSettings.tabs.security": "Beveiliging",
      "accountSettings.tabs.billing": "Facturatie",
      "accountSettings.descriptions.profile": "Contactgegevens en rolgegevens voor je account.",
      "accountSettings.descriptions.company": "Bedrijfsgegevens, merk en facturatie.",
      "accountSettings.descriptions.preferences": "Taal, valuta, eenheden en kaartweergave.",
      "accountSettings.descriptions.security": "Inloggen en accountbeveiliging.",
      "accountSettings.descriptions.billing": "Abonnement, gebruik en losse aankopen.",
      "accountSettings.personal.title": "Persoonlijk profiel",
      "accountSettings.personal.description": "Contactgegevens en rolgegevens voor je account. Wijzigingen worden automatisch opgeslagen.",
      "accountSettings.personal.firstName": "Voornaam",
      "accountSettings.personal.lastName": "Achternaam",
      "accountSettings.personal.role": "Functie",
      "accountSettings.personal.phone": "Telefoonnummer",
      "accountSettings.personal.email": "E-mailadres",
      "accountSettings.personal.linkedin": "LinkedIn",
      "accountSettings.personal.address": "Adres",
      "accountSettings.company.title": "Bedrijfsprofiel",
      "accountSettings.company.description": "Bedrijfsgegevens, merkinformatie en facturatie voor makelaars- en eigenaarsaccounts. Wijzigingen worden automatisch opgeslagen.",
      "accountSettings.company.brandLogoTitle": "Merk en logo",
      "accountSettings.company.brandLogoDescription": "We gebruiken dit logo op pandkaarten en andere zichtbare merkplekken.",
      "accountSettings.company.readOnlyNotice": "Bedrijfsgroep en domein sturen koppelingen, zichtbaarheid en AI-profielen en blijven daarom alleen-lezen.",
      "accountSettings.company.companyName": "Bedrijfsnaam",
      "accountSettings.company.companyGroup": "Bedrijfsgroep",
      "accountSettings.company.domain": "Domein",
      "accountSettings.company.legalName": "Juridische naam",
      "accountSettings.company.website": "Website",
      "accountSettings.company.roleType": "Roltype",
      "accountSettings.company.headquartersTitle": "Hoofdkantoor",
      "accountSettings.company.headquartersAddress": "Adres hoofdkantoor",
      "accountSettings.company.postalCode": "Postcode",
      "accountSettings.company.city": "Plaats",
      "accountSettings.company.country": "Land",
      "accountSettings.company.billingTitle": "Facturatie",
      "accountSettings.company.billingDescription": "We gebruiken deze gegevens voor abonnementen, facturen en financiele administratie.",
      "accountSettings.company.billingEmail": "Facturatie e-mail",
      "accountSettings.company.invoiceReference": "Factuurreferentie / PO",
      "accountSettings.company.chamberOfCommerce": "KvK-nummer",
      "accountSettings.company.vatNumber": "Btw-nummer",
      "accountSettings.company.billingAddress": "Factuuradres",
      "accountSettings.company.taxIdType": "Type belastingnummer",
      "accountSettings.company.taxIdValue": "Btw- / belastingnummer",
      "accountSettings.company.taxIdPlaceholder": "NL123456789B01",
      "accountSettings.company.peopleTitle": "Personen",
      "accountSettings.company.peopleDescription": "Accounts die aan dezelfde organisatie zijn gekoppeld. Statussen zijn gebaseerd op abonnement en proefperiode.",
      "accountSettings.company.peopleName": "Naam",
      "accountSettings.company.peopleEmail": "E-mail",
      "accountSettings.company.peopleRole": "Rol",
      "accountSettings.company.peopleStatus": "Status",
      "accountSettings.company.peopleTrialUntil": "Proefperiode tot",
      "accountSettings.company.peopleYou": "Jij",
      "accountSettings.company.peopleEmpty": "Er zijn nog geen andere accounts binnen deze organisatie gevonden.",
      "accountSettings.company.statusTrial": "Proefperiode",
      "accountSettings.company.statusActive": "Actief",
      "accountSettings.company.statusInactive": "Niet actief",
      "accountSettings.company.taxTypes.euVat": "Europees btw-nummer",
      "accountSettings.company.taxTypes.gbVat": "Brits btw-nummer",
      "accountSettings.company.taxTypes.auAbn": "Australisch bedrijfsnummer (AU ABN)",
      "accountSettings.company.taxTypes.auArn": "Australisch belastingreferentienummer",
      "accountSettings.company.taxTypes.brCnpj": "Braziliaans CNPJ-nummer",
      "accountSettings.company.taxTypes.brCpf": "Braziliaans CPF-nummer",
      "accountSettings.company.taxTypes.caBn": "Canadees BN",
      "accountSettings.company.taxTypes.caGstHst": "Canadees GST/HST-nummer",
      "accountSettings.company.taxTypes.chVat": "Zwitsers btw-nummer",
      "accountSettings.company.taxTypes.clTin": "Chileens TIN",
      "accountSettings.company.taxTypes.egTin": "Egyptisch fiscaal nummer",
      "accountSettings.company.taxTypes.inGst": "Indiaas GST-nummer",
      "accountSettings.company.taxTypes.jpCn": "Japans ondernemingsnummer",
      "accountSettings.company.taxTypes.jpRn": "Japans registratienummer buitenlandse onderneming",
      "accountSettings.company.taxTypes.mxRfc": "Mexicaans RFC-nummer",
      "accountSettings.company.taxTypes.noVat": "Noors btw-nummer",
      "accountSettings.company.taxTypes.nzGst": "Nieuw-Zeelands GST-nummer",
      "accountSettings.company.taxTypes.sgGst": "Singaporees GST-nummer",
      "accountSettings.company.taxTypes.usEin": "Amerikaans EIN",
      "accountSettings.company.taxTypes.zaVat": "Zuid-Afrikaans btw-nummer",
      "security.twoFactor.title": "Twee-factor-authenticatie",
      "security.twoFactor.subtitle": "Bescherm je account met een 6-cijferige code uit een authenticator-app.",
      "security.twoFactor.setup": "2FA instellen",
      "security.twoFactor.scanQr": "Scan de QR-code met je authenticator-app. Lukt dat niet, gebruik dan de setup-code handmatig.",
      "security.twoFactor.openAuthenticator": "Open in authenticator-app",
      "security.twoFactor.sixDigitCode": "6-cijferige code",
      "security.twoFactor.enable": "2FA inschakelen",
      "security.twoFactor.disableWarning": "Schakel 2FA alleen uit als je zeker weet dat dit account op een andere manier goed beschermd is.",
      "security.password": "Wachtwoord",
      "security.twoFactor.code": "2FA-code",
      "security.twoFactor.disable": "2FA uitschakelen",
      "propertyDetails.datePlaceholder": "dd-mm-jjjj",
      "brokerProperty": {
        "askingPrice": "Vraagprijs"
      },
      "owner.financieringBlock.vraagprijs": "Vraagprijs",
      "propertyDetails.askingRentPrice": "Vraaghuurprijs",
      "propertyDetails.serviceCosts": "Servicekosten",
      "propertyDetails.takeoverPrice": "Overnamesom",
      "propertyDetails.availableFrom": "Beschikbaar per",
      "propertyDetails.projectInfoDivider": "Projectinformatie",
      "propertyDetails.addProjectInfo": "Projectinformatie toevoegen",
      "extraSections": {
        "addField": "Veld toevoegen",
        "addSection": "Sectie toevoegen",
        "newTab": "Nieuw tabblad"
      },
      "extraFields.addField": "Veld toevoegen",
      "extraFields": {
        "addField": "Veld toevoegen",
        "addSection": "Sectie toevoegen"
      },
      "extraFields.addSection": "Sectie toevoegen",
      "extraFieldsBlock": {
        "addField": "Veld toevoegen",
        "addHeader": "Sectie toevoegen",
        "title": "Extra velden"
      },
      "retailerMap.downloadSvg": "Download SVG",
      "retailerMap.downloadSvgTooltip": "Download de kaart als SVG-bestand",
      "retailerMap.printMenu.paper": "Printen op papier",
      "retailerMap.printMenu.pdf": "Opslaan als PDF",
      "retailerMap.printMenu.svg": "Download kaartbeeld SVG",
      "dashboardOverlay.shared.assistant": "Hoe werkt het?",
      "settingsPanel.dashboardOverlay.shared.assistant": "Hoe werkt het?",
      "myProperties.nr": "Nr.",
      "myProperties.tenant": "Huurder",
      "myProperties.status": "Status",
      "myProperties.actions": "Acties",
      "myProperties.assetManager": "Assetmanager",
      "myProperties.noAssetManager": "- geen -",
      "myProperties.noPaidSubscriptionSuffix": " - geen betaald abonnement",
      "myProperties.noResults": "Geen resultaten",
      "myProperties.ownProperties": "Mijn panden",
      "myProperties.groupProperties": "Organisatieportefeuille",
      "myProperties.stopRent": "Stop verhuur",
      "myProperties.setForRent": "Zet te huur",
      "myProperties.street": "Straat",
      "myProperties.allCities": "Alle steden",
      "myProperties.allStreets": "Alle straten",
      "myProperties.status.forRent": "Te huur",
      "myProperties.status.rented": "Verhuurd",
      "myProperties.bulk.assignToSelection": "Toewijzen aan selectie",
      "myProperties.bulk.onlyUnassigned": "Alleen zonder assetmanager",
      "myProperties.bulk.selectAllVisible": "Alles zichtbaar selecteren",
      "myProperties.bulk.noManagerSelected": "Kies een assetmanager.",
      "myProperties.bulk.noSelection": "Geen panden geselecteerd.",
      "myProperties.loading": "Laden...",
      "myProperties.assignToMe": "Aan mij toewijzen",
      "myProperties.analysis": "Analyse",
      "myProperties.view": "Bekijken",
      "myProperties.assignError": "Toewijzen mislukt.",
      "myProperties.assignRequiresPaidSubscription": "Deze gebruiker heeft een actief abonnement nodig.",
      "myProperties.importPortfolio": "Importeer portefeuille",
      "myProperties.rentToggleError": "Wijzigen van verhuurstatus mislukt.",
      "settingsPanel.retailerMap.loading.zoomInToLoad": "Zoom in tot {{zoom}} om retailers te laden",
      "settingsPanel.retailerMap.loading.fillingStreet": "Nieuwe panden laden. Dit kan tot 2 min duren...",
      "settingsPanel.retailerMap.loading.paintingFromCenter": "Panden laden vanaf het midden...",
      "propertyFields": {
        "shop": "Winkel",
        "storage": "Opslag",
        "secondary": "Secundair"
      },
      "propertyList": {
        "filters": {
          "country": "Land",
          "allCountries": "Alle landen",
          "city": "Stad",
          "select": "Selecteer...",
          "street": "Straat",
          "typeStreet": "Typ straat...",
          "retailer": "Retailer",
          "retailerExampleShort": "Retailer",
          "searchAddress": "Zoek adres",
          "scopeHint": "Kies een straat of zoek op retailer om de pandenlijst te laden."
        },
        "columns": {
          "number": "Nr.",
          "country": "Land",
          "city": "Stad",
          "address": "Adres",
          "retailer": "Retailer",
          "status": "Status",
          "interests": "Interesses",
          "purchased": "Gekocht",
          "details": "Details",
          "analysis": "Analyse",
          "rental": "Verhuur"
        },
        "status": {
          "forRent": "Te huur",
          "notForRent": "Niet te huur"
        },
        "rental": {
          "setForRent": "Zet te huur",
          "stop": "Stop verhuur",
          "stopForRent": "Stop verhuur"
        },
        "pagination": {
          "rowsPerPage": "Rijen per pagina"
        },
        "interests": {
          "none": "Geen interesses",
          "date": "Datum",
          "interestedParty": "Geinteresseerde",
          "type": "Type",
          "branch": "Branche",
          "stores": "Winkels",
          "contactDetails": "Contactgegevens",
          "protected": "Afgeschermd",
          "interest": "Interesse",
          "generalInterest": "Algemene interesse",
          "forRentInterest": "Te huur interesse",
          "downloadContact": "Download contactgegevens",
          "buyContact": "Koop contactgegevens (EUR 9)"
        },
        "contactPurchase": {
          "title": "Contactgegevens kopen",
          "description": "Accordeer de eenmalige prijs van EUR 9 om deze contactgegevens te openen.",
          "invoiceNotice": "EUR 9 wordt toegevoegd aan je eerstvolgende maandelijkse creditcardfactuur.",
          "buy": "EUR 9 accorderen en openen"
        },
        "openDetails": "Details openen",
        "loading": "Panden laden...",
        "noPropertiesFound": "Geen panden gevonden"
      },
      "dashboardOverlay.shared.forRent": "Te huur",
      "dashboardOverlay.shared.requests": "Aanvragen",
      "dashboardOverlay.shared.alerts": "Alerts",
      "dashboardOverlay.shared.settings": "Instellingen",
      "dashboardOverlay.broker.properties": "Panden",
      "analysis.title": "Analyse",
      "analysis.empty": "Voeg panden toe aan de analyse om de cijfers te bekijken.",
      "analysis.summary.totalRent": "Totale jaarhuur",
      "analysis.summary.totalAskingRent": "Totale vraaghuur",
      "analysis.summary.weightedArea": "Gewogen m2",
      "analysis.summary.avgRentPerM2": "Gem. huur/m2/jaar",
      "analysis.summary.avgAskingRentPerM2": "Gem. vraaghuur/m2/jaar",
      "analysis.metrics.waltYears": "WALT: {{value}} jaar",
      "analysis.metrics.expiry12": "Expiratie 12m: {{value}}",
      "analysis.metrics.expiry24": "Expiratie 24m: {{value}}",
      "analysis.metrics.expiry36": "Expiratie 36m: {{value}}",
      "analysis.values.years": "{{value}} jaar",
      "analysis.actions.clear": "Analyse wissen",
      "analysis.actions.collapseSurfaces": "Oppervlaktes inklappen",
      "analysis.actions.expandSurfaces": "Oppervlaktes uitklappen",
      "analysis.table.property": "Pand",
      "analysis.table.tenant": "Huurder",
      "analysis.table.front": "Front",
      "analysis.table.annualRent": "Jaarhuur",
      "analysis.table.askingRent": "Vraaghuur",
      "analysis.table.weightedM2": "Gewogen m2",
      "analysis.table.rentPerM2": "Huur/m2",
      "analysis.table.askingRentPerM2": "Vraaghuur/m2",
      "analysis.table.expiry": "Expiratie",
      "analysis.table.remainingTerm": "Resterende looptijd",
      "analysis.table.remainingMonths": "Resterende maanden",
      "analysis.table.rentCoverage": "Huurdekking",
      "analysis.table.interestCoverage": "Interest coverage",
      "analysis.table.guaranteeMonths": "Garantiemaanden",
      "analysis.table.surfaces": "Oppervlaktes",
      "analysis.surfaces.title": "Oppervlaktes",
      "analysis.surfaces.helper": "Standaard: winkel 100%, secundair 50%. Pas dit hier per verdieping aan.",
      "analysis.surfaces.weightedTotal": "Gewogen totaal",
      "analysis.surfaces.grossM2": "{{value}} m2 bruto",
      "analysis.surfaces.weightedM2Value": "= {{value}} m2",
      "analysis.surfaces.empty": "Geen oppervlaktes gevonden. Vul winkel- en secundaire oppervlaktes in bij publieke data.",
      "analysis.surfaceFields.front": "Front",
      "analysis.surfaceFields.winkel": "Winkel",
      "analysis.surfaceFields.secundair": "Secundair",
      "analysis.surfaceFields.begane_grond_winkel": "Begane grond winkel",
      "analysis.surfaceFields.begane_grond_secundair": "Begane grond secundair",
      "analysis.surfaceFields.kelder_winkel": "Kelder winkel",
      "analysis.surfaceFields.kelder_secundair": "Kelder secundair",
      "propertyList.rental.stopForRent": "Stop verhuur",
      "analysis.summary.wault": "WAULT",
      "analysis.actions.remove": "Verwijderen",
      "analysis.chips.wault": "WAULT: {{value}} jaar",
      "analysis.chips.expiry12": "Expiratie 12m: {{value}}",
      "analysis.chips.expiry24": "Expiratie 24m: {{value}}",
      "analysis.chips.expiry36": "Expiratie 36m: {{value}}",
      "analysis.table.weightedArea": "Gewogen m2",
      "analysis.table.ltv": "LTV",
      "analysis.surfaces.button": "Oppervlaktes",
      "analysis.surfaceFields.shop": "Winkel",
      "analysis.surfaceFields.secondary": "Secundair",
      "dashboardOverlay.shared.support": "Support",
      "support": {
        "title": "Support",
        "intro": "Hulp nodig? Stuur uw vraag rechtstreeks naar ons supportteam.",
        "emailIntro": "U kunt ons ook rechtstreeks e-mailen.",
        "category": "Onderwerp",
        "categoryGeneral": "Algemene vraag",
        "categoryAccount": "Account en abonnement",
        "categoryBilling": "Facturatie en betalingen",
        "categoryMap": "Kaart en data",
        "categoryForRent": "Te huur",
        "categoryBug": "Probleem melden",
        "subject": "Onderwerp",
        "message": "Uw vraag",
        "subjectPlaceholder": "Omschrijf uw vraag kort",
        "messagePlaceholder": "Vertel ons waarmee we u kunnen helpen",
        "send": "Naar support sturen",
        "sending": "Versturen…",
        "successTitle": "Uw supportverzoek is verstuurd",
        "success": "We hebben uw vraag ontvangen. Uw referentie is {{ticketNumber}}. U ontvangt ook een bevestiging per e-mail.",
        "context": "Uw bericht is gekoppeld aan uw {{role}}-account en de pagina die u nu bekijkt.",
        "validation": "Vul zowel een onderwerp als uw vraag in.",
        "error": "Uw verzoek kon niet worden verstuurd. Probeer het opnieuw of e-mail support@retailmaps.com."
      }
    }
  },
  "pl": {
    "translation": {
      "popup2.trialPaywallTitle": "Wykorzystano 10 bezpłatnych próbnych zgłoszeń zainteresowania",
      "popup2.trialPaywallDescription": "Aby wyrazić zainteresowanie także tą nieruchomością, potrzebujesz subskrypcji. Twoje obecne 10 próbnych zgłoszeń zostanie przekształconych w płatne zgłoszenia zainteresowania.",
      "popup2.trialPaywallManage": "Możesz później zarządzać tymi zgłoszeniami w panelu (edytować je lub usuwać).",
      "popup2.trialPaywallActivate": "Aktywuj subskrypcję",
      "popup2.privateData": "Dane prywatne",
      "popup2.privateDataHint": "Informacje wewnętrzne pozostają w bezpiecznej przestrzeni roboczej i są widoczne tylko dla upoważnionych użytkowników.",
      "popup2.privateWorkspace": "Prywatna przestrzeń robocza",
      "popup2.privateWorkspaceHint": "Te karty pozwalają przejrzyście i bezpiecznie zarządzać poufnymi notatkami właściciela, finansami, kontaktami, zdjęciami i dokumentami.",
      "propertyDetails.privateDataDivider": "Dane prywatne",
      "help": {
        "title": "How it works",
        "subtitle": "Short explanations for common actions in Retailmaps.",
        "howItWorks": "How it works",
        "goodToKnow": "Good to know",
        "empty": "There are no topics for this role yet.",
        "actions": {
          "openListings": "Open listings",
          "openInterests": "Open interests",
          "openProperties": "Open properties",
          "openAlerts": "Open Alerts",
          "openRequests": "Open requests",
          "openAnalysis": "Open analysis"
        },
        "topics": {
          "ownerForRent": {
            "title": "List a property for rent",
            "summary": "Publish a property as a rental offer and add the right information.",
            "step1": "Open the Properties tab.",
            "step2": "Find the property you want to offer.",
            "step3": "Click List for rent.",
            "step4": "Open For rent and complete the asking price, key money and available-from date.",
            "step5": "Check details that were already copied, such as current rent and expiry date.",
            "step6": "Add project information. You can upload a brochure or generate project information automatically.",
            "note1": "As an owner, you do not need to choose visibility. The property is automatically shown as a rental offer.",
            "note2": "Automatic project information uses the entered data, photos, floor plans and a map image."
          },
          "retailerStore": {
            "title": "Link a store to my stores",
            "summary": "Add an existing location to your store overview.",
            "step1": "Open the Stores tab.",
            "step2": "Find the store by country, city or address.",
            "step3": "Assign yourself or a colleague as retail manager.",
            "step4": "The store then appears in My stores.",
            "note1": "A store can only be listed for rent after it is linked to My stores.",
            "note2": "If the location is not on the map yet, add a new marker first."
          },
          "newMarker": {
            "title": "Add a new marker",
            "summary": "Add a new location to the map.",
            "step1": "Open the map.",
            "step2": "Desktop: double-click an empty place on the map.",
            "step3": "Mobile: double-tap an empty place on the map.",
            "step4": "Fill in the location details.",
            "note1": "First check whether the location is already on the map. If so, use the existing marker.",
            "note2": "If you place a new marker incorrectly, you can delete it yourself as long as you added it."
          },
          "moveDeleteMarker": {
            "title": "Move or delete a marker",
            "summary": "Correct a marker position or remove a marker you added yourself.",
            "step1": "Desktop: right-click the marker.",
            "step2": "Mobile: press and hold the marker.",
            "step3": "Choose Move marker and click or tap the new location.",
            "step4": "Choose Delete marker to remove a marker you added yourself.",
            "note1": "Existing markers and markers added by someone else can only be deleted by an admin.",
            "note2": "After moving a marker, open it again if you want to check or edit the data."
          },
          "mobile": {
            "title": "Use Retailmaps on mobile",
            "summary": "Add Retailmaps to your home screen for quick access.",
            "step1": "Open www.retailmaps.com on your phone.",
            "step2": "iPhone or iPad: use Safari, tap Share and choose Add to Home Screen.",
            "step3": "Android Chrome: tap the three dots and choose Install app or Add to Home screen.",
            "step4": "Samsung Internet: open the menu and choose Add page to or Add to Home screen.",
            "step5": "Name the shortcut Retailmaps and tap Add.",
            "step6": "Open Retailmaps from the icon on your home screen.",
            "note1": "On iPhone this normally works through Safari. Chrome on iPhone usually cannot do this directly.",
            "note2": "You sign in with the same account as on desktop."
          },
          "security": {
            "title": "Turn two-factor authentication on or off",
            "summary": "Protect your account with an extra code from an authenticator app.",
            "step1": "Open Settings.",
            "step2": "Go to Security or Two-factor authentication.",
            "step3": "Click Enable 2FA.",
            "step4": "Open an authenticator app, such as Google Authenticator, Microsoft Authenticator or 1Password.",
            "step5": "Scan the QR code with the authenticator app.",
            "step6": "Enter the 6-digit code from the app and confirm.",
            "step7": "From now on you sign in with your password plus the 6-digit code.",
            "step8": "To turn 2FA off, go back to Settings and click Disable 2FA.",
            "note1": "Keep access to your authenticator app. Without it, signing in can become difficult.",
            "note2": "The code changes about every 30 seconds. Always use the newest code."
          },
          "popupMedia": {
            "title": "Photos, documents and floor plans",
            "summary": "Add files to a location.",
            "step1": "Open the location popup.",
            "step2": "Przejdź do sekcji Dane prywatne.",
            "step3": "Choose Photos, Documents or Floor plans.",
            "step4": "Add a file or take a photo directly on mobile.",
            "note1": "Photos are shown as thumbnails.",
            "note2": "Floor plans work best as images, for example jpg or png."
          },
          "alerts": {
            "title": "Set alerts",
            "summary": "Set a reminder for important dates.",
            "step1": "Open Property Details or the popup.",
            "step2": "Enter a date, such as expiry date, indexation date or termination date.",
            "step3": "Tick Alert.",
            "step4": "Enter how many days in advance you want to receive the alert.",
            "step5": "View active alerts in the Alerts tab.",
            "note1": "Active alerts are visible in the Alerts tab.",
            "note2": "On the reminder date you automatically receive an email."
          },
          "ownerRequests": {
            "title": "View requests",
            "summary": "See who is interested in your rental offer or property.",
            "step1": "Open the Requests tab.",
            "step2": "Check which property the request belongs to.",
            "step3": "Review which applicant details are available.",
            "step4": "Open the request for more details.",
            "note1": "Requests are created when retailers show interest in a retail location, even if it is not actively listed for rent."
          },
          "retailerRequests": {
            "title": "View requests",
            "summary": "See which retailers are interested in your locations.",
            "step1": "Open the Requests tab.",
            "step2": "See which retailer showed interest.",
            "step3": "Check which location the request belongs to.",
            "step4": "Click the address to open the location on the map.",
            "note1": "Requests are incoming interests in locations linked to your organisation."
          },
          "interest": {
            "title": "Show interest",
            "summary": "Make clear that you are interested in a specific location.",
            "step1": "Open the location on the map.",
            "step2": "Click Show interest in the popup.",
            "step3": "Confirm the action and complete any required access step.",
            "step4": "The location then appears in the Interests tab.",
            "step5": "The interest remains active until you withdraw it.",
            "note1": "Your interest is saved on the specific property, not only in your own overview.",
            "note2": "The current tenant, owner and relevant brokers can see the interest where they have access."
          },
          "analysis": {
            "title": "Use analysis",
            "summary": "Compare locations and view important calculations.",
            "step1": "Select a property or store in your overview.",
            "step2": "Choose the Analysis action.",
            "step3": "Add multiple locations if needed.",
            "step4": "Open Analysis to view rent per m2, WALT, remaining lease term and ratios."
          }
        }
      },
      "dashboardOverlay": {
        "shared": {
          "assistant": "How it works"
        }
      },
      "dashboardOverlay.shared.assistant": "How it works",
      "settingsPanel": {
        "dashboardOverlay": {
          "shared": {
            "assistant": "How it works"
          }
        }
      },
      "settingsPanel.dashboardOverlay.shared.assistant": "How it works"
    }
  },
  "pt": {
    "translation": {
      "popup2.trialPaywallTitle": "Já utilizou as suas 10 manifestações de interesse gratuitas",
      "popup2.trialPaywallDescription": "Para manifestar interesse também neste imóvel, necessita de uma subscrição. As suas 10 manifestações de interesse de teste atuais serão convertidas em manifestações de interesse pagas.",
      "popup2.trialPaywallManage": "Poderá gerir estas manifestações de interesse mais tarde no seu painel (alterá-las ou removê-las).",
      "popup2.trialPaywallActivate": "Ativar subscrição",
      "popup2.privateData": "Dados privados",
      "popup2.privateDataHint": "As informações internas permanecem no seu espaço de trabalho seguro e só são visíveis para utilizadores autorizados.",
      "popup2.privateWorkspace": "Espaço de trabalho privado",
      "popup2.privateWorkspaceHint": "Utilize estes separadores para gerir de forma clara e segura notas confidenciais do proprietário, finanças, contactos, fotografias e documentos.",
      "propertyDetails.privateDataDivider": "Dados privados",
      "help": {
        "title": "How it works",
        "subtitle": "Short explanations for common actions in Retailmaps.",
        "howItWorks": "How it works",
        "goodToKnow": "Good to know",
        "empty": "There are no topics for this role yet.",
        "actions": {
          "openListings": "Open listings",
          "openInterests": "Open interests",
          "openProperties": "Open properties",
          "openAlerts": "Open Alerts",
          "openRequests": "Open requests",
          "openAnalysis": "Open analysis"
        },
        "topics": {
          "ownerForRent": {
            "title": "List a property for rent",
            "summary": "Publish a property as a rental offer and add the right information.",
            "step1": "Open the Properties tab.",
            "step2": "Find the property you want to offer.",
            "step3": "Click List for rent.",
            "step4": "Open For rent and complete the asking price, key money and available-from date.",
            "step5": "Check details that were already copied, such as current rent and expiry date.",
            "step6": "Add project information. You can upload a brochure or generate project information automatically.",
            "note1": "As an owner, you do not need to choose visibility. The property is automatically shown as a rental offer.",
            "note2": "Automatic project information uses the entered data, photos, floor plans and a map image."
          },
          "retailerStore": {
            "title": "Link a store to my stores",
            "summary": "Add an existing location to your store overview.",
            "step1": "Open the Stores tab.",
            "step2": "Find the store by country, city or address.",
            "step3": "Assign yourself or a colleague as retail manager.",
            "step4": "The store then appears in My stores.",
            "note1": "A store can only be listed for rent after it is linked to My stores.",
            "note2": "If the location is not on the map yet, add a new marker first."
          },
          "newMarker": {
            "title": "Add a new marker",
            "summary": "Add a new location to the map.",
            "step1": "Open the map.",
            "step2": "Desktop: double-click an empty place on the map.",
            "step3": "Mobile: double-tap an empty place on the map.",
            "step4": "Fill in the location details.",
            "note1": "First check whether the location is already on the map. If so, use the existing marker.",
            "note2": "If you place a new marker incorrectly, you can delete it yourself as long as you added it."
          },
          "moveDeleteMarker": {
            "title": "Move or delete a marker",
            "summary": "Correct a marker position or remove a marker you added yourself.",
            "step1": "Desktop: right-click the marker.",
            "step2": "Mobile: press and hold the marker.",
            "step3": "Choose Move marker and click or tap the new location.",
            "step4": "Choose Delete marker to remove a marker you added yourself.",
            "note1": "Existing markers and markers added by someone else can only be deleted by an admin.",
            "note2": "After moving a marker, open it again if you want to check or edit the data."
          },
          "mobile": {
            "title": "Use Retailmaps on mobile",
            "summary": "Add Retailmaps to your home screen for quick access.",
            "step1": "Open www.retailmaps.com on your phone.",
            "step2": "iPhone or iPad: use Safari, tap Share and choose Add to Home Screen.",
            "step3": "Android Chrome: tap the three dots and choose Install app or Add to Home screen.",
            "step4": "Samsung Internet: open the menu and choose Add page to or Add to Home screen.",
            "step5": "Name the shortcut Retailmaps and tap Add.",
            "step6": "Open Retailmaps from the icon on your home screen.",
            "note1": "On iPhone this normally works through Safari. Chrome on iPhone usually cannot do this directly.",
            "note2": "You sign in with the same account as on desktop."
          },
          "security": {
            "title": "Turn two-factor authentication on or off",
            "summary": "Protect your account with an extra code from an authenticator app.",
            "step1": "Open Settings.",
            "step2": "Go to Security or Two-factor authentication.",
            "step3": "Click Enable 2FA.",
            "step4": "Open an authenticator app, such as Google Authenticator, Microsoft Authenticator or 1Password.",
            "step5": "Scan the QR code with the authenticator app.",
            "step6": "Enter the 6-digit code from the app and confirm.",
            "step7": "From now on you sign in with your password plus the 6-digit code.",
            "step8": "To turn 2FA off, go back to Settings and click Disable 2FA.",
            "note1": "Keep access to your authenticator app. Without it, signing in can become difficult.",
            "note2": "The code changes about every 30 seconds. Always use the newest code."
          },
          "popupMedia": {
            "title": "Photos, documents and floor plans",
            "summary": "Add files to a location.",
            "step1": "Open the location popup.",
            "step2": "Aceda a Dados privados.",
            "step3": "Choose Photos, Documents or Floor plans.",
            "step4": "Add a file or take a photo directly on mobile.",
            "note1": "Photos are shown as thumbnails.",
            "note2": "Floor plans work best as images, for example jpg or png."
          },
          "alerts": {
            "title": "Set alerts",
            "summary": "Set a reminder for important dates.",
            "step1": "Open Property Details or the popup.",
            "step2": "Enter a date, such as expiry date, indexation date or termination date.",
            "step3": "Tick Alert.",
            "step4": "Enter how many days in advance you want to receive the alert.",
            "step5": "View active alerts in the Alerts tab.",
            "note1": "Active alerts are visible in the Alerts tab.",
            "note2": "On the reminder date you automatically receive an email."
          },
          "ownerRequests": {
            "title": "View requests",
            "summary": "See who is interested in your rental offer or property.",
            "step1": "Open the Requests tab.",
            "step2": "Check which property the request belongs to.",
            "step3": "Review which applicant details are available.",
            "step4": "Open the request for more details.",
            "note1": "Requests are created when retailers show interest in a retail location, even if it is not actively listed for rent."
          },
          "retailerRequests": {
            "title": "View requests",
            "summary": "See which retailers are interested in your locations.",
            "step1": "Open the Requests tab.",
            "step2": "See which retailer showed interest.",
            "step3": "Check which location the request belongs to.",
            "step4": "Click the address to open the location on the map.",
            "note1": "Requests are incoming interests in locations linked to your organisation."
          },
          "interest": {
            "title": "Show interest",
            "summary": "Make clear that you are interested in a specific location.",
            "step1": "Open the location on the map.",
            "step2": "Click Show interest in the popup.",
            "step3": "Confirm the action and complete any required access step.",
            "step4": "The location then appears in the Interests tab.",
            "step5": "The interest remains active until you withdraw it.",
            "note1": "Your interest is saved on the specific property, not only in your own overview.",
            "note2": "The current tenant, owner and relevant brokers can see the interest where they have access."
          },
          "analysis": {
            "title": "Use analysis",
            "summary": "Compare locations and view important calculations.",
            "step1": "Select a property or store in your overview.",
            "step2": "Choose the Analysis action.",
            "step3": "Add multiple locations if needed.",
            "step4": "Open Analysis to view rent per m2, WALT, remaining lease term and ratios."
          }
        }
      },
      "dashboardOverlay": {
        "shared": {
          "assistant": "How it works"
        }
      },
      "dashboardOverlay.shared.assistant": "How it works",
      "settingsPanel": {
        "dashboardOverlay": {
          "shared": {
            "assistant": "How it works"
          }
        }
      },
      "settingsPanel.dashboardOverlay.shared.assistant": "How it works"
    }
  },
  "sk": {
    "translation": {
      "popup2.trialPaywallTitle": "Využili ste svojich 10 bezplatných skúšobných prejavov záujmu",
      "popup2.trialPaywallDescription": "Ak chcete prejaviť záujem aj o túto nehnuteľnosť, potrebujete predplatné. Vašich súčasných 10 skúšobných prejavov záujmu sa zmení na platené.",
      "popup2.trialPaywallManage": "Tieto prejavy záujmu môžete neskôr spravovať na svojom ovládacom paneli (upraviť alebo odstrániť).",
      "popup2.trialPaywallActivate": "Aktivovať predplatné",
      "popup2.privateData": "Súkromné údaje",
      "popup2.privateDataHint": "Interné informácie zostávajú v zabezpečenom pracovnom priestore a sú viditeľné iba oprávneným používateľom.",
      "popup2.privateWorkspace": "Súkromný pracovný priestor",
      "popup2.privateWorkspaceHint": "Pomocou týchto kariet môžete prehľadne a bezpečne spravovať citlivé poznámky vlastníka, financie, kontakty, fotografie a dokumenty.",
      "propertyDetails.privateDataDivider": "Súkromné údaje",
      "help": {
        "title": "How it works",
        "subtitle": "Short explanations for common actions in Retailmaps.",
        "howItWorks": "How it works",
        "goodToKnow": "Good to know",
        "empty": "There are no topics for this role yet.",
        "actions": {
          "openListings": "Open listings",
          "openInterests": "Open interests",
          "openProperties": "Open properties",
          "openAlerts": "Open Alerts",
          "openRequests": "Open requests",
          "openAnalysis": "Open analysis"
        },
        "topics": {
          "ownerForRent": {
            "title": "List a property for rent",
            "summary": "Publish a property as a rental offer and add the right information.",
            "step1": "Open the Properties tab.",
            "step2": "Find the property you want to offer.",
            "step3": "Click List for rent.",
            "step4": "Open For rent and complete the asking price, key money and available-from date.",
            "step5": "Check details that were already copied, such as current rent and expiry date.",
            "step6": "Add project information. You can upload a brochure or generate project information automatically.",
            "note1": "As an owner, you do not need to choose visibility. The property is automatically shown as a rental offer.",
            "note2": "Automatic project information uses the entered data, photos, floor plans and a map image."
          },
          "retailerStore": {
            "title": "Link a store to my stores",
            "summary": "Add an existing location to your store overview.",
            "step1": "Open the Stores tab.",
            "step2": "Find the store by country, city or address.",
            "step3": "Assign yourself or a colleague as retail manager.",
            "step4": "The store then appears in My stores.",
            "note1": "A store can only be listed for rent after it is linked to My stores.",
            "note2": "If the location is not on the map yet, add a new marker first."
          },
          "newMarker": {
            "title": "Add a new marker",
            "summary": "Add a new location to the map.",
            "step1": "Open the map.",
            "step2": "Desktop: double-click an empty place on the map.",
            "step3": "Mobile: double-tap an empty place on the map.",
            "step4": "Fill in the location details.",
            "note1": "First check whether the location is already on the map. If so, use the existing marker.",
            "note2": "If you place a new marker incorrectly, you can delete it yourself as long as you added it."
          },
          "moveDeleteMarker": {
            "title": "Move or delete a marker",
            "summary": "Correct a marker position or remove a marker you added yourself.",
            "step1": "Desktop: right-click the marker.",
            "step2": "Mobile: press and hold the marker.",
            "step3": "Choose Move marker and click or tap the new location.",
            "step4": "Choose Delete marker to remove a marker you added yourself.",
            "note1": "Existing markers and markers added by someone else can only be deleted by an admin.",
            "note2": "After moving a marker, open it again if you want to check or edit the data."
          },
          "mobile": {
            "title": "Use Retailmaps on mobile",
            "summary": "Add Retailmaps to your home screen for quick access.",
            "step1": "Open www.retailmaps.com on your phone.",
            "step2": "iPhone or iPad: use Safari, tap Share and choose Add to Home Screen.",
            "step3": "Android Chrome: tap the three dots and choose Install app or Add to Home screen.",
            "step4": "Samsung Internet: open the menu and choose Add page to or Add to Home screen.",
            "step5": "Name the shortcut Retailmaps and tap Add.",
            "step6": "Open Retailmaps from the icon on your home screen.",
            "note1": "On iPhone this normally works through Safari. Chrome on iPhone usually cannot do this directly.",
            "note2": "You sign in with the same account as on desktop."
          },
          "security": {
            "title": "Turn two-factor authentication on or off",
            "summary": "Protect your account with an extra code from an authenticator app.",
            "step1": "Open Settings.",
            "step2": "Go to Security or Two-factor authentication.",
            "step3": "Click Enable 2FA.",
            "step4": "Open an authenticator app, such as Google Authenticator, Microsoft Authenticator or 1Password.",
            "step5": "Scan the QR code with the authenticator app.",
            "step6": "Enter the 6-digit code from the app and confirm.",
            "step7": "From now on you sign in with your password plus the 6-digit code.",
            "step8": "To turn 2FA off, go back to Settings and click Disable 2FA.",
            "note1": "Keep access to your authenticator app. Without it, signing in can become difficult.",
            "note2": "The code changes about every 30 seconds. Always use the newest code."
          },
          "popupMedia": {
            "title": "Photos, documents and floor plans",
            "summary": "Add files to a location.",
            "step1": "Open the location popup.",
            "step2": "Prejdite do sekcie Súkromné údaje.",
            "step3": "Choose Photos, Documents or Floor plans.",
            "step4": "Add a file or take a photo directly on mobile.",
            "note1": "Photos are shown as thumbnails.",
            "note2": "Floor plans work best as images, for example jpg or png."
          },
          "alerts": {
            "title": "Set alerts",
            "summary": "Set a reminder for important dates.",
            "step1": "Open Property Details or the popup.",
            "step2": "Enter a date, such as expiry date, indexation date or termination date.",
            "step3": "Tick Alert.",
            "step4": "Enter how many days in advance you want to receive the alert.",
            "step5": "View active alerts in the Alerts tab.",
            "note1": "Active alerts are visible in the Alerts tab.",
            "note2": "On the reminder date you automatically receive an email."
          },
          "ownerRequests": {
            "title": "View requests",
            "summary": "See who is interested in your rental offer or property.",
            "step1": "Open the Requests tab.",
            "step2": "Check which property the request belongs to.",
            "step3": "Review which applicant details are available.",
            "step4": "Open the request for more details.",
            "note1": "Requests are created when retailers show interest in a retail location, even if it is not actively listed for rent."
          },
          "retailerRequests": {
            "title": "View requests",
            "summary": "See which retailers are interested in your locations.",
            "step1": "Open the Requests tab.",
            "step2": "See which retailer showed interest.",
            "step3": "Check which location the request belongs to.",
            "step4": "Click the address to open the location on the map.",
            "note1": "Requests are incoming interests in locations linked to your organisation."
          },
          "interest": {
            "title": "Show interest",
            "summary": "Make clear that you are interested in a specific location.",
            "step1": "Open the location on the map.",
            "step2": "Click Show interest in the popup.",
            "step3": "Confirm the action and complete any required access step.",
            "step4": "The location then appears in the Interests tab.",
            "step5": "The interest remains active until you withdraw it.",
            "note1": "Your interest is saved on the specific property, not only in your own overview.",
            "note2": "The current tenant, owner and relevant brokers can see the interest where they have access."
          },
          "analysis": {
            "title": "Use analysis",
            "summary": "Compare locations and view important calculations.",
            "step1": "Select a property or store in your overview.",
            "step2": "Choose the Analysis action.",
            "step3": "Add multiple locations if needed.",
            "step4": "Open Analysis to view rent per m2, WALT, remaining lease term and ratios."
          }
        }
      },
      "dashboardOverlay": {
        "shared": {
          "assistant": "How it works"
        }
      },
      "dashboardOverlay.shared.assistant": "How it works",
      "settingsPanel": {
        "dashboardOverlay": {
          "shared": {
            "assistant": "How it works"
          }
        }
      },
      "settingsPanel.dashboardOverlay.shared.assistant": "How it works"
    }
  }
};

export default resources;
